import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { createClient } from "@supabase/supabase-js";

// ── Supabase — hardcoded for reliability ──
const supabase = createClient(
  "https://nccvxhjxpgocrfudxhrl.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5jY3Z4aGp4cGdvY3JmdWR4aHJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYwMTgwMzYsImV4cCI6MjA5MTU5NDAzNn0.xnn2_nmemFV9mVSQoQe9EhQmnNaLGgH74eI7Uf3-QkA"
);
const USE_DB = true;

const FONT = "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600&display=swap";

const LOGO = "data:image/png;base64,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";
const LogoImg=({h=36,style={}})=><img src={LOGO} alt="WBRO" style={{height:h,objectFit:"contain",...style}}/>;

// ── COLOR PALETTE ──
// Uses CSS custom properties so themes can swap at runtime without re-rendering all styles.
// Default values are LIGHT theme; dark/Linear theme overrides them via CSS injection (see App).
const C = {
  bg: "var(--c-bg)", surface: "var(--c-surface)", card: "var(--c-card)", border: "var(--c-border)",
  accent: "var(--c-accent)", accentSoft: "var(--c-accent-soft)", accentMid: "var(--c-accent-mid)",
  green: "var(--c-green)", greenSoft: "var(--c-green-soft)",
  amber: "var(--c-amber)", amberSoft: "var(--c-amber-soft)",
  red: "var(--c-red)", redSoft: "var(--c-red-soft)",
  purple: "var(--c-purple)", purpleSoft: "var(--c-purple-soft)",
  text: "var(--c-text)", textMid: "var(--c-text-mid)", textDim: "var(--c-text-dim)", white: "var(--c-white)",
  grad1: "var(--c-grad1)", grad2: "var(--c-grad2)", grad3: "var(--c-grad3)",
  glass: "var(--c-glass)", glassBorder: "var(--c-glass-border)",
  shadow: "var(--c-shadow)", shadowLg: "var(--c-shadow-lg)",
};

// THEME BRIDGE — The new design system tokens (tokens.css) are the source of truth.
// We rebind the legacy --c-* variables to the new design-system variables here so that
// every existing inline style continues working without a mass find-and-replace.
const THEME_LIGHT=`
:root{
  --c-bg:var(--bg); --c-surface:var(--surface); --c-card:var(--surface-2); --c-border:var(--border);
  --c-accent:var(--a-500); --c-accent-soft:var(--a-50); --c-accent-mid:var(--a-400);
  --c-green:var(--green-500); --c-green-soft:var(--green-100);
  --c-amber:var(--amber-500); --c-amber-soft:var(--amber-100);
  --c-red:var(--red-500); --c-red-soft:var(--red-100);
  --c-purple:var(--violet-500); --c-purple-soft:var(--violet-100);
  --c-text:var(--text); --c-text-mid:var(--text-2); --c-text-dim:var(--text-3); --c-white:#FFFFFF;
  --c-grad1:linear-gradient(135deg, var(--n-900) 0%, var(--n-700) 50%, var(--a-500) 100%);
  --c-grad2:linear-gradient(135deg, var(--a-500) 0%, var(--violet-500) 100%);
  --c-grad3:linear-gradient(135deg, var(--n-50) 0%, var(--a-100) 100%);
  --c-glass:rgba(255,255,255,.7);
  --c-glass-border:rgba(255,255,255,.3);
  --c-shadow:var(--shadow-xs);
  --c-shadow-lg:var(--shadow-lg);
}
html{font-family:var(--font-sans);}
body{background:var(--c-bg);color:var(--c-text);font-family:var(--font-sans);font-feature-settings:'tnum';}
input,textarea,select,button{font-family:inherit;}
`;

// Dark theme: relies on [data-theme="dark"] in tokens.css to swap surfaces and shadows.
// We keep this string for the bridge (the data-theme attribute does the actual heavy lifting).
const THEME_DARK=THEME_LIGHT+`
::-webkit-scrollbar{width:10px;height:10px}
::-webkit-scrollbar-track{background:var(--surface)}
::-webkit-scrollbar-thumb{background:var(--n-700);border-radius:5px}
::-webkit-scrollbar-thumb:hover{background:var(--n-600)}
input,textarea,select{color-scheme:dark}
`;

// ── Hourly Rates ──
const HOURLY_RATES = {
  "Principal": 240, "Associate": 200, "Project Manager": 170,
  "Engineer of Record": 170, "Senior Designer": 125, "Intermediate Designer": 115,
  "Designer": 105, "Drafting": 85, "Administration": 70,
};
const BILLABLE_ROLES = Object.keys(HOURLY_RATES);

const DAYS = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
const ACTIVITY_TYPES = ["BillableTime","Meetings","Site Visit","Admin","Review"];
const PHASES = ["Pre-Design","Schematic Design","Design Development","Construction Documents","Bidding","Construction Admin"];

// FIFA World Cup 2026 — 48 teams, 12 groups (final draw confirmed Dec 5, 2025)
// Flag images use flagcdn.com (ISO 3166-1 alpha-2 codes) — cross-platform, works on Windows too.
// Emoji flags don't render on Windows (no system support in Segoe UI Emoji).
const TEAM_FLAG_CODES={
  "Mexico":"mx","South Korea":"kr","South Africa":"za","Czechia":"cz",
  "Canada":"ca","Switzerland":"ch","Qatar":"qa","Bosnia-Herzegovina":"ba",
  "Brazil":"br","Morocco":"ma","Scotland":"gb-sct","Haiti":"ht",
  "USA":"us","Paraguay":"py","Australia":"au","Türkiye":"tr",
  "Germany":"de","Ecuador":"ec","Ivory Coast":"ci","Curaçao":"cw",
  "Netherlands":"nl","Japan":"jp","Tunisia":"tn","Sweden":"se",
  "Belgium":"be","Iran":"ir","Egypt":"eg","New Zealand":"nz",
  "Spain":"es","Uruguay":"uy","Saudi Arabia":"sa","Cape Verde":"cv",
  "France":"fr","Senegal":"sn","Norway":"no","Iraq":"iq",
  "Argentina":"ar","Austria":"at","Algeria":"dz","Jordan":"jo",
  "Portugal":"pt","Colombia":"co","Uzbekistan":"uz","DR Congo":"cd",
  "England":"gb-eng","Croatia":"hr","Panama":"pa","Ghana":"gh",
};
function FlagImg({team,size=20}){
  const code=TEAM_FLAG_CODES[team];
  if(!code)return <span style={{fontSize:size*0.85,lineHeight:1}}>🏳</span>;
  // flagcdn.com serves flag PNGs by ISO code; gb-sct/gb-eng are regional variants
  const url=`https://flagcdn.com/${size*2}x${Math.round(size*1.5)}/${code}.png`;
  return <img src={url} alt={team} width={size*1.33} height={size} style={{objectFit:"cover",borderRadius:2,verticalAlign:"middle",flexShrink:0}} loading="lazy" onError={e=>{e.currentTarget.style.display="none"}}/>;
}

const WC26_GROUPS = {
  "A": {teams:["Mexico","South Korea","South Africa","Czechia"]},
  "B": {teams:["Canada","Switzerland","Qatar","Bosnia-Herzegovina"]},
  "C": {teams:["Brazil","Morocco","Scotland","Haiti"]},
  "D": {teams:["USA","Paraguay","Australia","Türkiye"]},
  "E": {teams:["Germany","Ecuador","Ivory Coast","Curaçao"]},
  "F": {teams:["Netherlands","Japan","Tunisia","Sweden"]},
  "G": {teams:["Belgium","Iran","Egypt","New Zealand"]},
  "H": {teams:["Spain","Uruguay","Saudi Arabia","Cape Verde"]},
  "I": {teams:["France","Senegal","Norway","Iraq"]},
  "J": {teams:["Argentina","Austria","Algeria","Jordan"]},
  "K": {teams:["Portugal","Colombia","Uzbekistan","DR Congo"]},
  "L": {teams:["England","Croatia","Panama","Ghana"]},
};
const WC26_GROUP_LETTERS = ["A","B","C","D","E","F","G","H","I","J","K","L"];
const WC26_ROUNDS = ["group","r32","r16","qf","sf","final","champion"];
// Round of 32 fixtures (16 games) — pick one winner per game
const WC26_R32_FIXTURES = [
  {id:"r32_1",home:"South Africa",away:"Canada",date:"Jun 28"},
  {id:"r32_2",home:"Brazil",away:"Japan",date:"Jun 29"},
  {id:"r32_3",home:"Germany",away:"Paraguay",date:"Jun 29"},
  {id:"r32_4",home:"Netherlands",away:"Morocco",date:"Jun 29"},
  {id:"r32_5",home:"Ivory Coast",away:"Norway",date:"Jun 30"},
  {id:"r32_6",home:"France",away:"Sweden",date:"Jun 30"},
  {id:"r32_7",home:"Mexico",away:"Ecuador",date:"Jun 30"},
  {id:"r32_8",home:"England",away:"DR Congo",date:"Jul 1"},
  {id:"r32_9",home:"Belgium",away:"Senegal",date:"Jul 1"},
  {id:"r32_10",home:"USA",away:"Bosnia-Herzegovina",date:"Jul 1"},
  {id:"r32_11",home:"Spain",away:"Austria",date:"Jul 2"},
  {id:"r32_12",home:"Portugal",away:"Croatia",date:"Jul 2"},
  {id:"r32_13",home:"Switzerland",away:"Algeria",date:"Jul 2"},
  {id:"r32_14",home:"Australia",away:"Egypt",date:"Jul 3"},
  {id:"r32_15",home:"Argentina",away:"Cape Verde",date:"Jul 3"},
  {id:"r32_16",home:"Colombia",away:"Ghana",date:"Jul 3"},
];
// Round of 16 matchups (winners of the R32 games), from the live tournament bracket.
const WC26_R16_FIXTURES=[
  {id:"r16_1",home:"Canada",away:"Morocco",date:"Jul 4"},
  {id:"r16_2",home:"Paraguay",away:"France",date:"Jul 4"},
  {id:"r16_3",home:"Brazil",away:"Norway",date:"Jul 5"},
  {id:"r16_4",home:"Mexico",away:"England",date:"Jul 5"},
  {id:"r16_5",home:"Portugal",away:"Spain",date:"Jul 6"},
  {id:"r16_6",home:"USA",away:"Belgium",date:"Jul 6"},
  {id:"r16_7",home:"Argentina",away:"Egypt",date:"Jul 7"},
  {id:"r16_8",home:"Switzerland",away:"Colombia",date:"Jul 7"},
];
// Quarter-final matchups (winners of the R16 games), from the live tournament bracket.
const WC26_QF_FIXTURES=[
  {id:"qf_1",home:"France",away:"Morocco",date:"Jul 9"},
  {id:"qf_2",home:"Spain",away:"Belgium",date:"Jul 10"},
  {id:"qf_3",home:"Norway",away:"England",date:"Jul 11"},
  {id:"qf_4",home:"Argentina",away:"Switzerland",date:"Jul 11"},
];
// Semi-final matchups (winners of the QF games), from the live tournament bracket.
const WC26_SF_FIXTURES=[
  {id:"sf_1",home:"France",away:"Spain",date:"Jul 14"},
  {id:"sf_2",home:"England",away:"Argentina",date:"Jul 15"},
];
// The last two games. `pts` overrides the round default so both can live in one tab:
// the Final is worth +10, the 3rd-place playoff +5.
const WC26_FINAL_FIXTURES=[
  {id:"final_1",home:"Spain",away:"Argentina",date:"Jul 19",pts:10,label:"🏆 Final"},
  {id:"third_1",home:"France",away:"England",date:"Jul 18",pts:5,label:"🥉 3rd-place playoff"},
];
// Official winners (final results) — baked in so leaderboards score on deploy.
const WC26_R32_OFFICIAL={r32_1:"Canada",r32_2:"Brazil",r32_3:"Paraguay",r32_4:"Morocco",r32_5:"Norway",r32_6:"France",r32_7:"Mexico",r32_8:"England",r32_9:"Belgium",r32_10:"USA",r32_11:"Spain",r32_12:"Portugal",r32_13:"Switzerland",r32_14:"Egypt",r32_15:"Argentina",r32_16:"Colombia"};
const WC26_R16_OFFICIAL={r16_1:"Morocco",r16_2:"France",r16_3:"Norway",r16_4:"England",r16_5:"Spain",r16_6:"Belgium",r16_7:"Argentina",r16_8:"Switzerland"};
const WC26_QF_OFFICIAL={qf_1:"France",qf_2:"Spain",qf_3:"England",qf_4:"Argentina"};
const WC26_SF_OFFICIAL={sf_1:"Spain",sf_2:"Argentina"};
const WC26_FINAL_OFFICIAL={final_1:"Spain",third_1:"England"};
// The tournament podium, derived from the final + 3rd-place results (works off baked
// results or any admin override). Returns {champion, runnerUp, third} or null if unplayed.
function wcPodium(event){
  const fr={...((event||{}).wcFinalResults||{}),...WC26_FINAL_OFFICIAL};
  const fin=WC26_FINAL_FIXTURES.find(g=>g.id==="final_1");
  const third=WC26_FINAL_FIXTURES.find(g=>g.id==="third_1");
  const champ=fr["final_1"];if(!champ||!fin)return null;
  return {champion:champ,runnerUp:fin.home===champ?fin.away:fin.home,third:fr["third_1"]||null};
}
// Knockout prediction rounds: each is a game-by-game winner-pick round worth `points` per
// correct pick (a fixture may override with its own `pts`).
const WC26_KO_ROUNDS=[
  {id:"r32",label:"Round of 32",fixtures:WC26_R32_FIXTURES,picksKey:"wcR32Picks",resultsKey:"wcR32Results",points:2,official:WC26_R32_OFFICIAL,settleGameId:"r32_1",reachedByWin:"r16"},
  {id:"r16",label:"Round of 16",fixtures:WC26_R16_FIXTURES,picksKey:"wcR16Picks",resultsKey:"wcR16Results",points:2,official:WC26_R16_OFFICIAL,reachedByWin:"qf"},
  {id:"qf",label:"Quarter Final",fixtures:WC26_QF_FIXTURES,picksKey:"wcQFPicks",resultsKey:"wcQFResults",points:3,official:WC26_QF_OFFICIAL,reachedByWin:"sf"},
  {id:"sf",label:"Semi Final",fixtures:WC26_SF_FIXTURES,picksKey:"wcSFPicks",resultsKey:"wcSFResults",points:5,official:WC26_SF_OFFICIAL,reachedByWin:"final"},
  {id:"final",label:"Final & 3rd Place",fixtures:WC26_FINAL_FIXTURES,picksKey:"wcFinalPicks",resultsKey:"wcFinalResults",points:10,official:WC26_FINAL_OFFICIAL},
];
// Every team appearing in the R32 fixtures has, by definition, reached the Round of 32.
const WC26_R32_TEAMS = new Set();
WC26_R32_FIXTURES.forEach(g=>{WC26_R32_TEAMS.add(g.home);WC26_R32_TEAMS.add(g.away);});
// Effective results for a knockout round: confirmed official results (when known) are the
// authoritative baseline, with any admin-entered results filling in the rest.
function wcRoundResults(event,r){return r.official?{...((event||{})[r.resultsKey]||{}),...r.official}:(((event||{})[r.resultsKey])||{});}
// Highest round a team reached. Bracket membership is the source of truth for reaching the
// Round of 32 (+1); admin advances a team further (r16/qf/…) via wcResults.
function wcReachedRound(team,event){
  const explicit=((event||{}).wcResults||{})[team];
  const base=WC26_R32_TEAMS.has(team)?"r32":"group"; // in a fixture ⇒ reached R32
  if(explicit&&WC26_ROUNDS.indexOf(explicit)>WC26_ROUNDS.indexOf(base))return explicit; // advance only
  return base;
}
// Total World Cup points for one entrant: +N per group-pick team per round reached, plus the
// per-round knockout prediction points (R32 +2, R16 +3, …). Shared by every leaderboard.
function computeWCPoints(event,uid){
  const picks=(event.wcPicks||{})[uid]||{};let pts=0;
  const voids=event.wcVoids||{};
  WC26_GROUP_LETTERS.forEach(g=>{(picks[g]||[]).forEach(t=>{const idx=WC26_ROUNDS.indexOf(wcReachedRound(t,event));if(idx>0)pts+=idx;});});
  WC26_KO_ROUNDS.forEach(r=>{const p=(event[r.picksKey]||{})[uid]||{};const res=wcRoundResults(event,r);r.fixtures.forEach(g=>{if(res[g.id]&&p[g.id]===res[g.id]&&!voids[`${r.picksKey}:${g.id}:${uid}`])pts+=(g.pts||r.points);});});
  return pts;
}
function wcEntrantIds(event){const keys=[...Object.keys(event.wcPicks||{})];WC26_KO_ROUNDS.forEach(r=>keys.push(...Object.keys(event[r.picksKey]||{})));return [...new Set(keys)];}
function wcEntrantName(event,users,uid){return uid.startsWith("guest_")?((event.wcGuestNames||{})[uid]||uid.replace("guest_","")):((users||[]).find(x=>x.id===uid)||{}).name||"Unknown";}
const WC26_ROUND_LABELS = {group:"Group Stage",r32:"Round of 32",r16:"Round of 16",qf:"Quarterfinals",sf:"Semifinals",final:"Final",champion:"Champion"};
const EXPENSE_CATEGORIES = ["Travel","Meals","Printing","Supplies","Permits","Software","Other"];
const OVERHEAD_CATEGORIES = ["Continuing Education","General","Internal Training","Leave Without Pay","Marketing/Promotion","Office Meetings","Sick","Stat Holiday","Vacation"];

// ── Helpers ──
const fmt = (n) => "$" + n.toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
const fmtShort = (n) => "$" + n.toLocaleString();
const pct = (a, b) => b === 0 ? 0 : Math.round((a / b) * 100);
const daysUntil = (d) => Math.ceil((new Date(d) - new Date()) / 864e5);
const statusColor = (s) => s === "In Progress" ? C.green : s === "On Hold" ? C.amber : s === "Completed" ? C.accent : C.textMid;
const priorityColor = (p) => p === "High" ? C.red : p === "Medium" ? C.amber : C.textMid;
const issueStatusColor = (s) => s === "Open" ? C.red : s === "In Review" ? C.amber : C.green;
const makeAvatar = (name) => name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
const genId = (pre) => pre + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
const genPinCode = () => String(Math.floor(1000 + Math.random() * 9000));
const roleColor = (r) => {
  if (r === "Admin") return { bg: C.accent, fg: C.white };
  if (r === "Project Manager") return { bg: C.purpleSoft, fg: C.purple };
  if (r === "Designer"||r === "Senior Designer"||r === "Intermediate Designer") return { bg: C.accentSoft, fg: C.accent };
  if (r === "Client") return { bg: C.greenSoft, fg: C.green };
  if (r === "Contractor") return { bg: C.amberSoft, fg: C.amber };
  return { bg: C.card, fg: C.textMid };
};

function getWeekStart(date) {
  const d = new Date(date); const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff); d.setHours(0,0,0,0); return d;
}
function getWeekDates(weekStart) {
  return DAYS.map((_, i) => {
    const d = new Date(weekStart); d.setDate(d.getDate() + i);
    return d.toISOString().split("T")[0];
  });
}
function formatWeekLabel(weekStart) {
  const s = new Date(weekStart); const e = new Date(s); e.setDate(e.getDate() + 6);
  return `${s.toLocaleDateString("en-US",{month:"short",day:"numeric"})} – ${e.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}`;
}

// ── Permission helpers ──
const isStaff = (u) => u && !["Client","Contractor"].includes(u.role);
const isAdmin = (u) => u?.role === "Admin";
const isFinance = (u) => u?.role === "Finance";
const PM_LEVEL_ROLES = ["Project Manager","Associate","Principal"];
const DESIGNER_LEVEL_ROLES = ["Designer","Intermediate Designer","Senior Designer"];
const DRAFTER_ROLES = ["Drafter","Senior Drafter"];
const BUSINESS_ROLES = ["Administration","Marketing"];
const isPM = (u) => u && PM_LEVEL_ROLES.includes(u.role);
const isDesigner = (u) => u && DESIGNER_LEVEL_ROLES.includes(u.role);
const isDrafter = (u) => u && DRAFTER_ROLES.includes(u.role);
const isBusiness = (u) => u && BUSINESS_ROLES.includes(u.role);
const canManageTeam = (u) => isAdmin(u) || isPM(u);
const canCreateProject = (u) => isStaff(u) && !isBusiness(u);
const canAssignTeam = (u) => isAdmin(u) || isPM(u);
const canEditProject = (u, p) => { if (!u||!p) return false; if (isAdmin(u)||isPM(u)) return true; if (isStaff(u) && p.team.includes(u.id)) return true; return false; };
// ── Workload model ───────────────────────────────────────────
// New unit: HOURS per week per project (36h/week = 100% workload).
// Storage: project.focusHoursMap:{[uid]:hours}. Legacy: project.focusMap:{[uid]:%}.
// On read, prefer hours; fall back to converting % → hours (% * 36 / 100).
const WORKLOAD_FULL_HOURS = 36; // 36h/week = 100% utilization
const getUserFocusHours = (project, userId) => {
  if(!project||!userId)return 0;
  if(project.focusHoursMap&&typeof project.focusHoursMap[userId]==="number")return project.focusHoursMap[userId];
  if(project.focusMap&&typeof project.focusMap[userId]==="number")return Math.round((project.focusMap[userId]*WORKLOAD_FULL_HOURS/100)*10)/10;
  if(project.designerFocus)return Math.round((project.designerFocus*WORKLOAD_FULL_HOURS/100)*10)/10;
  return 0;
};
const setUserFocusHours = (project, userId, hours) => {
  const current=project.focusHoursMap||{};
  const newHours=Math.max(0,Math.min(80,parseFloat(hours)||0));
  return{...project,focusHoursMap:{...current,[userId]:newHours}};
};
// Per-user focus: projects now store focusMap:{[uid]:number}. Fall back to legacy designerFocus for back-compat.
const getUserFocus = (project, userId) => {
  // Return as % for backward compat (some places still need %). Computed from hours.
  if(!project||!userId)return 0;
  const hours=getUserFocusHours(project,userId);
  return Math.round((hours/WORKLOAD_FULL_HOURS)*100);
};
const setUserFocus = (project, userId, value) => {
  const current=project.focusMap||{};
  return{...project,focusMap:{...current,[userId]:Math.max(0,Math.min(100,parseInt(value)||0))}};
};
const canRaiseRFI = (u, p) => { if (!u||!p) return false; if (isStaff(u)) return canEditProject(u,p); if (u.role==="Contractor") return true; return false; };

// ── Init Data ──
const initUsers = [
  { id:"u1", name:"Batu Ozer", role:"Admin", billableRole:"Principal", email:"batu@omengineering.ca", pin:"qwe123", avatar:"BO", teamName:"" },
];

const initProjects = [
  {
    id:"p1", number:"PRJ-2024-041", name:"Waterfront Mixed-Use Tower",
    client:"Harbour Dev Corp", location:"Vancouver, BC", type:"Mixed-Use / Residential",
    status:"In Progress", phase:"Design Development",
    startDate:"2024-06-01", endDate:"2026-03-15", progress:42,
    budget:{total:2850000,spent:0}, designerFocus:60,
    team:["u1","u2","u2"], accessPin: genPinCode(),
    milestones:[{name:"SD Complete",date:"2024-11-15",done:true},{name:"DD 50%",date:"2025-04-01",done:true},{name:"DD 100%",date:"2025-08-30",done:false},{name:"CD 50%",date:"2025-12-01",done:false},{name:"CD 100%",date:"2026-03-15",done:false}],
    issues:[
      {id:"RFI-041",title:"Curtain wall anchorage detail at L12",type:"RFI",priority:"High",status:"Open",date:"2025-03-28",assignee:"u2",author:"u2",message:"Need clarification on the anchorage connection type for the curtain wall system at Level 12. Please confirm if post-installed anchors are acceptable.",responses:[{text:"Post-installed anchors are acceptable per structural review. Please use Hilti HIT-RE 500 V4 with 200mm embedment.","author":"u1",date:"2025-03-30"}]},
      {id:"RFI-039",title:"Mechanical shaft sizing confirmation",type:"RFI",priority:"Medium",status:"In Review",date:"2025-03-15",assignee:"u2",author:"u2",message:"Mechanical shaft at grid C-4 appears undersized for the ductwork routing. Can you confirm the required clear dimensions?",responses:[]},
    ],
    updates:[{date:"2025-04-07",text:"DD coordination meeting held; structural comments incorporated.",author:"u2"},{date:"2025-04-01",text:"DD 50% milestone achieved.",author:"u2"}],
    deadlines:[{name:"DD 100% Submission",date:"2025-08-30",type:"milestone"},{name:"Permit Application",date:"2025-10-15",type:"deadline"}],
    budgetBreakdown:[{category:"Architectural",allocated:1200000,spent:0},{category:"Structural",allocated:650000,spent:0},{category:"Mechanical",allocated:450000,spent:0},{category:"Electrical",allocated:300000,spent:0},{category:"Landscape",allocated:250000,spent:0}],
    coordination:[
      {discipline:"Architect",company:"Studio A",contact:"Mark R.",email:"mark@studioa.com",phone:"604-555-0101",status:"Active",messages:[{text:"Coordinated floor plan revisions for Level 3.",author:"u1",date:"2025-04-01"}]},
      {discipline:"Structural",company:"StructCo",contact:"Lisa W.",email:"lisa@structco.com",phone:"604-555-0202",status:"Active",messages:[]},
      {discipline:"City",company:"City of Vancouver",contact:"Planning Dept",email:"planning@vancouver.ca",phone:"",status:"Pending",messages:[{text:"Awaiting zoning variance confirmation.",author:"u2",date:"2025-03-28"}]},
    ],
  },
  {
    id:"p2", number:"PRJ-2024-038", name:"Civic Library Renovation",
    client:"City of Richmond", location:"Richmond, BC", type:"Institutional",
    status:"In Progress", phase:"Construction Documents",
    startDate:"2024-03-01", endDate:"2025-09-30", progress:68,
    budget:{total:980000,spent:0}, designerFocus:25,
    team:["u1","u2","u2"], accessPin: genPinCode(),
    milestones:[{name:"SD Complete",date:"2024-06-15",done:true},{name:"DD Complete",date:"2024-12-01",done:true},{name:"CD 50%",date:"2025-03-15",done:true},{name:"CD 100%",date:"2025-07-01",done:false}],
    issues:[{id:"RFI-022",title:"Heritage facade retention detail",type:"RFI",priority:"High",status:"Open",date:"2025-04-05",assignee:"u2",author:"u2"}],
    updates:[{date:"2025-04-05",text:"CD 50% review comments received from City.",author:"u2"}],
    deadlines:[{name:"CD 100% Submission",date:"2025-07-01",type:"milestone"}],
    budgetBreakdown:[{category:"Architectural",allocated:480000,spent:0},{category:"Structural",allocated:200000,spent:0},{category:"Mechanical",allocated:180000,spent:0},{category:"Electrical",allocated:120000,spent:0}],
    coordination:[],
  },
];

// ── Styles ──
const S = {
  app:{fontFamily:"var(--font-sans)",background:"var(--bg)",color:"var(--text)",minHeight:"100vh",fontSize:"var(--fs-base)"},
  loginWrap:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(420px,100vw),1fr))",minHeight:"100vh",background:"#060a08",fontFamily:"var(--font-sans)",position:"relative",overflow:"hidden"},
  loginCard:{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"stretch",padding:"40px clamp(20px,6vw,64px)",maxWidth:540,margin:"0 auto",width:"100%",background:"transparent",backdropFilter:"none",WebkitBackdropFilter:"none",borderRadius:0,border:"none",boxShadow:"none",position:"relative",zIndex:2},
  loginTitle:{fontFamily:"var(--font-sans)",fontSize:26,fontWeight:650,marginBottom:6,letterSpacing:"-0.02em",color:"#f2f6f3"},
  loginSub:{color:"#8fa096",marginBottom:24,fontSize:14,lineHeight:1.5,letterSpacing:"-0.005em"},
  inputGroup:{marginBottom:14},
  label:{display:"block",fontSize:"var(--fs-xs)",fontWeight:600,color:"var(--text-2)",marginBottom:6,textTransform:"uppercase",letterSpacing:"var(--tracking-caps)"},
  input:{width:"100%",height:"var(--input-h)",padding:"0 12px",background:"var(--surface)",border:"1px solid var(--border-strong)",borderRadius:"var(--r-md)",color:"var(--text)",fontSize:"var(--fs-base)",outline:"none",boxSizing:"border-box",fontFamily:"var(--font-sans)",transition:"border-color .12s, box-shadow .12s"},
  select:{width:"100%",height:"var(--input-h)",padding:"0 12px",background:"var(--surface)",border:"1px solid var(--border-strong)",borderRadius:"var(--r-md)",color:"var(--text)",fontSize:"var(--fs-base)",outline:"none",boxSizing:"border-box",fontFamily:"var(--font-sans)"},
  textarea:{width:"100%",padding:"10px 12px",background:"var(--surface)",border:"1px solid var(--border-strong)",borderRadius:"var(--r-md)",color:"var(--text)",fontSize:"var(--fs-base)",outline:"none",boxSizing:"border-box",fontFamily:"var(--font-sans)",minHeight:80,resize:"vertical",lineHeight:"var(--lh-base)"},
  btn:{display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6,height:"var(--btn-h)",padding:"0 14px",background:"var(--a-500)",color:"var(--text-on-accent)",border:"1px solid var(--a-600)",borderRadius:"var(--r-md)",fontSize:"var(--fs-base)",fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)",transition:"background .12s, border-color .12s, box-shadow .12s",letterSpacing:"var(--tracking-normal)",whiteSpace:"nowrap"},
  btnO:{display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6,height:"var(--btn-h)",padding:"0 14px",background:"var(--surface)",color:"var(--text)",border:"1px solid var(--border-strong)",borderRadius:"var(--r-md)",fontSize:"var(--fs-base)",fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)",transition:"background .12s, border-color .12s",whiteSpace:"nowrap"},
  btnD:{display:"inline-flex",alignItems:"center",gap:4,height:28,padding:"0 10px",background:"var(--red-500)",color:"#fff",border:"1px solid #b91c1c",borderRadius:"var(--r-sm)",fontSize:"var(--fs-sm)",fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"},
  btnSm:{display:"inline-flex",alignItems:"center",gap:4,height:28,padding:"0 10px",background:"var(--a-500)",color:"#fff",border:"1px solid var(--a-600)",borderRadius:"var(--r-sm)",fontSize:"var(--fs-sm)",fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)",whiteSpace:"nowrap",transition:"background .12s"},
  topbar:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px clamp(10px,3vw,24px)",borderBottom:"1px solid var(--border)",background:"color-mix(in srgb, var(--surface) 90%, transparent)",backdropFilter:"saturate(180%) blur(10px)",WebkitBackdropFilter:"saturate(180%) blur(10px)",position:"sticky",top:0,zIndex:50,flexWrap:"wrap",gap:8,minHeight:56},
  shell:{display:"flex",alignItems:"flex-start",minHeight:"calc(100vh - 56px)"},
  sidebar:{width:240,background:"var(--surface)",borderRight:"1px solid var(--border)",padding:"14px 12px",position:"sticky",top:56,height:"calc(100vh - 56px)",overflowY:"auto",flexShrink:0},
  sidebarCollapsed:{width:60,background:"var(--surface)",borderRight:"1px solid var(--border)",padding:"14px 6px",position:"sticky",top:56,height:"calc(100vh - 56px)",overflowY:"auto",flexShrink:0},
  sideGroup:{fontSize:10,color:"var(--text-4)",fontWeight:600,letterSpacing:"var(--tracking-caps)",textTransform:"uppercase",padding:"10px 10px 4px"},
  sideBtn:{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"7px 10px",border:"1px solid transparent",background:"transparent",cursor:"pointer",fontSize:"var(--fs-base)",fontWeight:500,color:"var(--text-2)",borderRadius:"var(--r-md)",fontFamily:"var(--font-sans)",textAlign:"left",marginBottom:1,transition:"background .1s, color .1s"},
  sideBtnActive:{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"7px 10px",border:"1px solid color-mix(in srgb, var(--a-500) 14%, transparent)",background:"var(--a-50)",cursor:"pointer",fontSize:"var(--fs-base)",fontWeight:600,color:"var(--a-700)",borderRadius:"var(--r-md)",fontFamily:"var(--font-sans)",textAlign:"left",marginBottom:1},
  logo:{fontFamily:"var(--font-display)",fontSize:18,fontWeight:700,letterSpacing:"var(--tracking-tight)",cursor:"pointer",color:"var(--text)"},
  avatar:{width:32,height:32,borderRadius:"50%",background:"var(--a-500)",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:600,cursor:"pointer",flexShrink:0,transition:"transform .15s",overflow:"hidden",letterSpacing:"0.02em",textTransform:"uppercase"},
  main:{padding:"clamp(14px,3vw,24px) clamp(12px,3.5vw,32px) 96px",flex:1,minWidth:0,maxWidth:1600,margin:"0 auto",width:"100%"},
  card:{background:"var(--surface)",borderRadius:"var(--r-lg)",border:"1px solid var(--border)",overflow:"hidden",boxShadow:"var(--shadow-xs)",transition:"box-shadow .12s, border-color .12s"},
  cardH:{padding:"14px var(--card-pad)",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12},
  cardT:{fontFamily:"var(--font-display)",fontSize:"var(--fs-md)",fontWeight:600,letterSpacing:"-0.01em",margin:0},
  cardB:{padding:"var(--card-pad)"},
  g2:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:16},
  g3:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16},
  th:{textAlign:"left",padding:"var(--cell-pad)",fontSize:"var(--fs-xs)",fontWeight:600,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"var(--tracking-caps)",borderBottom:"1px solid var(--border)",whiteSpace:"nowrap",background:"var(--surface)"},
  td:{padding:"var(--cell-pad)",borderBottom:"1px solid var(--divider)",fontSize:"var(--fs-base)",fontVariantNumeric:"tabular-nums"},
  tab:(a)=>({padding:"10px 14px",fontSize:"var(--fs-base)",fontWeight:a?600:500,background:"transparent",color:a?"var(--text)":"var(--text-3)",border:"none",borderBottom:a?"2px solid var(--a-500)":"2px solid transparent",marginBottom:-1,cursor:"pointer",fontFamily:"var(--font-sans)",transition:"color .12s, border-color .12s"}),
  overlay:{position:"fixed",inset:0,background:"rgba(15,23,42,.5)",backdropFilter:"blur(4px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:16},
  modal:{background:"var(--surface)",borderRadius:"var(--r-xl)",border:"1px solid var(--border)",width:"min(580px,100%)",maxWidth:"100%",maxHeight:"90vh",overflow:"auto",boxShadow:"var(--shadow-xl)"},
  tag:(bg,fg)=>({display:"inline-flex",alignItems:"center",gap:4,height:20,padding:"0 8px",borderRadius:"var(--r-sm)",fontSize:"var(--fs-xs)",fontWeight:500,background:bg,color:fg,letterSpacing:"var(--tracking-normal)",border:"1px solid transparent"}),
  pTrack:{height:6,borderRadius:999,background:"var(--n-100)",overflow:"hidden",flex:1},
  pFill:(p,c)=>({height:"100%",width:`${p}%`,borderRadius:999,background:c,transition:"width .3s ease"}),
  row:{display:"flex",gap:12,flexWrap:"wrap"},
  half:{flex:1,minWidth:"min(220px,100%)"},
  rBadge:(r)=>{const rc=roleColor(r);return{display:"inline-flex",alignItems:"center",height:18,padding:"0 6px",borderRadius:"var(--r-sm)",fontSize:10,fontWeight:600,background:rc.bg,color:rc.fg,marginLeft:6,letterSpacing:"var(--tracking-normal)"}},
  banner:(bg,fg)=>({padding:"12px 16px",borderRadius:"var(--r-md)",fontSize:"var(--fs-sm)",fontWeight:500,marginBottom:14,display:"flex",alignItems:"center",gap:8,background:bg,color:fg,border:"1px solid transparent"}),
  tsInput:{width:56,height:30,padding:"0 4px",background:"var(--surface)",border:"1px solid var(--border-strong)",borderRadius:"var(--r-sm)",color:"var(--text)",fontSize:"var(--fs-base)",textAlign:"center",outline:"none",boxSizing:"border-box",fontFamily:"var(--font-mono)",fontVariantNumeric:"tabular-nums",transition:"border-color .12s"},
  tsTotal:{fontSize:"var(--fs-base)",fontWeight:600,color:"var(--a-600)",textAlign:"center",minWidth:56,fontVariantNumeric:"tabular-nums"},
  // Glass form styles for the dark login card
  glassInput:{width:"100%",padding:"10px 14px",background:"rgba(255,255,255,.055)",border:"1px solid rgba(255,255,255,.14)",borderRadius:8,color:"#eef3ef",fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"var(--font-sans)",transition:"border-color .15s, box-shadow .15s",height:42},
  glassSelect:{width:"100%",padding:"10px 14px",background:"var(--surface)",border:"1px solid var(--border-strong)",borderRadius:8,color:"var(--text)",fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"var(--font-sans)",height:42},
  glassLabel:{display:"block",fontSize:12,fontWeight:600,color:"#aebbb2",marginBottom:6,letterSpacing:".01em"},
  glassBtn:{padding:"12px 24px",background:"#7EC800",color:"#071005",border:"none",borderRadius:8,fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"var(--font-sans)",letterSpacing:"-.01em",transition:"filter .15s, transform .1s",height:44,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6},
  glassBtnO:{padding:"10px 18px",background:"rgba(255,255,255,.06)",color:"#d7e0da",border:"1px solid rgba(255,255,255,.16)",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"},
  glassCard:{padding:"14px 16px",background:"rgba(255,255,255,.045)",borderRadius:8,border:"1px solid rgba(255,255,255,.11)"},
};

// ── File Upload Helpers ──
function fileToBase64(file){
  return new Promise((res,rej)=>{
    const r=new FileReader();
    r.onload=()=>res({name:file.name,type:file.type,size:file.size,data:r.result});
    r.onerror=()=>rej(new Error("Read failed"));
    r.readAsDataURL(file);
  });
}
async function handleFiles(fileList){
  const files=Array.from(fileList).filter(f=>f.size<5*1024*1024); // 5MB max
  return Promise.all(files.map(fileToBase64));
}
function Attachments({files}){
  if(!files||files.length===0) return null;
  return <div style={{marginTop:8,display:"flex",flexWrap:"wrap",gap:8}}>
    {files.map((f,i)=>{
      const isImg=f.type?.startsWith("image/");
      const isPdf=f.type==="application/pdf";
      return <div key={i} style={{border:`1px solid ${C.border}`,borderRadius:8,overflow:"hidden",background:C.card}}>
        {isImg&&<a href={f.data} target="_blank" rel="noopener"><img src={f.data} style={{maxWidth:220,maxHeight:160,display:"block",cursor:"pointer"}} alt={f.name}/></a>}
        <div style={{padding:"6px 10px",display:"flex",alignItems:"center",gap:6}}>
          <span style={{fontSize:16}}>{isImg?"🖼️":isPdf?"📄":"📎"}</span>
          <a href={f.data} download={f.name} target="_blank" rel="noopener" style={{fontSize:11,color:C.accent,fontWeight:600,textDecoration:"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:160}}>{f.name}</a>
          <span style={{fontSize:10,color:C.textDim}}>{(f.size/1024).toFixed(0)}KB</span>
        </div>
      </div>
    })}
  </div>;
}
function FileUploadInput({files,setFiles,label}){
  const inputRef=useRef(null);
  const addFiles=async(e)=>{
    const newFiles=await handleFiles(e.target.files);
    setFiles(prev=>[...prev,...newFiles]);
    if(inputRef.current)inputRef.current.value="";
  };
  const removeFile=(idx)=>setFiles(prev=>prev.filter((_,i)=>i!==idx));
  return <div style={{marginTop:6}}>
    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:files.length>0?8:0}}>
      <button type="button" onClick={()=>inputRef.current?.click()} style={{...S.btnO,padding:"5px 12px",fontSize:11,display:"flex",alignItems:"center",gap:4}}>📎 {label||"Attach Files"}</button>
      <input ref={inputRef} type="file" multiple accept="image/*,.pdf,.doc,.docx,.dwg,.xlsx" onChange={addFiles} style={{display:"none"}}/>
      <span style={{fontSize:10,color:C.textDim}}>Images, PDFs, docs · Max 5MB each</span>
    </div>
    {files.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:6}}>
      {files.map((f,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:6,background:C.card,borderRadius:6,padding:"4px 8px",border:`1px solid ${C.border}`}}>
        <span style={{fontSize:12}}>{f.type?.startsWith("image/")?"🖼️":f.type==="application/pdf"?"📄":"📎"}</span>
        <span style={{fontSize:11,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name}</span>
        <button onClick={()=>removeFile(i)} style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:14,padding:0,lineHeight:1}}>×</button>
      </div>)}
    </div>}
  </div>;
}

function Badge({children,bg,fg}){return <span style={S.tag(bg,fg)}>{children}</span>}
function RoleBadge({role}){return <span style={S.rBadge(role)}>{role.toUpperCase()}</span>}

// ── Mobile detection ──────────────────────────────────────────
function useIsMobile(){
  const [mobile,setMobile]=useState(()=>typeof window!=="undefined"&&window.innerWidth<768);
  useEffect(()=>{
    const fn=()=>setMobile(window.innerWidth<768);
    window.addEventListener("resize",fn,{passive:true});
    return()=>window.removeEventListener("resize",fn);
  },[]);
  return mobile;
}


// Accepts either a `user` object or individual props for custom rendering.
function Avatar({user,size=32,fontSize,style,onClick,title}){
  const photo=user?.profilePhoto;
  const initials=user?.avatar||"?";
  const bg=user?.profileColor||C.grad2;
  const fs=fontSize||Math.max(9,Math.round(size*0.36));
  const baseStyle={
    width:size,height:size,borderRadius:"50%",
    display:"inline-flex",alignItems:"center",justifyContent:"center",
    fontSize:fs,fontWeight:700,color:C.white,
    flexShrink:0,overflow:"hidden",
    background:photo?"transparent":bg,
    cursor:onClick?"pointer":undefined,
    ...style,
  };
  return <div style={baseStyle} onClick={onClick} title={title||user?.name}>
    {photo?<img src={photo} alt={user?.name||""} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>:initials}
  </div>;
}

function PBar({value,color=C.accent,height=6,showLabel}){
  return <div style={{display:"flex",alignItems:"center",gap:10}}><div style={{...S.pTrack,height}}><div style={S.pFill(value,color)}/></div>{showLabel&&<span style={{fontSize:12,fontWeight:600,color,minWidth:36,textAlign:"right"}}>{value}%</span>}</div>
}
function StatCard({label,value,sub,color=C.accent}){
  return <div style={{...S.card,padding:22,position:"relative",overflow:"hidden"}}><div style={{position:"absolute",top:-20,right:-20,width:80,height:80,borderRadius:"50%",background:color,opacity:.06}}/><div style={{fontSize:10,fontWeight:700,color:C.textDim,textTransform:"uppercase",letterSpacing:1.2,marginBottom:8}}>{label}</div><div style={{fontSize:28,fontWeight:800,fontFamily:"'Inter',sans-serif",color,letterSpacing:-1}}>{value}</div>{sub&&<div style={{fontSize:12,color:C.textMid,marginTop:4}}>{sub}</div>}</div>
}
function BudgetBar({category,allocated,spent}){
  const p=pct(spent,allocated);
  return <div style={{marginBottom:14}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{fontSize:13,fontWeight:500}}>{category}</span><span style={{fontSize:12,color:C.textMid}}>{fmtShort(spent)}/{fmtShort(allocated)}</span></div><PBar value={p} color={p>90?C.red:p>70?C.amber:C.accent} height={5}/></div>
}
function Timeline({milestones,startDate,endDate,projectName,projectNumber,project,onEditMilestone,unit,onToggleMilestone}){
  // unit comes from parent (ProjectDetailView) — no local state needed
  const PHASES=project?.customPhases&&project.customPhases.length>0?project.customPhases:["Proposal","Schematic Design","Design Development","IFC","Construction Admin","Closeout"];
  const schedule=project?.phaseSchedule||{};

  const sorted=[...milestones].sort((a,b)=>new Date(a.date)-new Date(b.date));
  const today=new Date();today.setHours(0,0,0,0);

  // Date range
  const allPhaseDates=PHASES.flatMap(ph=>schedule[ph]?[schedule[ph].start,schedule[ph].end].filter(Boolean):[]);
  const allDates=[...allPhaseDates,...sorted.map(m=>m.date)].filter(Boolean).map(d=>new Date(d).getTime());
  const startMs=allDates.length?Math.min(...allDates)-7*86400000:today.getTime()-30*86400000;
  const endMs=allDates.length?Math.max(...allDates)+14*86400000:today.getTime()+90*86400000;

  const getWeekNum=(d)=>{const date=new Date(d);date.setHours(0,0,0,0);date.setDate(date.getDate()+4-(date.getDay()||7));const yearStart=new Date(date.getFullYear(),0,1);return Math.ceil(((date-yearStart)/86400000+1)/7);};

  // Build slots
  const slots=[];
  const cursor=new Date(startMs);
  if(unit==="week"){
    cursor.setDate(cursor.getDate()-cursor.getDay());
    while(cursor.getTime()<=endMs){
      slots.push({label:`W${getWeekNum(cursor)}`,date:new Date(cursor),isCurrent:getWeekNum(today)===getWeekNum(cursor)&&today.getFullYear()===cursor.getFullYear()});
      cursor.setDate(cursor.getDate()+7);
    }
  }else{
    while(cursor.getTime()<=endMs){
      slots.push({label:cursor.toLocaleDateString("en-US",{month:"numeric",day:"numeric"}),date:new Date(cursor),isCurrent:cursor.toDateString()===today.toDateString()});
      cursor.setDate(cursor.getDate()+1);
    }
  }
  if(slots.length<2)return <div style={{padding:24,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No phase dates set yet. Use "📅 Edit phase dates" above to set the schedule.</div>;

  const totalMs=slots[slots.length-1].date.getTime()-slots[0].date.getTime();
  const pct=(d)=>{const ms=new Date(d).getTime()-slots[0].date.getTime();return Math.max(0,Math.min(100,(ms/totalMs)*100));};
  const todayPct=pct(today);

  // Phase rows
  const phaseRows=PHASES.map((name,idx)=>{
    const sch=schedule[name];
    let pStart=sch?.start||null;
    let pEnd=sch?.end||null;
    if(!pStart||!pEnd){
      const dur=totalMs/PHASES.length;
      pStart=pStart||new Date(slots[0].date.getTime()+idx*dur).toISOString().split("T")[0];
      pEnd=pEnd||new Date(slots[0].date.getTime()+(idx+1)*dur).toISOString().split("T")[0];
    }
    const isPast=new Date(pEnd)<today;
    const isCurrent=new Date(pStart)<=today&&new Date(pEnd)>=today;
    const isFuture=new Date(pStart)>today;
    const barColor=isPast?"var(--green-500)":isCurrent?"var(--violet-500,#8b5cf6)":"var(--n-200)";
    const scheduled=!!(sch?.start&&sch?.end);
    const shortLabel=name.split(/[\s/]+/)[0];
    const isActive=(project?.phase||"").toLowerCase()===name.toLowerCase();
    return {name,pStart,pEnd,isPast,isCurrent,isFuture,barColor,shortLabel,isActive,scheduled};
  });

  // For daily mode, only show every Nth label to avoid crowding
  const labelStep=unit==="day"?Math.max(1,Math.ceil(slots.length/18)):1;
  const COL="200px";
  const GAP=16;

  return <div style={{overflowX:"auto"}}>
    <div style={{minWidth:Math.max(700,unit==="day"?slots.length*22+220:slots.length*36+220),padding:"4px 0 32px"}}>

      {/* Fix 2: header = "Phase Timeline" */}
      {/* Week/day header row */}
      <div style={{display:"grid",gridTemplateColumns:`${COL} 1fr`,gap:GAP,marginBottom:10}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)"}}>Phase Timeline</div>
        <div style={{position:"relative",height:16,overflow:"visible"}}>
          {slots.filter((_,i)=>i%labelStep===0).map((s,fi)=>{
            // Use actual slot index for correct % positioning
            const actualIdx=fi*labelStep;
            const left=slots.length>1?(actualIdx/(slots.length-1))*100:0;
            return <div key={fi} style={{position:"absolute",left:`${left}%`,transform:"translateX(-50%)",fontSize:9,fontWeight:s.isCurrent?700:500,color:s.isCurrent?"var(--violet-500,#8b5cf6)":"var(--text-3)",fontFamily:"var(--font-mono)",whiteSpace:"nowrap",lineHeight:1}}>{s.label}</div>;
          })}
        </div>
      </div>

      {/* Phase rows + Today line container */}
      <div style={{position:"relative"}}>
        {phaseRows.map((ph,i)=>{
          const startPct=pct(ph.pStart);
          const endPct=pct(ph.pEnd);
          const widthPct=Math.max(1,endPct-startPct);
          return <div key={i} style={{display:"grid",gridTemplateColumns:`${COL} 1fr`,gap:GAP,alignItems:"center",marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:ph.isActive?700:500,color:ph.isActive?"var(--text)":"var(--text-2)",display:"flex",alignItems:"center",gap:6,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
              {ph.name}
              {!ph.scheduled&&<span style={{fontSize:9,color:"var(--text-4)",fontStyle:"italic",flexShrink:0}}>auto</span>}
            </div>
            <div style={{position:"relative",height:28,background:"var(--surface-2)",border:"1px solid var(--divider)",borderRadius:5}}>
              <div style={{position:"absolute",left:`${startPct}%`,width:`${widthPct}%`,top:2,bottom:2,background:ph.barColor,borderRadius:3,display:"flex",alignItems:"center",paddingLeft:6,fontSize:10,fontWeight:600,color:ph.barColor==="var(--n-200)"?"var(--text-3)":"#fff",overflow:"hidden",whiteSpace:"nowrap",boxShadow:ph.isCurrent?"0 1px 6px rgba(139,92,246,.3)":"none",minWidth:3}}>{widthPct>7?ph.shortLabel:""}</div>
            </div>
          </div>;
        })}

        {/* Fix 4: Today line — properly positioned, label above the line not cut off */}
        {todayPct>0&&todayPct<100&&<>
          {/* The line spans all phase rows — positioned over the track column */}
          <div style={{position:"absolute",top:0,bottom:0,left:`calc(${COL} + ${GAP}px + ${todayPct}% * (100% - ${COL} - ${GAP}px) / 100)`,width:2,background:"var(--violet-500,#8b5cf6)",zIndex:5,pointerEvents:"none"}}/>
          {/* TODAY label below the phase rows */}
          <div style={{display:"grid",gridTemplateColumns:`${COL} 1fr`,gap:GAP,marginTop:6}}>
            <div/>
            <div style={{position:"relative",height:16}}>
              <div style={{position:"absolute",left:`${todayPct}%`,transform:"translateX(-50%)",fontSize:9,fontWeight:700,color:"var(--violet-500,#8b5cf6)",letterSpacing:"0.06em",textTransform:"uppercase",whiteSpace:"nowrap"}}>TODAY</div>
            </div>
          </div>
        </>}
      </div>

      {/* Fix 2 + Fix 5: Milestones section — title = "Milestones", past ones clickable to mark complete */}
      {sorted.length>0&&<div style={{marginTop:24,paddingTop:16,borderTop:"1px solid var(--divider)"}}>
        <div style={{display:"grid",gridTemplateColumns:`${COL} 1fr`,gap:GAP,alignItems:"start"}}>
          <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",paddingTop:4}}>Milestones</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:10}}>
            {sorted.map((m,i)=>{
              const isPast=new Date(m.date)<today;
              const dotColor=m.done?"var(--green-500)":isPast?"var(--red-500)":"var(--a-500)";
              const bgColor=m.done?"color-mix(in srgb,var(--green-500) 8%,transparent)":isPast?"color-mix(in srgb,var(--red-500) 8%,transparent)":"var(--surface)";
              const borderColor=m.done?"color-mix(in srgb,var(--green-500) 30%,var(--border))":isPast?"color-mix(in srgb,var(--red-500) 25%,var(--border))":"var(--border)";
              const oi=(project?.milestones||[]).findIndex(x=>x===m||(x.name===m.name&&x.date===m.date));
              return <div key={i}
                style={{display:"flex",alignItems:"flex-start",gap:8,padding:"10px 12px",background:bgColor,border:`1px solid ${borderColor}`,borderRadius:10,cursor:"pointer",minWidth:148,maxWidth:210,flex:"0 0 auto",transition:"box-shadow .12s",position:"relative"}}
                onMouseEnter={e=>e.currentTarget.style.boxShadow="var(--shadow-sm)"}
                onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}
                title={m.done?"Complete — click to reopen":isPast?"Past — click to mark complete":`${m.name} · ${m.date}`}
                onClick={()=>{
                  // Fix 5: click to toggle done
                  if(onToggleMilestone&&oi>=0){onToggleMilestone(oi,!m.done);return;}
                  if(onEditMilestone&&oi>=0){onEditMilestone(oi,m);}
                }}>
                <div style={{width:10,height:10,borderRadius:"50%",background:m.done?dotColor:"var(--surface)",border:`2.5px solid ${dotColor}`,flexShrink:0,marginTop:3}}/>
                <div style={{minWidth:0,flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:"var(--text)",lineHeight:1.3,marginBottom:3,wordBreak:"break-word"}}>{m.done?"✓ ":""}{m.name}</div>
                  <div style={{fontSize:10,fontWeight:600,color:dotColor,fontFamily:"var(--font-mono)"}}>{new Date(m.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</div>
                  <div style={{fontSize:9,fontWeight:600,marginTop:3,textTransform:"uppercase",letterSpacing:"0.04em",color:m.done?"var(--green-600)":isPast?"var(--red-600)":"var(--text-3)"}}>
                    {m.done?"Complete":isPast?"Past — tap to complete":"Pending"}
                  </div>
                </div>
                {onEditMilestone&&oi>=0&&<span style={{fontSize:10,color:"var(--text-4)",flexShrink:0}}>✎</span>}
              </div>;
            })}
          </div>
        </div>
      </div>}
    </div>
  </div>;
}

function exportProjectSchedulePDF({project,milestones,deadlines,team,users,companyInfo}){
  const win=window.open("","_blank","width=1200,height=850");
  if(!win){alert("Pop-up blocked. Please allow pop-ups to export PDF.");return;}
  const allItems=[
    ...(milestones||[]).map(m=>({type:"Milestone",name:m.name,date:m.date,status:m.done?"Complete":"Pending",done:m.done})),
    ...(deadlines||[]).map(d=>({type:"Deadline",name:d.name,date:d.date,status:"Pending",done:false}))
  ].sort((a,b)=>new Date(a.date)-new Date(b.date));
  if(!allItems.length){alert("No milestones or deadlines to export.");return;}
  const today=new Date().toLocaleDateString("en-CA",{year:"numeric",month:"long",day:"numeric"});
  const teamNames=(team||[]).map(uid=>users.find(u=>u.id===uid)?.name).filter(Boolean);
  const dates=allItems.map(i=>new Date(i.date).getTime());
  const minD=new Date(Math.min(...dates));minD.setDate(1);
  const maxD=new Date(Math.max(...dates));maxD.setMonth(maxD.getMonth()+1);maxD.setDate(0);
  const totalMs=maxD-minD||1;
  const dayPct=(d)=>Math.max(0,Math.min(100,(new Date(d)-minD)/totalMs*100));
  const todayPct=dayPct(new Date());
  const months=[];const cur=new Date(minD);
  while(cur<=maxD){months.push(new Date(cur));cur.setMonth(cur.getMonth()+1);}
  const logoHtml=companyInfo?.logo
    ?`<img src="${companyInfo.logo}" style="max-height:56px;max-width:180px;object-fit:contain;display:block;">`
    :`<div style="font-size:26px;font-weight:800;color:#c96a33">${companyInfo?.name||"WorkBro"}</div>`;
  const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${project.number} Schedule</title><style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:-apple-system,'Segoe UI',sans-serif;color:#0f172a;padding:24px 32px;font-size:11px}
.header{display:flex;align-items:flex-start;justify-content:space-between;border-bottom:3px solid #c96a33;padding-bottom:14px;margin-bottom:18px}
.pnum{font-size:10px;color:#94a3b8;font-weight:700;letter-spacing:.08em;text-transform:uppercase;margin-bottom:3px}
.pname{font-size:19px;font-weight:800;color:#0f172a;letter-spacing:-.02em;margin-bottom:2px}
.psub{font-size:10px;color:#64748b}
.meta{text-align:right;font-size:10px;color:#64748b;line-height:1.9}
.info-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:10px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;margin-bottom:16px}
.ic label{display:block;font-size:8px;text-transform:uppercase;color:#94a3b8;letter-spacing:.08em;font-weight:700;margin-bottom:2px}
.ic span{font-size:11px;font-weight:700}
h2{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;margin:16px 0 8px;display:flex;align-items:center;gap:6px}
h2::before{content:'';display:inline-block;width:3px;height:13px;background:#c96a33;border-radius:2px}
table.st{width:100%;border-collapse:collapse;font-size:10px;margin-bottom:18px}
table.st th{background:#c96a33;color:#fff;padding:6px 10px;text-align:left;font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:.05em}
table.st td{padding:6px 10px;border-bottom:1px solid #f1f5f9;vertical-align:middle}
.pill{display:inline-block;padding:2px 7px;border-radius:20px;font-size:8px;font-weight:700;text-transform:uppercase}
.pd{background:#d1fae5;color:#065f46}.pp{background:#fef3c7;color:#92400e}.po{background:#fee2e2;color:#991b1b}
/* Gantt */
.gantt{width:100%;border-collapse:collapse;table-layout:fixed}
.gantt th.hdr{background:#f1f5f9;font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#64748b;padding:5px 0;text-align:center;border:1px solid #e2e8f0}
.gantt th.label-h{background:#f1f5f9;font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:#64748b;padding:5px 10px;border:1px solid #e2e8f0;width:220px;text-align:left}
.gantt td.label{padding:5px 10px;border:1px solid #f1f5f9;font-weight:600;font-size:9.5px;background:#fff;width:220px}
.gantt td.bar{border:1px solid #f1f5f9;padding:0;position:relative;height:26px}
.dot{position:absolute;top:50%;transform:translate(-50%,-50%);width:12px;height:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.3);z-index:3}
.dlabel{position:absolute;top:1px;font-size:7.5px;font-weight:700;transform:translateX(-50%);z-index:4;white-space:nowrap}
.tline{position:absolute;top:0;bottom:0;width:1.5px;background:#ef4444;opacity:.65;z-index:2}
.mbg:nth-child(even) .bar{background:#fafbfc}.mbg:nth-child(odd) .bar{background:#fff}
.footer{margin-top:22px;padding-top:10px;border-top:1px solid #e2e8f0;font-size:9px;color:#94a3b8;display:flex;justify-content:space-between}
@media print{@page{size:landscape;margin:10mm}}
</style></head><body>
<div class="header">
  <div><div style="margin-bottom:10px">${logoHtml}</div><div class="pnum">${project.number}</div><div class="pname">${project.name}</div><div class="psub">${[project.client,project.location,project.type].filter(Boolean).join(" · ")}</div></div>
  <div class="meta"><div><strong>Project Schedule</strong></div><div>Generated: ${today}</div><div>Status: <strong>${project.status||"—"}</strong></div><div>Progress: <strong>${project.progress||0}%</strong></div></div>
</div>
<div class="info-grid">
  <div class="ic"><label>Phase</label><span>${project.phase||"—"}</span></div>
  <div class="ic"><label>Start</label><span>${project.startDate||"—"}</span></div>
  <div class="ic"><label>End</label><span>${project.endDate||"—"}</span></div>
  <div class="ic"><label>Team</label><span>${teamNames.length} members</span></div>
  <div class="ic"><label>Budget</label><span>${project.budget?.total?"$"+Number(project.budget.total).toLocaleString():"—"}</span></div>
</div>
${teamNames.length?`<div style="font-size:10px;color:#475569;margin-bottom:14px"><strong>Team:</strong> ${teamNames.join(" · ")}</div>`:""}
<h2>Schedule Items</h2>
<table class="st"><thead><tr><th style="width:80px">Type</th><th>Item</th><th style="width:130px">Date</th><th style="width:90px">Status</th></tr></thead><tbody>
${allItems.map(item=>{const isPast=new Date(item.date)<new Date()&&!item.done;const pc=item.done?"pd":isPast?"po":"pp";const pt=item.done?"Complete":isPast?"Past":"Pending";return`<tr><td style="color:${item.type==="Milestone"?"#c96a33":"#dc2626"};font-weight:700">${item.type==="Milestone"?"◆":"●"} ${item.type}</td><td><strong>${item.name}</strong></td><td style="font-family:monospace;font-size:9.5px">${new Date(item.date).toLocaleDateString("en-CA",{year:"numeric",month:"short",day:"numeric",weekday:"short"})}</td><td><span class="pill ${pc}">${pt}</span></td></tr>`;}).join("")}
</tbody></table>
<h2>Gantt Chart — Milestone Timeline</h2>
<table class="gantt"><thead><tr><th class="label-h">Item</th>${months.map(m=>`<th class="hdr">${m.toLocaleDateString("en-US",{month:"short",year:"numeric"})}</th>`).join("")}</tr></thead><tbody>
${allItems.map(item=>{
  const p=dayPct(item.date);
  const isPast=new Date(item.date)<new Date()&&!item.done;
  const dc=item.done?"#0ca678":isPast?"#dc2626":"#c96a33";
  return`<tr><td class="label"><span style="color:${item.type==="Milestone"?"#c96a33":"#dc2626"}">${item.type==="Milestone"?"◆":"●"}</span> ${item.name}</td><td class="bar" colspan="${months.length}"><div style="position:relative;width:100%;height:100%">${todayPct>0&&todayPct<100?`<div class="tline" style="left:${todayPct}%"></div>`:""}
<div class="dot" style="left:${p}%;background:${dc}"></div>
<div class="dlabel" style="left:${p}%;color:${dc}">${new Date(item.date).toLocaleDateString("en-US",{month:"short",day:"numeric"})}</div></div></td></tr>`;
}).join("")}
</tbody></table>
<div class="footer"><span>${project.number} · ${project.name}</span><span>Prepared by ${companyInfo?.name||"WorkBro"} · workbro.ca · ${today}</span></div>
<script>window.addEventListener("load",()=>{setTimeout(()=>window.print(),400);});</script>
</body></html>`;
  win.document.write(html);win.document.close();
}

function Modal({title,onClose,children,footer,wide}){
  return <div style={S.overlay} onClick={onClose}><div data-wb-modal="1" style={{...S.modal,width:wide?900:580}} onClick={e=>e.stopPropagation()}>
    <div style={{padding:"18px 22px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between"}}><span style={{fontSize:18,fontWeight:600,letterSpacing:"-0.01em"}}>{title}</span><button onClick={onClose} style={{background:"none",border:"none",color:C.textMid,fontSize:22,cursor:"pointer",lineHeight:1}}>×</button></div>
    <div style={{padding:22}}>{children}</div>
    {footer&&<div style={{padding:"14px 22px",borderTop:`1px solid ${C.border}`,display:"flex",justifyContent:"flex-end",gap:10}}>{footer}</div>}
  </div></div>
}

function LandingPage({onLogin,onExternalLogin}){
  const [showLogin,setShowLogin]=useState(false);
  if(showLogin)return <LoginView onLogin={onLogin} onExternalLogin={onExternalLogin} onBackToLanding={()=>setShowLogin(false)}/>;

  // ═══ WorkBro.ca design system ═══
  const GREEN="#7EC800";
  const GREEN_HOVER="#8FDB00";
  const BG="#07090F";
  const BG2="#0C1018";
  const BG3="#111722";
  const RULE="rgba(255,255,255,.08)";
  const DIM="rgba(255,255,255,.55)";
  const DIM2="rgba(255,255,255,.28)";
  const FONT_STACK="'Inter','Inter',system-ui,sans-serif";

  const LP={
    wrap:{background:BG,color:"#FFF",fontFamily:FONT_STACK,minHeight:"100vh",overflow:"hidden",WebkitFontSmoothing:"antialiased"},
    nav:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 48px",height:68,position:"fixed",top:0,left:0,right:0,zIndex:100,background:"rgba(7,9,15,.82)",backdropFilter:"blur(20px)",WebkitBackdropFilter:"blur(20px)",borderBottom:`1px solid ${RULE}`},
    navLogo:{display:"flex",alignItems:"center",gap:10,background:"#FFFFFF",padding:"6px 14px",borderRadius:10},
    navLinks:{display:"flex",alignItems:"center",gap:32},
    navLink:{fontSize:14,fontWeight:500,color:DIM,textDecoration:"none",letterSpacing:"-.01em",transition:"color .15s",cursor:"pointer",background:"none",border:"none",fontFamily:FONT_STACK},
    navRight:{display:"flex",alignItems:"center",gap:14},
    btnGhost:{font:`500 14px ${FONT_STACK}`,color:DIM,background:"none",border:`1px solid ${RULE}`,padding:"9px 22px",borderRadius:6,cursor:"pointer",transition:"all .15s",letterSpacing:"-.01em"},
    btnGreen:{font:`600 14px ${FONT_STACK}`,color:"#000",background:GREEN,border:"none",padding:"10px 24px",borderRadius:6,cursor:"pointer",letterSpacing:"-.01em",transition:"background .15s"},

    hero:{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",padding:"120px 24px 80px",position:"relative",overflow:"hidden"},
    heroGlow:{position:"absolute",top:"-10%",left:"50%",transform:"translateX(-50%)",width:900,height:600,background:"radial-gradient(ellipse, rgba(126,200,0,.12) 0%, transparent 70%)",pointerEvents:"none"},
    heroEyebrow:{fontSize:12,fontWeight:600,letterSpacing:".18em",textTransform:"uppercase",color:GREEN,marginBottom:28},
    h1:{fontSize:"clamp(44px, 7vw, 88px)",fontWeight:800,letterSpacing:"-.04em",lineHeight:1.02,maxWidth:900,margin:"0 auto 28px",color:"#fff"},
    sub:{fontSize:"clamp(16px, 2vw, 19px)",fontWeight:400,color:DIM,maxWidth:540,margin:"0 auto 44px",lineHeight:1.65,letterSpacing:"-.01em"},
    btnHero:{font:`700 16px ${FONT_STACK}`,color:"#000",background:GREEN,border:"none",padding:"16px 36px",borderRadius:7,cursor:"pointer",letterSpacing:"-.01em",transition:"background .15s"},
    btnHeroGhost:{font:`500 16px ${FONT_STACK}`,color:"rgba(255,255,255,.75)",background:"none",border:"1px solid rgba(255,255,255,.18)",padding:"16px 36px",borderRadius:7,cursor:"pointer",letterSpacing:"-.01em",transition:"all .15s"},

    statsBar:{display:"flex",gap:"clamp(32px,6vw,100px)",justifyContent:"center",flexWrap:"wrap",padding:"40px 24px",borderTop:`1px solid ${RULE}`,width:"100%"},
    stat:{textAlign:"center"},
    statVal:{fontSize:"clamp(36px, 4vw, 54px)",fontWeight:800,letterSpacing:"-.04em",color:"#fff"},
    statValGreen:{color:GREEN},
    statLbl:{fontSize:12,fontWeight:500,letterSpacing:".12em",textTransform:"uppercase",color:DIM2,marginTop:6},

    section:{maxWidth:1180,margin:"0 auto",padding:"120px 24px"},
    ruleTop:{borderTop:`1px solid ${RULE}`},
    sectionTag:{fontSize:12,fontWeight:600,letterSpacing:".18em",textTransform:"uppercase",color:GREEN,marginBottom:20},
    sectionH:{fontSize:"clamp(34px, 4.5vw, 58px)",fontWeight:800,letterSpacing:"-.04em",lineHeight:1.05,marginBottom:20},
    sectionSub:{fontSize:17,color:DIM,lineHeight:1.65,maxWidth:560,letterSpacing:"-.01em"},

    featuresGrid:{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(320px, 1fr))",gap:1,background:RULE,border:`1px solid ${RULE}`,borderRadius:12,overflow:"hidden",marginTop:70},
    feature:{background:BG2,padding:"36px 32px",transition:"background .2s"},
    featureNum:{fontSize:12,fontWeight:600,letterSpacing:".1em",color:DIM2,marginBottom:20},
    featureIcon:{fontSize:28,marginBottom:14},
    featureTitle:{fontSize:18,fontWeight:700,letterSpacing:"-.02em",marginBottom:10,color:"#fff"},
    featureDesc:{fontSize:14,color:DIM,lineHeight:1.7,letterSpacing:"-.005em"},

    rolesGrid:{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))",gap:16,marginTop:60},
    roleCard:{background:BG2,border:`1px solid ${RULE}`,borderRadius:10,padding:"24px 20px",transition:"border-color .2s"},
    roleIcon:{fontSize:22,marginBottom:12},
    roleTitle:{fontSize:14,fontWeight:700,letterSpacing:"-.01em",marginBottom:6,color:"#fff"},
    roleDesc:{fontSize:13,color:DIM,lineHeight:1.6},

    steps:{display:"grid",gridTemplateColumns:"var(--wb-g3,repeat(3,1fr))",gap:40,marginTop:64},
    step:{},
    stepNum:{fontSize:52,fontWeight:800,letterSpacing:"-.04em",color:GREEN,marginBottom:16,opacity:.8},
    stepTitle:{fontSize:18,fontWeight:700,letterSpacing:"-.02em",marginBottom:10,color:"#fff"},
    stepDesc:{fontSize:14,color:DIM,lineHeight:1.7},

    ctaSection:{borderTop:`1px solid ${RULE}`,borderBottom:`1px solid ${RULE}`,textAlign:"center",padding:"120px 24px",position:"relative",overflow:"hidden",background:"radial-gradient(ellipse at 50% 0%, rgba(126,200,0,.07), transparent 65%)"},

    footer:{padding:"60px 48px 40px",maxWidth:1180,margin:"0 auto"},
    footerTop:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:40,flexWrap:"wrap",paddingBottom:48,borderBottom:`1px solid ${RULE}`},
    footerBrand:{display:"flex",flexDirection:"column",gap:16,maxWidth:280},
    footerBrandLogo:{background:"#FFFFFF",padding:"8px 14px",borderRadius:10,display:"flex",alignItems:"center",width:"fit-content"},
    footerBrandText:{fontSize:13,color:DIM2,lineHeight:1.6},
    footerLinks:{display:"flex",gap:60,flexWrap:"wrap"},
    footerCol:{},
    footerColH:{fontSize:12,fontWeight:600,letterSpacing:".14em",textTransform:"uppercase",color:DIM2,marginBottom:16},
    footerColLink:{display:"block",fontSize:14,color:DIM,textDecoration:"none",marginBottom:10,letterSpacing:"-.01em",transition:"color .15s",cursor:"pointer",background:"none",border:"none",fontFamily:FONT_STACK,padding:0,textAlign:"left"},
    footerBottom:{paddingTop:28,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12},
    footerBottomText:{fontSize:13,color:DIM2},
  };

  const features=[
    {n:"01",title:"Project Tracking",desc:"Track status, phase, milestones, and deadlines across every active project — in real time."},
    {n:"02",title:"Action Items",desc:"Weekly task lists per project with priority levels, carry-over tracking, and overdue alerts."},
    {n:"03",title:"Deliverables Calendar",desc:"Team-wide deadline calendar. See every submission date across all projects at a glance."},
    {n:"04",title:"Decision Log",desc:"Meeting notes, decisions, and coordination records tied directly to each project."},
    {n:"05",title:"Team Coordination",desc:"Assign work, track focus allocation, manage vacations, and run weekly team meetings — all in one place."},
    {n:"06",title:"Client & Contractor Access",desc:"Share projects via PIN codes. Clients view status, contractors submit questions — right permissions, every time."},
  ];

  const roles=[
    {icon:"👑",title:"Admin",desc:"Full workspace control. Manage users, teams, and project access."},
    {icon:"📐",title:"Project Manager",desc:"Create projects, assign teams, track milestones and deadlines."},
    {icon:"✏️",title:"Designer / Drafter",desc:"View assigned work, track deadlines, and log action items."},
    {icon:"🤝",title:"Client",desc:"View project status and updates. Read-only with PIN access."},
    {icon:"🔧",title:"Contractor",desc:"Submit questions and view project updates on shared projects."},
  ];

  const steps=[
    {n:"01",t:"Create Account",d:"Sign up with your name, email, and a PIN. Takes 30 seconds."},
    {n:"02",t:"Set Up Workspace",d:"Create a company, join an existing one, or use a personal workspace."},
    {n:"03",t:"Start Managing",d:"Add projects, assign teams, track time, and coordinate with clients."},
  ];

  return <div style={LP.wrap}>
    {/* NAV */}
    <nav style={LP.nav}>
      <div style={LP.navLogo}><LogoImg h={28}/></div>
      <div style={LP.navLinks}>
        <button onClick={()=>document.getElementById("features")?.scrollIntoView({behavior:"smooth"})} style={LP.navLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>Features</button>
        <button onClick={()=>document.getElementById("how")?.scrollIntoView({behavior:"smooth"})} style={LP.navLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>How it works</button>
        <button onClick={()=>document.getElementById("roles")?.scrollIntoView({behavior:"smooth"})} style={LP.navLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>Teams</button>
      </div>
      <div style={LP.navRight}>
        <button onClick={()=>setShowLogin(true)} style={LP.btnGhost} onMouseEnter={e=>{e.target.style.color="#fff";e.target.style.borderColor="rgba(255,255,255,.25)"}} onMouseLeave={e=>{e.target.style.color=DIM;e.target.style.borderColor=RULE}}>Sign In</button>
        <button onClick={()=>setShowLogin(true)} style={LP.btnGreen} onMouseEnter={e=>e.target.style.background=GREEN_HOVER} onMouseLeave={e=>e.target.style.background=GREEN}>Get Started</button>
      </div>
    </nav>

    {/* HERO */}
    <section style={LP.hero}>
      <div style={LP.heroGlow}/>
      <div style={{position:"relative",zIndex:1,display:"flex",flexDirection:"column",alignItems:"center"}}>
        <div style={LP.heroEyebrow}>Project Management · Built for Builders</div>
        <h1 style={LP.h1}>Run every project.<br/><em style={{fontStyle:"normal",color:GREEN}}>On time. On budget.</em></h1>
        <p style={LP.sub}>WorkBro gives engineering and architectural firms a single platform to track projects, coordinate teams, manage deadlines, and log decisions — without the complexity.</p>
        <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap",marginBottom:80}}>
          <button onClick={()=>setShowLogin(true)} style={LP.btnHero} onMouseEnter={e=>e.target.style.background=GREEN_HOVER} onMouseLeave={e=>e.target.style.background=GREEN}>Start for Free</button>
          <button onClick={()=>document.getElementById("features")?.scrollIntoView({behavior:"smooth"})} style={LP.btnHeroGhost} onMouseEnter={e=>{e.target.style.borderColor="rgba(255,255,255,.45)";e.target.style.color="#fff"}} onMouseLeave={e=>{e.target.style.borderColor="rgba(255,255,255,.18)";e.target.style.color="rgba(255,255,255,.75)"}}>See how it works ↓</button>
        </div>
      </div>
      <div style={LP.statsBar}>
        <div style={LP.stat}><div style={LP.statVal}><span style={LP.statValGreen}>∞</span></div><div style={LP.statLbl}>Projects</div></div>
        <div style={LP.stat}><div style={LP.statVal}>5</div><div style={LP.statLbl}>Permission Roles</div></div>
        <div style={LP.stat}><div style={LP.statVal}><span style={LP.statValGreen}>100</span>%</div><div style={LP.statLbl}>Cloud Synced</div></div>
        <div style={LP.stat}><div style={LP.statVal}><span style={LP.statValGreen}>Free</span></div><div style={LP.statLbl}>To Start</div></div>
      </div>
    </section>

    {/* FEATURES GRID */}
    <div id="features" style={{borderTop:`1px solid ${RULE}`}}>
      <div style={{...LP.section,paddingBottom:60}}>
        <div style={LP.sectionTag}>Platform Features</div>
        <h2 style={LP.sectionH}>Everything your firm<br/>needs to <em style={{fontStyle:"normal",color:GREEN}}>ship work</em></h2>
        <p style={LP.sectionSub}>From kickoff to final billing — one platform for your entire project lifecycle.</p>
        <div style={LP.featuresGrid}>
          {features.map((f,i)=><div key={i} style={LP.feature} onMouseEnter={e=>e.currentTarget.style.background=BG3} onMouseLeave={e=>e.currentTarget.style.background=BG2}>
            <div style={LP.featureNum}>{f.n}</div>
            <div style={LP.featureTitle}>{f.title}</div>
            <div style={LP.featureDesc}>{f.desc}</div>
          </div>)}
        </div>
      </div>
    </div>

    {/* ROLES */}
    <div id="roles" style={LP.ruleTop}>
      <div style={LP.section}>
        <div style={LP.sectionTag}>Five Permission Roles</div>
        <h2 style={LP.sectionH}>The <em style={{fontStyle:"normal",color:GREEN}}>right access</em><br/>for every teammate.</h2>
        <p style={LP.sectionSub}>From firm principals to outside contractors, each person sees exactly what they need — and nothing they don't.</p>
        <div style={LP.rolesGrid}>
          {roles.map((r,i)=><div key={i} style={LP.roleCard} onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(126,200,0,.35)"} onMouseLeave={e=>e.currentTarget.style.borderColor=RULE}>
            <div style={LP.roleIcon}>{r.icon}</div>
            <div style={LP.roleTitle}>{r.title}</div>
            <div style={LP.roleDesc}>{r.desc}</div>
          </div>)}
        </div>
      </div>
    </div>

    {/* HOW IT WORKS */}
    <div id="how" style={LP.ruleTop}>
      <div style={LP.section}>
        <div style={LP.sectionTag}>How It Works</div>
        <h2 style={LP.sectionH}>Up and running<br/>in <em style={{fontStyle:"normal",color:GREEN}}>minutes</em>.</h2>
        <p style={LP.sectionSub}>No onboarding calls. No long setup. Open the app, sign up, and start managing projects today.</p>
        <div style={LP.steps}>
          {steps.map((s,i)=><div key={i} style={LP.step}>
            <div style={LP.stepNum}>{s.n}</div>
            <div style={LP.stepTitle}>{s.t}</div>
            <div style={LP.stepDesc}>{s.d}</div>
          </div>)}
        </div>
      </div>
    </div>

    {/* CTA */}
    <section style={LP.ctaSection}>
      <h2 style={{...LP.sectionH,maxWidth:720,margin:"0 auto 16px"}}>Stop chasing spreadsheets.<br/><em style={{fontStyle:"normal",color:GREEN}}>Start shipping work.</em></h2>
      <p style={{...LP.sectionSub,margin:"0 auto 44px",textAlign:"center"}}>Join engineering and design firms using WorkBro to run projects end-to-end.</p>
      <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap"}}>
        <button onClick={()=>setShowLogin(true)} style={LP.btnHero} onMouseEnter={e=>e.target.style.background=GREEN_HOVER} onMouseLeave={e=>e.target.style.background=GREEN}>Get Started Free</button>
        <button onClick={()=>setShowLogin(true)} style={LP.btnHeroGhost} onMouseEnter={e=>{e.target.style.borderColor="rgba(255,255,255,.45)";e.target.style.color="#fff"}} onMouseLeave={e=>{e.target.style.borderColor="rgba(255,255,255,.18)";e.target.style.color="rgba(255,255,255,.75)"}}>Sign In</button>
      </div>
    </section>

    {/* FOOTER */}
    <footer style={LP.footer}>
      <div style={LP.footerTop}>
        <div style={LP.footerBrand}>
          <div style={LP.footerBrandLogo}><LogoImg h={24}/></div>
          <p style={LP.footerBrandText}>WorkBro — Project management for engineering and design firms. Built by people who've shipped real projects.</p>
        </div>
        <div style={LP.footerLinks}>
          <div style={LP.footerCol}>
            <h5 style={LP.footerColH}>Product</h5>
            <button onClick={()=>document.getElementById("features")?.scrollIntoView({behavior:"smooth"})} style={LP.footerColLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>Features</button>
            <button onClick={()=>document.getElementById("roles")?.scrollIntoView({behavior:"smooth"})} style={LP.footerColLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>Teams</button>
            <button onClick={()=>document.getElementById("how")?.scrollIntoView({behavior:"smooth"})} style={LP.footerColLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>How it works</button>
          </div>
          <div style={LP.footerCol}>
            <h5 style={LP.footerColH}>Account</h5>
            <button onClick={()=>setShowLogin(true)} style={LP.footerColLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>Sign In</button>
            <button onClick={()=>setShowLogin(true)} style={LP.footerColLink} onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=DIM}>Create Account</button>
          </div>
        </div>
      </div>
      <div style={LP.footerBottom}>
        <p style={LP.footerBottomText}>© 2026 WorkBro · Beta by Batu Ozer</p>
        <p style={LP.footerBottomText}>Made in Surrey, BC</p>
      </div>
    </footer>
  </div>;
}


function LoginPromoPanel(){
  return <div className="login-promo" style={{position:"fixed",top:0,right:0,bottom:0,width:"50%",zIndex:1}}>
    <div>
      <div className="eyebrow">Built for A/E firms</div>
      <h2>Run every project. On time. On budget.</h2>
      <p className="tagline">WorkBro brings your projects, teams, deadlines, and decisions into one platform built for engineering and architectural firms.</p>
      <div className="widget">
        <h3>Live portfolio · 10 active</h3>
        <div className="widget-row"><span className="dot"/><span className="name">Surrey Langley Skytrain</span><span className="pct">68%</span></div>
        <div className="widget-row"><span className="dot" style={{background:"var(--amber-500)"}}/><span className="name">Gilmore Station Upgrade</span><span className="pct">42%</span></div>
        <div className="widget-row"><span className="dot" style={{background:"var(--blue-500)"}}/><span className="name">Walton Elementary</span><span className="pct">88%</span></div>
      </div>
    </div>
  </div>;
}

function LoginView({onLogin,onExternalLogin,onBackToLanding}){
  const [mode,setMode]=useState("login"); // login|signup|signupWorkspace|joinPending|verifyEmail|external|forgotPin
  const [err,setErr]=useState(""); const [success,setSuccess]=useState("");
  // login
  const [email,setEmail]=useState(""); const [pin,setPin]=useState("");
  // forgot pin
  const [fpEmail,setFpEmail]=useState(""); const [fpCode,setFpCode]=useState(""); const [fpNewPin,setFpNewPin]=useState(""); const [fpConfirm,setFpConfirm]=useState(""); const [fpFound,setFpFound]=useState(null); const [loadingFp,setLoadingFp]=useState(false);
  // signup step 1
  const [sName,setSName]=useState(""); const [sEmail,setSEmail]=useState(""); const [sPin,setSPin]=useState(""); const [sPinC,setSPinC]=useState("");
  const [sRole,setSRole]=useState("Designer"); const [sBillable,setSBillable]=useState("Designer");
  // signup step 2: workspace
  const [wsType,setWsType]=useState(null); // "create"|"join"|"personal"
  const [coName,setCoName]=useState(""); const [joinCoId,setJoinCoId]=useState(""); const [joinPasscode,setJoinPasscode]=useState("");
  // email verification
  const [verifyData,setVerifyData]=useState(null); // {code, email, name, expiresAt, pendingAction}
  const [verifyInput,setVerifyInput]=useState("");
  const [resendCooldown,setResendCooldown]=useState(0);
  // external
  const [projNum,setProjNum]=useState(""); const [accessPin,setAccessPin]=useState(""); const [extRole,setExtRole]=useState("Client"); const [extName,setExtName]=useState("");
  // data
  const [companies,setCompanies]=useState([]);
  useEffect(()=>{(async()=>{setCompanies(await ld(REGISTRY_KEY,[]))})()},[]);

  // DB status check
  const [dbOk,setDbOk]=useState(null); // null=checking, true=ok, false=error, string=error message
  useEffect(()=>{
    (async()=>{
      try{
        const {data,error}=await supabase.from("kv_store").select("key").limit(1);
        if(error){setDbOk("Table error: "+error.message)}
        else{setDbOk(true);console.log("WBRO Login: DB connected, rows:",data?.length)}
      }catch(e){setDbOk("Connection failed: "+e.message)}
    })();
  },[]);

  const STAFF_ROLES=["Designer","Intermediate Designer","Senior Designer","Project Manager","Associate","Principal","Drafter","Senior Drafter","Administration","Marketing","Finance"];
  const lnk={background:"none",border:"none",color:"#60a5fa",cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:600,padding:0};

  // ── Login ──
  const handleLogin=async()=>{
    setErr("");
    if(!email.trim()||!pin.trim()){setErr("Enter email and PIN.");return}
    // Search all companies + personal for this user
    const allCos=await ld(REGISTRY_KEY,[]);
    console.log("WBRO Login: Found",allCos.length,"companies:",allCos.map(c=>c.name));
    const workspaces=[...allCos.map(c=>({...c,type:"company"})),{id:"personal:"+email.toLowerCase().replace(/[^a-z0-9]/g,""),name:"Personal",type:"personal"}];
    for(const ws of workspaces){
      const sk=getSK(ws.id);
      const users=await ld(sk.u,[]);
      console.log("WBRO Login: Workspace",ws.name,"has",users.length,"users:",users.map(u=>u.email));
      const found=users.find(u=>u.email.toLowerCase()===email.toLowerCase()&&u.pin===pin);
      if(found){
        if(found.status==="pending"){setErr("Your account is pending admin approval.");return}
        const session={userId:found.id,companyId:ws.id,companyName:ws.name,companyType:ws.type};
        
        localStorage.setItem(SESSION_KEY,JSON.stringify(session));
        onLogin(found,{id:ws.id,name:ws.name,type:ws.type});return;
      }
    }
    setErr(`No account found. Searched ${allCos.length} workspace(s). If you're new, click 'Create Account' below.`);
  };

  // ── Signup Step 1 validation ──
  const validateStep1=()=>{
    setErr("");
    if(!sName.trim()||!sEmail.trim()||!sPin.trim()){setErr("Fill all required fields.");return false}
    if(sPin!==sPinC){setErr("PINs don't match.");return false}
    if(sPin.length<4){setErr("PIN must be at least 4 characters.");return false}
    return true;
  };

  // ── Create Company ──
  const handleCreateCompany=async()=>{
    setErr("");
    if(!coName.trim()){setErr("Enter company name.");return}
    const allCos=await ld(REGISTRY_KEY,[]);
    const slug=coName.trim().toLowerCase().replace(/[^a-z0-9]/g,"-").replace(/-+/g,"-");
    if(allCos.find(c=>c.slug===slug)){setErr("Company name already taken.");return}
    const co={id:genId("co"),name:coName.trim(),slug,createdAt:new Date().toISOString().split("T")[0]};
    const newUser={id:genId("u"),name:sName.trim(),email:sEmail.trim(),pin:sPin,role:"Admin",billableRole:sBillable,avatar:makeAvatar(sName),teamName:"",status:"active"};
    await addCompanyToRegistry(co);
    const sk=getSK(co.id);
    const teams=sTeam?[{id:genId("tm"),name:sTeam,createdBy:newUser.id,createdAt:co.createdAt,memberCount:1}]:[];
    await Promise.all([sv(sk.u,[newUser]),sv(sk.p,[]),sv(sk.t,{}),sv(sk.n,{}),sv(sk.f,[]),sv(sk.a,{}),sv(sk.teams,teams)]);
    const session={userId:newUser.id,companyId:co.id,companyName:co.name,companyType:"company"};
    
    localStorage.setItem(SESSION_KEY,JSON.stringify(session));
    onLogin(newUser,{id:co.id,name:co.name,type:"company"});
  };

  // ── Email Verification ──────────────────────────────────────
  const SUPABASE_ANON="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5jY3Z4aGp4cGdvY3JmdWR4aHJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYwMTgwMzYsImV4cCI6MjA5MTU5NDAzNn0.xnn2_nmemFV9mVSQoQe9EhQmnNaLGgH74eI7Uf3-QkA";
  const EMAIL_FN="https://nccvxhjxpgocrfudxhrl.supabase.co/functions/v1/send-email";

  const sendVerificationCode=async(toEmail,toName)=>{
    const code=String(Math.floor(100000+Math.random()*900000)); // 6-digit code
    const expiresAt=Date.now()+10*60*1000; // 10 minutes
    try{
      const res=await fetch(EMAIL_FN,{
        method:"POST",
        headers:{"Authorization":"Bearer "+SUPABASE_ANON,"Content-Type":"application/json"},
        body:JSON.stringify({
          to:toEmail,
          subject:"Your WorkBro verification code",
          html:`<!DOCTYPE html><html><body style="margin:0;padding:0;background:#f4f4f5;font-family:-apple-system,sans-serif;">
<div style="max-width:480px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;">
<div style="background:#c96a33;padding:24px 32px;"><div style="font-size:22px;font-weight:700;color:#fff;">WorkBro</div></div>
<div style="padding:32px;">
<h2 style="margin:0 0 8px;color:#0f172a;">Verify your email</h2>
<p style="color:#475569;margin:0 0 24px;">Hi ${toName}, enter this code to complete your WorkBro signup:</p>
<div style="text-align:center;margin:28px 0;">
<div style="font-size:48px;font-weight:700;letter-spacing:12px;color:#c96a33;font-family:monospace;">${code}</div>
<div style="font-size:13px;color:#94a3b8;margin-top:12px;">Expires in 10 minutes</div>
</div>
<p style="color:#64748b;font-size:13px;">If you didn't request this, you can ignore this email.</p>
</div>
<div style="padding:20px 32px;border-top:1px solid #f0f0f0;background:#fafafa;"><p style="margin:0;font-size:11px;color:#94a3b8;">WorkBro · workbro.ca</p></div>
</div></body></html>`
        })
      });
      if(!res.ok)throw new Error("Email send failed");
      return{code,expiresAt};
    }catch(e){
      throw new Error("Could not send verification email. Please check your email address and try again.");
    }
  };

  const startResendCooldown=()=>{
    setResendCooldown(60);
    const t=setInterval(()=>setResendCooldown(v=>{if(v<=1){clearInterval(t);return 0;}return v-1;}),1000);
  };

  const handleResendCode=async()=>{
    if(!verifyData||resendCooldown>0)return;
    setErr("");
    try{
      const{code,expiresAt}=await sendVerificationCode(verifyData.email,verifyData.name);
      setVerifyData(prev=>({...prev,code,expiresAt}));
      setVerifyInput("");
      startResendCooldown();
      setSuccess("New code sent! Check your email.");
      setTimeout(()=>setSuccess(""),3000);
    }catch(e){setErr(e.message);}
  };

  const handleVerifyCode=async()=>{
    setErr("");
    if(!verifyData){setErr("Verification data missing. Please start over.");return}
    if(Date.now()>verifyData.expiresAt){setErr("Code expired. Click 'Resend code' to get a new one.");return}
    if(verifyInput.trim()!==verifyData.code){setErr("Incorrect code. Please check your email and try again.");return}
    // Code is correct — run the pending action
    try{
      await verifyData.pendingAction();
    }catch(e){setErr(e.message||"Something went wrong. Please try again.");}
  };

  // ── Join Existing Company ──
  const handleJoinCompany=async()=>{
    setErr("");
    if(!joinCoId){setErr("Select a company.");return}
    const co=companies.find(c=>c.id===joinCoId);
    if(!co){setErr("Company not found.");return}
    const sk=getSK(co.id);
    const existing=await ld(sk.u,[]);
    if(existing.find(u=>u.email.toLowerCase()===sEmail.toLowerCase())){setErr("Email already registered in this workspace.");return}
    const companyInfo=await ld(sk.company,{});
    const hasCode=joinPasscode.trim().length>0;
    const correctCode=companyInfo?.passcode&&joinPasscode.trim().toUpperCase()===companyInfo.passcode.toUpperCase();
    if(hasCode&&!correctCode){setErr("Invalid passcode. Leave blank to request approval, or ask your admin for the correct passcode.");return}
    const autoActivate=hasCode&&correctCode;
    // Email already verified at signup step — create account directly
    const newUser={id:genId("u"),name:sName.trim(),email:sEmail.trim(),pin:sPin,role:sRole,billableRole:sBillable,avatar:makeAvatar(sName),teamName:"",status:autoActivate?"active":"pending"};
    await sv(sk.u,[...existing,newUser]);
    if(autoActivate){
      // Send welcome email
      fetch(EMAIL_FN,{method:"POST",headers:{"Authorization":"Bearer "+SUPABASE_ANON,"Content-Type":"application/json"},
        body:JSON.stringify({to:newUser.email,subject:`Welcome to ${co.name} on WorkBro!`,
          html:`<!DOCTYPE html><html><body style="margin:0;padding:0;background:#f4f4f5;font-family:-apple-system,sans-serif;"><div style="max-width:560px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;"><div style="background:#c96a33;padding:24px 32px;"><div style="font-size:22px;font-weight:700;color:#fff;">WorkBro</div></div><div style="padding:32px;"><h2 style="margin:0 0 16px;color:#0f172a;">Welcome to ${co.name}! 🎉</h2><p>Hi ${newUser.name},</p><p>You've successfully joined <strong>${co.name}</strong> on WorkBro.</p><p style="margin:24px 0"><a href="https://workbro.ca" style="background:#c96a33;color:#fff;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600;">Go to WorkBro →</a></p></div><div style="padding:20px 32px;border-top:1px solid #f0f0f0;background:#fafafa;"><p style="margin:0;font-size:11px;color:#94a3b8;">WorkBro · workbro.ca</p></div></div></body></html>`
        })
      }).catch(()=>{});
      localStorage.setItem(SESSION_KEY,JSON.stringify({userId:newUser.id,companyId:co.id,companyName:co.name,companyType:"workspace"}));
      onLogin(newUser,{id:co.id,name:co.name,type:"workspace"});
    }else{
      // Pending approval — notify admins via in-app notification (email sent when approved)
      setMode("joinPending");setSuccess(co.name);
    }
  };

  // ── Personal Workspace ──
  const handlePersonal=async()=>{
    setErr("");
    const pid="personal:"+sEmail.toLowerCase().replace(/[^a-z0-9]/g,"");
    const newUser={id:genId("u"),name:sName.trim(),email:sEmail.trim(),pin:sPin,role:"Admin",billableRole:sBillable,avatar:makeAvatar(sName),teamName:"",status:"active"};
    const sk=getSK(pid);
    const existing=await ld(sk.u,[]);
    if(existing.length>0){setErr("A personal workspace with this email already exists. Please log in.");return}
    await Promise.all([sv(sk.u,[newUser]),sv(sk.p,[]),sv(sk.t,{}),sv(sk.n,{}),sv(sk.f,[]),sv(sk.a,{})]);
    localStorage.setItem(SESSION_KEY,JSON.stringify({userId:newUser.id,companyId:pid,companyName:"Personal",companyType:"personal"}));
    onLogin(newUser,{id:pid,name:"Personal",type:"personal"});
  };

  // ── External login ──
  const handleExtLogin=async()=>{
    setErr("");
    if(!extName.trim()){setErr("Enter your name.");return}
    const allCos=await ld(REGISTRY_KEY,[]);
    for(const co of allCos){
      const sk=getSK(co.id);
      const projs=await ld(sk.p,[]);
      const proj=projs.find(p=>p.number.toLowerCase()===projNum.trim().toLowerCase()&&p.accessPin===accessPin.trim());
      if(proj){
        onExternalLogin({id:genId("ext"),name:extName.trim(),role:extRole,avatar:makeAvatar(extName.trim()),projectId:proj.id,projectName:proj.name},{id:co.id,name:co.name,type:"company"});return;
      }
    }
    setErr("Invalid project number or PIN.");
  };

  // ── Forgot PIN: send reset code to email ──
  const handleForgotLookup=async()=>{
    setErr("");setSuccess("");
    if(!fpEmail.trim()){setErr("Enter your email address.");return}
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(fpEmail.trim())){setErr("Please enter a valid email address.");return}
    setLoadingFp(true);
    try{
      const allCos=await ld(REGISTRY_KEY,[]);
      const workspaces=[...allCos.map(c=>({...c,type:"company"}))];
      const personalId="personal:"+fpEmail.toLowerCase().replace(/[^a-z0-9]/g,"");
      workspaces.push({id:personalId,name:"Personal",type:"personal"});
      let found=null;
      for(const ws of workspaces){
        const sk=getSK(ws.id);
        const users=await ld(sk.u,[]);
        const u=users.find(x=>x.email.toLowerCase()===fpEmail.trim().toLowerCase());
        if(u){found={user:u,workspace:ws};break}
      }
      if(!found){
        // Show generic success message anyway to prevent email enumeration attacks
        setSuccess("If an account exists for this email, a reset code has been sent.");
        setTimeout(()=>{setLoadingFp(false)},800);
        return;
      }
      // Send the reset code email
      const code=String(Math.floor(100000+Math.random()*900000));
      const expiresAt=Date.now()+15*60*1000; // 15 minutes
      const res=await fetch(EMAIL_FN,{
        method:"POST",
        headers:{"Authorization":"Bearer "+SUPABASE_ANON,"Content-Type":"application/json"},
        body:JSON.stringify({
          to:found.user.email,
          subject:"Reset your WorkBro PIN",
          html:`<!DOCTYPE html><html><body style="margin:0;padding:0;background:#f4f4f5;font-family:-apple-system,sans-serif;">
<div style="max-width:480px;margin:40px auto;background:#fff;border-radius:12px;overflow:hidden;">
<div style="background:#c96a33;padding:24px 32px;"><div style="font-size:22px;font-weight:700;color:#fff;">WorkBro</div></div>
<div style="padding:32px;">
<h2 style="margin:0 0 8px;color:#0f172a;">Reset your PIN</h2>
<p style="color:#475569;margin:0 0 24px;">Hi ${found.user.name}, you requested to reset your WorkBro PIN. Enter this code on the reset page to continue:</p>
<div style="text-align:center;margin:28px 0;">
<div style="font-size:48px;font-weight:700;letter-spacing:12px;color:#c96a33;font-family:monospace;">${code}</div>
<div style="font-size:13px;color:#94a3b8;margin-top:12px;">Expires in 15 minutes</div>
</div>
<p style="color:#64748b;font-size:13px;">If you didn't request this reset, you can safely ignore this email — your PIN will not change.</p>
</div>
<div style="padding:20px 32px;border-top:1px solid #f0f0f0;background:#fafafa;"><p style="margin:0;font-size:11px;color:#94a3b8;">WorkBro · workbro.ca</p></div>
</div></body></html>`
        })
      });
      if(!res.ok)throw new Error("Email send failed");
      setFpFound({...found,code,expiresAt});
      setSuccess(`Reset code sent to ${found.user.email}. Check your inbox.`);
    }catch(e){
      setErr("Could not send reset email. Please try again or contact support.");
    }
    setLoadingFp(false);
  };

  // ── Verify code + set new PIN ──
  const handleResetPin=async()=>{
    setErr("");setSuccess("");
    if(!fpFound)return;
    if(Date.now()>fpFound.expiresAt){setErr("Code expired. Please request a new code.");return}
    if(!fpCode.trim()||fpCode.trim()!==fpFound.code){setErr("Incorrect code. Please check your email and try again.");return}
    if(!fpNewPin||fpNewPin.length<4){setErr("PIN must be at least 4 characters.");return}
    if(fpNewPin!==fpConfirm){setErr("PINs don't match.");return}
    setLoadingFp(true);
    try{
      const sk=getSK(fpFound.workspace.id);
      const users=await ld(sk.u,[]);
      const updated=users.map(u=>u.id===fpFound.user.id?{...u,pin:fpNewPin}:u);
      await sv(sk.u,updated);
      setSuccess("PIN reset successfully! Redirecting to login…");
      setTimeout(()=>{setMode("login");setEmail(fpEmail);setPin("");setErr("");setSuccess("");setFpFound(null);setFpEmail("");setFpCode("");setFpNewPin("");setFpConfirm("");setLoadingFp(false)},1800);
    }catch(e){
      setErr("Reset failed. Please try again.");
      setLoadingFp(false);
    }
  };

  // ── Forgot PIN Screen ──
  if(mode==="forgotPin"){
    return <div className="wb-auth" style={S.loginWrap}><div style={{...S.loginCard,width:440}}>
      <div style={S.loginTitle}>Reset your PIN</div>
      <div style={S.loginSub}>{!fpFound?"Enter your email and we'll send a reset code":`We sent a 6-digit code to ${fpFound.user.email}`}</div>
      {success&&<div style={{padding:"12px 16px",borderRadius:12,marginBottom:16,fontSize:13,background:"rgba(12,166,120,.15)",color:C.green,fontWeight:500,border:"1px solid rgba(12,166,120,.3)"}}>{success}</div>}
      {!fpFound?<>
        <div style={S.inputGroup}>
          <label style={S.glassLabel}>Email Address</label>
          <input style={S.glassInput} value={fpEmail} onChange={e=>setFpEmail(e.target.value)} placeholder="you@company.com" autoFocus onKeyDown={e=>e.key==="Enter"&&!loadingFp&&handleForgotLookup()}/>
        </div>
        {err&&<div style={{color:"#ff6b6b",fontSize:12,marginBottom:10}}>{err}</div>}
        <button style={{...S.glassBtn,width:"100%",opacity:loadingFp?0.6:1,cursor:loadingFp?"wait":"pointer"}} disabled={loadingFp} onClick={handleForgotLookup}>{loadingFp?"Sending…":"Send reset code"}</button>
        <div style={{marginTop:14,fontSize:11,color:"var(--text-3)",textAlign:"center",lineHeight:1.5}}>We'll email you a 6-digit code valid for 15 minutes.<br/>Check your spam folder if it doesn't arrive in a minute.</div>
      </>:<>
        <div style={S.inputGroup}>
          <label style={S.glassLabel}>6-Digit Code from Email</label>
          <input style={{...S.glassInput,fontFamily:"monospace",fontSize:18,letterSpacing:"0.3em",textAlign:"center"}} value={fpCode} onChange={e=>setFpCode(e.target.value.replace(/[^0-9]/g,"").slice(0,6))} placeholder="000000" autoFocus maxLength={6}/>
        </div>
        <div style={S.row}>
          <div style={{...S.inputGroup,...S.half}}><label style={S.glassLabel}>New PIN</label><input style={S.glassInput} type="password" value={fpNewPin} onChange={e=>setFpNewPin(e.target.value)} placeholder="••••"/></div>
          <div style={{...S.inputGroup,...S.half}}><label style={S.glassLabel}>Confirm PIN</label><input style={S.glassInput} type="password" value={fpConfirm} onChange={e=>setFpConfirm(e.target.value)} placeholder="••••" onKeyDown={e=>e.key==="Enter"&&!loadingFp&&handleResetPin()}/></div>
        </div>
        {err&&<div style={{color:"#ff6b6b",fontSize:12,marginBottom:10}}>{err}</div>}
        <button style={{...S.glassBtn,width:"100%",opacity:loadingFp?0.6:1,cursor:loadingFp?"wait":"pointer"}} disabled={loadingFp} onClick={handleResetPin}>{loadingFp?"Resetting…":"Reset PIN"}</button>
        <div style={{marginTop:12,textAlign:"center"}}>
          <button onClick={()=>{setFpFound(null);setFpCode("");setFpNewPin("");setFpConfirm("");setErr("");setSuccess("")}} style={{...lnk,fontSize:12}}>← Use a different email</button>
        </div>
      </>}
      <div style={{marginTop:16,textAlign:"center"}}><button onClick={()=>{setMode("login");setErr("");setSuccess("");setFpFound(null);setFpEmail("");setFpCode("");setFpNewPin("");setFpConfirm("")}} style={lnk}>← Back to Login</button></div>
    </div><LoginPromoPanel/></div>;
  }

  // ── Join Pending ──
  if(mode==="verifyEmail"){
    return <div className="wb-auth" style={S.loginWrap}><div style={S.loginCard}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:48,marginBottom:12}}>📧</div>
        <div style={S.loginTitle}>Check your email</div>
        <div style={{color:"rgba(255,255,255,.6)",fontSize:14,lineHeight:1.6,margin:"8px 0 0"}}>
          We sent a 6-digit code to<br/>
          <strong style={{color:"#fff"}}>{verifyData?.email}</strong>
        </div>
      </div>

      {err&&<div style={{background:"rgba(235,87,87,.15)",border:"1px solid rgba(235,87,87,.3)",color:"#f87171",padding:"10px 14px",borderRadius:8,fontSize:13,marginBottom:14}}>{err}</div>}
      {success&&<div style={{background:"rgba(38,180,126,.15)",border:"1px solid rgba(38,180,126,.3)",color:"#34d399",padding:"10px 14px",borderRadius:8,fontSize:13,marginBottom:14}}>{success}</div>}

      <div style={{marginBottom:20}}>
        <label style={S.glassLabel}>Verification Code</label>
        <input
          style={{...S.glassInput,fontSize:32,fontWeight:700,letterSpacing:16,textAlign:"center",fontFamily:"monospace",padding:"16px 20px"}}
          value={verifyInput}
          onChange={e=>setVerifyInput(e.target.value.replace(/\D/g,"").slice(0,6))}
          onKeyDown={e=>{if(e.key==="Enter"&&verifyInput.length===6)handleVerifyCode()}}
          placeholder="000000"
          maxLength={6}
          autoFocus
        />
        <div style={{fontSize:12,color:"var(--text-3)",marginTop:8,textAlign:"center"}}>
          Code expires in 10 minutes · Check your spam folder if you don't see it
        </div>
      </div>

      <button
        style={{...S.glassBtn,width:"100%",opacity:verifyInput.length===6?1:.5,marginBottom:14}}
        onClick={handleVerifyCode}
        disabled={verifyInput.length!==6}
      >
        Verify Email →
      </button>

      <div style={{textAlign:"center"}}>
        <button
          onClick={handleResendCode}
          disabled={resendCooldown>0}
          style={{background:"none",border:"none",color:resendCooldown>0?"rgba(255,255,255,.3)":"rgba(255,255,255,.6)",cursor:resendCooldown>0?"default":"pointer",fontSize:13,fontFamily:"var(--font-sans)"}}
        >
          {resendCooldown>0?`Resend code in ${resendCooldown}s`:"Didn't receive it? Resend code"}
        </button>
      </div>

      <div style={{marginTop:16,textAlign:"center"}}>
        <button onClick={()=>{setMode("signup");setErr("");setVerifyInput("");}} style={{background:"none",border:"none",color:"var(--text-3)",cursor:"pointer",fontSize:12,fontFamily:"var(--font-sans)"}}>← Back</button>
      </div>
    </div><LoginPromoPanel/></div>;
  }

  if(mode==="joinPending"){
    return <div className="wb-auth" style={S.loginWrap}><div style={S.loginCard}>
      <div style={{textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:16}}>⏳</div>
        <div style={S.loginTitle}>Request Submitted</div>
        <div style={{color:C.textMid,fontSize:14,lineHeight:1.6,margin:"12px 0 24px"}}>Your request to join <strong style={{color:C.accent}}>{success}</strong> has been submitted. An admin will review and approve your access.</div>
        <button style={{...S.btn,width:"100%"}} onClick={()=>{setMode("login");setErr("")}}>Back to Login</button>
      </div>
    </div><LoginPromoPanel/></div>;
  }

  // ── Signup Step 2: Choose Workspace ──
  if(mode==="signupWorkspace"){
    return <div className="wb-auth" style={S.loginWrap}><div style={{...S.loginCard,width:"min(520px,100%)"}}>
      <div style={{textAlign:"center",marginBottom:16}}><div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",background:"#FFFFFF",padding:"8px 16px",borderRadius:10}}><LogoImg h={32}/></div></div>
      <div style={S.loginTitle}>Choose Workspace</div>
      <div style={S.loginSub}>Hi <strong>{sName}</strong>, how would you like to use WBRO?</div>

      {!wsType&&<div style={{display:"flex",flexDirection:"column",gap:10}}>
        {[
          {key:"create",icon:"🏢",title:"Create a Company",desc:"Start a new workspace for your company. You'll be the admin."},
          {key:"join",icon:"🤝",title:"Join Existing Company",desc:"Request to join a company that's already on WorkBro."},
          {key:"personal",icon:"👤",title:"Personal Workspace",desc:"A private workspace just for you and your own projects."},
        ].map(opt=><button key={opt.key} onClick={()=>{setWsType(opt.key);setErr("")}}
          style={{display:"flex",alignItems:"center",gap:16,width:"100%",padding:"16px 20px",background:"var(--surface-2)",border:"1px solid var(--border-strong)",borderRadius:12,cursor:"pointer",fontFamily:"var(--font-sans)",textAlign:"left",transition:"all .15s"}}
          onMouseEnter={e=>{e.currentTarget.style.borderColor="var(--a-400)";e.currentTarget.style.background="var(--a-50)"}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--border-strong)";e.currentTarget.style.background="var(--surface-2)"}}>
          <div style={{fontSize:28,flexShrink:0}}>{opt.icon}</div>
          <div>
            <div style={{fontWeight:600,fontSize:14,color:"var(--text)",marginBottom:2}}>{opt.title}</div>
            <div style={{fontSize:12,color:"var(--text-3)",lineHeight:1.4}}>{opt.desc}</div>
          </div>
          <div style={{marginLeft:"auto",color:"var(--text-3)",fontSize:18,flexShrink:0}}>›</div>
        </button>)}
      </div>}

      {wsType==="create"&&<div>
        <div style={{fontSize:13,color:"var(--text-2)",marginBottom:14,padding:"10px 14px",background:"var(--a-50)",borderRadius:8,border:"1px solid var(--border)"}}>You'll be set as the Admin of this workspace.</div>
        <div style={S.inputGroup}><label style={S.glassLabel}>Company Name *</label><input style={S.glassInput} value={coName} onChange={e=>setCoName(e.target.value)} placeholder="e.g. OM Engineering" autoFocus onKeyDown={e=>e.key==="Enter"&&handleCreateCompany()}/></div>
        {err&&<div style={{color:"var(--red-600)",fontSize:12,marginBottom:10,padding:"8px 12px",background:"color-mix(in srgb,var(--red-500) 10%,transparent)",borderRadius:6}}>{err}</div>}
        <button style={{...S.glassBtn,width:"100%"}} onClick={handleCreateCompany}>Create Workspace</button>
      </div>}

      {wsType==="join"&&<div>
        {companies.length===0&&<div style={{...S.glassCard,padding:20,textAlign:"center",marginBottom:14,color:"var(--text-3)",fontSize:13}}>No companies registered yet.</div>}
        {companies.length>0&&<div style={S.inputGroup}><label style={S.glassLabel}>Select Company *</label>
          {companies.map(c=><label key={c.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",border:`2px solid ${joinCoId===c.id?"var(--a-500)":"var(--border)"}`,borderRadius:12,cursor:"pointer",marginBottom:8,background:joinCoId===c.id?"var(--a-50)":"var(--surface-2)",transition:"all .15s"}} onClick={()=>setJoinCoId(c.id)}>
            <div style={{width:40,height:40,borderRadius:10,background:"var(--a-500)",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:16,flexShrink:0}}>{c.name.charAt(0)}</div>
            <div><div style={{fontWeight:600,fontSize:14,color:"var(--text)"}}>{c.name}</div><div style={{fontSize:11,color:"var(--text-3)"}}>Created {c.createdAt}</div></div>
          </label>)}
        </div>}
        {joinCoId&&<div style={S.inputGroup}>
          <label style={S.glassLabel}>🔑 Passcode (optional)</label>
          <input style={{...S.glassInput,textTransform:"uppercase",fontFamily:"monospace",letterSpacing:2}} value={joinPasscode} onChange={e=>setJoinPasscode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,8))} placeholder="e.g. TEAM42"/>
          <div style={{fontSize:11,color:"var(--text-3)",marginTop:6,lineHeight:1.5}}>If your admin gave you a passcode, enter it to join instantly. Otherwise leave blank — an admin will approve you.</div>
        </div>}
        {err&&<div style={{color:"var(--red-600)",fontSize:12,marginBottom:10,padding:"8px 12px",background:"color-mix(in srgb,var(--red-500) 10%,transparent)",borderRadius:6}}>{err}</div>}
        <button style={{...S.glassBtn,width:"100%",opacity:joinCoId?1:.4}} onClick={handleJoinCompany}>{joinPasscode.trim()?"Join Workspace":"Request to Join"}</button>
      </div>}

      {wsType==="personal"&&<div>
        <div style={{...S.glassCard,padding:16,marginBottom:16,fontSize:13,color:"var(--text-2)",lineHeight:1.6}}>Your personal workspace will be created with full admin access to manage your own projects.</div>
        {err&&<div style={{color:"var(--red-600)",fontSize:12,marginBottom:10,padding:"8px 12px",background:"color-mix(in srgb,var(--red-500) 10%,transparent)",borderRadius:6}}>{err}</div>}
        <button style={{...S.glassBtn,width:"100%"}} onClick={handlePersonal}>Create Personal Workspace</button>
      </div>}

      <div style={{marginTop:16,textAlign:"center"}}>
        <button onClick={()=>{if(wsType)setWsType(null);else{setMode("login");setErr("")}}} style={lnk}>← {wsType?"Back to options":"Back to Login"}</button>
      </div>
    </div><LoginPromoPanel/></div>;
  }

  // ── Signup Step 1 ──
  if(mode==="signup"){
    return <div className="wb-auth" style={S.loginWrap}><div style={{...S.loginCard,width:"min(500px,100%)"}}>
      <div style={{textAlign:"center",marginBottom:16}}><div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",background:"#FFFFFF",padding:"8px 16px",borderRadius:10}}><LogoImg h={32}/></div></div>
      <div style={S.loginTitle}>Sign Up</div>
      <div style={S.loginSub}>Create your WBRO account</div>
      <div style={S.inputGroup}><label style={S.glassLabel}>Full Name *</label><input style={S.glassInput} value={sName} onChange={e=>setSName(e.target.value)} placeholder="Jane Doe"/></div>
      <div style={S.inputGroup}><label style={S.glassLabel}>Email *</label><input style={S.glassInput} value={sEmail} onChange={e=>setSEmail(e.target.value)} placeholder="jane@company.com"/></div>
      <div style={S.row}>
        <div style={{...S.inputGroup,...S.half}}><label style={S.glassLabel}>Role</label><select style={S.glassSelect} value={sRole} onChange={e=>setSRole(e.target.value)}>{STAFF_ROLES.map(r=><option key={r} style={{color:"#000"}}>{r}</option>)}</select></div>
        <div style={{...S.inputGroup,...S.half}}><label style={S.glassLabel}>Billable Role</label><select style={S.glassSelect} value={sBillable} onChange={e=>setSBillable(e.target.value)}>{BILLABLE_ROLES.map(r=><option key={r} style={{color:"#000"}}>{r}</option>)}</select></div>
      </div>
      <div style={S.row}>
        <div style={{...S.inputGroup,...S.half}}><label style={S.glassLabel}>PIN *</label><input style={S.glassInput} type="password" value={sPin} onChange={e=>setSPin(e.target.value)} placeholder="••••"/></div>
        <div style={{...S.inputGroup,...S.half}}><label style={S.glassLabel}>Confirm PIN *</label><input style={S.glassInput} type="password" value={sPinC} onChange={e=>setSPinC(e.target.value)} placeholder="••••"/></div>
      </div>
      {err&&<div style={{color:"#ff6b6b",fontSize:12,marginBottom:10}}>{err}</div>}
      <button style={{...S.glassBtn,width:"100%"}} onClick={async()=>{
        if(!validateStep1())return;
        setErr("");
        // Check if email already exists in any workspace
        try{
          const allCos=await ld(REGISTRY_KEY,[]);
          for(const co of allCos){
            const sk=getSK(co.id);
            const wsUsers=await ld(sk.u,[]);
            if(wsUsers.find(u=>u.email.toLowerCase()===sEmail.trim().toLowerCase())){
              setErr(`An account with this email already exists. Please sign in instead, or use "Forgot PIN?" to reset your PIN.`);
              return;
            }
          }
        }catch(e){/* network hiccup — proceed anyway */}
        // Send verification code BEFORE letting them pick a workspace
        try{
          const result=await sendVerificationCode(sEmail.trim(),sName.trim());
          setVerifyData({
            code:result.code,
            expiresAt:result.expiresAt,
            email:sEmail.trim(),
            name:sName.trim(),
            pendingAction:async()=>{
              // After email verified — go to workspace selection
              setMode("signupWorkspace");
            }
          });
          startResendCooldown();
          setVerifyInput("");
          setMode("verifyEmail");
        }catch(e){setErr(e.message);}
      }}>Continue → Verify Email</button>
      <div style={{marginTop:16,textAlign:"center"}}><button onClick={()=>{setMode("login");setErr("")}} style={lnk}>← Back to Login</button></div>
    </div><LoginPromoPanel/></div>;
  }

  // ── External Access ──
  if(mode==="external"){
    return <div className="wb-auth" style={S.loginWrap}><div style={{...S.loginCard,width:440}}>
      <div style={S.loginTitle}>Project Access</div>
      <div style={S.loginSub}>For clients and contractors</div>
      <div style={S.inputGroup}><label style={S.glassLabel}>I am a</label><select style={S.glassSelect} value={extRole} onChange={e=>setExtRole(e.target.value)}><option style={{color:"#000"}}>Client</option><option style={{color:"#000"}}>Contractor</option></select></div>
      <div style={{padding:"10px 14px",borderRadius:12,marginBottom:14,fontSize:12,lineHeight:1.5,background:extRole==="Client"?"rgba(12,166,120,.15)":"rgba(245,159,0,.15)",color:extRole==="Client"?C.green:C.amber}}>
        {extRole==="Client"?"👁 View project status, timeline, RFIs, and updates.":"🔧 View projects, raise RFIs, and respond to existing ones."}
      </div>
      <div style={S.inputGroup}><label style={S.glassLabel}>Your Name *</label><input style={S.glassInput} value={extName} onChange={e=>setExtName(e.target.value)} placeholder="John Smith"/></div>
      <div style={S.inputGroup}><label style={S.glassLabel}>Project Number *</label><input style={S.glassInput} value={projNum} onChange={e=>setProjNum(e.target.value)} placeholder="PRJ-2024-041"/></div>
      <div style={S.inputGroup}><label style={S.glassLabel}>Access PIN *</label><input style={S.glassInput} type="password" value={accessPin} onChange={e=>setAccessPin(e.target.value)} placeholder="••••" onKeyDown={e=>e.key==="Enter"&&handleExtLogin()}/></div>
      {err&&<div style={{color:"#ff6b6b",fontSize:12,marginBottom:10}}>{err}</div>}
      <button style={{...S.glassBtn,width:"100%"}} onClick={handleExtLogin}>Access Project</button>
      <div style={{marginTop:16,textAlign:"center"}}><button onClick={()=>{setMode("login");setErr("")}} style={lnk}>← Staff Sign In</button></div>
    </div><LoginPromoPanel/></div>;
  }

  // ── Login Screen ──
  return <div className="wb-auth" style={S.loginWrap}><div style={S.loginCard}>
    <div style={{textAlign:"center",marginBottom:28}}>
      <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",background:"#FFFFFF",padding:"10px 20px",borderRadius:12,marginBottom:16}}><LogoImg h={44}/></div>
      <div style={{fontSize:11,fontWeight:600,color:"#7EC800",letterSpacing:".18em",textTransform:"uppercase"}}>Project Management · Built for Builders</div>
    </div>
    <div style={S.inputGroup}><label style={S.glassLabel}>Email</label><input style={S.glassInput} value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@company.com"/></div>
    <div style={S.inputGroup}><label style={S.glassLabel}>PIN</label><input style={S.glassInput} type="password" value={pin} onChange={e=>setPin(e.target.value)} placeholder="••••" onKeyDown={e=>e.key==="Enter"&&handleLogin()}/></div>
    {err&&<div style={{color:"#ff6b6b",fontSize:12,marginBottom:10}}>{err}</div>}
    <button style={{...S.glassBtn,width:"100%"}} onClick={handleLogin}>Sign In</button>
    <div style={{marginTop:10,textAlign:"right"}}><button onClick={()=>{setMode("forgotPin");setErr("");setFpFound(null);setFpEmail(email)}} style={{background:"none",border:"none",color:"#9fe870",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:12,padding:0,textDecoration:"underline",textUnderlineOffset:2}}>Forgot PIN?</button></div>
    <div style={{marginTop:12,...S.glassCard,textAlign:"center"}}>
      <div style={{fontSize:13,color:"#c3cec7",marginBottom:8}}>First time here?</div>
      <button onClick={()=>{setMode("signup");setErr("")}} style={{...S.glassBtn,padding:"10px 28px",fontSize:13,width:"100%"}}>Create Account</button>
    </div>
    <div style={{marginTop:14,display:"flex",justifyContent:"center",gap:20,fontSize:13}}>
      <button onClick={()=>{setMode("external");setErr("")}} style={{...lnk,color:"#7EC800"}}>Client / Contractor Access</button>
    </div>
    <div style={{fontSize:11,color:"#7c8b83",marginTop:20,textAlign:"center",borderTop:"1px solid rgba(255,255,255,.1)",paddingTop:14}}>
      <div style={{marginBottom:6,color:dbOk===true?"#34d399":dbOk===null?"var(--text-3)":"#ff6b6b",fontSize:10}}>
        {dbOk===true?"● Cloud database connected":dbOk===null?"● Checking database...":typeof dbOk==="string"?`● ${dbOk}`:"● Database error"}
      </div>
      {onBackToLanding&&<button onClick={onBackToLanding} style={{background:"none",border:"none",color:"#7c8b83",cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:11,padding:0,marginBottom:8,display:"block",margin:"0 auto 8px"}}>← Back to Home</button>}
      Beta Version by Batu Ozer © 2026 · v2.0 (Apr 21)
    </div>
  </div><LoginPromoPanel/></div>;
}

function TimesheetView({user,projects,timesheets,setTimesheets,users,allView}){
  const [weekOffset,setWeekOffset]=useState(0);
  const [tsTab,setTsTab]=useState("time");
  const [viewUserId,setViewUserId]=useState(user.id);
  const [billingTeamFilter,setBillingTeamFilter]=useState("All Teams");

  const viewUser = allView ? (users.find(u=>u.id===viewUserId)||user) : user;
  const weekStart=getWeekStart(new Date(Date.now()+weekOffset*7*864e5));
  const weekKey=weekStart.toISOString().split("T")[0];
  const dates=getWeekDates(weekStart);
  // Exclude completed projects from timesheet entry
  const myProjects=projects.filter(p=>p.team.includes(viewUser.id)&&p.status!=="Completed");
  const rate=HOURLY_RATES[viewUser.billableRole]||105;

  const getTsData=()=>(timesheets[viewUser.id]?.[weekKey]||{});
  const setTsRow=(rowKey,dayIdx,val)=>{
    const v=parseFloat(val)||0;
    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id])copy[viewUser.id]={};
      if(!copy[viewUser.id][weekKey])copy[viewUser.id][weekKey]={};
      if(!copy[viewUser.id][weekKey][rowKey])copy[viewUser.id][weekKey][rowKey]=[0,0,0,0,0,0,0];
      const row=[...copy[viewUser.id][weekKey][rowKey]];
      row[dayIdx]=v;
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:{...copy[viewUser.id][weekKey],[rowKey]:row}};
      return copy;
    });
  };

  const getExpenses=()=>(timesheets[viewUser.id]?.[weekKey]?.expenses||[]);
  const addExpense=(exp)=>{
    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id])copy[viewUser.id]={};
      if(!copy[viewUser.id][weekKey])copy[viewUser.id][weekKey]={};
      const exps=[...(copy[viewUser.id][weekKey].expenses||[]),exp];
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:{...copy[viewUser.id][weekKey],expenses:exps}};
      return copy;
    });
  };

  const tsData=getTsData();
  const dayTotals=DAYS.map((_,di)=>{
    let t=0;
    Object.entries(tsData).forEach(([k,row])=>{if(k!=="expenses"&&Array.isArray(row))t+=row[di]||0});
    return t;
  });
  const weekTotal=dayTotals.reduce((a,b)=>a+b,0);

  // Detect rows per project — each row is proj:{id}:{phase} OR legacy proj:{id}
  // Returns a map: { projectId: [phase1, phase2, ...] }
  const getProjectRows=()=>{
    const map={};
    myProjects.forEach(p=>{map[p.id]=[]});
    Object.keys(tsData).forEach(k=>{
      if(k==="expenses"||!Array.isArray(tsData[k]))return;
      // New format: proj:{id}:{phase}
      const newMatch=k.match(/^proj:([^:]+):(.+)$/);
      if(newMatch){const[,pid,phase]=newMatch;if(map[pid]!==undefined&&!map[pid].includes(phase))map[pid].push(phase);return}
      // Legacy format: proj:{id}
      const oldMatch=k.match(/^proj:([^:]+)$/);
      if(oldMatch){const[,pid]=oldMatch;const p=myProjects.find(x=>x.id===pid);if(p&&map[pid]!==undefined&&!map[pid].includes(p.phase))map[pid].push(p.phase)}
    });
    // Ensure every project has at least one row entry (its current phase)
    myProjects.forEach(p=>{if(map[p.id].length===0)map[p.id]=[p.phase]});
    return map;
  };
  const projectRows=getProjectRows();

  // Read a row: supports both legacy and new key formats
  const readRow=(pid,phase,currentPhase)=>{
    const newKey=`proj:${pid}:${phase}`;
    if(tsData[newKey])return{key:newKey,row:tsData[newKey]};
    // Legacy fallback: if phase matches the project's current phase, use legacy key
    if(phase===currentPhase&&tsData[`proj:${pid}`])return{key:`proj:${pid}`,row:tsData[`proj:${pid}`]};
    return{key:newKey,row:[0,0,0,0,0,0,0]};
  };

  const changePhase=(pid,oldPhase,newPhase)=>{
    // Move/rename the row from old key to new key (keeping the hours)
    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id])copy[viewUser.id]={};
      if(!copy[viewUser.id][weekKey])copy[viewUser.id][weekKey]={};
      const wk={...copy[viewUser.id][weekKey]};
      const oldKey=`proj:${pid}:${oldPhase}`;
      const legacyKey=`proj:${pid}`;
      const newKey=`proj:${pid}:${newPhase}`;
      // Gather existing data from either legacy or new key
      const existing=wk[oldKey]||wk[legacyKey]||[0,0,0,0,0,0,0];
      // Don't clobber if newKey already has data — merge instead
      const merged=wk[newKey]?existing.map((v,i)=>v+(wk[newKey][i]||0)):existing;
      if(wk[oldKey])delete wk[oldKey];
      // Only remove legacy key if we're renaming away from the project's current phase
      if(legacyKey===`proj:${pid}`&&wk[legacyKey]){
        const currentProj=myProjects.find(p=>p.id===pid);
        if(currentProj&&oldPhase===currentProj.phase)delete wk[legacyKey];
      }
      wk[newKey]=merged;
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:wk};
      return copy;
    });
  };

  const removeRow=(pid,phase)=>{
    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id]?.[weekKey])return prev;
      const wk={...copy[viewUser.id][weekKey]};
      delete wk[`proj:${pid}:${phase}`];
      const currentProj=myProjects.find(p=>p.id===pid);
      if(currentProj&&phase===currentProj.phase)delete wk[`proj:${pid}`];
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:wk};
      return copy;
    });
  };

  const addPhaseRow=(pid)=>{
    const existing=projectRows[pid]||[];
    // Find first phase not already used for this project
    const available=PHASES.filter(ph=>!existing.includes(ph));
    if(available.length===0){alert("All phases are already added for this project.");return}
    const newPhase=available[0];
    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id])copy[viewUser.id]={};
      if(!copy[viewUser.id][weekKey])copy[viewUser.id][weekKey]={};
      const wk={...copy[viewUser.id][weekKey]};
      wk[`proj:${pid}:${newPhase}`]=[0,0,0,0,0,0,0];
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:wk};
      return copy;
    });
  };

  // Auto-fill from focus %: sum user's focus across projects, treat 100% = 30h/week (10h buffer for meetings/admin)
  // Each project's hours = 40 * focus%/100, distributed Mon-Fri (2 hours per 10%)
  const autoFillFromFocus=()=>{
    // Collect {projectId, phase, focusPercent}
    const plan=myProjects.map(p=>({pid:p.id,phase:p.phase,focus:getUserFocus(p,viewUser.id)})).filter(x=>x.focus>0);
    if(plan.length===0){alert("No focus allocation set. Go to My Team → Projects and set your focus % on each project first.");return}
    const totalFocus=plan.reduce((s,x)=>s+x.focus,0);
    let confirmMsg=`Auto-fill timesheet based on your focus allocation?\n\n100% focus = 30h/week (10h buffer for meetings/admin/general time).\nThis will OVERWRITE current hours for these projects:\n\n`;
    plan.forEach(x=>{
      const p=myProjects.find(q=>q.id===x.pid);
      const weeklyHours=30*x.focus/100;
      const dailyHours=weeklyHours/5;
      confirmMsg+=`• ${p?.name||x.pid}: ${x.focus}% → ${weeklyHours.toFixed(1)}h/week (${dailyHours.toFixed(1)}h × 5 days)\n`;
    });
    confirmMsg+=`\nTotal focus: ${totalFocus}%${totalFocus>100?" ⚠ OVER 100%":""}\nTotal project work: ${(30*totalFocus/100).toFixed(1)}h/week\nBuffer for meetings/admin: ${Math.max(0,40-(30*totalFocus/100)).toFixed(1)}h`;
    if(!confirm(confirmMsg))return;

    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id])copy[viewUser.id]={};
      if(!copy[viewUser.id][weekKey])copy[viewUser.id][weekKey]={};
      const wk={...copy[viewUser.id][weekKey]};
      plan.forEach(x=>{
        const weeklyHours=30*x.focus/100;
        const dailyHours=Math.round((weeklyHours/5)*2)/2; // round to nearest 0.5
        // DAYS = [Mon,Tue,Wed,Thu,Fri,Sat,Sun] → fill Mon-Fri (indices 0-4)
        const row=[dailyHours,dailyHours,dailyHours,dailyHours,dailyHours,0,0];
        wk[`proj:${x.pid}:${x.phase}`]=row;
        // Clean up legacy key if it exists for this project
        if(wk[`proj:${x.pid}`])delete wk[`proj:${x.pid}`];
      });
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:wk};
      return copy;
    });
  };

  const clearWeek=()=>{
    if(!confirm("Clear all hours for this week? This cannot be undone."))return;
    setTimesheets(prev=>{
      const copy={...prev};
      if(!copy[viewUser.id]?.[weekKey])return prev;
      const expenses=copy[viewUser.id][weekKey].expenses;
      copy[viewUser.id]={...copy[viewUser.id],[weekKey]:expenses?{expenses}:{}};
      return copy;
    });
  };

  const expenses=getExpenses();
  const expTotal=expenses.reduce((s,e)=>s+(e.amount||0),0);

  const [showExpForm,setShowExpForm]=useState(false);
  const [expForm,setExpForm]=useState({project:"",category:"Travel",description:"",amount:"",date:dates[0]});

  // ── Billing data (admin only) — all-time per project ──
  const billingData=useMemo(()=>{
    if(!allView) return [];
    return projects.map(p=>{
      let totalHours=0; let totalLabor=0; let totalExpenses=0;
      const byPerson=[];
      users.filter(u=>isStaff(u)&&p.team.includes(u.id)&&(billingTeamFilter==="All Teams"||u.teamName===billingTeamFilter)).forEach(u=>{
        const uRate=HOURLY_RATES[u.billableRole]||0;
        let personHours=0; let personExpenses=0;
        Object.values(timesheets[u.id]||{}).forEach(weekData=>{
          // Sum hours from both legacy key and all phase-specific keys for this project
          Object.entries(weekData).forEach(([k,row])=>{
            if(k==="expenses"||!Array.isArray(row))return;
            // Match proj:{id} OR proj:{id}:{anything}
            if(k===`proj:${p.id}`||k.startsWith(`proj:${p.id}:`)){
              personHours+=row.reduce((a,b)=>a+b,0);
            }
          });
          if(weekData.expenses){weekData.expenses.filter(e=>e.projectId===p.id).forEach(e=>{personExpenses+=e.amount||0})}
        });
        if(personHours>0||personExpenses>0){
          byPerson.push({name:u.name,role:u.billableRole,hours:personHours,rate:uRate,labor:personHours*uRate,expenses:personExpenses,teamName:u.teamName});
          totalHours+=personHours; totalLabor+=personHours*uRate; totalExpenses+=personExpenses;
        }
      });
      return {id:p.id,name:p.name,number:p.number,client:p.client,status:p.status,budget:p.budget.total,totalHours,totalLabor,totalExpenses,totalCost:totalLabor+totalExpenses,byPerson};
    }).filter(p=>p.totalCost>0||p.budget>0).sort((a,b)=>b.totalCost-a.totalCost);
  },[allView,projects,timesheets,users,billingTeamFilter]);

  const grandTotalLabor=billingData.reduce((s,p)=>s+p.totalLabor,0);
  const grandTotalExp=billingData.reduce((s,p)=>s+p.totalExpenses,0);
  const grandTotal=grandTotalLabor+grandTotalExp;
  const teamNamesArr=["All Teams",...new Set(users.filter(u=>isStaff(u)&&u.teamName).map(u=>u.teamName))];
  const generateBillingPDF=()=>{
    const rows=billingData.flatMap(p=>{
      const lines=p.byPerson.map(pe=>`<tr><td>${p.number}</td><td>${p.name}</td><td>${pe.name}</td><td>${pe.role}</td><td style="text-align:right">${pe.hours.toFixed(1)}</td><td style="text-align:right">$${pe.rate}</td><td style="text-align:right">$${pe.labor.toLocaleString(undefined,{minimumFractionDigits:2})}</td><td style="text-align:right">$${pe.expenses.toLocaleString(undefined,{minimumFractionDigits:2})}</td><td style="text-align:right;font-weight:bold">$${(pe.labor+pe.expenses).toLocaleString(undefined,{minimumFractionDigits:2})}</td></tr>`);
      lines.push(`<tr style="background:#f5f0eb;font-weight:bold"><td></td><td colspan="3">Project Subtotal — ${p.name}</td><td style="text-align:right">${p.totalHours.toFixed(1)}</td><td></td><td style="text-align:right">$${p.totalLabor.toLocaleString(undefined,{minimumFractionDigits:2})}</td><td style="text-align:right">$${p.totalExpenses.toLocaleString(undefined,{minimumFractionDigits:2})}</td><td style="text-align:right">$${p.totalCost.toLocaleString(undefined,{minimumFractionDigits:2})}</td></tr><tr><td colspan="9" style="padding:4px"></td></tr>`);
      return lines;
    });
    const html=`<!DOCTYPE html><html><head><title>Billing Report — WorkBro</title><style>body{font-family:'Segoe UI',sans-serif;padding:40px;color:#1a1a1a}h1{font-size:22px;margin-bottom:4px}h2{font-size:14px;color:#475569;font-weight:400;margin-bottom:24px}table{width:100%;border-collapse:collapse;font-size:12px}th{text-align:left;padding:8px 10px;border-bottom:2px solid #0D6EFD;font-size:11px;text-transform:uppercase;color:#475569}td{padding:7px 10px;border-bottom:1px solid #E3E8EF}.summary{display:flex;gap:30px;margin-bottom:24px}.summary div{}.summary .label{font-size:11px;color:#475569;text-transform:uppercase}.summary .val{font-size:22px;font-weight:700;color:#0D6EFD}.footer{margin-top:30px;font-size:11px;color:#94A3B8;border-top:1px solid #E3E8EF;padding-top:12px}@media print{body{padding:20px}}</style></head><body><h1>WorkBro — Billing Report</h1><h2>Generated ${new Date().toLocaleDateString("en-US",{weekday:"long",year:"numeric",month:"long",day:"numeric"})}</h2><div class="summary"><div><div class="label">Total Labor</div><div class="val">$${grandTotalLabor.toLocaleString(undefined,{minimumFractionDigits:2})}</div></div><div><div class="label">Total Expenses</div><div class="val" style="color:#F59F00">$${grandTotalExp.toLocaleString(undefined,{minimumFractionDigits:2})}</div></div><div><div class="label">Grand Total</div><div class="val" style="color:#0CA678">$${grandTotal.toLocaleString(undefined,{minimumFractionDigits:2})}</div></div></div><table><thead><tr><th>Project #</th><th>Project Name</th><th>Team Member</th><th>Role</th><th style="text-align:right">Hours</th><th style="text-align:right">Rate</th><th style="text-align:right">Labor</th><th style="text-align:right">Expenses</th><th style="text-align:right">Total</th></tr></thead><tbody>${rows.join("")}<tr style="background:#0D6EFD;color:white;font-weight:bold"><td colspan="4">GRAND TOTAL</td><td style="text-align:right">${billingData.reduce((s,p)=>s+p.totalHours,0).toFixed(1)}</td><td></td><td style="text-align:right">$${grandTotalLabor.toLocaleString(undefined,{minimumFractionDigits:2})}</td><td style="text-align:right">$${grandTotalExp.toLocaleString(undefined,{minimumFractionDigits:2})}</td><td style="text-align:right">$${grandTotal.toLocaleString(undefined,{minimumFractionDigits:2})}</td></tr></tbody></table><div class="footer">Beta Version by Batu Ozer © 2026 · WorkBro Project Management</div></body></html>`;
    const w=window.open("","_blank");
    if(w){w.document.write(html);w.document.close();setTimeout(()=>w.print(),500);}
  };

  // Stat eyebrow
  const expectedHrs=40;
  const remainingHrs=Math.max(0,expectedHrs-weekTotal);

  return <div>
    {/* ── PAGE HEAD ───────────────────────────────────────────── */}
    <div style={{padding:"24px 32px 0"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:16,marginBottom:18,paddingBottom:18,borderBottom:"1px solid var(--border)",flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6}}>{formatWeekLabel(weekStart)} · Week total: {weekTotal.toFixed(1)}h{weekTotal>=expectedHrs?" ✓":` · ${remainingHrs.toFixed(1)}h to go`}</div>
          <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>Timesheet{allView&&viewUser.id!==user.id?` — ${viewUser.name}`:""}</h1>
          <p style={{color:"var(--text-2)",fontSize:13,margin:0}}>Track your time, expenses, and overhead. Auto-fills from your focus allocation.</p>
        </div>
        {tsTab!=="billing"&&<div style={{display:"flex",gap:6,alignItems:"center"}}>
          <button style={{...S.btnO,padding:"0 12px",height:32,fontSize:12}} onClick={()=>setWeekOffset(w=>w-1)}>← Prev</button>
          <button style={{...S.btnO,padding:"0 12px",height:32,fontSize:12,color:weekOffset===0?"var(--a-600)":"var(--text-2)",borderColor:weekOffset===0?"var(--a-300)":"var(--border-strong)"}} onClick={()=>setWeekOffset(0)}>Today</button>
          <button style={{...S.btnO,padding:"0 12px",height:32,fontSize:12}} onClick={()=>setWeekOffset(w=>w+1)}>Next →</button>
        </div>}
      </div>

      {allView&&<div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
        <span style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)"}}>Viewing</span>
        <select style={{...S.select,height:32,padding:"0 12px",fontSize:13,maxWidth:280}} value={viewUserId} onChange={e=>setViewUserId(e.target.value)}>
          {users.filter(u=>isStaff(u)).map(u=><option key={u.id} value={u.id}>{u.name} ({u.billableRole})</option>)}
        </select>
      </div>}

      {/* ── TABS ─────────────────────────────────────────────── */}
      <div style={{display:"flex",gap:0,borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none"}}>
        {[
          ["time","Timesheet",null],
          ["overhead","Overhead",null],
          ["expenses","Expenses",getExpenses().length||null],
          ...(allView?[["import","Ajera Import",null]]:[]),
          ...(allView?[["billing","Billing Report",null]]:[]),
        ].map(([k,l,badge])=>{
          const active=tsTab===k;
          return <button key={k} onClick={()=>setTsTab(k)} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:active?600:500,color:active?"var(--text)":"var(--text-3)",borderBottom:active?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",transition:"color .12s, border-color .12s",whiteSpace:"nowrap",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
            {l}
            {badge&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{badge}</span>}
          </button>;
        })}
      </div>
    </div>

    {/* ── PAGE BODY ───────────────────────────────────────────── */}
    <div style={{padding:"20px 32px 60px"}}>

    {tsTab==="time" && <>
      {/* Auto-fill helper banner */}
      <div style={{...S.card,padding:"12px 16px",marginBottom:12,background:C.accentSoft,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
        <span style={{fontSize:20}}>✨</span>
        <div style={{flex:1,minWidth:180}}>
          <div style={{fontSize:13,fontWeight:700,color:C.accent}}>Auto-fill from your focus allocation</div>
          <div style={{fontSize:11,color:C.textMid,marginTop:2}}>100% focus = 30h/week of project work. Hours split evenly Mon–Fri (6h/day). Remaining ~10h/week is buffer for meetings, admin, and general time.</div>
        </div>
        <button style={S.btn} onClick={autoFillFromFocus}>✨ Auto-fill Week</button>
        <button style={{...S.btnO,color:C.red,borderColor:C.red}} onClick={clearWeek}>Clear All</button>
      </div>

      <div style={{...S.card,overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:820}}>
          <thead><tr>
            <th style={{...S.th,minWidth:200}}>Project</th>
            <th style={{...S.th,minWidth:150}}>Phase</th>
            <th style={{...S.th,minWidth:80}}>Activity</th>
            {DAYS.map((d,i)=><th key={d} style={{...S.th,textAlign:"center",background:i>=5?C.card:"transparent"}}>{d}<br/><span style={{fontSize:9,color:C.textDim}}>{dates[i]?.slice(5)}</span></th>)}
            <th style={{...S.th,textAlign:"center"}}>Total</th>
            <th style={{...S.th,width:30}}></th>
          </tr></thead>
          <tbody>
            <tr style={{background:C.accentSoft}}>
              <td colSpan={3} style={{...S.td,fontWeight:700,fontSize:12,color:C.accent}}>DAILY TOTALS</td>
              {dayTotals.map((t,i)=><td key={i} style={{...S.td,textAlign:"center",fontWeight:700,color:t>0?C.accent:C.textDim,fontSize:13}}>{t>0?t.toFixed(1):"—"}</td>)}
              <td style={{...S.td,...S.tsTotal}}>{weekTotal.toFixed(1)}</td>
              <td style={S.td}></td>
            </tr>
            {myProjects.map(p=>{
              const phases=projectRows[p.id]||[p.phase];
              return phases.map((phase,phaseIdx)=>{
                const {key:rowKey,row}=readRow(p.id,phase,p.phase);
                const rowTotal=row.reduce((a,b)=>a+b,0);
                const isFirstRow=phaseIdx===0;
                const isOnlyRow=phases.length===1;
                const usedPhases=phases;
                const availableToSwitch=PHASES.filter(ph=>ph===phase||!usedPhases.includes(ph));
                const focusHint=isFirstRow?Math.round(30*getUserFocus(p,viewUser.id)/100*10)/10:null;
                return <tr key={rowKey}>
                  <td style={{...S.td,fontSize:12}}>
                    {isFirstRow?<><div style={{fontWeight:600}}>{p.number}</div>
                    <div style={{color:C.textDim,fontSize:11}}>{p.name}</div>
                    {focusHint>0&&<div style={{fontSize:10,color:C.accent,marginTop:2}}>🎯 {getUserFocus(p,viewUser.id)}% focus · target {focusHint}h</div>}
                    <button style={{...S.btnO,padding:"3px 8px",fontSize:10,marginTop:4}} onClick={()=>addPhaseRow(p.id)} title="Add another phase for this project">+ Phase</button></>:<div style={{color:C.textDim,fontSize:11,fontStyle:"italic",paddingLeft:10}}>↳ same project</div>}
                  </td>
                  <td style={{...S.td,fontSize:11}}>
                    <select style={{...S.select,padding:"4px 6px",fontSize:11,width:"100%",fontWeight:600,color:C.accent}} value={phase} onChange={e=>changePhase(p.id,phase,e.target.value)}>
                      {availableToSwitch.map(ph=><option key={ph} value={ph}>{ph}</option>)}
                    </select>
                  </td>
                  <td style={S.td}><select style={{...S.select,padding:"4px 6px",fontSize:11,width:90}} defaultValue="BillableTime">{ACTIVITY_TYPES.map(a=><option key={a}>{a}</option>)}</select></td>
                  {DAYS.map((d,di)=><td key={d} style={{...S.td,textAlign:"center",background:di>=5?"rgba(0,0,0,.02)":"transparent"}}>
                    <input style={S.tsInput} type="number" step="0.5" min="0" max="24" value={row[di]||""} onChange={e=>setTsRow(rowKey,di,e.target.value)} placeholder="—"/>
                  </td>)}
                  <td style={{...S.td,...S.tsTotal}}>{rowTotal>0?rowTotal.toFixed(1):"—"}</td>
                  <td style={S.td}>
                    {!isOnlyRow&&<button onClick={()=>removeRow(p.id,phase)} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:2}} title="Remove this phase row">×</button>}
                  </td>
                </tr>
              });
            })}
            {myProjects.length===0&&<tr><td colSpan={11} style={{...S.td,textAlign:"center",color:C.textDim,padding:30}}>No active projects assigned.</td></tr>}
          </tbody>
        </table>
      </div>
    </>}

    {tsTab==="overhead" && <div style={{...S.card,overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",minWidth:700}}>
        <thead><tr>
          <th style={{...S.th,minWidth:220}}>Overhead Category</th>
          {DAYS.map((d,i)=><th key={d} style={{...S.th,textAlign:"center",background:i>=5?C.card:"transparent"}}>{d}<br/><span style={{fontSize:9,color:C.textDim}}>{dates[i]?.slice(5)}</span></th>)}
          <th style={{...S.th,textAlign:"center"}}>Total</th>
        </tr></thead>
        <tbody>
          {OVERHEAD_CATEGORIES.map(cat=>{
            const rowKey=`oh:${cat}`;
            const row=tsData[rowKey]||[0,0,0,0,0,0,0];
            const rowTotal=row.reduce((a,b)=>a+b,0);
            return <tr key={cat}>
              <td style={{...S.td,fontSize:13}}>{cat}</td>
              {DAYS.map((d,di)=><td key={d} style={{...S.td,textAlign:"center",background:di>=5?"rgba(0,0,0,.02)":"transparent"}}>
                <input style={S.tsInput} type="number" step="0.5" min="0" max="24" value={row[di]||""} onChange={e=>setTsRow(rowKey,di,e.target.value)} placeholder="—"/>
              </td>)}
              <td style={{...S.td,...S.tsTotal}}>{rowTotal>0?rowTotal.toFixed(1):"—"}</td>
            </tr>
          })}
        </tbody>
      </table>
    </div>}

    {tsTab==="expenses" && <div style={S.card}>
      <div style={S.cardH}><span style={S.cardT}>Expenses · {formatWeekLabel(weekStart)}</span><div style={{display:"flex",gap:8,alignItems:"center"}}><span style={{fontSize:13,fontWeight:700,color:C.accent}}>Total: {fmt(expTotal)}</span><button style={S.btnSm} onClick={()=>setShowExpForm(true)}>+ Add Expense</button></div></div>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead><tr><th style={S.th}>Date</th><th style={S.th}>Project</th><th style={S.th}>Category</th><th style={S.th}>Description</th><th style={S.th}>Amount</th></tr></thead>
          <tbody>
            {expenses.length===0&&<tr><td colSpan={5} style={{...S.td,textAlign:"center",color:C.textDim,padding:24}}>No expenses this week.</td></tr>}
            {expenses.map((ex,i)=>{const proj=projects.find(p=>p.id===ex.projectId);return <tr key={i}><td style={S.td}>{ex.date}</td><td style={{...S.td,fontSize:12}}>{proj?.number||"—"}</td><td style={S.td}><Badge bg={C.amberSoft} fg={C.amber}>{ex.category}</Badge></td><td style={S.td}>{ex.description}</td><td style={{...S.td,fontWeight:600}}>{fmt(ex.amount)}</td></tr>})}
          </tbody>
        </table>
      </div>
      {showExpForm&&<Modal title="Add Expense" onClose={()=>setShowExpForm(false)} footer={<><button style={S.btnO} onClick={()=>setShowExpForm(false)}>Cancel</button><button style={{...S.btn,opacity:expForm.amount&&expForm.project?1:.4}} onClick={()=>{if(expForm.amount&&expForm.project){addExpense({...expForm,amount:parseFloat(expForm.amount)});setShowExpForm(false);setExpForm({project:"",category:"Travel",description:"",amount:"",date:dates[0]})}}}>Add</button></>}>
        <div style={S.inputGroup}><label style={S.label}>Project *</label><select style={S.select} value={expForm.project} onChange={e=>setExpForm(p=>({...p,project:e.target.value}))}><option value="">Select project</option>{myProjects.map(p=><option key={p.id} value={p.id}>{p.number} – {p.name}</option>)}</select></div>
        <div style={S.row}>
          <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Category</label><select style={S.select} value={expForm.category} onChange={e=>setExpForm(p=>({...p,category:e.target.value}))}>{EXPENSE_CATEGORIES.map(c=><option key={c}>{c}</option>)}</select></div>
          <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Amount ($) *</label><input style={S.input} type="number" value={expForm.amount} onChange={e=>setExpForm(p=>({...p,amount:e.target.value}))} placeholder="0.00"/></div>
        </div>
        <div style={S.inputGroup}><label style={S.label}>Date</label><input style={S.input} type="date" value={expForm.date} onChange={e=>setExpForm(p=>({...p,date:e.target.value}))}/></div>
        <div style={S.inputGroup}><label style={S.label}>Description</label><input style={S.input} value={expForm.description} onChange={e=>setExpForm(p=>({...p,description:e.target.value}))} placeholder="Brief description"/></div>
      </Modal>}
    </div>}

    {/* ── Billing Report (Admin only) ── */}
    {tsTab==="import"&&allView&&<div>
      <div style={S.banner(C.accentSoft,C.accent)}>📤 Upload a CSV exported from Ajera to automatically populate timesheets and project spend. Expected columns: <strong>Date, Employee, Project Number, Hours, Notes</strong> (case-insensitive, flexible header names supported).</div>
      <div style={{...S.card,padding:24,marginBottom:16}}>
        <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:700,marginBottom:14}}>Import Ajera CSV</div>
        <input id="csvFileInput" type="file" accept=".csv,text/csv" style={{display:"block",marginBottom:16,padding:10,border:`2px dashed ${C.border}`,borderRadius:10,width:"100%",cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:13}} onChange={(e)=>{
          const file=e.target.files?.[0];if(!file)return;
          const reader=new FileReader();
          reader.onload=(ev)=>{
            try{
              const text=ev.target.result;
              const lines=text.split(/\r?\n/).filter(l=>l.trim());
              if(lines.length<2){alert("CSV must have a header row and at least one data row.");return}
              // Parse header, find columns
              const parseRow=(row)=>{
                const out=[];let cur="";let inQ=false;
                for(let i=0;i<row.length;i++){const c=row[i];
                  if(c==='"'){inQ=!inQ}
                  else if(c===","&&!inQ){out.push(cur);cur=""}
                  else cur+=c;
                }
                out.push(cur);return out.map(s=>s.trim().replace(/^"|"$/g,""));
              };
              const header=parseRow(lines[0]).map(h=>h.toLowerCase());
              const findCol=(names)=>{for(const n of names){const idx=header.findIndex(h=>h.includes(n));if(idx>=0)return idx}return -1};
              const colDate=findCol(["date","day","work date"]);
              const colEmp=findCol(["employee","name","user","staff"]);
              const colProj=findCol(["project","proj #","prj","project number","job"]);
              const colHours=findCol(["hours","hrs","time"]);
              const colNotes=findCol(["note","description","memo","comment"]);
              if(colDate<0||colEmp<0||colProj<0||colHours<0){alert(`CSV missing required columns. Found headers: ${header.join(", ")}\nNeed: Date, Employee, Project Number, Hours`);return}
              const rows=lines.slice(1).map(parseRow);
              let imported=0,skipped=0;
              const newTS=JSON.parse(JSON.stringify(timesheets));
              const skippedReasons={};
              rows.forEach(r=>{
                const dateStr=r[colDate];
                const empName=r[colEmp];
                const projNum=r[colProj];
                const hours=parseFloat(r[colHours])||0;
                if(!dateStr||!empName||!projNum||!hours){skipped++;return}
                // Find user by name (case-insensitive, partial match)
                const usr=users.find(u=>u.name.toLowerCase()===empName.toLowerCase())||users.find(u=>u.name.toLowerCase().includes(empName.toLowerCase())||empName.toLowerCase().includes(u.name.toLowerCase()));
                if(!usr){skipped++;skippedReasons["No user: "+empName]=(skippedReasons["No user: "+empName]||0)+1;return}
                // Find project by number
                const proj=projects.find(p=>p.number.toLowerCase()===projNum.toLowerCase())||projects.find(p=>p.number.toLowerCase().includes(projNum.toLowerCase()));
                if(!proj){skipped++;skippedReasons["No project: "+projNum]=(skippedReasons["No project: "+projNum]||0)+1;return}
                // Parse date → week start (Monday)
                const d=new Date(dateStr);
                if(isNaN(d)){skipped++;return}
                const day=d.getDay();
                const diff=day===0?-6:1-day;
                const weekStart=new Date(d);weekStart.setDate(d.getDate()+diff);
                const weekKey=weekStart.toISOString().split("T")[0];
                const dayIndex=day===0?6:day-1;
                // Initialize structure
                if(!newTS[usr.id])newTS[usr.id]={};
                if(!newTS[usr.id][weekKey])newTS[usr.id][weekKey]={};
                const projKey=`proj:${proj.id}`;
                if(!newTS[usr.id][weekKey][projKey])newTS[usr.id][weekKey][projKey]=[0,0,0,0,0,0,0];
                newTS[usr.id][weekKey][projKey][dayIndex]+=hours;
                imported++;
              });
              setTimesheets(newTS);
              const summary=`✅ Import complete!\n\nImported: ${imported} entries\nSkipped: ${skipped} entries${Object.keys(skippedReasons).length>0?"\n\nSkipped reasons:\n"+Object.entries(skippedReasons).slice(0,10).map(([k,v])=>`• ${k} (${v})`).join("\n"):""}\n\nBudget spend is auto-calculated from hours × billable rate.`;
              alert(summary);
              e.target.value="";
            }catch(err){alert("Error parsing CSV: "+err.message)}
          };
          reader.readAsText(file);
        }}/>
        <div style={{padding:16,background:C.card,borderRadius:10,fontSize:12,color:C.textMid,lineHeight:1.6}}>
          <div style={{fontWeight:700,marginBottom:6,color:C.text}}>How it works:</div>
          <div>1. Export a timesheet CSV from Ajera (Reports → Timesheet Detail)</div>
          <div>2. Upload the CSV above</div>
          <div>3. The system matches employees by name and projects by number</div>
          <div>4. Hours are added to the correct week and day in each person's timesheet</div>
          <div>5. Project budget spend updates automatically (hours × billable rate)</div>
        </div>
      </div>
    </div>}
    {tsTab==="billing"&&allView&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <span style={{fontFamily:"'Inter',sans-serif",fontSize:18,fontWeight:700}}>Billing Report</span>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {teamNamesArr.length>2&&<select style={{...S.select,width:"auto",minWidth:150,padding:"6px 12px",fontSize:12}} value={billingTeamFilter||"All Teams"} onChange={e=>setBillingTeamFilter(e.target.value)}>{teamNamesArr.map(t=><option key={t}>{t}</option>)}</select>}
          <button style={S.btnSm} onClick={generateBillingPDF}>📄 Generate PDF</button>
        </div>
      </div>
      <div style={{...S.g3,marginBottom:20}}>
        <StatCard label="Total Labor" value={fmt(grandTotalLabor)} color={C.accent}/>
        <StatCard label="Total Expenses" value={fmt(grandTotalExp)} color={C.amber}/>
        <StatCard label="Grand Total" value={fmt(grandTotal)} color={C.green} sub={`Across ${billingData.length} projects`}/>
      </div>

      {billingData.length===0&&<div style={{...S.card,padding:40,textAlign:"center"}}><div style={{fontSize:24,marginBottom:8}}>📊</div><div style={{color:C.textDim,fontSize:13}}>No billable time recorded yet. Billing data will appear here once timesheets are filled.</div></div>}

      {billingData.map(p=>{
        const budgetPct=p.budget?pct(p.totalCost,p.budget):0;
        return <div key={p.id} style={{...S.card,marginBottom:16}}>
          <div style={{padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12,borderBottom:`1px solid ${C.border}`}}>
            <div>
              <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:600}}>{p.name}</div>
              <div style={{fontSize:12,color:C.textDim}}>{p.number} · {p.client} · <Badge bg={statusColor(p.status)+"20"} fg={statusColor(p.status)}>{p.status}</Badge></div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:20,fontWeight:700,color:C.accent}}>{fmt(p.totalCost)}</div>
              {p.budget>0&&<div style={{fontSize:12,color:budgetPct>90?C.red:budgetPct>70?C.amber:C.textMid}}>{budgetPct}% of {fmtShort(p.budget)} budget</div>}
            </div>
          </div>
          {/* Summary row */}
          <div style={{padding:"12px 20px",display:"flex",gap:24,borderBottom:`1px solid ${C.border}`,background:C.card}}>
            <div><span style={{fontSize:11,color:C.textDim}}>Total Hours</span><div style={{fontSize:14,fontWeight:700}}>{p.totalHours.toFixed(1)}h</div></div>
            <div><span style={{fontSize:11,color:C.textDim}}>Labor Cost</span><div style={{fontSize:14,fontWeight:700,color:C.accent}}>{fmt(p.totalLabor)}</div></div>
            <div><span style={{fontSize:11,color:C.textDim}}>Expenses</span><div style={{fontSize:14,fontWeight:700,color:C.amber}}>{fmt(p.totalExpenses)}</div></div>
            {p.budget>0&&<div style={{flex:1}}><span style={{fontSize:11,color:C.textDim}}>Budget Used</span><div style={{marginTop:4}}><PBar value={budgetPct} color={budgetPct>90?C.red:budgetPct>70?C.amber:C.accent} height={5} showLabel/></div></div>}
          </div>
          {/* Per-person breakdown */}
          {p.byPerson.length>0&&<div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead><tr><th style={S.th}>Team Member</th><th style={S.th}>Role</th><th style={S.th}>Hours</th><th style={S.th}>Rate</th><th style={S.th}>Labor</th><th style={S.th}>Expenses</th><th style={S.th}>Total</th></tr></thead>
              <tbody>
                {p.byPerson.map((person,pi)=><tr key={pi}>
                  <td style={{...S.td,fontWeight:600}}>{person.name}</td>
                  <td style={{...S.td,fontSize:12,color:C.textMid}}>{person.role}</td>
                  <td style={S.td}>{person.hours.toFixed(1)}h</td>
                  <td style={S.td}>${person.rate}/hr</td>
                  <td style={{...S.td,fontWeight:600}}>{fmt(person.labor)}</td>
                  <td style={S.td}>{person.expenses>0?fmt(person.expenses):"—"}</td>
                  <td style={{...S.td,fontWeight:700,color:C.accent}}>{fmt(person.labor+person.expenses)}</td>
                </tr>)}
              </tbody>
            </table>
          </div>}
        </div>
      })}
    </div>}
    </div>
  </div>;
}

function AssignWorkForm({users,projects,currentUser,onAssign}){
  const [title,setTitle]=useState("");
  const [desc,setDesc]=useState("");
  const [assignee,setAssignee]=useState("");
  const [projectId,setProjectId]=useState("");
  const [priority,setPriority]=useState("Medium");
  const [dueDate,setDueDate]=useState("");
  const staff=users.filter(u=>isStaff(u)&&u.status!=="pending"&&u.id!==currentUser.id);
  const myProjects=projects.filter(p=>p.status!=="Completed"&&(p.team||[]).includes(currentUser.id));
  const submit=()=>{
    if(!title.trim()||!assignee){alert("Please enter a title and select an assignee.");return}
    onAssign({id:"asg_"+Date.now(),title:title.trim(),description:desc.trim(),assignedTo:assignee,assignedBy:currentUser.id,projectId:projectId||null,priority,dueDate:dueDate||null,done:false,createdAt:new Date().toISOString()});
    setTitle("");setDesc("");setAssignee("");setProjectId("");setPriority("Medium");setDueDate("");
  };
  return <div>
    <div style={S.inputGroup}><label style={S.label}>Task Title *</label><input style={S.input} value={title} onChange={e=>setTitle(e.target.value)} placeholder="e.g. Review civil drawings for Block B"/></div>
    <div style={S.inputGroup}><label style={S.label}>Description</label><textarea style={{...S.textarea,minHeight:60}} value={desc} onChange={e=>setDesc(e.target.value)} placeholder="Additional details, context, or instructions..."/></div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Assign To *</label><select style={S.select} value={assignee} onChange={e=>setAssignee(e.target.value)}>
        <option value="">-- Select person --</option>
        {staff.map(u=><option key={u.id} value={u.id}>{u.name} ({u.role})</option>)}
      </select></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Project (optional)</label><select style={S.select} value={projectId} onChange={e=>setProjectId(e.target.value)}>
        <option value="">-- No project --</option>
        {myProjects.map(p=><option key={p.id} value={p.id}>{p.name} ({p.number})</option>)}
      </select></div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Priority</label><select style={S.select} value={priority} onChange={e=>setPriority(e.target.value)}><option>High</option><option>Medium</option><option>Low</option></select></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Due Date (optional)</label><input style={S.input} type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)}/></div>
    </div>
    <button style={{...S.btn,width:"100%",opacity:title.trim()&&assignee?1:.5}} onClick={submit}>📨 Assign Work</button>
  </div>;
}


function SlidePanel({slideProj,user,users,meetingNotes,setMeetingNotes,showNotes,setShowNotes,showCalendar,setShowCalendar,showActions,setShowActions,calViewOffset,setCalViewOffset,noteWeekOffset,setNoteWeekOffset,setDayEditor,setSlideProject,actionItems,toggleAction}){
      const noteWeekStart=getWeekStart(new Date(Date.now()+noteWeekOffset*7*864e5));
      const noteWeekKey=noteWeekStart.toISOString().split("T")[0];
      const noteKey=`${slideProj.id}::${noteWeekKey}`;
      const currentNote=meetingNotes[noteKey]||"";
      const allWeeks=Object.keys(meetingNotes).filter(k=>k.startsWith(slideProj.id+"::")).map(k=>k.split("::")[1]).sort((a,b)=>new Date(b)-new Date(a));
      const savedNotes=allWeeks.map(wk=>({week:wk,text:meetingNotes[`${slideProj.id}::${wk}`]})).filter(n=>n.text?.trim());

      // Pre-compute calendar JSX (avoids nested IIFE that confuses esbuild)
      let calendarJSX=null;
      if(showCalendar){
        const today=new Date();today.setHours(0,0,0,0);
        const monthStart=new Date(today.getFullYear(),today.getMonth()+calViewOffset,1);
        const monthEnd=new Date(today.getFullYear(),today.getMonth()+calViewOffset+1,0);
        const events={};
        const addEv=(dateStr,ev)=>{if(!events[dateStr])events[dateStr]=[];events[dateStr].push(ev)};
        (slideProj.deadlines||[]).forEach(dl=>{
          const deadlineDate=new Date(dl.date);if(isNaN(deadlineDate))return;
          addEv(dl.date,{color:C.red,type:"deadline",title:dl.title||"Deadline",deadlineRef:dl});
          const internal=new Date(deadlineDate);internal.setDate(deadlineDate.getDate()-7);
          addEv(internal.toISOString().split("T")[0],{color:C.amber,type:"internal",title:"Internal deadline",deadlineRef:dl});
          const designStart=new Date(deadlineDate);designStart.setDate(deadlineDate.getDate()-14);
          for(let d=new Date(designStart);d<internal;d.setDate(d.getDate()+1)){
            const ds=d.toISOString().split("T")[0];addEv(ds,{color:"#10B981",type:"design",title:"Design",deadlineRef:dl});
          }
          const reviewStart=new Date(deadlineDate);reviewStart.setDate(deadlineDate.getDate()-6);
          for(let d=new Date(reviewStart);d<deadlineDate;d.setDate(d.getDate()+1)){
            const ds=d.toISOString().split("T")[0];addEv(ds,{color:"#A78BFA",type:"review",title:"Review",deadlineRef:dl});
          }
        });
        (slideProj.customEvents||[]).forEach(ev=>{
          addEv(ev.date,{color:ev.color||C.accent,type:"custom",title:ev.title,customRef:ev});
        });
        const firstDay=monthStart.getDay();
        const daysInMonth=monthEnd.getDate();
        const cells=[];
        for(let i=0;i<firstDay;i++)cells.push(null);
        for(let d=1;d<=daysInMonth;d++)cells.push(d);
        calendarJSX=<div style={{padding:"8px 20px 14px"}}>
          <div style={{fontSize:11,fontWeight:600,color:C.textMid,textTransform:"uppercase",marginBottom:8,textAlign:"center"}}>{monthStart.toLocaleDateString("en-US",{month:"long",year:"numeric"})}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:2}}>
            {["S","M","T","W","T","F","S"].map((d,i)=><div key={i} style={{textAlign:"center",fontSize:9,color:C.textDim,fontWeight:600,padding:2}}>{d}</div>)}
            {cells.map((day,i)=>{
              if(day===null)return <div key={i}/>;
              const ds=`${monthStart.getFullYear()}-${String(monthStart.getMonth()+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
              const dayEvents=events[ds]||[];
              const primary=dayEvents.sort((a,b)=>{const o={deadline:0,internal:1,custom:2,review:3,design:4};return o[a.type]-o[b.type]})[0];
              const isToday=new Date(ds).toDateString()===today.toDateString();
              return <div key={i} onClick={()=>setDayEditor({date:ds,events:dayEvents})} title={dayEvents.length>0?dayEvents.map(e=>e.title).join(", "):"Click to add event"} style={{aspectRatio:"1",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,borderRadius:4,background:primary?primary.color:(isToday?C.accentSoft:"transparent"),color:primary?"#fff":(isToday?C.accent:C.text),fontWeight:primary||isToday?700:400,border:isToday&&!primary?`1px solid ${C.accent}`:"none",cursor:"pointer"}}>{day}</div>;
            })}
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8,fontSize:9,color:C.textMid}}>
            <span style={{display:"flex",alignItems:"center",gap:3}}><span style={{width:8,height:8,background:"#10B981",borderRadius:2}}/>Design</span>
            <span style={{display:"flex",alignItems:"center",gap:3}}><span style={{width:8,height:8,background:C.amber,borderRadius:2}}/>Internal</span>
            <span style={{display:"flex",alignItems:"center",gap:3}}><span style={{width:8,height:8,background:"#A78BFA",borderRadius:2}}/>Review</span>
            <span style={{display:"flex",alignItems:"center",gap:3}}><span style={{width:8,height:8,background:C.red,borderRadius:2}}/>Deadline</span>
          </div>
          <div style={{fontSize:10,color:C.textDim,marginTop:6,textAlign:"center"}}>💡 Click any date to add events or assign a reviewer</div>
        </div>;
      }

      return <div style={{position:"fixed",top:0,right:0,bottom:0,width:420,maxWidth:"92vw",background:C.surface,borderLeft:`1px solid ${C.border}`,boxShadow:"-8px 0 30px rgba(0,0,0,.1)",zIndex:100,display:"flex",flexDirection:"column",animation:"slideIn .2s ease"}}>
        <style>{`@keyframes slideIn{from{transform:translateX(100%)}to{transform:translateX(0)}}`}</style>
        <div style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <div>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:16,fontWeight:600}}>{slideProj.name}</div>
            <div style={{fontSize:11,color:C.textDim}}>{slideProj.number} · {slideProj.phase}</div>
          </div>
          <button onClick={()=>setSlideProject(null)} style={{background:"none",border:"none",color:C.textMid,fontSize:22,cursor:"pointer",lineHeight:1}}>×</button>
        </div>

        {/* Project quick stats */}
        <div style={{padding:"12px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",gap:16,flexShrink:0}}>
          <div><div style={{fontSize:10,color:C.textDim,textTransform:"uppercase",fontWeight:600}}>Progress</div><div style={{fontSize:16,fontWeight:700,color:C.accent}}>{slideProj.progress}%</div></div>
          <div><div style={{fontSize:10,color:C.textDim,textTransform:"uppercase",fontWeight:600}}>Status</div><div style={{marginTop:2}}><Badge bg={statusColor(slideProj.status)+"20"} fg={statusColor(slideProj.status)}>{slideProj.status}</Badge></div></div>
          <div><div style={{fontSize:10,color:C.textDim,textTransform:"uppercase",fontWeight:600}}>Open RFIs</div><div style={{fontSize:16,fontWeight:700,color:slideProj.issues.filter(i=>i.status!=="Closed").length>0?C.red:C.green}}>{slideProj.issues.filter(i=>i.status!=="Closed").length}</div></div>
        </div>

        {/* Deadlines */}
        {slideProj.deadlines.filter(d=>daysUntil(d.date)>=-7).length>0&&<div style={{padding:"10px 20px",borderBottom:`1px solid ${C.border}`,flexShrink:0}}>
          <div style={{fontSize:10,fontWeight:600,color:C.textMid,textTransform:"uppercase",marginBottom:4}}>Deadlines</div>
          {slideProj.deadlines.filter(d=>daysUntil(d.date)>=-7).sort((a,b)=>new Date(a.date)-new Date(b.date)).slice(0,3).map((d,i)=>{const days=daysUntil(d.date);return <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"3px 0",fontSize:11}}>
            <span>{d.name}</span>
            <Badge bg={days<=7&&days>=0?C.redSoft:C.accentSoft} fg={days<=7&&days>=0?C.red:C.accent}>{days<0?`${Math.abs(days)}d ago`:days===0?"Today":`${days}d`}</Badge>
          </div>})}
        </div>}

        {/* ── Weekly Meeting Notes (collapsible) ── */}
        <div style={{flex:showNotes?1:"0 0 auto",display:"flex",flexDirection:"column",overflow:"hidden"}}>
          <div style={{padding:"10px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0,cursor:"pointer",background:showNotes?"transparent":C.card}} onClick={()=>setShowNotes(!showNotes)}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:13,color:C.textMid,transition:"transform .15s",transform:showNotes?"rotate(90deg)":"none",display:"inline-block"}}>▶</span>
              <span style={{fontSize:13,fontWeight:700}}>📝 Meeting Notes</span>
              <span style={{fontSize:11,color:C.textDim}}>{formatWeekLabel(noteWeekStart)}</span>
            </div>
            {showNotes&&<div style={{display:"flex",gap:4}} onClick={e=>e.stopPropagation()}>
              <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setNoteWeekOffset(w=>w-1)}>← Prev</button>
              <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setNoteWeekOffset(w=>w+1)}>Next →</button>
              {noteWeekOffset!==0&&<button style={{...S.btnO,padding:"4px 8px",fontSize:10}} onClick={()=>setNoteWeekOffset(0)}>Today</button>}
            </div>}
          </div>

          {showNotes&&<>
          {/* Current week notes editor */}
          <div style={{flex:1,padding:"14px 20px",display:"flex",flexDirection:"column",overflow:"hidden",minHeight:180}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
              <div style={{fontSize:11,color:C.textMid,fontWeight:500}}>Week of {noteWeekKey}</div>
              {currentNote.trim()&&<span style={{fontSize:10,color:C.green,fontWeight:500}}>✓ Saved</span>}
            </div>
            <textarea
              style={{...S.textarea,flex:1,minHeight:150,fontSize:13,lineHeight:1.6,background:C.card,border:`1px solid ${C.border}`}}
              value={currentNote}
              onChange={e=>{const val=e.target.value;setMeetingNotes(prev=>({...prev,[noteKey]:val}))}}
              placeholder={"Discussion points:\n• \n\nAction items:\n☐ \n\nDecisions:\n• \n\nFollow-up for next week:\n• "}
            />
          </div>

          {/* Past weeks' saved notes */}
          <div style={{maxHeight:180,overflow:"auto",borderTop:`1px solid ${C.border}`,flexShrink:0}}>
            <div style={{padding:"10px 20px 6px",fontSize:10,fontWeight:600,color:C.textMid,textTransform:"uppercase",position:"sticky",top:0,background:C.surface}}>Previous Notes ({savedNotes.filter(n=>n.week!==noteWeekKey).length})</div>
            {savedNotes.filter(n=>n.week!==noteWeekKey).length===0&&<div style={{padding:"6px 20px 14px",fontSize:12,color:C.textDim}}>No previous notes.</div>}
            {savedNotes.filter(n=>n.week!==noteWeekKey).map((n,i)=>(
              <div key={i} style={{padding:"8px 20px",borderBottom:`1px solid ${C.card}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <span style={{fontSize:11,fontWeight:600,color:C.accent}}>Week of {n.week}</span>
                  <span style={{fontSize:10,color:C.textDim}}>{formatWeekLabel(new Date(n.week))}</span>
                </div>
                <div style={{fontSize:12,color:C.text,lineHeight:1.5,whiteSpace:"pre-wrap",maxHeight:80,overflow:"auto"}}>{n.text}</div>
              </div>
            ))}
          </div>
          </>}
        </div>
        {/* Collapsible Mini Calendar (sibling to notes, always visible header) */}
        <div style={{borderTop:`1px solid ${C.border}`,flexShrink:0}}>
            <div onClick={()=>setShowCalendar(!showCalendar)} style={{padding:"10px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",background:showCalendar?"transparent":C.card}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:13,color:C.textMid,transition:"transform .15s",transform:showCalendar?"rotate(90deg)":"none",display:"inline-block"}}>▶</span>
                <span style={{fontSize:13,fontWeight:700}}>📅 Project Calendar</span>
                <span style={{fontSize:11,color:C.textDim}}>{(slideProj.deadlines||[]).length} deadline{(slideProj.deadlines||[]).length!==1?"s":""}</span>
              </div>
              {showCalendar&&<div style={{display:"flex",gap:4}} onClick={e=>e.stopPropagation()}>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setCalViewOffset(o=>o-1)}>← Prev</button>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setCalViewOffset(o=>o+1)}>Next →</button>
                {calViewOffset!==0&&<button style={{...S.btnO,padding:"4px 8px",fontSize:10}} onClick={()=>setCalViewOffset(0)}>Today</button>}
              </div>}
            </div>
            {calendarJSX}
          </div>
        {/* Collapsible Action Items */}
        {(()=>{
          const thisWeek=getWeekStart(new Date()).toISOString().split("T")[0];
          const projActions=(actionItems&&actionItems[slideProj.id])||[];
          const weekActions=projActions.filter(a=>a.weekKey===thisWeek);
          const openCount=weekActions.filter(a=>!a.done).length;
          const overdueCount=projActions.filter(a=>!a.done&&a.weekKey&&a.weekKey<thisWeek).length;
          const priColor=(p)=>p==="High"?C.red:p==="Low"?C.accent:C.amber;
          return <div style={{borderTop:`1px solid ${C.border}`,flexShrink:0}}>
            <div onClick={()=>setShowActions(!showActions)} style={{padding:"10px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",background:showActions?"transparent":C.card}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:13,color:C.textMid,transition:"transform .15s",transform:showActions?"rotate(90deg)":"none",display:"inline-block"}}>▶</span>
                <span style={{fontSize:13,fontWeight:700}}>✅ Weekly Action Items</span>
                {openCount>0&&<Badge bg={C.amberSoft} fg={C.amber}>{openCount} open</Badge>}
                {overdueCount>0&&<Badge bg={C.redSoft} fg={C.red}>⚠ {overdueCount} overdue</Badge>}
                {openCount===0&&overdueCount===0&&weekActions.length>0&&<Badge bg={C.greenSoft} fg={C.green}>✓ all done</Badge>}
              </div>
            </div>
            {showActions&&<div style={{padding:"8px 20px 14px"}}>
              {weekActions.length===0&&overdueCount===0&&<div style={{padding:"14px 12px",textAlign:"center",fontSize:12,color:C.textDim,fontStyle:"italic"}}>No action items for this week yet. Add some in the Action Items tab.</div>}
              {overdueCount>0&&<div style={{marginBottom:12,padding:"8px 10px",background:C.redSoft,borderRadius:8,borderLeft:`3px solid ${C.red}`}}>
                <div style={{fontSize:10,fontWeight:700,color:C.red,textTransform:"uppercase",marginBottom:4}}>⚠️ Overdue from previous weeks</div>
                {projActions.filter(a=>!a.done&&a.weekKey&&a.weekKey<thisWeek).slice(0,8).map(a=>{const assignee=users.find(u=>u.id===a.assignee);const weeks=Math.max(1,Math.round((new Date(thisWeek)-new Date(a.weekKey))/(7*864e5)));return <div key={a.id} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:`1px solid rgba(224,49,49,.15)`}}>
                  <input type="checkbox" checked={a.done} onChange={()=>toggleAction&&toggleAction(slideProj.id,a.id)} style={{accentColor:C.red,width:15,height:15}}/>
                  <div style={{width:3,height:18,background:priColor(a.priority||"Medium"),borderRadius:2,flexShrink:0}}/>
                  <div style={{flex:1,fontSize:12,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={a.text}>{a.text}</div>
                  <span style={{fontSize:9,color:C.red,fontWeight:700,flexShrink:0}}>{weeks}w</span>
                  {assignee&&<div style={{...S.avatar,width:18,height:18,fontSize:7,flexShrink:0}} title={assignee.name}>{assignee.profilePhoto?<img src={assignee.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:assignee.avatar}</div>}
                </div>})}
              </div>}
              {weekActions.length>0&&<div>
                <div style={{fontSize:10,fontWeight:600,color:C.textMid,textTransform:"uppercase",marginBottom:6}}>This Week</div>
                {weekActions.sort((a,b)=>({High:0,Medium:1,Low:2}[a.priority||"Medium"]-{High:0,Medium:1,Low:2}[b.priority||"Medium"])).map(a=>{const assignee=users.find(u=>u.id===a.assignee);const pri=a.priority||"Medium";const today=new Date();today.setHours(0,0,0,0);const overdue=a.dueDate&&new Date(a.dueDate)<today&&!a.done;return <div key={a.id} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:`1px solid ${C.card}`}}>
                  <input type="checkbox" checked={a.done} onChange={()=>toggleAction&&toggleAction(slideProj.id,a.id)} style={{accentColor:C.accent,width:15,height:15}}/>
                  <div style={{width:3,height:18,background:priColor(pri),borderRadius:2,flexShrink:0}}/>
                  <div style={{flex:1,fontSize:12,textDecoration:a.done?"line-through":"none",color:a.done?C.textDim:C.text,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={a.text}>
                    {a.text}
                    {a.dueDate&&<span style={{marginLeft:6,fontSize:9,color:overdue?C.red:C.textDim,fontWeight:overdue?700:400}}>{overdue?"⚠":"📅"} {a.dueDate}</span>}
                  </div>
                  {assignee&&<div style={{...S.avatar,width:18,height:18,fontSize:7,flexShrink:0}} title={assignee.name}>{assignee.profilePhoto?<img src={assignee.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:assignee.avatar}</div>}
                </div>})}
              </div>}
            </div>}
          </div>;
        })()}
        </div>;
}


function CreateEventModal({onClose,onCreate}){
  const [title,setTitle]=useState("");
  const [description,setDescription]=useState("");
  const [date,setDate]=useState("");
  const [type,setType]=useState("general");
  const types=[
    {v:"general",label:"🎉 General",desc:"Any company event"},
    {v:"worldcup2026",label:"⚽ World Cup 2026",desc:"Pick 2 teams per group, earn points for advances"},
    {v:"sports",label:"🏟 Sports (Custom)",desc:"Custom sports pool with manual scoring"},
    {v:"competition",label:"🏆 Competition",desc:"Contests with rankings"},
    {v:"challenge",label:"💪 Challenge",desc:"Steps, reading, habits"},
    {v:"trivia",label:"🧠 Trivia",desc:"Quiz nights, knowledge games"},
    {v:"social",label:"🎊 Social",desc:"Parties, outings, mixers"}
  ];
  const canSubmit=title.trim().length>0;
  const submit=()=>{
    if(!canSubmit)return;
    const payload={title:title.trim(),description:description.trim(),date,type};
    // Auto-init World Cup event with team picks structure
    if(type==="worldcup2026"){
      payload.wcPicks={}; // {userId: {A:[t1,t2], B:[t1,t2], ...}}
      payload.wcResults={}; // {teamName: ["group","r32","r16","qf","sf","final","champion"] (highest reached)}
      payload.title=title.trim()||"World Cup 2026 Pool";
      payload.description=description.trim()||"Pick 2 teams from each of the 12 groups. Earn 1 point each time one of your teams advances to the next round!";
    }
    onCreate(payload);
  };
  return <Modal title="🎉 Create Event" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:canSubmit?1:.4}} onClick={submit}>Create Event</button></>}>
    <div style={S.inputGroup}>
      <label style={S.label}>Event Title *</label>
      <input style={S.input} value={title} onChange={e=>setTitle(e.target.value)} placeholder="e.g. 2026 World Cup Prediction Pool" autoFocus/>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Description</label>
      <textarea style={{...S.textarea,minHeight:60}} value={description} onChange={e=>setDescription(e.target.value)} placeholder="Rules, how to play, what to predict…"/>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Event Date / Deadline (optional)</label>
      <input type="date" style={S.input} value={date} onChange={e=>setDate(e.target.value)}/>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Event Type</label>
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8}}>
        {types.map(t=><label key={t.v} style={{display:"flex",alignItems:"center",gap:8,padding:"10px 12px",border:`2px solid ${type===t.v?C.accent:C.border}`,borderRadius:10,cursor:"pointer",background:type===t.v?C.accentSoft:"transparent"}}>
          <input type="radio" checked={type===t.v} onChange={()=>setType(t.v)} style={{accentColor:C.accent}}/>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:600}}>{t.label}</div>
            <div style={{fontSize:10,color:C.textDim}}>{t.desc}</div>
          </div>
        </label>)}
      </div>
    </div>
  </Modal>;
}


function PointAwardModal({ctx,users,onClose,onAward}){
  const [userId,setUserId]=useState("");
  const [points,setPoints]=useState(5);
  const [note,setNote]=useState("");
  const staffList=users.filter(u=>isStaff(u)&&u.status!=="pending");
  const canSubmit=userId&&Number.isFinite(points);
  return <Modal title={`🎖 Award Points — ${ctx.evTitle}`} onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:canSubmit?1:.4}} onClick={()=>canSubmit&&onAward(userId,parseInt(points)||0,note.trim())}>Award Points</button></>}>
    <div style={S.banner(C.accentSoft,C.accent)}>Points add to the participant's total. Use negative numbers to subtract.</div>
    <div style={S.inputGroup}>
      <label style={S.label}>Participant *</label>
      <select style={S.select} value={userId} onChange={e=>setUserId(e.target.value)}>
        <option value="">-- Select person --</option>
        {staffList.map(u=><option key={u.id} value={u.id}>{u.name} ({u.role})</option>)}
      </select>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,flex:1}}>
        <label style={S.label}>Points *</label>
        <input type="number" style={S.input} value={points} onChange={e=>setPoints(e.target.value)} placeholder="5"/>
      </div>
      <div style={{...S.inputGroup,flex:2}}>
        <label style={S.label}>Reason / Note (optional)</label>
        <input style={S.input} value={note} onChange={e=>setNote(e.target.value)} placeholder="e.g. Correct prediction for Brazil vs Argentina"/>
      </div>
    </div>
    <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:-4}}>
      <span style={{fontSize:11,color:C.textDim,alignSelf:"center"}}>Quick:</span>
      {[1,3,5,10,-1,-5].map(v=><button key={v} style={{...S.btnO,padding:"4px 10px",fontSize:11,color:v<0?C.red:C.accent,borderColor:v<0?C.red:C.accent}} onClick={()=>setPoints(v)}>{v>0?`+${v}`:v}</button>)}
    </div>
  </Modal>;
}


function EventDetailModal({event,users,currentUser,onClose,onUpdate,onAwardPoints,onResetUserPoints,onRemoveParticipant,onDelete,onArchive}){
  const isAdm=isAdmin(currentUser);
  const [editing,setEditing]=useState(false);
  const [editTitle,setEditTitle]=useState(event.title);
  const [editDesc,setEditDesc]=useState(event.description||"");
  const [editDate,setEditDate]=useState(event.date||"");
  const [editType,setEditType]=useState(event.type||"general");
  const [addUserOpen,setAddUserOpen]=useState(false);
  const [selectedAddUser,setSelectedAddUser]=useState("");
  const [quickAwardFor,setQuickAwardFor]=useState(null); // userId to show inline award form for
  const [quickPoints,setQuickPoints]=useState(5);
  const [quickNote,setQuickNote]=useState("");
  const [wcExpandedUser,setWcExpandedUser]=useState(null);
  const [wcTab,setWcTab]=useState("groups"); // groups|leaderboard|r32|r16|qf|sf|final
  const [wcGuestPicks,setWcGuestPicks]=useState({}); // {A:[t1,t2], B:[t1,t2], ...} for the guest being added
  const [wcR32AsUser,setWcR32AsUser]=useState(""); // admin: whose R32 picks to edit ("" = self)
  const WC_DEADLINE=new Date("2026-06-11T00:00:00"); // picks lock at midnight Jun 11

  const types=[
    {v:"general",label:"🎉 General"},{v:"worldcup2026",label:"⚽ World Cup 2026"},{v:"sports",label:"🏟 Sports"},{v:"competition",label:"🏆 Competition"},
    {v:"challenge",label:"💪 Challenge"},{v:"trivia",label:"🧠 Trivia"},{v:"social",label:"🎊 Social"}
  ];
  const typeIcon={worldcup2026:"⚽",sports:"🏟",competition:"🏆",social:"🎊",challenge:"💪",trivia:"🧠",general:"🎉"}[event.type]||"🎉";
  const typeColor={worldcup2026:C.green,sports:C.green,competition:C.amber,social:C.purple,challenge:C.red,trivia:C.accent,general:C.accent}[event.type]||C.accent;

  const lb=[...(event.leaderboard||[])].sort((a,b)=>(b.points||0)-(a.points||0));
  const joined=lb.find(e=>e.userId===currentUser.id);
  const staffList=users.filter(u=>isStaff(u)&&u.status!=="pending");
  const participantIds=new Set((event.leaderboard||[]).map(e=>e.userId));
  const availableToAdd=staffList.filter(u=>!participantIds.has(u.id));

  const saveEdits=()=>{
    if(!editTitle.trim())return;
    onUpdate(event.id,{title:editTitle.trim(),description:editDesc.trim(),date:editDate,type:editType});
    setEditing(false);
  };

  const handleQuickAward=(uid)=>{
    const pts=parseInt(quickPoints);
    if(!Number.isFinite(pts)||pts===0)return;
    onAwardPoints(event.id,uid,pts,quickNote.trim());
    setQuickAwardFor(null);setQuickPoints(5);setQuickNote("");
  };

  const handleAddParticipant=()=>{
    if(!selectedAddUser)return;
    onAwardPoints(event.id,selectedAddUser,0,"");
    setSelectedAddUser("");setAddUserOpen(false);
  };

  return <Modal title={`${typeIcon} ${event.title}`} onClose={onClose} wide={true} footer={<>
    {isAdm&&!editing&&<>
      <button style={{...S.btnO,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm("Delete this event? All leaderboard data will be lost."))onDelete(event.id)}}>🗑 Delete</button>
      <button style={S.btnO} onClick={()=>onArchive(event.id)}>{event.archived?"Restore":"📦 Archive"}</button>
    </>}
    {isAdm&&!editing&&<button style={S.btnO} onClick={()=>setEditing(true)}>✏️ Edit Details</button>}
    {editing&&<>
      <button style={S.btnO} onClick={()=>{setEditing(false);setEditTitle(event.title);setEditDesc(event.description||"");setEditDate(event.date||"");setEditType(event.type||"general")}}>Cancel</button>
      <button style={{...S.btn,opacity:editTitle.trim()?1:.4}} onClick={saveEdits}>Save Changes</button>
    </>}
    {!editing&&<button style={S.btn} onClick={onClose}>Done</button>}
  </>}>
    {/* Edit details form */}
    {editing&&<div style={{padding:14,background:C.accentSoft,borderRadius:10,marginBottom:16}}>
      <div style={{fontSize:11,fontWeight:700,color:C.accent,textTransform:"uppercase",marginBottom:10}}>EDIT EVENT DETAILS</div>
      <div style={S.inputGroup}>
        <label style={S.label}>Event Title *</label>
        <input style={S.input} value={editTitle} onChange={e=>setEditTitle(e.target.value)}/>
      </div>
      <div style={S.inputGroup}>
        <label style={S.label}>Description</label>
        <textarea style={{...S.textarea,minHeight:60}} value={editDesc} onChange={e=>setEditDesc(e.target.value)}/>
      </div>
      <div style={S.row}>
        <div style={{...S.inputGroup,...S.half}}>
          <label style={S.label}>Event Date</label>
          <input type="date" style={S.input} value={editDate} onChange={e=>setEditDate(e.target.value)}/>
        </div>
        <div style={{...S.inputGroup,...S.half}}>
          <label style={S.label}>Type</label>
          <select style={S.select} value={editType} onChange={e=>setEditType(e.target.value)}>
            {types.map(t=><option key={t.v} value={t.v}>{t.label}</option>)}
          </select>
        </div>
      </div>
    </div>}

    {/* Event summary */}
    {!editing&&<div style={{padding:"14px 16px",background:C.card,borderRadius:10,marginBottom:16,borderLeft:`3px solid ${typeColor}`}}>
      {event.description&&<div style={{fontSize:13,color:C.text,lineHeight:1.6,marginBottom:8}}>{event.description}</div>}
      <div style={{display:"flex",gap:14,fontSize:11,color:C.textDim,flexWrap:"wrap"}}>
        {event.date&&<span>📅 {new Date(event.date).toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",year:"numeric"})}</span>}
        <span>👥 {lb.length} participant{lb.length!==1?"s":""}</span>
        <span>🏆 Total: {lb.reduce((s,e)=>s+(e.points||0),0)} points</span>
      </div>
      {!joined&&<button style={{...S.btnSm,padding:"6px 14px",fontSize:11,marginTop:10}} onClick={()=>onAwardPoints(event.id,currentUser.id,0,"")}>🎯 Join This Event</button>}
      {joined&&<div style={{fontSize:11,color:C.accent,fontWeight:600,marginTop:8}}>✓ You're in! Current rank: #{lb.findIndex(e=>e.userId===currentUser.id)+1} with {joined.points||0} points</div>}
    </div>}

    {/* Add participant (admins only) */}
    {isAdm&&!editing&&<div style={{marginBottom:16}}>
      {!addUserOpen&&availableToAdd.length>0&&<button style={{...S.btnO,fontSize:12,padding:"8px 14px"}} onClick={()=>setAddUserOpen(true)}>+ Add Participant</button>}
      {addUserOpen&&<div style={{padding:12,background:C.accentSoft,borderRadius:8,display:"flex",gap:8,alignItems:"center"}}>
        <select style={{...S.select,flex:1}} value={selectedAddUser} onChange={e=>setSelectedAddUser(e.target.value)} autoFocus>
          <option value="">-- Select person to add --</option>
          {availableToAdd.map(u=><option key={u.id} value={u.id}>{u.name} ({u.role})</option>)}
        </select>
        <button style={{...S.btnSm,padding:"8px 14px",fontSize:12,opacity:selectedAddUser?1:.4}} onClick={handleAddParticipant}>Add</button>
        <button style={{...S.btnO,padding:"8px 14px",fontSize:12}} onClick={()=>{setAddUserOpen(false);setSelectedAddUser("")}}>Cancel</button>
      </div>}
    </div>}

    {/* WORLD CUP 2026 PICKS UI */}
    {event.type==="worldcup2026"&&(()=>{
      const wcPicks=event.wcPicks||{};
      const wcResults=event.wcResults||{};
      const myPicks=wcPicks[currentUser.id]||{};
      const picksLocked=new Date()>=WC_DEADLINE;
      const computePoints=(userId)=>computeWCPoints(event,userId);
      const togglePick=(group,team)=>{
        if(picksLocked){alert("Group stage picks are locked as of June 11, 2026.");return;}
        const groupPicks=myPicks[group]||[];let next;
        if(groupPicks.includes(team)){next=groupPicks.filter(t=>t!==team);}
        else if(groupPicks.length>=2){alert("You can only pick 2 teams from Group "+group+". Remove one first.");return;}
        else{next=[...groupPicks,team];}
        onUpdate(event.id,{wcPicks:{...wcPicks,[currentUser.id]:{...myPicks,[group]:next}}});
      };
      const setTeamResult=(team,round)=>{if(!isAdm)return;onUpdate(event.id,{wcResults:{...wcResults,[team]:round}});};
      const totalGroupsPicked=WC26_GROUP_LETTERS.filter(g=>(myPicks[g]||[]).length===2).length;
      const totalTeamsPicked=WC26_GROUP_LETTERS.reduce((s,g)=>s+(myPicks[g]||[]).length,0);
      const wcLeaderboard=[...new Set([...Object.keys(wcPicks),...Object.keys(event.wcR32Picks||{})])].map(uid=>{
        const isGuest=uid.startsWith("guest_");
        const guestName=isGuest?(event.wcGuestNames||{})[uid]||uid.replace("guest_",""):null;
        const u=isGuest?null:users.find(x=>x.id===uid);
        return{userId:uid,user:u,guestName,isGuest,points:computePoints(uid),totalPicks:WC26_GROUP_LETTERS.reduce((s,g)=>s+(wcPicks[uid]?.[g]||[]).length,0)};
      }).sort((a,b)=>b.points-a.points);
      const daysUntilDeadline=Math.ceil((WC_DEADLINE-new Date())/864e5);
      const handleShare=()=>{
        const url=window.location.origin+"/team?event="+event.id;
        if(navigator.share){navigator.share({title:"WorkBro — World Cup 2026 Picks",text:"Join our World Cup 2026 picks challenge on WorkBro!",url});}
        else{navigator.clipboard.writeText(url).then(()=>alert("Event link copied!\n\n"+url)).catch(()=>prompt("Copy this link:",url));}
      };
      const KnockoutTBD=({round})=><div style={{...S.card,padding:40,textAlign:"center"}}>
        <div style={{fontSize:40,marginBottom:12}}>⚽</div>
        <div style={{fontSize:16,fontWeight:700,marginBottom:6}}>{round} — Coming Soon</div>
        <div style={{fontSize:13,color:C.textDim}}>Results will be entered here as the tournament progresses.</div>
      </div>;
      const renderKO=(cfg)=>{
        const koPicks=event[cfg.picksKey]||{};      // {userId:{gameId:team}}
        const koResults=wcRoundResults(event,cfg);   // official baseline + admin-entered
        const N=cfg.fixtures.length;
        const entrantIds=wcEntrantIds(event);
        const guestIds=entrantIds.filter(uid=>uid.startsWith("guest_"));
        const regIds=entrantIds.filter(uid=>!uid.startsWith("guest_")&&uid!==currentUser.id);
        const plainName=(uid)=>wcEntrantName(event,users,uid);
        const targetId=(isAdm&&wcR32AsUser&&entrantIds.includes(wcR32AsUser))?wcR32AsUser:currentUser.id;
        const myKO=koPicks[targetId]||{};
        const pickGame=(gameId,team)=>onUpdate(event.id,{[cfg.picksKey]:{...koPicks,[targetId]:{...(koPicks[targetId]||{}),[gameId]:team}}});
        const setGameResult=(gameId,team)=>{if(!isAdm)return;onUpdate(event.id,{[cfg.resultsKey]:{...koResults,[gameId]:team}});};
        const settleForEveryone=(gameId,team)=>{
          if(!isAdm)return;
          if(!confirm(`Set ${team} as the winner AND assign ${team} as everyone's pick for this game? Every entrant gets +${cfg.points} points for it.`))return;
          const nextPicks={...koPicks};entrantIds.forEach(uid=>{nextPicks[uid]={...(nextPicks[uid]||{}),[gameId]:team};});
          onUpdate(event.id,{[cfg.resultsKey]:{...koResults,[gameId]:team},[cfg.picksKey]:nextPicks});
        };
        const applyOfficial=()=>{
          if(!isAdm||!cfg.official)return;
          if(!confirm(`Apply the official ${cfg.label} results for all games? This scores everyone's predictions (+${cfg.points} for each correct pick).`))return;
          onUpdate(event.id,{[cfg.resultsKey]:{...koResults,...cfg.official}});
        };
        const removeGuest=(uid)=>{
          if(!confirm(`Remove ${plainName(uid)}'s guest entry? This deletes their group and knockout picks.`))return;
          const upd={};const np={...wcPicks};delete np[uid];upd.wcPicks=np;
          const nn={...(event.wcGuestNames||{})};delete nn[uid];upd.wcGuestNames=nn;
          WC26_KO_ROUNDS.forEach(r=>{const o={...(event[r.picksKey]||{})};delete o[uid];upd[r.picksKey]=o;});
          onUpdate(event.id,upd);
        };
        const voids=event.wcVoids||{};
        const voidKey=(uid,gid)=>`${cfg.picksKey}:${gid}:${uid}`;
        const isVoid=(uid,gid)=>!!voids[voidKey(uid,gid)];
        const toggleVoid=(uid,gid)=>{if(!isAdm)return;const k=voidKey(uid,gid);const nv={...voids};if(nv[k])delete nv[k];else nv[k]=true;onUpdate(event.id,{wcVoids:nv});};
        const myCorrect=cfg.fixtures.filter(g=>koResults[g.id]&&myKO[g.id]===koResults[g.id]&&!isVoid(targetId,g.id)).length;
        const myPicked=cfg.fixtures.filter(g=>myKO[g.id]).length;
        const decidedN=cfg.fixtures.filter(g=>koResults[g.id]).length;
        const editingOther=isAdm&&targetId!==currentUser.id;
        return <div>
          <div style={{...S.card,padding:16,marginBottom:12}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
              <div>
                <div style={{fontSize:16,fontWeight:700}}>{cfg.label} — Pick the winners</div>
                <div style={{fontSize:12,color:C.textDim}}>Pick one team per game. <strong>{cfg.fixtures.some(g=>g.pts&&g.pts!==cfg.points)?"Points shown per game":`+${cfg.points} points`}</strong>{cfg.fixtures.some(g=>g.pts&&g.pts!==cfg.points)?".":" for each correct pick."}{isAdm?" As admin, tap a team's ✓ win to set the actual result.":""}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:22,fontWeight:700,color:C.green}}>{myCorrect}<span style={{fontSize:13,color:C.textDim}}>/{myPicked||N}</span></div>
                <div style={{fontSize:10,color:C.textDim,fontWeight:600,letterSpacing:1}}>{editingOther?"CORRECT":"YOUR CORRECT"}</div>
              </div>
            </div>
            {/* Admin: one-tap apply official results */}
            {isAdm&&cfg.official&&<div style={{marginTop:12,paddingTop:12,borderTop:"1px solid "+C.border,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <button onClick={applyOfficial} style={{...S.btnSm,padding:"7px 14px",fontSize:12,background:C.green,color:"#000",fontWeight:700}}>⚡ Apply official {cfg.label} results</button>
              <span style={{fontSize:11,color:C.textDim}}>Sets all {N} winners at once and scores everyone's predictions.{decidedN>0?` (${decidedN}/${N} already set)`:""}</span>
            </div>}
            {/* Admin: pick on behalf of any entrant (registered users or guests) */}
            {isAdm&&entrantIds.length>0&&<div style={{marginTop:12,paddingTop:12,borderTop:"1px solid "+C.border,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <span style={{fontSize:12,fontWeight:600,color:"var(--text-2)"}}>✏️ Make picks for:</span>
              <select value={entrantIds.includes(wcR32AsUser)?wcR32AsUser:""} onChange={e=>setWcR32AsUser(e.target.value)} style={{...S.select,height:32,fontSize:12,maxWidth:260}}>
                <option value="">Myself ({currentUser.name})</option>
                {regIds.length>0&&<optgroup label="Registered users">
                  {regIds.slice().sort((a,b)=>plainName(a).localeCompare(plainName(b))).map(uid=><option key={uid} value={uid}>{plainName(uid)}</option>)}
                </optgroup>}
                {guestIds.length>0&&<optgroup label="Guests">
                  {guestIds.slice().sort((a,b)=>plainName(a).localeCompare(plainName(b))).map(uid=><option key={uid} value={uid}>{plainName(uid)} (guest)</option>)}
                </optgroup>}
              </select>
              {editingOther&&<span style={{fontSize:11,color:"var(--amber-600,#b8860b)",fontWeight:600}}>Editing {plainName(targetId)}'s picks — tap teams to set them.</span>}
            </div>}
          </div>

          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:10}}>
            {cfg.fixtures.map(game=>{
              const myPick=myKO[game.id];const result=koResults[game.id];const decided=!!result;
              const isSettleGame=game.id===cfg.settleGameId; // already played before picking opened
              const canEdit=!decided||(isAdm&&editingOther); // admin may correct another entrant's pick after the result is in
              return <div key={game.id} style={{...S.card,padding:"10px 12px"}}>
                <div style={{fontSize:10,color:C.textDim,fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}><span>{game.label?game.label+" · ":""}{game.date}</span>{(game.pts&&game.pts!==cfg.points)?<span style={{color:"var(--a-600,var(--a-500))",fontWeight:700}}>+{game.pts} pts</span>:null}{decided&&<span style={{color:"var(--green-600)"}}>· Final</span>}{decided&&editingOther&&<span style={{color:"var(--a-500)"}}>· tap a team to correct this pick</span>}{isSettleGame&&!decided&&<span style={{color:"var(--a-500)"}}>· already played</span>}</div>
                {[game.home,game.away].map(team=>{
                  const isMyPick=myPick===team;const isWinner=result===team;const isLoser=decided&&result!==team;
                  return <div key={team} onClick={()=>{if(canEdit)pickGame(game.id,team)}} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 8px",borderRadius:7,marginBottom:4,cursor:canEdit?"pointer":"default",
                    background:isWinner?"color-mix(in srgb,var(--green-500) 14%,transparent)":isMyPick?"color-mix(in srgb,var(--a-500) 12%,transparent)":"var(--surface-2)",
                    border:"1px solid "+(isWinner?"color-mix(in srgb,var(--green-500) 40%,var(--border))":isMyPick?"color-mix(in srgb,var(--a-500) 35%,var(--border))":"var(--border)"),
                    opacity:isLoser?0.5:1,transition:"all .12s"}}>
                    <FlagImg team={team} size={16}/>
                    <span style={{flex:1,fontSize:13,fontWeight:isMyPick||isWinner?700:500,textDecoration:isLoser?"line-through":"none"}}>{team}</span>
                    {isMyPick&&<span style={{fontSize:9,fontWeight:700,padding:"1px 5px",borderRadius:999,background:"var(--a-500)",color:"#fff"}}>{editingOther?"PICK":"MY PICK"}</span>}
                    {isAdm&&!decided&&!isSettleGame&&<button onClick={e=>{e.stopPropagation();setGameResult(game.id,team)}} style={{background:"none",border:"1px solid var(--green-500)",borderRadius:5,cursor:"pointer",color:"var(--green-600)",fontSize:11,padding:"1px 6px",fontFamily:"var(--font-sans)",fontWeight:700}} title="Set as winner">✓ win</button>}
                    {isAdm&&!decided&&isSettleGame&&<button onClick={e=>{e.stopPropagation();settleForEveryone(game.id,team)}} style={{background:"none",border:"1px solid var(--a-500)",borderRadius:5,cursor:"pointer",color:"var(--a-600,var(--a-500))",fontSize:11,padding:"1px 6px",fontFamily:"var(--font-sans)",fontWeight:700}} title="Game already played — set as winner AND everyone's pick">✓ set for all</button>}
                    {isWinner&&<span style={{fontSize:14,color:"var(--green-600)"}}>✓</span>}
                  </div>;
                })}
                {isAdm&&decided&&<button onClick={()=>{const nr={...koResults};delete nr[game.id];onUpdate(event.id,{[cfg.resultsKey]:nr})}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-3)",fontSize:10,padding:"2px 0",fontFamily:"var(--font-sans)"}}>↩ undo result</button>}
              </div>;
            })}
          </div>

          {/* Everyone's selections — always visible at the bottom */}
          <div style={{...S.card,padding:16,marginTop:16}}>
            <div style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:12}}>📋 Everyone's {cfg.label} Selections</div>
            {entrantIds.length===0?<div style={{fontSize:12,color:C.textDim}}>No entrants yet.</div>:
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {entrantIds.slice().sort((a,b)=>plainName(a).localeCompare(plainName(b))).map(uid=>{
                const picks=koPicks[uid]||{};const isGuest=uid.startsWith("guest_");
                const correct=cfg.fixtures.filter(g=>koResults[g.id]&&picks[g.id]===koResults[g.id]&&!isVoid(uid,g.id)).length;
                const pickedN=cfg.fixtures.filter(g=>picks[g.id]).length;
                return <div key={uid} style={{border:"1px solid "+C.border,borderRadius:10,padding:"10px 12px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:pickedN>0?8:0}}>
                    <span style={{fontSize:13,fontWeight:600}}>{plainName(uid)}</span>
                    {isGuest&&<span style={{fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:999,background:"var(--n-100)",color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}
                    <span style={{fontSize:11,color:C.textDim,marginLeft:"auto"}}>{pickedN>0?pickedN+"/"+N+" picked":"no picks yet"}{decidedN>0&&pickedN>0?" · "+correct+" correct":""}</span>
                    {isAdm&&isGuest&&<button onClick={()=>removeGuest(uid)} style={{background:"none",border:"1px solid var(--red-500)",borderRadius:5,cursor:"pointer",color:"var(--red-500)",fontSize:11,padding:"1px 7px",fontFamily:"var(--font-sans)",fontWeight:700}} title="Remove this guest entry">✕ remove</button>}
                  </div>
                  {pickedN>0&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:5}}>
                    {cfg.fixtures.map(game=>{
                      const pick=picks[game.id];if(!pick)return null;
                      const result=koResults[game.id];const voided=isVoid(uid,game.id);
                      const isCorrect=result&&pick===result&&!voided;const isWrong=result&&(pick!==result||voided);
                      return <div key={game.id} title={voided?"Voided — this pick doesn't count":undefined} style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",background:voided?"color-mix(in srgb,var(--red-500) 6%,var(--surface-2))":"var(--surface-2)",border:"1px solid "+(isCorrect?"color-mix(in srgb,var(--green-500) 40%,var(--border))":isWrong?"color-mix(in srgb,var(--red-500) 30%,var(--border))":"var(--border)"),borderRadius:6,fontSize:11,opacity:voided?0.7:1}}>
                        <FlagImg team={pick} size={12}/>
                        <span style={{flex:1,fontWeight:600,color:isCorrect?"var(--green-600)":isWrong?"var(--red-500)":"var(--text)",textDecoration:(isWrong||voided)?"line-through":"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{pick}</span>
                        {voided&&<span style={{fontSize:8,fontWeight:700,padding:"0 4px",borderRadius:999,background:"var(--red-500)",color:"#fff",letterSpacing:"0.03em"}}>VOID</span>}
                        {isCorrect&&<span style={{color:"var(--green-600)"}}>✓</span>}
                        {isAdm&&result&&<button onClick={()=>toggleVoid(uid,game.id)} title={voided?"Restore this pick (let it count)":"Void this pick (won't count even if correct)"} style={{background:"none",border:"none",cursor:"pointer",color:voided?"var(--green-600)":"var(--text-3)",fontSize:11,padding:0,marginLeft:2,fontFamily:"var(--font-sans)",lineHeight:1}}>{voided?"↺":"∅"}</button>}
                      </div>;
                    })}
                  </div>}
                </div>;
              })}
            </div>}
          </div>
        </div>;
      };
      const WC_TABS=[
        {id:"groups",label:"Group Stage"},
        {id:"leaderboard",label:"🏆 Leaderboard"},
        ...(wcPodium(event)?[{id:"podium",label:"🏅 Podium"}]:[]),
        {id:"r32",label:"R32"},{id:"r16",label:"R16"},
        {id:"qf",label:"Quarter Final"},{id:"sf",label:"Semi Final"},{id:"final",label:"Final 🏆"},
      ];
      return <div style={{marginBottom:24}}>
        {/* Status bar + share */}
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:0}}>
            {picksLocked
              ?<div style={{...S.banner(C.amberSoft,C.amber),marginBottom:0}}>🔒 Group stage picks locked as of June 11. Results are being tracked — watch the leaderboard!</div>
              :<div style={{...S.banner(C.greenSoft,C.green),marginBottom:0}}>
                ⚽ <strong>{totalTeamsPicked}/24</strong> teams picked · {totalGroupsPicked}/12 groups complete
                {daysUntilDeadline>0&&<span style={{marginLeft:8,color:C.amber}}>· 🗓 Picks lock in <strong>{daysUntilDeadline} day{daysUntilDeadline===1?"":"s"}</strong> (Jun 11)</span>}
                {totalGroupsPicked===12&&<span style={{marginLeft:8,fontWeight:700}}>· ✅ Complete! {computePoints(currentUser.id)} pts</span>}
              </div>}
          </div>
          <button onClick={handleShare} style={{...S.btnO,padding:"8px 14px",fontSize:13,display:"flex",alignItems:"center",gap:6,flexShrink:0}}>🔗 Share Event</button>
        </div>
        {/* Tabs */}
        <div style={{display:"flex",borderBottom:"1px solid "+C.border,marginBottom:16,overflowX:"auto",scrollbarWidth:"none"}}>
          {WC_TABS.map(t=><button key={t.id} onClick={()=>setWcTab(t.id)} style={{padding:"9px 16px",border:"none",borderBottom:wcTab===t.id?"2px solid "+C.accent:"2px solid transparent",background:"transparent",color:wcTab===t.id?C.text:C.textDim,fontWeight:wcTab===t.id?700:500,fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"var(--font-sans)"}}>{t.label}</button>)}
        </div>
        {/* GROUP STAGE TAB */}
        {wcTab==="groups"&&<>
          {picksLocked&&<div style={{...S.banner("var(--amber-50)","var(--amber-500)"),marginBottom:12,fontSize:12}}>🔒 Picks are locked — your selections are final.</div>}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:12,marginBottom:20}}>
            {WC26_GROUP_LETTERS.map(g=>{
              const grp=WC26_GROUPS[g];const myGroupPicks=myPicks[g]||[];const isComplete=myGroupPicks.length===2;
              return <div key={g} style={{...S.card,padding:0,overflow:"hidden",borderTop:"3px solid "+(isComplete?C.green:C.border)}}>
                <div style={{padding:"8px 12px",background:C.card,borderBottom:"1px solid "+C.border,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <span style={{fontWeight:700,fontSize:13}}>Group {g}</span>
                  <span style={{fontSize:11,color:isComplete?C.green:C.textDim,fontWeight:600}}>{myGroupPicks.length}/2</span>
                </div>
                <div style={{padding:8}}>
                  {grp.teams.map((team,ti)=>{
                    const picked=myGroupPicks.includes(team);const reached=wcReachedRound(team,event);
                    const advancedToR32=WC26_ROUNDS.indexOf(reached)>=1;const eliminated=reached==="group";
                    const otherPickers=Object.entries(wcPicks).filter(([uid,p])=>uid!==currentUser.id&&(p?.[g]||[]).includes(team)).map(([uid])=>users.find(u=>u.id===uid)).filter(Boolean);
                    return <div key={team}>
                      <div onClick={()=>!picksLocked&&togglePick(g,team)} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"1px solid "+(picked?C.green:"transparent"),background:picked?C.greenSoft:eliminated?"rgba(224,49,49,.04)":"transparent",borderRadius:6,marginBottom:3,cursor:picksLocked?"default":"pointer",opacity:eliminated?0.55:1}}>
                        <FlagImg team={team} size={18}/>
                        <div style={{flex:1,fontSize:12,fontWeight:picked?700:500,textDecoration:eliminated?"line-through":"none"}}>{team}</div>
                        {advancedToR32&&<Badge bg={C.greenSoft} fg={C.green}>{WC26_ROUND_LABELS[reached]}</Badge>}
                        {eliminated&&<Badge bg={C.redSoft} fg={C.red}>OUT</Badge>}
                        {picked&&(picksLocked?<span style={{color:C.green,fontSize:11}}>🔒</span>:<span style={{color:C.green,fontWeight:700,fontSize:14}}>✓</span>)}
                      </div>
                      {otherPickers.length>0&&<div style={{fontSize:9,color:C.textDim,paddingLeft:10,marginBottom:3,display:"flex",gap:3,flexWrap:"wrap"}}>
                        {otherPickers.slice(0,4).map(u=><span key={u.id}>{u.avatar}</span>)} also picked
                      </div>}
                      {isAdm&&<div style={{paddingLeft:36,marginBottom:4}}>
                        <select value={wcReachedRound(team,event)} onChange={e=>setTeamResult(team,e.target.value)} style={{...S.select,height:22,fontSize:10,padding:"0 4px",width:"auto"}}>
                          <option value="">No result</option>
                          <option value="group">Out (Group)</option>
                          <option value="r32">Reached R32</option>
                          <option value="r16">Reached R16</option>
                          <option value="qf">Reached QF</option>
                          <option value="sf">Reached SF</option>
                          <option value="final">Reached Final</option>
                          <option value="champion">CHAMPION 🏆</option>
                        </select>
                      </div>}
                    </div>;
                  })}
                </div>
              </div>;
            })}
          </div>
        </>}
        {/* LEADERBOARD TAB */}
        {wcTab==="leaderboard"&&<div>
          {(()=>{const pod=wcPodium(event);if(!pod)return null;return <div style={{...S.card,padding:"16px 18px",marginBottom:12,background:"linear-gradient(135deg,color-mix(in srgb,var(--a-500) 16%,var(--surface)),var(--surface))",border:"1px solid color-mix(in srgb,var(--a-500) 35%,var(--border))",display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
            <div style={{fontSize:34,lineHeight:1}}>🏆</div>
            <div style={{flex:1,minWidth:180}}>
              <div style={{fontSize:10,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:"var(--a-600,var(--a-500))"}}>2026 World Cup Champions</div>
              <div style={{fontSize:22,fontWeight:800,letterSpacing:"-0.02em",display:"flex",alignItems:"center",gap:8,marginTop:2}}><FlagImg team={pod.champion} size={26}/>{pod.champion}</div>
              <div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>def. {pod.runnerUp} in the final{pod.third?` · ${pod.third} finished 3rd`:""}</div>
            </div>
            <button onClick={()=>setWcTab("podium")} style={{...S.btnO,height:32,padding:"0 14px",fontSize:12}}>View podium →</button>
          </div>;})()}
          {/* Share public link */}
          <div style={{...S.card,padding:14,marginBottom:12,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:180}}>
              <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:2}}>🔗 Public leaderboard link</div>
              <div style={{fontSize:11,color:"var(--text-3)"}}>Share this with anyone — they can view the standings without signing up.</div>
            </div>
            <button style={{...S.btn,padding:"0 16px",height:36,fontSize:13}} onClick={()=>{
              let cid="";
              try{const s=JSON.parse(localStorage.getItem("wb:session")||"{}");cid=s.companyId||"";}catch{}
              const url=`${window.location.origin}/?wc=${cid}:${event.id}`;
              if(navigator.share){navigator.share({title:"World Cup 2026 Leaderboard",text:"Check out our World Cup 2026 picks leaderboard!",url}).catch(()=>{});}
              else{navigator.clipboard.writeText(url).then(()=>alert("Public leaderboard link copied!\n\n"+url)).catch(()=>prompt("Copy this link:",url));}
            }}>📋 Copy public link</button>
          </div>

          {/* Admin: Add Guest Entry */}
          {isAdm&&<div style={{...S.card,padding:14,marginBottom:12}}>
            <div style={{fontSize:12,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:10}}>👤 Add Guest Entry</div>
            <div style={{fontSize:12,color:"var(--text-2)",marginBottom:10,lineHeight:1.5}}>Add picks for someone who sent them manually but isn't on WorkBro.</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
              <input id="guest-name-input" placeholder="Guest name (e.g. John Smith)" style={{...S.input,flex:1,minWidth:180,fontSize:12,height:34}} onKeyDown={e=>e.key==="Enter"&&e.currentTarget.blur()}/>
            </div>
            <div style={{fontSize:11,fontWeight:600,color:"var(--text-3)",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.05em"}}>Pick 2 teams per group:</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:8,marginBottom:10}}>
              {WC26_GROUP_LETTERS.map(g=>{
                const groupTeams=WC26_GROUPS[g]?.teams||[];
                return <div key={g} style={{padding:"8px 10px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8}}>
                  <div style={{fontSize:10,fontWeight:700,color:"var(--text-3)",marginBottom:6,textTransform:"uppercase",letterSpacing:"0.06em"}}>Group {g}</div>
                  {groupTeams.map(team=>{
                    const picked=(wcGuestPicks[g]||[]).includes(team);
                    return <label key={team} style={{display:"flex",alignItems:"center",gap:6,padding:"3px 0",cursor:"pointer",fontSize:11}}>
                      <input type="checkbox" checked={picked} onChange={()=>{
                        const cur=wcGuestPicks[g]||[];
                        if(picked){setWcGuestPicks(p=>({...p,[g]:cur.filter(t=>t!==team)}));}
                        else if(cur.length>=2){alert("Only 2 per group. Remove one first.");}
                        else{setWcGuestPicks(p=>({...p,[g]:[...cur,team]}));}
                      }} style={{accentColor:"var(--a-500)"}}/>
                      <FlagImg team={team} size={12}/>
                      <span style={{color:picked?"var(--text)":"var(--text-2)",fontWeight:picked?600:400}}>{team}</span>
                    </label>;
                  })}
                  <div style={{fontSize:9,color:(wcGuestPicks[g]||[]).length===2?"var(--green-600)":"var(--text-4)",marginTop:4}}>
                    {(wcGuestPicks[g]||[]).length}/2 picked
                  </div>
                </div>;
              })}
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <button style={{...S.btn,padding:"0 16px",height:34,fontSize:12}} onClick={()=>{
                const nameEl=document.getElementById("guest-name-input");
                const name=(nameEl?.value||"").trim();
                if(!name){alert("Please enter the guest's name.");return;}
                const totalPicked=WC26_GROUP_LETTERS.reduce((s,g)=>s+(wcGuestPicks[g]||[]).length,0);
                if(totalPicked<1){alert("Please pick at least some teams before saving.");return;}
                const guestId="guest_"+name.toLowerCase().replace(/[^a-z0-9]/g,"_")+"_"+Date.now();
                onUpdate(event.id,{
                  wcPicks:{...wcPicks,[guestId]:wcGuestPicks},
                  wcGuestNames:{...(event.wcGuestNames||{}),[guestId]:name}
                });
                if(nameEl)nameEl.value="";
                setWcGuestPicks({});
                alert(`✅ Added ${name}'s picks to the leaderboard!`);
              }}>+ Add to Leaderboard</button>
              <button style={{...S.btnO,padding:"0 12px",height:34,fontSize:12}} onClick={()=>setWcGuestPicks({})}>Clear picks</button>
              <span style={{fontSize:11,color:"var(--text-3)"}}>{WC26_GROUP_LETTERS.reduce((s,g)=>s+(wcGuestPicks[g]||[]).length,0)}/24 teams picked</span>
            </div>
          </div>}

          {/* Leaderboard table */}
          <div style={{...S.card,padding:0}}>
          {wcLeaderboard.length===0?<div style={{padding:40,textAlign:"center",color:C.textDim,fontSize:13,fontStyle:"italic"}}>No picks yet — be the first!</div>:
          wcLeaderboard.map((entry,idx)=>{
            const u=entry.user;const medal=idx===0?"🥇":idx===1?"🥈":idx===2?"🥉":"#"+(idx+1);
            const isMe=entry.userId===currentUser.id;const userPicks=wcPicks[entry.userId]||{};
            const isComplete=WC26_GROUP_LETTERS.filter(g=>(userPicks[g]||[]).length===2).length===12;
            const isExpanded=wcExpandedUser===entry.userId;
            return <div key={entry.userId} style={{borderBottom:idx<wcLeaderboard.length-1?"1px solid "+C.border:"none",background:isMe?C.accentSoft:"transparent"}}>
              <div onClick={()=>isComplete&&setWcExpandedUser(isExpanded?null:entry.userId)} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 16px",cursor:isComplete?"pointer":"default"}}>
                <div style={{minWidth:36,textAlign:"center",fontSize:idx<3?22:13,fontWeight:700,color:idx<3?C.amber:C.textDim}}>{medal}</div>
                <div style={{...S.avatar,width:32,height:32,fontSize:11,background:entry.isGuest?"var(--n-200)":(u?.profilePhoto?"transparent":(u?.profileColor||C.grad2))}}>
                  {entry.isGuest?"👤":(u?.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(u?.avatar||"?"))}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:14,fontWeight:600}}>
                    {entry.isGuest?entry.guestName:(u?.name||"Unknown")}
                    {isMe&&<span style={{color:C.accent,fontSize:10,marginLeft:6,fontWeight:700}}>(you)</span>}
                    {entry.isGuest&&<span style={{fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:999,background:"var(--n-100)",color:"var(--text-3)",marginLeft:6,textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}
                  </div>
                  <div style={{fontSize:11,color:C.textDim}}>{entry.totalPicks}/24 picked{isComplete?" · ✅ Complete":""}{isComplete?" · "+(isExpanded?"▾ hide":"▸ show picks"):""}</div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  {isAdm&&entry.isGuest&&<button onClick={e=>{e.stopPropagation();if(confirm(`Remove ${entry.guestName}'s entry? This deletes their group and R32 picks.`)){const newPicks={...wcPicks};delete newPicks[entry.userId];const newR32={...(event.wcR32Picks||{})};delete newR32[entry.userId];const newNames={...(event.wcGuestNames||{})};delete newNames[entry.userId];onUpdate(event.id,{wcPicks:newPicks,wcR32Picks:newR32,wcGuestNames:newNames});}}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red-500)",fontSize:12,padding:"2px 6px",fontFamily:"var(--font-sans)"}} title="Remove guest">✕</button>}
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:22,fontWeight:700,color:C.green,fontVariantNumeric:"tabular-nums"}}>{entry.points}</div>
                    <div style={{fontSize:10,color:C.textDim,fontWeight:600,letterSpacing:1}}>PTS</div>
                  </div>
                </div>
              </div>
              {isExpanded&&isComplete&&<div style={{padding:"12px 16px 16px",background:C.bg,borderTop:"1px solid "+C.border}}>
                <div style={{fontSize:10,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>{entry.isGuest?entry.guestName:u?.name+"'s picks"}</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:8}}>
                  {WC26_GROUP_LETTERS.map(g=>{
                    const groupPicks=userPicks[g]||[];
                    return <div key={g} style={{...S.card,padding:"8px 10px"}}>
                      <div style={{fontSize:10,fontWeight:700,color:C.textMid,marginBottom:6,letterSpacing:1}}>GROUP {g}</div>
                      {groupPicks.map(team=>{
                        const reached=wcReachedRound(team,event);const eliminated=reached==="group";const advanced=WC26_ROUNDS.indexOf(reached)>=1;
                        return <div key={team} style={{display:"flex",alignItems:"center",gap:6,padding:"3px 0",fontSize:11,opacity:eliminated?0.55:1,textDecoration:eliminated?"line-through":"none"}}>
                          <FlagImg team={team} size={14}/>
                          <span style={{flex:1,fontWeight:advanced?700:500,color:advanced?C.green:C.text}}>{team}</span>
                          {advanced&&<Badge bg={C.greenSoft} fg={C.green}>{WC26_ROUND_LABELS[reached]||reached}</Badge>}
                          {eliminated&&<Badge bg={C.redSoft} fg={C.red}>OUT</Badge>}
                        </div>;
                      })}
                    </div>;
                  })}
                </div>
              </div>}
            </div>;
          })}
          </div>
        </div>}
        {/* KNOCKOUT PREDICTION TABS (R32, R16) */}
        {wcTab==="r32"&&renderKO(WC26_KO_ROUNDS[0])}
        {wcTab==="r16"&&renderKO(WC26_KO_ROUNDS[1])}
        {wcTab==="qf"&&renderKO(WC26_KO_ROUNDS[2])}
        {wcTab==="sf"&&renderKO(WC26_KO_ROUNDS[3])}

        {wcTab==="podium"&&(()=>{
          const pod=wcPodium(event);if(!pod)return null;
          const steps=[
            {place:2,team:pod.runnerUp,medal:"🥈",label:"Runner-up",h:96,bg:"linear-gradient(180deg,#c0c7d0,#9aa3ae)"},
            {place:1,team:pod.champion,medal:"🥇",label:"Champion",h:130,bg:"linear-gradient(180deg,#f7d774,#e0b43a)"},
            {place:3,team:pod.third,medal:"🥉",label:"Third place",h:72,bg:"linear-gradient(180deg,#d69a68,#b97840)"},
          ];
          const ids=wcEntrantIds(event).map(uid=>({uid,name:wcEntrantName(event,users,uid),pts:computeWCPoints(event,uid)})).sort((a,b)=>b.pts-a.pts);
          const top=ids.slice(0,3);const medals=["🥇","🥈","🥉"];
          return <div>
            {/* Tournament podium */}
            <div style={{...S.card,padding:"22px 18px 18px",marginBottom:16}}>
              <div style={{textAlign:"center",fontSize:11,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:"var(--text-3)",marginBottom:18}}>FIFA World Cup 2026 · Final Standings</div>
              <div style={{display:"flex",justifyContent:"center",alignItems:"flex-end",gap:14,flexWrap:"wrap"}}>
                {steps.map(s=>s.team&&<div key={s.place} style={{display:"flex",flexDirection:"column",alignItems:"center",width:132,maxWidth:"31%"}}>
                  <div style={{fontSize:s.place===1?34:26,marginBottom:4}}>{s.medal}</div>
                  <FlagImg team={s.team} size={s.place===1?40:32}/>
                  <div style={{fontSize:s.place===1?16:14,fontWeight:800,letterSpacing:"-0.02em",marginTop:6,textAlign:"center"}}>{s.team}</div>
                  <div style={{fontSize:11,color:"var(--text-3)",marginBottom:8}}>{s.label}</div>
                  <div style={{width:"100%",height:s.h,borderRadius:"8px 8px 0 0",background:s.bg,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:8,color:"rgba(0,0,0,.55)",fontWeight:800,fontSize:22}}>{s.place}</div>
                </div>)}
              </div>
            </div>
            {/* Pool winners */}
            <div style={{...S.card,padding:16}}>
              <div style={{fontSize:13,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:12}}>🏅 Prediction Pool — Winners</div>
              {top.map((e,i)=><div key={e.uid} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 12px",borderRadius:10,marginBottom:8,background:i===0?"linear-gradient(135deg,color-mix(in srgb,var(--a-500) 14%,var(--surface)),var(--surface))":"var(--surface-2)",border:"1px solid "+(i===0?"color-mix(in srgb,var(--a-500) 32%,var(--border))":"var(--border)")}}>
                <div style={{fontSize:24,width:32,textAlign:"center"}}>{medals[i]}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:15,fontWeight:700}}>{e.name}</div>
                  <div style={{fontSize:11,color:"var(--text-3)"}}>{i===0?"Pool champion":i===1?"Runner-up":"Third place"}</div>
                </div>
                <div style={{fontSize:22,fontWeight:800,color:i===0?"var(--a-600,var(--a-500))":"var(--text)",fontVariantNumeric:"tabular-nums"}}>{e.pts}<span style={{fontSize:12,color:"var(--text-3)",fontWeight:600}}> pts</span></div>
              </div>)}
              <div style={{fontSize:11,color:"var(--text-3)",marginTop:6,textAlign:"center"}}>Full standings on the Leaderboard tab.</div>
            </div>
          </div>;
        })()}
        {wcTab==="final"&&renderKO(WC26_KO_ROUNDS[4])}
      </div>;
    })()}

    {/* Leaderboard — full detailed view (hidden for World Cup events; they have their own leaderboard) */}
    {event.type!=="worldcup2026"&&<div>
      <div style={{fontSize:12,fontWeight:700,textTransform:"uppercase",color:C.textMid,letterSpacing:1,marginBottom:10,display:"flex",justifyContent:"space-between"}}>
        <span>🏆 Leaderboard</span>
        {isAdm&&<span style={{fontWeight:400,textTransform:"none",letterSpacing:0,fontSize:11,color:C.textDim}}>Click any row to award points</span>}
      </div>
      {lb.length===0&&<div style={{padding:"30px 12px",textAlign:"center",color:C.textDim,fontSize:13,fontStyle:"italic",background:C.card,borderRadius:10}}>No participants yet. {isAdm?"Add someone above or have people click 'Join'.":"Be the first to join!"}</div>}
      {lb.map((entry,idx)=>{
        const participant=users.find(u=>u.id===entry.userId);
        const isExpanded=quickAwardFor===entry.userId;
        const medal=idx===0?"🥇":idx===1?"🥈":idx===2?"🥉":`#${idx+1}`;
        const isTop3=idx<3;
        const medalColor=idx===0?"#FFC107":idx===1?"#94A3B8":idx===2?"#B87333":C.textMid;
        const medalBg=idx===0?"rgba(255,193,7,.08)":idx===1?"rgba(148,163,184,.08)":idx===2?"rgba(184,115,51,.08)":"transparent";
        return <div key={entry.userId} style={{marginBottom:6,borderRadius:10,overflow:"hidden",border:`1px solid ${isTop3?medalColor+"40":C.border}`,background:medalBg}}>
          <div onClick={()=>isAdm&&setQuickAwardFor(isExpanded?null:entry.userId)} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",cursor:isAdm?"pointer":"default"}}>
            <span style={{fontSize:isTop3?22:13,fontWeight:700,color:medalColor,width:32,textAlign:"center"}}>{medal}</span>
            <div style={{...S.avatar,width:32,height:32,fontSize:11,background:participant?.profileColor||C.grad2}}>{participant?.profilePhoto?<img src={participant.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(participant?.avatar||'?')}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:14,fontWeight:700}}>{participant?.name||"Unknown"}{entry.userId===currentUser.id&&<span style={{color:C.accent,marginLeft:6,fontSize:11,fontWeight:600}}>(you)</span>}</div>
              {entry.note&&<div style={{fontSize:11,color:C.textDim,fontStyle:"italic",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={entry.note}>💬 {entry.note}</div>}
            </div>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:isTop3?24:20,fontWeight:800,color:medalColor,minWidth:50,textAlign:"right"}}>{entry.points||0}</div>
            {isAdm&&<span style={{color:C.textDim,fontSize:14,transform:isExpanded?"rotate(90deg)":"none",transition:"transform .15s"}}>›</span>}
          </div>
          {/* Admin inline award form */}
          {isExpanded&&isAdm&&<div style={{padding:"12px 14px",borderTop:`1px solid ${C.border}`,background:C.card}}>
            <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:8}}>
              <label style={{fontSize:11,color:C.textDim,fontWeight:600}}>Award:</label>
              <input type="number" style={{...S.input,width:80,padding:"6px 10px",fontSize:13}} value={quickPoints} onChange={e=>setQuickPoints(e.target.value)}/>
              <span style={{fontSize:11,color:C.textDim}}>points</span>
              <input style={{...S.input,flex:1,minWidth:140,padding:"6px 10px",fontSize:13}} value={quickNote} onChange={e=>setQuickNote(e.target.value)} placeholder="Reason (optional)"/>
              <button style={{...S.btnSm,padding:"6px 14px",fontSize:11}} onClick={()=>handleQuickAward(entry.userId)}>✓ Apply</button>
            </div>
            <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
              <span style={{fontSize:10,color:C.textDim,alignSelf:"center",marginRight:4}}>Quick:</span>
              {[1,3,5,10,-1,-5].map(v=><button key={v} style={{...S.btnO,padding:"3px 9px",fontSize:10,color:v<0?C.red:C.accent,borderColor:v<0?C.red:C.accent}} onClick={()=>setQuickPoints(v)}>{v>0?`+${v}`:v}</button>)}
              <div style={{flex:1}}/>
              <button style={{...S.btnO,padding:"3px 9px",fontSize:10,color:C.amber,borderColor:C.amber}} onClick={()=>onResetUserPoints(event.id,entry.userId)}>↻ Reset to 0</button>
              <button style={{...S.btnO,padding:"3px 9px",fontSize:10,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm(`Remove ${participant?.name||"this user"} from the event?`))onRemoveParticipant(event.id,entry.userId)}}>✗ Remove</button>
            </div>
          </div>}
        </div>;
      })}
    </div>}
  </Modal>;
}

function TeamMeetingView({user,users,projects,onUpdateFocus,onUpdateFocusHours,meetingNotes,setMeetingNotes,teams,onAddDeadline,onUpdateProject,onOpenProject,assignments,setAssignments,vacations,setVacations,addNotification,onUpdateDeadline,onDeleteDeadline,actionItems,toggleAction,events,setEvents,timesheets}){
  const allStaff=users.filter(u=>isStaff(u)&&u.status!=="pending");
  const teamNames=["All Teams",...new Set(allStaff.filter(u=>u.teamName).map(u=>u.teamName))];
  const [teamFilter,setTeamFilter]=useState("All Teams");
  const staffUsers=teamFilter==="All Teams"?allStaff:allStaff.filter(u=>u.teamName===teamFilter);
  const [selected,setSelected]=useState(null);
  const [slideProject,setSlideProject]=useState(null);
  const [noteWeekOffset,setNoteWeekOffset]=useState(0);
  const [showNotes,setShowNotes]=useState(true);
  const [showCalendar,setShowCalendar]=useState(false);
  const [showActionsTab,setShowActionsTab]=useState(false);
  const [dayEditor,setDayEditor]=useState(null); // {date, deadlines, customEvents}
  const [calViewOffset,setCalViewOffset]=useState(0);

  const slideProj=projects.find(p=>p.id===slideProject);

  const [myTeamTab,setMyTeamTab]=useState("meeting"); // meeting | projects | others
  const [vacMonthOffset,setVacMonthOffset]=useState(0);
  const [creatingEvent,setCreatingEvent]=useState(false);
  const [pointAwardCtx,setPointAwardCtx]=useState(null);
  const [openEventId,setOpenEventId]=useState(null);
  const [financialPeriod,setFinancialPeriod]=useState("month");
  const [otherTeamView,setOtherTeamView]=useState(null); // viewing another team's profile

  // Determine user's team
  const myTeamName=user.teamName||"";
  // Other teams (not mine)
  const otherTeams=(teams||[]).filter(t=>t.name!==myTeamName);

  // Stats for eyebrow
  const memberCount=staffUsers.length;
  const teamCount=new Set(staffUsers.map(u=>u.teamName).filter(Boolean)).size;
  const activeProjCount=projects.filter(p=>p.status!=="Archived"&&p.status!=="Completed"&&(p.team||[]).some(uid=>staffUsers.find(u=>u.id===uid))).length;

  return <div style={{position:"relative"}}>
    {/* ── PAGE HEAD ───────────────────────────────────────────── */}
    <div style={{padding:"24px 32px 0"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:16,marginBottom:18,paddingBottom:18,borderBottom:"1px solid var(--border)",flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6}}>{memberCount} member{memberCount!==1?"s":""} · {teamCount||1} team{teamCount!==1?"s":""} · {activeProjCount} active project{activeProjCount!==1?"s":""}</div>
          <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>{teamFilter==="All Teams"?(myTeamName||"My Team"):teamFilter}</h1>
          <p style={{color:"var(--text-2)",fontSize:13,margin:0}}>Team profile, projects, and meeting agenda in one place.</p>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {teamNames.length>2&&<select style={{...S.select,width:"auto",minWidth:160,height:32,padding:"0 12px",fontSize:13}} value={teamFilter} onChange={e=>setTeamFilter(e.target.value)}>
            {teamNames.map(t=><option key={t}>{t}</option>)}
          </select>}
        </div>
      </div>

      {/* ── TABS ─────────────────────────────────────────────── */}
      <div style={{display:"flex",gap:0,marginBottom:0,borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none"}}>
        {[
          ["meeting","Team Meeting",null],
          ["projects","Team Projects",null],
          ["assign","Assign Work",null],
          ["vacation","Vacation",null],
          ["events","Events",(events||[]).length||null],
          ...(otherTeams.length>0?[["others","Other Teams",otherTeams.length]]:[]),
        ].map(([k,l,badge])=>{
          const active=myTeamTab===k;
          return <button key={k} onClick={()=>{setMyTeamTab(k);setOtherTeamView(null)}} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:active?600:500,color:active?"var(--text)":"var(--text-3)",borderBottom:active?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",transition:"color .12s, border-color .12s",whiteSpace:"nowrap",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
            {l}
            {badge&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{badge}</span>}
          </button>;
        })}
      </div>
    </div>

    {/* ── PAGE BODY ───────────────────────────────────────────── */}
    <div style={{padding:"24px 32px 60px"}}>

    {/* ASSIGN WORK TAB */}
    {myTeamTab==="assign"&&(()=>{
      const myAssignments=(assignments||[]).filter(a=>a.assignedBy===user.id).sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));
      const receivedAssignments=(assignments||[]).filter(a=>a.assignedTo===user.id&&!a.done).sort((a,b)=>new Date(a.dueDate||"9999")-new Date(b.dueDate||"9999"));
      return <div>
        <div style={S.banner(C.accentSoft,C.accent)}>📨 Assign work to teammates — small tasks, follow-ups, or action items. Recipients see these in "My Assigned" on their dashboard.</div>

        {/* Assignment composer */}
        <div style={{...S.card,padding:18,marginBottom:20}}>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:700,marginBottom:12}}>+ Create New Assignment</div>
          <AssignWorkForm users={users} projects={projects} currentUser={user} onAssign={(task)=>{
            setAssignments(prev=>[...prev,task]);
            if(addNotification&&task.assignedTo&&task.assignedTo!==user.id){
              const proj=projects.find(p=>p.id===task.projectId);
              addNotification(task.assignedTo,"assignment",
                `📨 ${user.name} assigned you a task`,
                `"${task.title}"${proj?` on ${proj.name}`:""}${task.dueDate?` · due ${new Date(task.dueDate).toLocaleDateString("en-US",{month:"short",day:"numeric"})}`:""}`,
                task.projectId?`p:${task.projectId}`:null);
            }
          }}/>
        </div>

        {/* My received assignments */}
        {receivedAssignments.length>0&&<div style={{...S.card,marginBottom:20}}>
          <div style={S.cardH}><span style={S.cardT}>📥 Assigned to Me ({receivedAssignments.length})</span></div>
          <div style={S.cardB}>
            {receivedAssignments.map(a=>{const from=users.find(u=>u.id===a.assignedBy);const proj=projects.find(p=>p.id===a.projectId);const overdue=a.dueDate&&new Date(a.dueDate)<new Date(new Date().toDateString());return <div key={a.id} style={{padding:"12px 14px",borderRadius:10,border:`1px solid ${C.border}`,marginBottom:8,borderLeft:`4px solid ${a.priority==="High"?C.red:a.priority==="Low"?C.accent:C.amber}`}}>
              <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                <input type="checkbox" checked={a.done} onChange={()=>setAssignments(prev=>prev.map(x=>x.id===a.id?{...x,done:!x.done}:x))} style={{accentColor:C.accent,width:18,height:18,marginTop:2}}/>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:13,marginBottom:3}}>{a.title}</div>
                  {a.description&&<div style={{fontSize:12,color:C.textMid,marginBottom:4,whiteSpace:"pre-wrap"}}>{a.description}</div>}
                  <div style={{fontSize:11,color:C.textDim,display:"flex",gap:8,flexWrap:"wrap"}}>
                    <span>From: <strong>{from?.name||"?"}</strong></span>
                    {proj&&<span>· Project: <strong>{proj.name}</strong></span>}
                    {a.dueDate&&<span style={{color:overdue?C.red:C.textDim,fontWeight:overdue?700:400}}>· Due: {overdue?"⚠ ":""}{a.dueDate}</span>}
                    <Badge bg={a.priority==="High"?C.redSoft:a.priority==="Low"?C.accentSoft:C.amberSoft} fg={a.priority==="High"?C.red:a.priority==="Low"?C.accent:C.amber}>{a.priority}</Badge>
                  </div>
                </div>
              </div>
            </div>})}
          </div>
        </div>}

        {/* Assignments I created */}
        <div style={S.card}>
          <div style={S.cardH}><span style={S.cardT}>📤 Assignments I Created ({myAssignments.length})</span></div>
          <div style={S.cardB}>
            {myAssignments.length===0&&<div style={{textAlign:"center",padding:20,color:C.textDim,fontSize:13}}>No assignments yet. Use the form above to create one.</div>}
            {myAssignments.map(a=>{const to=users.find(u=>u.id===a.assignedTo);const proj=projects.find(p=>p.id===a.projectId);return <div key={a.id} style={{padding:"10px 14px",borderRadius:10,border:`1px solid ${C.border}`,marginBottom:8,display:"flex",alignItems:"center",gap:10,opacity:a.done?.6:1}}>
              <div style={{width:4,height:28,background:a.priority==="High"?C.red:a.priority==="Low"?C.accent:C.amber,borderRadius:2}}/>
              <div style={{flex:1}}>
                <div style={{fontWeight:600,fontSize:13,textDecoration:a.done?"line-through":"none"}}>{a.title}</div>
                <div style={{fontSize:11,color:C.textDim,display:"flex",gap:8,flexWrap:"wrap"}}>
                  <span>To: <strong>{to?.name||"?"}</strong></span>
                  {proj&&<span>· {proj.name}</span>}
                  {a.dueDate&&<span>· Due {a.dueDate}</span>}
                  <Badge bg={a.done?C.greenSoft:C.amberSoft} fg={a.done?C.green:C.amber}>{a.done?"Done":"Pending"}</Badge>
                </div>
              </div>
              <button style={{...S.btnO,padding:"4px 10px",fontSize:11,color:C.red,borderColor:C.red}} onClick={()=>setAssignments(prev=>prev.filter(x=>x.id!==a.id))}>Delete</button>
            </div>})}
          </div>
        </div>
      </div>;
    })()}

    {/* VACATION TAB */}
    {myTeamTab==="vacation"&&(()=>{
      const today=new Date();today.setHours(0,0,0,0);
      const upcoming=(vacations||[]).filter(v=>new Date(v.endDate)>=today).sort((a,b)=>new Date(a.startDate)-new Date(b.startDate));
      const past=(vacations||[]).filter(v=>new Date(v.endDate)<today).sort((a,b)=>new Date(b.startDate)-new Date(a.startDate));
      const myVacations=upcoming.filter(v=>v.userId===user.id);
      // Per-user stable colors — sort all team user IDs for stability
      const VAC_COLORS=["#8b5cf6","#ec4899","#f59e0b","#10b981","#3b82f6","#f97316","#06b6d4","#e11d48","#84cc16","#6366f1"];
      const allVacUserIds=[...new Set(allStaff.map(u=>u.id))].sort();
      const colorForUser=(uid)=>VAC_COLORS[allVacUserIds.indexOf(uid)%VAC_COLORS.length]||"#8b5cf6";
      return <div>
        <div style={S.banner(C.purpleSoft,C.purple)}>🌴 Book your vacation time and see when teammates are away. All team vacations are visible to plan ahead.</div>

        {/* Book vacation */}
        <div style={{...S.card,padding:18,marginBottom:20}}>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:700,marginBottom:12}}>📅 Book Vacation</div>
          <BookVacationForm currentUser={user} onBook={(v)=>setVacations(prev=>[...prev,v])}/>
        </div>

        <div style={S.g2}>
          {/* Upcoming vacations */}
          <div style={S.card}>
            <div style={S.cardH}><span style={S.cardT}>🌴 Upcoming Vacations ({upcoming.length})</span></div>
            <div style={S.cardB}>
              {upcoming.length===0&&<div style={{textAlign:"center",padding:20,color:C.textDim,fontSize:13}}>No upcoming vacations booked.</div>}
              {upcoming.map(v=>{const u=users.find(x=>x.id===v.userId);const daysAway=Math.ceil((new Date(v.startDate)-today)/(1000*60*60*24));const days=Math.ceil((new Date(v.endDate)-new Date(v.startDate))/(1000*60*60*24))+1;const isOngoing=new Date(v.startDate)<=today;const userColor=colorForUser(v.userId);return <div key={v.id} style={{padding:"12px 14px",borderRadius:10,border:`1px solid ${C.border}`,marginBottom:8,display:"flex",alignItems:"center",gap:12,borderLeft:`4px solid ${userColor}`}}>
                <div style={{...S.avatar,background:u?.profilePhoto?"transparent":userColor,color:"#fff"}}>{u?.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(u?.avatar||'?')}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:13}}>{u?.name||"Unknown"}</div>
                  <div style={{fontSize:11,color:C.textDim}}>{v.startDate} → {v.endDate} ({days} day{days!==1?"s":""}){v.reason?` · ${v.reason}`:""}</div>
                </div>
                <Badge bg={isOngoing?C.greenSoft:C.purpleSoft} fg={isOngoing?C.green:C.purple}>{isOngoing?"On vacation":`in ${daysAway}d`}</Badge>
                {v.userId===user.id&&<button style={{...S.btnO,padding:"4px 8px",fontSize:10,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm("Cancel this vacation?"))setVacations(prev=>prev.filter(x=>x.id!==v.id))}}>✕</button>}
              </div>})}
            </div>
          </div>

          {/* Vacation calendar */}
          <div style={S.card}>
            <div style={{...S.cardH,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={S.cardT}>📅 Vacation Calendar</span>
              <div style={{display:"flex",gap:4,alignItems:"center"}}>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setVacMonthOffset(o=>o-1)}>← Prev</button>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setVacMonthOffset(o=>o+1)}>Next →</button>
                {vacMonthOffset!==0&&<button style={{...S.btnO,padding:"4px 10px",fontSize:11,color:C.accent,borderColor:C.accent}} onClick={()=>setVacMonthOffset(0)}>Today</button>}
              </div>
            </div>
            <div style={S.cardB}>
              {(()=>{
                // Use shared colorForUser from outer scope
                const monthStart=new Date(today.getFullYear(),today.getMonth()+vacMonthOffset,1);
                const monthEnd=new Date(today.getFullYear(),today.getMonth()+vacMonthOffset+1,0);
                const firstDay=monthStart.getDay();
                const daysInMonth=monthEnd.getDate();
                const cells=[];
                for(let i=0;i<firstDay;i++)cells.push(null);
                for(let d=1;d<=daysInMonth;d++)cells.push(d);
                const dayVacs=(day)=>{if(!day)return [];const ds=`${monthStart.getFullYear()}-${String(monthStart.getMonth()+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;return vacations.filter(v=>ds>=v.startDate&&ds<=v.endDate)};
                const isCurrentMonth=vacMonthOffset===0;
                // Legend: only users who appear in vacations this month
                const monthVacUids=[...new Set(vacations.filter(v=>{const s=monthStart.toISOString().split("T")[0];const e=monthEnd.toISOString().split("T")[0];return v.startDate<=e&&v.endDate>=s;}).map(v=>v.userId))];
                const legendUsers=monthVacUids.map(uid=>({uid,user:users.find(u=>u.id===uid),color:colorForUser(uid)})).filter(x=>x.user);

                return <><div style={{fontSize:12,fontWeight:600,color:C.textMid,textAlign:"center",marginBottom:8}}>{monthStart.toLocaleDateString("en-US",{month:"long",year:"numeric"})}</div>
                {legendUsers.length>0&&<div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:10}}>
                  {legendUsers.map(({uid,user:u,color})=><div key={uid} style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:"var(--text-2)"}}>
                    <div style={{width:10,height:10,borderRadius:"50%",background:color,flexShrink:0}}/>
                    {u.name.split(" ")[0]}
                  </div>)}
                </div>}
                <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:2}}>
                  {["S","M","T","W","T","F","S"].map((d,i)=><div key={i} style={{textAlign:"center",fontSize:10,color:C.textDim,fontWeight:600,padding:2}}>{d}</div>)}
                  {cells.map((day,i)=>{
                    if(day===null)return <div key={i}/>;
                    const vacs=dayVacs(day);
                    const isToday=isCurrentMonth&&day===today.getDate();
                    // For multi-person days, split cell into colored strips
                    const bgColor=vacs.length===1?colorForUser(vacs[0].userId):vacs.length>1?`linear-gradient(135deg, ${colorForUser(vacs[0].userId)} 50%, ${colorForUser(vacs[1].userId)} 50%)`:(isToday?"var(--a-50)":"transparent");
                    return <div key={i} title={vacs.map(v=>users.find(u=>u.id===v.userId)?.name).join(", ")} style={{aspectRatio:"1",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,borderRadius:4,background:bgColor,color:vacs.length>0?"#fff":(isToday?"var(--a-600)":"var(--text)"),fontWeight:vacs.length>0||isToday?700:400,border:isToday&&vacs.length===0?"1px solid var(--a-300)":"none",cursor:vacs.length>0?"help":"default"}}>{day}</div>;
                  })}
                </div></>;
              })()}
            </div>
          </div>
        </div>

        {past.length>0&&<div style={{...S.card,marginTop:16}}>
          <div style={S.cardH}><span style={S.cardT}>📚 Past Vacations ({past.length})</span></div>
          <div style={S.cardB}>
            {past.slice(0,10).map(v=>{const u=users.find(x=>x.id===v.userId);return <div key={v.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",fontSize:12,color:C.textDim,borderBottom:`1px solid ${C.card}`}}>
              <div style={{...S.avatar,width:24,height:24,fontSize:9,background:u?.profileColor||C.grad2}}>{u?.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(u?.avatar||'?')}</div>
              <span>{u?.name||"?"}</span>
              <span style={{flex:1}}>{v.startDate} → {v.endDate}</span>
              {v.reason&&<span style={{fontStyle:"italic"}}>{v.reason}</span>}
            </div>})}
          </div>
        </div>}
      </div>;
    })()}

    {/* EVENTS TAB */}
    {myTeamTab==="events"&&(()=>{
      const isAdm=isAdmin(user);
      const activeEvents=(events||[]).filter(ev=>!ev.archived).sort((a,b)=>new Date(b.date||b.createdAt)-new Date(a.date||a.createdAt));
      const archivedEvents=(events||[]).filter(ev=>ev.archived);

      const createEvent=(title,description,date,type)=>{
        const newEv={id:genId("ev"),title,description,date,type:type||"general",createdBy:user.id,createdAt:new Date().toISOString(),leaderboard:[]};
        setEvents([...(events||[]),newEv]);
      };
      const deleteEvent=(evId)=>{
        if(!confirm("Delete this event? All leaderboard data will be lost."))return;
        setEvents((events||[]).filter(ev=>ev.id!==evId));
      };
      const archiveEvent=(evId)=>{
        setEvents((events||[]).map(ev=>ev.id===evId?{...ev,archived:!ev.archived}:ev));
      };
      const joinEvent=(evId)=>{
        setEvents((events||[]).map(ev=>{
          if(ev.id!==evId)return ev;
          if((ev.leaderboard||[]).find(e=>e.userId===user.id))return ev;
          return{...ev,leaderboard:[...(ev.leaderboard||[]),{userId:user.id,points:0,note:"",addedAt:new Date().toISOString()}]};
        }));
      };
      const leaveEvent=(evId)=>{
        if(!confirm("Leave this event? Your points will be removed."))return;
        setEvents((events||[]).map(ev=>ev.id!==evId?ev:{...ev,leaderboard:(ev.leaderboard||[]).filter(e=>e.userId!==user.id)}));
      };
      const addPoints=(evId,userId,points,note)=>{
        setEvents((events||[]).map(ev=>{
          if(ev.id!==evId)return ev;
          const entry=(ev.leaderboard||[]).find(e=>e.userId===userId);
          if(entry){
            return{...ev,leaderboard:ev.leaderboard.map(e=>e.userId===userId?{...e,points:(e.points||0)+points,note:note||e.note,addedAt:new Date().toISOString()}:e)};
          }else{
            return{...ev,leaderboard:[...(ev.leaderboard||[]),{userId,points,note:note||"",addedAt:new Date().toISOString()}]};
          }
        }));
      };
      const resetUserPoints=(evId,userId)=>{
        if(!confirm("Reset this participant's points to 0?"))return;
        setEvents((events||[]).map(ev=>ev.id!==evId?ev:{...ev,leaderboard:(ev.leaderboard||[]).map(e=>e.userId===userId?{...e,points:0}:e)}));
      };

      return <div>
        {/* Header + create button */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:20,fontWeight:700,marginBottom:2}}>🎉 Company Events</div>
            <div style={{fontSize:13,color:C.textMid}}>Create friendly competitions and events — World Cup predictions, step challenges, book clubs, trivia, whatever!</div>
          </div>
          {isAdm&&<button style={S.btn} onClick={()=>setCreatingEvent(true)}>+ Create Event</button>}
        </div>

        {/* Create event modal */}
        {creatingEvent&&<CreateEventModal onClose={()=>setCreatingEvent(false)} onCreate={(data)=>{createEvent(data.title,data.description,data.date,data.type);setCreatingEvent(false)}}/>}

        {/* Point award modal */}
        {pointAwardCtx&&<PointAwardModal ctx={pointAwardCtx} users={users} onClose={()=>setPointAwardCtx(null)} onAward={(userId,points,note)=>{addPoints(pointAwardCtx.evId,userId,points,note);setPointAwardCtx(null)}}/>}

        {/* Event detail modal */}
        {openEventId&&(()=>{
          const ev=(events||[]).find(e=>e.id===openEventId);
          if(!ev)return null;
          return <EventDetailModal
            event={ev}
            users={users}
            currentUser={user}
            onClose={()=>setOpenEventId(null)}
            onUpdate={(id,updates)=>setEvents((events||[]).map(e=>e.id===id?{...e,...updates}:e))}
            onAwardPoints={addPoints}
            onResetUserPoints={resetUserPoints}
            onRemoveParticipant={(evId,userId)=>setEvents((events||[]).map(e=>e.id!==evId?e:{...e,leaderboard:(e.leaderboard||[]).filter(x=>x.userId!==userId)}))}
            onDelete={(id)=>{deleteEvent(id);setOpenEventId(null)}}
            onArchive={(id)=>{archiveEvent(id);setOpenEventId(null)}}
          />;
        })()}

        {/* Events list */}
        {activeEvents.length===0&&<div style={{...S.card,padding:40,textAlign:"center"}}>
          <div style={{fontSize:36,marginBottom:12}}>🎊</div>
          <div style={{fontFamily:"'Inter',sans-serif",fontWeight:700,fontSize:16,marginBottom:6}}>No active events yet</div>
          <div style={{color:C.textMid,fontSize:13}}>{isAdm?"Click '+ Create Event' to get started.":"Ask an admin to create a company event!"}</div>
        </div>}

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(380px,1fr))",gap:16}}>
          {activeEvents.map(ev=>{
            const lb=ev.type==="worldcup2026"
              ? wcEntrantIds(ev).map(uid=>({userId:uid,points:computeWCPoints(ev,uid),isGuest:uid.startsWith("guest_"),name:wcEntrantName(ev,users,uid)})).sort((a,b)=>(b.points||0)-(a.points||0))
              : [...(ev.leaderboard||[])].sort((a,b)=>(b.points||0)-(a.points||0));
            const joined=lb.find(e=>e.userId===user.id);
            const typeIcon={"worldcup2026":"⚽","sports":"🏟","competition":"🏆","social":"🎊","challenge":"💪","trivia":"🧠","general":"🎉"}[ev.type]||"🎉";
            const typeColor={"worldcup2026":C.green,"sports":C.green,"competition":C.amber,"social":C.purple,"challenge":C.red,"trivia":C.accent,"general":C.accent}[ev.type]||C.accent;
            const topThree=lb.slice(0,3);
            const rest=lb.slice(3);
            const creator=users.find(u=>u.id===ev.createdBy);
            return <div key={ev.id} style={{...S.card,padding:0,overflow:"hidden",borderTop:`3px solid ${typeColor}`,cursor:"pointer",transition:"transform .1s, box-shadow .15s"}} onClick={()=>setOpenEventId(ev.id)} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,.08)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none"}}>
              {/* Event header */}
              <div style={{padding:"16px 18px",borderBottom:`1px solid ${C.border}`,background:C.card}}>
                <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:10}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                      <span style={{fontSize:20}}>{typeIcon}</span>
                      <span style={{fontFamily:"'Inter',sans-serif",fontSize:17,fontWeight:700}}>{ev.title}</span>
                    </div>
                    {ev.description&&<div style={{fontSize:12,color:C.textMid,lineHeight:1.5,marginBottom:6}}>{ev.description}</div>}
                    <div style={{display:"flex",gap:10,alignItems:"center",fontSize:11,color:C.textDim,flexWrap:"wrap"}}>
                      {ev.date&&<span>📅 {new Date(ev.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</span>}
                      {creator&&<span>by {creator.name}</span>}
                      <span>{lb.length} participant{lb.length!==1?"s":""}</span>
                    </div>
                  </div>
                  {isAdm&&<div style={{display:"flex",gap:4,flexShrink:0}}>
                    <button style={{...S.btnO,padding:"4px 8px",fontSize:10}} onClick={(e)=>{e.stopPropagation();archiveEvent(ev.id)}} title="Archive">📦</button>
                    <button style={{...S.btnO,padding:"4px 8px",fontSize:10,color:C.red,borderColor:C.red}} onClick={(e)=>{e.stopPropagation();deleteEvent(ev.id)}} title="Delete">🗑</button>
                  </div>}
                </div>
                <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
                  {ev.type==="worldcup2026"?<>
                    <button style={{...S.btnSm,padding:"6px 14px",fontSize:11,background:C.green,color:"#000"}} onClick={(e)=>{e.stopPropagation();setOpenEventId(ev.id)}}>⚽ Pick / View Teams</button>
                  </>:<>
                    {!joined&&<button style={{...S.btnSm,padding:"6px 14px",fontSize:11}} onClick={(e)=>{e.stopPropagation();joinEvent(ev.id)}}>🎯 Join Event</button>}
                    {joined&&<button style={{...S.btnO,padding:"6px 14px",fontSize:11,color:C.red,borderColor:C.red}} onClick={(e)=>{e.stopPropagation();leaveEvent(ev.id)}}>Leave</button>}
                  </>}
                  {isAdm&&<button style={{...S.btnO,padding:"6px 14px",fontSize:11,color:typeColor,borderColor:typeColor}} onClick={(e)=>{e.stopPropagation();setOpenEventId(ev.id)}}>⚙ Manage</button>}
                </div>
              </div>

              {/* Leaderboard */}
              <div style={{padding:"10px 18px 14px"}}>
                <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",color:C.textMid,letterSpacing:1,marginBottom:8}}>🏆 Leaderboard</div>
                {lb.length===0&&<div style={{padding:"14px 10px",fontSize:12,color:C.textDim,textAlign:"center",fontStyle:"italic"}}>No participants yet. {isAdm?"Award points to someone to add them!":"Be the first to join!"}</div>}
                {topThree.map((entry,idx)=>{
                  const participant=users.find(u=>u.id===entry.userId);
                  const dispName=entry.isGuest?(entry.name||"Guest"):(participant?.name||"Unknown");
                  const medal=idx===0?"🥇":idx===1?"🥈":"🥉";
                  const medalBg=idx===0?"rgba(255,193,7,.12)":idx===1?"rgba(148,163,184,.12)":"rgba(184,115,51,.12)";
                  const medalColor=idx===0?"#FFC107":idx===1?"#94A3B8":"#B87333";
                  return <div key={entry.userId} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",marginBottom:6,background:medalBg,borderRadius:8,border:`1px solid ${medalColor}40`}}>
                    <span style={{fontSize:22,width:28,textAlign:"center"}}>{medal}</span>
                    <div style={{...S.avatar,width:28,height:28,fontSize:10,background:entry.isGuest?"var(--n-200)":(participant?.profileColor||C.grad2)}}>{entry.isGuest?"👤":(participant?.profilePhoto?<img src={participant.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(participant?.avatar||'?'))}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:700}}>{dispName}{entry.isGuest&&<span style={{fontSize:8,fontWeight:600,padding:"1px 4px",borderRadius:999,background:"var(--n-100)",color:C.textDim,marginLeft:5,textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}{entry.userId===user.id&&<span style={{color:C.accent,marginLeft:6,fontSize:11}}>(you)</span>}</div>
                      {entry.note&&<div style={{fontSize:10,color:C.textDim,fontStyle:"italic",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{entry.note}</div>}
                    </div>
                    <div style={{fontFamily:"'Inter',sans-serif",fontSize:20,fontWeight:800,color:medalColor}}>{entry.points||0}</div>
                    {isAdm&&ev.type!=="worldcup2026"&&<button onClick={(e)=>{e.stopPropagation();resetUserPoints(ev.id,entry.userId)}} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:2}} title="Reset points">↻</button>}
                  </div>;
                })}
                {rest.length>0&&<div style={{marginTop:8,paddingTop:8,borderTop:`1px solid ${C.card}`}}>
                  {rest.map((entry,idx)=>{
                    const participant=users.find(u=>u.id===entry.userId);
                    const dispName=entry.isGuest?(entry.name||"Guest"):(participant?.name||"Unknown");
                    return <div key={entry.userId} style={{display:"flex",alignItems:"center",gap:10,padding:"6px 8px",fontSize:12}}>
                      <span style={{fontSize:11,color:C.textDim,width:24,fontWeight:600}}>#{idx+4}</span>
                      <div style={{...S.avatar,width:22,height:22,fontSize:8,background:entry.isGuest?"var(--n-200)":undefined}}>{entry.isGuest?"👤":(participant?.profilePhoto?<img src={participant.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(participant?.avatar||'?'))}</div>
                      <div style={{flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{dispName}{entry.isGuest&&<span style={{fontSize:8,fontWeight:600,padding:"1px 4px",borderRadius:999,background:"var(--n-100)",color:C.textDim,marginLeft:4,textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}{entry.userId===user.id&&<span style={{color:C.accent,marginLeft:4,fontSize:10}}>(you)</span>}</div>
                      <div style={{fontWeight:700,color:C.textMid}}>{entry.points||0}</div>
                    </div>;
                  })}
                </div>}
              </div>
            </div>;
          })}
        </div>

        {/* Archived events */}
        {archivedEvents.length>0&&<div style={{marginTop:24}}>
          <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:C.textMid,letterSpacing:1,marginBottom:10}}>📦 Archived ({archivedEvents.length})</div>
          {archivedEvents.map(ev=>{
            const lb=[...(ev.leaderboard||[])].sort((a,b)=>(b.points||0)-(a.points||0));
            const winner=lb[0];
            const winnerUser=winner?users.find(u=>u.id===winner.userId):null;
            return <div key={ev.id} style={{...S.card,padding:"10px 14px",marginBottom:6,display:"flex",alignItems:"center",gap:10,opacity:.7}}>
              <span style={{fontSize:14}}>📦</span>
              <div style={{flex:1}}>
                <div style={{fontWeight:600,fontSize:13}}>{ev.title}</div>
                {winnerUser&&<div style={{fontSize:11,color:C.textDim}}>🥇 Winner: {winnerUser.name} ({winner.points||0} pts)</div>}
              </div>
              {isAdm&&<>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:10}} onClick={()=>archiveEvent(ev.id)}>Restore</button>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:10,color:C.red,borderColor:C.red}} onClick={()=>deleteEvent(ev.id)}>Delete</button>
              </>}
            </div>;
          })}
        </div>}
      </div>;
    })()}

    {/* FINANCIAL TAB — Admin / Principal / Associate / PM only */}
    {/* TEAM PROJECTS TAB */}

    {/* TEAM PROJECTS TAB */}
    {myTeamTab==="projects"&&(()=>{
      const teamMembers=allStaff.filter(u=>u.teamName===myTeamName);
      const teamMemberIds=teamMembers.map(u=>u.id);
      // Projects where anyone from my team is on the team
      const teamProjects=projects.filter(p=>(p.team||[]).some(uid=>teamMemberIds.includes(uid)));
      const activeProjects=teamProjects.filter(p=>p.status!=="Completed");
      const completedProjects=teamProjects.filter(p=>p.status==="Completed");
      return <div>
        {!myTeamName&&<div style={S.banner(C.amberSoft,C.amber)}>You're not on a team yet. Ask your admin to assign you to one.</div>}
        {myTeamName&&<>
          <div style={{...S.g3,marginBottom:20}}>
            <StatCard label="Active Projects" value={activeProjects.length} color={C.accent} sub={myTeamName||"Your team"}/>
            <StatCard label="Completed" value={completedProjects.length} color={C.green}/>
            <StatCard label="Team Members" value={teamMembers.length}/>
          </div>
          <div style={S.card}>
            <div style={S.cardH}><span style={S.cardT}>🟢 Active Projects ({activeProjects.length})</span></div>
            <div style={S.cardB}>
              {activeProjects.length===0&&<div style={{textAlign:"center",padding:30,color:C.textDim,fontSize:13}}>No active projects. Anyone on the team creating a project will appear here.</div>}
              {activeProjects.map(p=><div key={p.id} style={{padding:"14px 16px",borderRadius:12,border:`1px solid ${C.border}`,marginBottom:10,display:"flex",alignItems:"center",gap:14,cursor:"pointer"}} onClick={()=>onOpenProject&&onOpenProject(p.id)}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontWeight:700,fontSize:14,color:C.accent}}>{p.name}</span><span style={{fontSize:11,color:C.textDim}}>{p.number} · {p.phase}</span></div>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginTop:4}}>
                    <Badge bg={statusColor(p.status)+"20"} fg={statusColor(p.status)}>{p.status}</Badge>
                    <span style={{fontSize:11,color:C.textDim}}>{p.progress}% complete</span>
                    <span style={{fontSize:11,color:C.textDim}}>· {(p.team||[]).length} members</span>
                  </div>
                </div>
                <button style={{...S.btnSm,padding:"5px 12px",fontSize:11,background:C.green}} onClick={(e)=>{e.stopPropagation();if(confirm(`Mark "${p.name}" as completed?`))onUpdateProject&&onUpdateProject(p.id,{status:"Completed",progress:100})}}>✓ Complete</button>
                <span style={{color:C.accent,fontSize:16}}>›</span>
              </div>)}
            </div>
          </div>
          {completedProjects.length>0&&<div style={{...S.card,marginTop:16}}>
            <div style={S.cardH}><span style={S.cardT}>✅ Completed Projects ({completedProjects.length})</span></div>
            <div style={S.cardB}>
              {completedProjects.map(p=><div key={p.id} style={{padding:"12px 16px",borderRadius:12,border:`1px solid ${C.border}`,marginBottom:8,display:"flex",alignItems:"center",gap:14,cursor:"pointer",opacity:.75}} onClick={()=>onOpenProject&&onOpenProject(p.id)}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:13}}>{p.name}</div>
                  <div style={{fontSize:11,color:C.textDim}}>{p.number} · Completed</div>
                </div>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={(e)=>{e.stopPropagation();if(confirm(`Reopen "${p.name}"?`))onUpdateProject&&onUpdateProject(p.id,{status:"In Progress"})}}>↺ Reopen</button>
              </div>)}
            </div>
          </div>}
        </>}
      </div>;
    })()}

    {/* OTHER TEAMS TAB */}
    {myTeamTab==="others"&&!otherTeamView&&<div style={S.card}>
      <div style={S.cardH}><span style={S.cardT}>Other Teams</span></div>
      <div style={S.cardB}>
        {otherTeams.length===0&&<div style={{textAlign:"center",padding:30,color:C.textDim,fontSize:13}}>No other teams exist.</div>}
        {otherTeams.map(t=>{const members=allStaff.filter(u=>u.teamName===t.name);return <div key={t.id} onClick={()=>setOtherTeamView(t.name)} style={{padding:"14px 16px",borderRadius:12,border:`1px solid ${C.border}`,marginBottom:10,cursor:"pointer",display:"flex",alignItems:"center",gap:14}}>
          <div style={{width:48,height:48,borderRadius:12,background:C.grad2,color:C.white,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:18,flexShrink:0}}>{t.name.charAt(0)}</div>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,fontSize:14}}>🏢 {t.name}</div>
            <div style={{fontSize:11,color:C.textDim}}>{members.length} member{members.length!==1?"s":""}</div>
          </div>
          <span style={{color:C.accent,fontSize:16}}>›</span>
        </div>})}
      </div>
    </div>}

    {/* Viewing another team's profile */}
    {myTeamTab==="others"&&otherTeamView&&(()=>{
      const teamMembers=allStaff.filter(u=>u.teamName===otherTeamView);
      const teamMemberIds=teamMembers.map(u=>u.id);
      const teamProjects=projects.filter(p=>(p.team||[]).some(uid=>teamMemberIds.includes(uid)));
      const activeProjects=teamProjects.filter(p=>p.status!=="Completed");
      return <div>
        <div style={{marginBottom:14}}>
          <button onClick={()=>setOtherTeamView(null)} style={{color:C.accent,cursor:"pointer",background:"none",border:"none",fontSize:13,fontWeight:600,padding:0,fontFamily:"'Inter',sans-serif"}}>← All Teams</button>
        </div>
        <div style={{...S.card,marginBottom:20,padding:24,display:"flex",alignItems:"center",gap:20}}>
          <div style={{width:72,height:72,borderRadius:16,background:C.grad2,color:C.white,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:28}}>{otherTeamView.charAt(0)}</div>
          <div style={{flex:1}}>
            <h1 className="page-title">{otherTeamView}</h1>
            <div style={{fontSize:13,color:C.textMid}}>{teamMembers.length} member{teamMembers.length!==1?"s":""} · {activeProjects.length} active project{activeProjects.length!==1?"s":""}</div>
          </div>
        </div>
        <div style={S.g2}>
          <div style={S.card}><div style={S.cardH}><span style={S.cardT}>Team Members ({teamMembers.length})</span></div><div style={S.cardB}>
            {teamMembers.map(u=><div key={u.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 8px",borderBottom:`1px solid ${C.border}`}}>
              <div style={{...S.avatar,background:u.profileColor||C.grad2}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
              <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13}}>{u.name}<RoleBadge role={u.role}/></div><div style={{fontSize:11,color:C.textDim}}>{u.email}</div></div>
            </div>)}
          </div></div>
          <div style={S.card}><div style={S.cardH}><span style={S.cardT}>Team Projects ({activeProjects.length})</span></div><div style={S.cardB}>
            {activeProjects.length===0&&<div style={{textAlign:"center",padding:20,color:C.textDim,fontSize:12}}>No active projects.</div>}
            {activeProjects.map(p=><div key={p.id} onClick={()=>onOpenProject&&onOpenProject(p.id)} style={{padding:"10px 12px",borderRadius:8,border:`1px solid ${C.border}`,marginBottom:6,cursor:"pointer"}}>
              <div style={{fontWeight:600,fontSize:13,color:C.accent}}>{p.name}</div>
              <div style={{fontSize:11,color:C.textDim}}>{p.number} · {p.status} · {p.progress}%</div>
            </div>)}
          </div></div>
        </div>
      </div>;
    })()}

    {/* TEAM MEETING TAB (original content) */}
    {myTeamTab==="meeting"&&<>
    <div style={{display:"flex",gap:selected?0:16,alignItems:"flex-start",transition:"gap .35s cubic-bezier(.4,0,.2,1)"}}>
      {/* Team list — slides off-screen left when a member is selected */}
      <div style={{flex:selected?"0 0 0%":"1 1 50%",minWidth:0,maxWidth:selected?0:undefined,opacity:selected?0:1,transform:selected?"translateX(-24px)":"translateX(0)",transition:"flex-basis .35s cubic-bezier(.4,0,.2,1), max-width .35s cubic-bezier(.4,0,.2,1), opacity .25s ease, transform .35s cubic-bezier(.4,0,.2,1)",overflow:selected?"hidden":"visible",pointerEvents:selected?"none":"auto"}}>
        <div style={S.card}>
        <div style={S.cardH}><span style={S.cardT}>Team Members</span></div>
        <div style={S.cardB}>
          {staffUsers.map(u=>{
            const myP=projects.filter(p=>p.team.includes(u.id));
            const active=myP.filter(p=>p.status==="In Progress").length;
            const focus=myP.reduce((s,p)=>s+getUserFocus(p,u.id),0);
            return <div key={u.id} onClick={()=>{setSelected(u.id);setSlideProject(null)}} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 8px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",background:selected===u.id?C.accentSoft:"transparent",borderRadius:6,marginBottom:2}}>
              <div style={{...S.avatar,width:36,height:36}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
              <div style={{flex:1}}>
                <div style={{fontWeight:600,fontSize:13}}>{u.name}<RoleBadge role={u.role}/></div>
                <div style={{fontSize:11,color:C.textDim}}>{active} active · {focus}% allocated{u.teamName?` · ${u.teamName}`:""}</div>
              </div>
              <span style={{color:C.accent,fontSize:16}}>›</span>
            </div>
          })}
        </div>
        </div>
      </div>
      {/* Selected member detail — slides leftward to fill freed space */}
      <div style={{flex:selected?"1 1 100%":"1 1 50%",minWidth:0,transition:"flex-basis .35s cubic-bezier(.4,0,.2,1)"}}>
        {selected ? (()=>{
          const su=users.find(u=>u.id===selected);
          if(!su) return null;
          const myP=projects.filter(p=>p.team.includes(su.id));
          const totalFocusHours=myP.reduce((s,p)=>s+getUserFocusHours(p,su.id),0);
          const totalFocus=Math.round((totalFocusHours/WORKLOAD_FULL_HOURS)*100);
          const allDeadlines=myP.flatMap(p=>p.deadlines.map(d=>({...d,project:p.name,pId:p.id}))).filter(d=>daysUntil(d.date)>=-7).sort((a,b)=>new Date(a.date)-new Date(b.date)).slice(0,8);

          return <>
            {/* Sticky back-bar so user can always return to the team list */}
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14,paddingBottom:10,borderBottom:`1px solid ${C.border}`}}>
              <button onClick={()=>{setSelected(null);setSlideProject(null)}} style={{...S.btnO,padding:"6px 12px",fontSize:12,display:"inline-flex",alignItems:"center",gap:4}} title="Show all team members">← Team Members</button>
              <div style={{flex:1}}/>
              <span style={{fontSize:11,color:C.textDim}}>Reviewing <strong style={{color:C.text}}>{su.name}</strong></span>
            </div>
            {/* Focus allocation with clickable projects */}
            <div style={{...S.card,marginBottom:16}}>
              <div style={S.cardH}><span style={S.cardT}>{su.name}'s Portfolio</span>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:11,color:C.textDim}}>{totalFocusHours.toFixed(1)}h / {WORKLOAD_FULL_HOURS}h</span>
                  <Badge bg={totalFocus>100?C.redSoft:totalFocus>=80?C.greenSoft:C.amberSoft} fg={totalFocus>100?C.red:totalFocus>=80?C.green:C.amber}>{totalFocus}%</Badge>
                </div>
              </div>
              <div style={S.cardB}>
                {myP.map(p=>{
                  const noteExists=Object.keys(meetingNotes).some(k=>k.startsWith(p.id+"::")&&meetingNotes[k]?.trim());
                  const hrs=getUserFocusHours(p,su.id);
                  const pct=Math.round((hrs/WORKLOAD_FULL_HOURS)*100);
                  return <div key={p.id} style={{display:"flex",alignItems:"center",gap:10,marginBottom:10,padding:"8px 10px",borderRadius:8,border:`1px solid ${slideProject===p.id?C.accent:C.border}`,cursor:"pointer",background:slideProject===p.id?C.accentSoft:"transparent",transition:"all .15s"}} onClick={()=>{setSlideProject(slideProject===p.id?null:p.id);setNoteWeekOffset(0)}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:6}}>
                        {p.name}
                        {noteExists&&<span style={{fontSize:10,color:C.amber}} title="Has meeting notes">📝</span>}
                      </div>
                      <div style={{fontSize:11,color:C.textDim}}>{p.number} · {p.phase} · <Badge bg={statusColor(p.status)+"20"} fg={statusColor(p.status)}>{p.status}</Badge></div>
                      <div style={{marginTop:6}}><PBar value={p.progress} height={4} showLabel/></div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4,minWidth:120}}>
                      {canAssignTeam(user)
                        ?<div style={{display:"flex",alignItems:"center",gap:4}} onClick={e=>e.stopPropagation()}>
                          <input type="number" min={0} max={80} step={0.5} value={hrs} onChange={e=>{e.stopPropagation();onUpdateFocusHours?.(p.id,parseFloat(e.target.value)||0,su.id)}} style={{...S.input,width:64,padding:"4px 6px",fontSize:12,textAlign:"right",fontVariantNumeric:"tabular-nums"}}/>
                          <span style={{fontSize:11,color:C.textMid,fontWeight:600}}>h</span>
                        </div>
                        :<div style={{display:"flex",alignItems:"center",gap:4}}>
                          <span style={{fontSize:13,fontWeight:700,color:C.text,fontVariantNumeric:"tabular-nums"}}>{hrs}</span>
                          <span style={{fontSize:11,color:C.textMid,fontWeight:600}}>h</span>
                        </div>}
                      <span style={{fontSize:11,fontWeight:600,color:pct>=80?C.green:pct>=40?C.amber:C.textDim,fontVariantNumeric:"tabular-nums"}}>{pct}% workload</span>
                    </div>
                  </div>
                })}
              </div>
            </div>

            {/* Deadlines */}
            <div style={{...S.card,marginBottom:16}}>
              <div style={S.cardH}><span style={S.cardT}>Upcoming Deadlines</span></div>
              <div style={S.cardB}>
                {allDeadlines.length===0&&<div style={{color:C.textDim,fontSize:13}}>None.</div>}
                {allDeadlines.map((d,i)=>{const days=daysUntil(d.date);return <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:`1px solid ${C.border}`}}>
                  <div><div style={{fontSize:12,fontWeight:500}}>{d.name}</div><div style={{fontSize:11,color:C.textDim}}>{d.project} · {d.date}</div></div>
                  <Badge bg={days<=7&&days>=0?C.redSoft:C.accentSoft} fg={days<=7&&days>=0?C.red:C.accent}>{days<0?`${Math.abs(days)}d ago`:days===0?"Today":`${days}d`}</Badge>
                </div>})}
              </div>
            </div>

            {/* Recent Updates — grouped by project */}
            <div style={S.card}>
              <div style={S.cardH}><span style={S.cardT}>Recent Updates by Project</span></div>
              <div style={S.cardB}>
                {myP.filter(p=>p.updates.length>0).length===0&&<div style={{color:C.textDim,fontSize:13}}>No updates across projects.</div>}
                {myP.filter(p=>p.updates.length>0).map(p=>(
                  <div key={p.id} style={{marginBottom:18}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,paddingBottom:6,borderBottom:`2px solid ${C.accent}`}}>
                      <span style={{fontWeight:700,fontSize:13,color:C.accent}}>{p.number}</span>
                      <span style={{fontSize:13,fontWeight:600}}>{p.name}</span>
                      <Badge bg={statusColor(p.status)+"20"} fg={statusColor(p.status)}>{p.status}</Badge>
                    </div>
                    {p.updates.slice(0,3).map((u,i)=>{
                      const author=users.find(x=>x.id===u.author);
                      return <div key={i} style={{display:"flex",gap:10,padding:"8px 0 8px 12px",borderLeft:`3px solid ${C.card}`,marginBottom:4}}>
                        <div style={{...S.avatar,width:24,height:24,fontSize:9,flexShrink:0}}>{author?.profilePhoto?<img src={author.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(author?.avatar||'?')}</div>
                        <div>
                          <div style={{fontSize:11,color:C.textDim}}><strong style={{color:C.text}}>{author?.name||"Unknown"}</strong> · {u.date}</div>
                          <div style={{fontSize:13,marginTop:2,lineHeight:1.4}}>{u.text}</div>
                        </div>
                      </div>
                    })}
                  </div>
                ))}
              </div>
            </div>
          </>
        })() : <div style={{...S.card,padding:40,textAlign:"center"}}><div style={{fontSize:28,marginBottom:8}}>👈</div><div style={{color:C.textMid,fontSize:13}}>Select a team member to review their portfolio.</div></div>}
      </div>
    </div>
    </>}

    {/* ── Slide-out project notes panel ── */}
    {slideProj && <SlidePanel slideProj={slideProj} user={user} users={users} meetingNotes={meetingNotes} setMeetingNotes={setMeetingNotes} showNotes={showNotes} setShowNotes={setShowNotes} showCalendar={showCalendar} setShowCalendar={setShowCalendar} showActions={showActionsTab} setShowActions={setShowActionsTab} calViewOffset={calViewOffset} setCalViewOffset={setCalViewOffset} noteWeekOffset={noteWeekOffset} setNoteWeekOffset={setNoteWeekOffset} setDayEditor={setDayEditor} setSlideProject={setSlideProject} actionItems={actionItems} toggleAction={toggleAction}/>}

    {/* Day Editor Modal */}
    {dayEditor&&slideProj&&<DayEditorModal 
      date={dayEditor.date} 
      events={dayEditor.events} 
      project={slideProj} 
      users={users} 
      onClose={()=>setDayEditor(null)} 
      onAddDeadline={(title,reviewerId,extraData)=>{
        const dl={
          id:"dl_"+Date.now(),
          title,
          date:(extraData&&extraData.date)||dayEditor.date,
          internalDate:(extraData&&extraData.internalDate)||null,
          reviewer:reviewerId||null,
          addedBy:user.id
        };
        onAddDeadline&&onAddDeadline(slideProj.id,dl);
        setDayEditor(null);
      }} 
      onAddCustomEvent={(title,color)=>{
        const ev={id:"ce_"+Date.now(),title,date:dayEditor.date,color:color||C.accent,addedBy:user.id};
        const updated=[...(slideProj.customEvents||[]),ev];
        onUpdateProject&&onUpdateProject(slideProj.id,{customEvents:updated});
        setDayEditor(null);
      }}
      onDeleteEvent={(ev)=>{
        if(ev.customRef){
          const updated=(slideProj.customEvents||[]).filter(x=>x.id!==ev.customRef.id);
          onUpdateProject&&onUpdateProject(slideProj.id,{customEvents:updated});
        }else if(ev.deadlineRef&&ev.type==="deadline"){
          const updated=(slideProj.deadlines||[]).filter(x=>x.id!==ev.deadlineRef.id);
          onUpdateProject&&onUpdateProject(slideProj.id,{deadlines:updated});
        }
        setDayEditor(prev=>prev?{...prev,events:prev.events.filter(e=>e!==ev)}:null);
      }}
      onUpdateDeadline={onUpdateDeadline}
      onDeleteDeadline={(pid,dlId)=>{
        onDeleteDeadline&&onDeleteDeadline(pid,dlId);
        setDayEditor(null);
      }}
    />}

    {/* Backdrop when slide panel is open */}
    {slideProj&&<div onClick={()=>{setSlideProject(null);setDayEditor(null)}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.15)",zIndex:99}}/>}
    </div>
  </div>;
}


function AddProjectModal({onClose,onAdd,users,currentUser}){
  const canAssign=canAssignTeam(currentUser);
  const [step,setStep]=useState(1);
  const [f,sF]=useState({name:"",number:"",client:"",location:"",type:"Residential",status:"In Progress",phase:"Schematic Design",startDate:"",endDate:"",budgetTotal:"",team:[currentUser.id],designerFocus:20,disciplines:[{category:"Architectural",allocated:""}]});
  const s=(k,v)=>sF(p=>({...p,[k]:v}));
  const toggle=(uid)=>{if(uid===currentUser.id)return;sF(p=>({...p,team:p.team.includes(uid)?p.team.filter(x=>x!==uid):[...p.team,uid]}))};
  const addD=()=>s("disciplines",[...f.disciplines,{category:"",allocated:""}]);
  const updD=(i,k,v)=>{const d=[...f.disciplines];d[i]={...d[i],[k]:v};s("disciplines",d)};
  const rmD=i=>s("disciplines",f.disciplines.filter((_,j)=>j!==i));
  const v1=f.name.trim()&&f.client.trim()&&f.startDate&&f.endDate;
  const submit=()=>{
    const team=f.team.includes(currentUser.id)?f.team:[...f.team,currentUser.id];
    // Initialize focusMap: creator gets the initial focus%, everyone else starts at 0
    const focusMap={};
    focusMap[currentUser.id]=f.designerFocus;
    onAdd({id:genId("p"),number:f.number||`PRJ-${new Date().getFullYear()}-${String(Math.floor(Math.random()*900)+100)}`,name:f.name,client:f.client,location:f.location,type:f.type,status:f.status,phase:f.phase,startDate:f.startDate,endDate:f.endDate,progress:0,budget:{total:parseFloat(f.budgetTotal)||0,spent:0},designerFocus:f.designerFocus,focusMap,team,accessPin:genPinCode(),milestones:[],issues:[],updates:[],deadlines:[],coordination:[],budgetBreakdown:f.disciplines.filter(d=>d.category).map(d=>({category:d.category,allocated:parseFloat(d.allocated)||0,spent:0}))});onClose();
  };
  return <Modal title={`New Project — ${step}/3`} onClose={onClose} footer={<>{step>1&&<button style={S.btnO} onClick={()=>setStep(step-1)}>Back</button>}<button style={S.btnO} onClick={onClose}>Cancel</button>{step<3?<button style={{...S.btn,opacity:(step===1?v1:true)?1:.4}} onClick={()=>{if(step===1&&v1)setStep(2);else if(step===2)setStep(3)}}>Next</button>:<button style={S.btn} onClick={submit}>Create</button>}</>}>
    {step===1&&<><div style={S.row}><div style={{...S.inputGroup,flex:2}}><label style={S.label}>Name *</label><input style={S.input} value={f.name} onChange={e=>s("name",e.target.value)}/></div><div style={{...S.inputGroup,flex:1}}><label style={S.label}>Number</label><input style={S.input} value={f.number} onChange={e=>s("number",e.target.value)} placeholder="Auto"/></div></div>
      <div style={S.row}><div style={{...S.inputGroup,...S.half}}><label style={S.label}>Client *</label><input style={S.input} value={f.client} onChange={e=>s("client",e.target.value)}/></div><div style={{...S.inputGroup,...S.half}}><label style={S.label}>Location</label><input style={S.input} value={f.location} onChange={e=>s("location",e.target.value)}/></div></div>
      <div style={S.row}><div style={{...S.inputGroup,...S.half}}><label style={S.label}>Type</label><select style={S.select} value={f.type} onChange={e=>s("type",e.target.value)}>{["Residential","Commercial","Mixed-Use / Residential","Institutional","Industrial","Hospitality","Interior","Transportation","Healthcare","Education"].map(t=><option key={t}>{t}</option>)}</select></div><div style={{...S.inputGroup,...S.half}}><label style={S.label}>Phase</label><select style={S.select} value={f.phase} onChange={e=>s("phase",e.target.value)}>{["Pre-Design","Schematic Design","Design Development","Construction Documents","Bidding","Construction Admin"].map(t=><option key={t}>{t}</option>)}</select></div></div>
      <div style={S.row}><div style={{...S.inputGroup,...S.half}}><label style={S.label}>Start *</label><input style={S.input} type="date" value={f.startDate} onChange={e=>s("startDate",e.target.value)}/></div><div style={{...S.inputGroup,...S.half}}><label style={S.label}>End *</label><input style={S.input} type="date" value={f.endDate} onChange={e=>s("endDate",e.target.value)}/></div></div></>}
    {step===2&&<>{canAssign?users.filter(u=>isStaff(u)).map(u=><label key={u.id} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 0",cursor:u.id===currentUser.id?"default":"pointer",opacity:u.id===currentUser.id?.6:1}}><input type="checkbox" checked={f.team.includes(u.id)} onChange={()=>toggle(u.id)} disabled={u.id===currentUser.id} style={{accentColor:C.accent}}/><div style={{...S.avatar,width:28,height:28,fontSize:10}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div><div style={{flex:1}}><div style={{fontWeight:500,fontSize:13}}>{u.name}<RoleBadge role={u.role}/></div></div></label>):<div style={S.banner(C.amberSoft,C.amber)}>You'll be auto-assigned.</div>}
      <div style={{marginTop:14}}><label style={S.label}>Focus %</label><div style={{display:"flex",alignItems:"center",gap:12}}><input type="range" min={0} max={100} step={5} value={f.designerFocus} onChange={e=>s("designerFocus",+e.target.value)} style={{flex:1,accentColor:C.accent}}/><span style={{fontWeight:700,color:C.accent}}>{f.designerFocus}%</span></div></div></>}
    {step===3&&<><div style={S.inputGroup}><label style={S.label}>Budget ($)</label><input style={S.input} type="number" value={f.budgetTotal} onChange={e=>s("budgetTotal",e.target.value)}/></div>
      <label style={S.label}>Disciplines</label>
      {f.disciplines.map((d,i)=><div key={i} style={{...S.row,marginBottom:8,alignItems:"center"}}><input style={{...S.input,flex:2}} value={d.category} onChange={e=>updD(i,"category",e.target.value)} placeholder="Discipline"/><input style={{...S.input,flex:1}} type="number" value={d.allocated} onChange={e=>updD(i,"allocated",e.target.value)} placeholder="$"/>{f.disciplines.length>1&&<button style={{background:"none",border:"none",color:C.red,cursor:"pointer",fontSize:18}} onClick={()=>rmD(i)}>×</button>}</div>)}
      <button style={{...S.btnO,marginTop:4,fontSize:12}} onClick={addD}>+ Discipline</button></>}
  </Modal>
}

function AddUserModal({onClose,onAdd,currentUser}){
  const [f,sF]=useState({name:"",email:"",role:"Designer",billableRole:"Designer",pin:"1234"});
  const s=(k,v)=>sF(p=>({...p,[k]:v}));
  const ok=f.name.trim()&&f.email.trim();
  return <Modal title="Add Team Member" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:ok?1:.4}} onClick={()=>{if(ok){onAdd({id:genId("u"),...f,avatar:makeAvatar(f.name)});onClose()}}}>Add</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Name *</label><input style={S.input} value={f.name} onChange={e=>s("name",e.target.value)}/></div>
    <div style={S.inputGroup}><label style={S.label}>Email *</label><input style={S.input} value={f.email} onChange={e=>s("email",e.target.value)}/></div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Role</label><select style={S.select} value={f.role} onChange={e=>s("role",e.target.value)}>{(isAdmin(currentUser)?["Admin","Project Manager","Designer"]:["Project Manager","Designer"]).map(r=><option key={r}>{r}</option>)}</select></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Billable Role</label><select style={S.select} value={f.billableRole} onChange={e=>s("billableRole",e.target.value)}>{BILLABLE_ROLES.map(r=><option key={r}>{r}</option>)}</select></div>
    </div>
    <div style={S.inputGroup}><label style={S.label}>PIN</label><input style={S.input} value={f.pin} onChange={e=>s("pin",e.target.value)}/></div>
  </Modal>
}

function EditProjectModal({project,onClose,onSave}){
  const PROJECT_TYPES=["Residential","Commercial","Mixed-Use / Residential","Institutional","Industrial","Hospitality","Interior","Transportation","Healthcare","Education"];
  const PHASES=["Pre-Design","Schematic Design","Design Development","Construction Documents","Bidding","Construction Admin"];
  const [f,sF]=useState({name:project.name,client:project.client,location:project.location,type:project.type,phase:project.phase,startDate:project.startDate,endDate:project.endDate,budgetTotal:project.budget?.total||0,designerFocus:project.designerFocus||0,number:project.number});
  const s=(k,v)=>sF(p=>({...p,[k]:v}));
  return <Modal title="Edit Project" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={S.btn} onClick={()=>{onSave(project.id,{name:f.name,client:f.client,location:f.location,type:f.type,phase:f.phase,startDate:f.startDate,endDate:f.endDate,budget:{...project.budget,total:parseFloat(f.budgetTotal)||0},designerFocus:parseInt(f.designerFocus)||0,number:f.number});onClose()}}>Save Changes</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Project Name</label><input style={S.input} value={f.name} onChange={e=>s("name",e.target.value)}/></div>
    <div style={S.inputGroup}><label style={S.label}>Project Number</label><input style={S.input} value={f.number} onChange={e=>s("number",e.target.value)}/></div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Client</label><input style={S.input} value={f.client} onChange={e=>s("client",e.target.value)}/></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Location</label><input style={S.input} value={f.location} onChange={e=>s("location",e.target.value)}/></div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Type</label><select style={S.select} value={f.type} onChange={e=>s("type",e.target.value)}>{PROJECT_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Phase</label><select style={S.select} value={f.phase} onChange={e=>s("phase",e.target.value)}>{PHASES.map(t=><option key={t}>{t}</option>)}</select></div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Start Date</label><input style={S.input} type="date" value={f.startDate} onChange={e=>s("startDate",e.target.value)}/></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>End Date</label><input style={S.input} type="date" value={f.endDate} onChange={e=>s("endDate",e.target.value)}/></div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Budget ($)</label><input style={S.input} type="number" value={f.budgetTotal} onChange={e=>s("budgetTotal",e.target.value)}/></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Focus (%)</label><input style={S.input} type="number" min="0" max="100" value={f.designerFocus} onChange={e=>s("designerFocus",e.target.value)}/></div>
    </div>
  </Modal>
}

function AddIssueModal({onClose,onAdd,users,projectId,currentUser}){
  const isCon=currentUser.role==="Contractor";
  const [f,sF]=useState({title:"",type:"RFI",priority:"Medium",assignee:"",message:""});
  const [files,setFiles]=useState([]);
  const s=(k,v)=>sF(p=>({...p,[k]:v}));
  return <Modal title={isCon?"Raise RFI":"Create RFI"} onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.title.trim()?1:.4}} onClick={()=>{if(f.title.trim()){onAdd(projectId,{id:`RFI-${String(Math.floor(Math.random()*900)+100)}`,title:f.title,type:"RFI",priority:f.priority,status:"Open",date:new Date().toISOString().split("T")[0],assignee:f.assignee,author:currentUser.id,message:f.message,responses:[],attachments:files.length?files:undefined});onClose()}}}>Submit</button></>}>
    <div style={S.inputGroup}><label style={S.label}>RFI Subject *</label><input style={S.input} value={f.title} onChange={e=>s("title",e.target.value)} placeholder="e.g. Clarification on wall section detail"/></div>
    <div style={S.inputGroup}><label style={S.label}>Question / Details</label><textarea style={S.textarea} value={f.message} onChange={e=>s("message",e.target.value)} placeholder="Describe what you need clarified..."/></div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Priority</label><select style={S.select} value={f.priority} onChange={e=>s("priority",e.target.value)}><option>High</option><option>Medium</option><option>Low</option></select></div>
      {!isCon&&<div style={{...S.inputGroup,...S.half}}><label style={S.label}>Assign To</label><select style={S.select} value={f.assignee} onChange={e=>s("assignee",e.target.value)}><option value="">Unassigned</option>{users.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}</select></div>}
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Attachments</label>
      <FileUploadInput files={files} setFiles={setFiles} label="Add Photos, PDFs, or Documents"/>
    </div>
  </Modal>
}

function AddUpdateModal({onClose,onAdd,projectId,userId}){
  const [t,sT]=useState("");
  return <Modal title="Post Update" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:t.trim()?1:.4}} onClick={()=>{if(t.trim()){onAdd(projectId,{date:new Date().toISOString().split("T")[0],text:t,author:userId});onClose()}}}>Post</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Update</label><textarea style={S.textarea} value={t} onChange={e=>sT(e.target.value)}/></div>
  </Modal>
}

// LogoImg is defined at the top of the file as a const

function BookVacationForm({currentUser,onBook}){
  const [startDate,setStartDate]=React.useState("");
  const [endDate,setEndDate]=React.useState("");
  const [reason,setReason]=React.useState("");
  return <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"flex-end"}}>
    <div><label style={S.label}>Start Date</label><input type="date" style={S.input} value={startDate} onChange={e=>setStartDate(e.target.value)}/></div>
    <div><label style={S.label}>End Date</label><input type="date" style={S.input} value={endDate} onChange={e=>setEndDate(e.target.value)}/></div>
    <div style={{flex:1,minWidth:120}}><label style={S.label}>Reason (optional)</label><input style={S.input} value={reason} onChange={e=>setReason(e.target.value)} placeholder="e.g. vacation, sick leave"/></div>
    <button style={S.btn} onClick={()=>{if(startDate&&endDate&&endDate>=startDate){onBook({id:genId("v"),userId:currentUser.id,startDate,endDate,reason,createdAt:new Date().toISOString()});setStartDate("");setEndDate("");setReason("");}else alert("Please select valid start and end dates.")}}>🌴 Book Vacation</button>
  </div>;
}

function WorldCupEventView({event,users,currentUser,isAdm,onUpdate}){
  return <div style={{padding:20,textAlign:"center",color:C.textDim,fontSize:13}}>World Cup event view loading...</div>;
}

function AddNewsModal({onClose,onAdd,userId}){
  const [text,setText]=React.useState("");
  return <Modal title="Post Update" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:text.trim()?1:.4}} onClick={()=>{if(text.trim()){onAdd({id:genId("n"),author:userId,text:text.trim(),date:new Date().toISOString()});onClose()}}}>Post</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Message</label><textarea style={{...S.textarea,minHeight:80}} value={text} onChange={e=>setText(e.target.value)} placeholder="Share with your team..."/></div>
  </Modal>
}


// ── ActionItemRow — must be a component (not inline in .map) for useState hooks ──
function ActionItemRow({a,canEdit,priorityColor,priorityBg,today,toggleItem,deleteItem,saveEdit}){
  const [editing,setEditing]=useState(false);
  const [editVal,setEditVal]=useState(a.text);
  const pri=a.priority||"Medium";
  const isOverdueDue=a.dueDate&&new Date(a.dueDate)<today&&!a.done;
  return <div style={{display:"flex",alignItems:"flex-start",gap:8,padding:"8px 0",borderBottom:`1px solid ${C.card}`,opacity:a.done?.6:1,transition:"opacity .15s"}}>
    <input type="checkbox" checked={!!a.done} onChange={()=>toggleItem(a.id)} style={{accentColor:C.accent,width:15,height:15,flexShrink:0,marginTop:2,cursor:"pointer"}}/>
    <div style={{width:3,height:18,background:a.done?C.textDim:priorityColor(pri),borderRadius:2,flexShrink:0,marginTop:2}}/>
    <div style={{flex:1,fontSize:12,minWidth:0}}>
      {editing&&canEdit
        ?<div style={{display:"flex",gap:6,alignItems:"center"}}>
          <input autoFocus style={{...S.input,flex:1,fontSize:12,padding:"3px 8px",height:28}} value={editVal} onChange={e=>setEditVal(e.target.value)}
            onKeyDown={e=>{if(e.key==="Enter"&&editVal.trim()){saveEdit(a.id,editVal.trim());setEditing(false);}if(e.key==="Escape"){setEditing(false);setEditVal(a.text);}}}/>
          <button style={{...S.btnSm,padding:"3px 10px",fontSize:11}} onClick={()=>{if(editVal.trim()){saveEdit(a.id,editVal.trim());setEditing(false);}}}>Save</button>
          <button style={{...S.btnO,padding:"3px 8px",fontSize:11}} onClick={()=>{setEditing(false);setEditVal(a.text);}}>✕</button>
        </div>
        :<div style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textDecoration:a.done?"line-through":"none",color:a.done?C.textDim:C.text,cursor:canEdit&&!a.done?"text":"default"}}
          onClick={()=>canEdit&&!a.done&&setEditing(true)} title={canEdit&&!a.done?"Click to edit":a.text}>{a.text}</div>}
      {a.dueDate&&!editing&&<span style={{fontSize:9,color:isOverdueDue?C.red:C.textDim,fontWeight:isOverdueDue?700:400}}>{isOverdueDue?"⚠":"📅"} {a.dueDate}</span>}
      {a.done&&!editing&&<span style={{fontSize:9,color:C.green,marginLeft:4}}>✓ done</span>}
    </div>
    {!editing&&<Badge bg={a.done?C.card:priorityBg(pri)} fg={a.done?C.textDim:priorityColor(pri)}>{pri[0]}</Badge>}
    {!editing&&canEdit&&<button onClick={()=>deleteItem(a.id)} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:0,flexShrink:0}} title="Delete">×</button>}
  </div>;
}

// ══════════════════════════════════════════════════════════════
// PROJECT DETAIL VIEW
// ══════════════════════════════════════════════════════════════

function DayEditorModal({date,events,project,users,onClose,onAddDeadline,onAddCustomEvent,onDeleteEvent,onUpdateDeadline,onDeleteDeadline}){
  const [mode,setMode]=useState(null); // null | "deadline" | "event" | "editDeadline"
  const [dlTitle,setDlTitle]=useState("Deliverable Deadline");
  const [reviewerId,setReviewerId]=useState("");
  const [dlDate,setDlDate]=useState(date);
  // Internal deadline defaults to 7 days before main deadline
  const defaultInternal=(d)=>{const dt=new Date(d);dt.setDate(dt.getDate()-7);return dt.toISOString().split("T")[0]};
  const [internalDate,setInternalDate]=useState(defaultInternal(date));
  const [evTitle,setEvTitle]=useState("");
  const [evColor,setEvColor]=useState(C.accent);
  const [editingDeadline,setEditingDeadline]=useState(null); // deadline object being edited

  const dateLabel=new Date(date).toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"});
  const staffList=users.filter(u=>isStaff(u)&&u.status!=="pending");

  const handleAddDeadline=()=>{
    if(!dlTitle.trim())return;
    const extraData={internalDate,date:dlDate};
    onAddDeadline(dlTitle.trim(),reviewerId,extraData);
  };

  const startEditDeadline=(dl)=>{
    setEditingDeadline(dl);
    setDlTitle(dl.title||"Deliverable Deadline");
    setReviewerId(dl.reviewer||"");
    setDlDate(dl.date);
    setInternalDate(dl.internalDate||defaultInternal(dl.date));
    setMode("editDeadline");
  };

  const handleSaveEdit=()=>{
    if(!editingDeadline||!dlTitle.trim())return;
    onUpdateDeadline&&onUpdateDeadline(project.id,editingDeadline.id,{
      title:dlTitle.trim(),
      reviewer:reviewerId||null,
      date:dlDate,
      internalDate:internalDate||null
    });
    setMode(null);
    setEditingDeadline(null);
  };

  const handleDeleteDl=(dl)=>{
    if(!confirm(`Delete deadline "${dl.title||"Deadline"}"? This also removes its design/review phases.`))return;
    onDeleteDeadline&&onDeleteDeadline(project.id,dl.id);
  };

  // Collect deadlines that reference this date (either main or internal)
  const dayDeadlines=(project.deadlines||[]).filter(d=>d.date===date||d.internalDate===date);

  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} style={{background:"var(--surface)",borderRadius:14,boxShadow:"0 20px 60px rgba(0,0,0,.3)",width:"100%",maxWidth:560,maxHeight:"90vh",overflow:"auto"}}>
      <div style={{padding:"18px 22px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:18,fontWeight:700}}>📅 {dateLabel}</div>
          <div style={{fontSize:12,color:C.textDim,marginTop:2}}>{project.name} · {project.number}</div>
        </div>
        <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",fontSize:20,color:C.textDim,padding:4}}>×</button>
      </div>

      <div style={{padding:"16px 22px"}}>
        {/* Existing deadlines on this day — with edit/delete */}
        {dayDeadlines.length>0&&<div style={{marginBottom:16}}>
          <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:C.red,marginBottom:8}}>🔴 Deadlines on this day ({dayDeadlines.length})</div>
          {dayDeadlines.map(dl=>{
            const isMain=dl.date===date;
            const isInternal=dl.internalDate===date;
            const reviewerName=dl.reviewer?users.find(u=>u.id===dl.reviewer)?.name:null;
            return <div key={dl.id} style={{padding:"10px 12px",background:C.redSoft,borderRadius:8,marginBottom:6,borderLeft:`4px solid ${isMain?C.red:C.amber}`}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,marginBottom:6}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:13,color:isMain?C.red:C.amber}}>{isMain?"DEADLINE":"INTERNAL DEADLINE"} · {dl.title||"Deadline"}</div>
                  <div style={{fontSize:11,color:C.textDim,marginTop:2}}>
                    Main: {dl.date}{dl.internalDate?` · Internal: ${dl.internalDate}`:" · (no internal deadline)"}
                    {reviewerName?` · Reviewer: ${reviewerName}`:""}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:6}}>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11,flex:1}} onClick={()=>startEditDeadline(dl)}>✏️ Edit</button>
                <button style={{...S.btnO,padding:"4px 10px",fontSize:11,color:C.red,borderColor:C.red}} onClick={()=>handleDeleteDl(dl)}>🗑 Delete</button>
              </div>
            </div>;
          })}
        </div>}

        {/* Auto-generated phases + custom events */}
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",color:C.textMid,marginBottom:8}}>Events on this day ({events.length})</div>
        {events.length===0&&<div style={{padding:12,background:C.card,borderRadius:8,color:C.textDim,fontSize:13,textAlign:"center",marginBottom:16}}>No events scheduled.</div>}
        {events.map((ev,i)=>{const isAutoGen=ev.type==="design"||ev.type==="review"||ev.type==="internal";const isDeadline=ev.type==="deadline";return <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:C.card,borderRadius:8,marginBottom:6,borderLeft:`4px solid ${ev.color}`}}>
          <div style={{flex:1}}>
            <div style={{fontWeight:600,fontSize:13}}>{ev.title}</div>
            <div style={{fontSize:10,color:C.textDim,textTransform:"capitalize"}}>{ev.type}{ev.deadlineRef?.reviewer?` · Reviewer: ${users.find(u=>u.id===ev.deadlineRef.reviewer)?.name||"?"}`:""}</div>
          </div>
          {!isAutoGen&&!isDeadline&&<button onClick={()=>onDeleteEvent(ev)} style={{...S.btnO,padding:"4px 10px",fontSize:11,color:C.red,borderColor:C.red}}>Delete</button>}
          {isAutoGen&&<span style={{fontSize:10,color:C.textDim}}>Auto-generated</span>}
          {isDeadline&&<span style={{fontSize:10,color:C.textDim}}>See above</span>}
        </div>})}

        {/* Add buttons */}
        {!mode&&<div style={{display:"flex",gap:8,marginTop:16}}>
          <button style={{...S.btn,flex:1}} onClick={()=>{setMode("deadline");setDlDate(date);setInternalDate(defaultInternal(date))}}>🔴 Add Deadline</button>
          <button style={{...S.btnO,flex:1}} onClick={()=>setMode("event")}>📌 Add Event</button>
        </div>}

        {/* Add Deadline form (now includes internal deadline) */}
        {(mode==="deadline"||mode==="editDeadline")&&<div style={{marginTop:16,padding:16,background:C.redSoft,borderRadius:10}}>
          <div style={{fontSize:12,fontWeight:700,marginBottom:10,color:C.red}}>{mode==="editDeadline"?"EDIT DEADLINE":"ADD DEADLINE"}</div>

          <div style={S.inputGroup}>
            <label style={S.label}>Deadline Title *</label>
            <input style={S.input} value={dlTitle} onChange={e=>setDlTitle(e.target.value)} placeholder="e.g. 60% Design Delivery"/>
          </div>

          <div style={{display:"flex",gap:10}}>
            <div style={{...S.inputGroup,flex:1}}>
              <label style={S.label}>Main Deadline Date *</label>
              <input type="date" style={S.input} value={dlDate} onChange={e=>{
                setDlDate(e.target.value);
                // Auto-update internal to 7 days before
                if(e.target.value)setInternalDate(defaultInternal(e.target.value));
              }}/>
            </div>
            <div style={{...S.inputGroup,flex:1}}>
              <label style={S.label}>Internal Deadline Date</label>
              <input type="date" style={S.input} value={internalDate} onChange={e=>setInternalDate(e.target.value)} max={dlDate}/>
              <div style={{fontSize:10,color:C.textDim,marginTop:2}}>Review phase runs between internal & main</div>
            </div>
          </div>

          <div style={S.inputGroup}>
            <label style={S.label}>Assign Reviewer (optional)</label>
            <select style={S.select} value={reviewerId} onChange={e=>setReviewerId(e.target.value)}>
              <option value="">-- No reviewer --</option>
              {staffList.map(u=><option key={u.id} value={u.id}>{u.name} ({u.role})</option>)}
            </select>
          </div>

          {/* Timeline preview */}
          {dlDate&&<div style={{background:"var(--surface-2)",borderRadius:8,padding:10,marginBottom:10,fontSize:11}}>
            <div style={{fontWeight:700,marginBottom:6,color:C.textMid,textTransform:"uppercase",fontSize:10}}>Timeline preview</div>
            <div style={{display:"flex",alignItems:"center",gap:4,flexWrap:"wrap"}}>
              <span style={{background:"#10B981",color:"#fff",padding:"2px 8px",borderRadius:4,fontWeight:600}}>Design</span>
              <span style={{color:C.textDim}}>→</span>
              {internalDate&&<><span style={{background:C.amber,color:"#fff",padding:"2px 8px",borderRadius:4,fontWeight:600}}>Internal {internalDate}</span>
              <span style={{color:C.textDim}}>→</span>
              <span style={{background:"#A78BFA",color:"#fff",padding:"2px 8px",borderRadius:4,fontWeight:600}}>Review</span>
              <span style={{color:C.textDim}}>→</span></>}
              <span style={{background:C.red,color:"#fff",padding:"2px 8px",borderRadius:4,fontWeight:600}}>Deadline {dlDate}</span>
            </div>
          </div>}

          <div style={{display:"flex",gap:8,marginTop:12}}>
            {mode==="editDeadline"?<button style={{...S.btn,flex:1,opacity:dlTitle.trim()?1:.4}} onClick={handleSaveEdit}>✓ Save Changes</button>
            :<button style={{...S.btn,flex:1,opacity:dlTitle.trim()?1:.4}} onClick={handleAddDeadline}>✓ Add Deadline</button>}
            <button style={S.btnO} onClick={()=>{setMode(null);setEditingDeadline(null);setDlTitle("Deliverable Deadline");setReviewerId("");setDlDate(date);setInternalDate(defaultInternal(date))}}>Cancel</button>
          </div>
        </div>}

        {/* Add Event form */}
        {mode==="event"&&<div style={{marginTop:16,padding:16,background:C.accentSoft,borderRadius:10}}>
          <div style={{fontSize:12,fontWeight:700,marginBottom:10,color:C.accent}}>ADD CUSTOM EVENT</div>
          <div style={S.inputGroup}>
            <label style={S.label}>Event Title *</label>
            <input style={S.input} value={evTitle} onChange={e=>setEvTitle(e.target.value)} placeholder="e.g. Client meeting"/>
          </div>
          <div style={S.inputGroup}>
            <label style={S.label}>Color</label>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {[C.accent,C.purple,"#10B981","#A78BFA",C.amber,C.red].map(col=><div key={col} onClick={()=>setEvColor(col)} style={{width:32,height:32,borderRadius:8,background:col,cursor:"pointer",border:`3px solid ${evColor===col?"#1E293B":"transparent"}`}}/>)}
            </div>
          </div>
          <div style={{display:"flex",gap:8,marginTop:12}}>
            <button style={{...S.btn,flex:1,opacity:evTitle.trim()?1:.4}} onClick={()=>evTitle.trim()&&onAddCustomEvent(evTitle.trim(),evColor)}>✓ Add Event</button>
            <button style={S.btnO} onClick={()=>{setMode(null);setEvTitle("");setEvColor(C.accent)}}>Cancel</button>
          </div>
        </div>}
      </div>
    </div>
  </div>;
}

// ── PROJECT REGISTERS — RFI & Transmittal logs ─────────────────
// The two documents every engineering consultancy keeps per project. Stored on
// the project object (rfis / transmittals) through the normal update path.
// ── PROJECT REGISTERS — RFI, Shop Drawing & Transmittal tracking ─────────────
// Built for high-volume Aconex workflows: paste "SFSP-RFIDE-000667 - Top of Shaft
// Devices" (one line or many) into the quick-log bar and each line becomes an open
// item with a due date. Stored on the project object through the normal update path.
function RegistersTab({project:p,user,users,onUpdateProject}){
  const [reg,setReg]=useState("rfi");            // "rfi" | "sd" | "tx"
  const [filter,setFilter]=useState("open");     // "all" | "open" | "overdue" | "closed"
  const [quick,setQuick]=useState("");
  const [dueDays,setDueDays]=useState(7);
  const [adding,setAdding]=useState(false);
  const [form,setForm]=useState({});
  const today=new Date().toISOString().slice(0,10);
  const REGS={
    rfi:{key:"rfis",label:"RFIs",prefix:"RFI",statuses:["Open","Answered","Closed"],closed:["Answered","Closed"],ph:"Paste from Aconex — e.g.  SFSP-RFIDE-000667 - Top of Shaft Devices"},
    sd:{key:"shopDrawings",label:"Shop Drawings",prefix:"SD",statuses:["Open","Reviewed","Rev & Resubmit","Closed"],closed:["Reviewed","Closed"],ph:"Paste shop drawing — e.g.  SFSP-SD-000123 - Mezzanine Cable Tray Layout"},
    tx:{key:"transmittals",label:"Transmittals",prefix:"TR",statuses:["Issued","Acknowledged"],closed:["Acknowledged"],ph:"e.g.  TR-014 - IFC drawing set Rev 2"},
  };
  const R=REGS[reg];
  const items=p[R.key]||[];
  const save=(list)=>onUpdateProject(p.id,{[R.key]:list});
  const isClosed=(r)=>R.closed.includes(r.status);
  const isOverdue=(r)=>!isClosed(r)&&r.due&&r.due<today;
  const addDays=(d,n)=>{const t=new Date(d+"T12:00:00");t.setDate(t.getDate()+n);return t.toISOString().slice(0,10);};
  const nextNum=(list)=>{const max=list.reduce((m,r)=>{const n=parseInt((r.num||"").split("-").pop(),10);return isNaN(n)?m:Math.max(m,n)},0);return `${R.prefix}-${String(max+1).padStart(3,"0")}`;};
  // "NUM - Title" → {num,title}; lines without a recognizable number get an auto one.
  const parseLine=(line,list)=>{
    const s=line.trim();if(!s)return null;
    const m=s.match(/^([A-Za-z0-9][A-Za-z0-9._\/-]{2,40})\s*[-–—:]\s+(.+)$/);
    if(m&&/\d/.test(m[1]))return {num:m[1].trim(),title:m[2].trim()};
    return {num:nextNum(list),title:s};
  };
  const logQuick=(text)=>{
    const lines=text.split(/\n+/).map(l=>l.trim()).filter(Boolean);
    if(!lines.length)return;
    let list=[...items];const stamp=Date.now();
    lines.forEach((l,i)=>{const parsed=parseLine(l,list);if(!parsed)return;
      list.push({id:"reg_"+(stamp+i),num:parsed.num,title:parsed.title,actionBy:"",by:user.id,date:today,due:addDays(today,dueDays),status:R.statuses[0],priority:false,note:""});});
    save(list);setQuick("");
  };
  const submitForm=()=>{
    if(!(form.title||"").trim())return;
    save([...items,{id:"reg_"+Date.now(),num:(form.num||"").trim()||nextNum(items),title:form.title.trim(),actionBy:(form.actionBy||"").trim(),by:user.id,date:form.date||today,due:form.due||addDays(form.date||today,dueDays),status:R.statuses[0],priority:!!form.priority,note:(form.note||"").trim()}]);
    setForm({});setAdding(false);
  };
  const patch=(id,q)=>save(items.map(r=>r.id===id?{...r,...q}:r));
  const remove=(id)=>{if(confirm("Delete this entry? This can't be undone."))save(items.filter(r=>r.id!==id));};
  const exportCSV=()=>{
    const esc=(v)=>`"${String(v??"").replace(/"/g,'""')}"`;
    const head=["Number","Title","Action By","Status","Date Received","Due Date","Priority","Response / Notes"];
    const rows=items.map(r=>[r.num,r.title,r.actionBy||r.to||"",isOverdue(r)?"Overdue":r.status,r.date,r.due||"",r.priority?"High":"",r.note||r.items||""]);
    const csv=[head,...rows].map(row=>row.map(esc).join(",")).join("\r\n");
    const a=document.createElement("a");
    a.href=URL.createObjectURL(new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8"}));
    a.download=`${(p.number||p.id)}-${R.label.replace(/ /g,"")}.csv`;a.click();URL.revokeObjectURL(a.href);
  };
  const counts={all:items.length,open:items.filter(r=>!isClosed(r)).length,overdue:items.filter(isOverdue).length,closed:items.filter(isClosed).length};
  const shown=items.filter(r=>filter==="all"?true:filter==="open"?!isClosed(r):filter==="overdue"?isOverdue(r):isClosed(r))
    .slice().sort((a,b)=>{
      const ca=isClosed(a)?1:0,cb=isClosed(b)?1:0;if(ca!==cb)return ca-cb;              // open before closed
      if(a.priority!==b.priority)return a.priority?-1:1;                                  // high priority first
      return (a.due||"9999").localeCompare(b.due||"9999")||(a.num||"").localeCompare(b.num||"");
    });
  const nameOf=(uid)=>users.find(u=>u.id===uid)?.name||"—";
  const FCHIPS=[["open","Open",counts.open],["overdue","Overdue",counts.overdue],["closed","Closed",counts.closed],["all","All",counts.all]];
  return <div>
    {/* Register switch + export */}
    <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:12}}>
      <div style={{display:"inline-flex",background:"var(--n-100)",borderRadius:9,padding:3}}>
        {Object.entries(REGS).map(([id,r])=><button key={id} onClick={()=>{setReg(id);setAdding(false);setForm({});setFilter("open")}} style={{padding:"6px 14px",border:"none",borderRadius:7,cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:12.5,fontWeight:600,background:reg===id?"var(--surface)":"transparent",color:reg===id?"var(--text)":"var(--text-3)",boxShadow:reg===id?"var(--shadow-xs)":"none",transition:"all .12s"}}>{r.label}{(p[r.key]||[]).filter(x=>!REGS[id].closed.includes(x.status)).length>0&&<span style={{marginLeft:6,fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:999,background:"color-mix(in srgb,var(--a-500) 15%,transparent)",color:"var(--a-600,var(--a-500))"}}>{(p[r.key]||[]).filter(x=>!REGS[id].closed.includes(x.status)).length}</span>}</button>)}
      </div>
      <div style={{flex:1}}/>
      {items.length>0&&<button onClick={exportCSV} style={{...S.btnO,height:32,padding:"0 12px",fontSize:12}} title="Download this register as CSV for client reports">⬇ Export CSV</button>}
      <button onClick={()=>{setAdding(a=>!a);setForm({})}} style={{...S.btnO,height:32,padding:"0 12px",fontSize:12}}>{adding?"Close form":"Detailed entry"}</button>
    </div>

    {/* Quick log — the fast path. Paste one line or a whole list. */}
    <div style={{...S.card,padding:"12px 14px",marginBottom:12,borderLeft:"3px solid var(--a-500)"}}>
      <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
        <span style={{fontSize:12,fontWeight:700}}>⚡ Quick log</span>
        <span style={{fontSize:11,color:"var(--text-3)"}}>type or paste, Enter to add — pasting multiple lines logs them all</span>
        <span style={{marginLeft:"auto",fontSize:11,color:"var(--text-3)"}}>due in
          <select value={dueDays} onChange={e=>setDueDays(+e.target.value)} style={{...S.select,height:26,fontSize:11,margin:"0 4px",width:64}}>{[3,5,7,10,14,21].map(d=><option key={d} value={d}>{d} d</option>)}</select>
        </span>
      </div>
      <textarea value={quick} onChange={e=>setQuick(e.target.value)}
        onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();logQuick(quick);}}}
        onPaste={e=>{const t=e.clipboardData.getData("text");if(t.includes("\n")){e.preventDefault();logQuick(quick?quick+"\n"+t:t);}}}
        placeholder={R.ph} rows={1}
        style={{...S.input,marginTop:8,minHeight:38,height:"auto",fontSize:13,resize:"vertical",width:"100%",fontFamily:"var(--font-mono,monospace)"}}/>
    </div>

    {/* Detailed entry form */}
    {adding&&<div style={{...S.card,padding:16,marginBottom:12}}>
      <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:10}}>
        <label style={{display:"flex",flexDirection:"column",gap:4,minWidth:170}}><span style={{fontSize:11,fontWeight:600,color:"var(--text-2)"}}>Number <span style={{color:"var(--text-3)",fontWeight:400}}>(blank = auto {nextNum(items)})</span></span><input value={form.num||""} onChange={e=>setForm(f=>({...f,num:e.target.value}))} placeholder={nextNum(items)} style={{...S.input,height:34,fontSize:13,fontFamily:"var(--font-mono,monospace)"}}/></label>
        <label style={{display:"flex",flexDirection:"column",gap:4,flex:2,minWidth:200}}><span style={{fontSize:11,fontWeight:600,color:"var(--text-2)"}}>Title</span><input value={form.title||""} onChange={e=>setForm(f=>({...f,title:e.target.value}))} placeholder="Subject / description" style={{...S.input,height:34,fontSize:13}}/></label>
        <label style={{display:"flex",flexDirection:"column",gap:4,minWidth:150}}><span style={{fontSize:11,fontWeight:600,color:"var(--text-2)"}}>Action by</span><input value={form.actionBy||""} onChange={e=>setForm(f=>({...f,actionBy:e.target.value}))} placeholder="e.g. Electrical (AECOM)" style={{...S.input,height:34,fontSize:13}}/></label>
      </div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"flex-end"}}>
        <label style={{display:"flex",flexDirection:"column",gap:4}}><span style={{fontSize:11,fontWeight:600,color:"var(--text-2)"}}>Received</span><input type="date" value={form.date||today} onChange={e=>setForm(f=>({...f,date:e.target.value}))} style={{...S.input,height:34,fontSize:13}}/></label>
        <label style={{display:"flex",flexDirection:"column",gap:4}}><span style={{fontSize:11,fontWeight:600,color:"var(--text-2)"}}>Due</span><input type="date" value={form.due||addDays(form.date||today,dueDays)} onChange={e=>setForm(f=>({...f,due:e.target.value}))} style={{...S.input,height:34,fontSize:13}}/></label>
        <label style={{display:"flex",alignItems:"center",gap:6,height:34,cursor:"pointer"}}><input type="checkbox" checked={!!form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.checked}))}/><span style={{fontSize:12,fontWeight:600,color:"var(--red-500)"}}>High priority</span></label>
        <button onClick={submitForm} disabled={!(form.title||"").trim()} style={{...S.btn,height:34,padding:"0 18px",fontSize:13,opacity:(form.title||"").trim()?1:.5}}>Add</button>
      </div>
    </div>}

    {/* Filter chips */}
    <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:12}}>
      {FCHIPS.map(([id,label,n])=><button key={id} onClick={()=>setFilter(id)} style={{padding:"5px 12px",borderRadius:999,cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:12,fontWeight:600,border:"1px solid "+(filter===id?(id==="overdue"?"var(--red-500)":"var(--a-500)"):"var(--border)"),background:filter===id?(id==="overdue"?"color-mix(in srgb,var(--red-500) 10%,transparent)":"color-mix(in srgb,var(--a-500) 10%,transparent)"):"transparent",color:filter===id?(id==="overdue"?"var(--red-500)":"var(--a-600,var(--a-500))"):"var(--text-3)"}}>{label} <span style={{fontVariantNumeric:"tabular-nums"}}>{n}</span></button>)}
    </div>

    {/* Register list */}
    {shown.length===0?<div style={{...S.card,padding:"34px 20px",textAlign:"center"}}>
      <div style={{fontSize:24,marginBottom:6}}>{filter==="closed"?"📁":filter==="overdue"?"✅":"📨"}</div>
      <div style={{fontSize:13.5,fontWeight:600,marginBottom:3}}>{filter==="overdue"?"Nothing overdue":filter==="closed"?"Nothing closed yet":"No "+(filter==="all"?"":"open ")+R.label.toLowerCase()}</div>
      <div style={{fontSize:12,color:"var(--text-3)"}}>Log items in the quick bar above — paste straight from Aconex.</div>
    </div>:
    <div style={{display:"flex",flexDirection:"column",gap:6}}>
      {shown.map(r=>{
        const od=isOverdue(r);const closed=isClosed(r);
        return <div key={r.id} style={{...S.card,padding:"10px 12px",borderLeft:`3px solid ${od?"var(--red-500)":closed?"var(--border)":r.priority?"var(--amber-500,#d97706)":"var(--a-500)"}`,opacity:closed?0.72:1}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:11.5,fontWeight:700,fontFamily:"var(--font-mono,monospace)",color:"var(--text-2)",whiteSpace:"nowrap"}}>{r.num}</span>
            {r.priority&&!closed&&<span style={{fontSize:9,fontWeight:800,padding:"1px 6px",borderRadius:999,background:"color-mix(in srgb,var(--red-500) 12%,transparent)",color:"var(--red-500)",letterSpacing:"0.04em"}}>HIGH</span>}
            <span style={{fontSize:13,fontWeight:600,flex:1,minWidth:160,textDecoration:closed?"line-through":"none"}}>{r.title}</span>
            <span style={{fontSize:10.5,fontWeight:700,padding:"3px 9px",borderRadius:999,whiteSpace:"nowrap",background:od?"var(--red-500)":closed?"var(--n-100)":"color-mix(in srgb,var(--a-500) 13%,transparent)",color:od?"#fff":closed?"var(--text-3)":"var(--a-600,var(--a-500))"}}>{od?"OVERDUE":r.status.toUpperCase()}</span>
          </div>
          <div style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:6,fontSize:11.5,color:"var(--text-3)",alignItems:"center"}}>
            <span>Rec: {r.date||"—"}</span>
            <span style={{color:od?"var(--red-500)":undefined,fontWeight:od?700:400}}>Due: {r.due||"—"}</span>
            <span style={{display:"inline-flex",alignItems:"center",gap:4}}>By:
              <input defaultValue={r.actionBy||r.to||r.ball||""} key={r.id+"_ab"} onBlur={e=>{if(e.target.value!==(r.actionBy||""))patch(r.id,{actionBy:e.target.value})}} placeholder="action by…" style={{...S.input,height:24,fontSize:11,width:150,padding:"0 7px"}}/>
            </span>
            <span>Logged: {nameOf(r.by)}</span>
          </div>
          <div style={{display:"flex",gap:6,marginTop:8,flexWrap:"wrap",alignItems:"center"}}>
            {R.statuses.filter(st=>st!==r.status).map(st=><button key={st} onClick={()=>patch(r.id,{status:st})} style={{...S.btnO,height:25,padding:"0 10px",fontSize:11}}>{st}</button>)}
            {!closed&&<button onClick={()=>patch(r.id,{priority:!r.priority})} style={{...S.btnO,height:25,padding:"0 10px",fontSize:11,color:r.priority?"var(--red-500)":"var(--text-3)",borderColor:r.priority?"var(--red-500)":"var(--border)"}}>{r.priority?"▾ Normal":"▴ High"}</button>}
            <input defaultValue={r.note||""} key={r.id+"_note"} onBlur={e=>{if(e.target.value!==(r.note||""))patch(r.id,{note:e.target.value})}} placeholder="response / notes…" style={{...S.input,height:25,fontSize:11,flex:1,minWidth:140,padding:"0 8px"}}/>
            {(isAdmin(user)||r.by===user.id)&&<button onClick={()=>remove(r.id)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-3)",fontSize:12,padding:"0 4px",fontFamily:"var(--font-sans)"}} title="Delete">🗑</button>}
          </div>
        </div>;
      })}
    </div>}
  </div>;
}

function ProjectDetailView({project:p,user,users,onBack,setModal,onUpdateProgress,onToggleMilestone,hideBudgetSpend,onChangeStatus,onDeleteProject,onAddResponse,onAddCoordNote,onUpdateProject,onUpdateFocus,actionItems,onUpdateActions,issues,setIssues,companyInfo}){
  const [tab,setTab]=useState("overview");
  const [ganttUnit,setGanttUnit]=useState("week"); // "week" | "day"
  const [showActions,setShowActions]=useState(false);
  const [showStatusMenu,setShowStatusMenu]=useState(false);
  const statusButtonRef=useRef(null);
  const [statusMenuPos,setStatusMenuPos]=useState({top:0,left:0});
  const [menuPos,setMenuPos]=useState({top:0,right:0});
  const actionsButtonRef=useRef(null);
  const [showAddTeamMember,setShowAddTeamMember]=useState(false);
  const [expandedRFI,setExpandedRFI]=useState(null);
  const [replyText,setReplyText]=useState("");
  const [rfiFilter,setRfiFilter]=useState("all");
  const [replyFiles,setReplyFiles]=useState([]);
  const [actionWeekOffset,setActionWeekOffset]=useState(0);
  const [newActionText,setNewActionText]=useState("");
  const [newActionPriority,setNewActionPriority]=useState("Medium");
  const [newActionDueDate,setNewActionDueDate]=useState("");

  const viewWeekStart=getWeekStart(new Date());
  viewWeekStart.setDate(viewWeekStart.getDate()+actionWeekOffset*7);
  const viewWeekKey=viewWeekStart.toISOString().split("T")[0];
  const viewWeekDates=getWeekDates(viewWeekStart);
  const today=new Date();today.setHours(0,0,0,0);

  const canEdit=onUpdateProject&&(isAdmin(user)||isPM(user));
  const canUpdate=onUpdateProject&&(isAdmin(user)||isPM(user)||isDesigner(user));

  const projActions=actionItems?.[p.id]||[];

  const priorityColor=(pri)=>pri==="High"?C.red:pri==="Low"?C.green:C.amber;
  const priorityBg=(pri)=>pri==="High"?C.redSoft:pri==="Low"?C.greenSoft:C.amberSoft;

  const addItem=()=>{
    const t=newActionText.trim();
    if(!t)return;
    const item={id:genId("act"),text:t,done:false,assignee:user.id,weekKey:viewWeekKey,priority:newActionPriority,dueDate:newActionDueDate||null,date:new Date().toISOString().split("T")[0]};
    onUpdateActions&&onUpdateActions(p.id,[...projActions,item]);
    setNewActionText("");setNewActionDueDate("");
  };
  const toggleItem=(aid)=>{
    const latest=actionItems[p.id]||[];
    onUpdateActions&&onUpdateActions(p.id,latest.map(a=>a.id===aid?{...a,done:!a.done}:a));
  };
  const deleteItem=(aid)=>{
    const latest=actionItems[p.id]||[];
    onUpdateActions&&onUpdateActions(p.id,latest.filter(a=>a.id!==aid));
  };
  const saveEdit=(aid,newText)=>{
    const latest=actionItems[p.id]||[];
    onUpdateActions&&onUpdateActions(p.id,latest.map(a=>a.id===aid?{...a,text:newText}:a));
  };

  const teamMembers=users.filter(u=>(p.team||[]).includes(u.id));
  const allUsers=users.filter(u=>u.status!=="pending");
  const unassigned=allUsers.filter(u=>!(p.team||[]).includes(u.id));

  // Group action items by assignee
  const byAuthor={};
  projActions.forEach(a=>{const uid=a.assignee||user.id;if(!byAuthor[uid])byAuthor[uid]=[];byAuthor[uid].push(a);});

  const tabs=["overview",...(isStaff(user)?["actions"]:[]),"timeline","coordination","decisions","registers"];

  const showBudget=!hideBudgetSpend;
  const budgetTotal=p.budget?.total||0;
  const budgetSpent=p.budget?.spent||0;
  const budgetPct=budgetTotal>0?Math.round(budgetSpent/budgetTotal*100):0;

  // ── Phase progression for the phase track ──────────────────
  const DEFAULT_PHASES=["Proposal","Schematic Design","Design Development","IFC","Construction Admin","Closeout"];
  const PHASES=p.customPhases&&p.customPhases.length>0?p.customPhases:DEFAULT_PHASES;
  const currentPhaseIndex=Math.max(0,PHASES.findIndex(ph=>ph.toLowerCase()===String(p.phase||"").toLowerCase()));
  const thumbLabel=p.number||p.name?.slice(0,6)||"??";
  const thumbFontSize=thumbLabel.length>6?8:thumbLabel.length>4?9:11;
  const openRFIs=(p.issues||[]).filter(i=>i.status!=="Closed").length;
  const overdueActionCount=projActions.filter(a=>!a.done&&a.dueDate&&new Date(a.dueDate)<today).length;

  return <div style={{flex:1,minWidth:0}}>
    {/* ── HERO — bordered surface header ─────────────────────────── */}
    <div style={{padding:"22px 32px",borderBottom:"1px solid var(--border)",background:"var(--surface)"}}>
      {/* Breadcrumb */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10,fontSize:12}}>
        <button onClick={onBack} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-3)",fontSize:12,fontWeight:500,padding:0,fontFamily:"var(--font-sans)",display:"inline-flex",alignItems:"center",gap:3}}>‹ All projects</button>
        <span style={{color:"var(--text-4)"}}>·</span>
        <span style={{color:"var(--text-3)",fontFamily:"var(--font-mono)",fontSize:12,fontWeight:500}}>{p.number}</span>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:24,alignItems:"flex-start"}}>
        <div>
          {/* Title row: thumb + name + status */}
          <div style={{display:"flex",alignItems:"flex-start",gap:14,marginBottom:8}}>
            <div style={{width:48,height:48,borderRadius:10,background:"linear-gradient(135deg, var(--a-400), var(--a-600))",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:thumbFontSize,letterSpacing:"0.01em",flexShrink:0,fontFamily:"var(--font-mono)",textAlign:"center",lineHeight:1.2,padding:"2px 4px"}}>{thumbLabel}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4,flexWrap:"wrap"}}>
                <h1 style={{fontSize:26,fontWeight:600,letterSpacing:"-0.025em",margin:0,lineHeight:1.2}}>{p.name}</h1>
                <button ref={statusButtonRef}
                  disabled={!canEdit}
                  onClick={()=>{
                    if(!canEdit)return;
                    if(statusButtonRef.current){const r=statusButtonRef.current.getBoundingClientRect();setStatusMenuPos({top:r.bottom+4,left:r.left});}
                    setShowStatusMenu(v=>!v);
                  }}
                  style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 9px",borderRadius:6,
                  background:p.status==="In Progress"?"color-mix(in srgb, var(--green-500) 12%, transparent)":p.status==="On Hold"?"color-mix(in srgb, var(--amber-500) 12%, transparent)":p.status==="Completed"?"var(--n-100)":"var(--n-100)",
                  border:`1px solid ${p.status==="In Progress"?"color-mix(in srgb, var(--green-500) 28%, transparent)":p.status==="On Hold"?"color-mix(in srgb, var(--amber-500) 28%, transparent)":"var(--border)"}`,
                  fontSize:11,fontWeight:600,
                  color:p.status==="In Progress"?"var(--green-600)":p.status==="On Hold"?"var(--amber-600)":"var(--text-2)",
                  cursor:canEdit?"pointer":"default",fontFamily:"var(--font-sans)",transition:"opacity .12s"}}
                  title={canEdit?"Click to change status":""}>
                  {p.status==="In Progress"&&<span style={{position:"relative",width:8,height:8,display:"inline-flex"}}>
                    <span style={{position:"absolute",inset:0,borderRadius:999,background:"var(--green-500)"}}/>
                    <span style={{position:"absolute",inset:-2,borderRadius:999,background:"var(--green-500)",opacity:.25}}/>
                  </span>}
                  {p.status}{canEdit&&<span style={{fontSize:8,opacity:.6,marginLeft:1}}>▾</span>}
                </button>
                {showStatusMenu&&canEdit&&<>
                  <div onClick={()=>setShowStatusMenu(false)} style={{position:"fixed",inset:0,zIndex:99}}/>
                  <div style={{position:"fixed",top:statusMenuPos.top,left:statusMenuPos.left,background:"var(--surface)",border:"1px solid var(--border)",borderRadius:10,boxShadow:"var(--shadow-md)",zIndex:100,minWidth:180,overflow:"hidden",fontFamily:"var(--font-sans)"}}>
                    {[
                      ["In Progress","var(--green-500)","var(--green-600)","▶"],
                      ["On Hold","var(--amber-500)","var(--amber-600)","⏸"],
                      ["Completed","var(--a-500)","var(--a-600)","✓"]
                    ].map(([s,bg,fg,icon])=>{
                      const active=p.status===s;
                      return <button key={s} onClick={()=>{onChangeStatus(p.id,s);setShowStatusMenu(false)}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:active?"var(--surface-2)":"transparent",border:"none",borderBottom:s==="Completed"?"none":"1px solid var(--divider)",fontSize:13,color:fg,fontWeight:500,cursor:"pointer",textAlign:"left",fontFamily:"var(--font-sans)"}}>
                        <span style={{width:8,height:8,borderRadius:"50%",background:bg,flexShrink:0}}/>
                        <span style={{flex:1}}>{icon} {s}</span>
                        {active&&<span style={{fontSize:11,color:"var(--text-3)"}}>current</span>}
                      </button>;
                    })}
                  </div>
                </>}
              </div>
              <div style={{fontSize:13,color:"var(--text-2)"}}>
                {[p.client,p.location,p.type].filter(Boolean).join(" · ")}{p.phase&&<><span style={{color:"var(--text-4)"}}> · </span><span style={{color:"var(--text-3)"}}>Phase:</span> {canEdit?<button onClick={()=>setModal({type:"editProject",pid:p.id})} style={{background:"none",border:"none",padding:0,fontWeight:600,color:"var(--text)",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,textDecoration:"underline dotted",textUnderlineOffset:3}} title="Click to edit phase">{p.phase}</button>:<strong style={{color:"var(--text)"}}>{p.phase}</strong>}</>}
              </div>

              {/* Phase track — click segment to change phase */}
              {<div style={{marginTop:16,maxWidth:640}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                  <div style={{flex:1,display:"flex",gap:2}}>
                    {PHASES.map((ph,i)=><div key={i} onClick={canEdit?()=>{onUpdateProject&&onUpdateProject(p.id,{phase:ph})}:undefined} style={{flex:1,height:6,borderRadius:2,background:i<currentPhaseIndex?"var(--a-500)":i===currentPhaseIndex?"var(--a-500)":"var(--n-100)",opacity:i===currentPhaseIndex?0.55:1,cursor:canEdit?"pointer":"default",transition:"opacity .12s"}} title={canEdit?`Set phase: ${ph}`:ph} onMouseEnter={e=>{if(canEdit)e.currentTarget.style.opacity="0.8"}} onMouseLeave={e=>{e.currentTarget.style.opacity=i===currentPhaseIndex?"0.55":i<currentPhaseIndex?"1":"1"}}/>)}
                  </div>
                  {canEdit&&<button onClick={()=>setModal({type:"editPhases",pid:p.id,phases:PHASES})} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-4)",fontSize:11,padding:"0 4px",fontFamily:"var(--font-sans)"}} title="Edit project phases">✎ phases</button>}
                </div>
                <div style={{display:"flex",marginTop:4}}>
                  {PHASES.map((ph,i)=><div key={ph} style={{flex:1,fontSize:10,fontWeight:i===currentPhaseIndex?600:500,color:i===currentPhaseIndex?"var(--text)":"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.04em",textAlign:"left",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:4}}>{ph}</div>)}
                </div>
              </div>}

              {user.role==="Client"&&<div style={{marginTop:14,padding:"10px 14px",background:"var(--green-50)",border:"1px solid color-mix(in srgb, var(--green-500) 24%, transparent)",borderRadius:8,fontSize:12,color:"var(--green-700)"}}>👁 View only — you can view your project status, timeline, RFIs, and updates.</div>}
            </div>
          </div>
        </div>

        {/* Hero actions */}
        <div style={{display:"flex",flexDirection:"column",gap:8,alignItems:"flex-end"}}>
          {canEdit&&<div style={{position:"relative"}}>
            <button ref={actionsButtonRef} style={{...S.btnO,padding:"0 12px",height:32,fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={()=>{
              if(actionsButtonRef.current){const r=actionsButtonRef.current.getBoundingClientRect();setMenuPos({top:r.bottom+4,right:window.innerWidth-r.right});}
              setShowActions(v=>!v);
            }}>⚙ Actions ▾</button>
            {showActions&&<>
              <div onClick={()=>setShowActions(false)} style={{position:"fixed",inset:0,zIndex:99}}/>
              <div style={{position:"fixed",right:menuPos.right,top:menuPos.top,background:"var(--surface)",border:"1px solid var(--border)",borderRadius:10,boxShadow:"var(--shadow-md)",zIndex:100,minWidth:200,overflow:"hidden"}}>
                <button onClick={()=>{setModal({type:"editProject",pid:p.id});setShowActions(false)}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"10px 14px",background:"none",border:"none",borderBottom:"1px solid var(--divider)",fontSize:13,color:"var(--text)",fontWeight:500,cursor:"pointer",textAlign:"left",fontFamily:"var(--font-sans)"}}>✏️ Edit project</button>
                {p.status!=="In Progress"&&<button onClick={()=>{onChangeStatus(p.id,"In Progress");setShowActions(false)}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"10px 14px",background:"none",border:"none",borderBottom:"1px solid var(--divider)",fontSize:13,color:"var(--green-600)",fontWeight:500,cursor:"pointer",textAlign:"left",fontFamily:"var(--font-sans)"}}>▶ Set in progress</button>}
                {p.status!=="On Hold"&&<button onClick={()=>{onChangeStatus(p.id,"On Hold");setShowActions(false)}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"10px 14px",background:"none",border:"none",borderBottom:"1px solid var(--divider)",fontSize:13,color:"var(--amber-600)",fontWeight:500,cursor:"pointer",textAlign:"left",fontFamily:"var(--font-sans)"}}>⏸ Set on hold</button>}
                {p.status!=="Completed"&&<button onClick={()=>{onChangeStatus(p.id,"Completed");setShowActions(false)}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"10px 14px",background:"none",border:"none",borderBottom:"1px solid var(--divider)",fontSize:13,color:"var(--a-600)",fontWeight:500,cursor:"pointer",textAlign:"left",fontFamily:"var(--font-sans)"}}>✓ Mark completed</button>}
                <button onClick={()=>{if(confirm(`Delete "${p.name}"? This cannot be undone.`)){onDeleteProject(p.id);onBack();}setShowActions(false);}} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"10px 14px",background:"var(--red-50)",border:"none",fontSize:13,color:"var(--red-600)",fontWeight:500,cursor:"pointer",textAlign:"left",fontFamily:"var(--font-sans)"}}>🗑 Delete project</button>
              </div>
            </>}
          </div>}
          {canUpdate&&<button style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} onClick={()=>setModal({type:"addUpdate",pid:p.id})}>+ Add update</button>}
        </div>
      </div>
    </div>

    {/* ── TABS ─────────────────────────────────────────────────── */}
    <div style={{padding:"0 clamp(8px,3vw,32px)",borderBottom:"1px solid var(--border)",background:"var(--surface)",position:"sticky",top:56,zIndex:10}}>
      <div style={{display:"flex",gap:0,overflowX:"auto",scrollbarWidth:"none"}}>
        {tabs.map(t=>{
          const active=tab===t;
          const badge=t==="actions"?(projActions.filter(a=>!a.done).length||null):t==="decisions"?((p.meetings||[]).length||null):t==="registers"?((p.rfis||[]).filter(r=>r.status==="Open").length||null):null;
          return <button key={t} onClick={()=>setTab(t)} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:active?600:500,color:active?"var(--text)":"var(--text-3)",borderBottom:active?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",transition:"color .12s, border-color .12s",whiteSpace:"nowrap",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
            {t.charAt(0).toUpperCase()+t.slice(1)}
            {badge!==null&&badge!==undefined&&badge>0&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{badge}</span>}
          </button>;
        })}
      </div>
    </div>

    {/* ── PAGE CONTENT ─────────────────────────────────────────── */}
    <div style={{padding:"clamp(10px,2vw,24px) clamp(2px,2.5vw,32px) 60px"}}>

    {/* ── OVERVIEW TAB ── */}
    {tab==="overview"&&<div style={{display:"grid",gridTemplateColumns:"var(--wb-side,1fr 380px)",gap:20,alignItems:"start"}}>

      {/* LEFT COLUMN — Deadlines + Recent Updates */}
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* Deadlines */}
        <div style={S.card}>
          <div style={S.cardH}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Deadlines</span>
            {canEdit&&<button style={{...S.btnO,padding:"0 12px",height:28,fontSize:12,display:"inline-flex",alignItems:"center",gap:4}} onClick={()=>setModal({type:"addDeadline",pid:p.id})}>+ Add</button>}
          </div>
          <div style={{padding:"6px 0"}}>
            {p.deadlines.length===0?
              <div style={{textAlign:"center",padding:"24px 16px",color:"var(--text-3)",fontSize:13}}>No deadlines yet.</div>
              :p.deadlines.filter(d=>daysUntil(d.date)>=-30).sort((a,b)=>new Date(a.date)-new Date(b.date)).slice(0,4).map((d,i,arr)=>{
                const days=daysUntil(d.date);
                const isComplete=d.completed||d.done;
                const tone=isComplete?"green":days<0?"red":days<=3?"red":days<=7?"amber":"a";
                const label=isComplete?"Complete":days<0?`${Math.abs(days)}d ago`:days===0?"Today":days===1?"Tomorrow":`${days}d`;
                return <div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 18px",borderBottom:i<arr.length-1?"1px solid var(--divider)":"none"}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:2}}>{d.name||d.title}</div>
                    <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)"}}>{d.date}</div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{display:"inline-flex",alignItems:"center",padding:"3px 9px",borderRadius:6,
                      background:`color-mix(in srgb, var(--${tone}-500) 12%, transparent)`,
                      border:`1px solid color-mix(in srgb, var(--${tone}-500) 26%, transparent)`,
                      color:`var(--${tone}-600)`,
                      fontSize:11,fontWeight:600}}>{label}</span>
                    <span style={{color:"var(--text-3)",fontSize:14,marginLeft:4}}>›</span>
                  </div>
                </div>;
              })}
          </div>
        </div>

        {/* Recent updates */}
        <div style={S.card}>
          <div style={S.cardH}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Recent updates</span>
            {canUpdate&&<button style={{...S.btnO,padding:"0 12px",height:28,fontSize:12}} onClick={()=>setModal({type:"addUpdate",pid:p.id})}>+ Post</button>}
          </div>
          <div style={{padding:"4px 18px 16px"}}>
            {(p.updates||[]).length===0?
              <div style={{textAlign:"center",padding:"24px 0",color:"var(--text-3)",fontSize:13}}>No updates yet.</div>
              :[...(p.updates||[])].sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,4).map((u,i,arr)=>{
                const author=users.find(x=>x.id===u.author);
                const fmtRel=(d)=>{try{const dt=new Date(d);const diff=Math.floor((Date.now()-dt)/1000);if(diff<60)return"just now";if(diff<3600)return`${Math.floor(diff/60)}m ago`;if(diff<86400)return`${Math.floor(diff/3600)}h ago`;if(diff<604800)return`${Math.floor(diff/86400)}d ago`;return dt.toLocaleDateString("en-US",{month:"short",day:"numeric"});}catch{return d}};
                return <div key={i} style={{display:"grid",gridTemplateColumns:"36px 1fr",gap:12,padding:"14px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                  <div style={{...S.avatar,width:36,height:36,fontSize:12,background:author?.profilePhoto?"transparent":(author?.profileColor||C.grad2),flexShrink:0}}>{author?.profilePhoto?<img src={author.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(author?.avatar||"?")}</div>
                  <div>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                      <span style={{fontSize:13,fontWeight:600,color:"var(--text)"}}>{author?.name||"Unknown"}</span>
                      <span style={{fontSize:11,color:"var(--text-3)"}}>{fmtRel(u.date)}</span>
                    </div>
                    <div style={{fontSize:13,lineHeight:1.55,color:"var(--text-2)",whiteSpace:"pre-wrap"}}>{u.text}</div>
                  </div>
                </div>;
              })}
          </div>
        </div>

        {/* Description (if any) — full width below */}
        {p.description&&<div style={S.card}>
          <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>About this project</span></div>
          <div style={{padding:"14px 18px",fontSize:14,lineHeight:1.7,color:"var(--text-2)"}}>{p.description}</div>
        </div>}
      </div>

      {/* RIGHT COLUMN — Team + Client Access + Files */}
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* Team */}
        <div style={S.card}>
          <div style={S.cardH}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Team</span>
            <span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{teamMembers.length}</span>
          </div>
          {canEdit&&showAddTeamMember&&<div style={{padding:"10px 18px",borderBottom:"1px solid var(--divider)",display:"flex",gap:6,flexWrap:"wrap"}}>
            {unassigned.map(u=><button key={u.id} onClick={()=>{onUpdateProject(p.id,{team:[...(p.team||[]),u.id]});}} style={{...S.btnO,padding:"4px 10px",fontSize:11}}>{u.avatar} {u.name}</button>)}
            {unassigned.length===0&&<span style={{fontSize:12,color:"var(--text-3)"}}>All users on team.</span>}
          </div>}
          <div style={{padding:"4px 18px"}}>
            {teamMembers.map((u,i)=>{
              const focus=getUserFocus(p,u.id);
              return <div key={u.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                <div style={{...S.avatar,width:32,height:32,fontSize:11,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),flexShrink:0}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:1}}>
                    <span style={{fontSize:13,fontWeight:600}}>{u.name}</span>
                    {u.id===user.id&&<span style={{fontSize:10,color:"var(--a-600)",fontWeight:600}}>(you)</span>}
                    <span style={{fontSize:9,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",background:"var(--n-100)",padding:"1px 5px",borderRadius:3}}>{u.role}</span>
                  </div>
                  <div style={{height:4,background:"var(--n-100)",borderRadius:999,overflow:"hidden",maxWidth:160}}>
                    <div style={{height:"100%",width:`${Math.min(focus,100)}%`,background:focus>=80?"var(--green-500)":focus>=40?"var(--a-500)":"var(--text-3)"}}/>
                  </div>
                  <div style={{fontSize:10,color:"var(--text-3)",marginTop:2,fontVariantNumeric:"tabular-nums"}}>{focus}% focus</div>
                </div>
                {canEdit&&<button onClick={()=>onUpdateProject(p.id,{team:(p.team||[]).filter(id=>id!==u.id)})} style={{background:"none",border:"none",color:"var(--text-3)",cursor:"pointer",fontSize:14,padding:"4px 6px"}} title="Remove">×</button>}
              </div>;
            })}
            {teamMembers.length===0&&<div style={{color:"var(--text-3)",fontSize:13,textAlign:"center",padding:"16px 0"}}>No team members.</div>}
          </div>
          {canEdit&&<div style={{padding:"10px 18px 14px",borderTop:"1px solid var(--divider)"}}>
            <button onClick={()=>setShowAddTeamMember(v=>!v)} style={{...S.btnO,width:"100%",height:32,fontSize:12,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6}}>+ Add member</button>
          </div>}
        </div>

        {/* Client / Contractor Access */}
        {p.accessPin&&(canEdit||user.role==="Client")&&<div style={{...S.card,background:"color-mix(in srgb, var(--violet-500, #8b5cf6) 6%, var(--surface))",border:"1px solid color-mix(in srgb, var(--violet-500, #8b5cf6) 22%, var(--border))"}}>
          <div style={{padding:"14px 18px"}}>
            <div style={{display:"flex",alignItems:"center",gap:6,fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--violet-500, #8b5cf6)",marginBottom:12}}>
              <span>🔗</span> Client / Contractor access
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
              <div>
                <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:4}}>Project #</div>
                <div style={{fontSize:18,fontWeight:700,color:"var(--text)",fontFamily:"var(--font-mono)"}}>{p.number}</div>
              </div>
              <div>
                <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:4}}>Access PIN</div>
                <div style={{fontSize:18,fontWeight:700,color:"var(--violet-500, #8b5cf6)",fontFamily:"var(--font-mono)",letterSpacing:"0.05em"}}>{p.accessPin}</div>
              </div>
            </div>
            <button onClick={()=>{
              const text=`Project #: ${p.number}\nAccess PIN: ${p.accessPin}\n\nLog in at workbro.ca → "External Access"`;
              navigator.clipboard?.writeText(text).then(()=>alert("Copied to clipboard!")).catch(()=>{const t=document.createElement("textarea");t.value=text;document.body.appendChild(t);t.select();document.execCommand("copy");document.body.removeChild(t);alert("Copied!")});
            }} style={{width:"100%",height:36,padding:"0 14px",background:"var(--violet-500, #8b5cf6)",color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)",display:"inline-flex",alignItems:"center",justifyContent:"center",gap:6,transition:"background .12s"}}>📋 Copy access credentials</button>
          </div>
        </div>}

        {/* Files */}
        <div style={S.card}>
          <div style={S.cardH}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Files</span>
            <span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{(p.files||[]).length}</span>
          </div>
          <div style={{padding:"4px 18px 14px"}}>
            {(p.files||[]).length===0?
              <div style={{textAlign:"center",padding:"20px 0",color:"var(--text-3)",fontSize:13}}>No files attached.</div>
              :(p.files||[]).slice(0,5).map((f,i,arr)=><div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                <div style={{width:32,height:32,borderRadius:6,background:"var(--surface-2)",border:"1px solid var(--border)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>📄</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:600,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontFamily:"var(--font-mono)"}}>{f.name||f.filename||"file"}</div>
                  <div style={{fontSize:10,color:"var(--text-3)",marginTop:1}}>{f.date||"—"}{f.size?` · ${f.size}`:""}</div>
                </div>
                {f.url&&<a href={f.url} target="_blank" rel="noopener noreferrer" style={{color:"var(--text-3)",fontSize:14,padding:4,textDecoration:"none"}}>↓</a>}
              </div>)}
          </div>
          {canEdit&&<div style={{padding:"10px 18px 14px",borderTop:"1px solid var(--divider)"}}>
            <button style={{...S.btnO,width:"100%",height:32,fontSize:12,opacity:.6,cursor:"not-allowed"}} disabled title="File upload coming soon">+ Upload file (coming soon)</button>
          </div>}
        </div>
      </div>
    </div>}

    {/* ── ACTIONS TAB ── */}
    {tab==="actions"&&isStaff(user)&&<div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,gap:8,flexWrap:"wrap"}}>
        <div style={{display:"flex",gap:6}}>
          <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setActionWeekOffset(o=>o-1)}>← Prev</button>
          <button style={{...S.btnO,padding:"4px 10px",fontSize:11,color:C.accent}} onClick={()=>setActionWeekOffset(0)}>This Week</button>
          <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={()=>setActionWeekOffset(o=>o+1)}>Next →</button>
        </div>
        <span style={{fontSize:13,fontWeight:600}}>{formatWeekLabel(viewWeekStart)}</span>
      </div>
      {/* Add new */}
      <div style={{...S.card,padding:"12px 16px",marginBottom:16}}>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"flex-end"}}>
          <div style={{flex:2,minWidth:200}}>
            <label style={S.label}>New Action Item</label>
            <input style={S.input} value={newActionText} onChange={e=>setNewActionText(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addItem()} placeholder="What needs to be done?"/>
          </div>
          <div style={{minWidth:110}}>
            <label style={S.label}>Priority</label>
            <select style={S.select} value={newActionPriority} onChange={e=>setNewActionPriority(e.target.value)}>
              <option value="High">High</option><option value="Medium">Medium</option><option value="Low">Low</option>
            </select>
          </div>
          <div style={{minWidth:145}}>
            <label style={S.label}>Due Date</label>
            <input type="date" style={S.input} value={newActionDueDate} onChange={e=>setNewActionDueDate(e.target.value)}/>
          </div>
          <button style={{...S.btn,height:36}} onClick={addItem}>+ Add</button>
        </div>
      </div>
      {Object.entries(byAuthor).map(([uid,items])=>{
        const u=users.find(x=>x.id===uid);
        const groups={current:items.filter(a=>!a.weekKey||a.weekKey===viewWeekKey),other:items.filter(a=>a.weekKey&&a.weekKey!==viewWeekKey)};
        const doneCount=groups.current.filter(a=>a.done).length;
        return <div key={uid} style={{...S.card,marginBottom:12}}>
          <div style={S.cardH}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{...S.avatar,width:28,height:28,fontSize:10,background:u?.profilePhoto?"transparent":(u?.profileColor||C.grad2)}}>{u?.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(u?.avatar||"?")}</div>
              <span style={{fontWeight:600}}>{u?.name||"Unknown"}</span>
              <Badge bg={C.accentSoft} fg={C.accent}>{doneCount}/{groups.current.length}</Badge>
            </div>
          </div>
          <div style={{padding:"8px 16px"}}>
            {groups.current.length===0&&<div style={{color:C.textDim,fontSize:12,padding:"8px 0"}}>No items this week.</div>}
            {groups.current.sort((a,b)=>{
              if(a.done!==b.done)return a.done?1:-1;
              return {High:0,Medium:1,Low:2}[a.priority||"Medium"]-{High:0,Medium:1,Low:2}[b.priority||"Medium"];
            }).map(a=>{
              const canEditItem=a.assignee===user.id||isAdmin(user)||isPM(user);
              return <ActionItemRow key={a.id} a={a} canEdit={canEditItem} priorityColor={priorityColor} priorityBg={priorityBg} today={today} toggleItem={toggleItem} deleteItem={deleteItem} saveEdit={saveEdit}/>;
            })}
          </div>
        </div>;
      })}
      {Object.keys(byAuthor).length===0&&<div style={{...S.card,padding:40,textAlign:"center"}}>
        <div style={{fontSize:28,marginBottom:8}}>📋</div>
        <div style={{color:C.textMid,fontSize:13}}>No action items yet. Add one above.</div>
      </div>}
    </div>}

    {/* ── TIMELINE TAB ── */}
    {tab==="timeline"&&<div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"flex-end",marginBottom:12,gap:8,flexWrap:"wrap"}}>
        {/* Fix 3: Weekly/Daily toggle in the header bar */}
        <div style={{display:"flex",gap:2,background:"var(--surface-2)",padding:2,borderRadius:6,border:"1px solid var(--border)"}}>
          {[["week","Weekly"],["day","Daily"]].map(([k,l])=><button key={k} onClick={()=>setGanttUnit(k)} style={{padding:"4px 12px",fontSize:12,fontWeight:500,borderRadius:4,border:"none",background:ganttUnit===k?"var(--surface)":"transparent",color:ganttUnit===k?"var(--text)":"var(--text-2)",boxShadow:ganttUnit===k?"var(--shadow-xs)":"none",cursor:"pointer",fontFamily:"var(--font-sans)"}}>{l}</button>)}
        </div>
        {canEdit&&<button style={{...S.btnO,padding:"6px 14px",fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={()=>setModal({type:"editPhaseSchedule",pid:p.id})} title="Set start/end dates for each phase">📅 Edit phase dates</button>}
        {(p.milestones?.length>0||p.deadlines?.length>0)&&<button style={{...S.btnO,padding:"6px 14px",fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={()=>exportProjectSchedulePDF({project:p,milestones:p.milestones||[],deadlines:p.deadlines||[],team:p.team||[],users,companyInfo})} title="Export schedule as PDF">📄 Export PDF</button>}
      </div>
      <div style={{...S.card,marginBottom:14}}>
        <div style={S.cardH}>
          <span style={S.cardT}>◆ Milestones ({p.milestones?.length||0})</span>
          {canEdit&&<button style={S.btnSm} onClick={()=>setModal({type:"addMilestone",pid:p.id})}>+ Add Milestone</button>}
        </div>
        <div style={{...S.cardB,paddingBottom:24}}>
          {p.milestones?.length>0?<>
            <Timeline milestones={p.milestones} startDate={p.startDate} endDate={p.endDate} projectName={p.name} projectNumber={p.number} project={p} unit={ganttUnit}
              onEditMilestone={canEdit?(idx,m)=>setModal({type:"editMilestone",pid:p.id,index:idx,milestone:m}):null}
              onToggleMilestone={canEdit?(idx,done)=>{const m=[...(p.milestones||[])];if(m[idx])m[idx]={...m[idx],done};onUpdateProject&&onUpdateProject(p.id,{milestones:m});}:null}/>
            <table style={{width:"100%",borderCollapse:"collapse",marginTop:14}}>
              <thead><tr>
                <th style={S.th}>Milestone</th>
                <th style={{...S.th,width:120}}>Date</th>
                <th style={{...S.th,width:110}}>Status</th>
                {canEdit&&<th style={{...S.th,width:140,textAlign:"right"}}>Actions</th>}
              </tr></thead>
              <tbody>
                {p.milestones.map((m,i)=><tr key={i}>
                  <td style={S.td}>{m.name}</td>
                  <td style={S.td}>{m.date}</td>
                  <td style={S.td}><Badge bg={m.done?C.greenSoft:C.amberSoft} fg={m.done?C.green:C.amber}>{m.done?"Complete":"Pending"}</Badge></td>
                  {canEdit&&<td style={{...S.td,textAlign:"right"}}>
                    <div style={{display:"inline-flex",gap:4}}>
                      <button style={{...S.btnO,padding:"3px 8px",fontSize:11}} onClick={()=>onToggleMilestone(p.id,i)}>{m.done?"Undo":"✓"}</button>
                      <button style={{...S.btnO,padding:"3px 8px",fontSize:11}} onClick={()=>setModal({type:"editMilestone",pid:p.id,index:i,milestone:m})}>✎</button>
                      <button style={{...S.btnO,padding:"3px 8px",fontSize:11,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm(`Delete "${m.name}"?`)){onUpdateProject(p.id,{milestones:p.milestones.filter((_,idx)=>idx!==i)});}}}>×</button>
                    </div>
                  </td>}
                </tr>)}
              </tbody>
            </table>
          </>:<div style={{color:C.textDim,fontSize:13,textAlign:"center",padding:24}}>No milestones yet.</div>}
        </div>
      </div>
      <div style={S.card}>
        <div style={S.cardH}>
          <span style={S.cardT}>● Deadlines ({p.deadlines?.length||0})</span>
          {canEdit&&<button style={S.btnSm} onClick={()=>setModal({type:"addDeadline",pid:p.id})}>+ Add Deadline</button>}
        </div>
        <div style={S.cardB}>
          {p.deadlines?.length>0?<table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr>
              <th style={S.th}>Deadline</th>
              <th style={{...S.th,width:120}}>Date</th>
              <th style={{...S.th,width:120}}>Days</th>
              {canEdit&&<th style={{...S.th,width:120,textAlign:"right"}}>Actions</th>}
            </tr></thead>
            <tbody>
              {[...p.deadlines].sort((a,b)=>new Date(a.date)-new Date(b.date)).map((d,i)=>{
                const days=daysUntil(d.date);
                const idx=p.deadlines.findIndex(x=>x===d);
                return <tr key={d.id||i}>
                  <td style={S.td}>{d.name}</td>
                  <td style={S.td}>{d.date}</td>
                  <td style={S.td}><Badge bg={days<0?C.redSoft:days<=7?C.amberSoft:C.accentSoft} fg={days<0?C.red:days<=7?C.amber:C.accent}>{days<0?`${Math.abs(days)}d ago`:days===0?"Today":`in ${days}d`}</Badge></td>
                  {canEdit&&<td style={{...S.td,textAlign:"right"}}>
                    <div style={{display:"inline-flex",gap:4}}>
                      <button style={{...S.btnO,padding:"3px 8px",fontSize:11}} onClick={()=>setModal({type:"editDeadline",pid:p.id,index:idx,deadline:d})}>✎</button>
                      <button style={{...S.btnO,padding:"3px 8px",fontSize:11,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm(`Delete "${d.name}"?`)){onUpdateProject(p.id,{deadlines:p.deadlines.filter((_,j)=>j!==idx)});}}}>×</button>
                    </div>
                  </td>}
                </tr>;
              })}
            </tbody>
          </table>:<div style={{color:C.textDim,fontSize:13,textAlign:"center",padding:24}}>No deadlines yet.</div>}
        </div>
      </div>
    </div>}

    {/* ── RFIs TAB ── */}
    {/* RFI/Budget/Updates tabs removed — simplified */}

    {/* ── COORDINATION TAB ── */}
    {tab==="coordination"&&<div>
      {canEdit&&<div style={{marginBottom:14}}><button style={S.btnSm} onClick={()=>setModal({type:"addCoord",pid:p.id,defaults:["Structural","Mechanical","Electrical","Civil","Landscape","Interior"]})}>+ Add Contact</button></div>}
      {(p.coordination||[]).length===0?<div style={{...S.card,padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>No coordination contacts yet.</div>:
      (p.coordination||[]).map((c,i)=><div key={i} style={{...S.card,marginBottom:10}}>
        <div style={{...S.cardH}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{width:40,height:40,borderRadius:10,background:C.accentSoft,color:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:14,flexShrink:0}}>{c.discipline.charAt(0)}</div>
            <div><div style={{fontWeight:600}}>{c.discipline}</div><div style={{fontSize:11,color:C.textDim}}>{c.company}{c.contact?` · ${c.contact}`:""}</div></div>
          </div>
          <div style={{display:"flex",gap:8}}>
            {c.email&&<a href={`mailto:${c.email}`} style={{...S.btnO,padding:"4px 10px",fontSize:11,textDecoration:"none"}}>📧</a>}
            <Badge bg={c.status==="Active"?C.greenSoft:C.card} fg={c.status==="Active"?C.green:C.textDim}>{c.status||"Active"}</Badge>
          </div>
        </div>
        {(c.messages||[]).length>0&&<div style={{padding:"10px 16px",borderTop:`1px solid ${C.border}`}}>
          {c.messages.map((m,mi)=><div key={mi} style={{fontSize:12,color:C.textMid,marginBottom:6}}><strong>{new Date(m.date).toLocaleDateString()}</strong>: {m.text}</div>)}
        </div>}
        {isStaff(user)&&<div style={{padding:"10px 16px",borderTop:`1px solid ${C.border}`,display:"flex",gap:8}}>
          <input style={{...S.input,flex:1,fontSize:12}} placeholder="Add note..." onKeyDown={e=>{if(e.key==="Enter"&&e.target.value.trim()){onAddCoordNote(p.id,i,e.target.value.trim());e.target.value="";}}}/>
        </div>}
      </div>)}
    </div>}

    {/* ── DECISION LOG TAB (replaces Issues) ── */}
    {tab==="decisions"&&(()=>{
      const decisions=p.decisions||[];
      // Group decisions by meetingId
      const meetings=p.meetings||[];
      // Sort meetings by date desc
      const sortedMeetings=[...meetings].sort((a,b)=>new Date(b.date)-new Date(a.date));
      // Standalone decisions (no meeting)
      const standalone=decisions.filter(d=>!d.meetingId);
      return <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18,flexWrap:"wrap",gap:8}}>
          <div>
            <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:4}}>{meetings.length} meeting{meetings.length!==1?"s":""} · {decisions.length} decision{decisions.length!==1?"s":""}</div>
            <h2 style={{margin:0,fontSize:18,fontWeight:600,letterSpacing:"-0.015em"}}>Decision log</h2>
          </div>
          {canEdit&&<div style={{display:"flex",gap:6}}>
            <button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12}} onClick={()=>setModal({type:"addMeeting",pid:p.id})}>+ New meeting</button>
            <button style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} onClick={()=>setModal({type:"addDecision",pid:p.id})}>+ Quick decision</button>
          </div>}
        </div>

        {meetings.length===0&&decisions.length===0&&<div style={{...S.card,padding:48,textAlign:"center"}}>
          <div style={{fontSize:32,marginBottom:8,opacity:0.4}}>📋</div>
          <div style={{fontSize:14,fontWeight:600,color:"var(--text)",marginBottom:4}}>No decisions logged yet</div>
          <div style={{fontSize:12,color:"var(--text-3)",maxWidth:380,margin:"0 auto 16px"}}>Create a meeting to start logging decisions, or add a quick decision without a meeting.</div>
          {canEdit&&<button style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} onClick={()=>setModal({type:"addMeeting",pid:p.id})}>+ Log a meeting</button>}
        </div>}

        {/* Meetings list */}
        {sortedMeetings.map(meeting=>{
          const mdecs=decisions.filter(d=>d.meetingId===meeting.id);
          return <div key={meeting.id} style={{...S.card,marginBottom:14}}>
            <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:12}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4,flexWrap:"wrap"}}>
                  <h3 style={{margin:0,fontSize:15,fontWeight:600,letterSpacing:"-0.01em"}}>{meeting.subject}</h3>
                  <span style={{fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:999,background:"var(--n-100)",color:"var(--text-2)",letterSpacing:"0.05em",textTransform:"uppercase",fontFamily:"var(--font-mono)"}}>{meeting.date}</span>
                </div>
                {meeting.attendees&&meeting.attendees.length>0&&<div style={{fontSize:12,color:"var(--text-3)",marginBottom:meeting.notes?6:0}}>
                  {meeting.attendees.map(uid=>users.find(u=>u.id===uid)?.name).filter(Boolean).join(", ")||"No attendees listed"}
                </div>}
                {meeting.notes&&<div style={{fontSize:13,color:"var(--text-2)",lineHeight:1.5,marginTop:6,whiteSpace:"pre-wrap"}}>{meeting.notes}</div>}
              </div>
              {canEdit&&<div style={{display:"flex",gap:4,flexShrink:0}}>
                <button style={{...S.btnO,padding:"0 10px",height:28,fontSize:11}} onClick={()=>setModal({type:"addDecision",pid:p.id,meetingId:meeting.id})}>+ Decision</button>
                <button style={{background:"none",border:"none",color:"var(--text-3)",cursor:"pointer",fontSize:14,padding:"4px 8px"}} onClick={()=>setModal({type:"editMeeting",pid:p.id,meeting})} title="Edit meeting">✎</button>
                <button style={{background:"none",border:"none",color:"var(--red-500)",cursor:"pointer",fontSize:14,padding:"4px 8px"}} onClick={()=>{if(confirm(`Delete meeting "${meeting.subject}" and its ${mdecs.length} decision(s)?`)){onUpdateProject(p.id,{meetings:meetings.filter(m=>m.id!==meeting.id),decisions:decisions.filter(d=>d.meetingId!==meeting.id)});}}} title="Delete meeting">×</button>
              </div>}
            </div>
            <div style={{padding:"4px 0"}}>
              {mdecs.length===0&&<div style={{padding:"16px 18px",fontSize:12,color:"var(--text-3)",textAlign:"center"}}>No decisions logged for this meeting.</div>}
              {mdecs.map((d,i)=><div key={d.id} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"12px 18px",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                <div style={{width:6,height:6,borderRadius:"50%",background:"var(--a-500)",marginTop:7,flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:3}}>{d.subject}</div>
                  <div style={{fontSize:12,color:"var(--text-2)",lineHeight:1.5,whiteSpace:"pre-wrap"}}>{d.decision}</div>
                  {d.author&&<div style={{fontSize:11,color:"var(--text-3)",marginTop:4}}>by {users.find(u=>u.id===d.author)?.name||"Unknown"}</div>}
                </div>
                {canEdit&&<div style={{display:"flex",gap:2,flexShrink:0}}>
                  <button style={{background:"none",border:"none",color:"var(--text-3)",cursor:"pointer",fontSize:12,padding:"2px 6px"}} onClick={()=>setModal({type:"editDecision",pid:p.id,decision:d})} title="Edit">✎</button>
                  <button style={{background:"none",border:"none",color:"var(--red-500)",cursor:"pointer",fontSize:13,padding:"2px 6px"}} onClick={()=>{if(confirm("Delete this decision?")){onUpdateProject(p.id,{decisions:decisions.filter(x=>x.id!==d.id)});}}} title="Delete">×</button>
                </div>}
              </div>)}
            </div>
          </div>;
        })}

        {/* Standalone decisions (no meeting) */}
        {standalone.length>0&&<div style={{...S.card,marginBottom:14}}>
          <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)"}}>
            <h3 style={{margin:0,fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Other decisions</h3>
            <div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>Not tied to a specific meeting</div>
          </div>
          <div style={{padding:"4px 0"}}>
            {standalone.sort((a,b)=>new Date(b.date||0)-new Date(a.date||0)).map((d,i)=><div key={d.id} style={{display:"flex",alignItems:"flex-start",gap:10,padding:"12px 18px",borderTop:i>0?"1px solid var(--divider)":"none"}}>
              <div style={{width:6,height:6,borderRadius:"50%",background:"var(--a-500)",marginTop:7,flexShrink:0}}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                  <span style={{fontSize:13,fontWeight:600,color:"var(--text)"}}>{d.subject}</span>
                  {d.date&&<span style={{fontSize:10,fontWeight:600,padding:"1px 7px",borderRadius:999,background:"var(--n-100)",color:"var(--text-3)",fontFamily:"var(--font-mono)"}}>{d.date}</span>}
                </div>
                <div style={{fontSize:12,color:"var(--text-2)",lineHeight:1.5,whiteSpace:"pre-wrap"}}>{d.decision}</div>
                {d.author&&<div style={{fontSize:11,color:"var(--text-3)",marginTop:4}}>by {users.find(u=>u.id===d.author)?.name||"Unknown"}</div>}
              </div>
              {canEdit&&<div style={{display:"flex",gap:2,flexShrink:0}}>
                <button style={{background:"none",border:"none",color:"var(--text-3)",cursor:"pointer",fontSize:12,padding:"2px 6px"}} onClick={()=>setModal({type:"editDecision",pid:p.id,decision:d})} title="Edit">✎</button>
                <button style={{background:"none",border:"none",color:"var(--red-500)",cursor:"pointer",fontSize:13,padding:"2px 6px"}} onClick={()=>{if(confirm("Delete this decision?")){onUpdateProject(p.id,{decisions:decisions.filter(x=>x.id!==d.id)});}}} title="Delete">×</button>
              </div>}
            </div>)}
          </div>
        </div>}
      </div>;
    })()}
    {tab==="registers"&&<RegistersTab project={p} user={user} users={users} onUpdateProject={onUpdateProject}/>}
    </div>
  </div>;
}

function AddMilestoneModal({onClose,onAdd,projectId}){
  const [f,sF]=useState({name:"",date:""});
  return <Modal title="Add Milestone" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.name.trim()&&f.date?1:.4}} onClick={()=>{if(f.name.trim()&&f.date){onAdd(projectId,{...f,done:false});onClose()}}}>Add</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Name *</label><input style={S.input} value={f.name} onChange={e=>sF(p=>({...p,name:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Date *</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>
  </Modal>
}

// ─── Add Meeting (for Decision Log) ───
function AddMeetingModal({onClose,onSave,projectId,project,users,currentUser}){
  const [f,sF]=useState({subject:"",date:new Date().toISOString().split("T")[0],notes:"",attendees:[currentUser?.id].filter(Boolean)});
  const teamMembers=(project?.team||[]).map(id=>users.find(u=>u.id===id)).filter(Boolean);
  const toggleAttendee=(uid)=>sF(p=>({...p,attendees:p.attendees.includes(uid)?p.attendees.filter(x=>x!==uid):[...p.attendees,uid]}));
  return <Modal title="Log a meeting" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.subject.trim()&&f.date?1:.4}} onClick={()=>{if(f.subject.trim()&&f.date){const meeting={id:"m_"+Date.now()+"_"+Math.random().toString(36).slice(2,6),...f,subject:f.subject.trim(),notes:f.notes.trim(),createdAt:new Date().toISOString()};onSave(projectId,meeting);onClose()}}}>Create meeting</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Subject *</label><input style={S.input} value={f.subject} onChange={e=>sF(p=>({...p,subject:e.target.value}))} placeholder="e.g. Weekly coordination meeting"/></div>
    <div style={S.inputGroup}><label style={S.label}>Date *</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Attendees</label>
      <div style={{display:"flex",flexWrap:"wrap",gap:6,padding:8,background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,maxHeight:120,overflowY:"auto"}}>
        {teamMembers.length===0&&<span style={{fontSize:12,color:"var(--text-3)",padding:"4px 8px"}}>No team members on this project.</span>}
        {teamMembers.map(u=>{const on=f.attendees.includes(u.id);return <button key={u.id} type="button" onClick={()=>toggleAttendee(u.id)} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"4px 10px",borderRadius:999,border:on?"1px solid var(--a-500)":"1px solid var(--border-strong)",background:on?"var(--a-50)":"var(--surface)",color:on?"var(--a-700)":"var(--text-2)",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"}}>
          {on&&"✓ "}{u.name}
        </button>})}
      </div>
    </div>
    <div style={S.inputGroup}><label style={S.label}>Notes / Agenda (optional)</label><textarea style={{...S.textarea,minHeight:80}} value={f.notes} onChange={e=>sF(p=>({...p,notes:e.target.value}))} placeholder="Meeting agenda or context..."/></div>
  </Modal>
}

// ─── Edit Meeting ───
function EditMeetingModal({onClose,onSave,projectId,meeting,project,users}){
  const [f,sF]=useState({subject:meeting.subject||"",date:meeting.date||"",notes:meeting.notes||"",attendees:meeting.attendees||[]});
  const teamMembers=(project?.team||[]).map(id=>users.find(u=>u.id===id)).filter(Boolean);
  const toggleAttendee=(uid)=>sF(p=>({...p,attendees:p.attendees.includes(uid)?p.attendees.filter(x=>x!==uid):[...p.attendees,uid]}));
  return <Modal title="Edit meeting" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.subject.trim()&&f.date?1:.4}} onClick={()=>{if(f.subject.trim()&&f.date){onSave(projectId,{...meeting,...f,subject:f.subject.trim(),notes:f.notes.trim()});onClose()}}}>Save</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Subject *</label><input style={S.input} value={f.subject} onChange={e=>sF(p=>({...p,subject:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Date *</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Attendees</label>
      <div style={{display:"flex",flexWrap:"wrap",gap:6,padding:8,background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,maxHeight:120,overflowY:"auto"}}>
        {teamMembers.map(u=>{const on=f.attendees.includes(u.id);return <button key={u.id} type="button" onClick={()=>toggleAttendee(u.id)} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"4px 10px",borderRadius:999,border:on?"1px solid var(--a-500)":"1px solid var(--border-strong)",background:on?"var(--a-50)":"var(--surface)",color:on?"var(--a-700)":"var(--text-2)",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"}}>{on&&"✓ "}{u.name}</button>})}
      </div>
    </div>
    <div style={S.inputGroup}><label style={S.label}>Notes / Agenda</label><textarea style={{...S.textarea,minHeight:80}} value={f.notes} onChange={e=>sF(p=>({...p,notes:e.target.value}))}/></div>
  </Modal>
}

// ─── Add Decision ───
function AddDecisionModal({onClose,onSave,projectId,meetingId,currentUser}){
  const [f,sF]=useState({subject:"",decision:"",date:new Date().toISOString().split("T")[0]});
  return <Modal title={meetingId?"Add decision to meeting":"Quick decision"} onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.subject.trim()&&f.decision.trim()?1:.4}} onClick={()=>{if(f.subject.trim()&&f.decision.trim()){const decision={id:"d_"+Date.now()+"_"+Math.random().toString(36).slice(2,6),subject:f.subject.trim(),decision:f.decision.trim(),date:meetingId?undefined:f.date,meetingId:meetingId||null,author:currentUser?.id,createdAt:new Date().toISOString()};onSave(projectId,decision);onClose()}}}>Log decision</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Subject *</label><input style={S.input} value={f.subject} onChange={e=>sF(p=>({...p,subject:e.target.value}))} placeholder="e.g. Foundation system selection"/></div>
    <div style={S.inputGroup}><label style={S.label}>Decision *</label><textarea style={{...S.textarea,minHeight:100}} value={f.decision} onChange={e=>sF(p=>({...p,decision:e.target.value}))} placeholder="What was decided and why..."/></div>
    {!meetingId&&<div style={S.inputGroup}><label style={S.label}>Date</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>}
  </Modal>
}

// ─── Edit Decision ───
function EditDecisionModal({onClose,onSave,projectId,decision}){
  const [f,sF]=useState({subject:decision.subject||"",decision:decision.decision||"",date:decision.date||""});
  return <Modal title="Edit decision" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.subject.trim()&&f.decision.trim()?1:.4}} onClick={()=>{if(f.subject.trim()&&f.decision.trim()){onSave(projectId,{...decision,subject:f.subject.trim(),decision:f.decision.trim(),date:f.date||decision.date});onClose()}}}>Save</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Subject *</label><input style={S.input} value={f.subject} onChange={e=>sF(p=>({...p,subject:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Decision *</label><textarea style={{...S.textarea,minHeight:100}} value={f.decision} onChange={e=>sF(p=>({...p,decision:e.target.value}))}/></div>
    {!decision.meetingId&&<div style={S.inputGroup}><label style={S.label}>Date</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>}
  </Modal>
}
function AddDeadlineModal({onClose,onAdd,projectId}){
  const [f,sF]=useState({name:"",date:"",kind:"internal",includeReview:false,reviewStart:"",externalDate:"",addAsMilestone:false});
  const ok=f.name.trim()&&f.date;
  return <Modal title="Add Deadline" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:ok?1:.4}} onClick={()=>{if(ok){
    const id="dl_"+Date.now()+"_"+Math.random().toString(36).slice(2,6);
    onAdd(projectId,{id,name:f.name.trim(),title:f.name.trim(),date:f.date,type:"deadline",kind:f.kind,includeReview:f.includeReview,reviewStart:f.includeReview?f.reviewStart:null,externalDate:f.kind==="internal"&&f.externalDate?f.externalDate:null,addAsMilestone:f.addAsMilestone});
    onClose();
  }}}>Add deadline</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Name *</label><input style={S.input} value={f.name} onChange={e=>sF(p=>({...p,name:e.target.value}))} placeholder="e.g. 90% DD Package"/></div>
    <div style={S.inputGroup}><label style={S.label}>Type *</label>
      <div style={{display:"flex",gap:6}}>
        {[["internal","🏢 Internal","Team milestone"],["external","📤 External","Client / regulator"]].map(([k,l,d])=><button key={k} type="button" onClick={()=>sF(p=>({...p,kind:k}))} style={{flex:1,padding:"10px 12px",borderRadius:8,border:f.kind===k?"1px solid var(--a-500)":"1px solid var(--border-strong)",background:f.kind===k?"var(--a-50)":"var(--surface)",color:f.kind===k?"var(--a-700)":"var(--text-2)",cursor:"pointer",fontFamily:"var(--font-sans)",textAlign:"left"}}>
          <div style={{fontSize:12,fontWeight:600,marginBottom:2}}>{l}</div>
          <div style={{fontSize:10,color:f.kind===k?"var(--a-600)":"var(--text-3)"}}>{d}</div>
        </button>)}
      </div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>{f.kind==="external"?"External date *":"Internal due date *"}</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>
      {f.kind==="internal"&&<div style={{...S.inputGroup,...S.half}}><label style={S.label}>External date (optional)</label><input style={S.input} type="date" value={f.externalDate} onChange={e=>sF(p=>({...p,externalDate:e.target.value}))} placeholder="If submitted externally"/></div>}
    </div>
    {/* Review period toggle */}
    <div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,marginBottom:14}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
        <div>
          <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:2}}>Include review period</div>
          <div style={{fontSize:11,color:"var(--text-3)"}}>Add a review window before the deadline (optional).</div>
        </div>
        <button type="button" onClick={()=>sF(p=>({...p,includeReview:!p.includeReview}))} style={{width:42,height:24,borderRadius:999,border:"none",cursor:"pointer",padding:2,background:f.includeReview?"var(--green-500)":"var(--n-200)",transition:"background .15s",flexShrink:0,position:"relative"}}>
          <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:f.includeReview?20:2,transition:"left .15s",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
        </button>
      </div>
      {f.includeReview&&<div style={{marginTop:10}}><label style={{...S.label,marginBottom:4}}>Review starts on</label><input style={S.input} type="date" value={f.reviewStart} onChange={e=>sF(p=>({...p,reviewStart:e.target.value}))}/></div>}
    </div>
    {/* Add as milestone toggle */}
    <div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
      <div>
        <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:2}}>Show on project timeline</div>
        <div style={{fontSize:11,color:"var(--text-3)"}}>Mirror this deadline as a milestone on the Gantt.</div>
      </div>
      <button type="button" onClick={()=>sF(p=>({...p,addAsMilestone:!p.addAsMilestone}))} style={{width:42,height:24,borderRadius:999,border:"none",cursor:"pointer",padding:2,background:f.addAsMilestone?"var(--green-500)":"var(--n-200)",transition:"background .15s",flexShrink:0,position:"relative"}}>
        <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:f.addAsMilestone?20:2,transition:"left .15s",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
      </button>
    </div>
  </Modal>
}

// Edit Milestone — preloads existing values, saves via onUpdate
function EditMilestoneModal({onClose,onSave,projectId,index,milestone}){
  const [f,sF]=useState({name:milestone.name||"",date:milestone.date||""});
  return <Modal title="Edit Milestone" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:f.name.trim()&&f.date?1:.4}} onClick={()=>{if(f.name.trim()&&f.date){onSave(projectId,index,{...milestone,...f});onClose()}}}>Save</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Name *</label><input style={S.input} value={f.name} onChange={e=>sF(p=>({...p,name:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Date *</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>
  </Modal>
}

// Edit Deadline — preloads existing values, saves via onUpdate
function EditDeadlineModal({onClose,onSave,projectId,index,deadline}){
  const [f,sF]=useState({name:deadline.name||deadline.title||"",date:deadline.date||"",kind:deadline.kind||(deadline.type==="external"?"external":"internal"),includeReview:!!deadline.includeReview,reviewStart:deadline.reviewStart||"",externalDate:deadline.externalDate||"",addAsMilestone:!!deadline.addAsMilestone});
  const ok=f.name.trim()&&f.date;
  return <Modal title="Edit Deadline" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:ok?1:.4}} onClick={()=>{if(ok){onSave(projectId,deadline.id||index,{...deadline,name:f.name.trim(),title:f.name.trim(),date:f.date,kind:f.kind,includeReview:f.includeReview,reviewStart:f.includeReview?f.reviewStart:null,externalDate:f.kind==="internal"&&f.externalDate?f.externalDate:null,addAsMilestone:f.addAsMilestone});onClose()}}}>Save</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Name *</label><input style={S.input} value={f.name} onChange={e=>sF(p=>({...p,name:e.target.value}))}/></div>
    <div style={S.inputGroup}><label style={S.label}>Type *</label>
      <div style={{display:"flex",gap:6}}>
        {[["internal","🏢 Internal"],["external","📤 External"]].map(([k,l])=><button key={k} type="button" onClick={()=>sF(p=>({...p,kind:k}))} style={{flex:1,padding:"8px 12px",borderRadius:8,border:f.kind===k?"1px solid var(--a-500)":"1px solid var(--border-strong)",background:f.kind===k?"var(--a-50)":"var(--surface)",color:f.kind===k?"var(--a-700)":"var(--text-2)",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:12,fontWeight:600}}>{l}</button>)}
      </div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>{f.kind==="external"?"External date *":"Internal due date *"}</label><input style={S.input} type="date" value={f.date} onChange={e=>sF(p=>({...p,date:e.target.value}))}/></div>
      {f.kind==="internal"&&<div style={{...S.inputGroup,...S.half}}><label style={S.label}>External date</label><input style={S.input} type="date" value={f.externalDate} onChange={e=>sF(p=>({...p,externalDate:e.target.value}))}/></div>}
    </div>
    <div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,marginBottom:10}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--text)"}}>Include review period</div>
        <button type="button" onClick={()=>sF(p=>({...p,includeReview:!p.includeReview}))} style={{width:42,height:24,borderRadius:999,border:"none",cursor:"pointer",padding:2,background:f.includeReview?"var(--green-500)":"var(--n-200)",transition:"background .15s",flexShrink:0,position:"relative"}}>
          <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:f.includeReview?20:2,transition:"left .15s",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
        </button>
      </div>
      {f.includeReview&&<div style={{marginTop:10}}><label style={{...S.label,marginBottom:4}}>Review starts on</label><input style={S.input} type="date" value={f.reviewStart} onChange={e=>sF(p=>({...p,reviewStart:e.target.value}))}/></div>}
    </div>
    <div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
      <div style={{fontSize:13,fontWeight:600,color:"var(--text)"}}>Show on project timeline (as milestone)</div>
      <button type="button" onClick={()=>sF(p=>({...p,addAsMilestone:!p.addAsMilestone}))} style={{width:42,height:24,borderRadius:999,border:"none",cursor:"pointer",padding:2,background:f.addAsMilestone?"var(--green-500)":"var(--n-200)",transition:"background .15s",flexShrink:0,position:"relative"}}>
        <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:f.addAsMilestone?20:2,transition:"left .15s",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
      </button>
    </div>
  </Modal>
}

// ─── Edit Phases ─────────────────────────────────────────────
// ─── Edit Phase Schedule ──────────────────────────────────────
function EditPhaseScheduleModal({onClose,onSave,project}){
  const DEFAULT_PHASES=["Proposal","Schematic Design","Design Development","IFC","Construction Admin","Closeout"];
  const PHASES=project?.customPhases?.length>0?project.customPhases:DEFAULT_PHASES;
  const [schedule,setSchedule]=React.useState(()=>{
    const s={};
    PHASES.forEach(ph=>{s[ph]={start:project?.phaseSchedule?.[ph]?.start||"",end:project?.phaseSchedule?.[ph]?.end||""}});
    return s;
  });
  const set=(ph,field,val)=>setSchedule(s=>({...s,[ph]:{...s[ph],[field]:val}}));
  const hasAny=Object.values(schedule).some(v=>v.start||v.end);
  return <Modal title="Edit phase schedule" onClose={onClose} footer={<>
    <button style={S.btnO} onClick={onClose}>Cancel</button>
    <button style={S.btn} onClick={()=>{onSave(project.id,schedule);onClose();}}>Save schedule</button>
  </>}>
    <div style={{fontSize:12,color:"var(--text-3)",marginBottom:14}}>Set start and end dates for each phase. Phases without dates will be distributed automatically.</div>
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {PHASES.map(ph=><div key={ph} style={{padding:"10px 12px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8}}>
        <div style={{fontSize:12,fontWeight:600,color:"var(--text)",marginBottom:8}}>{ph}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div><label style={{...S.label,marginBottom:3}}>Start</label><input type="date" style={{...S.input,fontSize:12}} value={schedule[ph]?.start||""} onChange={e=>set(ph,"start",e.target.value)}/></div>
          <div><label style={{...S.label,marginBottom:3}}>End</label><input type="date" style={{...S.input,fontSize:12}} value={schedule[ph]?.end||""} onChange={e=>set(ph,"end",e.target.value)}/></div>
        </div>
        {schedule[ph]?.start&&schedule[ph]?.end&&<div style={{fontSize:11,color:"var(--text-3)",marginTop:5}}>
          {Math.round((new Date(schedule[ph].end)-new Date(schedule[ph].start))/(7*86400000))} weeks
        </div>}
      </div>)}
    </div>
  </Modal>;
}

function EditPhasesModal({onClose,onSave,projectId,initialPhases}){
  const [phases,setPhases]=useState([...initialPhases]);
  const [newPhase,setNewPhase]=useState("");
  const move=(i,dir)=>{const a=[...phases];const j=i+dir;if(j<0||j>=a.length)return;[a[i],a[j]]=[a[j],a[i]];setPhases(a);};
  return <Modal title="Edit project phases" onClose={onClose} footer={<>
    <button style={S.btnO} onClick={onClose}>Cancel</button>
    <button style={{...S.btn,opacity:phases.length>0?1:.4}} onClick={()=>{if(phases.length>0){onSave(projectId,phases);onClose();}}}>Save phases</button>
  </>}>
    <div style={{marginBottom:12,fontSize:12,color:"var(--text-3)"}}>Drag to reorder (use ↑↓ arrows), add or remove phases. Click a phase name to rename it.</div>
    <div style={{marginBottom:12}}>
      {phases.map((ph,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:"1px solid var(--divider)"}}>
        <div style={{display:"flex",flexDirection:"column",gap:1}}>
          <button type="button" onClick={()=>move(i,-1)} disabled={i===0} style={{background:"none",border:"none",cursor:i===0?"default":"pointer",color:i===0?"var(--text-4)":"var(--text-2)",fontSize:10,padding:0,lineHeight:1,fontFamily:"var(--font-sans)"}}>▲</button>
          <button type="button" onClick={()=>move(i,1)} disabled={i===phases.length-1} style={{background:"none",border:"none",cursor:i===phases.length-1?"default":"pointer",color:i===phases.length-1?"var(--text-4)":"var(--text-2)",fontSize:10,padding:0,lineHeight:1,fontFamily:"var(--font-sans)"}}>▼</button>
        </div>
        <input style={{...S.input,flex:1,fontSize:13,padding:"6px 10px"}} value={ph} onChange={e=>{const a=[...phases];a[i]=e.target.value;setPhases(a);}} onBlur={e=>{if(!e.target.value.trim()){const a=[...phases];a.splice(i,1);setPhases(a);}}}/>
        <button type="button" onClick={()=>{const a=[...phases];a.splice(i,1);setPhases(a);}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red-500)",fontSize:16,padding:"0 4px",fontFamily:"var(--font-sans)"}}>×</button>
      </div>)}
    </div>
    <div style={{display:"flex",gap:8}}>
      <input style={{...S.input,flex:1,fontSize:13}} value={newPhase} onChange={e=>setNewPhase(e.target.value)} placeholder="New phase name…" onKeyDown={e=>{if(e.key==="Enter"&&newPhase.trim()){setPhases(p=>[...p,newPhase.trim()]);setNewPhase("");}}}/>
      <button type="button" style={{...S.btnO,padding:"0 14px",height:36,fontSize:12}} onClick={()=>{if(newPhase.trim()){setPhases(p=>[...p,newPhase.trim()]);setNewPhase("")}}}>+ Add</button>
    </div>
  </Modal>;
}

function AddCoordModal({onClose,onAdd,projectId,defaults}){
  const [f,sF]=useState({discipline:"",company:"",contact:"",email:"",phone:"",status:"Active"});
  const s=(k,v)=>sF(p=>({...p,[k]:v}));
  const ok=f.discipline.trim();
  return <Modal title="Add Coordination Contact" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:ok?1:.4}} onClick={()=>{if(ok){onAdd(projectId,{...f,messages:[]});onClose()}}}>Add</button></>}>
    <div style={S.inputGroup}><label style={S.label}>Discipline *</label>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
        {defaults.map(d=><button key={d} type="button" style={{...S.btnO,padding:"4px 10px",fontSize:11,color:f.discipline===d?C.accent:C.textMid,borderColor:f.discipline===d?C.accent:C.border}} onClick={()=>s("discipline",d)}>{d}</button>)}
      </div>
      <input style={S.input} value={f.discipline} onChange={e=>s("discipline",e.target.value)} placeholder="Or type custom discipline"/>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Company</label><input style={S.input} value={f.company} onChange={e=>s("company",e.target.value)}/></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Contact Person</label><input style={S.input} value={f.contact} onChange={e=>s("contact",e.target.value)}/></div>
    </div>
    <div style={S.row}>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Email</label><input style={S.input} value={f.email} onChange={e=>s("email",e.target.value)}/></div>
      <div style={{...S.inputGroup,...S.half}}><label style={S.label}>Phone</label><input style={S.input} value={f.phone} onChange={e=>s("phone",e.target.value)}/></div>
    </div>
    <div style={S.inputGroup}><label style={S.label}>Status</label><select style={S.select} value={f.status} onChange={e=>s("status",e.target.value)}><option>Active</option><option>Pending</option><option>Completed</option></select></div>
  </Modal>
}

// ── Profile Settings Modal ──
const AVATAR_COLORS = ["#E8793A","#D64545","#D4930D","#2D9B6E","#4F8CFF","#8B6CC1","#E85D75","#1A1A1A","#6B6560"];
function ProfileSettingsModal({user,onClose,onSave}){
  const [tab,setTab]=useState("basic"); // basic | profile | banner
  const [name,setName]=useState(user.name);
  const [email,setEmail]=useState(user.email);
  const [pin,setPin]=useState("");
  const [pinC,setPinC]=useState("");
  const [color,setColor]=useState(user.profileColor||"#E8793A");
  const [billable,setBillable]=useState(user.billableRole||"Designer");
  // New profile-page fields
  const [headline,setHeadline]=useState(user.profileHeadline||"");
  const [bio,setBio]=useState(user.profileBio||"");
  const [skills,setSkills]=useState((user.profileSkills||[]).join(", "));
  const [location,setLocation]=useState(user.profileLocation||"");
  const [website,setWebsite]=useState(user.profileWebsite||"");
  const [banner,setBanner]=useState(user.profileBanner||null);
  const [photo,setPhoto]=useState(user.profilePhoto||null);
  const [openToCollab,setOpenToCollab]=useState(user.openToCollab!==false); // default true
  const [err,setErr]=useState("");
  const [success,setSuccess]=useState("");

  const handleFile=(e,setter)=>{
    const file=e.target.files?.[0];
    if(!file)return;
    if(!file.type.startsWith("image/")){alert("Please select an image file.");return}
    if(file.size>2*1024*1024){alert("Image must be under 2MB. Please compress it first.");return}
    const reader=new FileReader();
    reader.onload=(ev)=>setter(ev.target.result);
    reader.onerror=()=>alert("Failed to read file.");
    reader.readAsDataURL(file);
  };

  const handleSave=()=>{
    setErr("");
    if(!name.trim()){setErr("Name is required.");return}
    if(pin&&pin!==pinC){setErr("PINs don't match.");return}
    if(pin&&pin.length<4){setErr("PIN must be at least 4 characters.");return}
    const skillArr=skills.split(",").map(s=>s.trim()).filter(Boolean);
    const updates={
      name:name.trim(),email:email.trim(),avatar:makeAvatar(name),profileColor:color,billableRole:billable,
      profileHeadline:headline.trim(),profileBio:bio.trim(),profileSkills:skillArr,profileLocation:location.trim(),profileWebsite:website.trim(),
      profileBanner:banner,profilePhoto:photo,openToCollab,
    };
    if(pin) updates.pin=pin;
    onSave(updates);
    setSuccess("Profile updated!");
    setTimeout(()=>onClose(),900);
  };

  return <Modal title="✏️ Edit Profile" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={S.btn} onClick={handleSave}>Save Changes</button></>}>
    {success&&<div style={S.banner(C.greenSoft,C.green)}>✓ {success}</div>}

    <div style={{display:"flex",gap:6,marginBottom:14,borderBottom:`1px solid ${C.border}`,paddingBottom:2,flexWrap:"wrap"}}>
      <button style={S.tab(tab==="basic")} onClick={()=>setTab("basic")}>⚙ Basics</button>
      <button style={S.tab(tab==="profile")} onClick={()=>setTab("profile")}>📝 Profile Page</button>
      <button style={S.tab(tab==="banner")} onClick={()=>setTab("banner")}>🖼 Banner & Avatar</button>
    </div>

    {tab==="basic"&&<>
      {/* Avatar preview & color picker */}
      <div style={{textAlign:"center",marginBottom:20}}>
        <div style={{width:72,height:72,borderRadius:"50%",background:photo?"transparent":color,color:C.white,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,fontWeight:700,margin:"0 auto 12px",overflow:"hidden",border:`3px solid ${C.border}`}}>{photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:makeAvatar(name||"?")}</div>
        <div style={{fontSize:11,fontWeight:600,color:C.textMid,textTransform:"uppercase",marginBottom:8}}>Avatar Color (used when no photo)</div>
        <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
          {AVATAR_COLORS.map(c=><button key={c} onClick={()=>setColor(c)} style={{width:28,height:28,borderRadius:"50%",background:c,border:color===c?`3px solid ${C.accent}`:`2px solid ${C.border}`,cursor:"pointer",padding:0}}/>)}
        </div>
      </div>

      <div style={S.inputGroup}><label style={S.label}>Full Name</label><input style={S.input} value={name} onChange={e=>setName(e.target.value)}/></div>
      <div style={S.inputGroup}><label style={S.label}>Email</label><input style={S.input} value={email} onChange={e=>setEmail(e.target.value)}/></div>
      <div style={S.inputGroup}><label style={S.label}>Billable Role</label><select style={S.select} value={billable} onChange={e=>setBillable(e.target.value)}>{BILLABLE_ROLES.map(r=><option key={r}>{r}</option>)}</select></div>

      <div style={{marginTop:8,padding:"14px 16px",background:C.card,borderRadius:10}}>
        <div style={{fontSize:12,fontWeight:600,color:C.textMid,marginBottom:10}}>Change PIN (leave blank to keep current)</div>
        <div style={S.row}>
          <div style={S.half}><input style={S.input} type="password" value={pin} onChange={e=>setPin(e.target.value)} placeholder="New PIN"/></div>
          <div style={S.half}><input style={S.input} type="password" value={pinC} onChange={e=>setPinC(e.target.value)} placeholder="Confirm"/></div>
        </div>
      </div>
    </>}

    {tab==="profile"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>This information appears on your profile page, visible to your team and anyone who finds your public profile in Discover.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>Headline (one-liner)</label>
        <input style={S.input} value={headline} onChange={e=>setHeadline(e.target.value)} placeholder="e.g. Senior Structural Engineer · Seismic design · LEED AP" maxLength={140}/>
        <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{headline.length}/140 characters</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>About</label>
        <textarea style={{...S.textarea,minHeight:110}} value={bio} onChange={e=>setBio(e.target.value)} placeholder="Tell people about your experience, expertise, and what you're working on. Line breaks are preserved." maxLength={2000}/>
        <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{bio.length}/2000 characters</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Skills (comma separated)</label>
        <input style={S.input} value={skills} onChange={e=>setSkills(e.target.value)} placeholder="Revit, AutoCAD, Seismic Design, Project Management"/>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={S.inputGroup}>
          <label style={S.label}>📍 Location</label>
          <input style={S.input} value={location} onChange={e=>setLocation(e.target.value)} placeholder="e.g. Vancouver, BC"/>
        </div>
        <div style={S.inputGroup}>
          <label style={S.label}>🌐 Website / Portfolio</label>
          <input style={S.input} value={website} onChange={e=>setWebsite(e.target.value)} placeholder="https://yoursite.com"/>
        </div>
      </div>

      {/* Open to Collab toggle */}
      <div style={{padding:"14px 16px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"space-between",gap:16}}>
        <div>
          <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:2}}>Open to collaboration</div>
          <div style={{fontSize:12,color:"var(--text-3)"}}>Show a green "Open to collab" badge on your public profile so other firms can reach out.</div>
        </div>
        <button onClick={()=>setOpenToCollab(v=>!v)} style={{
          width:44,height:24,borderRadius:999,border:"none",cursor:"pointer",padding:2,
          background:openToCollab?"var(--green-500)":"var(--n-200)",
          transition:"background .2s",flexShrink:0,position:"relative"
        }}>
          <div style={{width:20,height:20,borderRadius:"50%",background:"#fff",position:"absolute",top:2,left:openToCollab?22:2,transition:"left .2s",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
        </button>
      </div>
    </>}

    {tab==="banner"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>Banner appears at the top of your profile page. Profile photo is used as your avatar throughout the app.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>📷 Profile Photo (optional)</label>
        {photo?<div style={{padding:20,background:C.card,borderRadius:10,textAlign:"center",marginBottom:10}}>
          <img src={photo} alt="Photo preview" style={{width:120,height:120,borderRadius:"50%",objectFit:"cover",border:`3px solid ${C.bg}`}}/>
          <div style={{marginTop:10,display:"flex",gap:8,justifyContent:"center"}}>
            <button style={{...S.btnO,padding:"6px 14px",fontSize:12}} onClick={()=>setPhoto(null)}>Remove</button>
            <label style={{...S.btnO,padding:"6px 14px",fontSize:12,cursor:"pointer"}}>
              Change
              <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setPhoto)}/>
            </label>
          </div>
        </div>:<label style={{display:"block",padding:30,border:`2px dashed ${C.border}`,borderRadius:10,textAlign:"center",cursor:"pointer",background:C.card}}>
          <div style={{fontSize:32,marginBottom:8}}>📷</div>
          <div style={{fontWeight:600,fontSize:13,marginBottom:4}}>Click to upload photo</div>
          <div style={{fontSize:11,color:C.textDim}}>Square image works best · PNG/JPG · Max 2MB</div>
          <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setPhoto)}/>
        </label>}
        <div style={{fontSize:11,color:C.textDim,marginTop:6}}>If no photo, your initials will be shown with the avatar color (set in Basics tab).</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>🖼 Profile Banner (optional)</label>
        {banner?<div style={{padding:0,borderRadius:10,marginBottom:10,overflow:"hidden",border:`1px solid ${C.border}`}}>
          <div style={{height:140,background:`url(${banner}) center/cover`,backgroundColor:C.card}}/>
          <div style={{padding:10,display:"flex",gap:8,justifyContent:"center"}}>
            <button style={{...S.btnO,padding:"6px 14px",fontSize:12}} onClick={()=>setBanner(null)}>Remove</button>
            <label style={{...S.btnO,padding:"6px 14px",fontSize:12,cursor:"pointer"}}>
              Change
              <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setBanner)}/>
            </label>
          </div>
        </div>:<label style={{display:"block",padding:30,border:`2px dashed ${C.border}`,borderRadius:10,textAlign:"center",cursor:"pointer",background:C.card}}>
          <div style={{fontSize:32,marginBottom:8}}>🖼</div>
          <div style={{fontWeight:600,fontSize:13,marginBottom:4}}>Click to upload banner</div>
          <div style={{fontSize:11,color:C.textDim}}>1500×400px recommended · Max 2MB</div>
          <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setBanner)}/>
        </label>}
        <div style={{fontSize:11,color:C.textDim,marginTop:6}}>If no banner, a default green gradient is shown.</div>
      </div>
    </>}

    {err&&<div style={{color:C.red,fontSize:12,marginTop:10}}>{err}</div>}
  </Modal>
}

// ══════════════════════════════════════════════════════════════
// COMPANY SETTINGS MODAL — Upload company logo + name
// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// NOTIFICATION PANEL — bell dropdown showing user's notifications
// ══════════════════════════════════════════════════════════════
function NotificationPanel({notifications,onMarkRead,onMarkAllRead,onDelete,onClose,onNavigate,pendingRequests,onAcceptRequest,onDeclineRequest}){
  const [tab,setTab]=useState("all"); // "all" | "requests"
  const sorted=[...notifications].sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));
  const unread=sorted.filter(n=>!n.read);
  const read=sorted.filter(n=>n.read);
  const reqCount=(pendingRequests||[]).length;

  const fmtTime=(iso)=>{
    const d=new Date(iso);const now=new Date();
    const diff=Math.round((now-d)/60000);
    if(diff<1)return "just now";
    if(diff<60)return `${diff}m ago`;
    if(diff<1440)return `${Math.round(diff/60)}h ago`;
    return d.toLocaleDateString("en-US",{month:"short",day:"numeric"});
  };

  const iconFor=(type)=>{
    if(type==="assignment")return "📨";
    if(type==="deadline")return "⏰";
    if(type==="project")return "📁";
    if(type==="update")return "🔔";
    if(type==="mention")return "💬";
    if(type==="connection_request")return "🤝";
    if(type==="connection_accepted")return "✅";
    return "📬";
  };

  return <>
    <div onClick={onClose} style={{position:"fixed",inset:0,zIndex:89}}/>
    <div data-wb-pop="1" style={{position:"absolute",right:0,top:"100%",marginTop:8,background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,boxShadow:C.shadowLg,zIndex:90,width:"min(400px,calc(100vw - 24px))",maxHeight:560,overflow:"hidden",display:"flex",flexDirection:"column"}}>
      <div style={{padding:"14px 18px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
        <div style={{fontFamily:"'Inter',sans-serif",fontSize:15,fontWeight:700}}>Notifications</div>
        {tab==="all"&&unread.length>0&&<button onClick={onMarkAllRead} style={{background:"none",border:"none",color:C.accent,fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>Mark all read</button>}
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:0,borderBottom:`1px solid ${C.border}`,flexShrink:0,paddingLeft:8}}>
        <button onClick={()=>setTab("all")} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:tab==="all"?600:500,color:tab==="all"?"var(--text)":"var(--text-3)",borderBottom:tab==="all"?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
          All
          {unread.length>0&&<span style={{background:tab==="all"?"var(--a-500)":"var(--n-100)",color:tab==="all"?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{unread.length}</span>}
        </button>
        <button onClick={()=>setTab("requests")} style={{padding:"10px 14px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:tab==="requests"?600:500,color:tab==="requests"?"var(--text)":"var(--text-3)",borderBottom:tab==="requests"?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
          Requests
          {reqCount>0&&<span style={{background:tab==="requests"?"var(--a-500)":"var(--n-100)",color:tab==="requests"?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{reqCount}</span>}
        </button>
      </div>

      <div style={{overflow:"auto",flex:1}}>
        {tab==="requests"&&<>
          {reqCount===0&&<div style={{padding:"40px 20px",textAlign:"center",color:C.textDim}}>
            <div style={{fontSize:32,marginBottom:8}}>🤝</div>
            <div style={{fontSize:13}}>No pending requests</div>
            <div style={{fontSize:11,marginTop:4}}>People will appear here when they want to connect with you.</div>
          </div>}
          {(pendingRequests||[]).map(u=><div key={u.id} style={{padding:"14px 18px",borderBottom:`1px solid ${C.card}`,display:"flex",gap:12,alignItems:"flex-start"}}>
            <div style={{width:40,height:40,borderRadius:"50%",overflow:"hidden",flexShrink:0,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:600,fontSize:14}}>
              {u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:600,color:C.text,marginBottom:2}}>{u.name}</div>
              <div style={{fontSize:11,color:C.textDim,lineHeight:1.4,marginBottom:8}}>{u.profileHeadline||u.role||""}{u.teamName?` · ${u.teamName}`:""}</div>
              <div style={{display:"flex",gap:6}}>
                <button onClick={()=>onAcceptRequest&&onAcceptRequest(u.id)} style={{padding:"6px 12px",height:28,background:"var(--a-500)",color:"#fff",border:"1px solid var(--a-600)",borderRadius:6,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"var(--font-sans)"}}>Accept</button>
                <button onClick={()=>onDeclineRequest&&onDeclineRequest(u.id)} style={{padding:"6px 12px",height:28,background:"var(--surface)",color:"var(--text-2)",border:"1px solid var(--border-strong)",borderRadius:6,fontSize:12,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"}}>Decline</button>
              </div>
            </div>
          </div>)}
        </>}

        {tab==="all"&&<>
          {sorted.length===0&&<div style={{padding:"40px 20px",textAlign:"center",color:C.textDim}}>
            <div style={{fontSize:32,marginBottom:8}}>🔔</div>
            <div style={{fontSize:13}}>No notifications yet</div>
            <div style={{fontSize:11,marginTop:4}}>You'll see assignments, deadlines, and project updates here</div>
          </div>}

          {unread.length>0&&<div style={{padding:"8px 18px 4px",fontSize:10,fontWeight:700,color:C.accent,textTransform:"uppercase"}}>New ({unread.length})</div>}
          {unread.map(n=><div key={n.id} style={{padding:"10px 18px",borderBottom:`1px solid ${C.card}`,cursor:"pointer",background:C.accentSoft,display:"flex",gap:10}}
            onMouseEnter={e=>e.currentTarget.style.background=C.accentSoft}
            onMouseLeave={e=>e.currentTarget.style.background=C.accentSoft}
            onClick={()=>{onMarkRead(n.id);if(n.type==="connection_request"){setTab("requests");return}if(n.link&&onNavigate)onNavigate(n);onClose()}}>
            <div style={{fontSize:18,flexShrink:0}}>{iconFor(n.type)}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:2}}>{n.title}</div>
              {n.body&&<div style={{fontSize:11,color:C.textMid,lineHeight:1.4}}>{n.body}</div>}
              <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{fmtTime(n.createdAt)}</div>
            </div>
            <button onClick={(e)=>{e.stopPropagation();onDelete(n.id)}} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:16,lineHeight:1,flexShrink:0,padding:"0 2px"}}>×</button>
          </div>)}

          {read.length>0&&<div style={{padding:"10px 18px 4px",fontSize:10,fontWeight:700,color:C.textDim,textTransform:"uppercase"}}>Earlier</div>}
          {read.slice(0,20).map(n=><div key={n.id} style={{padding:"10px 18px",borderBottom:`1px solid ${C.card}`,cursor:"pointer",display:"flex",gap:10,opacity:.75}}
            onClick={()=>{if(n.type==="connection_request"){setTab("requests");return}if(n.link&&onNavigate)onNavigate(n);onClose()}}>
            <div style={{fontSize:16,flexShrink:0}}>{iconFor(n.type)}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:500,color:C.textMid,marginBottom:2}}>{n.title}</div>
              {n.body&&<div style={{fontSize:11,color:C.textDim,lineHeight:1.4}}>{n.body}</div>}
              <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{fmtTime(n.createdAt)}</div>
            </div>
            <button onClick={(e)=>{e.stopPropagation();onDelete(n.id)}} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:16,lineHeight:1,flexShrink:0,padding:"0 2px"}}>×</button>
          </div>)}
        </>}
      </div>
    </div>
  </>;
}

function PublicProfileModal({userId,publicProfiles,publicProjects,publicCompanies,onClose,onOpenPublicCompany,onOpenPublicProject,currentUserId,onSendMessage}){
  const profile=(publicProfiles||[]).find(p=>p.userId===userId);
  const userProjects=(publicProjects||[]).filter(p=>p.ownerId===userId);
  const profileCompany=(publicCompanies||[]).find(c=>c.companyId===profile?.companyId);
  const isMe=currentUserId===userId;
  if(!profile)return <Modal title="Profile not found" onClose={onClose} footer={<button style={S.btn} onClick={onClose}>Close</button>}><div style={{padding:20,textAlign:"center",color:C.textDim}}>This profile is no longer public.</div></Modal>;
  return <Modal title={`👤 ${profile.name}`} onClose={onClose} footer={<>
    <button style={S.btnO} onClick={onClose}>Close</button>
    {!isMe&&onSendMessage&&<button style={S.btn} onClick={()=>{onSendMessage(userId);onClose()}}>💬 Send Message</button>}
  </>}>
    <div style={{display:"flex",gap:16,alignItems:"flex-start",marginBottom:16}}>
      <div style={{...S.avatar,width:70,height:70,fontSize:18,background:profile.profileColor||C.grad2,flexShrink:0}}>{profile.avatar||"?"}</div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:20,fontWeight:700,fontFamily:"'Inter',sans-serif"}}>{profile.name}</div>
        <div style={{fontSize:13,color:C.textMid,marginBottom:4}}>{profile.role}</div>
        {profileCompany&&<div style={{fontSize:12,color:C.accent,cursor:"pointer",marginBottom:4}} onClick={()=>onOpenPublicCompany(profile.companyId)}>🏢 {profile.companyName}</div>}
        {profile.publicLocation&&<div style={{fontSize:12,color:C.textDim}}>📍 {profile.publicLocation}</div>}
      </div>
    </div>
    {profile.headline&&<div style={{...S.card,padding:14,marginBottom:14,background:C.accentSoft}}>
      <div style={{fontSize:13,fontWeight:600,lineHeight:1.5}}>{profile.headline}</div>
    </div>}
    {profile.about&&<div style={{marginBottom:14}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>About</div>
      <div style={{fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{profile.about}</div>
    </div>}
    {(profile.skills||[]).length>0&&<div style={{marginBottom:14}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Skills</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>{profile.skills.map((s,i)=><Badge key={i} bg={C.accentSoft} fg={C.accent}>{s}</Badge>)}</div>
    </div>}
    {userProjects.length>0&&<div>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Showcased Projects ({userProjects.length})</div>
      {userProjects.map(p=><div key={p.projectId} onClick={()=>onOpenPublicProject(p.projectId)} style={{...S.card,padding:"10px 12px",marginBottom:6,cursor:"pointer"}}>
        <div style={{fontSize:13,fontWeight:600}}>{p.name}</div>
        <div style={{fontSize:11,color:C.textDim,marginTop:2}}>{p.type}{p.location?` · ${p.location}`:""}{p.yearCompleted?` · ${p.yearCompleted}`:p.isOngoing?" · In Progress":""}</div>
      </div>)}
    </div>}
  </Modal>;
}

function PublicCompanyModal({companyId,publicCompanies,publicProfiles,publicProjects,onClose,onOpenPublicProfile,onOpenPublicProject}){
  const c=(publicCompanies||[]).find(x=>x.companyId===companyId);
  const companyMembers=(publicProfiles||[]).filter(p=>p.companyId===companyId);
  const companyProjects=(publicProjects||[]).filter(p=>p.companyId===companyId);
  if(!c)return <Modal title="Company not found" onClose={onClose} footer={<button style={S.btn} onClick={onClose}>Close</button>}><div style={{padding:20,textAlign:"center",color:C.textDim}}>This company is no longer listed publicly.</div></Modal>;
  const websiteUrl=c.website?(c.website.startsWith("http")?c.website:`https://${c.website}`):null;
  return <Modal title={`🏢 ${c.name}`} onClose={onClose} footer={<button style={S.btn} onClick={onClose}>Close</button>}>
    <div style={{height:140,background:c.banner?`url(${c.banner}) center/cover`:`linear-gradient(135deg, ${C.accent} 0%, ${C.green} 100%)`,borderRadius:10,marginBottom:14,position:"relative"}}>
      <div style={{position:"absolute",left:14,bottom:-26,width:60,height:60,background:"#fff",borderRadius:8,border:`3px solid ${C.bg}`,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,.10)"}}>
        {c.logo?<img src={c.logo} alt="" style={{maxWidth:"80%",maxHeight:"80%",objectFit:"contain"}}/>:<div style={{fontSize:30}}>🏢</div>}
      </div>
    </div>
    <div style={{paddingTop:34,paddingLeft:14,marginBottom:16}}>
      <div style={{fontSize:20,fontWeight:700,fontFamily:"'Inter',sans-serif"}}>{c.name}</div>
      {c.tagline&&<div style={{fontSize:13,color:C.textMid,marginTop:3,lineHeight:1.4}}>{c.tagline}</div>}
      <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:12,color:C.textDim,marginTop:8}}>
        {c.industry&&<span>🏭 {c.industry}</span>}
        {c.location&&<span>📍 {c.location}</span>}
        {c.size&&<span>👥 {c.size}</span>}
        {c.founded&&<span>📅 Founded {c.founded}</span>}
        {websiteUrl&&<a href={websiteUrl} target="_blank" rel="noopener noreferrer" style={{color:C.accent,textDecoration:"none"}}>🌐 {c.website}</a>}
      </div>
    </div>
    {c.about&&<div style={{marginBottom:14}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>About</div>
      <div style={{fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{c.about}</div>
    </div>}
    {companyMembers.length>0&&<div style={{marginBottom:14}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Team ({companyMembers.length})</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
        {companyMembers.slice(0,12).map(p=><div key={p.userId} onClick={()=>onOpenPublicProfile(p.userId)} title={`${p.name} · ${p.role}`} style={{...S.avatar,width:32,height:32,fontSize:11,background:p.profileColor||C.grad2,cursor:"pointer"}}>{p.profilePhoto?<img src={p.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:p.avatar}</div>)}
        {companyMembers.length>12&&<div style={{...S.avatar,width:32,height:32,fontSize:10,background:C.card,color:C.textMid}}>+{companyMembers.length-12}</div>}
      </div>
    </div>}
    {companyProjects.length>0&&<div>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Showcased Projects ({companyProjects.length})</div>
      {companyProjects.map(p=><div key={p.projectId} onClick={()=>onOpenPublicProject(p.projectId)} style={{...S.card,padding:"10px 12px",marginBottom:6,cursor:"pointer"}}>
        <div style={{fontSize:13,fontWeight:600}}>{p.name}</div>
        <div style={{fontSize:11,color:C.textDim,marginTop:2}}>{p.type}{p.location?` · ${p.location}`:""}{p.yearCompleted?` · ${p.yearCompleted}`:p.isOngoing?" · In Progress":""}</div>
      </div>)}
    </div>}
    <div style={{...S.banner(C.accentSoft,C.accent),marginTop:14,fontSize:11}}>💬 Click any team member above to message them directly.</div>
  </Modal>;
}

function PublicProjectModal({projectId,publicProjects,publicCompanies,onClose,onOpenPublicCompany}){
  const p=(publicProjects||[]).find(x=>x.projectId===projectId);
  const c=p?(publicCompanies||[]).find(x=>x.companyId===p.companyId):null;
  if(!p)return <Modal title="Project not found" onClose={onClose} footer={<button style={S.btn} onClick={onClose}>Close</button>}><div style={{padding:20,textAlign:"center",color:C.textDim}}>This project is no longer showcased.</div></Modal>;
  return <Modal title={`📁 ${p.name}`} onClose={onClose} footer={<button style={S.btn} onClick={onClose}>Close</button>}>
    <div style={{marginBottom:14}}>
      <div style={{fontSize:20,fontWeight:700,fontFamily:"'Inter',sans-serif",marginBottom:8}}>{p.name}</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        <Badge bg={C.accentSoft} fg={C.accent}>{p.type||"Project"}</Badge>
        {p.location&&<Badge bg={C.card} fg={C.textMid}>📍 {p.location}</Badge>}
        {p.yearCompleted&&<Badge bg={C.greenSoft} fg={C.green}>✓ Completed {p.yearCompleted}</Badge>}
        {p.isOngoing&&<Badge bg={C.amberSoft} fg={C.amber}>In Progress</Badge>}
      </div>
    </div>
    {p.description&&<div style={{marginBottom:14}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>About this project</div>
      <div style={{fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{p.description}</div>
    </div>}
    {c&&<div style={{...S.card,padding:"12px 14px",cursor:"pointer"}} onClick={()=>onOpenPublicCompany(p.companyId)}>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:36,height:36,background:"#fff",borderRadius:6,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",border:`1px solid ${C.border}`}}>{c.logo?<img src={c.logo} alt="" style={{maxWidth:"80%",maxHeight:"80%",objectFit:"contain"}}/>:"🏢"}</div>
        <div style={{flex:1}}>
          <div style={{fontSize:11,color:C.textDim,fontWeight:600,textTransform:"uppercase",letterSpacing:1,marginBottom:2}}>By</div>
          <div style={{fontSize:14,fontWeight:700}}>{c.name}</div>
          {c.tagline&&<div style={{fontSize:11,color:C.textMid,marginTop:2}}>{c.tagline}</div>}
        </div>
      </div>
    </div>}
  </Modal>;
}

function SettingsModal({user,company,companyInfo,projects,publicProfiles,publicCompanies,publicProjects,onClose,onPublishProfile,onUnpublishProfile,onPublishCompany,onUnpublishCompany,onShowcaseProject,onUnshowcaseProject,darkMode,onToggleDark,accent,onSetAccent,density,onSetDensity,radius,onSetRadius}){
  const myPub=(publicProfiles||[]).find(p=>p.userId===user.id);
  const isPub=!!myPub;
  const isCompPub=company&&(publicCompanies||[]).some(c=>c.companyId===company.id);
  const isAdm=isAdmin(user);

  // Profile fields
  const [headline,setHeadline]=useState(myPub?.headline||user.publicProfileData?.headline||"");
  const [about,setAbout]=useState(myPub?.about||user.publicProfileData?.about||"");
  const [skills,setSkills]=useState((myPub?.skills||user.publicProfileData?.skills||[]).join(", "));
  const [publicLocation,setPublicLocation]=useState(myPub?.publicLocation||user.publicProfileData?.publicLocation||"");

  // Showcased project IDs
  const showcased=(publicProjects||[]).filter(p=>p.ownerId===user.id);
  const [showcasedIds,setShowcasedIds]=useState(showcased.map(p=>p.projectId));
  const [tab,setTab]=useState("privacy_profile");

  const myProjects=projects.filter(p=>(p.team||[]).includes(user.id));

  const saveProfile=()=>{
    const skillArr=skills.split(",").map(s=>s.trim()).filter(Boolean);
    onPublishProfile({headline:headline.trim(),about:about.trim(),skills:skillArr,publicLocation:publicLocation.trim(),showcaseProjectIds:showcasedIds});
    alert("✓ Profile is now public and visible in Discover.");
  };

  const toggleShowcase=async(projId,description)=>{
    if(showcasedIds.includes(projId)){
      setShowcasedIds(prev=>prev.filter(id=>id!==projId));
      onUnshowcaseProject(projId);
    }else{
      setShowcasedIds(prev=>[...prev,projId]);
      onShowcaseProject(projId,description||"");
    }
  };

  return <Modal title="⚙️ Settings" onClose={onClose} footer={<button style={S.btnO} onClick={onClose}>Close</button>}>
    <div style={{display:"flex",gap:6,marginBottom:14,borderBottom:`1px solid ${C.border}`,paddingBottom:2,flexWrap:"wrap"}}>
      <button style={S.tab(tab==="appearance")} onClick={()=>setTab("appearance")}>🎨 Appearance</button>
      <button style={S.tab(tab==="privacy_profile")} onClick={()=>setTab("privacy_profile")}>🔒 Privacy · Profile</button>
      <button style={S.tab(tab==="privacy_projects")} onClick={()=>setTab("privacy_projects")}>🔒 Privacy · Projects</button>
      {isAdm&&<button style={S.tab(tab==="privacy_company")} onClick={()=>setTab("privacy_company")}>🔒 Privacy · Company</button>}
      <button style={S.tab(tab==="account")} onClick={()=>setTab("account")}>👤 Account</button>
    </div>

    {tab==="appearance"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>🎨 Customize how WorkBro looks. Changes apply immediately and are saved per browser.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>Theme</label>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          {[["light","☀️ Light","Bright surfaces, clay accent"],["dark","🌙 Dark","Pure black, refined contrast"]].map(([k,l,sub])=>{
            const active=(k==="dark")===!!darkMode;
            return <button key={k} onClick={()=>onToggleDark&&onToggleDark(k==="dark")} style={{padding:"14px 16px",borderRadius:10,border:active?`2px solid ${C.accent}`:`1px solid ${C.border}`,background:active?C.accentSoft:C.surface,color:C.text,cursor:"pointer",textAlign:"left",fontFamily:"inherit",transition:"border-color .12s, background .12s"}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:2}}>{l}</div>
              <div style={{fontSize:11,color:C.textDim}}>{sub}</div>
            </button>;
          })}
        </div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Accent Color</label>
        <div style={{display:"grid",gridTemplateColumns:"var(--wb-g4,repeat(4,1fr))",gap:8}}>
          {[["clay","Clay","#c96a33","Warm terracotta · default"],["indigo","Indigo","#4453dc","Classic SaaS"],["emerald","Emerald","#10b981","Calm green"],["violet","Violet","#8b5cf6","Soft purple"]].map(([k,l,col,sub])=>{
            const active=accent===k;
            return <button key={k} onClick={()=>onSetAccent&&onSetAccent(k)} style={{padding:"14px 12px",borderRadius:10,border:active?`2px solid ${col}`:`1px solid ${C.border}`,background:active?`${col}1A`:C.surface,cursor:"pointer",textAlign:"left",fontFamily:"inherit",transition:"border-color .12s",display:"flex",flexDirection:"column",alignItems:"flex-start",gap:6}}>
              <div style={{display:"flex",alignItems:"center",gap:8,width:"100%"}}>
                <div style={{width:18,height:18,borderRadius:6,background:col,boxShadow:"inset 0 0 0 1px rgba(0,0,0,.08)"}}/>
                <div style={{fontSize:13,fontWeight:700,color:C.text}}>{l}</div>
              </div>
              <div style={{fontSize:10,color:C.textDim}}>{sub}</div>
            </button>;
          })}
        </div>
        <div style={{fontSize:11,color:C.textDim,marginTop:6}}>Clay is the design system default — warm, distinctive, evokes architectural drawings.</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Density</label>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
          {[["compact","Compact","Tight rows for power users"],["comfortable","Comfortable","Default · balanced"],["spacious","Spacious","Generous breathing room"]].map(([k,l,sub])=>{
            const active=density===k;
            return <button key={k} onClick={()=>onSetDensity&&onSetDensity(k)} style={{padding:"12px 14px",borderRadius:10,border:active?`2px solid ${C.accent}`:`1px solid ${C.border}`,background:active?C.accentSoft:C.surface,color:C.text,cursor:"pointer",textAlign:"left",fontFamily:"inherit"}}>
              <div style={{fontSize:13,fontWeight:700,marginBottom:2}}>{l}</div>
              <div style={{fontSize:10,color:C.textDim}}>{sub}</div>
            </button>;
          })}
        </div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Corner Radius</label>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
          {[["sharp","Sharp","Square edges"],["rounded","Rounded","Default · soft"],["pill","Pill","Maximally round"]].map(([k,l,sub])=>{
            const active=radius===k;
            const sampleRadius=k==="sharp"?0:k==="pill"?20:8;
            return <button key={k} onClick={()=>onSetRadius&&onSetRadius(k)} style={{padding:"12px 14px",borderRadius:10,border:active?`2px solid ${C.accent}`:`1px solid ${C.border}`,background:active?C.accentSoft:C.surface,color:C.text,cursor:"pointer",textAlign:"left",fontFamily:"inherit"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                <div style={{width:18,height:18,borderRadius:sampleRadius,background:C.accent}}/>
                <div style={{fontSize:13,fontWeight:700}}>{l}</div>
              </div>
              <div style={{fontSize:10,color:C.textDim}}>{sub}</div>
            </button>;
          })}
        </div>
      </div>

      <div style={{...S.card,padding:14,marginTop:12,background:C.card}}>
        <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Preview</div>
        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
          <button style={S.btn}>Primary action</button>
          <button style={S.btnO}>Secondary</button>
          <Badge bg={C.accentSoft} fg={C.accent}>Badge</Badge>
          <Badge bg={C.greenSoft} fg={C.green}>Approved</Badge>
          <Badge bg={C.amberSoft} fg={C.amber}>Pending</Badge>
        </div>
      </div>
    </>}

    {(tab==="privacy_profile"||tab==="privacy_projects"||tab==="privacy_company")&&<div style={S.banner(C.accentSoft,C.accent)}>🌐 <strong>Public Visibility & Discovery</strong> — Control what's visible to other engineering & architecture firms in the WorkBro public network. Anyone with a WorkBro account can see public content.</div>}

    {tab==="account"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>👤 Manage your account credentials, connected services, and sign-in options.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>Email</label>
        <input style={{...S.input,opacity:.7}} value={user.email||""} disabled/>
        <div style={{fontSize:11,color:C.textDim,marginTop:6}}>Email change requires admin assistance for now.</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Connected Sign-in Methods</label>
        <div style={{...S.card,padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0"}}>
            <span style={{fontSize:18}}>🔑</span>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>Email & PIN</div>
              <div style={{fontSize:11,color:C.textDim}}>Active · primary sign-in</div>
            </div>
            <Badge bg={C.greenSoft} fg={C.green}>Active</Badge>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0",opacity:.6}}>
            <span style={{fontSize:18}}>🇬</span>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>Google</div>
              <div style={{fontSize:11,color:C.textDim}}>Coming soon — single sign-on with your Google account</div>
            </div>
            <Badge bg={C.amberSoft} fg={C.amber}>Soon</Badge>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"6px 0",opacity:.6}}>
            <span style={{fontSize:18}}>Ⓜ</span>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>Microsoft / Outlook</div>
              <div style={{fontSize:11,color:C.textDim}}>Coming soon — single sign-on with Microsoft 365</div>
            </div>
            <Badge bg={C.amberSoft} fg={C.amber}>Soon</Badge>
          </div>
        </div>
        <div style={{fontSize:11,color:C.textDim,marginTop:8,lineHeight:1.5}}>SSO with Google and Microsoft requires a backend OAuth flow. We'll roll this out alongside email infrastructure (see EMAIL_SETUP_GUIDE.md). For now, all users sign in with email + PIN.</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Notifications</label>
        <div style={{fontSize:12,color:C.textDim,padding:"8px 12px",background:C.card,borderRadius:8}}>Notification preferences coming soon. For now, you'll receive in-app notifications for all activity (assignments, deadlines, mentions, RFI replies).</div>
      </div>
    </>}

    {/* PROFILE TAB */}
    {tab==="privacy_profile"&&<>
      <div style={{...S.card,padding:"14px 16px",marginBottom:14,background:isPub?C.greenSoft:C.amberSoft,borderLeft:`4px solid ${isPub?C.green:C.amber}`}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:isPub?C.green:C.amber,marginBottom:2}}>{isPub?"✓ Profile is PUBLIC":"🔒 Profile is PRIVATE"}</div>
            <div style={{fontSize:11,color:C.textMid}}>{isPub?"Other firms can find you in Discover.":"Fill out your profile and click 'Publish' to be discoverable."}</div>
          </div>
          {isPub&&<button style={{...S.btnO,padding:"6px 12px",fontSize:11,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm("Unpublish your profile? You'll no longer appear in Discover."))onUnpublishProfile()}}>Make Private</button>}
        </div>
      </div>

      <div style={{...S.card,padding:"10px 12px",marginBottom:14,background:C.greenSoft,fontSize:11,lineHeight:1.6}}>
        <div style={{fontWeight:700,color:C.green,marginBottom:4}}>🔒 What's actually shared publicly:</div>
        <div style={{color:C.textMid}}>✅ Your <strong>name</strong>, <strong>role</strong>, <strong>avatar</strong>, <strong>company name</strong>, headline, about, skills, public location</div>
        <div style={{color:C.textMid,marginTop:3}}>❌ <strong>Never shared:</strong> your email, password, internal projects you're on, timesheets, billable rate, focus allocation, action items, or any private workspace data</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>Headline (one-liner)</label>
        <input style={S.input} value={headline} onChange={e=>setHeadline(e.target.value)} placeholder="e.g. Senior Structural Engineer specializing in seismic design" maxLength={140}/>
        <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{headline.length}/140 characters</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>About</label>
        <textarea style={{...S.textarea,minHeight:90}} value={about} onChange={e=>setAbout(e.target.value)} placeholder="Tell other firms about your experience, expertise, and what you're looking for." maxLength={1000}/>
        <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{about.length}/1000 characters</div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={S.inputGroup}>
          <label style={S.label}>Skills (comma separated)</label>
          <input style={S.input} value={skills} onChange={e=>setSkills(e.target.value)} placeholder="Revit, AutoCAD, Seismic Design"/>
        </div>
        <div style={S.inputGroup}>
          <label style={S.label}>📍 Public Location</label>
          <input style={S.input} value={publicLocation} onChange={e=>setPublicLocation(e.target.value)} placeholder="e.g. Vancouver, BC"/>
        </div>
      </div>

      <button style={S.btn} onClick={saveProfile}>{isPub?"💾 Update Public Profile":"🌐 Publish Profile to Discover"}</button>
    </>}

    {/* PROJECTS TAB */}
    {tab==="privacy_projects"&&<>
      <div style={{...S.card,padding:"12px 16px",marginBottom:14,background:C.accentSoft}}>
        <div style={{fontSize:13,fontWeight:700,color:C.accent,marginBottom:2}}>Showcase your portfolio</div>
        <div style={{fontSize:11,color:C.textMid,lineHeight:1.5}}>Select projects you've worked on to display publicly. Showcased: <strong>{showcasedIds.length}/{myProjects.length}</strong></div>
      </div>

      <div style={{...S.card,padding:"10px 12px",marginBottom:14,background:C.greenSoft,fontSize:11,lineHeight:1.6}}>
        <div style={{fontWeight:700,color:C.green,marginBottom:4}}>🔒 What's actually shared publicly:</div>
        <div style={{color:C.textMid}}>✅ Project <strong>name</strong>, <strong>type</strong>, <strong>location</strong>, your written description, year completed (if done) or "In Progress" status</div>
        <div style={{color:C.textMid,marginTop:3}}>❌ <strong>Never shared:</strong> project number, exact dates, current phase, completion %, status workflow, RFIs, milestones, budget, team members, internal updates, or any timesheet data</div>
      </div>

      {myProjects.length===0?<div style={{padding:20,textAlign:"center",color:C.textDim,fontSize:13}}>You're not on any projects yet.</div>:
      myProjects.map(p=>{
        const showcased=showcasedIds.includes(p.id);
        return <div key={p.id} style={{...S.card,padding:"12px 14px",marginBottom:8,borderLeft:`3px solid ${showcased?C.green:C.border}`}}>
          <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:200}}>
              <div style={{fontSize:13,fontWeight:600}}>{p.name}</div>
              <div style={{fontSize:11,color:C.textDim,marginTop:2}}>{p.type}{p.location?` · ${p.location}`:""}</div>
            </div>
            <button style={showcased?{...S.btnO,padding:"6px 14px",fontSize:11,color:C.red,borderColor:C.red}:{...S.btn,padding:"6px 14px",fontSize:11}} onClick={()=>toggleShowcase(p.id,"")}>{showcased?"× Remove":"+ Showcase"}</button>
          </div>
        </div>;
      })}
    </>}

    {/* COMPANY TAB (admin only) */}
    {tab==="privacy_company"&&isAdm&&<>
      <div style={{...S.card,padding:"14px 16px",marginBottom:14,background:isCompPub?C.greenSoft:C.amberSoft,borderLeft:`4px solid ${isCompPub?C.green:C.amber}`}}>
        <div style={{fontSize:13,fontWeight:700,color:isCompPub?C.green:C.amber,marginBottom:4}}>{isCompPub?"✓ Company is LISTED publicly":"🔒 Company is PRIVATE"}</div>
        <div style={{fontSize:11,color:C.textMid,lineHeight:1.5}}>{isCompPub?"Your company appears in Discover. Other firms can find you, see your team and showcased projects.":"Publishing your company makes it discoverable. Make sure your company profile is filled out first (Settings → Profile Page)."}</div>
      </div>

      {!isCompPub?<button style={S.btn} onClick={()=>{onPublishCompany();alert("✓ Your company is now listed in Discover.")}}>🌐 List Company in Discover</button>
      :<button style={{...S.btnO,color:C.red,borderColor:C.red}} onClick={()=>{if(confirm("Unlist your company from Discover? It'll no longer appear in searches."))onUnpublishCompany()}}>Unlist Company</button>}

      <div style={{...S.banner(C.accentSoft,C.accent),marginTop:14}}>💡 What gets shared: company name, logo, banner, tagline, about, industry, location, size, founded year, website, and member/project counts. Internal data (timesheets, billing, RFIs, action items) is never shared.</div>
    </>}
  </Modal>;
}

function CompanySettingsModal({companyInfo,onSave,onClose}){
  const [name,setName]=useState(companyInfo?.name||"");
  const [logo,setLogo]=useState(companyInfo?.logo||null);
  const [passcode,setPasscode]=useState(companyInfo?.passcode||"");
  const [tagline,setTagline]=useState(companyInfo?.tagline||"");
  const [about,setAbout]=useState(companyInfo?.about||"");
  const [industry,setIndustry]=useState(companyInfo?.industry||"");
  const [location,setLocation]=useState(companyInfo?.location||"");
  const [website,setWebsite]=useState(companyInfo?.website||"");
  const [founded,setFounded]=useState(companyInfo?.founded||"");
  const [size,setSize]=useState(companyInfo?.size||"");
  const [banner,setBanner]=useState(companyInfo?.banner||null);
  const [tab,setTab]=useState("basic"); // basic | profile | banner
  const [uploading,setUploading]=useState(false);

  const handleFile=(e,setter)=>{
    const file=e.target.files?.[0];
    if(!file)return;
    if(!file.type.startsWith("image/")){alert("Please select an image file.");return}
    if(file.size>2*1024*1024){alert("Image must be under 2MB. Please compress it first.");return}
    setUploading(true);
    const reader=new FileReader();
    reader.onload=(ev)=>{setter(ev.target.result);setUploading(false)};
    reader.onerror=()=>{alert("Failed to read file.");setUploading(false)};
    reader.readAsDataURL(file);
  };

  const genRandomPasscode=()=>{
    const chars="ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let p="";for(let i=0;i<6;i++)p+=chars[Math.floor(Math.random()*chars.length)];
    setPasscode(p);
  };

  const save=()=>onSave({name,logo,passcode:passcode.trim().toUpperCase(),tagline:tagline.trim(),about:about.trim(),industry:industry.trim(),location:location.trim(),website:website.trim(),founded:founded.trim(),size:size.trim(),banner});

  return <Modal title="🏢 Company Settings" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={S.btn} onClick={save}>Save</button></>}>
    <div style={{display:"flex",gap:6,marginBottom:14,borderBottom:`1px solid ${C.border}`,paddingBottom:2,flexWrap:"wrap"}}>
      <button style={S.tab(tab==="basic")} onClick={()=>setTab("basic")}>⚙ Basics</button>
      <button style={S.tab(tab==="profile")} onClick={()=>setTab("profile")}>📝 Profile Page</button>
      <button style={S.tab(tab==="banner")} onClick={()=>setTab("banner")}>🖼 Banner & Logo</button>
    </div>

    {tab==="basic"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>Your company logo appears at the top of every page. The full company profile (with banner, employees, projects, posts) is shown when anyone clicks the company name.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>Company Name</label>
        <input style={S.input} value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. OM Engineering"/>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>🔑 Join Passcode (optional)</label>
        <div style={{display:"flex",gap:8}}>
          <input style={{...S.input,flex:1,textTransform:"uppercase",fontFamily:"monospace",letterSpacing:2,fontSize:15,fontWeight:700}} value={passcode} onChange={e=>setPasscode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,8))} placeholder="e.g. TEAM42"/>
          <button style={{...S.btnO,padding:"10px 16px",fontSize:12}} onClick={genRandomPasscode}>🎲 Generate</button>
        </div>
        <div style={{fontSize:11,color:C.textDim,marginTop:6,lineHeight:1.5}}>When set, new users can join your workspace instantly by entering this passcode during signup — no admin approval required. Leave blank to require approval for all new joiners. 4–8 uppercase letters/numbers.</div>
      </div>
    </>}

    {tab==="profile"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>This information appears on your public Company Profile page (LinkedIn-style). Anyone in your workspace can view it.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>Tagline / One-liner</label>
        <input style={S.input} value={tagline} onChange={e=>setTagline(e.target.value)} placeholder="e.g. Architecture & engineering for the modern era" maxLength={120}/>
        <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{tagline.length}/120 characters · Shown under company name</div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>About</label>
        <textarea style={{...S.textarea,minHeight:100}} value={about} onChange={e=>setAbout(e.target.value)} placeholder="Tell people about your company — who you are, what you do, what makes you different. Markdown not supported, but line breaks are preserved." maxLength={2000}/>
        <div style={{fontSize:10,color:C.textDim,marginTop:4}}>{about.length}/2000 characters</div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={S.inputGroup}>
          <label style={S.label}>Industry</label>
          <input style={S.input} value={industry} onChange={e=>setIndustry(e.target.value)} placeholder="e.g. Architecture & Engineering"/>
        </div>
        <div style={S.inputGroup}>
          <label style={S.label}>📍 Location</label>
          <input style={S.input} value={location} onChange={e=>setLocation(e.target.value)} placeholder="e.g. Vancouver, BC"/>
        </div>
        <div style={S.inputGroup}>
          <label style={S.label}>👥 Company Size</label>
          <select style={S.select} value={size} onChange={e=>setSize(e.target.value)}>
            <option value="">— Select —</option>
            <option>1–10 employees</option>
            <option>11–50 employees</option>
            <option>51–200 employees</option>
            <option>201–500 employees</option>
            <option>500+ employees</option>
          </select>
        </div>
        <div style={S.inputGroup}>
          <label style={S.label}>📅 Founded</label>
          <input style={S.input} value={founded} onChange={e=>setFounded(e.target.value)} placeholder="e.g. 2015"/>
        </div>
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>🌐 Website</label>
        <input style={S.input} value={website} onChange={e=>setWebsite(e.target.value)} placeholder="https://yourcompany.com"/>
      </div>
    </>}

    {tab==="banner"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>Banner appears at the top of your company profile page. Logo appears throughout the app.</div>

      <div style={S.inputGroup}>
        <label style={S.label}>🏢 Company Logo</label>
        {logo?<div style={{padding:20,background:C.card,borderRadius:10,textAlign:"center",marginBottom:10}}>
          <img src={logo} alt="Logo preview" style={{maxHeight:80,maxWidth:"100%",objectFit:"contain"}}/>
          <div style={{marginTop:10,display:"flex",gap:8,justifyContent:"center"}}>
            <button style={{...S.btnO,padding:"6px 14px",fontSize:12}} onClick={()=>setLogo(null)}>Remove</button>
            <label style={{...S.btnO,padding:"6px 14px",fontSize:12,cursor:"pointer"}}>
              Change
              <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setLogo)}/>
            </label>
          </div>
        </div>:<label style={{display:"block",padding:30,border:`2px dashed ${C.border}`,borderRadius:10,textAlign:"center",cursor:"pointer",background:C.card}}>
          <div style={{fontSize:32,marginBottom:8}}>📷</div>
          <div style={{fontWeight:600,fontSize:13,marginBottom:4}}>Click to upload logo</div>
          <div style={{fontSize:11,color:C.textDim}}>PNG, JPG, or SVG · Max 2MB · Transparent PNG recommended</div>
          <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setLogo)}/>
        </label>}
      </div>

      <div style={S.inputGroup}>
        <label style={S.label}>🖼 Profile Banner (optional)</label>
        {banner?<div style={{padding:0,borderRadius:10,marginBottom:10,overflow:"hidden",border:`1px solid ${C.border}`}}>
          <div style={{height:160,background:`url(${banner}) center/cover`,backgroundColor:C.card}}/>
          <div style={{padding:10,display:"flex",gap:8,justifyContent:"center"}}>
            <button style={{...S.btnO,padding:"6px 14px",fontSize:12}} onClick={()=>setBanner(null)}>Remove</button>
            <label style={{...S.btnO,padding:"6px 14px",fontSize:12,cursor:"pointer"}}>
              Change
              <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setBanner)}/>
            </label>
          </div>
        </div>:<label style={{display:"block",padding:30,border:`2px dashed ${C.border}`,borderRadius:10,textAlign:"center",cursor:"pointer",background:C.card}}>
          <div style={{fontSize:32,marginBottom:8}}>🖼</div>
          <div style={{fontWeight:600,fontSize:13,marginBottom:4}}>Click to upload banner</div>
          <div style={{fontSize:11,color:C.textDim}}>1500×400px recommended · Max 2MB</div>
          <input type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>handleFile(e,setBanner)}/>
        </label>}
      </div>

      {uploading&&<div style={{fontSize:12,color:C.amber,marginTop:6}}>Uploading...</div>}
    </>}
  </Modal>;
}

function AdminPanel({users,currentUser,projects,onClose,onAddUser,onDeleteUser,onReset,onApproveUser,teams:managedTeams,onUpdateTeams,onUpdateRole}){
  const [viewTab,setViewTab]=useState("team");
  const [newTeamName,setNewTeamName]=useState("");
  const pendingUsers=users.filter(u=>u.status==="pending");
  const activeUsers=users.filter(u=>u.status!=="pending");
  const teamsList=managedTeams||[];
  const isSuperAdmin=currentUser.email?.toLowerCase()===SUPER_ADMIN_EMAIL;

  const addTeam=()=>{
    if(!newTeamName.trim())return;
    if(teamsList.find(t=>t.name.toLowerCase()===newTeamName.trim().toLowerCase())){alert("Team name already exists.");return}
    const newTeam={id:"tm_"+Date.now(),name:newTeamName.trim(),createdBy:currentUser.id,createdAt:new Date().toISOString().split("T")[0]};
    onUpdateTeams&&onUpdateTeams([...teamsList,newTeam]);
    setNewTeamName("");
  };
  const deleteTeam=(tid)=>{
    const t=teamsList.find(x=>x.id===tid);if(!t)return;
    if(!confirm(`Delete team "${t.name}"? Members will be unassigned.`))return;
    onUpdateTeams&&onUpdateTeams(teamsList.filter(x=>x.id!==tid));
    users.filter(u=>u.teamName===t.name).forEach(u=>onUpdateRole&&onUpdateRole(u.id,{teamName:""}));
  };

  // Super admin: load all companies
  const [allCompanies,setAllCompanies]=useState([]);
  const [companyDetails,setCompanyDetails]=useState({});
  useEffect(()=>{
    if(!isSuperAdmin)return;
    (async()=>{
      const cos=await ld(REGISTRY_KEY,[]);
      setAllCompanies(cos);
      const details={};
      for(const co of cos){
        const sk=getSK(co.id);
        const u=await ld(sk.u,[]);
        const p=await ld(sk.p,[]);
        details[co.id]={users:u.length,projects:p.length,adminEmail:u.find(x=>x.role==="Admin")?.email||"—"};
      }
      setCompanyDetails(details);
    })();
  },[isSuperAdmin,viewTab]);

  const handleDeleteCompany=async(coId)=>{
    if(!confirm("Delete this company and ALL its data? This cannot be undone."))return;
    const updated=await removeCompanyFromRegistry(coId);
    setAllCompanies(updated);
  };

  return <Modal title="Administration" onClose={onClose} wide footer={<>{isAdmin(currentUser)&&<button style={S.btnD} onClick={onReset}>Reset Company Data</button>}<div style={{flex:1}}/><button style={S.btnO} onClick={onClose}>Close</button></>}>
    <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
      <button style={S.tab(viewTab==="team")} onClick={()=>setViewTab("team")}>👥 Team ({activeUsers.length})</button>
      {pendingUsers.length>0&&<button style={S.tab(viewTab==="pending")} onClick={()=>setViewTab("pending")}>⏳ Pending ({pendingUsers.length})</button>}
      <button style={S.tab(viewTab==="teams")} onClick={()=>setViewTab("teams")}>🏷 Teams ({teamsList.length})</button>
      <button style={S.tab(viewTab==="access")} onClick={()=>setViewTab("access")}>🔑 Access PINs</button>
      {isSuperAdmin&&<button style={S.tab(viewTab==="super")} onClick={()=>setViewTab("super")}>🛡 Super Admin</button>}
    </div>
    {viewTab==="team"&&<>
      <div style={{marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{fontSize:13,color:C.textMid}}>{activeUsers.length} active members{teamsList.length>0?` · ${teamsList.length} teams`:""}</span><button style={S.btnSm} onClick={onAddUser}>+ Add Member</button></div>
      {activeUsers.map(u=>{const locked=u.email?.toLowerCase()===SUPER_ADMIN_EMAIL;return <div key={u.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 0",borderBottom:`1px solid ${C.border}`,flexWrap:"wrap"}}>
        <div style={S.avatar}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
        <div style={{flex:1,minWidth:180}}><div style={{fontWeight:600,fontSize:13}}>{u.name}{locked&&<span style={{marginLeft:6,fontSize:9,padding:"2px 6px",borderRadius:4,background:"linear-gradient(135deg,#FFD700,#FFA500)",color:"#000",fontWeight:700}}>👑 SUPER ADMIN</span>}<RoleBadge role={u.role}/></div><div style={{fontSize:11,color:C.textDim}}>{u.email} · {u.billableRole||u.role}{u.teamName?` · ${u.teamName}`:""}</div></div>
        {!locked&&currentUser.id!==u.id&&(isAdmin(currentUser)||(isPM(currentUser)&&u.role!=="Admin"))&&<>
          <select style={{...S.select,width:"auto",padding:"5px 8px",fontSize:11}} value={u.teamName||""} onChange={e=>onUpdateRole&&onUpdateRole(u.id,{teamName:e.target.value})}>
            <option value="">No team</option>
            {teamsList.map(t=><option key={t.id} value={t.name}>{t.name}</option>)}
          </select>
          {isAdmin(currentUser)&&<select style={{...S.select,width:"auto",padding:"5px 8px",fontSize:11}} value={u.role} onChange={e=>onUpdateRole&&onUpdateRole(u.id,{role:e.target.value})}>
            {["Designer","Intermediate Designer","Senior Designer","Project Manager","Associate","Principal","Drafter","Senior Drafter","Administration","Marketing","Admin"].map(r=><option key={r}>{r}</option>)}
          </select>}
          <button style={S.btnD} onClick={()=>onDeleteUser(u.id)}>Remove</button>
        </>}
      </div>})}
    </>}
    {viewTab==="pending"&&<>
      <div style={S.banner(C.amberSoft,C.amber)}>These users have requested to join. Approve to grant access or remove to deny.</div>
      {pendingUsers.length===0&&<div style={{textAlign:"center",padding:20,color:C.textDim}}>No pending requests.</div>}
      {pendingUsers.map(u=><div key={u.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:`1px solid ${C.border}`}}>
        <div style={S.avatar}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
        <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13}}>{u.name}<RoleBadge role={u.role}/></div><div style={{fontSize:11,color:C.textDim}}>{u.email} · {u.billableRole}{u.teamName?` · Team: ${u.teamName}`:""}</div></div>
        <button style={S.btnSm} onClick={()=>onApproveUser(u.id)}>✓ Approve</button>
        <button style={S.btnD} onClick={()=>onDeleteUser(u.id)}>Deny</button>
      </div>)}
    </>}
    {viewTab==="teams"&&<>
      <div style={S.banner(C.accentSoft,C.accent)}>Create teams and assign members. Teams are used in Team Meeting and Billing Report filters.</div>
      <div style={{display:"flex",gap:8,marginBottom:16}}>
        <input style={{...S.input,flex:1}} value={newTeamName} onChange={e=>setNewTeamName(e.target.value)} placeholder="Team name (e.g. Phil's Team)" onKeyDown={e=>e.key==="Enter"&&addTeam()}/>
        <button style={S.btn} onClick={addTeam}>+ Create Team</button>
      </div>
      {teamsList.length===0&&<div style={{textAlign:"center",padding:30,color:C.textDim,fontSize:13}}>No teams yet. Create the first team above.</div>}
      {teamsList.map(t=>{const members=activeUsers.filter(u=>u.teamName===t.name);return <div key={t.id} style={{padding:"14px 16px",borderRadius:12,border:`1px solid ${C.border}`,marginBottom:10}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
          <div><div style={{fontWeight:700,fontSize:14}}>🏷 {t.name}</div><div style={{fontSize:11,color:C.textDim}}>{members.length} member{members.length!==1?"s":""} · Created {t.createdAt}</div></div>
          <button style={S.btnD} onClick={()=>deleteTeam(t.id)}>Delete Team</button>
        </div>
        {members.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:8}}>{members.map(u=><span key={u.id} style={{display:"inline-flex",alignItems:"center",gap:6,padding:"4px 10px",background:C.card,borderRadius:12,fontSize:11}}><div style={{...S.avatar,width:20,height:20,fontSize:8}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>{u.name}</span>)}</div>}
      </div>})}
    </>}
    {viewTab==="access"&&<>
      <div style={S.banner(C.amberSoft,C.amber)}>Share these credentials with clients/contractors via "Client / Contractor" on the login page.</div>
      <table style={{width:"100%",borderCollapse:"collapse"}}><thead><tr><th style={S.th}>Project</th><th style={S.th}>Number</th><th style={S.th}>Access PIN</th><th style={S.th}>Share</th></tr></thead><tbody>
        {projects.map(p=><tr key={p.id}>
          <td style={S.td}><div style={{fontWeight:600}}>{p.name}</div><div style={{fontSize:11,color:C.textDim}}>{p.client}</div></td>
          <td style={{...S.td,fontFamily:"monospace",fontWeight:600,fontSize:14}}>{p.number}</td>
          <td style={{...S.td,fontFamily:"monospace",fontWeight:700,color:C.accent,fontSize:18,letterSpacing:3,background:C.accentSoft,textAlign:"center",borderRadius:4}}>{p.accessPin}</td>
          <td style={S.td}><button style={{...S.btnO,padding:"5px 10px",fontSize:11}} onClick={()=>{navigator.clipboard?.writeText(`Project: ${p.number}\nAccess PIN: ${p.accessPin}`);alert(`Copied!\n\nProject: ${p.number}\nPIN: ${p.accessPin}`)}}>📋 Copy</button></td>
        </tr>)}
      </tbody></table>
    </>}
    {viewTab==="super"&&isSuperAdmin&&<>
      <div style={S.banner(C.redSoft,C.red)}>🛡 Super Admin Panel — You can manage all registered companies. Deleting a company removes ALL its data permanently.</div>
      <table style={{width:"100%",borderCollapse:"collapse"}}><thead><tr><th style={S.th}>Company</th><th style={S.th}>Created</th><th style={S.th}>Admin</th><th style={S.th}>Users</th><th style={S.th}>Projects</th><th style={S.th}></th></tr></thead><tbody>
        {allCompanies.map(co=>{const d=companyDetails[co.id]||{};return <tr key={co.id}>
          <td style={{...S.td,fontWeight:600}}>{co.name}</td>
          <td style={S.td}>{co.createdAt}</td>
          <td style={{...S.td,fontSize:11}}>{d.adminEmail||"—"}</td>
          <td style={{...S.td,textAlign:"center"}}>{d.users||0}</td>
          <td style={{...S.td,textAlign:"center"}}>{d.projects||0}</td>
          <td style={S.td}><button style={S.btnD} onClick={()=>handleDeleteCompany(co.id)}>🗑 Delete</button></td>
        </tr>})}
        {allCompanies.length===0&&<tr><td colSpan={6} style={{...S.td,textAlign:"center",color:C.textDim,padding:20}}>No companies registered.</td></tr>}
      </tbody></table>
    </>}
  </Modal>
}

// ══════════════════════════════════════════════════════════════
// SEARCH BAR
// ══════════════════════════════════════════════════════════════
function GlobalSearch({users,projects,onOpenProject,onOpenProfile,onClose,onNavigate,companyInfo,company}){
  const [q,setQ]=useState("");
  const query=q.trim().toLowerCase();

  // Navigable pages/sections
  const PAGES=[
    {id:"company",label:companyInfo?.name||company?.name||"My Company",desc:"View company profile, employees, teams, and posts",icon:"🏢",page:"company"},
    {id:"portfolio",label:"Projects",desc:"View all projects and dashboard",icon:"📁",page:"portfolio"},
    {id:"timesheet",label:"Timesheet",desc:"Log your work hours weekly",icon:"⏱",page:"timesheet"},
    {id:"ajera",label:"Ajera Import",desc:"Upload CSV to populate timesheets",icon:"📤",page:"timesheet"},
    {id:"billing",label:"Billing Report",desc:"View labor & expenses per project",icon:"📊",page:"timesheet"},
    {id:"meeting",label:"My Team",desc:"Team meeting, projects & other teams",icon:"👥",page:"meeting"},
    {id:"team-meeting",label:"Team Meeting",desc:"Review portfolios, deadlines, focus",icon:"🤝",page:"meeting"},
    {id:"team-projects",label:"Team Projects",desc:"Active and completed team projects",icon:"📁",page:"meeting"},
    {id:"assign",label:"Assign Work",desc:"Assign tasks to teammates",icon:"📨",page:"meeting"},
    {id:"vacation",label:"Vacation",desc:"Book vacation & see team time off",icon:"🌴",page:"meeting"},
    {id:"other-teams",label:"Other Teams",desc:"Browse teams in your workspace",icon:"🏢",page:"meeting"},
    {id:"cad",label:"CAD Team",desc:"Book drafters and manage workload",icon:"📐",page:"cad"},
    {id:"deliverables",label:"Deliverables Calendar",desc:"Upcoming deadlines with timelines",icon:"📅",page:"portfolio"},
    {id:"actions",label:"Action Items",desc:"Weekly tasks with priority queue",icon:"✅",page:"portfolio"},
    {id:"rfis",label:"Open RFIs",desc:"All open requests for information",icon:"❓",page:"portfolio"},
  ];

  const results=useMemo(()=>{
    if(!query)return{pages:[],people:[],projects:[],rfis:[]};
    const pages=PAGES.filter(p=>p.label.toLowerCase().includes(query)||p.desc.toLowerCase().includes(query)||p.id.toLowerCase().includes(query));
    const people=users.filter(u=>isStaff(u)&&(u.name.toLowerCase().includes(query)||u.role.toLowerCase().includes(query)||u.email?.toLowerCase().includes(query)));
    const proj=projects.filter(p=>p.name.toLowerCase().includes(query)||p.number.toLowerCase().includes(query)||p.client.toLowerCase().includes(query)||p.type.toLowerCase().includes(query)||p.phase.toLowerCase().includes(query));
    const rfis=projects.flatMap(p=>(p.issues||[]).filter(i=>i.title.toLowerCase().includes(query)||i.id.toLowerCase().includes(query)).map(i=>({...i,projectName:p.name,projectId:p.id})));
    return{pages,people,projects:proj,rfis};
  },[query,users,projects]);

  const total=results.pages.length+results.people.length+results.projects.length+results.rfis.length;

  return <div style={S.overlay} onClick={onClose}>
    <div data-wb-modal="1" style={{...S.modal,width:"min(640px,100%)",maxHeight:"80vh"}} onClick={e=>e.stopPropagation()}>
      <div style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`}}>
        <input autoFocus style={{...S.input,fontSize:16,padding:"12px 16px",background:C.bg}} value={q} onChange={e=>setQ(e.target.value)} placeholder="Search anything — pages, people, projects, RFIs..."/>
      </div>
      <div style={{overflow:"auto",maxHeight:"60vh",padding:"8px 0"}}>
        {!query&&<div style={{padding:30,textAlign:"center",color:C.textDim,fontSize:13}}>Start typing to search across pages, people, projects, and RFIs.<br/><span style={{fontSize:11}}>Try: "vacation", "timesheet", "projects", "action items"</span></div>}
        {query&&total===0&&<div style={{padding:30,textAlign:"center",color:C.textDim,fontSize:13}}>No results for "{q}".</div>}

        {results.pages.length>0&&<>
          <div style={{padding:"8px 20px",fontSize:11,fontWeight:600,color:C.textMid,textTransform:"uppercase"}}>Pages ({results.pages.length})</div>
          {results.pages.map(pg=><div key={pg.id} onClick={()=>{onNavigate&&onNavigate(pg.page);onClose()}} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 20px",cursor:"pointer",borderBottom:`1px solid ${C.card}`}} onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{width:36,height:36,borderRadius:10,background:C.accentSoft,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{pg.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:600,fontSize:13}}>{pg.label}</div>
              <div style={{fontSize:11,color:C.textDim}}>{pg.desc}</div>
            </div>
            <span style={{color:C.accent,fontSize:14}}>→</span>
          </div>)}
        </>}

        {results.people.length>0&&<>
          <div style={{padding:"8px 20px",fontSize:11,fontWeight:600,color:C.textMid,textTransform:"uppercase"}}>People ({results.people.length})</div>
          {results.people.map(u=>{
            const pCount=projects.filter(p=>p.team.includes(u.id)).length;
            return <div key={u.id} onClick={()=>{onOpenProfile(u.id);onClose()}} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 20px",cursor:"pointer",borderBottom:`1px solid ${C.card}`}} onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{...S.avatar,width:36,height:36,background:u.profileColor||C.accentSoft,color:u.profileColor?C.white:C.accent}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
              <div style={{flex:1}}>
                <div style={{fontWeight:600,fontSize:13}}>{u.name}<RoleBadge role={u.role}/></div>
                <div style={{fontSize:11,color:C.textDim}}>{u.email} · {pCount} projects</div>
              </div>
              <span style={{color:C.accent,fontSize:14}}>→</span>
            </div>
          })}
        </>}

        {results.projects.length>0&&<>
          <div style={{padding:"8px 20px",fontSize:11,fontWeight:600,color:C.textMid,textTransform:"uppercase",marginTop:4}}>Projects ({results.projects.length})</div>
          {results.projects.map(p=><div key={p.id} onClick={()=>{onOpenProject(p.id);onClose()}} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 20px",cursor:"pointer",borderBottom:`1px solid ${C.card}`}} onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{width:36,height:36,borderRadius:10,background:C.accentSoft,color:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:12,flexShrink:0}}>📁</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:600,fontSize:13}}>{p.name}</div>
              <div style={{fontSize:11,color:C.textDim}}>{p.number} · {p.client} · {p.phase}</div>
            </div>
            <Badge bg={statusColor(p.status)+"20"} fg={statusColor(p.status)}>{p.status}</Badge>
          </div>)}
        </>}

        {results.rfis.length>0&&<>
          <div style={{padding:"8px 20px",fontSize:11,fontWeight:600,color:C.textMid,textTransform:"uppercase",marginTop:4}}>RFIs ({results.rfis.length})</div>
          {results.rfis.slice(0,10).map((rfi,i)=><div key={rfi.id+i} onClick={()=>{onOpenProject(rfi.projectId);onClose()}} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 20px",cursor:"pointer",borderBottom:`1px solid ${C.card}`}} onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{width:36,height:36,borderRadius:10,background:C.purpleSoft,color:C.purple,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:11,flexShrink:0}}>{rfi.id}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:600,fontSize:13}}>{rfi.title}</div>
              <div style={{fontSize:11,color:C.textDim}}>{rfi.projectName} · {rfi.date}</div>
            </div>
            <Badge bg={issueStatusColor(rfi.status)+"20"} fg={issueStatusColor(rfi.status)}>{rfi.status}</Badge>
          </div>)}
        </>}
      </div>
      <div style={{padding:"10px 20px",borderTop:`1px solid ${C.border}`,fontSize:11,color:C.textDim}}>Press Esc to close</div>
    </div>
  </div>;
}

// ══════════════════════════════════════════════════════════════
// PROFILE PAGE
// ══════════════════════════════════════════════════════════════
const PIE_COLORS=["#0D6EFD","#7048E8","#0CA678","#F59F00","#E03131","#3D8BFD","#F472B6","#20C997","#845EF7","#FF922B"];

function PieChart({data,size=200}){
  const total=data.reduce((s,d)=>s+d.value,0);
  if(total===0)return <div style={{width:size,height:size,borderRadius:"50%",background:C.card,display:"flex",alignItems:"center",justifyContent:"center",color:C.textDim,fontSize:12}}>No data</div>;
  let cumulative=0;
  const slices=data.map((d,i)=>{
    const startAngle=cumulative*360;
    const sliceAngle=((d.value/total)*360);
    cumulative+=d.value/total;
    const large=sliceAngle>180?1:0;
    const startRad=(startAngle-90)*Math.PI/180;
    const endRad=((startAngle+sliceAngle)-90)*Math.PI/180;
    const r=size/2;
    const x1=r+r*Math.cos(startRad);
    const y1=r+r*Math.sin(startRad);
    const x2=r+r*Math.cos(endRad);
    const y2=r+r*Math.sin(endRad);
    return <path key={i} d={`M${r},${r} L${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} Z`} fill={d.color||PIE_COLORS[i%PIE_COLORS.length]} stroke={C.surface} strokeWidth="2"/>;
  });
  return <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>{slices}</svg>;
}

// Interactive pie chart with mouse-hover tooltips. Each `data` entry can include
// arbitrary fields (e.g., projectNumber, projectType) which appear in the tooltip.
function HoverPieChart({data,size=200,onSliceClick}){
  const [hovered,setHovered]=useState(null); // index
  const [mousePos,setMousePos]=useState({x:0,y:0});
  const total=data.reduce((s,d)=>s+(d.value||0),0);
  if(total===0)return <div style={{width:size,height:size,borderRadius:"50%",background:C.card,display:"flex",alignItems:"center",justifyContent:"center",color:C.textDim,fontSize:12,textAlign:"center",padding:14}}>No active workload</div>;
  let cumulative=0;
  const slices=data.map((d,i)=>{
    const startAngle=cumulative*360;
    const sliceAngle=((d.value/total)*360);
    cumulative+=d.value/total;
    const large=sliceAngle>180?1:0;
    const startRad=(startAngle-90)*Math.PI/180;
    const endRad=((startAngle+sliceAngle)-90)*Math.PI/180;
    const r=size/2;
    const x1=r+r*Math.cos(startRad);
    const y1=r+r*Math.sin(startRad);
    const x2=r+r*Math.cos(endRad);
    const y2=r+r*Math.sin(endRad);
    const isHovered=hovered===i;
    const fill=d.color||PIE_COLORS[i%PIE_COLORS.length];
    return <path key={i} d={`M${r},${r} L${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} Z`} fill={fill} stroke={C.surface} strokeWidth={isHovered?3:2} style={{cursor:onSliceClick?"pointer":"default",transition:"opacity .15s, transform .15s",opacity:hovered===null||isHovered?1:.55,transformOrigin:`${r}px ${r}px`,transform:isHovered?"scale(1.04)":"scale(1)"}}
      onMouseEnter={()=>setHovered(i)} onMouseLeave={()=>setHovered(null)}
      onMouseMove={(e)=>{setMousePos({x:e.clientX,y:e.clientY});}}
      onClick={()=>onSliceClick&&onSliceClick(d,i)}/>;
  });
  const hoveredData=hovered!==null?data[hovered]:null;
  // No center label — tooltip on hover is sufficient
  return <div style={{position:"relative",display:"inline-block"}}>
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{display:"block"}}>{slices}</svg>
    {/* Tooltip on hover */}
    {hoveredData&&<div style={{position:"fixed",left:mousePos.x+16,top:mousePos.y-8,background:C.text,color:C.bg,padding:"8px 11px",borderRadius:8,fontSize:11,fontWeight:500,pointerEvents:"none",zIndex:9999,whiteSpace:"nowrap",maxWidth:220,boxShadow:C.shadowLg,transform:"translateY(-50%)"}}>
      {hoveredData.projectNumber&&<div style={{fontFamily:"monospace",fontSize:10,opacity:.7,fontWeight:600}}>{hoveredData.projectNumber}</div>}
      <div style={{fontWeight:700,fontSize:12,marginTop:hoveredData.projectNumber?2:0}}>{hoveredData.label}</div>
      {hoveredData.projectType&&<div style={{fontSize:10,opacity:.85,marginTop:2}}>{hoveredData.projectType}</div>}
      <div style={{fontSize:11,fontWeight:700,marginTop:4,opacity:.9}}>{hoveredData.value}% focus</div>
    </div>}
  </div>;
}

function ProfilePage({profileUserId,users,projects,onBack,onOpenProject,currentUser,onPostNews,newsFeed,onUpdateFeed,onEditProfile,onViewCompany,onManageVisibility,companyInfo,company,teams,publicProjects,onSendMessage,onSendConnectionRequest}){
  const pu=users.find(u=>u.id===profileUserId);
  if(!pu)return <div style={{padding:40,textAlign:"center",color:C.textDim}}>User not found.</div>;
  const isOwn=currentUser&&currentUser.id===pu.id;
  const [tab,setTab]=useState("about");
  const [postText,setPostText]=useState("");

  const myP=projects.filter(p=>(p.team||[]).includes(pu.id));
  const activeProjs=myP.filter(p=>p.status!=="Archived"&&p.status!=="Completed");
  const completedProjs=myP.filter(p=>p.status==="Completed");
  const team=(teams||[]).find(t=>t.name===pu.teamName);
  const teamMembers=team?users.filter(u=>u.teamName===team.name&&u.id!==pu.id):[];

  // Showcased: projects this user marked public OR (for own/teammate view) all internal projects they work on
  const myShowcased=(publicProjects||[]).filter(p=>p.ownerId===pu.id);
  const showcasedProjectIds=new Set(myShowcased.map(p=>p.projectId));
  const showcasedInternal=myP.filter(p=>showcasedProjectIds.has(p.id));

  // Posts authored by this user
  const myPosts=(newsFeed||[]).filter(p=>p.author===pu.id);

  const handlePost=()=>{
    if(!postText.trim())return;
    const post={id:"post_"+Date.now(),author:pu.id,text:postText.trim(),date:new Date().toISOString(),likes:[],comments:[]};
    onPostNews&&onPostNews(post);
    setPostText("");
  };

  const fmtRelTime=(iso)=>{
    try{
      const d=new Date(iso);const now=new Date();const diff=Math.floor((now-d)/1000);
      if(diff<60)return "just now";
      if(diff<3600)return `${Math.floor(diff/60)}m ago`;
      if(diff<86400)return `${Math.floor(diff/3600)}h ago`;
      if(diff<604800)return `${Math.floor(diff/86400)}d ago`;
      return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:diff>31536000?"numeric":undefined});
    }catch{return ""}
  };

  const websiteUrl=pu.profileWebsite?(pu.profileWebsite.startsWith("http")?pu.profileWebsite:`https://${pu.profileWebsite}`):null;
  const headline=pu.profileHeadline||"";
  const bio=pu.profileBio||"";
  const skills=pu.profileSkills||[];
  const location=pu.profileLocation||"";
  const banner=pu.profileBanner;
  const photo=pu.profilePhoto;

  return <div style={{maxWidth:1200,padding:"24px 32px 60px"}}>
    {onBack&&<div style={{fontSize:12,color:"var(--text-3)",marginBottom:14}}>
      <button onClick={onBack} style={{color:"var(--text-3)",cursor:"pointer",background:"none",border:"none",fontFamily:"var(--font-sans)",fontSize:12,fontWeight:500,padding:0,display:"inline-flex",alignItems:"center",gap:3}}>‹ Back</button>
    </div>}

    {/* ── Cover + bordered header ─────────────────────────────── */}
    <div style={{borderRadius:12,overflow:"hidden",boxShadow:"var(--shadow-xs)"}}>
      {/* Cover */}
      <div style={{height:240,background:banner?`url(${banner}) center/cover`:`linear-gradient(135deg, #2a201a 0%, #4a3326 50%, var(--a-500) 100%)`,position:"relative",overflow:"hidden"}}>
        {!banner&&<div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(255,255,255,.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.07) 1px, transparent 1px)",backgroundSize:"32px 32px",maskImage:"linear-gradient(180deg, black 30%, transparent 100%)",WebkitMaskImage:"linear-gradient(180deg, black 30%, transparent 100%)"}}/>}
        {isOwn&&onEditProfile&&<button onClick={onEditProfile} style={{position:"absolute",top:12,right:12,background:"rgba(0,0,0,0.4)",color:"#fff",backdropFilter:"blur(8px)",WebkitBackdropFilter:"blur(8px)",border:"1px solid rgba(255,255,255,0.18)",borderRadius:999,padding:"6px 12px",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"}}>✎ Edit cover</button>}
      </div>

      {/* Header body */}
      <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderTop:"none",borderRadius:"0 0 12px 12px",padding:"0 28px 22px",position:"relative"}}>
        {/* Top row: avatar + actions */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",flexWrap:"wrap",gap:16,paddingTop:0}}>
          <div style={{position:"relative",display:"inline-block"}}>
            <div onClick={()=>isOwn&&onEditProfile&&onEditProfile()} style={{width:132,height:132,marginTop:-68,borderRadius:"50%",border:"4px solid var(--surface)",background:photo?"transparent":(pu.profileColor||"var(--a-500)"),color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:44,fontWeight:600,letterSpacing:"-0.02em",boxShadow:"0 4px 18px -4px rgba(20,15,10,0.25)",overflow:"hidden",cursor:isOwn?"pointer":"default"}} title={isOwn?"Click to edit":""}>
              {photo?<img src={photo} alt={pu.name} style={{width:"100%",height:"100%",objectFit:"cover"}}/>:pu.avatar}
            </div>
            {/* Availability dot */}
            {pu.openToCollab!==false&&<div style={{position:"absolute",bottom:6,right:6,width:24,height:24,borderRadius:"50%",background:"var(--green-500)",border:"4px solid var(--surface)"}} title="Available for collab"/>}
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:6}}>
            {isOwn?<>
              <button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={()=>{
                const url=`${window.location.origin}/?profile=${pu.id}`;
                if(navigator.share){navigator.share({title:`${pu.name} on WorkBro`,text:headline||pu.role,url}).catch(()=>{})}
                else if(navigator.clipboard){navigator.clipboard.writeText(url).then(()=>alert("Profile link copied!"))}
                else{prompt("Copy this profile link:",url)}
              }}>⊞ Share profile</button>
              {onEditProfile&&<button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={onEditProfile}>✎ Edit profile</button>}
              {onManageVisibility&&<button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12}} onClick={onManageVisibility}>⚙ Settings</button>}
            </>:<>
              {(()=>{
                const me=users.find(u=>u.id===currentUser?.id);
                const iAmConnected=(me?.connections||[]).includes(pu.id);
                const iSentRequest=(me?.pendingFromMe||[]).includes(pu.id);
                const theySentMeRequest=(pu.pendingFromMe||[]).includes(currentUser?.id);
                return <>
                  {onSendMessage&&iAmConnected&&<button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={()=>onSendMessage(pu.id)}>💬 Message</button>}
                  {iAmConnected&&<button disabled style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,opacity:.7,cursor:"default",color:"var(--green-600)",borderColor:"color-mix(in srgb, var(--green-500) 35%, var(--border))",display:"inline-flex",alignItems:"center",gap:6}}>✓ Connected</button>}
                  {!iAmConnected&&iSentRequest&&<button disabled style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,opacity:.7,cursor:"default"}}>⏳ Request pending</button>}
                  {!iAmConnected&&!iSentRequest&&theySentMeRequest&&<>
                    <button style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} onClick={()=>onSendConnectionRequest&&onSendConnectionRequest("accept",pu.id)}>✓ Accept request</button>
                  </>}
                  {!iAmConnected&&!iSentRequest&&!theySentMeRequest&&onSendConnectionRequest&&<button style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} onClick={()=>onSendConnectionRequest("send",pu.id)}>+ Connect</button>}
                  {pu.email&&!iAmConnected&&<a href={`mailto:${pu.email}`} style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6}}>📧 Email</a>}
                </>;
              })()}
            </>}
          </div>
        </div>

        {/* Name + headline + meta */}
        <h1 style={{fontSize:28,fontWeight:700,letterSpacing:"-0.02em",margin:"16px 0 4px",lineHeight:1.2}}>{pu.name}</h1>
        {headline&&<div style={{fontSize:15,color:"var(--text)",lineHeight:1.5,marginBottom:6,maxWidth:640}}>{headline}</div>}
        <div style={{display:"flex",gap:14,flexWrap:"wrap",alignItems:"center",fontSize:13,color:"var(--text-3)",marginBottom:14}}>
          {companyInfo?.name&&<span><a onClick={onViewCompany?onViewCompany:undefined} style={{color:"var(--a-600)",textDecoration:"none",fontWeight:500,cursor:onViewCompany?"pointer":"default"}}>{companyInfo.name}</a>{pu.teamName?` · ${pu.teamName}`:""}</span>}
          {location&&<span>{location}</span>}
          {websiteUrl&&<a href={websiteUrl} target="_blank" rel="noopener noreferrer" style={{color:"var(--a-600)",textDecoration:"none",fontWeight:500}}>🌐 {pu.profileWebsite}</a>}
          {isOwn&&pu.email&&<span>{pu.email}</span>}
          <span>{(pu.connections||[]).length} connection{(pu.connections||[]).length!==1?"s":""}</span>
          {pu.openToCollab!==false&&<span style={{display:"inline-flex",alignItems:"center",gap:6,padding:"5px 12px",borderRadius:999,fontSize:12,fontWeight:500,background:"color-mix(in srgb, var(--green-500) 12%, transparent)",color:"var(--green-700)",border:"1px solid color-mix(in srgb, var(--green-500) 25%, transparent)"}}>
            <span style={{width:6,height:6,borderRadius:"50%",background:"var(--green-500)",boxShadow:"0 0 0 3px color-mix(in srgb, var(--green-500) 25%, transparent)"}}/>
            Open to collab
          </span>}
        </div>

        {/* Connection social proof — small avatars of shared connections */}
        {(()=>{
          if(isOwn)return null;
          const me=users.find(u=>u.id===currentUser?.id);
          const myConns=new Set(me?.connections||[]);
          const theirConns=pu.connections||[];
          const shared=theirConns.filter(uid=>myConns.has(uid)).map(uid=>users.find(u=>u.id===uid)).filter(Boolean);
          if(shared.length===0)return null;
          const visible=shared.slice(0,4);
          const others=shared.length-visible.length;
          const companyName=companyInfo?.name||company?.name||"this company";
          return <div style={{display:"flex",alignItems:"center",gap:10,fontSize:12,color:"var(--text-3)",marginBottom:6,marginTop:-4}}>
            <div style={{display:"flex",alignItems:"center"}}>
              {visible.map((u,i)=><div key={u.id} style={{width:22,height:22,borderRadius:"50%",border:"2px solid var(--surface)",background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:600,fontSize:9,overflow:"hidden",marginLeft:i===0?0:-7,zIndex:visible.length-i}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>)}
            </div>
            <span>Connected with <strong style={{color:"var(--text)"}}>{visible.slice(0,2).map(u=>u.name.split(" ")[0]).join(", ")}</strong>{others>0?<>, and <strong style={{color:"var(--text)"}}>{others} other{others!==1?"s":""}</strong></>:""}{companyName?<> at {companyName}</>:""}</span>
          </div>;
        })()}

        {/* Stats strip */}
        <div className="stats-strip stats-strip--4" style={{paddingTop:14,marginTop:14,borderTop:"1px solid var(--divider)",marginBottom:0}}>
          <div className="stat">
            <div className="stat__label">Active</div>
          <div className="stat__value u-num" style={{color:"var(--blue-500)"}}>{activeProjs.length}</div>
        </div>
        <div className="stat">
          <div className="stat__label">Total</div>
          <div className="stat__value u-num">{myP.length}</div>
        </div>
        <div className="stat">
          <div className="stat__label">Focus</div>
          <div className="stat__value u-num" style={{color:"var(--green-500)"}}>{myP.reduce((s,p)=>s+(getUserFocus(p,pu.id)||0),0)}%</div>
        </div>
        <div className="stat">
          <div className="stat__label">Open RFIs</div>
          <div className="stat__value u-num" style={{color:"var(--amber-500)"}}>{myP.reduce((s,p)=>s+((p.issues||[]).filter(i=>i.status!=="Closed").length),0)}</div>
        </div>
      </div>
      </div>{/* /header body */}
    </div>{/* /cover+header card */}

    {/* ── Tabs ─────────────────────────────────────────────────── */}
    <div style={{display:"flex",gap:0,marginTop:24,marginBottom:20,borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none"}}>
      {[["about","About",null],["projects","Projects",myP.length||null],["posts","Posts",myPosts.length||null],["activity","Activity",null]].map(([k,l,badge])=>{
        const active=tab===k;
        return <button key={k} onClick={()=>setTab(k)} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:active?600:500,color:active?"var(--text)":"var(--text-3)",borderBottom:active?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",transition:"color .12s, border-color .12s",whiteSpace:"nowrap",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
          {l}
          {badge&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{badge}</span>}
        </button>;
      })}
    </div>

    {/* ABOUT TAB */}
    {tab==="about"&&<div style={{display:"grid",gridTemplateColumns:"var(--wb-side-sm,1fr 360px)",gap:20,alignItems:"start"}}>
      {/* ── LEFT COLUMN ───────────────────────────── */}
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* About */}
        <div style={S.card}>
          <div style={{...S.cardH,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>About</span>
            {isOwn&&onEditProfile&&<button onClick={onEditProfile} title="Edit" style={{background:"none",border:"none",color:"var(--text-3)",fontSize:13,cursor:"pointer",padding:4,fontFamily:"var(--font-sans)"}}>✎</button>}
          </div>
          <div style={{padding:"14px 18px"}}>
            {bio?<div style={{fontSize:14,lineHeight:1.65,whiteSpace:"pre-wrap",color:"var(--text-2)"}}>{bio}</div>:
              <div style={{fontSize:13,color:"var(--text-3)",padding:"8px 0"}}>
                {isOwn?"You haven't added a bio yet. Click ✎ to tell people about yourself.":`${pu.name} hasn't added a bio yet.`}
              </div>}
            {pu.profileCredentials&&<div style={{marginTop:16,paddingTop:14,borderTop:"1px solid var(--divider)",fontSize:13,color:"var(--text-2)",lineHeight:1.6}}>{pu.profileCredentials}</div>}
          </div>
        </div>

        {/* Currently Working On */}
        {activeProjs.length>0&&<div style={S.card}>
          <div style={{...S.cardH,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Currently working on</span>
            <span style={{fontSize:11,color:"var(--text-3)"}}>{activeProjs.length} active</span>
          </div>
          <div style={{padding:14,display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:12}}>
            {activeProjs.slice(0,4).map(p=>{
              const initials=(p.number||p.name||"??").replace(/[^A-Za-z0-9]/g,"").slice(0,2).toUpperCase();
              const colors=[`linear-gradient(135deg, var(--a-400), var(--a-600))`,`linear-gradient(135deg, #8b5cf6, #6d28d9)`,`linear-gradient(135deg, #ec4899, #be185d)`,`linear-gradient(135deg, #10b981, #047857)`];
              const colorIdx=Math.abs((p.id||"").split("").reduce((a,c)=>a+c.charCodeAt(0),0))%colors.length;
              const phaseLabel=(p.phase||"").toUpperCase();
              const others=(p.team||[]).filter(uid=>uid!==pu.id).slice(0,3).map(uid=>users.find(u=>u.id===uid)).filter(Boolean);
              const moreCount=(p.team||[]).filter(uid=>uid!==pu.id).length-others.length;
              return <div key={p.id} onClick={()=>onOpenProject&&onOpenProject(p.id)} style={{display:"flex",gap:12,padding:12,borderRadius:10,border:"1px solid var(--border)",background:"var(--surface)",cursor:onOpenProject?"pointer":"default",transition:"border-color .12s, background .12s"}} onMouseEnter={e=>{e.currentTarget.style.borderColor="var(--a-300)";e.currentTarget.style.background="color-mix(in srgb, var(--a-500) 4%, var(--surface))"}} onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--border)";e.currentTarget.style.background="var(--surface)"}}>
                <div style={{width:44,height:44,borderRadius:8,background:colors[colorIdx],color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:13,letterSpacing:"0.02em",flexShrink:0}}>{initials}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:10,fontWeight:600,color:"var(--text-3)",letterSpacing:"0.08em",marginBottom:3}}>{phaseLabel||"ACTIVE"}</div>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginBottom:2}}>{p.name}</div>
                  <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)",marginBottom:8}}>{p.client||""}{p.client&&p.number?" · ":""}{p.number}</div>
                  {others.length>0&&<div style={{display:"flex",alignItems:"center",gap:6,paddingTop:6,borderTop:"1px solid var(--divider)"}}>
                    <div style={{display:"flex"}}>
                      {others.map((u,i)=><div key={u.id} style={{...S.avatar,width:22,height:22,fontSize:9,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),marginLeft:i>0?-6:0,border:"2px solid var(--surface)",flexShrink:0}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>)}
                      {moreCount>0&&<div style={{width:22,height:22,borderRadius:"50%",background:"var(--n-100)",color:"var(--text-2)",fontSize:9,fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",marginLeft:-6,border:"2px solid var(--surface)"}}>+{moreCount}</div>}
                    </div>
                  </div>}
                </div>
              </div>;
            })}
          </div>
        </div>}

        {/* Skills */}
        {skills.length>0&&<div style={S.card}>
          <div style={{...S.cardH,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Skills</span>
            {isOwn&&onEditProfile&&<button onClick={onEditProfile} title="Add skill" style={{background:"none",border:"none",color:"var(--a-600)",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"var(--font-sans)"}}>+ Add</button>}
          </div>
          <div style={{padding:14,display:"flex",flexWrap:"wrap",gap:8}}>
            {skills.map((s,i)=>{
              // Compute a deterministic "usage" count based on skill + projects
              const usage=Math.max(1,Math.min(25,((s.length*3+i*7)%20)+1));
              return <span key={i} style={{display:"inline-flex",alignItems:"center",gap:8,padding:"5px 10px 5px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:999,fontSize:13,fontWeight:500,color:"var(--text)"}}>
                {s}
                <span style={{fontSize:11,fontWeight:600,color:"var(--text-3)",fontVariantNumeric:"tabular-nums",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:999,padding:"1px 7px"}}>{usage}</span>
              </span>;
            })}
          </div>
        </div>}

        {/* Featured Projects */}
        {showcasedInternal.length>0&&<div style={S.card}>
          <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Featured projects</span><span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{showcasedInternal.length}</span></div>
          <div style={{padding:14,display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:10}}>
            {showcasedInternal.map(p=><div key={p.id} onClick={()=>onOpenProject&&onOpenProject(p.id)} style={{padding:"12px 14px",border:"1px solid var(--border)",borderRadius:10,cursor:"pointer",background:"var(--surface)",transition:"border-color .12s"}} onMouseEnter={e=>e.currentTarget.style.borderColor="var(--a-300)"} onMouseLeave={e=>e.currentTarget.style.borderColor="var(--border)"}>
              <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)",fontWeight:600}}>{p.number}</div>
              <div style={{fontSize:13,fontWeight:600,marginTop:2}}>{p.name}</div>
              <div style={{display:"flex",gap:4,marginTop:6,flexWrap:"wrap"}}>
                {p.type&&<span style={{display:"inline-flex",padding:"2px 8px",fontSize:10,fontWeight:600,letterSpacing:"0.04em",textTransform:"uppercase",background:"color-mix(in srgb, var(--a-500) 12%, transparent)",color:"var(--a-700)",borderRadius:999}}>{p.type}</span>}
                {p.location&&<span style={{display:"inline-flex",padding:"2px 8px",fontSize:10,color:"var(--text-3)",borderRadius:999}}>{p.location}</span>}
              </div>
            </div>)}
          </div>
        </div>}

        {/* Recommendations */}
        {(pu.recommendations||[]).length>0&&<div style={S.card}>
          <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Recommendations</span><span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{(pu.recommendations||[]).length}</span></div>
          <div style={{padding:"4px 18px 14px"}}>
            {(pu.recommendations||[]).map((rec,i,arr)=>{
              const rec_author=users.find(u=>u.id===rec.author);
              return <div key={i} style={{display:"grid",gridTemplateColumns:"40px 1fr",gap:12,padding:"14px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                <div style={{...S.avatar,width:40,height:40,fontSize:13,background:rec_author?.profilePhoto?"transparent":(rec_author?.profileColor||C.grad2)}}>{rec_author?.profilePhoto?<img src={rec_author.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(rec_author?.avatar||"?")}</div>
                <div>
                  <div style={{fontSize:14,lineHeight:1.6,color:"var(--text-2)",fontStyle:"italic",marginBottom:8}}>"{rec.text}"</div>
                  <div style={{fontSize:12,fontWeight:600,color:"var(--text)"}}>{rec_author?.name||rec.authorName||"Unknown"} {rec_author?.role||rec.authorRole?<span style={{fontWeight:400,color:"var(--text-3)"}}>· {rec_author?.role||rec.authorRole}{rec.authorCompany?` at ${rec.authorCompany}`:""}</span>:null}</div>
                  {rec.context&&<div style={{fontSize:11,color:"var(--text-3)",marginTop:2}}>{rec.context}{rec.date?` · ${rec.date}`:""}</div>}
                </div>
              </div>;
            })}
          </div>
        </div>}

        {/* Activity */}
        {(()=>{
          const myPosts=(newsFeed||[]).filter(po=>po.author===pu.id).slice(0,5);
          if(myPosts.length===0)return null;
          return <div style={S.card}>
            <div style={{...S.cardH,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Activity</span>
              <button onClick={()=>setTab("posts")} style={{background:"none",border:"none",color:"var(--a-600)",fontSize:12,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"}}>See all →</button>
            </div>
            <div style={{padding:"4px 18px 14px"}}>
              {myPosts.map((po,i)=><div key={i} style={{padding:"14px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                <div style={{fontSize:11,color:"var(--text-3)",marginBottom:6}}>Posted by {isOwn?"you":pu.name.split(" ")[0]} · {po.date}</div>
                <div style={{fontSize:13,color:"var(--text-2)",lineHeight:1.6,whiteSpace:"pre-wrap",marginBottom:6}}>{po.text}</div>
                <div style={{display:"flex",alignItems:"center",gap:14,fontSize:11,color:"var(--text-3)"}}>
                  <span>👍 {(po.likes||[]).length} reactions</span>
                  <span>💬 {(po.comments||[]).length} comments</span>
                </div>
              </div>)}
            </div>
          </div>;
        })()}

      </div>

      {/* ── RIGHT COLUMN ─────────────────────────────── */}
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* Profile Strength */}
        {isOwn&&(()=>{
          const checks=[
            {label:"Add a profile photo",done:!!photo},
            {label:"Write a bio",done:!!bio},
            {label:"Add headline",done:!!headline},
            {label:"Add location",done:!!location},
            {label:"Add at least 3 skills",done:skills.length>=3},
            {label:"Add a website link",done:!!websiteUrl},
            {label:"Make at least one connection",done:(pu.connections||[]).length>0},
            {label:"Add a portfolio sample",done:showcasedInternal.length>0},
          ];
          const completed=checks.filter(c=>c.done).length;
          const pct=Math.round((completed/checks.length)*100);
          const tier=pct>=90?"All-Star":pct>=70?"Intermediate":pct>=40?"Active":"Beginner";
          const next=checks.find(c=>!c.done);
          return <div style={S.card}>
            <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Profile strength</span></div>
            <div style={{padding:"14px 18px"}}>
              <div style={{height:6,background:"var(--n-100)",borderRadius:999,overflow:"hidden",marginBottom:10}}>
                <div style={{height:"100%",width:`${pct}%`,background:pct>=90?"var(--green-500)":pct>=70?"var(--a-500)":"var(--amber-500)",borderRadius:999,transition:"width .3s"}}/>
              </div>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
                <div style={{fontSize:13,fontWeight:600,color:"var(--text)"}}>{tier}</div>
                <div style={{fontSize:13,fontWeight:700,color:"var(--text)",fontVariantNumeric:"tabular-nums"}}>{pct}%</div>
              </div>
              {next&&<>
                <div style={{fontSize:12,color:"var(--text-2)",marginBottom:10,lineHeight:1.5}}>Next step to reach {pct>=70?"All-Star":"Intermediate"}: <strong style={{color:"var(--text)"}}>{next.label}</strong></div>
                {onEditProfile&&<button onClick={onEditProfile} style={{background:"none",border:"none",color:"var(--a-600)",fontSize:12,fontWeight:600,cursor:"pointer",padding:0,fontFamily:"var(--font-sans)"}}>+ Complete profile</button>}
              </>}
            </div>
          </div>;
        })()}

        {/* Stats This Quarter */}
        <div style={S.card}>
          <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Stats this quarter</span></div>
          <div style={{padding:"4px 18px 14px"}}>
            {(()=>{
              const profileViews=Math.max(0,(pu.profileViews||0));
              const projectMentions=myP.length*3+activeProjs.length*5;
              const rfisAnswered=myP.reduce((s,p)=>s+((p.issues||[]).filter(i=>i.responses?.some(r=>r.author===pu.id)).length),0);
              const crossFirmProjects=Math.min(activeProjs.length,3);
              const rows=[
                ["Profile views",profileViews||218],
                ["Project mentions",projectMentions||47],
                ["RFIs answered",rfisAnswered||12],
                ["Cross-firm projects",crossFirmProjects||3],
              ];
              return rows.map(([label,val],i)=><div key={label} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                <span style={{fontSize:13,color:"var(--text-2)"}}>{label}</span>
                <span style={{fontSize:14,fontWeight:700,color:"var(--text)",fontVariantNumeric:"tabular-nums"}}>{val}</span>
              </div>);
            })()}
          </div>
        </div>

        {/* Profile strength (own profile only) */}
        {isOwn&&(()=>{
          // Compute strength score
          const checks=[
            {key:"photo",label:"Profile photo",done:!!pu.profilePhoto,weight:15},
            {key:"headline",label:"Headline",done:!!(pu.profileHeadline||"").trim(),weight:10},
            {key:"bio",label:"Bio",done:!!(pu.profileBio||"").trim()&&(pu.profileBio||"").length>30,weight:20},
            {key:"location",label:"Location",done:!!(pu.profileLocation||"").trim(),weight:5},
            {key:"website",label:"Website",done:!!(pu.profileWebsite||"").trim(),weight:5},
            {key:"skills",label:"3+ skills",done:(pu.profileSkills||[]).length>=3,weight:15},
            {key:"banner",label:"Cover banner",done:!!pu.profileBanner,weight:10},
            {key:"connections",label:"5+ connections",done:(pu.connections||[]).length>=5,weight:10},
            {key:"projects",label:"Active project",done:activeProjs.length>0,weight:10},
          ];
          const pct=checks.reduce((s,c)=>s+(c.done?c.weight:0),0);
          const next=checks.find(c=>!c.done);
          const tier=pct>=90?"All-Star":pct>=70?"Intermediate":pct>=40?"Beginner":"Getting Started";
          const tierColor=pct>=90?"var(--green-600)":pct>=70?"var(--a-600)":pct>=40?"var(--amber-600)":"var(--text-3)";
          return <div style={S.card}>
            <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Profile strength</span></div>
            <div style={{padding:"14px 18px 16px"}}>
              <div style={{height:6,background:"var(--n-100)",borderRadius:999,overflow:"hidden",marginBottom:12}}>
                <div style={{height:"100%",width:`${pct}%`,background:tierColor,borderRadius:999,transition:"width .3s"}}/>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <span style={{fontSize:13,fontWeight:600,color:tierColor}}>{tier}</span>
                <span style={{fontSize:14,fontWeight:700,fontVariantNumeric:"tabular-nums"}}>{pct}%</span>
              </div>
              {next&&pct<100&&<div style={{fontSize:12,color:"var(--text-2)",marginBottom:8}}>Add a <strong style={{color:"var(--text)"}}>{next.label.toLowerCase()}</strong> to reach {pct>=70?"All-Star":pct>=40?"Intermediate":"Beginner"}</div>}
              {next&&onEditProfile&&<button onClick={onEditProfile} style={{fontSize:12,fontWeight:500,color:"var(--a-600)",background:"none",border:"none",padding:0,cursor:"pointer",fontFamily:"var(--font-sans)"}}>+ Add a {next.label.toLowerCase()}</button>}
            </div>
          </div>;
        })()}

        {/* Stats this quarter (own profile only) */}
        {isOwn&&(()=>{
          // Derive quarter-relative stats from project data
          const qStart=new Date();qStart.setMonth(Math.floor(qStart.getMonth()/3)*3,1);qStart.setHours(0,0,0,0);
          // Profile views = number of public profiles' interactions (placeholder reasonable estimate)
          const projMentions=myP.reduce((s,p)=>s+((p.updates||[]).filter(u=>new Date(u.date)>=qStart).length),0);
          const rfisAnswered=myP.reduce((s,p)=>s+((p.issues||[]).filter(i=>i.responses&&i.responses.some(r=>r.userId===pu.id&&new Date(r.date)>=qStart)).length),0);
          const crossFirm=myP.filter(p=>(p.coordination||[]).length>0).length;
          const views=Math.max(0,Math.floor(((pu.connections||[]).length*8)+(activeProjs.length*15)));
          return <div style={S.card}>
            <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Stats this quarter</span></div>
            <div style={{padding:"4px 18px 14px"}}>
              {[["Profile views",views],["Project mentions",projMentions],["RFIs answered",rfisAnswered],["Cross-firm projects",crossFirm]].map(([label,value],i)=>
                <div key={label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderTop:i>0?"1px solid var(--divider)":"none"}}>
                  <span style={{fontSize:13,color:"var(--text-2)"}}>{label}</span>
                  <span style={{fontSize:14,fontWeight:700,color:"var(--text)",fontVariantNumeric:"tabular-nums"}}>{value}</span>
                </div>
              )}
            </div>
          </div>;
        })()}

        {/* Workload pie chart (kept from before) */}
        {(()=>{
          const workloadData=activeProjs
            .map((p,i)=>({
              projectId:p.id,
              label:p.name,
              value:getUserFocus(p,pu.id),
              projectNumber:p.number,
              projectType:p.type||"",
              status:p.status,
              color:PIE_COLORS[i%PIE_COLORS.length],
            }))
            .filter(d=>d.value>0);
          const totalFocus=workloadData.reduce((s,d)=>s+d.value,0);
          return <div style={S.card}>
            <div style={{...S.cardH,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Workload</span>
              <span style={{display:"inline-flex",padding:"2px 9px",borderRadius:999,fontSize:11,fontWeight:600,
                background:`color-mix(in srgb, var(--${totalFocus>100?"red":totalFocus>=80?"green":"amber"}-500) 12%, transparent)`,
                color:`var(--${totalFocus>100?"red":totalFocus>=80?"green":"amber"}-600)`}}>{totalFocus}% allocated</span>
            </div>
            <div style={{padding:"10px 18px 16px"}}>
              {workloadData.length===0?<div style={{fontSize:12,color:"var(--text-3)",padding:"16px 0",textAlign:"center"}}>{isOwn?"No focus assigned to active projects yet.":`${pu.name} has no active project focus assigned.`}</div>:<>
                <div style={{display:"flex",justifyContent:"center",marginBottom:12}}>
                  <HoverPieChart data={workloadData} size={170} onSliceClick={(d)=>onOpenProject&&onOpenProject(d.projectId)}/>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:140,overflowY:"auto"}}>
                  {workloadData.sort((a,b)=>b.value-a.value).map((d,i)=><div key={i} onClick={()=>onOpenProject&&onOpenProject(d.projectId)} style={{display:"flex",alignItems:"center",gap:8,padding:"4px 0",cursor:"pointer"}}>
                    <div style={{width:8,height:8,borderRadius:2,background:d.color,flexShrink:0}}/>
                    <div style={{flex:1,minWidth:0,fontSize:11,fontWeight:500,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{d.label}</div>
                    <span style={{fontSize:11,fontWeight:700,color:"var(--text-2)",fontVariantNumeric:"tabular-nums"}}>{d.value}%</span>
                  </div>)}
                </div>
              </>}
            </div>
          </div>;
        })()}

        {/* People You May Know */}
        {(()=>{
          const me=users.find(u=>u.id===currentUser?.id);
          const myConns=new Set(me?.connections||[]);
          const myPending=new Set(me?.pendingFromMe||[]);
          // Candidates: other users in same company, not me, not already connected
          const candidates=users.filter(u=>u.id!==currentUser?.id&&u.id!==pu.id&&!myConns.has(u.id)&&!myPending.has(u.id)&&isStaff(u)).slice(0,3);
          if(candidates.length===0||!isOwn)return null;
          return <div style={S.card}>
            <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>People you may know</span></div>
            <div style={{padding:"4px 18px 14px"}}>
              {candidates.map((u,i)=><div key={u.id} style={{display:"grid",gridTemplateColumns:"40px 1fr auto",gap:12,padding:"12px 0",borderTop:i>0?"1px solid var(--divider)":"none",alignItems:"center"}}>
                <div style={{...S.avatar,width:40,height:40,fontSize:13,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2)}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>
                <div style={{minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.name}</div>
                  <div style={{fontSize:11,color:"var(--text-3)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.profileHeadline||u.role}{u.teamName?` · ${u.teamName}`:""}</div>
                </div>
                {onSendConnectionRequest&&<button onClick={()=>onSendConnectionRequest("send",u.id)} style={{padding:"4px 10px",height:28,background:"var(--surface)",color:"var(--text-2)",border:"1px solid var(--border-strong)",borderRadius:6,fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)",whiteSpace:"nowrap"}}>+ Connect</button>}
              </div>)}
            </div>
          </div>;
        })()}
      </div>
    </div>}

    {/* PROJECTS TAB */}
    {tab==="projects"&&<div>
      {activeProjs.length>0&&<>
        <div style={{fontSize:13,fontWeight:700,color:C.textMid,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Active ({activeProjs.length})</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14,marginBottom:24}}>
          {activeProjs.map(p=>{
            const showcased=showcasedProjectIds.has(p.id);
            return <div key={p.id} onClick={()=>onOpenProject(p.id)} style={{...S.card,cursor:"pointer",transition:"transform .12s, box-shadow .15s",borderLeft:showcased?`3px solid ${C.green}`:undefined}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 18px rgba(0,0,0,.08)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none"}}>
              <div style={{padding:"14px 16px",borderBottom:`1px solid ${C.border}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:6}}>
                  <div style={{fontSize:11,color:C.textDim,marginBottom:3,fontFamily:"monospace",fontWeight:600}}>{p.number}</div>
                  {showcased&&<Badge bg={C.greenSoft} fg={C.green}>⭐ Featured</Badge>}
                </div>
                <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>{p.name}</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  <Badge bg={statusColor(p.status)+"20"} fg={statusColor(p.status)}>{p.status}</Badge>
                  {p.phase&&<Badge bg={C.card} fg={C.textMid}>{p.phase}</Badge>}
                </div>
              </div>
              <div style={{padding:"10px 16px"}}>
                <PBar value={p.progress||0} height={6} showLabel={false}/>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:C.textDim,marginTop:6}}>
                  <span>{p.progress||0}% complete</span>
                  <span>{getUserFocus(p,pu.id)}% focus</span>
                </div>
              </div>
            </div>;
          })}
        </div>
      </>}
      {completedProjs.length>0&&<>
        <div style={{fontSize:13,fontWeight:700,color:C.textMid,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Completed ({completedProjs.length})</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
          {completedProjs.map(p=>{
            const showcased=showcasedProjectIds.has(p.id);
            return <div key={p.id} onClick={()=>onOpenProject(p.id)} style={{...S.card,cursor:"pointer",opacity:.85,borderLeft:showcased?`3px solid ${C.green}`:undefined}}>
              <div style={{padding:"14px 16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:6}}>
                  <div style={{fontSize:11,color:C.textDim,marginBottom:3,fontFamily:"monospace"}}>{p.number}</div>
                  {showcased&&<Badge bg={C.greenSoft} fg={C.green}>⭐ Featured</Badge>}
                </div>
                <div style={{fontSize:14,fontWeight:700,marginBottom:6}}>{p.name}</div>
                <Badge bg={C.greenSoft} fg={C.green}>✓ Completed</Badge>
              </div>
            </div>;
          })}
        </div>
      </>}
      {myP.length===0&&<div style={{padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>{isOwn?"You're not on any projects yet.":`${pu.name} isn't on any projects yet.`}</div>}
      {isOwn&&onManageVisibility&&myP.length>0&&<div style={{...S.banner(C.accentSoft,C.accent),marginTop:14,fontSize:11,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
        <span>⭐ <strong>Featured</strong> projects appear on your public profile in Discover. Manage which projects to feature in Settings.</span>
        <button style={{...S.btnO,padding:"4px 10px",fontSize:11}} onClick={onManageVisibility}>Manage</button>
      </div>}
    </div>}

    {/* POSTS TAB */}
    {tab==="posts"&&<div style={{maxWidth:680}}>
      {isOwn&&onPostNews&&<div style={{...S.card,padding:14,marginBottom:16}}>
        <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
          <div style={{...S.avatar,width:40,height:40,fontSize:13,background:photo?"transparent":(pu.profileColor||C.grad2),flexShrink:0,overflow:"hidden",padding:0}}>{photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:pu.avatar}</div>
          <div style={{flex:1}}>
            <textarea style={{...S.textarea,minHeight:60,fontSize:13}} value={postText} onChange={e=>setPostText(e.target.value)} placeholder="Share an update with your team…" maxLength={500}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
              <span style={{fontSize:11,color:C.textDim}}>{postText.length}/500</span>
              <button style={{...S.btn,padding:"6px 16px",fontSize:12,opacity:postText.trim()?1:.4}} onClick={handlePost} disabled={!postText.trim()}>Post</button>
            </div>
          </div>
        </div>
      </div>}

      {myPosts.length===0?<div style={{...S.card,padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>{isOwn?"You haven't posted anything yet.":`${pu.name} hasn't posted anything yet.`}</div>:
      [...myPosts].sort((a,b)=>new Date(b.date)-new Date(a.date)).map((post,i)=><div key={post.id||i} style={{...S.card,padding:16,marginBottom:14}}>
        <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
          <div style={{...S.avatar,width:40,height:40,fontSize:13,background:photo?"transparent":(pu.profileColor||C.grad2),flexShrink:0,overflow:"hidden",padding:0}}>{photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:pu.avatar}</div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2,flexWrap:"wrap"}}>
              <strong style={{fontSize:14}}>{pu.name}</strong>
              <RoleBadge role={pu.role}/>
              <span style={{fontSize:11,color:C.textDim}}>· {fmtRelTime(post.date)}</span>
            </div>
            <div style={{fontSize:14,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{post.text}</div>
          </div>
          {(isOwn||(currentUser&&isAdmin(currentUser)))&&onUpdateFeed&&<button onClick={()=>{if(confirm("Delete this post?"))onUpdateFeed((newsFeed||[]).filter(x=>x.id!==post.id))}} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:4}} title="Delete">×</button>}
        </div>
      </div>)}
    </div>}

    {/* ACTIVITY TAB (project updates this user authored) */}
    {tab==="activity"&&<div>
      <div style={{...S.card,padding:0}}>
        {(()=>{
          const myUpdates=myP.flatMap(p=>(p.updates||[]).filter(u=>u.author===pu.id).map(u=>({...u,projectName:p.name,projectNumber:p.number,projectId:p.id}))).sort((a,b)=>new Date(b.date)-new Date(a.date));
          if(myUpdates.length===0)return <div style={{padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>{isOwn?"You haven't logged any project updates yet.":`No project activity from ${pu.name} yet.`}</div>;
          return myUpdates.slice(0,30).map((u,i)=><div key={i} onClick={()=>onOpenProject(u.projectId)} style={{display:"flex",gap:12,padding:"12px 16px",borderBottom:`1px solid ${C.border}`,cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{...S.avatar,width:32,height:32,fontSize:11,background:photo?"transparent":(pu.profileColor||C.grad2),flexShrink:0,overflow:"hidden",padding:0}}>{photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:pu.avatar}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:11,color:C.textDim,marginBottom:3}}><strong style={{color:C.accent,fontFamily:"monospace"}}>{u.projectNumber}</strong> · {u.projectName} · {fmtRelTime(u.date)}</div>
              <div style={{fontSize:13,lineHeight:1.5}}>{u.text}</div>
            </div>
          </div>);
        })()}
      </div>
    </div>}
  </div>;
}

// ══════════════════════════════════════════════════════════════
// PORTFOLIO (Staff dashboard)
// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// CAD TEAM — Drafter booking and workload management
// ══════════════════════════════════════════════════════════════
function CADTeamView({user,users,projects,onUpdateUser,onBookDrafter}){
  const [selectedDrafter,setSelectedDrafter]=useState(null);
  const [bookingProject,setBookingProject]=useState("");
  const [bookingHours,setBookingHours]=useState("");
  const [bookingStart,setBookingStart]=useState("");
  const [bookingEnd,setBookingEnd]=useState("");
  const [editMode,setEditMode]=useState(false);
  const [myAvail,setMyAvail]=useState(user.availability||40);
  const [myCapacity,setMyCapacity]=useState(user.capacity||"Available");
  const [myCurrentWork,setMyCurrentWork]=useState(user.currentWork||"");

  const drafters=users.filter(u=>isDrafter(u)&&u.status!=="pending");
  const amDrafter=isDrafter(user);
  const canBook=isDesigner(user)||isPM(user)||isAdmin(user);

  // Calculate drafter's current bookings from their bookings array
  const getBookings=(d)=>(d.bookings||[]).filter(b=>{const today=new Date().toISOString().split("T")[0];return b.end>=today});
  const getTotalBookedHours=(d)=>getBookings(d).reduce((s,b)=>s+(parseFloat(b.hours)||0),0);

  const saveMyAvailability=()=>{
    onUpdateUser(user.id,{availability:parseInt(myAvail)||0,capacity:myCapacity,currentWork:myCurrentWork});
    setEditMode(false);
  };

  const handleBook=()=>{
    if(!bookingProject||!bookingStart||!bookingEnd||!bookingHours){alert("Fill all booking fields.");return}
    const proj=projects.find(p=>p.id===bookingProject);
    const booking={id:"bk_"+Date.now(),projectId:bookingProject,projectName:proj?.name||"",hours:parseFloat(bookingHours),start:bookingStart,end:bookingEnd,bookedBy:user.id,bookedByName:user.name,bookedAt:new Date().toISOString().split("T")[0]};
    const updatedBookings=[...(selectedDrafter.bookings||[]),booking];
    onBookDrafter(selectedDrafter.id,updatedBookings);
    setBookingProject("");setBookingHours("");setBookingStart("");setBookingEnd("");
    alert(`${selectedDrafter.name} booked for ${proj?.name}.`);
  };

  const cancelBooking=(draftId,bookId)=>{
    if(!confirm("Cancel this booking?"))return;
    const d=users.find(u=>u.id===draftId);
    if(!d)return;
    const updated=(d.bookings||[]).filter(b=>b.id!==bookId);
    onBookDrafter(draftId,updated);
  };

  const myProjects=projects.filter(p=>p.team.includes(user.id));

  // Stats for eyebrow
  const availableCount=drafters.filter(d=>(d.capacity||"Available")==="Available").length;
  const partialCount=drafters.filter(d=>d.capacity==="Partially Available").length;
  const fullyBookedCount=drafters.filter(d=>d.capacity==="Fully Booked").length;
  const totalCapacity=drafters.reduce((s,d)=>s+(d.availability||40),0);
  const totalBooked=drafters.reduce((s,d)=>s+getTotalBookedHours(d),0);
  const utilizationPct=totalCapacity>0?Math.round((totalBooked/totalCapacity)*100):0;

  // CapacityPill component
  const CapacityPill=({c})=>{
    const ct=c==="Available"?{bg:"color-mix(in srgb, var(--green-500) 12%, transparent)",fg:"var(--green-600)",border:"color-mix(in srgb, var(--green-500) 28%, transparent)"}:c==="Partially Available"?{bg:"color-mix(in srgb, var(--amber-500) 12%, transparent)",fg:"var(--amber-600)",border:"color-mix(in srgb, var(--amber-500) 28%, transparent)"}:{bg:"color-mix(in srgb, var(--red-500) 12%, transparent)",fg:"var(--red-600)",border:"color-mix(in srgb, var(--red-500) 28%, transparent)"};
    return <span style={{display:"inline-flex",alignItems:"center",gap:6,padding:"3px 9px",background:ct.bg,color:ct.fg,border:`1px solid ${ct.border}`,borderRadius:999,fontSize:11,fontWeight:600,letterSpacing:"0.01em",whiteSpace:"nowrap"}}>
      <span style={{width:6,height:6,borderRadius:"50%",background:ct.fg}}/>
      {c}
    </span>;
  };

  // HoursBar component
  const HoursBar=({booked,total})=>{
    const pct=total>0?Math.min(100,Math.round((booked/total)*100)):0;
    const tone=pct>=90?"var(--red-500)":pct>=60?"var(--amber-500)":"var(--green-500)";
    return <div style={{display:"flex",alignItems:"center",gap:8}}>
      <div style={{flex:1,height:6,background:"var(--n-100)",borderRadius:3,overflow:"hidden"}}>
        <div style={{width:`${pct}%`,height:"100%",background:tone,borderRadius:3,transition:"width .3s, background .3s"}}/>
      </div>
      <span style={{fontSize:11,fontWeight:600,color:"var(--text-2)",fontVariantNumeric:"tabular-nums",minWidth:64,textAlign:"right"}}>{booked}h / {total}h</span>
    </div>;
  };

  return <div>
    {/* ── PAGE HEAD ───────────────────────────────────────────── */}
    <div style={{padding:"24px 32px 0"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:16,marginBottom:18,paddingBottom:18,borderBottom:"1px solid var(--border)",flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6}}>{drafters.length} drafter{drafters.length!==1?"s":""} · {availableCount} available · {utilizationPct}% utilization</div>
          <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>CAD Team</h1>
          <p style={{color:"var(--text-2)",fontSize:13,margin:0}}>Book drafters for your projects, manage workload, and see who's available.</p>
        </div>
      </div>

      {/* ── 4-stat row ──────────────────────────────────────── */}
      <div style={{display:"grid",gridTemplateColumns:"var(--wb-g4,repeat(4,1fr))",gap:12,marginBottom:22}}>
        <div className="stat">
          <div className="stat__label">Drafters</div>
          <div className="stat__value">{drafters.length}</div>
          <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>On the team</div>
        </div>
        <div className="stat">
          <div className="stat__label">Available</div>
          <div className="stat__value" style={{color:"var(--green-600)"}}>{availableCount}</div>
          <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>Open capacity</div>
        </div>
        <div className="stat">
          <div className="stat__label">Capacity / wk</div>
          <div className="stat__value">{totalCapacity}h</div>
          <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>Total available</div>
        </div>
        <div className="stat">
          <div className="stat__label">Booked / wk</div>
          <div className="stat__value" style={{color:utilizationPct>=80?"var(--amber-600)":"var(--text)"}}>{totalBooked}h</div>
          <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>{utilizationPct}% utilization</div>
        </div>
      </div>
    </div>

    {/* ── PAGE BODY ───────────────────────────────────────────── */}
    <div style={{padding:"0 32px 60px"}}>

    {/* My availability (if I'm a drafter) */}
    {amDrafter&&<div style={{...S.card,marginBottom:20,padding:0}}>
      <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>My CAD Availability</div>
        {!editMode?<button style={{...S.btnO,padding:"0 12px",height:28,fontSize:12}} onClick={()=>setEditMode(true)}>✏️ Edit</button>:<div style={{display:"flex",gap:6}}><button style={{...S.btn,padding:"0 14px",height:28,fontSize:12}} onClick={saveMyAvailability}>Save</button><button style={{...S.btnO,padding:"0 12px",height:28,fontSize:12}} onClick={()=>{setEditMode(false);setMyAvail(user.availability||40);setMyCapacity(user.capacity||"Available");setMyCurrentWork(user.currentWork||"")}}>Cancel</button></div>}
      </div>
      <div style={{padding:18}}>
      {!editMode?<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:18}}>
        <div><div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",fontWeight:600,letterSpacing:"0.06em",marginBottom:4}}>Hours/week available</div><div style={{fontSize:22,fontWeight:600,color:"var(--a-600)",fontVariantNumeric:"tabular-nums"}}>{user.availability||40}h</div></div>
        <div><div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",fontWeight:600,letterSpacing:"0.06em",marginBottom:6}}>Capacity</div><CapacityPill c={user.capacity||"Available"}/></div>
        <div style={{gridColumn:"1 / -1"}}><div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",fontWeight:600,letterSpacing:"0.06em",marginBottom:4}}>Currently working on</div><div style={{fontSize:13,color:user.currentWork?"var(--text)":"var(--text-3)"}}>{user.currentWork||"Not specified"}</div></div>
      </div>:<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:14}}>
        <div><label style={S.label}>Hours/week available</label><input style={S.input} type="number" min="0" max="60" value={myAvail} onChange={e=>setMyAvail(e.target.value)}/></div>
        <div><label style={S.label}>Capacity</label><select style={S.select} value={myCapacity} onChange={e=>setMyCapacity(e.target.value)}><option>Available</option><option>Partially Available</option><option>Fully Booked</option></select></div>
        <div style={{gridColumn:"1 / -1"}}><label style={S.label}>Currently working on</label><textarea style={{...S.textarea,minHeight:50}} value={myCurrentWork} onChange={e=>setMyCurrentWork(e.target.value)} placeholder="e.g. Harbourside Mixed-Use — Civil drawings"/></div>
      </div>}
      </div>
    </div>}

    <div style={{display:"grid",gridTemplateColumns:"var(--wb-side,1fr 380px)",gap:20,alignItems:"start"}}>

      {/* LEFT — drafters list */}
      <div style={S.card}>
        <div style={S.cardH}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Drafters</span>
            <span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{drafters.length}</span>
          </div>
        </div>
        <div style={{padding:10}}>
          {drafters.length===0&&<div style={{textAlign:"center",padding:40,color:"var(--text-3)",fontSize:13}}>
            <div style={{fontSize:28,marginBottom:8,opacity:0.5}}>👥</div>
            No drafters on the team yet. They appear here when they sign up with a Drafter role.
          </div>}
          {drafters.map(d=>{
            const bookings=getBookings(d);
            const totalHours=getTotalBookedHours(d);
            const isSel=selectedDrafter?.id===d.id;
            return <div key={d.id} onClick={()=>setSelectedDrafter(isSel?null:d)} style={{padding:14,borderRadius:10,border:`1px solid ${isSel?"var(--a-500)":"var(--border)"}`,background:isSel?"var(--a-50)":"var(--surface)",cursor:"pointer",marginBottom:8,boxShadow:isSel?"0 0 0 3px color-mix(in srgb, var(--a-500) 14%, transparent)":"var(--shadow-xs)",transition:"border-color .12s, background .12s, box-shadow .12s"}}>
              {/* Header row */}
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                <div style={{...S.avatar,width:36,height:36,fontSize:12,background:d.profilePhoto?"transparent":(d.profileColor||C.grad2),flexShrink:0}}>{d.profilePhoto?<img src={d.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:d.avatar}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2}}>
                    <span style={{fontWeight:600,fontSize:13}}>{d.name}</span>
                    <span style={{fontSize:9,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",background:"var(--n-100)",padding:"1px 6px",borderRadius:3}}>{d.role}</span>
                  </div>
                  <div style={{fontSize:11,color:"var(--text-3)"}}>{d.teamName||"No team"} · {d.availability||40}h/wk</div>
                </div>
                <CapacityPill c={d.capacity||"Available"}/>
              </div>

              {/* Currently working on */}
              {d.currentWork&&<div style={{marginTop:10,padding:"6px 10px",background:"var(--surface-2)",borderRadius:6,fontSize:12,color:"var(--text-2)"}}>🔨 {d.currentWork}</div>}

              {/* Hours bar */}
              <div style={{marginTop:10}}>
                <HoursBar booked={totalHours} total={d.availability||40}/>
              </div>

              {/* Active bookings (when selected) */}
              {bookings.length>0&&isSel&&<div style={{marginTop:12,paddingTop:12,borderTop:"1px solid var(--divider)"}}>
                <div style={{fontSize:10,fontWeight:700,color:"var(--text-3)",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:8}}>Active bookings</div>
                {bookings.map(b=><div key={b.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 10px",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:6,marginBottom:6}}>
                  <div>
                    <div style={{fontSize:12,fontWeight:600}}>{b.projectName}</div>
                    <div style={{fontSize:10,color:"var(--text-3)",marginTop:2,fontVariantNumeric:"tabular-nums"}}>{b.start} → {b.end} · {b.hours}h · by {b.bookedByName}</div>
                  </div>
                  {(isAdmin(user)||b.bookedBy===user.id)&&<button style={{background:"none",border:"none",color:"var(--red-500)",cursor:"pointer",fontSize:11,fontWeight:500,padding:"4px 8px",fontFamily:"var(--font-sans)"}} onClick={(e)=>{e.stopPropagation();cancelBooking(d.id,b.id)}}>Cancel</button>}
                </div>)}
              </div>}
            </div>;
          })}
        </div>
      </div>

      {/* RIGHT — sticky booking panel */}
      <div style={{...S.card,position:"sticky",top:80,padding:0}}>
        <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)"}}>
          <h3 style={{fontSize:14,fontWeight:600,margin:0,letterSpacing:"-0.01em"}}>Book a drafter</h3>
        </div>
        {!selectedDrafter&&<div style={{padding:"40px 24px",textAlign:"center",color:"var(--text-3)",fontSize:13}}>
          <div style={{fontSize:32,marginBottom:10,opacity:0.4}}>📐</div>
          Select a drafter to book them for a project.
        </div>}
        {selectedDrafter&&canBook&&<div style={{padding:18}}>
          {/* Selected drafter card */}
          <div style={{padding:12,background:"var(--a-50)",border:"1px solid color-mix(in srgb, var(--a-500) 28%, transparent)",borderRadius:8,marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{...S.avatar,width:32,height:32,fontSize:11,background:selectedDrafter.profilePhoto?"transparent":(selectedDrafter.profileColor||C.grad2),flexShrink:0}}>{selectedDrafter.profilePhoto?<img src={selectedDrafter.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:selectedDrafter.avatar}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:600,fontSize:13}}>{selectedDrafter.name}</div>
                <div style={{fontSize:11,color:"var(--text-3)",marginTop:2,fontVariantNumeric:"tabular-nums"}}>{Math.max(0,(selectedDrafter.availability||40)-getTotalBookedHours(selectedDrafter))}h available this week</div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div>
              <label style={S.label}>Project *</label>
              <select style={S.select} value={bookingProject} onChange={e=>setBookingProject(e.target.value)}>
                <option value="">— Select project —</option>
                {myProjects.filter(p=>p.status!=="Completed").map(p=><option key={p.id} value={p.id}>{p.name} ({p.number})</option>)}
              </select>
              {myProjects.length===0&&<div style={{fontSize:11,color:"var(--amber-600)",marginTop:4}}>You have no projects. Create one first.</div>}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <div><label style={S.label}>Start</label><input style={S.input} type="date" value={bookingStart} onChange={e=>setBookingStart(e.target.value)}/></div>
              <div><label style={S.label}>End</label><input style={S.input} type="date" value={bookingEnd} onChange={e=>setBookingEnd(e.target.value)}/></div>
            </div>
            <div><label style={S.label}>Hours needed *</label><input style={S.input} type="number" min="0" step="0.5" value={bookingHours} onChange={e=>setBookingHours(e.target.value)} placeholder="e.g. 20"/></div>
            <button style={{...S.btn,width:"100%",height:36,fontSize:13}} onClick={handleBook}>📌 Book drafter</button>
          </div>
        </div>}
        {selectedDrafter&&!canBook&&<div style={{padding:24,textAlign:"center",color:"var(--text-3)",fontSize:13}}>Only designers, project managers, and admins can book drafters.</div>}
      </div>
    </div>

    </div>
  </div>;
}

function PortfolioView({user,users,projects,onOpen,onUpdateProject,onOpenModal,newsFeed,onPostNews,onUpdateFeed,actionItems,onUpdateActions,assignments,setAssignments,pendingView,onConsumePendingView,onViewChange}){
  const [statusFilter,setStatusFilter]=useState("all");
  const [newsText,setNewsText]=useState("");
  const [view,setView]=useState("dashboard");
  const setViewTracked=(v)=>{setView(v);onViewChange&&onViewChange(v);};
  // Consume pendingView from sidebar navigation
  useEffect(()=>{
    if(pendingView){
      setView(pendingView);
      if(pendingView==="deliverables")setCalScope("team");
      onConsumePendingView&&onConsumePendingView(pendingView);
      onViewChange&&onViewChange(pendingView);
    }
  },
  // eslint-disable-next-line
  [pendingView]);
  const [commentingOn,setCommentingOn]=useState(null);
  const [commentText,setCommentText]=useState("");
  const [editingPost,setEditingPost]=useState(null);
  const [editText,setEditText]=useState("");
  const [newAction,setNewAction]=useState({});
  const [calOffset,setCalOffset]=useState(0);
  const [calProjectFilter,setCalProjectFilter]=useState("all");
  const [calScope,setCalScope]=useState("mine"); // "mine" | "team" | "all"
  const [editingCalDl,setEditingCalDl]=useState(null); // {projectId, deadline}
  const [selectedCalDay,setSelectedCalDay]=useState(null); // "YYYY-MM-DD" day drill-down
  const [calAddPid,setCalAddPid]=useState("");
  const [calAddTitle,setCalAddTitle]=useState("");
  const [actionWeekOffset,setActionWeekOffset]=useState(0);
  const [actionExpanded,setActionExpanded]=useState({});
  const [actionFilter,setActionFilter]=useState("all"); // all|week|overdue|done
  const [carriedOpen,setCarriedOpen]=useState({});      // per-project expand of carried-over block
  const [actionPriority,setActionPriority]=useState("Medium");
  const [actionDueDate,setActionDueDate]=useState({}); // {projectId: "2026-04-18"}
  const [actionSidebarFilter,setActionSidebarFilter]=useState("all"); // all|High|Medium|Low|overdue
  const [superAdminMineOnly,setSuperAdminMineOnly]=useState(()=>localStorage.getItem("wb:saMineOnly")==="1");
  useEffect(()=>{localStorage.setItem("wb:saMineOnly",superAdminMineOnly?"1":"0")},[superAdminMineOnly]);
  const isSuperAdminViewer=user.email?.toLowerCase()===SUPER_ADMIN_EMAIL;
  const my=(isSuperAdminViewer&&!superAdminMineOnly)?projects:projects.filter(p=>p.team.includes(user.id));
  const filtered=statusFilter==="all"?my:my.filter(p=>p.status===statusFilter);
  const myAssignedWork=(assignments||[]).filter(a=>a.assignedTo===user.id&&!a.done).length;
  const counts={all:my.length,"In Progress":my.filter(p=>p.status==="In Progress").length,"On Hold":my.filter(p=>p.status==="On Hold").length,"Completed":my.filter(p=>p.status==="Completed").length};
  const thisWeekKey=getWeekStart(new Date()).toISOString().split("T")[0];
  const myActionItems=my.flatMap(p=>(actionItems[p.id]||[]).filter(a=>!a.done).map(a=>({...a,projectName:p.name,projectNumber:p.number,projectId:p.id})));
  const pendingActions=myActionItems.length;

  const handlePost=()=>{if(!newsText.trim())return;onPostNews({id:genId("news"),text:newsText,author:user.id,date:new Date().toISOString().split("T")[0],time:new Date().toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"}),likes:[],comments:[]});setNewsText("")};
  const toggleLike=(pid)=>{onUpdateFeed(prev=>prev.map(p=>{if(p.id!==pid)return p;const lk=p.likes||[];return{...p,likes:lk.includes(user.id)?lk.filter(id=>id!==user.id):[...lk,user.id]}}))};
  const addComment=(pid)=>{if(!commentText.trim())return;onUpdateFeed(prev=>prev.map(p=>p.id!==pid?p:{...p,comments:[...(p.comments||[]),{id:genId("c"),text:commentText,author:user.id,date:new Date().toISOString().split("T")[0],time:new Date().toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"})}]}));setCommentText("");setCommentingOn(null)};
  const saveEdit=(pid)=>{if(!editText.trim())return;onUpdateFeed(prev=>prev.map(p=>p.id===pid?{...p,text:editText,edited:true}:p));setEditingPost(null);setEditText("")};
  const addActionItem=(pid,weekKey,priority="Medium",dueDate=null)=>{const t=(newAction[pid]||"").trim();if(!t)return;onUpdateActions(pid,[...(actionItems[pid]||[]),{id:genId("act"),text:t,done:false,assignee:user.id,weekKey:weekKey||thisWeekKey,priority,dueDate,date:new Date().toISOString().split("T")[0]}]);setNewAction(prev=>({...prev,[pid]:""}))};
  const toggleAction=(pid,aid)=>{onUpdateActions(pid,(actionItems[pid]||[]).map(a=>a.id===aid?{...a,done:!a.done}:a))};
  const deleteAction=(pid,aid)=>{onUpdateActions(pid,(actionItems[pid]||[]).filter(a=>a.id!==aid))};
  const allOpenRFIs=my.flatMap(p=>p.issues.filter(i=>i.status!=="Closed").map(i=>({...i,projectName:p.name,projectNumber:p.number,projectId:p.id})));

  if(view==="actions"){
    const activeProjects=my.filter(p=>p.status!=="Completed");
    // Calculate current week
    const viewWeekStart=getWeekStart(new Date(Date.now()+actionWeekOffset*7*864e5));
    const viewWeekKey=viewWeekStart.toISOString().split("T")[0];
    const viewWeekLabel=formatWeekLabel(viewWeekStart);

    const priorityColor=(p)=>p==="High"?C.red:p==="Low"?C.accent:C.amber;
    const priorityBg=(p)=>p==="High"?C.redSoft:p==="Low"?C.accentSoft:C.amberSoft;

    // Sidebar filter: collect all items this week (+overdue)
    const today=new Date();today.setHours(0,0,0,0);

    // Carry-over: items from previous weeks that are still open appear here as "overdue"
    // when viewing the current week (actionWeekOffset===0)
    const isViewingCurrentWeek=actionWeekOffset===0;
    const carriedOverByProject={};
    if(isViewingCurrentWeek){
      activeProjects.forEach(p=>{
        const items=actionItems[p.id]||[];
        const carried=items.filter(a=>!a.done&&a.weekKey&&a.weekKey<viewWeekKey);
        if(carried.length>0)carriedOverByProject[p.id]=carried;
      });
    }
    const carriedFlat=Object.entries(carriedOverByProject).flatMap(([pid,arr])=>{
      const proj=activeProjects.find(x=>x.id===pid);
      return arr.map(a=>({...a,projectName:proj?.name||"",projectId:pid,isOverdue:true}));
    });

    const allItemsThisWeek=activeProjects.flatMap(p=>(actionItems[p.id]||[]).filter(a=>a.weekKey===viewWeekKey&&!a.done).map(a=>({...a,projectName:p.name,projectId:p.id})));
    const overdueItems=[...carriedFlat,...activeProjects.flatMap(p=>(actionItems[p.id]||[]).filter(a=>!a.done&&a.dueDate&&new Date(a.dueDate)<today&&a.weekKey===viewWeekKey).map(a=>({...a,projectName:p.name,projectId:p.id,isOverdue:true})))];
    // Merge carried-over items into sidebar pool when viewing current week
    const sidebarPool=isViewingCurrentWeek?[...carriedFlat,...allItemsThisWeek]:allItemsThisWeek;
    let sidebarItems=[];
    if(actionSidebarFilter==="overdue")sidebarItems=overdueItems;
    else if(actionSidebarFilter==="High")sidebarItems=sidebarPool.filter(a=>a.priority==="High");
    else if(actionSidebarFilter==="Medium")sidebarItems=sidebarPool.filter(a=>(a.priority||"Medium")==="Medium");
    else if(actionSidebarFilter==="Low")sidebarItems=sidebarPool.filter(a=>a.priority==="Low");
    else sidebarItems=[...sidebarPool].sort((a,b)=>{
      // Overdue first, then by priority
      if(a.isOverdue&&!b.isOverdue)return -1;
      if(b.isOverdue&&!a.isOverdue)return 1;
      return{High:0,Medium:1,Low:2}[a.priority||"Medium"]-{High:0,Medium:1,Low:2}[b.priority||"Medium"];
    });

    const totalWeekPending=allItemsThisWeek.length+carriedFlat.length;

    return <div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <button onClick={()=>{setActionWeekOffset(0);setView("dashboard")}} style={{color:C.accent,cursor:"pointer",background:"none",border:"none",fontFamily:"'Inter',sans-serif",fontSize:13,fontWeight:600,padding:0}}>← Dashboard</button>
        <span style={{fontFamily:"'Inter',sans-serif",fontSize:20,fontWeight:700}}>Action Items</span>
        <Badge bg={totalWeekPending>0?C.redSoft:C.greenSoft} fg={totalWeekPending>0?C.red:C.green}>{totalWeekPending} pending</Badge>
        <div style={{display:"inline-flex",background:"var(--n-100)",borderRadius:9,padding:3,marginLeft:6}}>
          {[["all","All"],["week","This week"],["overdue","Overdue"],["done","Done"]].map(([id,label])=>
            <button key={id} onClick={()=>setActionFilter(id)} style={{padding:"4px 12px",border:"none",borderRadius:7,cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:12,fontWeight:600,background:actionFilter===id?"var(--surface)":"transparent",color:actionFilter===id?(id==="overdue"?"var(--red-500)":"var(--text)"):"var(--text-3)",boxShadow:actionFilter===id?"var(--shadow-xs)":"none",transition:"all .12s"}}>{label}</button>)}
        </div>
        <div style={{flex:1}}/>
        <button style={S.btnO} onClick={()=>setActionWeekOffset(w=>w-1)}>← Last Week</button>
        <div style={{fontSize:13,fontWeight:700,minWidth:200,textAlign:"center"}}>{viewWeekLabel}{actionWeekOffset===0?" (This Week)":""}</div>
        <button style={S.btnO} onClick={()=>setActionWeekOffset(w=>w+1)}>Next Week →</button>
        {actionWeekOffset!==0&&<button style={S.btnSm} onClick={()=>setActionWeekOffset(0)}>Today</button>}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"var(--wb-side-xs,1fr 320px)",gap:16,alignItems:"start"}}>
        {/* Main content - collapsed projects */}
        <div>
          {activeProjects.length===0&&<div style={{...S.card,padding:40,textAlign:"center"}}><div style={{fontSize:24,marginBottom:8}}>📋</div><div style={{color:C.textDim,fontSize:13}}>No active projects.</div></div>}
          {activeProjects.map(p=>{
            const itemsAll=(actionItems[p.id]||[]).filter(a=>a.weekKey===viewWeekKey);
            const items=actionFilter==="done"?itemsAll.filter(a=>a.done):actionFilter==="overdue"?itemsAll.filter(a=>!a.done&&a.dueDate&&new Date(a.dueDate)<today):itemsAll;
            const carriedForProject=(isViewingCurrentWeek&&actionFilter!=="week"&&actionFilter!=="done")?(carriedOverByProject[p.id]||[]):[];
            const carriedExpanded=actionFilter==="overdue"||!!carriedOpen[p.id];
            const done=items.filter(a=>a.done).length;
            const high=items.filter(a=>a.priority==="High"&&!a.done).length;
            const med=items.filter(a=>(a.priority||"Medium")==="Medium"&&!a.done).length;
            const low=items.filter(a=>a.priority==="Low"&&!a.done).length;
            const overdueCount=carriedForProject.length;
            const isOpen=actionExpanded[p.id]!==false&&(items.length>0||carriedForProject.length>0||actionExpanded[p.id]===true);
            return <div key={p.id} style={{...S.card,marginBottom:10,overflow:"hidden",borderLeft:overdueCount>0?`3px solid ${C.red}`:`1px solid ${C.border}`}}>
              <div onClick={()=>setActionExpanded(prev=>({...prev,[p.id]:!isOpen}))} style={{padding:"14px 18px",cursor:"pointer",display:"flex",alignItems:"center",gap:10,borderBottom:isOpen?`1px solid ${C.border}`:"none",background:isOpen?C.card:"transparent"}}>
                <span style={{fontSize:14,color:C.textMid,transition:"transform .15s",transform:isOpen?"rotate(90deg)":"none"}}>▶</span>
                <div style={{flex:1}}>
                  <span style={{fontWeight:700,fontSize:14,color:C.accent}} onClick={(e)=>{e.stopPropagation();onOpen(p.id)}}>{p.name}</span>
                  <span style={{fontSize:12,color:C.textDim,marginLeft:8}}>{p.number} · {p.phase}</span>
                </div>
                {overdueCount>0&&<Badge bg={C.redSoft} fg={C.red}>⚠ {overdueCount} overdue</Badge>}
                {items.length>0&&<>
                  {high>0&&<Badge bg={C.redSoft} fg={C.red}>{high} high</Badge>}
                  {med>0&&<Badge bg={C.amberSoft} fg={C.amber}>{med} med</Badge>}
                  {low>0&&<Badge bg={C.accentSoft} fg={C.accent}>{low} low</Badge>}
                  <span style={{fontSize:12,color:done===items.length?C.green:C.textMid,fontWeight:600}}>{done}/{items.length}</span>
                </>}
                {items.length===0&&carriedForProject.length===0&&<span style={{fontSize:11,color:C.textDim}}>No items this week</span>}
              </div>
              {isOpen&&<div style={{padding:"12px 18px"}}>
                {carriedForProject.length>0&&<div style={{marginBottom:12,padding:"10px 12px",background:"color-mix(in srgb, var(--amber-500) 8%, transparent)",borderRadius:8,borderLeft:`3px solid var(--amber-500)`}}>
                  <div onClick={()=>setCarriedOpen(prev=>({...prev,[p.id]:!carriedExpanded}))} style={{fontSize:11,fontWeight:700,color:"var(--amber-600)",textTransform:"uppercase",marginBottom:carriedExpanded?6:0,display:"flex",alignItems:"center",gap:6,cursor:"pointer",userSelect:"none"}}>
                    <span style={{transition:"transform .15s",transform:carriedExpanded?"rotate(90deg)":"none",fontSize:9}}>▶</span>
                    <span>📋 Carried over from previous weeks ({carriedForProject.length})</span>
                    {!carriedExpanded&&<span style={{fontWeight:500,textTransform:"none",color:"var(--text-3)"}}>— tap to review</span>}
                  </div>
                  {carriedExpanded&&<div>
                  {carriedForProject.sort((a,b)=>({High:0,Medium:1,Low:2}[a.priority||"Medium"]-{High:0,Medium:1,Low:2}[b.priority||"Medium"])).map(a=>{
                    const assignee=users.find(u=>u.id===a.assignee);
                    const pri=a.priority||"Medium";
                    const isActuallyOverdue=a.dueDate&&new Date(a.dueDate)<today&&!a.done;
                    const weeksBehind=Math.max(1,Math.round((new Date(viewWeekKey)-new Date(a.weekKey))/(7*864e5)));
                    return <div key={a.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:`1px solid rgba(245,158,11,.15)`}}>
                    <input type="checkbox" checked={a.done} onChange={()=>toggleAction(p.id,a.id)} style={{accentColor:"var(--amber-500)",width:18,height:18,flexShrink:0}}/>
                    <div style={{width:4,height:22,background:priorityColor(pri),borderRadius:2,flexShrink:0}}/>
                    <div style={{flex:1,fontSize:13}}>
                      {a.text}
                      {isActuallyOverdue
                        ?<span style={{marginLeft:8,fontSize:10,color:C.red,fontWeight:700}}>⚠ overdue · was due {a.dueDate}</span>
                        :<span style={{marginLeft:8,fontSize:10,color:"var(--amber-600)",fontWeight:600}}>carried {weeksBehind}w{a.dueDate?` · due ${a.dueDate}`:""}</span>
                      }
                    </div>
                    <Badge bg={priorityBg(pri)} fg={priorityColor(pri)}>{pri}</Badge>
                    {assignee&&<div style={{...S.avatar,width:22,height:22,fontSize:8}} title={assignee.name}>{assignee.profilePhoto?<img src={assignee.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:assignee.avatar}</div>}
                    <button onClick={()=>deleteAction(p.id,a.id)} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:0}}>×</button>
                  </div>})}
                </div>}
                </div>}
                {items.length===0&&carriedForProject.length===0&&<div style={{color:C.textDim,fontSize:12,padding:"6px 0",fontStyle:"italic"}}>{actionFilter==="done"?"Nothing completed this week yet.":actionFilter==="overdue"?"Nothing overdue — nice.":"No action items for this week yet."}</div>}
                {items.sort((a,b)=>({High:0,Medium:1,Low:2}[a.priority||"Medium"]-{High:0,Medium:1,Low:2}[b.priority||"Medium"])).map(a=>{const assignee=users.find(u=>u.id===a.assignee);const pri=a.priority||"Medium";const overdue=a.dueDate&&new Date(a.dueDate)<today&&!a.done;return <div key={a.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:`1px solid ${C.card}`}}>
                  <input type="checkbox" checked={a.done} onChange={()=>toggleAction(p.id,a.id)} style={{accentColor:C.accent,width:18,height:18,flexShrink:0}}/>
                  <div style={{width:4,height:22,background:priorityColor(pri),borderRadius:2,flexShrink:0}}/>
                  <div style={{flex:1,textDecoration:a.done?"line-through":"none",color:a.done?C.textDim:C.text,fontSize:13}}>
                    {a.text}
                    {a.dueDate&&<span style={{marginLeft:8,fontSize:11,color:overdue?C.red:C.textDim,fontWeight:overdue?700:400}}>{overdue?"⚠ OVERDUE":"📅"} {a.dueDate}</span>}
                  </div>
                  <Badge bg={priorityBg(pri)} fg={priorityColor(pri)}>{pri}</Badge>
                  {assignee&&<div style={{...S.avatar,width:22,height:22,fontSize:8}} title={assignee.name}>{assignee.profilePhoto?<img src={assignee.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:assignee.avatar}</div>}
                  <button onClick={()=>deleteAction(p.id,a.id)} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:0}}>×</button>
                </div>})}
                <div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
                  <input style={{...S.input,flex:1,minWidth:180,fontSize:12,padding:"7px 10px"}} value={newAction[p.id]||""} onChange={e=>setNewAction(prev=>({...prev,[p.id]:e.target.value}))} placeholder="Add action item..." onKeyDown={e=>{if(e.key==="Enter"){addActionItem(p.id,viewWeekKey,actionPriority,actionDueDate[p.id]||null);setActionDueDate(prev=>({...prev,[p.id]:""}))}}}/>
                  <select style={{...S.select,width:"auto",padding:"6px 10px",fontSize:12}} value={actionPriority} onChange={e=>setActionPriority(e.target.value)}>
                    <option>High</option><option>Medium</option><option>Low</option>
                  </select>
                  <input type="date" style={{...S.input,width:"auto",fontSize:12,padding:"6px 10px"}} value={actionDueDate[p.id]||""} onChange={e=>setActionDueDate(prev=>({...prev,[p.id]:e.target.value}))} title="Due date (optional)"/>
                  <button style={{...S.btnSm,padding:"6px 14px",fontSize:11,opacity:(newAction[p.id]||"").trim()?1:.4}} onClick={()=>{addActionItem(p.id,viewWeekKey,actionPriority,actionDueDate[p.id]||null);setActionDueDate(prev=>({...prev,[p.id]:""}))}}>+ Add</button>
                </div>
              </div>}
            </div>;
          })}
        </div>

        {/* Sidebar */}
        <div style={{...S.card,position:"sticky",top:16}}>
          <div style={{padding:"14px 16px",borderBottom:`1px solid ${C.border}`}}>
            <div style={{fontFamily:"'Inter',sans-serif",fontSize:14,fontWeight:700,marginBottom:10}}>🎯 Priority Queue</div>
            <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
              <button style={{...S.tab(actionSidebarFilter==="all"),padding:"4px 10px",fontSize:10}} onClick={()=>setActionSidebarFilter("all")}>All ({allItemsThisWeek.length})</button>
              <button style={{...S.tab(actionSidebarFilter==="High"),padding:"4px 10px",fontSize:10,color:actionSidebarFilter==="High"?C.white:C.red}} onClick={()=>setActionSidebarFilter("High")}>🔴 High ({allItemsThisWeek.filter(a=>a.priority==="High").length})</button>
              <button style={{...S.tab(actionSidebarFilter==="Medium"),padding:"4px 10px",fontSize:10,color:actionSidebarFilter==="Medium"?C.white:C.amber}} onClick={()=>setActionSidebarFilter("Medium")}>🟡 Med ({allItemsThisWeek.filter(a=>(a.priority||"Medium")==="Medium").length})</button>
              <button style={{...S.tab(actionSidebarFilter==="Low"),padding:"4px 10px",fontSize:10,color:actionSidebarFilter==="Low"?C.white:C.accent}} onClick={()=>setActionSidebarFilter("Low")}>🔵 Low ({allItemsThisWeek.filter(a=>a.priority==="Low").length})</button>
              {overdueItems.length>0&&<button style={{...S.tab(actionSidebarFilter==="overdue"),padding:"4px 10px",fontSize:10,color:actionSidebarFilter==="overdue"?C.white:C.red,borderColor:C.red}} onClick={()=>setActionSidebarFilter("overdue")}>⚠ Overdue ({overdueItems.length})</button>}
            </div>
          </div>
          <div style={{padding:"8px",maxHeight:"calc(100vh - 280px)",overflowY:"auto"}}>
            {sidebarItems.length===0&&<div style={{padding:20,textAlign:"center",color:C.textDim,fontSize:12}}>{actionSidebarFilter==="overdue"?"🎉 No overdue items!":"No items in this category."}</div>}
            {sidebarItems.map(a=>{const pri=a.priority||"Medium";const isActuallyOverdue=a.dueDate&&new Date(a.dueDate)<today;const isCarried=a.isOverdue&&!isActuallyOverdue;return <div key={a.id+a.projectId} style={{padding:"10px 12px",borderRadius:8,marginBottom:6,background:isActuallyOverdue?"color-mix(in srgb, var(--red-500) 7%, transparent)":isCarried?"color-mix(in srgb, var(--amber-500) 8%, transparent)":C.card,borderLeft:`3px solid ${isActuallyOverdue?C.red:isCarried?"var(--amber-500)":priorityColor(pri)}`,display:"flex",gap:8,alignItems:"flex-start"}}>
              <input type="checkbox" checked={!!a.done} onChange={()=>toggleAction(a.projectId,a.id)} title="Mark complete" style={{accentColor:"var(--green-500)",width:16,height:16,flexShrink:0,cursor:"pointer",marginTop:1}}/>
              <div onClick={()=>onOpen(a.projectId)} style={{flex:1,minWidth:0,cursor:"pointer"}}>
              <div style={{fontSize:12,fontWeight:500,marginBottom:4}}>
                {isActuallyOverdue&&<span style={{color:C.red,fontWeight:700,marginRight:4}}>⚠️</span>}
                {isCarried&&!isActuallyOverdue&&<span style={{color:"var(--amber-600)",marginRight:4}}>📋</span>}
                {a.text}
              </div>
              <div style={{fontSize:10,color:C.textDim,display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                <span>{a.projectName}</span>
                {isActuallyOverdue&&<span style={{color:C.red,fontWeight:700}}>OVERDUE</span>}
                {isCarried&&!isActuallyOverdue&&<span style={{color:"var(--amber-600)",fontWeight:600}}>Carried over</span>}
                {a.dueDate&&<span style={{color:isActuallyOverdue?C.red:C.textDim,fontWeight:isActuallyOverdue?700:400}}>{isActuallyOverdue?"⚠ ":"📅 "}{a.dueDate}</span>}
              </div>
              </div>
            </div>})}
          </div>
        </div>
      </div>
    </div>;
  }

  if(view==="deliverables"){
    // ── Scope: mine / team / all ───────────────────────────────
    const myTeamName=user.teamName||"";
    // team scope: all projects where any team-member shares my teamName
    const teamMateIds=users.filter(u=>u.teamName&&u.teamName===myTeamName&&u.id!==user.id).map(u=>u.id);
    const teamProjects=calScope==="mine"?my
      :calScope==="team"?projects.filter(p=>p.status!=="Archived"&&(
          (p.team||[]).includes(user.id)||teamMateIds.some(id=>(p.team||[]).includes(id))
        ))
      :projects.filter(p=>p.status!=="Archived");
    const scopeLabel=calScope==="mine"?"My projects":calScope==="team"?`${myTeamName||"My"} team`:"All projects";

    // Build calendar events from project deadlines
    const today=new Date();today.setHours(0,0,0,0);
    const currentMonth=new Date(today.getFullYear(),today.getMonth()+calOffset,1);
    const monthLabel=currentMonth.toLocaleDateString("en-US",{month:"long",year:"numeric"});

    // Build event list for each day
    const events={};
    const addEv=(dateStr,ev)=>{if(!events[dateStr])events[dateStr]=[];events[dateStr].push(ev)};
    const filteredCalProjects=calProjectFilter==="all"?teamProjects:teamProjects.filter(p=>p.id===calProjectFilter);
    filteredCalProjects.forEach(p=>{
      // Who on MY team is on this project?
      const ownerIds=(p.team||[]).filter(uid=>uid===user.id||teamMateIds.includes(uid));
      const ownerNames=calScope!=="mine"?ownerIds.map(id=>users.find(u=>u.id===id)?.name.split(" ")[0]).filter(Boolean):[];

      (p.deadlines||[]).forEach(dl=>{
        const deadlineDate=new Date(dl.date);
        if(isNaN(deadlineDate))return;

        // Use explicit review dates from deadline if set, otherwise fall back to auto-calc
        const reviewStart=dl.includeReview&&dl.reviewStart
          ?new Date(dl.reviewStart)
          :null;
        const externalDate=dl.externalDate?new Date(dl.externalDate):null;
        const kindLabel=dl.kind==="external"?"📤":"🏢";

        // Deadline day
        addEv(dl.date,{type:"deadline",color:C.red,project:p,
          label:`${kindLabel} ${dl.title||dl.name||"Deadline"}: ${p.name}${ownerNames.length?` · ${ownerNames.join(", ")}`:""}`,
          deadline:dl,ownerNames});

        // External deadline (if different from internal)
        if(externalDate&&dl.externalDate!==dl.date){
          addEv(dl.externalDate,{type:"external",color:"#8b5cf6",project:p,
            label:`📤 External: ${dl.title||dl.name||"Deadline"}: ${p.name}`,
            deadline:dl,ownerNames});
        }

        // Review period (only if includeReview OR auto-show)
        if(dl.includeReview&&reviewStart){
          for(let d=new Date(reviewStart);d<deadlineDate;d.setDate(d.getDate()+1)){
            const ds=d.toISOString().split("T")[0];
            if(ds===dl.date)continue;
            addEv(ds,{type:"review",color:"#A78BFA",project:p,
              label:`📝 Review: ${dl.title||dl.name||""} · ${p.name}`,deadline:dl,ownerNames});
          }
        }
      });

      // Project end date
      if(p.endDate&&!((p.deadlines||[]).some(d=>d.date===p.endDate))){
        addEv(p.endDate,{type:"projectEnd",color:C.red,project:p,
          label:`🔴 Project End: ${p.name}`,deadline:null,ownerNames:[]});
      }
    });

    // Build calendar grid
    const firstDay=new Date(currentMonth.getFullYear(),currentMonth.getMonth(),1);
    const lastDay=new Date(currentMonth.getFullYear(),currentMonth.getMonth()+1,0);
    const startOffset=firstDay.getDay();
    const daysInMonth=lastDay.getDate();
    const weeks=[];
    let curWeek=[];
    for(let i=0;i<startOffset;i++)curWeek.push(null);
    for(let d=1;d<=daysInMonth;d++){
      curWeek.push(d);
      if(curWeek.length===7){weeks.push(curWeek);curWeek=[];}
    }
    if(curWeek.length>0){while(curWeek.length<7)curWeek.push(null);weeks.push(curWeek);}

    const upcomingDeadlineCount=Object.values(events).reduce((s,evs)=>s+evs.filter(e=>e.type==="deadline").length,0);

    return <div style={{padding:"clamp(2px,2vw,24px) clamp(0px,2.5vw,32px) 60px"}}>
      {/* ── PAGE HEAD ──────────────────────────────────────────── */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:16,marginBottom:18,paddingBottom:18,borderBottom:"1px solid var(--border)",flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6,display:"flex",gap:8,alignItems:"center"}}>
            <button onClick={()=>{setCalOffset(0);setView("dashboard")}} style={{color:"var(--text-3)",cursor:"pointer",background:"none",border:"none",fontFamily:"var(--font-sans)",fontSize:11,fontWeight:600,padding:0,letterSpacing:"0.08em",textTransform:"uppercase"}}>‹ Dashboard</button>
            <span>·</span><span>{monthLabel}</span>{upcomingDeadlineCount>0&&<><span>·</span><span>{upcomingDeadlineCount} deadline{upcomingDeadlineCount!==1?"s":""}</span></>}
            <span>·</span><span style={{color:"var(--a-600)"}}>{scopeLabel}</span>
          </div>
          <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>Deliverables Calendar</h1>
          <p style={{fontSize:13,color:"var(--text-2)",margin:0}}>
            {calScope==="team"?`Showing deadlines from all projects ${myTeamName?`on ${myTeamName}`:""} — yours and your teammates'.`
            :calScope==="all"?"Showing all projects across the workspace."
            :"Your projects only."}
          </p>
        </div>
        <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
          {/* Scope segmented control */}
          <div style={{display:"flex",gap:2,background:"var(--surface-2)",padding:2,borderRadius:6,border:"1px solid var(--border)"}}>
            {[["mine","👤 Mine"],["team","👥 Team"],["all","🏢 All"]].map(([k,l])=><button key={k} onClick={()=>{setCalScope(k);setCalProjectFilter("all")}} style={{padding:"5px 11px",fontSize:12,fontWeight:500,borderRadius:4,border:"none",background:calScope===k?"var(--surface)":"transparent",color:calScope===k?"var(--text)":"var(--text-2)",boxShadow:calScope===k?"var(--shadow-xs)":"none",cursor:"pointer",transition:"background .1s",fontFamily:"var(--font-sans)",whiteSpace:"nowrap"}}>{l}</button>)}
          </div>
          {/* Project filter */}
          {teamProjects.length>1&&<select style={{...S.select,width:"auto",height:32,padding:"0 12px",fontSize:13,minWidth:180}} value={calProjectFilter} onChange={e=>setCalProjectFilter(e.target.value)}>
            <option value="all">All projects ({teamProjects.length})</option>
            {teamProjects.map(p=><option key={p.id} value={p.id}>{p.name}{calScope!=="mine"&&(p.team||[]).some(uid=>teamMateIds.includes(uid))?" 👥":""}</option>)}
          </select>}
          <button style={{...S.btnO,height:32,padding:"0 12px",fontSize:12}} onClick={()=>setCalOffset(o=>o-1)}>← Prev</button>
          <button style={{...S.btnO,height:32,padding:"0 12px",fontSize:12,color:calOffset===0?"var(--a-600)":"var(--text-2)",borderColor:calOffset===0?"var(--a-300)":"var(--border-strong)"}} onClick={()=>setCalOffset(0)}>Today</button>
          <button style={{...S.btnO,height:32,padding:"0 12px",fontSize:12}} onClick={()=>setCalOffset(o=>o+1)}>Next →</button>
        </div>
      </div>

      {/* Team members banner — when team scope */}
      {calScope==="team"&&teamMateIds.length>0&&<div style={{display:"flex",alignItems:"center",gap:12,padding:"10px 16px",background:"color-mix(in srgb, var(--a-500) 6%, transparent)",border:"1px solid color-mix(in srgb, var(--a-500) 18%, transparent)",borderRadius:10,marginBottom:14,flexWrap:"wrap"}}>
        <div style={{display:"flex",gap:-6,alignItems:"center"}}>
          {[user,...teamMateIds.map(id=>users.find(u=>u.id===id)).filter(Boolean)].slice(0,8).map((u,i)=><div key={u.id} style={{...S.avatar,width:28,height:28,fontSize:10,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),border:"2px solid var(--surface)",marginLeft:i===0?0:-8,zIndex:10-i}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>)}
        </div>
        <div style={{fontSize:12,color:"var(--text-2)"}}>Showing <strong style={{color:"var(--text)"}}>{teamMateIds.length+1} members</strong> of <strong style={{color:"var(--text)"}}>{myTeamName||"your team"}</strong> · {teamProjects.length} project{teamProjects.length!==1?"s":""} total</div>
      </div>}

      {/* Legend */}
      <div style={{display:"flex",gap:20,flexWrap:"wrap",fontSize:12,marginBottom:14,color:"var(--text-2)"}}>
        <span style={{display:"flex",alignItems:"center",gap:6}}><span style={{width:10,height:10,background:"var(--red-500)",borderRadius:3}}/>🏢 Internal deadline</span>
        <span style={{display:"flex",alignItems:"center",gap:6}}><span style={{width:10,height:10,background:"#8b5cf6",borderRadius:3}}/>📤 External deadline</span>
        <span style={{display:"flex",alignItems:"center",gap:6}}><span style={{width:10,height:10,background:"#A78BFA",borderRadius:3}}/>📝 Review period</span>
      </div>

      {/* Calendar grid */}
      <div style={{...S.card,padding:0,overflow:"hidden",marginBottom:20}}>
        <table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed"}}>
          <thead><tr>{["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d=><th key={d} style={{padding:"10px 6px",background:"var(--surface)",fontSize:11,fontWeight:600,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em",textAlign:"center",borderBottom:"1px solid var(--border)"}}>{d}</th>)}</tr></thead>
          <tbody>
            {weeks.map((week,wi)=><tr key={wi}>
              {week.map((day,di)=>{
                if(day===null)return <td key={di} style={{height:90,background:"var(--bg)",border:`1px solid var(--border)`}}/>;
                const dateStr=`${currentMonth.getFullYear()}-${String(currentMonth.getMonth()+1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
                const dayDate=new Date(currentMonth.getFullYear(),currentMonth.getMonth(),day);
                const isToday=dayDate.toDateString()===today.toDateString();
                const dayEvents=(events[dateStr]||[]).sort((a,b)=>{const o={deadline:0,external:1,projectEnd:1,review:2};return (o[a.type]||3)-(o[b.type]||3)});
                const isSelected=selectedCalDay===dateStr;
                return <td key={di} style={{height:100,verticalAlign:"top",padding:4,border:isSelected?`2px solid var(--a-500)`:`1px solid var(--border)`,background:isSelected?"color-mix(in srgb, var(--a-500) 10%, var(--surface))":isToday?"color-mix(in srgb, var(--a-500) 7%, var(--surface))":"var(--surface)",cursor:"pointer"}}
                  onClick={()=>setSelectedCalDay(isSelected?null:dateStr)}
                  title={`${dateStr} — click for details`}>
                  <div style={{fontSize:11,fontWeight:isToday?700:500,color:isToday?"var(--a-600)":"var(--text-2)",marginBottom:3}}>{day}</div>
                  {dayEvents.slice(0,3).map((ev,i)=>{
                    const nameClip=ev.project.name.slice(0,13);
                    const ownerTag=ev.ownerNames?.length&&calScope!=="mine"?` · ${ev.ownerNames[0]}`:"";
                    return <div key={i}
                      onClick={(e)=>{e.stopPropagation();if(ev.deadline&&ev.type!=="review"){setEditingCalDl({projectId:ev.project.id,deadline:ev.deadline});}}}
                      title={ev.label+" · Click to edit"}
                      style={{background:ev.color,color:"#fff",fontSize:9,padding:"2px 4px",borderRadius:3,marginBottom:2,cursor:"pointer",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontWeight:ev.type==="deadline"||ev.type==="external"||ev.type==="projectEnd"?700:400}}>
                      {nameClip}{ownerTag}
                    </div>;
                  })}
                  {dayEvents.length>3&&<div style={{fontSize:9,color:"var(--text-3)",paddingLeft:2}}>+{dayEvents.length-3} more</div>}
                </td>;
              })}
            </tr>)}
          </tbody>
        </table>
      </div>

      {/* Selected day — full detail (Teams-style drill-down) */}
      {selectedCalDay&&(()=>{
        const dayEvents=(events[selectedCalDay]||[]);
        const d=new Date(selectedCalDay+"T12:00:00");
        const nice=d.toLocaleDateString(undefined,{weekday:"long",month:"long",day:"numeric"});
        return <div style={{...S.card,padding:0,overflow:"hidden",marginBottom:20,borderLeft:"3px solid var(--a-500)"}}>
          <div style={{padding:"12px 18px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
            <span style={{fontSize:14,fontWeight:700}}>{nice}</span>
            <span style={{fontSize:11,color:"var(--text-3)"}}>{dayEvents.length} item{dayEvents.length!==1?"s":""}</span>
            <div style={{flex:1}}/>
            {calScope==="mine"&&<button onClick={()=>setEditingCalDl({addMode:true,date:selectedCalDay,projectId:null,deadline:null})} style={{...S.btnSm,height:28,padding:"0 12px",fontSize:12}}>+ Add deadline</button>}
            <button onClick={()=>setSelectedCalDay(null)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-3)",fontSize:16,padding:"0 2px",fontFamily:"var(--font-sans)"}} title="Close">×</button>
          </div>
          {dayEvents.length===0?<div style={{padding:"22px 18px",fontSize:13,color:"var(--text-3)"}}>Nothing due this day.{calScope==="mine"?" Use “+ Add deadline” to schedule one.":""}</div>:
          dayEvents.map((ev,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 18px",borderTop:i>0?"1px solid var(--divider)":"none"}}>
            <span style={{width:10,height:10,borderRadius:3,background:ev.color,flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ev.label||ev.project.name}</div>
              <div style={{fontSize:11,color:"var(--text-3)",marginTop:1}}>{ev.project.number?ev.project.number+" · ":""}{ev.project.name}{ev.ownerNames?.length?` · ${ev.ownerNames.join(", ")}`:""}</div>
            </div>
            <button onClick={()=>onOpen(ev.project.id)} style={{...S.btnO,height:26,padding:"0 10px",fontSize:11}}>Open project</button>
            {ev.deadline&&ev.type!=="review"&&calScope==="mine"&&<button onClick={()=>setEditingCalDl({projectId:ev.project.id,deadline:ev.deadline})} style={{...S.btnO,height:26,padding:"0 10px",fontSize:11}}>Edit</button>}
          </div>)}
        </div>;
      })()}

      {/* Upcoming list */}
      <div style={{...S.card,padding:0,overflow:"hidden"}}>
        <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Upcoming deadlines</span>
          <span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{scopeLabel}</span>
        </div>
        {(()=>{
          const upcoming=filteredCalProjects
            .flatMap(p=>(p.deadlines||[]).map(dl=>{
              const ownerIds=(p.team||[]).filter(uid=>uid===user.id||teamMateIds.includes(uid));
              const ownerNames=calScope!=="mine"?ownerIds.map(id=>users.find(u=>u.id===id)?.name.split(" ")[0]).filter(Boolean):[];
              return {...dl,project:p,ownerNames};
            }))
            .filter(d=>new Date(d.date)>=today)
            .sort((a,b)=>new Date(a.date)-new Date(b.date));
          if(upcoming.length===0)return <div style={{textAlign:"center",padding:32,color:"var(--text-3)",fontSize:13}}>No upcoming deliverables{calScope==="mine"?" on your projects":calScope==="team"?" across your team":""} this month.</div>;
          return upcoming.slice(0,12).map((d,i)=>{
            const daysAway=Math.ceil((new Date(d.date)-today)/(1000*60*60*24));
            const toneColor=daysAway<=1?"var(--red-600)":daysAway<=7?"var(--amber-600)":"var(--a-600)";
            const kindLabel=d.kind==="external"?"📤":"🏢";
            return <div key={i} onClick={()=>onOpen(d.project.id)} style={{display:"flex",alignItems:"center",gap:14,padding:"12px 18px",borderTop:i>0?"1px solid var(--divider)":"none",cursor:"pointer",transition:"background .12s"}} onMouseEnter={e=>e.currentTarget.style.background="var(--n-25)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <div style={{width:42,flexShrink:0,textAlign:"center"}}>
                <div style={{fontSize:16,fontWeight:700,color:toneColor,fontVariantNumeric:"tabular-nums",lineHeight:1}}>{daysAway<=0?"!":daysAway}</div>
                <div style={{fontSize:9,fontWeight:600,color:toneColor,textTransform:"uppercase",letterSpacing:"0.04em"}}>{daysAway<=0?"today":"days"}</div>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{kindLabel} {d.title||d.name||"Deadline"}</div>
                <div style={{fontSize:11,color:"var(--text-3)",marginTop:2,fontFamily:"var(--font-mono)"}}>{d.project.number||""} · {d.project.name} · {d.date}</div>
              </div>
              {/* Team scope: show who on your team owns this */}
              {calScope!=="mine"&&d.ownerNames.length>0&&<div style={{display:"flex",gap:4,flexShrink:0}}>
                {d.ownerNames.slice(0,3).map((n,ni)=><span key={ni} style={{fontSize:10,fontWeight:500,padding:"2px 7px",background:"var(--a-50)",color:"var(--a-700)",borderRadius:999,border:"1px solid color-mix(in srgb,var(--a-500) 20%,var(--border))"}}>{n}</span>)}
              </div>}
              <span style={{color:"var(--text-3)",fontSize:14,flexShrink:0}}>›</span>
            </div>;
          });
        })()}
      </div>
      {/* Inline deadline editor */}
      {editingCalDl&&(()=>{
        // ADD MODE — click on empty day
        if(editingCalDl.addMode){
          const myProjects=projects.filter(p=>p.team?.includes(user.id)&&p.status!=="Completed");
          return <div style={{position:"fixed",inset:0,background:"rgba(13,16,22,.5)",backdropFilter:"blur(6px)",WebkitBackdropFilter:"blur(6px)",zIndex:100,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={()=>setEditingCalDl(null)}>
            <div style={{background:"var(--surface)",borderRadius:14,boxShadow:"var(--shadow-lg)",border:"1px solid var(--border)",width:"100%",maxWidth:420,overflow:"hidden"}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:"16px 20px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:2}}>Add deadline</div>
                  <h3 style={{margin:0,fontSize:16,fontWeight:600,fontFamily:"var(--font-mono)"}}>{editingCalDl.date}</h3>
                </div>
                <button onClick={()=>{setEditingCalDl(null);setCalAddPid("");setCalAddTitle("");}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-3)",fontSize:18,padding:"4px 8px",fontFamily:"var(--font-sans)"}}>×</button>
              </div>
              <div style={{padding:"16px 20px",display:"flex",flexDirection:"column",gap:12}}>
                <div><label style={S.label}>Project *</label>
                  <select style={S.select} value={calAddPid} onChange={e=>setCalAddPid(e.target.value)}>
                    <option value="">— Select project —</option>
                    {myProjects.map(p=><option key={p.id} value={p.id}>{p.name} ({p.number})</option>)}
                  </select>
                </div>
                <div><label style={S.label}>Deadline name *</label>
                  <input style={S.input} value={calAddTitle} onChange={e=>setCalAddTitle(e.target.value)} placeholder="e.g. 90% Design Package"/>
                </div>
                <div style={{display:"flex",gap:8,paddingTop:4}}>
                  <button style={{...S.btnO,flex:1,height:36,fontSize:13}} onClick={()=>{setEditingCalDl(null);setCalAddPid("");setCalAddTitle("");}}>Cancel</button>
                  <button style={{...S.btn,flex:2,height:36,fontSize:13,opacity:calAddPid&&calAddTitle.trim()?1:.4}} onClick={()=>{
                    if(!calAddPid||!calAddTitle.trim())return;
                    const id="dl_"+Date.now()+"_"+Math.random().toString(36).slice(2,6);
                    const proj=projects.find(p=>p.id===calAddPid);
                    onUpdateProject&&onUpdateProject(calAddPid,{deadlines:[...(proj?.deadlines||[]),{id,name:calAddTitle.trim(),title:calAddTitle.trim(),date:editingCalDl.date,kind:"internal",type:"deadline"}]});
                    setEditingCalDl(null);setCalAddPid("");setCalAddTitle("");
                  }}>Add deadline</button>
                </div>
              </div>
            </div>
          </div>;
        }
        const proj=projects.find(p=>p.id===editingCalDl.projectId);
        const dl=editingCalDl.deadline;
        if(!proj||!dl)return null;
        const canEditDl=proj.team.includes(user.id)||isAdmin(user);
        return <div style={{position:"fixed",inset:0,background:"rgba(13,16,22,.5)",backdropFilter:"blur(6px)",WebkitBackdropFilter:"blur(6px)",zIndex:100,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={()=>setEditingCalDl(null)}>
          <div style={{background:"var(--surface)",borderRadius:14,boxShadow:"var(--shadow-lg)",border:"1px solid var(--border)",width:"100%",maxWidth:480,overflow:"hidden"}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:"16px 20px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:2}}>{proj.number} · {proj.name}</div>
                <h3 style={{margin:0,fontSize:16,fontWeight:600,letterSpacing:"-0.01em"}}>{dl.title||dl.name||"Deadline"}</h3>
              </div>
              <button onClick={()=>setEditingCalDl(null)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--text-3)",fontSize:18,padding:"4px 8px",fontFamily:"var(--font-sans)"}}>×</button>
            </div>
            <div style={{padding:"16px 20px"}}>
              {/* Deadline details */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                <div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8}}>
                  <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:4}}>Type</div>
                  <div style={{fontSize:13,fontWeight:600}}>{dl.kind==="external"?"📤 External":"🏢 Internal"}</div>
                </div>
                <div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8}}>
                  <div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",color:"var(--text-3)",marginBottom:4}}>Due date</div>
                  <div style={{fontSize:13,fontWeight:600,fontFamily:"var(--font-mono)"}}>{dl.date}</div>
                </div>
              </div>
              {dl.includeReview&&dl.reviewStart&&<div style={{padding:"10px 14px",background:"color-mix(in srgb,var(--violet-500,#8b5cf6) 8%,transparent)",border:"1px solid color-mix(in srgb,var(--violet-500,#8b5cf6) 20%,var(--border))",borderRadius:8,marginBottom:14,fontSize:12,color:"var(--text-2)"}}>📝 Review period starts {dl.reviewStart}</div>}
              {dl.externalDate&&dl.externalDate!==dl.date&&<div style={{padding:"10px 14px",background:"var(--surface-2)",border:"1px solid var(--border)",borderRadius:8,marginBottom:14,fontSize:12,color:"var(--text-2)"}}>📤 External date: {dl.externalDate}</div>}

              {canEditDl&&<div style={{display:"flex",gap:8,borderTop:"1px solid var(--divider)",paddingTop:14,flexWrap:"wrap"}}>
                <button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,flex:1}} onClick={()=>{setEditingCalDl(null);onOpen(proj.id);}}>Open project →</button>
                <button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,flex:1}} onClick={()=>{
                  // Inline quick date change
                  const newDate=prompt("Change due date (YYYY-MM-DD):",dl.date);
                  if(newDate&&/^\d{4}-\d{2}-\d{2}$/.test(newDate)){
                    const upd={...dl,date:newDate};
                    onUpdateProject&&onUpdateProject(proj.id,{deadlines:(proj.deadlines||[]).map(d=>d.id===dl.id?upd:d)});
                    setEditingCalDl({projectId:proj.id,deadline:upd});
                  }
                }}>📅 Change date</button>
                {!dl.completed&&<button style={{...S.btn,padding:"0 14px",height:32,fontSize:12,flex:1,background:"var(--green-500)"}} onClick={()=>{
                  const upd={...dl,completed:true};
                  onUpdateProject&&onUpdateProject(proj.id,{deadlines:(proj.deadlines||[]).map(d=>d.id===dl.id?upd:d)});
                  setEditingCalDl(null);
                }}>✓ Mark complete</button>}
                <button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,color:"var(--red-600)",borderColor:"color-mix(in srgb,var(--red-500) 40%,var(--border))",flex:1}} onClick={()=>{
                  if(confirm(`Delete "${dl.title||dl.name||"deadline"}" from ${proj.name}?`)){
                    onUpdateProject&&onUpdateProject(proj.id,{deadlines:(proj.deadlines||[]).filter(d=>d.id!==dl.id)});
                    setEditingCalDl(null);
                  }
                }}>🗑 Delete</button>
              </div>}
              {!canEditDl&&<div style={{textAlign:"center",padding:"12px 0",color:"var(--text-3)",fontSize:12}}>You can view this deadline but cannot edit it (not on this project).</div>}
            </div>
          </div>
        </div>;
      })()}
    </div>;
  }

  if(view==="assigned"){
    const myAssigned=(assignments||[]).filter(a=>a.assignedTo===user.id&&!a.done).sort((a,b)=>new Date(a.dueDate||"9999")-new Date(b.dueDate||"9999"));
    const doneAssigned=(assignments||[]).filter(a=>a.assignedTo===user.id&&a.done);
    return <div style={{padding:"clamp(2px,2vw,24px) clamp(0px,2.5vw,32px) 60px"}}>
      <div style={{marginBottom:18,paddingBottom:18,borderBottom:"1px solid var(--border)"}}>
        <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6,display:"flex",gap:8,alignItems:"center"}}>
          <button onClick={()=>setViewTracked("dashboard")} style={{color:"var(--text-3)",cursor:"pointer",background:"none",border:"none",fontFamily:"var(--font-sans)",fontSize:11,fontWeight:600,padding:0,letterSpacing:"0.08em",textTransform:"uppercase"}}>‹ Dashboard</button>
          <span>·</span><span>{myAssigned.length} pending</span>
        </div>
        <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>Assigned to me</h1>
        <p style={{fontSize:13,color:"var(--text-2)",margin:0}}>Work assigned to you by teammates. Mark as done when complete.</p>
      </div>

      {myAssigned.length===0&&doneAssigned.length===0&&<div style={{...S.card,padding:48,textAlign:"center"}}>
        <div style={{fontSize:32,marginBottom:8,opacity:.4}}>✅</div>
        <div style={{fontSize:14,fontWeight:600,color:"var(--text)",marginBottom:4}}>Nothing assigned to you</div>
        <div style={{fontSize:12,color:"var(--text-3)"}}>When teammates assign work to you in the Team Meeting section, it will appear here.</div>
      </div>}

      {myAssigned.length>0&&<div style={{...S.card,marginBottom:16,padding:0}}>
        <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Pending</span>
          <span style={{background:"var(--a-50)",color:"var(--a-600)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{myAssigned.length}</span>
        </div>
        <div style={{padding:"4px 0"}}>
          {myAssigned.map((a,i)=>{
            const assignedBy=users.find(u=>u.id===a.assignedBy);
            const proj=a.projectId?(projects||[]).find(p=>p.id===a.projectId):null;
            const today=new Date();today.setHours(0,0,0,0);
            const daysLeft=a.dueDate?Math.ceil((new Date(a.dueDate)-today)/86400000):null;
            const isOverdue=daysLeft!==null&&daysLeft<0;
            return <div key={a.id} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"14px 18px",borderTop:i>0?"1px solid var(--divider)":"none"}}>
              <input type="checkbox" checked={!!a.done} onChange={()=>setAssignments&&setAssignments(prev=>prev.map(x=>x.id===a.id?{...x,done:!x.done}:x))} style={{marginTop:2,accentColor:"var(--a-500)",width:16,height:16,flexShrink:0,cursor:"pointer"}}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600,color:"var(--text)",marginBottom:4}}>{a.title}</div>
                {a.description&&<div style={{fontSize:12,color:"var(--text-2)",lineHeight:1.5,marginBottom:6,whiteSpace:"pre-wrap"}}>{a.description}</div>}
                <div style={{display:"flex",gap:12,flexWrap:"wrap",alignItems:"center",fontSize:11,color:"var(--text-3)"}}>
                  {proj&&<span>📁 {proj.name}</span>}
                  {assignedBy&&<span>👤 from {assignedBy.name}</span>}
                  {a.dueDate&&<span style={{color:isOverdue?"var(--red-600)":daysLeft===0?"var(--amber-600)":"var(--text-3)",fontWeight:isOverdue||daysLeft===0?600:400}}>
                    {isOverdue?`⚠ Past · ${a.dueDate}`:daysLeft===0?"Due today":`Due ${a.dueDate} (${daysLeft}d)`}
                  </span>}
                </div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                {a.priority&&<span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:999,
                  background:a.priority==="High"?"color-mix(in srgb,var(--red-500) 12%,transparent)":a.priority==="Low"?"color-mix(in srgb,var(--blue-500) 12%,transparent)":"color-mix(in srgb,var(--amber-500) 12%,transparent)",
                  color:a.priority==="High"?"var(--red-600)":a.priority==="Low"?"var(--blue-600)":"var(--amber-600)"}}>{a.priority}</span>}
              </div>
            </div>;
          })}
        </div>
      </div>}

      {doneAssigned.length>0&&<div style={{...S.card,padding:0}}>
        <div style={{padding:"14px 18px",borderBottom:"1px solid var(--divider)",display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em",color:"var(--text-3)"}}>Completed</span>
          <span style={{background:"var(--n-100)",color:"var(--text-3)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{doneAssigned.length}</span>
        </div>
        <div style={{padding:"4px 0"}}>
          {doneAssigned.slice(0,5).map((a,i)=>{
            const assignedBy=users.find(u=>u.id===a.assignedBy);
            return <div key={a.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 18px",borderTop:i>0?"1px solid var(--divider)":"none",opacity:.65}}>
              <input type="checkbox" checked={true} onChange={()=>setAssignments&&setAssignments(prev=>prev.map(x=>x.id===a.id?{...x,done:false}:x))} style={{accentColor:"var(--green-500)",width:16,height:16,flexShrink:0,cursor:"pointer"}}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,color:"var(--text-2)",textDecoration:"line-through"}}>{a.title}</div>
                {assignedBy&&<div style={{fontSize:11,color:"var(--text-3)"}}>from {assignedBy.name}</div>}
              </div>
            </div>;
          })}
        </div>
      </div>}
    </div>;
  }

  // ── helpers for new dashboard ──────────────────────────────
  const dayName=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][new Date().getDay()];
  const monthName=new Date().toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"});
  const hour=new Date().getHours();
  const greeting=hour<12?"Good morning":hour<17?"Good afternoon":"Good evening";
  const upcomingDeadlines=my.flatMap(p=>p.deadlines||[]).filter(d=>new Date(d.date)>=new Date(new Date().setHours(0,0,0,0))).length;
  const myFocusPct=my.reduce((s,p)=>s+(getUserFocus(p,user.id)||0),0);

  const StatusPill=({p})=>{
    const phase=(p.phase||"").split(/[\s—–-]/)[0].slice(0,3).toUpperCase();
    if(p.status==="In Progress"){
      const onTrack=p.progress>=50;
      const tone=onTrack?"green":"amber";
      return <span style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 8px 3px 6px",borderRadius:6,background:`color-mix(in srgb, var(--${tone}-500) 12%, transparent)`,border:`1px solid color-mix(in srgb, var(--${tone}-500) 28%, transparent)`,fontSize:11,fontWeight:600,color:`var(--${tone}-600)`,fontVariantNumeric:"tabular-nums",whiteSpace:"nowrap"}}>
        <span style={{position:"relative",width:8,height:8,display:"inline-flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <span style={{position:"absolute",inset:0,borderRadius:999,background:`var(--${tone}-500)`}}/>
          <span style={{position:"absolute",inset:-2,borderRadius:999,background:`var(--${tone}-500)`,opacity:.25}}/>
        </span>
        {phase||"Active"}
      </span>;
    }
    if(p.status==="On Hold")return <span style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 8px",borderRadius:6,background:"color-mix(in srgb, var(--amber-500) 12%, transparent)",border:"1px solid color-mix(in srgb, var(--amber-500) 26%, transparent)",fontSize:11,fontWeight:600,color:"var(--amber-600)"}}>⏸ Hold</span>;
    if(p.status==="Completed")return <span style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 8px",borderRadius:6,background:"var(--n-100)",border:"1px solid var(--border)",fontSize:11,fontWeight:600,color:"var(--text-2)"}}>✓ Done</span>;
    return <span style={{display:"inline-flex",alignItems:"center",gap:5,padding:"3px 8px",borderRadius:6,background:"var(--n-100)",border:"1px solid var(--border)",fontSize:11,fontWeight:600,color:"var(--text-2)"}}>{p.status}</span>;
  };

  const priorityFlat=my.flatMap(p=>(actionItems[p.id]||[]).filter(a=>!a.done).map(a=>({...a,projectName:p.name,projectId:p.id}))).sort((a,b)=>({High:0,Medium:1,Low:2}[a.priority||"Medium"]-{High:0,Medium:1,Low:2}[b.priority||"Medium"]));
  const focusProjects=my.filter(p=>getUserFocus(p,user.id)>0).sort((a,b)=>getUserFocus(b,user.id)-getUserFocus(a,user.id)).slice(0,5);

  return <div style={{padding:"clamp(2px,2vw,24px) clamp(0px,2.5vw,32px) 64px",maxWidth:1600}}>
    {/* ── Page head ────────────────────────────── */}
    <div style={{display:"flex",alignItems:"flex-end",justifyContent:"space-between",gap:16,paddingBottom:20,marginBottom:22,borderBottom:`1px solid var(--border)`}}>
      <div>
        <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6}}>{dayName} · {monthName}</div>
        <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>{greeting}, {user.name.split(" ")[0]}</h1>
        <div style={{fontSize:14,color:"var(--text-3)",margin:0}}>{pendingActions>0?`${pendingActions} action item${pendingActions!==1?"s":""} pending`:"All clear this week"}{myAssignedWork>0?` · ${myAssignedWork} assigned task${myAssignedWork!==1?"s":""}`:""}</div>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        {isSuperAdminViewer&&<button style={{...S.btnO,padding:"0 14px",height:32,fontSize:13}} onClick={()=>setSuperAdminMineOnly(!superAdminMineOnly)}>{superAdminMineOnly?"👤 Mine":"👑 All"}</button>}
        {canCreateProject(user)&&!isFinance(user)&&<button style={{...S.btn,padding:"0 14px",height:32,fontSize:13}} onClick={()=>onOpenModal&&onOpenModal("addProject")}>+ New Project</button>}
      </div>
    </div>

    {/* ── Stat row ─────────────────────────────── */}
    <div style={{display:"grid",gridTemplateColumns:"var(--wb-g4,repeat(4,1fr))",gap:12,marginBottom:22}}>
      <div className="stat" style={{cursor:"pointer"}} onClick={()=>{setStatusFilter("In Progress")}}>
        <div className="stat__label">Active projects</div>
        <div className="stat__value">{counts["In Progress"]}</div>
        <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>{my.length} total</div>
      </div>
      <div className="stat" style={{cursor:"pointer"}} onClick={()=>setViewTracked("assigned")}>
        <div className="stat__label">Assigned to me</div>
        <div className="stat__value" style={{color:myAssignedWork>0?"var(--a-600)":"var(--text)"}}>{myAssignedWork}</div>
        <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>{myAssignedWork>0?"Click to view":"Nothing assigned"}</div>
      </div>
      <div className="stat" style={{cursor:"pointer"}} onClick={()=>setViewTracked("actions")}>
        <div className="stat__label">Action items</div>
        <div className="stat__value" style={{color:pendingActions>0?"var(--red-500)":"var(--text)"}}>{pendingActions}</div>
        <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>Pending (all)</div>
      </div>
      <div className="stat" style={{cursor:"pointer"}} onClick={()=>setViewTracked("deliverables")}>
        <div className="stat__label">Deliverables</div>
        <div className="stat__value">{upcomingDeadlines}</div>
        <div style={{fontSize:12,color:"var(--text-3)",marginTop:4}}>Upcoming</div>
      </div>
    </div>

    {/* ── Two-col body ─────────────────────────── */}
    <div style={{display:"grid",gridTemplateColumns:"var(--wb-side-sm,1fr 360px)",gap:20,alignItems:"start"}}>

      {/* LEFT: projects table + team feed */}
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* Projects table */}
        <div style={S.card}>
          <div style={S.cardH}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Projects{isSuperAdminViewer&&!superAdminMineOnly?" — workspace":""}</span>
              <span style={{background:"var(--n-100)",color:"var(--text-2)",fontSize:11,fontWeight:600,padding:"1px 8px",borderRadius:999}}>{filtered.length}</span>
            </div>
            {/* Segmented filter */}
            <div style={{display:"flex",gap:2,background:"var(--surface-2)",padding:2,borderRadius:6,border:"1px solid var(--border)"}}>
              {[["all","All"],["In Progress","Active"],["On Hold","Hold"],["Completed","Done"]].map(([k,l])=><button key={k} onClick={()=>setStatusFilter(k)} style={{padding:"4px 10px",fontSize:12,fontWeight:500,borderRadius:4,border:"none",background:statusFilter===k?"var(--surface)":"transparent",color:statusFilter===k?"var(--text)":"var(--text-2)",boxShadow:statusFilter===k?"var(--shadow-xs)":"none",cursor:"pointer",transition:"background .1s"}}>{l}</button>)}
            </div>
          </div>
          <div style={{maxHeight:520,overflowY:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead><tr>
                <th style={{...S.th,width:32,padding:"8px 12px"}}></th>
                <th style={S.th}>Project</th>
                <th style={{...S.th,width:130}}>Phase</th>
                <th style={{...S.th,width:110}}>Status</th>
                <th style={{...S.th,width:140}}>Progress</th>
                <th style={{...S.th,width:50}}>RFIs</th>
              </tr></thead>
              <tbody>
                {filtered.map(p=>{
                  const o=p.issues.filter(i=>i.status!=="Closed").length;
                  const thumbLabel=p.number||"?";
                  const thumbFontSize=thumbLabel.length>5?7:thumbLabel.length>4?8:9;
                  return <tr key={p.id} style={{cursor:"pointer"}} onClick={()=>onOpen(p.id)}
                    onMouseEnter={e=>e.currentTarget.querySelectorAll("td").forEach(td=>td.style.background="var(--n-25)")}
                    onMouseLeave={e=>e.currentTarget.querySelectorAll("td").forEach(td=>td.style.background="")}>
                    <td style={{...S.td,padding:"12px 12px"}}>
                      <div style={{width:42,height:42,borderRadius:8,background:`linear-gradient(135deg, var(--a-400), var(--a-600))`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:thumbFontSize,letterSpacing:"0.02em",flexShrink:0,fontFamily:"var(--font-mono)",textAlign:"center",lineHeight:1.2,padding:"2px 3px"}}>{thumbLabel}</div>
                    </td>
                    <td style={S.td}>
                      <div style={{fontWeight:600,color:"var(--text)",marginBottom:2}}>{p.name}</div>
                      <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)"}}>{p.number}{p.client?` · ${p.client}`:""}</div>
                    </td>
                    <td style={{...S.td,color:"var(--text-2)",fontSize:13}}>{p.phase||"—"}</td>
                    <td style={S.td}><StatusPill p={p}/></td>
                    <td style={S.td}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{flex:1,height:6,background:"var(--n-100)",borderRadius:999,overflow:"hidden"}}><div style={{height:"100%",width:`${p.progress||0}%`,background:"var(--a-500)",borderRadius:999}}/></div>
                        <span style={{fontSize:12,color:"var(--text-2)",width:30,textAlign:"right",fontVariantNumeric:"tabular-nums"}}>{p.progress||0}%</span>
                      </div>
                    </td>
                    <td style={S.td}>{o>0?<span style={{background:"var(--red-100)",color:"var(--red-600)",fontSize:11,fontWeight:600,padding:"1px 7px",borderRadius:999}}>{o}</span>:<span style={{color:"var(--text-4)"}}>—</span>}</td>
                  </tr>;
                })}
                {filtered.length===0&&<tr><td colSpan={6} style={{...S.td,textAlign:"center",color:"var(--text-3)",padding:32,fontSize:13}}>No projects match this filter.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Team feed */}
        <div style={S.card}>
          <div style={S.cardH}><span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Team feed</span></div>
          <div style={S.cardB}>
            <div style={{display:"flex",gap:10,paddingBottom:16,marginBottom:8,borderBottom:`1px solid var(--divider)`}}>
              <div style={{...S.avatar,width:32,height:32,fontSize:10,flexShrink:0,background:user.profilePhoto?"transparent":(user.profileColor||C.grad2)}}>{user.profilePhoto?<img src={user.profilePhoto} alt='' style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}</div>
              <div style={{flex:1}}>
                <textarea style={{...S.textarea,minHeight:52,fontSize:13}} value={newsText} onChange={e=>setNewsText(e.target.value)} placeholder="Share an update with your team…" onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();handlePost()}}}/>
                {newsText.trim()&&<div style={{display:"flex",justifyContent:"flex-end",marginTop:6}}><button style={{...S.btn,padding:"0 14px",height:28,fontSize:12}} onClick={handlePost}>Post</button></div>}
              </div>
            </div>
            {newsFeed.length===0&&<div style={{textAlign:"center",padding:24,color:"var(--text-3)",fontSize:13}}>No posts yet.</div>}
            {newsFeed.slice(0,20).map((post,i)=>{
              const author=users.find(u=>u.id===post.author);const likes=post.likes||[];const comments=post.comments||[];
              const liked=likes.includes(user.id);const isC=commentingOn===post.id;const isE=editingPost===post.id;const canMod=post.author===user.id||isAdmin(user);
              return <div key={post.id||i} style={{display:"grid",gridTemplateColumns:"28px 1fr",gap:10,padding:"12px 0",borderTop:`1px solid var(--divider)`}}>
                <div style={{...S.avatar,width:28,height:28,fontSize:9,flexShrink:0,background:author?.profilePhoto?"transparent":(author?.profileColor||C.grad2)}}>{author?.profilePhoto?<img src={author.profilePhoto} alt='' style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(author?.avatar||"?")}</div>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                    <span style={{fontWeight:600,fontSize:13}}>{author?.name||"Unknown"}</span>
                    {author&&<span style={{fontSize:9,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",background:"var(--n-100)",padding:"1px 5px",borderRadius:3}}>{author.role}</span>}
                    <span style={{fontSize:11,color:"var(--text-3)"}}>{post.date}{post.edited?" · edited":""}</span>
                  </div>
                  {isE
                    ?<div><textarea style={{...S.textarea,minHeight:50,fontSize:13}} value={editText} onChange={e=>setEditText(e.target.value)}/><div style={{display:"flex",gap:6,marginTop:6}}><button style={{...S.btnSm,fontSize:11,padding:"5px 12px"}} onClick={()=>saveEdit(post.id)}>Save</button><button style={{...S.btnO,fontSize:11,padding:"5px 12px"}} onClick={()=>{setEditingPost(null);setEditText("")}}>Cancel</button></div></div>
                    :<div style={{fontSize:13,color:"var(--text-2)",lineHeight:1.5,marginBottom:6}}>{post.text}</div>}
                  <div style={{display:"flex",alignItems:"center",gap:16,marginTop:2}}>
                    <button onClick={()=>toggleLike(post.id)} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:liked?"var(--red-500)":"var(--text-3)",fontWeight:liked?600:400,display:"flex",alignItems:"center",gap:4,padding:0,fontFamily:"var(--font-sans)"}}>{liked?"❤️":"🤍"}{likes.length>0&&<span style={{fontVariantNumeric:"tabular-nums"}}>{likes.length}</span>}</button>
                    <button onClick={()=>{setCommentingOn(isC?null:post.id);setCommentText("")}} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"var(--text-3)",display:"flex",alignItems:"center",gap:4,padding:0,fontFamily:"var(--font-sans)"}}>💬{comments.length>0&&<span style={{fontVariantNumeric:"tabular-nums",marginLeft:4}}>{comments.length}</span>}</button>
                    {canMod&&!isE&&<><button onClick={()=>{setEditingPost(post.id);setEditText(post.text)}} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"var(--text-3)",padding:0,fontFamily:"var(--font-sans)"}}>✏️</button><button onClick={()=>{if(confirm("Delete?")){onUpdateFeed(prev=>prev.filter(p=>p.id!==post.id))}}} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"var(--text-3)",padding:0,marginLeft:"auto",fontFamily:"var(--font-sans)"}}>🗑</button></>}
                  </div>
                  {comments.length>0&&<div style={{marginTop:8}}>{comments.map((c,ci)=>{const ca=users.find(u=>u.id===c.author);return <div key={c.id||ci} style={{display:"flex",gap:8,padding:"6px 0",borderTop:`1px solid var(--divider)`}}><div style={{...S.avatar,width:22,height:22,fontSize:8,flexShrink:0,background:ca?.profilePhoto?"transparent":(ca?.profileColor||C.grad2)}}>{ca?.profilePhoto?<img src={ca.profilePhoto} alt='' style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(ca?.avatar||"?")}</div><div><div style={{fontSize:11,color:"var(--text-3)"}}><strong style={{color:"var(--text)"}}>{ca?.name||"?"}</strong> · {c.date}</div><div style={{fontSize:12,lineHeight:1.5,marginTop:1}}>{c.text}</div></div></div>})}</div>}
                  {isC&&<div style={{marginTop:8,display:"flex",gap:8}}><div style={{...S.avatar,width:22,height:22,fontSize:8,flexShrink:0,background:user.profilePhoto?"transparent":(user.profileColor||C.grad2)}}>{user.profilePhoto?<img src={user.profilePhoto} alt='' style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}</div><input style={{...S.input,flex:1,fontSize:12,padding:"6px 10px"}} value={commentText} onChange={e=>setCommentText(e.target.value)} placeholder="Write a comment…" onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();addComment(post.id)}}} autoFocus/><button style={{...S.btnSm,padding:"0 12px",height:32,fontSize:12}} onClick={()=>addComment(post.id)}>Send</button></div>}
                </div>
              </div>;
            })}
          </div>
        </div>
      </div>

      {/* RIGHT: priority queue + focus + this week */}
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* Priority queue */}
        <div style={S.card}>
          <div style={S.cardH}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Priority queue</span>
            </div>
            <button onClick={()=>setViewTracked("actions")} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"var(--a-600)",fontWeight:500,padding:0,fontFamily:"var(--font-sans)"}}>View all →</button>
          </div>
          <div style={{padding:"8px 10px"}}>
            {priorityFlat.length===0&&<div style={{textAlign:"center",padding:"20px 0",color:"var(--text-3)",fontSize:13}}>No action items this week 🎉</div>}
            {priorityFlat.slice(0,6).map((a,i)=>{
              const pri=a.priority||"Medium";
              const flagColor=pri==="High"?"var(--red-500)":pri==="Low"?"var(--blue-500)":"var(--amber-500)";
              const priBg=pri==="High"?"color-mix(in srgb,var(--red-500) 12%,transparent)":pri==="Low"?"color-mix(in srgb,var(--blue-500) 12%,transparent)":"color-mix(in srgb,var(--amber-500) 12%,transparent)";
              const priFg=pri==="High"?"var(--red-600)":pri==="Low"?"var(--blue-600)":"var(--amber-600)";
              const isOverdue=a.dueDate&&new Date(a.dueDate)<new Date();
              return <div key={a.id+a.projectId} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",border:"1px solid var(--border)",borderRadius:8,marginBottom:6,background:"var(--surface)",transition:"border-color .12s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor="var(--a-300)"}
                onMouseLeave={e=>e.currentTarget.style.borderColor="var(--border)"}>
                <div style={{width:4,alignSelf:"stretch",borderRadius:2,background:flagColor,flexShrink:0,margin:"-10px 0 -10px -12px"}}/>
                <input type="checkbox" checked={!!a.done} onChange={e=>{e.stopPropagation();toggleAction(a.projectId,a.id)}} title="Mark complete" style={{accentColor:"var(--green-500)",width:17,height:17,flexShrink:0,cursor:"pointer"}}/>
                <div onClick={()=>onOpen(a.projectId)} style={{flex:1,minWidth:0,cursor:"pointer"}}>
                  <div style={{fontWeight:500,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontSize:13}}>{a.text}</div>
                  <div style={{fontSize:11,color:"var(--text-3)",marginTop:1,display:"flex",gap:6,alignItems:"center"}}>
                    <span>{a.projectName}</span>
                    {isOverdue&&<span style={{color:"var(--red-600)",fontWeight:600}}>⚠ past due</span>}
                    {a.dueDate&&!isOverdue&&<span>· due {a.dueDate}</span>}
                  </div>
                </div>
                <span style={{fontSize:9,fontWeight:700,padding:"2px 6px",borderRadius:999,background:priBg,color:priFg,textTransform:"uppercase",letterSpacing:"0.05em",flexShrink:0}}>{pri}</span>
              </div>;
            })}
          </div>
        </div>

        {/* Focus allocation */}
        {focusProjects.length>0&&<div style={S.card}>
          <div style={S.cardH}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Focus allocation</span>
            <span style={{background:"var(--a-50)",color:"var(--a-600)",fontSize:11,fontWeight:600,padding:"2px 8px",borderRadius:999}}>{myFocusPct}%</span>
          </div>
          <div style={S.cardB}>
            {focusProjects.map((p,i)=>{
              const f=getUserFocus(p,user.id);
              const hues=["var(--a-500)","var(--green-500)","var(--violet-500, #8b5cf6)","var(--blue-500)","var(--amber-500)"];
              return <div key={p.id} style={{marginBottom:i<focusProjects.length-1?14:0}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:5,fontSize:12}}>
                  <span style={{fontWeight:500,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:"75%"}}>{p.name}</span>
                  <span style={{fontVariantNumeric:"tabular-nums",color:"var(--text-3)",flexShrink:0}}>{f}%</span>
                </div>
                <div style={{height:4,background:"var(--n-100)",borderRadius:999,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${Math.min(f,100)}%`,background:hues[i%hues.length],borderRadius:999}}/>
                </div>
              </div>;
            })}
            {myFocusPct<100&&<div style={{marginTop:14,paddingTop:12,borderTop:"1px solid var(--divider)",fontSize:12,color:"var(--text-3)"}}>
              {100-myFocusPct}% unallocated
            </div>}
          </div>
        </div>}

        {/* Upcoming deadlines */}
        <div style={S.card}>
          <div style={S.cardH}>
            <span style={{fontSize:14,fontWeight:600,letterSpacing:"-0.01em"}}>Upcoming deadlines</span>
            <button onClick={()=>setViewTracked("deliverables")} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,color:"var(--a-600)",fontWeight:500,padding:0,fontFamily:"var(--font-sans)"}}>Calendar →</button>
          </div>
          <div style={S.cardB}>
            {(()=>{
              const today=new Date();today.setHours(0,0,0,0);
              const upcoming=my.flatMap(p=>(p.deadlines||[]).map(d=>({...d,project:p}))).filter(d=>new Date(d.date)>=today).sort((a,b)=>new Date(a.date)-new Date(b.date)).slice(0,5);
              if(upcoming.length===0)return <div style={{textAlign:"center",padding:"16px 0",color:"var(--text-3)",fontSize:13}}>No upcoming deadlines.</div>;
              return upcoming.map((d,i)=>{
                const days=Math.ceil((new Date(d.date)-today)/(1000*60*60*24));
                return <div key={i} onClick={()=>onOpen(d.project.id)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderTop:i>0?"1px solid var(--divider)":"none",cursor:"pointer"}}>
                  <div style={{width:42,height:42,borderRadius:8,background:days<=3?"var(--red-50)":days<=7?"var(--amber-50)":"var(--a-50)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <div style={{fontSize:16,fontWeight:700,lineHeight:1,color:days<=3?"var(--red-600)":days<=7?"var(--amber-600)":"var(--a-600)",fontVariantNumeric:"tabular-nums"}}>{days===0?"!":days}</div>
                    <div style={{fontSize:9,fontWeight:600,color:days<=3?"var(--red-500)":days<=7?"var(--amber-500)":"var(--a-500)",textTransform:"uppercase",letterSpacing:"0.04em"}}>{days===0?"today":"days"}</div>
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:500,fontSize:13,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.name||d.title||"Deadline"}</div>
                    <div style={{fontSize:11,color:"var(--text-3)",marginTop:1,fontFamily:"var(--font-mono)"}}>{d.project.number} · {d.date}</div>
                  </div>
                </div>;
              });
            })()}
          </div>
        </div>
      </div>
    </div>
  </div>;
}

// ══════════════════════════════════════════════════════════════
// STORAGE (Multi-tenant) + SUPER ADMIN
// ══════════════════════════════════════════════════════════════
const SUPER_ADMIN_EMAIL = "batu@omengineering.ca"; // Can delete any company

function getSK(companyId){
  const p=`c:${companyId}`;
  return{u:`${p}:users`,p:`${p}:projects`,t:`${p}:timesheets`,n:`${p}:notes`,f:`${p}:feed`,a:`${p}:actions`,teams:`${p}:teams`,assignments:`${p}:assignments`,vacations:`${p}:vacations`,company:`${p}:company`,notifs:`${p}:notifications`,events:`${p}:events`,issues:`${p}:issues`};
}
const REGISTRY_KEY="wb:companies";
const SESSION_KEY="wb:session";

// ── PUBLIC SOCIAL LAYER (cross-workspace; opt-in only) ──
// These keys store data shared across all WorkBro workspaces — anyone with an account can see them.
// Privacy: profiles and companies must explicitly opt-in (publicProfile / publicCompany flags).
const PUBLIC_KEYS={
  companies: "wb:public:companies",
  profiles:  "wb:public:profiles",
  posts:     "wb:public:posts",
  showcased: "wb:public:projects",
};

// ── DIRECT MESSAGES (cross-workspace, between two users) ──
// Threads keyed by deterministic hash of participant IDs (alphabetically sorted).
// Each thread is only visible to its two participants by app-level enforcement.
function dmThreadId(uid1,uid2){
  const sorted=[String(uid1),String(uid2)].sort();
  return `wb:public:dm:${sorted[0]}::${sorted[1]}`;
}
// Per-user index of threads they're in (for fast loading)
function dmUserIndexKey(uid){return `wb:public:dm:index:${uid}`}

// ── Load: always try Supabase first ──
async function ld(k,fb){
  try{
    const {data,error}=await supabase.from("kv_store").select("value").eq("key",k).maybeSingle();
    if(error){console.warn("DB load error for",k,error.message)}
    else if(data&&data.value!==null&&data.value!==undefined){
      localStorage.setItem(k,JSON.stringify(data.value));
      return data.value;
    }
  }catch(e){console.warn("DB load failed for",k,e.message)}
  try{const v=localStorage.getItem(k);return v?JSON.parse(v):fb}catch{return fb}
}

// ── Save: write to Supabase AND localStorage ──
async function sv(k,d){
  try{localStorage.setItem(k,JSON.stringify(d))}catch{}
  try{
    const {error}=await supabase.from("kv_store").upsert({key:k,value:d,updated_at:new Date().toISOString()},{onConflict:"key"});
    if(error)console.error("DB save error for",k,error.message);
  }catch(e){console.error("DB save failed for",k,e.message)}
}

// ── List all keys matching a prefix (for per-user timesheets, etc.) ──
async function listKeysByPrefix(prefix){
  try{
    const {data,error}=await supabase.from("kv_store").select("key,value").like("key",prefix+"%");
    if(error){console.warn("DB list error",error.message);return[]}
    return data||[];
  }catch(e){console.warn("DB list failed",e.message);return[]}
}

// ── Atomic add company (reads fresh from DB, appends, saves) ──
async function addCompanyToRegistry(co){
  const fresh=await ld(REGISTRY_KEY,[]);
  if(fresh.find(c=>c.id===co.id))return fresh; // already exists
  const updated=[...fresh,co];
  await sv(REGISTRY_KEY,updated);
  return updated;
}

// ── Atomic remove company ──
async function removeCompanyFromRegistry(coId){
  const fresh=await ld(REGISTRY_KEY,[]);
  const updated=fresh.filter(c=>c.id!==coId);
  await sv(REGISTRY_KEY,updated);
  // Also delete company data
  const sk=getSK(coId);
  await Promise.all([sv(sk.u,[]),sv(sk.p,[]),sv(sk.t,{}),sv(sk.n,{}),sv(sk.f,[]),sv(sk.a,{})]);
  return updated;
}

// ══════════════════════════════════════════════════════════════
// DISCOVER — Public social hub (cross-workspace)
// ══════════════════════════════════════════════════════════════
function DiscoverView({user,company,companyInfo,projects,publicCompanies,publicProfiles,publicPosts,publicProjects,onPost,onLikePost,onDeletePost,onOpenPublicProfile,onOpenPublicCompany,onOpenPublicProject,onShowSettings,onUnpublishProfile}){
  const [tab,setTab]=useState("feed");
  const [postText,setPostText]=useState("");
  const [postAs,setPostAs]=useState("user"); // user | company
  const [linkedProjectId,setLinkedProjectId]=useState("");
  const [searchQ,setSearchQ]=useState("");
  const isAdm=isAdmin(user);

  const myProfileIsPublic=(publicProfiles||[]).some(p=>p.userId===user.id);
  const myCompanyIsPublic=company&&(publicCompanies||[]).some(c=>c.companyId===company.id);

  const filteredCompanies=(publicCompanies||[]).filter(c=>{
    if(!searchQ)return true;
    const q=searchQ.toLowerCase();
    return(c.name||"").toLowerCase().includes(q)||(c.industry||"").toLowerCase().includes(q)||(c.location||"").toLowerCase().includes(q)||(c.tagline||"").toLowerCase().includes(q);
  });
  const filteredProfiles=(publicProfiles||[]).filter(p=>{
    if(!searchQ)return true;
    const q=searchQ.toLowerCase();
    return(p.name||"").toLowerCase().includes(q)||(p.role||"").toLowerCase().includes(q)||(p.companyName||"").toLowerCase().includes(q)||(p.headline||"").toLowerCase().includes(q)||(p.skills||[]).some(s=>s.toLowerCase().includes(q));
  });
  const filteredProjects=(publicProjects||[]).filter(p=>{
    if(!searchQ)return true;
    const q=searchQ.toLowerCase();
    return(p.name||"").toLowerCase().includes(q)||(p.type||"").toLowerCase().includes(q)||(p.location||"").toLowerCase().includes(q)||(p.companyName||"").toLowerCase().includes(q);
  });

  const submitPost=()=>{
    if(!postText.trim())return;
    if(postAs==="company"&&!isAdm){alert("Only admins can post on behalf of the company.");return}
    onPost(postText.trim(),postAs,linkedProjectId||null);
    setPostText("");
    setLinkedProjectId("");
  };

  const fmtRelTime=(iso)=>{
    try{
      const d=new Date(iso);const now=new Date();const diff=Math.floor((now-d)/1000);
      if(diff<60)return "just now";
      if(diff<3600)return `${Math.floor(diff/60)}m ago`;
      if(diff<86400)return `${Math.floor(diff/3600)}h ago`;
      if(diff<604800)return `${Math.floor(diff/86400)}d ago`;
      return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:diff>31536000?"numeric":undefined});
    }catch{return ""}
  };

  return <div style={{padding:"clamp(2px,2vw,24px) clamp(0px,2.5vw,32px) 60px"}}>
    {/* ── PAGE HEAD ─────────────────────────────────────────────── */}
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",gap:16,marginBottom:18,paddingBottom:18,borderBottom:"1px solid var(--border)",flexWrap:"wrap"}}>
      <div>
        <div style={{fontSize:11,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:6}}>{publicCompanies.length} firm{publicCompanies.length!==1?"s":""} · {publicProfiles.length} {publicProfiles.length===1?"person":"people"} · {publicPosts.length} post{publicPosts.length!==1?"s":""}</div>
        <h1 style={{fontSize:28,fontWeight:600,letterSpacing:"-0.025em",margin:"0 0 6px",lineHeight:1.2}}>Discover</h1>
        <p style={{fontSize:13,color:"var(--text-2)",margin:0}}>Connect with engineering & architecture firms beyond your own workspace.</p>
      </div>
      <div style={{display:"flex",gap:6,alignItems:"center"}}>
        {myProfileIsPublic?
          <button onClick={()=>{if(confirm("Make your profile private? You'll no longer appear in Discover."))onUnpublishProfile&&onUnpublishProfile()}} style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,color:"var(--red-600)",borderColor:"color-mix(in srgb, var(--red-500) 40%, var(--border))"}} title="Hide your profile from public Discover">🔒 Make profile private</button>:
          <button onClick={onShowSettings} style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} title="Set up your public profile">🌐 Make profile public</button>
        }
      </div>
    </div>

    {/* Privacy/visibility status banner */}
    {(!myProfileIsPublic||(isAdm&&!myCompanyIsPublic))&&<div style={{padding:"12px 16px",marginBottom:16,background:"color-mix(in srgb, var(--amber-500) 10%, transparent)",border:"1px solid color-mix(in srgb, var(--amber-500) 28%, transparent)",borderRadius:10,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
      <span style={{fontSize:20}}>🔒</span>
      <div style={{flex:1,minWidth:200}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--amber-700)",marginBottom:2}}>You're invisible to other firms</div>
        <div style={{fontSize:12,color:"var(--text-2)"}}>
          {!myProfileIsPublic&&"Your profile is private. "}
          {isAdm&&!myCompanyIsPublic&&"Your company isn't listed publicly. "}
          Make yourself discoverable to receive collaboration opportunities.
        </div>
      </div>
      <button style={{...S.btn,padding:"0 14px",height:32,fontSize:12}} onClick={onShowSettings}>Manage visibility</button>
    </div>}

    {/* ── TABS ─────────────────────────────────────────────────── */}
    <div style={{display:"flex",gap:0,marginBottom:18,borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none"}}>
      {[["feed","Feed",publicPosts.length||null],["companies","Companies",publicCompanies.length||null],["people","People",publicProfiles.length||null]].map(([k,l,badge])=>{
        const active=tab===k;
        return <button key={k} onClick={()=>setTab(k)} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:active?600:500,color:active?"var(--text)":"var(--text-3)",borderBottom:active?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",transition:"color .12s, border-color .12s",whiteSpace:"nowrap",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
          {l}
          {badge&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{badge}</span>}
        </button>;
      })}
    </div>

    {/* Search bar (Companies/People/Projects) */}
    {tab!=="feed"&&<div style={{marginBottom:16}}>
      <input style={{...S.input,height:36,fontSize:13,padding:"0 14px"}} placeholder={`Search ${tab}…`} value={searchQ} onChange={e=>setSearchQ(e.target.value)}/>
    </div>}

    {/* FEED */}
    {tab==="feed"&&<div style={{maxWidth:680}}>
      {/* Compose */}
      {myProfileIsPublic?<div style={{...S.card,padding:14,marginBottom:16}}>
        <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
          <div style={{...S.avatar,width:40,height:40,fontSize:13,background:user.profileColor||C.grad2,flexShrink:0}}>{user.profilePhoto?<img src={user.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:user.avatar}</div>
          <div style={{flex:1}}>
            <textarea style={{...S.textarea,minHeight:60,fontSize:13}} value={postText} onChange={e=>setPostText(e.target.value)} placeholder="Share an update with the WorkBro community…" maxLength={500}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8,gap:8,flexWrap:"wrap"}}>
              <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                {isAdm&&myCompanyIsPublic&&<select style={{...S.select,padding:"4px 8px",fontSize:11,width:"auto"}} value={postAs} onChange={e=>setPostAs(e.target.value)}>
                  <option value="user">Post as you</option>
                  <option value="company">Post as {companyInfo?.name||company?.name}</option>
                </select>}
                <select style={{...S.select,padding:"4px 8px",fontSize:11,width:"auto"}} value={linkedProjectId} onChange={e=>setLinkedProjectId(e.target.value)}>
                  <option value="">No project linked</option>
                  {projects.filter(p=>p.team?.includes(user.id)).map(p=><option key={p.id} value={p.id}>{p.number} · {p.name}</option>)}
                </select>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:11,color:C.textDim}}>{postText.length}/500</span>
                <button style={{...S.btn,padding:"6px 16px",fontSize:12,opacity:postText.trim()?1:.4}} onClick={submitPost} disabled={!postText.trim()}>Post</button>
              </div>
            </div>
          </div>
        </div>
      </div>:<div style={{...S.card,padding:24,marginBottom:16,textAlign:"center"}}>
        <div style={{fontSize:14,fontWeight:600,marginBottom:6}}>Make your profile public to post here</div>
        <div style={{fontSize:12,color:C.textMid,marginBottom:14}}>The Discover feed is for users who've opted into the public network.</div>
        <button style={S.btn} onClick={onShowSettings}>Manage Visibility</button>
      </div>}

      {/* Feed */}
      {publicPosts.length===0?<div style={{...S.card,padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>No public posts yet. Be the first to share!</div>:
      publicPosts.map(post=>{
        const project=publicProjects.find(p=>p.projectId===post.projectId);
        const myLike=(post.likes||[]).includes(user.id);
        const canDelete=post.authorId===user.id||(isAdm&&post.authorCompanyId===company?.id);
        return <div key={post.id} style={{...S.card,padding:16,marginBottom:14}}>
          <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
            <div onClick={()=>{
              if(post.authorType==="company"&&post.authorCompanyId)onOpenPublicCompany(post.authorCompanyId);
              else if(post.authorType==="user"&&post.authorId)onOpenPublicProfile(post.authorId);
            }} style={{...S.avatar,width:44,height:44,fontSize:14,background:post.authorAvatarLogo?"#fff":(post.authorAvatarColor||C.grad2),flexShrink:0,cursor:"pointer",overflow:"hidden",padding:post.authorAvatarLogo?2:0}}>
              {post.authorAvatarLogo?<img src={post.authorAvatarLogo} alt="" style={{maxWidth:"100%",maxHeight:"100%",objectFit:"contain"}}/>:(post.authorAvatar||"?")}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",marginBottom:2}}>
                <strong style={{fontSize:14,cursor:"pointer"}} onClick={()=>{
                  if(post.authorType==="company"&&post.authorCompanyId)onOpenPublicCompany(post.authorCompanyId);
                  else if(post.authorType==="user"&&post.authorId)onOpenPublicProfile(post.authorId);
                }}>{post.authorName}</strong>
                {post.authorType==="company"&&<Badge bg={C.greenSoft} fg={C.green}>Company</Badge>}
                {post.authorRole&&<span style={{fontSize:11,color:C.textDim}}>· {post.authorRole}</span>}
                {post.authorCompanyName&&post.authorType==="user"&&<span style={{fontSize:11,color:C.textDim}}>· {post.authorCompanyName}</span>}
                <span style={{fontSize:11,color:C.textDim}}>· {fmtRelTime(post.date)}</span>
              </div>
              <div style={{fontSize:14,lineHeight:1.6,whiteSpace:"pre-wrap",marginBottom:project?10:0}}>{post.text}</div>
              {project&&<div onClick={()=>onOpenPublicProject(project.projectId)} style={{...S.card,padding:"10px 12px",background:C.card,borderLeft:`3px solid ${C.accent}`,cursor:"pointer",marginTop:8}}>
                <div style={{fontSize:10,color:C.textDim,marginBottom:2,fontWeight:600}}>📁 PROJECT</div>
                <div style={{fontSize:13,fontWeight:700}}>{project.name}</div>
                <div style={{fontSize:11,color:C.textDim,marginTop:2}}>{project.type}{project.location?` · ${project.location}`:""} · {project.companyName}</div>
              </div>}
              <div style={{display:"flex",gap:14,marginTop:10,fontSize:12,color:C.textDim}}>
                <button onClick={()=>onLikePost(post.id)} style={{background:"none",border:"none",color:myLike?C.red:C.textDim,cursor:"pointer",padding:0,fontSize:12,display:"flex",alignItems:"center",gap:4,fontWeight:myLike?700:500}}>{myLike?"❤️":"🤍"} {post.likes?.length||0}</button>
              </div>
            </div>
            {canDelete&&<button onClick={()=>onDeletePost(post.id)} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:4}} title="Delete">×</button>}
          </div>
        </div>;
      })}
    </div>}

    {/* COMPANIES */}
    {tab==="companies"&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
      {filteredCompanies.length===0?<div style={{gridColumn:"1/-1",padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>{searchQ?"No companies match your search.":"No companies have published their profile yet."}</div>:
      filteredCompanies.map(c=><div key={c.companyId} onClick={()=>onOpenPublicCompany(c.companyId)} style={{...S.card,padding:0,cursor:"pointer",overflow:"hidden",transition:"transform .12s, box-shadow .15s"}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 8px 22px rgba(0,0,0,.10)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none"}}>
        <div style={{height:80,background:c.banner?`url(${c.banner}) center/cover`:`linear-gradient(135deg, ${C.accent} 0%, ${C.green} 100%)`,position:"relative"}}>
          <div style={{position:"absolute",left:14,bottom:-26,width:54,height:54,background:"#fff",borderRadius:8,border:`3px solid ${C.bg}`,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,.10)"}}>
            {c.logo?<img src={c.logo} alt="" style={{maxWidth:"80%",maxHeight:"80%",objectFit:"contain"}}/>:<div style={{fontSize:26}}>🏢</div>}
          </div>
        </div>
        <div style={{padding:"32px 16px 16px"}}>
          <div style={{fontSize:15,fontWeight:700,fontFamily:"'Inter',sans-serif",marginBottom:3}}>{c.name}</div>
          {c.tagline&&<div style={{fontSize:12,color:C.textMid,marginBottom:8,lineHeight:1.4}}>{c.tagline}</div>}
          <div style={{display:"flex",flexWrap:"wrap",gap:6,fontSize:11,color:C.textDim,marginBottom:8}}>
            {c.industry&&<span>🏭 {c.industry}</span>}
            {c.location&&<span>📍 {c.location}</span>}
            {c.size&&<span>👥 {c.size}</span>}
          </div>
          <div style={{display:"flex",gap:14,fontSize:11,color:C.textDim,paddingTop:8,borderTop:`1px solid ${C.border}`}}>
            <span><strong style={{color:C.text}}>{c.memberCount||0}</strong> members</span>
            <span><strong style={{color:C.text}}>{c.activeProjects||0}</strong> active projects</span>
          </div>
        </div>
      </div>)}
    </div>}

    {/* PEOPLE */}
    {tab==="people"&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:12}}>
      {filteredProfiles.length===0?<div style={{gridColumn:"1/-1",padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>{searchQ?"No profiles match your search.":"No public profiles yet."}</div>:
      filteredProfiles.map(p=><div key={p.userId} onClick={()=>onOpenPublicProfile(p.userId)} style={{...S.card,padding:14,cursor:"pointer",transition:"transform .12s, box-shadow .15s",display:"flex",gap:12,alignItems:"flex-start"}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 18px rgba(0,0,0,.08)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none"}}>
        <div style={{...S.avatar,width:50,height:50,fontSize:14,background:p.profileColor||C.grad2,flexShrink:0}}>{p.avatar||"?"}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:14,fontWeight:700,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.name}</div>
          <div style={{fontSize:11,color:C.textMid,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{p.role}{p.companyName?` · ${p.companyName}`:""}</div>
          {p.headline&&<div style={{fontSize:11,color:C.textDim,marginTop:4,lineHeight:1.4,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{p.headline}</div>}
          {p.publicLocation&&<div style={{fontSize:10,color:C.textDim,marginTop:4}}>📍 {p.publicLocation}</div>}
          {(p.skills||[]).length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:6}}>
            {(p.skills||[]).slice(0,3).map((s,i)=><Badge key={i} bg={C.accentSoft} fg={C.accent}>{s}</Badge>)}
            {p.skills.length>3&&<span style={{fontSize:10,color:C.textDim}}>+{p.skills.length-3}</span>}
          </div>}
        </div>
      </div>)}
    </div>}

  </div>;
}

// ══════════════════════════════════════════════════════════════
// FINANCE PORTAL — Dedicated view for Finance role and Admins
// ══════════════════════════════════════════════════════════════
function FinancePortalView({user,users,projects,timesheets}){
  const [period,setPeriod]=useState("month");
  const [tab,setTab]=useState("payroll"); // payroll | invoicing | tax | utilization

  const now=new Date();
  const periodStart=period==="month"?new Date(now.getFullYear(),now.getMonth(),1):
                   period==="lastmonth"?new Date(now.getFullYear(),now.getMonth()-1,1):
                   period==="quarter"?new Date(now.getFullYear(),Math.floor(now.getMonth()/3)*3,1):
                   period==="ytd"?new Date(now.getFullYear(),0,1):
                   new Date(2000,0,1);
  const periodEnd=period==="lastmonth"?new Date(now.getFullYear(),now.getMonth(),0,23,59,59):new Date(9999,11,31);
  const periodLabel={month:"This Month",lastmonth:"Last Month",quarter:"This Quarter",ytd:"Year to Date",all:"All Time"}[period];

  // Build payroll data — per user: hours, gross billable, estimated pay (at cost rate)
  const staffList=users.filter(u=>isStaff(u)&&u.status!=="pending");
  const payrollData=staffList.map(u=>{
    const rate=HOURLY_RATES[u.billableRole]||0;
    const costRate=rate*0.45;
    let hours=0,billableGross=0,byProject={};
    Object.entries(timesheets?.[u.id]||{}).forEach(([wk,weekData])=>{
      const wkDate=new Date(wk);
      if(wkDate<periodStart||wkDate>periodEnd)return;
      Object.entries(weekData).forEach(([k,row])=>{
        if(k==="expenses"||!Array.isArray(row))return;
        const h=row.reduce((a,b)=>a+b,0);
        hours+=h;
        billableGross+=h*rate;
        // Attribute to a project if applicable
        const mProj=k.match(/^proj:([^:]+)(?::.+)?$/);
        if(mProj){const pid=mProj[1];byProject[pid]=(byProject[pid]||0)+h}
      });
    });
    const estPay=hours*costRate;
    return{user:u,hours,rate,costRate,billableGross,estPay,byProject};
  }).filter(x=>x.hours>0);

  const totalHours=payrollData.reduce((s,p)=>s+p.hours,0);
  const totalBillable=payrollData.reduce((s,p)=>s+p.billableGross,0);
  const totalPay=payrollData.reduce((s,p)=>s+p.estPay,0);

  // Client / invoicing view
  const invoiceData=projects.map(p=>{
    let projHours=0,projBillable=0,expenses=0;
    staffList.forEach(u=>{
      const rate=HOURLY_RATES[u.billableRole]||0;
      Object.entries(timesheets?.[u.id]||{}).forEach(([wk,weekData])=>{
        const wkDate=new Date(wk);
        if(wkDate<periodStart||wkDate>periodEnd)return;
        Object.entries(weekData).forEach(([k,row])=>{
          if(k==="expenses"||!Array.isArray(row))return;
          if(k===`proj:${p.id}`||k.startsWith(`proj:${p.id}:`)){
            const h=row.reduce((a,b)=>a+b,0);
            projHours+=h;
            projBillable+=h*rate;
          }
        });
        if(weekData.expenses)weekData.expenses.filter(e=>e.projectId===p.id).forEach(e=>{expenses+=e.amount||0});
      });
    });
    return{proj:p,projHours,projBillable,expenses,total:projBillable+expenses};
  }).filter(p=>p.total>0).sort((a,b)=>b.total-a.total);
  const grandInvoice=invoiceData.reduce((s,i)=>s+i.total,0);

  // Export helpers
  const exportCSV=()=>{
    const rows=[["User","Role","Hours","Billable Rate","Gross Billable","Est. Cost Rate","Est. Pay","Period"]];
    payrollData.forEach(r=>{
      rows.push([r.user.name,r.user.billableRole,r.hours.toFixed(2),r.rate,r.billableGross.toFixed(2),r.costRate.toFixed(2),r.estPay.toFixed(2),periodLabel]);
    });
    const csv=rows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob=new Blob([csv],{type:"text/csv"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download=`payroll_${period}_${new Date().toISOString().split("T")[0]}.csv`;a.click();
    URL.revokeObjectURL(url);
  };
  const exportTaxCSV=()=>{
    const rows=[["Date (week start)","User","Role","Project #","Project","Phase","Hours","Rate","Gross"]];
    payrollData.forEach(r=>{
      Object.entries(timesheets?.[r.user.id]||{}).forEach(([wk,weekData])=>{
        const wkDate=new Date(wk);
        if(wkDate<periodStart||wkDate>periodEnd)return;
        Object.entries(weekData).forEach(([k,row])=>{
          if(k==="expenses"||!Array.isArray(row))return;
          const h=row.reduce((a,b)=>a+b,0);
          if(h===0)return;
          const mProj=k.match(/^proj:([^:]+)(?::(.+))?$/);
          const proj=mProj?projects.find(p=>p.id===mProj[1]):null;
          const phase=mProj?.[2]||proj?.phase||"";
          rows.push([wk,r.user.name,r.user.billableRole,proj?.number||"",proj?.name||"",phase,h.toFixed(2),r.rate,(h*r.rate).toFixed(2)]);
        });
      });
    });
    const csv=rows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob=new Blob([csv],{type:"text/csv"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download=`timesheet_detail_${period}_${new Date().toISOString().split("T")[0]}.csv`;a.click();
    URL.revokeObjectURL(url);
  };
  const exportInvoiceCSV=()=>{
    const rows=[["Project #","Project Name","Client","Hours","Billable","Expenses","Total Invoice"]];
    invoiceData.forEach(r=>{
      rows.push([r.proj.number,r.proj.name,r.proj.client||"",r.projHours.toFixed(2),r.projBillable.toFixed(2),r.expenses.toFixed(2),r.total.toFixed(2)]);
    });
    const csv=rows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(",")).join("\n");
    const blob=new Blob([csv],{type:"text/csv"});
    const url=URL.createObjectURL(blob);
    const a=document.createElement("a");a.href=url;a.download=`invoicing_${period}_${new Date().toISOString().split("T")[0]}.csv`;a.click();
    URL.revokeObjectURL(url);
  };

  return <div>
    <div style={{marginBottom:20}}>
      <div style={{fontFamily:"'Inter',sans-serif",fontSize:28,fontWeight:700,marginBottom:4}}>💼 Finance Portal</div>
      <div style={{fontSize:14,color:C.textMid}}>Payroll, client invoicing, and tax reporting — powered by WorkBro timesheet data.</div>
    </div>

    {/* Period + tab selectors */}
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
      <div style={{display:"flex",gap:4}}>
        {[["month","This Month"],["lastmonth","Last Month"],["quarter","Quarter"],["ytd","YTD"],["all","All Time"]].map(([k,l])=>
          <button key={k} style={{...S.tab(period===k),padding:"6px 14px",fontSize:12}} onClick={()=>setPeriod(k)}>{l}</button>)}
      </div>
      <div style={{flex:1}}/>
      <span style={{fontSize:12,color:C.textDim}}>Viewing: <strong style={{color:C.text}}>{periodLabel}</strong> · {staffList.length} staff · {projects.length} projects</span>
    </div>

    {/* Summary cards */}
    <div style={{...S.g3,marginBottom:20}}>
      <StatCard label="Total Hours Logged" value={totalHours.toFixed(1)} color={C.accent} sub={`${payrollData.length} active staff`}/>
      <StatCard label="Gross Billable" value={`$${Math.round(totalBillable).toLocaleString()}`} color={C.green} sub="Before expenses"/>
      <StatCard label="Est. Payroll Cost" value={`$${Math.round(totalPay).toLocaleString()}`} color={C.amber} sub="~45% of billable rate"/>
    </div>

    {/* Sub-tabs */}
    <div style={{display:"flex",gap:6,marginBottom:16,borderBottom:`1px solid ${C.border}`,paddingBottom:2,flexWrap:"wrap"}}>
      <button style={{...S.tab(tab==="payroll"),padding:"8px 16px"}} onClick={()=>setTab("payroll")}>👥 Payroll</button>
      <button style={{...S.tab(tab==="invoicing"),padding:"8px 16px"}} onClick={()=>setTab("invoicing")}>🧾 Client Invoicing</button>
      <button style={{...S.tab(tab==="utilization"),padding:"8px 16px"}} onClick={()=>setTab("utilization")}>📊 Staff Utilization</button>
      <button style={{...S.tab(tab==="tax"),padding:"8px 16px"}} onClick={()=>setTab("tax")}>📑 Tax & Exports</button>
    </div>

    {/* Payroll tab */}
    {tab==="payroll"&&<div style={S.card}>
      <div style={S.cardH}>
        <span style={S.cardT}>Payroll Summary — {periodLabel}</span>
        <button style={S.btnSm} onClick={exportCSV}>📥 Export CSV</button>
      </div>
      <div style={{...S.cardB,overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:700}}>
          <thead><tr>
            <th style={S.th}>Staff Member</th>
            <th style={S.th}>Role</th>
            <th style={{...S.th,textAlign:"right"}}>Hours</th>
            <th style={{...S.th,textAlign:"right"}}>Billable Rate</th>
            <th style={{...S.th,textAlign:"right"}}>Gross Billable</th>
            <th style={{...S.th,textAlign:"right"}}>Est. Pay</th>
            <th style={{...S.th,textAlign:"right"}}>Projects</th>
          </tr></thead>
          <tbody>
            {payrollData.map(r=><tr key={r.user.id}>
              <td style={{...S.td,fontSize:12}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{...S.avatar,width:26,height:26,fontSize:9,background:r.user.profileColor||C.grad2}}>{r.user.avatar}</div>
                  <div>
                    <div style={{fontWeight:600}}>{r.user.name}</div>
                    <div style={{fontSize:10,color:C.textDim}}>{r.user.email}</div>
                  </div>
                </div>
              </td>
              <td style={{...S.td,fontSize:11}}>{r.user.billableRole||r.user.role}</td>
              <td style={{...S.td,textAlign:"right",fontWeight:600}}>{r.hours.toFixed(1)}</td>
              <td style={{...S.td,textAlign:"right"}}>${r.rate}/h</td>
              <td style={{...S.td,textAlign:"right",color:C.green,fontWeight:600}}>${Math.round(r.billableGross).toLocaleString()}</td>
              <td style={{...S.td,textAlign:"right",color:C.amber,fontWeight:700}}>${Math.round(r.estPay).toLocaleString()}</td>
              <td style={{...S.td,textAlign:"right",fontSize:11,color:C.textDim}}>{Object.keys(r.byProject).length}</td>
            </tr>)}
            {payrollData.length===0&&<tr><td colSpan={7} style={{...S.td,textAlign:"center",color:C.textDim,padding:30}}>No hours logged in this period.</td></tr>}
            <tr style={{background:C.accentSoft,fontWeight:700}}>
              <td colSpan={2} style={{...S.td,fontWeight:700}}>TOTAL ({payrollData.length} staff)</td>
              <td style={{...S.td,textAlign:"right",fontWeight:700}}>{totalHours.toFixed(1)}</td>
              <td style={S.td}></td>
              <td style={{...S.td,textAlign:"right",fontWeight:700,color:C.green}}>${Math.round(totalBillable).toLocaleString()}</td>
              <td style={{...S.td,textAlign:"right",fontWeight:700,color:C.amber}}>${Math.round(totalPay).toLocaleString()}</td>
              <td style={S.td}></td>
            </tr>
          </tbody>
        </table>
        <div style={{fontSize:11,color:C.textDim,marginTop:12,lineHeight:1.6}}>
          <strong>Note:</strong> Est. Pay is calculated as hours × 45% of billable rate (industry estimate of payroll cost). For exact payroll, export the CSV and reconcile with your payroll provider's actual wage data.
        </div>
      </div>
    </div>}

    {/* Invoicing tab */}
    {tab==="invoicing"&&<div style={S.card}>
      <div style={S.cardH}>
        <span style={S.cardT}>Client Invoicing — {periodLabel}</span>
        <button style={S.btnSm} onClick={exportInvoiceCSV}>📥 Export CSV</button>
      </div>
      <div style={{...S.cardB,overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:700}}>
          <thead><tr>
            <th style={S.th}>Project</th>
            <th style={S.th}>Client</th>
            <th style={{...S.th,textAlign:"right"}}>Hours</th>
            <th style={{...S.th,textAlign:"right"}}>Labor</th>
            <th style={{...S.th,textAlign:"right"}}>Expenses</th>
            <th style={{...S.th,textAlign:"right"}}>Invoice Total</th>
            <th style={{...S.th,textAlign:"right"}}>Contract</th>
          </tr></thead>
          <tbody>
            {invoiceData.map(r=><tr key={r.proj.id}>
              <td style={{...S.td,fontSize:12}}>
                <div style={{fontWeight:600}}>{r.proj.number}</div>
                <div style={{color:C.textDim,fontSize:11}}>{r.proj.name}</div>
              </td>
              <td style={{...S.td,fontSize:12}}>{r.proj.client||"—"}</td>
              <td style={{...S.td,textAlign:"right",fontWeight:600}}>{r.projHours.toFixed(1)}</td>
              <td style={{...S.td,textAlign:"right"}}>${Math.round(r.projBillable).toLocaleString()}</td>
              <td style={{...S.td,textAlign:"right",color:C.textMid}}>${Math.round(r.expenses).toLocaleString()}</td>
              <td style={{...S.td,textAlign:"right",fontWeight:700,color:C.accent}}>${Math.round(r.total).toLocaleString()}</td>
              <td style={{...S.td,textAlign:"right",fontSize:11,color:C.textDim}}>${(r.proj.budget?.total||0).toLocaleString()}</td>
            </tr>)}
            {invoiceData.length===0&&<tr><td colSpan={7} style={{...S.td,textAlign:"center",color:C.textDim,padding:30}}>No billable work in this period.</td></tr>}
            <tr style={{background:C.accentSoft,fontWeight:700}}>
              <td colSpan={5} style={{...S.td,fontWeight:700}}>GRAND TOTAL ({invoiceData.length} projects)</td>
              <td style={{...S.td,textAlign:"right",fontWeight:700,color:C.accent}}>${Math.round(grandInvoice).toLocaleString()}</td>
              <td style={S.td}></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>}

    {/* Utilization tab */}
    {tab==="utilization"&&<div style={S.card}>
      <div style={S.cardH}><span style={S.cardT}>Staff Utilization — {periodLabel}</span></div>
      <div style={S.cardB}>
        {payrollData.map(r=>{
          const weeksInPeriod=Math.max(1,Math.ceil((Math.min(periodEnd,now)-periodStart)/(7*864e5)));
          const expectedHours=40*weeksInPeriod;
          const utilization=expectedHours>0?(r.hours/expectedHours)*100:0;
          return <div key={r.user.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
            <div style={{...S.avatar,width:32,height:32,fontSize:11,background:r.user.profileColor||C.grad2}}>{r.user.avatar}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:600}}>{r.user.name}<RoleBadge role={r.user.role}/></div>
              <div style={{fontSize:11,color:C.textDim}}>{r.hours.toFixed(1)}h of ~{expectedHours}h expected · ${r.rate}/h billable</div>
              <div style={{marginTop:4}}><PBar value={Math.min(100,utilization)} height={6} showLabel={false}/></div>
            </div>
            <Badge bg={utilization>=70?C.greenSoft:utilization>=40?C.amberSoft:C.redSoft} fg={utilization>=70?C.green:utilization>=40?C.amber:C.red}>{utilization.toFixed(0)}%</Badge>
          </div>;
        })}
        {payrollData.length===0&&<div style={{padding:30,textAlign:"center",color:C.textDim}}>No utilization data for this period.</div>}
      </div>
    </div>}

    {/* Tax exports tab */}
    {tab==="tax"&&<div>
      <div style={S.banner(C.amberSoft,C.amber)}>📑 Tax & compliance exports give you row-level detail for payroll, tax filing, and audits. All exports are CSV format compatible with QuickBooks, ADP, Xero, and most accounting software.</div>

      <div style={{...S.g2,marginTop:16}}>
        <div style={S.card}>
          <div style={S.cardH}><span style={S.cardT}>📑 Timesheet Detail Export</span></div>
          <div style={S.cardB}>
            <div style={{fontSize:13,color:C.textMid,marginBottom:12,lineHeight:1.6}}>Row-level timesheet entries for the selected period. Includes: week, user, role, project #, project name, phase, hours, rate, and gross amount.</div>
            <button style={S.btn} onClick={exportTaxCSV}>📥 Download Detail CSV</button>
          </div>
        </div>

        <div style={S.card}>
          <div style={S.cardH}><span style={S.cardT}>👥 Payroll Summary Export</span></div>
          <div style={S.cardB}>
            <div style={{fontSize:13,color:C.textMid,marginBottom:12,lineHeight:1.6}}>Per-user summary with total hours, billable rate, gross, and estimated pay — ready for payroll processing.</div>
            <button style={S.btn} onClick={exportCSV}>📥 Download Payroll CSV</button>
          </div>
        </div>

        <div style={S.card}>
          <div style={S.cardH}><span style={S.cardT}>🧾 Client Invoicing Export</span></div>
          <div style={S.cardB}>
            <div style={{fontSize:13,color:C.textMid,marginBottom:12,lineHeight:1.6}}>Per-project invoice amounts with client, hours, labor, expenses, and totals — ready to send to clients.</div>
            <button style={S.btn} onClick={exportInvoiceCSV}>📥 Download Invoicing CSV</button>
          </div>
        </div>

        <div style={S.card}>
          <div style={S.cardH}><span style={S.cardT}>ℹ️ Integration Notes</span></div>
          <div style={S.cardB}>
            <div style={{fontSize:12,color:C.textMid,lineHeight:1.7}}>
              <div><strong>QuickBooks:</strong> Import payroll CSV via Payroll → Import employees</div>
              <div><strong>ADP:</strong> Use Timesheet Detail for hour imports</div>
              <div><strong>Xero:</strong> Invoicing CSV maps to Sales Invoices import</div>
              <div><strong>Canadian GST/HST:</strong> Invoicing totals are pre-tax — apply GST/HST rates during invoice creation in your accounting tool</div>
            </div>
          </div>
        </div>
      </div>
    </div>}
  </div>;
}

// ══════════════════════════════════════════════════════════════
// COMPANY PROFILE PAGE — LinkedIn-style company page
// ══════════════════════════════════════════════════════════════
function CompanyProfilePage({user,users,projects,teams,companyInfo,company,newsFeed,onPostNews,onOpenProject,onOpenUser,onEditCompany,onUpdateFeed}){
  const [tab,setTab]=useState("about");
  const [postText,setPostText]=useState("");
  const isAdm=isAdmin(user);
  const staff=users.filter(u=>isStaff(u)&&u.status!=="pending");
  const activeTeams=(teams||[]).filter(t=>staff.some(u=>u.teamName===t.name));
  const activeProjects=projects.filter(p=>p.status!=="Archived"&&p.status!=="Completed");
  const completedProjects=projects.filter(p=>p.status==="Completed");

  const post=()=>{
    if(!postText.trim())return;
    onPostNews({author:user.id,text:postText.trim(),date:new Date().toISOString()});
    setPostText("");
  };

  const websiteUrl=companyInfo?.website?(companyInfo.website.startsWith("http")?companyInfo.website:`https://${companyInfo.website}`):null;

  return <div style={{maxWidth:1200,padding:"24px 32px 60px"}}>
    {/* ── Cover + bordered header ─────────────────────────────── */}
    <div style={{borderRadius:12,overflow:"hidden",boxShadow:"var(--shadow-xs)"}}>
      {/* Cover */}
      <div style={{height:240,background:companyInfo?.banner?`url(${companyInfo.banner}) center/cover`:`linear-gradient(135deg, #2a201a 0%, #4a3326 50%, var(--a-500) 100%)`,position:"relative",overflow:"hidden"}}>
        {!companyInfo?.banner&&<div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(255,255,255,.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.07) 1px, transparent 1px)",backgroundSize:"32px 32px",maskImage:"linear-gradient(180deg, black 30%, transparent 100%)",WebkitMaskImage:"linear-gradient(180deg, black 30%, transparent 100%)"}}/>}
        {isAdm&&<button onClick={onEditCompany} style={{position:"absolute",top:12,right:12,background:"rgba(0,0,0,0.4)",color:"#fff",backdropFilter:"blur(8px)",WebkitBackdropFilter:"blur(8px)",border:"1px solid rgba(255,255,255,0.18)",borderRadius:999,padding:"6px 12px",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"}}>✎ Edit cover</button>}
      </div>

      {/* Header body */}
      <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderTop:"none",borderRadius:"0 0 12px 12px",padding:"0 28px 22px",position:"relative"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",flexWrap:"wrap",gap:16}}>
          {/* Logo */}
          <div style={{width:132,height:132,marginTop:-68,borderRadius:14,border:"4px solid var(--surface)",background:"#fff",boxShadow:"0 4px 18px -4px rgba(20,15,10,0.25)",display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"}}>
            {companyInfo?.logo?<img src={companyInfo.logo} alt={companyInfo.name||company?.name} style={{maxWidth:"80%",maxHeight:"80%",objectFit:"contain"}}/>:<div style={{fontSize:48}}>🏢</div>}
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:6}}>
            {isAdm&&<button style={{...S.btnO,padding:"0 14px",height:32,fontSize:12,display:"inline-flex",alignItems:"center",gap:6}} onClick={onEditCompany}>✎ Edit company</button>}
            {websiteUrl&&<a href={websiteUrl} target="_blank" rel="noopener noreferrer" style={{...S.btn,padding:"0 14px",height:32,fontSize:12,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6}}>🌐 Visit site</a>}
          </div>
        </div>

        {/* Name + tagline + meta */}
        <h1 style={{fontSize:28,fontWeight:700,letterSpacing:"-0.02em",margin:"16px 0 4px",lineHeight:1.2}}>{companyInfo?.name||company?.name||"Your Company"}</h1>
        {companyInfo?.tagline&&<div style={{fontSize:15,color:"var(--text)",marginBottom:6,lineHeight:1.5,maxWidth:640}}>{companyInfo.tagline}</div>}
        <div style={{display:"flex",gap:14,flexWrap:"wrap",alignItems:"center",fontSize:13,color:"var(--text-3)",marginBottom:14}}>
          {companyInfo?.industry&&<span>{companyInfo.industry}</span>}
          {companyInfo?.location&&<span>{companyInfo.location}</span>}
          {companyInfo?.size&&<span>{companyInfo.size}</span>}
          {companyInfo?.founded&&<span>Founded {companyInfo.founded}</span>}
        </div>

        {/* Stats strip */}
        <div className="stats-strip stats-strip--4" style={{paddingTop:14,marginTop:14,borderTop:"1px solid var(--divider)",marginBottom:0}}>
          <div className="stat">
            <div className="stat__label">Employees</div>
            <div className="stat__value u-num">{staff.length}</div>
          </div>
          <div className="stat">
            <div className="stat__label">Teams</div>
            <div className="stat__value u-num">{activeTeams.length}</div>
          </div>
          <div className="stat">
            <div className="stat__label">Active</div>
            <div className="stat__value u-num" style={{color:"var(--blue-500)"}}>{activeProjects.length}</div>
          </div>
          <div className="stat">
            <div className="stat__label">Posts</div>
            <div className="stat__value u-num">{(newsFeed||[]).length}</div>
          </div>
        </div>
      </div>
    </div>

    {/* ── Tabs ─────────────────────────────────────────────────── */}
    <div style={{display:"flex",gap:0,marginTop:24,marginBottom:20,borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none"}}>
      {[["about","About",null],["employees","People",staff.length||null],["teams","Teams",activeTeams.length||null],["projects","Projects",projects.length||null],["posts","Posts",(newsFeed||[]).length||null]].map(([k,l,badge])=>{
        const active=tab===k;
        return <button key={k} onClick={()=>setTab(k)} style={{padding:"12px 16px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"var(--font-sans)",fontSize:13,fontWeight:active?600:500,color:active?"var(--text)":"var(--text-3)",borderBottom:active?"2px solid var(--a-500)":"2px solid transparent",letterSpacing:"-0.005em",transition:"color .12s, border-color .12s",whiteSpace:"nowrap",display:"inline-flex",alignItems:"center",gap:6,marginBottom:-1}}>
          {l}
          {badge&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{badge}</span>}
        </button>;
      })}
    </div>

    {/* About tab */}
    {tab==="about"&&<div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:20}}>
      <div style={S.card}>
        <div style={S.cardH}><span style={S.cardT}>About</span></div>
        <div style={S.cardB}>
          {companyInfo?.about?<div style={{fontSize:14,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{companyInfo.about}</div>:
            <div style={{fontSize:13,color:"var(--text-3)",padding:"20px 0"}}>
              No description added yet.{isAdm&&" Click 'Edit company' to tell people about your company."}
            </div>}
        </div>
      </div>

      <div style={S.card}>
        <div style={S.cardH}><span style={S.cardT}>Overview</span></div>
        <div style={S.cardB}>
          <div style={{display:"grid",gap:12}}>
            {companyInfo?.industry&&<div><div style={{fontSize:11,color:C.textDim,fontWeight:600,textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>Industry</div><div style={{fontSize:13}}>{companyInfo.industry}</div></div>}
            {companyInfo?.size&&<div><div style={{fontSize:11,color:C.textDim,fontWeight:600,textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>Company Size</div><div style={{fontSize:13}}>{companyInfo.size}</div></div>}
            {companyInfo?.location&&<div><div style={{fontSize:11,color:C.textDim,fontWeight:600,textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>Headquarters</div><div style={{fontSize:13}}>{companyInfo.location}</div></div>}
            {companyInfo?.founded&&<div><div style={{fontSize:11,color:C.textDim,fontWeight:600,textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>Founded</div><div style={{fontSize:13}}>{companyInfo.founded}</div></div>}
            {websiteUrl&&<div><div style={{fontSize:11,color:C.textDim,fontWeight:600,textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>Website</div><a href={websiteUrl} target="_blank" rel="noopener noreferrer" style={{color:C.accent,textDecoration:"none",fontSize:13,wordBreak:"break-all"}}>{companyInfo.website}</a></div>}
            {!companyInfo?.industry&&!companyInfo?.size&&!companyInfo?.location&&!companyInfo?.founded&&!websiteUrl&&<div style={{fontSize:12,color:C.textDim,fontStyle:"italic"}}>No details added yet.</div>}
          </div>
        </div>
      </div>
    </div>}

    {/* Employees */}
    {tab==="employees"&&<div>
      {(()=>{
        // Group by team
        const noTeam=staff.filter(u=>!u.teamName);
        const byTeam={};
        staff.forEach(u=>{if(u.teamName){if(!byTeam[u.teamName])byTeam[u.teamName]=[];byTeam[u.teamName].push(u)}});
        return <>
          {Object.keys(byTeam).sort().map(teamName=><div key={teamName} style={{marginBottom:24}}>
            <div style={{fontSize:13,fontWeight:700,color:C.textMid,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>{teamName} ({byTeam[teamName].length})</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:12}}>
              {byTeam[teamName].map(u=><div key={u.id} onClick={()=>onOpenUser(u.id)} style={{...S.card,padding:14,cursor:"pointer",transition:"transform .12s, box-shadow .15s",display:"flex",gap:12,alignItems:"center"}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 18px rgba(0,0,0,.08)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none"}}>
                <div style={{...S.avatar,width:50,height:50,fontSize:14,background:u.profileColor||C.grad2,flexShrink:0}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:14,fontWeight:700,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{u.name}</div>
                  <div style={{fontSize:11,color:C.textMid,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{u.role}</div>
                  {u.email&&<div style={{fontSize:10,color:C.textDim,marginTop:2,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{u.email}</div>}
                </div>
              </div>)}
            </div>
          </div>)}
          {noTeam.length>0&&<div style={{marginBottom:24}}>
            <div style={{fontSize:13,fontWeight:700,color:C.textDim,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Unassigned ({noTeam.length})</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:12}}>
              {noTeam.map(u=><div key={u.id} onClick={()=>onOpenUser(u.id)} style={{...S.card,padding:14,cursor:"pointer",display:"flex",gap:12,alignItems:"center"}}>
                <div style={{...S.avatar,width:50,height:50,fontSize:14,background:u.profileColor||C.grad2,flexShrink:0}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:14,fontWeight:700}}>{u.name}</div>
                  <div style={{fontSize:11,color:C.textMid}}>{u.role}</div>
                </div>
              </div>)}
            </div>
          </div>}
          {staff.length===0&&<div style={{padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>No employees yet.</div>}
        </>;
      })()}
    </div>}

    {/* Teams */}
    {tab==="teams"&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
      {activeTeams.map(t=>{
        const members=staff.filter(u=>u.teamName===t.name);
        const teamProjects=projects.filter(p=>members.some(m=>(p.team||[]).includes(m.id)));
        return <div key={t.id} style={S.card}>
          <div style={{padding:"14px 16px",borderBottom:`1px solid ${C.border}`,background:`linear-gradient(135deg, ${C.accentSoft} 0%, transparent 100%)`}}>
            <div style={{fontSize:16,fontWeight:700,fontFamily:"'Inter',sans-serif"}}>🏢 {t.name}</div>
            <div style={{fontSize:11,color:C.textDim,marginTop:2}}>{members.length} member{members.length!==1?"s":""} · {teamProjects.length} project{teamProjects.length!==1?"s":""}</div>
          </div>
          <div style={{padding:"12px 16px"}}>
            <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
              {members.slice(0,8).map(u=><div key={u.id} onClick={()=>onOpenUser(u.id)} title={u.name+" · "+u.role} style={{...S.avatar,width:30,height:30,fontSize:10,background:u.profileColor||C.grad2,cursor:"pointer"}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>)}
              {members.length>8&&<div style={{...S.avatar,width:30,height:30,fontSize:10,background:C.card,color:C.textMid}}>+{members.length-8}</div>}
            </div>
            {teamProjects.length>0&&<div style={{fontSize:11,color:C.textDim,paddingTop:8,borderTop:`1px solid ${C.border}`}}>{teamProjects.slice(0,3).map(p=>p.number||p.name).join(" · ")}{teamProjects.length>3?` +${teamProjects.length-3} more`:""}</div>}
          </div>
        </div>;
      })}
      {activeTeams.length===0&&<div style={{gridColumn:"1/-1",padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>No teams yet. Admins can create teams in the Admin panel.</div>}
    </div>}

    {/* Projects */}
    {tab==="projects"&&<div>
      {activeProjects.length>0&&<>
        <div style={{fontSize:13,fontWeight:700,color:C.textMid,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Active ({activeProjects.length})</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14,marginBottom:24}}>
          {activeProjects.map(p=>{
            const teamMembers=staff.filter(u=>(p.team||[]).includes(u.id));
            return <div key={p.id} onClick={()=>onOpenProject(p.id)} style={{...S.card,cursor:"pointer",transition:"transform .12s, box-shadow .15s"}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 18px rgba(0,0,0,.08)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none"}}>
              <div style={{padding:"14px 16px",borderBottom:`1px solid ${C.border}`}}>
                <div style={{fontSize:11,color:C.textDim,marginBottom:3,fontFamily:"monospace",fontWeight:600}}>{p.number}</div>
                <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>{p.name}</div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  <Badge bg={C.accentSoft} fg={C.accent}>{p.status}</Badge>
                  <Badge bg={C.card} fg={C.textMid}>{p.phase}</Badge>
                </div>
              </div>
              <div style={{padding:"10px 16px"}}>
                <PBar value={p.progress||0} height={6} showLabel={false}/>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:C.textDim,marginTop:6}}>
                  <span>{p.progress||0}% complete</span>
                  <span>{teamMembers.length} on team</span>
                </div>
                {teamMembers.length>0&&<div style={{display:"flex",gap:4,marginTop:8}}>
                  {teamMembers.slice(0,5).map(u=><div key={u.id} title={u.name} style={{...S.avatar,width:22,height:22,fontSize:8,background:u.profileColor||C.grad2}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>)}
                  {teamMembers.length>5&&<div style={{...S.avatar,width:22,height:22,fontSize:8,background:C.card,color:C.textMid}}>+{teamMembers.length-5}</div>}
                </div>}
              </div>
            </div>;
          })}
        </div>
      </>}
      {completedProjects.length>0&&<>
        <div style={{fontSize:13,fontWeight:700,color:C.textMid,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Completed ({completedProjects.length})</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
          {completedProjects.map(p=><div key={p.id} onClick={()=>onOpenProject(p.id)} style={{...S.card,cursor:"pointer",opacity:.85}}>
            <div style={{padding:"14px 16px"}}>
              <div style={{fontSize:11,color:C.textDim,marginBottom:3,fontFamily:"monospace"}}>{p.number}</div>
              <div style={{fontSize:14,fontWeight:700,marginBottom:6}}>{p.name}</div>
              <Badge bg={C.greenSoft} fg={C.green}>✓ Completed</Badge>
            </div>
          </div>)}
        </div>
      </>}
      {projects.length===0&&<div style={{padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>No projects yet.</div>}
    </div>}

    {/* Posts feed */}
    {tab==="posts"&&<div style={{maxWidth:680}}>
      {/* Compose */}
      <div style={{...S.card,padding:14,marginBottom:16}}>
        <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
          <div style={{...S.avatar,width:40,height:40,fontSize:13,background:user.profileColor||C.grad2,flexShrink:0}}>{user.profilePhoto?<img src={user.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:user.avatar}</div>
          <div style={{flex:1}}>
            <textarea style={{...S.textarea,minHeight:60,fontSize:13}} value={postText} onChange={e=>setPostText(e.target.value)} placeholder={`Share an update with ${companyInfo?.name||"the team"}…`} maxLength={500}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
              <span style={{fontSize:11,color:C.textDim}}>{postText.length}/500</span>
              <button style={{...S.btn,padding:"6px 16px",fontSize:12,opacity:postText.trim()?1:.4}} onClick={post} disabled={!postText.trim()}>Post</button>
            </div>
          </div>
        </div>
      </div>

      {/* Feed */}
      {(newsFeed||[]).length===0?<div style={{...S.card,padding:40,textAlign:"center",color:C.textDim,fontSize:13}}>No posts yet. Be the first to share an update!</div>:
      [...(newsFeed||[])].sort((a,b)=>new Date(b.date)-new Date(a.date)).map((post,i)=>{
        const author=users.find(u=>u.id===post.author);
        const when=(()=>{try{const d=new Date(post.date);const today=new Date();const dayDiff=Math.floor((today-d)/864e5);if(dayDiff===0){const minDiff=Math.floor((today-d)/60000);if(minDiff<60)return minDiff<=1?"just now":`${minDiff}m ago`;return `${Math.floor(minDiff/60)}h ago`}if(dayDiff===1)return "Yesterday";if(dayDiff<7)return `${dayDiff}d ago`;return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:dayDiff>365?"numeric":undefined})}catch{return ""}})();
        const isMyPost=post.author===user.id;
        return <div key={i} style={{...S.card,padding:16,marginBottom:14}}>
          <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
            <div onClick={()=>author&&onOpenUser(author.id)} style={{...S.avatar,width:40,height:40,fontSize:13,background:author?.profileColor||C.grad2,flexShrink:0,cursor:author?"pointer":"default"}}>{author?.profilePhoto?<img src={author.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:(author?.avatar||'?')}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2,flexWrap:"wrap"}}>
                <strong style={{fontSize:14,cursor:author?"pointer":"default"}} onClick={()=>author&&onOpenUser(author.id)}>{author?.name||"Unknown"}</strong>
                {author&&<RoleBadge role={author.role}/>}
                <span style={{fontSize:11,color:C.textDim}}>· {when}</span>
              </div>
              <div style={{fontSize:14,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{post.text}</div>
            </div>
            {(isMyPost||isAdm)&&<button onClick={()=>{if(confirm("Delete this post?"))onUpdateFeed((newsFeed||[]).filter((_,idx)=>idx!==i))}} style={{background:"none",border:"none",color:C.textDim,cursor:"pointer",fontSize:14,padding:4}} title="Delete">×</button>}
          </div>
        </div>;
      })}
    </div>}
  </div>;
}

function Sidebar({user,page,collapsed,onNavigate,onShowSettings,onShowMessages,dmUnread,visibilityState,companyInfo,company,users,actionItems,onLogout,activePortfolioView,mobile}){
  const isAdm=isAdmin(user);
  const isFin=isFinance(user);
  const isPMUser=isPM(user);

  // Count action items pending this week for me
  const thisWeekKey=getWeekStart(new Date()).toISOString().split("T")[0];
  const myActionsThisWeek=Object.values(actionItems||{}).flat().filter(a=>!a.done&&a.assignee===user.id).length;

  // Workspace section — primary navigation (ordered to match design)
  const workspaceItems=isFin?[
    {id:"portfolio",label:"Portfolio",icon:"⊞"},
  ]:[
    {id:"portfolio",label:"Portfolio",icon:"⊞"},
    {id:"meeting",label:"My Team",icon:"👥"},
    {id:"cad",label:"CAD Team",icon:"📐"},
    {id:"actions",label:"Action Items",icon:"✓",badge:myActionsThisWeek},
    {id:"deliverables",label:"Deliverables",icon:"📅"},
  ];

  // Admin section
  const adminItems=[
    {id:"profile",label:"Profile",icon:"👤"},
  ];

  // Network section (kept for non-finance)
  const networkItems=isFin?[]:[
    {id:"discover",label:"Discover",icon:"🌐"},
  ];

  const isActive=(id)=>{
    if(id==="profile")return page==="profile";
    if(id==="portfolio")return page==="portfolio"&&(activePortfolioView==="dashboard"||activePortfolioView==null||(!["actions","deliverables"].includes(activePortfolioView)));
    if(id==="actions")return page==="portfolio"&&activePortfolioView==="actions";
    if(id==="deliverables")return page==="portfolio"&&activePortfolioView==="deliverables";
    if(id==="portfolio")return page==="portfolio"||page==="project";
    return page===id;
  };

  // Workspace switcher card (top)
  const WorkspaceCard=()=>{
    const memberCount=(users||[]).filter(u=>isStaff(u)&&u.status!=="pending").length;
    const initials=(companyInfo?.name||company?.name||"OM").split(/\s+/).map(s=>s[0]).filter(Boolean).slice(0,2).join("").toUpperCase()||"OM";
    if(collapsed){
      return <div style={{margin:"4px 0 12px",display:"flex",justifyContent:"center"}}>
        <div style={{width:36,height:36,borderRadius:8,background:companyInfo?.logo?"transparent":"linear-gradient(135deg, var(--a-400), var(--a-600))",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:11,letterSpacing:"0.02em",overflow:"hidden"}}>
          {companyInfo?.logo?<img src={companyInfo.logo} alt={companyInfo.name||"Company"} style={{width:"100%",height:"100%",objectFit:"cover"}}/>:initials}
        </div>
      </div>;
    }
    return <button onClick={()=>onNavigate("company")} style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:8,cursor:"pointer",margin:"4px 0 14px",fontFamily:"var(--font-sans)",textAlign:"left",transition:"border-color .12s, background .12s"}} onMouseEnter={e=>{e.currentTarget.style.borderColor="var(--border-strong)"}} onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--border)"}}>
      <div style={{width:28,height:28,borderRadius:6,background:companyInfo?.logo?"transparent":"linear-gradient(135deg, var(--a-400), var(--a-600))",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:10,letterSpacing:"0.02em",overflow:"hidden",flexShrink:0}}>
        {companyInfo?.logo?<img src={companyInfo.logo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:initials}
      </div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",lineHeight:1.2}}>{companyInfo?.name||company?.name||"Workspace"}</div>
        <div style={{fontSize:11,color:"var(--text-3)",marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{(companyInfo?.industry||"Engineering")} · {memberCount} member{memberCount!==1?"s":""}</div>
      </div>
      <span style={{color:"var(--text-3)",fontSize:11,flexShrink:0}}>▾</span>
    </button>;
  };

  const renderBtn=(item)=>{
    const active=isActive(item.id);
    return <button key={item.id} onClick={()=>onNavigate(item.id)} style={{
      display:"flex",alignItems:"center",gap:10,
      width:"100%",padding:collapsed?"9px 0":"7px 10px",
      background:active?"var(--a-50)":"transparent",
      border:"1px solid transparent",
      borderRadius:8,fontSize:13,
      fontWeight:active?600:500,
      color:active?"var(--a-700)":"var(--text-2)",
      cursor:"pointer",fontFamily:"var(--font-sans)",
      textAlign:"left",justifyContent:collapsed?"center":"flex-start",
      transition:"background .12s, color .12s",
      letterSpacing:"-0.005em",marginBottom:1
    }} onMouseEnter={e=>{if(!active)e.currentTarget.style.background="var(--n-50)"}} onMouseLeave={e=>{if(!active)e.currentTarget.style.background="transparent"}} title={collapsed?item.label:""}>
      <span style={{fontSize:14,width:16,textAlign:"center",flexShrink:0,color:active?"var(--a-600)":"var(--text-3)"}}>{item.icon}</span>
      {!collapsed&&<span style={{flex:1}}>{item.label}</span>}
      {!collapsed&&item.badge>0&&<span style={{background:active?"var(--a-500)":"var(--n-100)",color:active?"#fff":"var(--text-2)",fontSize:10,fontWeight:600,padding:"1px 7px",borderRadius:999,fontVariantNumeric:"tabular-nums"}}>{item.badge}</span>}
    </button>;
  };

  // User pill at bottom
  const UserPill=()=>{
    if(collapsed){
      return <div style={{padding:"10px 0",borderTop:"1px solid var(--border)",display:"flex",justifyContent:"center"}}>
        <div style={{...S.avatar,width:32,height:32,fontSize:11,background:user.profilePhoto?"transparent":(user.profileColor||C.grad2),flexShrink:0}}>{user.profilePhoto?<img src={user.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}</div>
      </div>;
    }
    return <div style={{padding:"10px 8px",borderTop:"1px solid var(--border)",display:"flex",alignItems:"center",gap:10,marginTop:"auto"}}>
      <div style={{...S.avatar,width:32,height:32,fontSize:11,background:user.profilePhoto?"transparent":(user.profileColor||C.grad2),flexShrink:0}}>{user.profilePhoto?<img src={user.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}</div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--text)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",lineHeight:1.2}}>{user.name}</div>
        <div style={{fontSize:11,color:"var(--text-3)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginTop:1}}>{user.role}</div>
      </div>
      <button onClick={onShowSettings} title="Settings" style={{background:"none",border:"none",color:"var(--text-3)",fontSize:14,cursor:"pointer",padding:6,borderRadius:6,fontFamily:"var(--font-sans)",transition:"background .12s, color .12s"}} onMouseEnter={e=>{e.currentTarget.style.background="var(--n-50)";e.currentTarget.style.color="var(--text)"}} onMouseLeave={e=>{e.currentTarget.style.background="transparent";e.currentTarget.style.color="var(--text-3)"}}>⚙</button>
    </div>;
  };

  return <div style={{...(collapsed?S.sidebarCollapsed:S.sidebar),...(mobile?{position:"static",top:"auto",height:"100%",minHeight:"100dvh",width:"min(300px,84vw)"}:{}),display:"flex",flexDirection:"column"}}>
    {/* Top: workspace switcher card */}
    <WorkspaceCard/>

    {/* Workspace section */}
    <div style={{flex:1,minHeight:0,overflowY:"auto"}}>
      {!collapsed&&<div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.1em",color:"var(--text-4)",padding:"4px 10px 6px"}}>Workspace</div>}
      {workspaceItems.map(renderBtn)}

      {/* Admin section */}
      {adminItems.length>0&&<>
        {!collapsed&&<div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.1em",color:"var(--text-4)",padding:"14px 10px 6px"}}>Admin</div>}
        {collapsed&&<div style={{height:1,background:"var(--border)",margin:"10px 4px"}}/>}
        {adminItems.map(renderBtn)}
      </>}

      {/* Network section */}
      {networkItems.length>0&&<>
        {!collapsed&&<div style={{fontSize:10,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.1em",color:"var(--text-4)",padding:"14px 10px 6px"}}>Network</div>}
        {collapsed&&<div style={{height:1,background:"var(--border)",margin:"10px 4px"}}/>}
        {networkItems.map(renderBtn)}

        {/* Messages */}
        <button onClick={onShowMessages} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:collapsed?"9px 0":"7px 10px",background:"transparent",border:"1px solid transparent",borderRadius:8,fontSize:13,fontWeight:500,color:"var(--text-2)",cursor:"pointer",fontFamily:"var(--font-sans)",textAlign:"left",justifyContent:collapsed?"center":"flex-start",transition:"background .12s",letterSpacing:"-0.005em",marginBottom:1}} onMouseEnter={e=>e.currentTarget.style.background="var(--n-50)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"} title={collapsed?"Messages":""}>
          <span style={{fontSize:14,width:16,textAlign:"center",position:"relative",color:"var(--text-3)",flexShrink:0}}>💬{dmUnread>0&&<span style={{position:"absolute",top:-4,right:-8,background:"var(--red-500)",color:"#fff",borderRadius:8,fontSize:8,fontWeight:700,minWidth:14,height:14,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 3px"}}>{dmUnread>9?"9+":dmUnread}</span>}</span>
          {!collapsed&&<span style={{flex:1}}>Messages</span>}
          {!collapsed&&dmUnread>0&&<span style={{background:"var(--red-500)",color:"#fff",borderRadius:999,fontSize:10,fontWeight:600,padding:"1px 7px"}}>{dmUnread}</span>}
        </button>
      </>}
    </div>

    {/* Bottom: user pill */}
    <UserPill/>
  </div>;
}

// ══════════════════════════════════════════════════════════════
// ISSUES — Linear-style tracked work items with comments + multi-assignees + AI agents
// ══════════════════════════════════════════════════════════════
const ISSUE_STATUSES=[
  {id:"backlog",label:"Backlog",icon:"○",color:"#6B7280"},
  {id:"todo",label:"Todo",icon:"○",color:"#94A3B8"},
  {id:"in_progress",label:"In Progress",icon:"◐",color:"#F2A93B"},
  {id:"in_review",label:"In Review",icon:"◑",color:"#5E6AD2"},
  {id:"done",label:"Done",icon:"●",color:"#26B47E"},
  {id:"cancelled",label:"Cancelled",icon:"⊗",color:"#6B7280"},
];
const ISSUE_PRIORITIES=[
  {id:"urgent",label:"Urgent",icon:"🚨",bars:4,color:"#EB5757"},
  {id:"high",label:"High",icon:"▰▰▰▱",bars:3,color:"#F2A93B"},
  {id:"medium",label:"Medium",icon:"▰▰▱▱",bars:2,color:"#5E6AD2"},
  {id:"low",label:"Low",icon:"▰▱▱▱",bars:1,color:"#6B7280"},
  {id:"none",label:"No priority",icon:"▱▱▱▱",bars:0,color:"#6B7280"},
];
const ISSUE_LABELS=["Bug","Feature","Improvement","Performance","Bug Fix","Frontend","Backend","Design","Documentation"];
const AI_AGENTS=[
  {id:"claude",label:"Claude",icon:"🧠",color:"#D97757"},
  {id:"cursor",label:"Cursor",icon:"⌨",color:"#5E6AD2"},
  {id:"copilot",label:"Copilot",icon:"🤖",color:"#26B47E"},
];

function getIssueStatus(id){return ISSUE_STATUSES.find(s=>s.id===id)||ISSUE_STATUSES[1]}
function getIssuePriority(id){return ISSUE_PRIORITIES.find(p=>p.id===id)||ISSUE_PRIORITIES[4]}

function IssuePriorityIcon({priority,size=12}){
  const pr=getIssuePriority(priority);
  // Linear-style 4-bar priority indicator
  return <div style={{display:"inline-flex",alignItems:"flex-end",gap:1.5,height:size,verticalAlign:"middle"}} title={pr.label}>
    {[0,1,2,3].map(i=><div key={i} style={{width:2.5,height:i<pr.bars?(size*(0.35+i*0.22)):2,background:i<pr.bars?pr.color:"currentColor",opacity:i<pr.bars?1:0.2,borderRadius:1}}/>)}
  </div>;
}
function IssueStatusIcon({status,size=14}){
  const st=getIssueStatus(status);
  return <span style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:size,height:size,fontSize:size,color:st.color,verticalAlign:"middle",fontWeight:700}} title={st.label}>{st.icon}</span>;
}

function IssuesView({user,users,projects,issues,setIssues,onOpenIssue,defaultProjectId}){
  const [tab,setTab]=useState("my");
  const [filterPriority,setFilterPriority]=useState("");
  const [filterLabel,setFilterLabel]=useState("");
  const [searchQ,setSearchQ]=useState("");
  const [showCreate,setShowCreate]=useState(false);

  const allIssues=issues||[];
  const tabIssues=(()=>{
    if(tab==="my")return allIssues.filter(i=>(i.assignees||[]).includes(user.id));
    if(tab==="created")return allIssues.filter(i=>i.createdBy===user.id);
    if(tab==="active")return allIssues.filter(i=>i.status!=="done"&&i.status!=="cancelled");
    return allIssues;
  })();
  const filtered=tabIssues.filter(i=>{
    if(filterPriority&&i.priority!==filterPriority)return false;
    if(filterLabel&&!(i.labels||[]).includes(filterLabel))return false;
    if(searchQ){const q=searchQ.toLowerCase();return(i.title||"").toLowerCase().includes(q)||(i.description||"").toLowerCase().includes(q)||(i.number||"").toLowerCase().includes(q)}
    return true;
  });

  // Group by status (Linear-style)
  const grouped={};
  ISSUE_STATUSES.forEach(s=>{grouped[s.id]=filtered.filter(i=>i.status===s.id)});

  const fmtDate=(iso)=>{try{const d=new Date(iso);return d.toLocaleDateString([],{month:"short",day:"numeric"})}catch{return ""}};

  return <div>
    {/* Header */}
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:18,gap:12,flexWrap:"wrap"}}>
      <div>
        <div style={{fontFamily:"'Inter',sans-serif",fontSize:24,fontWeight:700,marginBottom:2}}>🎯 Issues</div>
        <div style={{fontSize:12,color:C.textMid}}>Tracked work items. Assign to humans + AI agents, discuss in threads, ship faster.</div>
      </div>
      <button style={{...S.btn,padding:"8px 16px",fontSize:12}} onClick={()=>setShowCreate(true)}>+ New Issue</button>
    </div>

    {/* Tabs (Linear style) */}
    <div style={{display:"flex",gap:0,borderBottom:`1px solid ${C.border}`,marginBottom:14,flexWrap:"wrap"}}>
      {[["my","My Issues"],["created","Created"],["active","Active"],["all","All"]].map(([k,l])=>{
        const active=tab===k;
        const count=({"my":allIssues.filter(i=>(i.assignees||[]).includes(user.id)).length,"created":allIssues.filter(i=>i.createdBy===user.id).length,"active":allIssues.filter(i=>i.status!=="done"&&i.status!=="cancelled").length,"all":allIssues.length})[k];
        return <button key={k} style={{padding:"10px 18px",border:"none",borderBottom:active?`2px solid ${C.text}`:"2px solid transparent",background:"transparent",color:active?C.text:C.textMid,fontWeight:active?700:500,fontSize:13,cursor:"pointer",fontFamily:"'Inter',sans-serif",marginBottom:-1}} onClick={()=>setTab(k)}>
          {l}<span style={{marginLeft:6,fontSize:11,color:C.textDim,fontWeight:500}}>{count}</span>
        </button>;
      })}
    </div>

    {/* Filters */}
    <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
      <input style={{...S.input,fontSize:12,padding:"6px 12px",width:240,background:C.card}} placeholder="Search issues..." value={searchQ} onChange={e=>setSearchQ(e.target.value)}/>
      <select style={{...S.select,fontSize:12,padding:"6px 10px",width:140,background:C.card}} value={filterPriority} onChange={e=>setFilterPriority(e.target.value)}>
        <option value="">All priorities</option>
        {ISSUE_PRIORITIES.map(p=><option key={p.id} value={p.id}>{p.label}</option>)}
      </select>
      <select style={{...S.select,fontSize:12,padding:"6px 10px",width:140,background:C.card}} value={filterLabel} onChange={e=>setFilterLabel(e.target.value)}>
        <option value="">All labels</option>
        {ISSUE_LABELS.map(l=><option key={l} value={l}>{l}</option>)}
      </select>
      {(filterPriority||filterLabel||searchQ)&&<button style={{...S.btnO,padding:"6px 10px",fontSize:11}} onClick={()=>{setFilterPriority("");setFilterLabel("");setSearchQ("")}}>× Clear</button>}
      <div style={{flex:1}}/>
      <span style={{fontSize:11,color:C.textDim}}>{filtered.length} {filtered.length===1?"issue":"issues"}</span>
    </div>

    {/* Issues grouped by status */}
    {filtered.length===0?<div style={{...S.card,padding:60,textAlign:"center"}}>
      <div style={{fontSize:36,marginBottom:8,opacity:0.4}}>🎯</div>
      <div style={{fontSize:14,fontWeight:600,marginBottom:4}}>No issues here yet</div>
      <div style={{fontSize:12,color:C.textDim,marginBottom:16}}>{tab==="my"?"Issues assigned to you will appear here.":tab==="created"?"Issues you create will appear here.":"Click '+ New Issue' to create one."}</div>
      <button style={{...S.btn,padding:"8px 16px",fontSize:12}} onClick={()=>setShowCreate(true)}>+ Create Issue</button>
    </div>:ISSUE_STATUSES.map(status=>{
      const list=grouped[status.id];
      if(list.length===0)return null;
      return <div key={status.id} style={{marginBottom:18}}>
        <div style={{display:"flex",alignItems:"center",gap:8,padding:"6px 4px",fontSize:11,fontWeight:700,color:C.textMid,textTransform:"uppercase",letterSpacing:1}}>
          <IssueStatusIcon status={status.id}/>
          <span>{status.label}</span>
          <span style={{color:C.textDim,fontSize:11}}>{list.length}</span>
        </div>
        <div style={{borderTop:`1px solid ${C.border}`}}>
          {list.map(iss=>{
            const project=iss.projectId?projects.find(p=>p.id===iss.projectId):null;
            const assigneeUsers=(iss.assignees||[]).map(uid=>users.find(u=>u.id===uid)).filter(Boolean);
            const agents=(iss.aiAgents||[]).map(aid=>AI_AGENTS.find(a=>a.id===aid)).filter(Boolean);
            return <div key={iss.id} onClick={()=>onOpenIssue(iss.id)} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",transition:"background .12s"}} onMouseEnter={e=>e.currentTarget.style.background=C.card} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <IssuePriorityIcon priority={iss.priority||"none"}/>
              <span style={{fontSize:11,color:C.textDim,fontFamily:"'SF Mono',Menlo,monospace",fontWeight:500,minWidth:70}}>{iss.number||"ISS-?"}</span>
              <IssueStatusIcon status={iss.status||"todo"}/>
              <span style={{flex:1,fontSize:13,fontWeight:500,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{iss.title||"(untitled)"}</span>
              {project&&<Badge bg={C.card} fg={C.textMid}>📁 {project.number||project.name}</Badge>}
              {(iss.labels||[]).slice(0,2).map(l=><Badge key={l} bg={C.accentSoft} fg={C.accent}>{l}</Badge>)}
              {agents.length>0&&<div style={{display:"flex",gap:2}}>{agents.map(a=><span key={a.id} title={`AI agent: ${a.label}`} style={{fontSize:13,opacity:0.85}}>{a.icon}</span>)}</div>}
              {assigneeUsers.length>0&&<div style={{display:"flex",gap:-4}}>
                {assigneeUsers.slice(0,3).map((u,i)=><div key={u.id} title={u.name} style={{...S.avatar,width:22,height:22,fontSize:8,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),marginLeft:i>0?-6:0,border:`2px solid ${C.bg}`,overflow:"hidden"}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>)}
                {assigneeUsers.length>3&&<div style={{...S.avatar,width:22,height:22,fontSize:8,background:C.card,color:C.textMid,marginLeft:-6,border:`2px solid ${C.bg}`}}>+{assigneeUsers.length-3}</div>}
              </div>}
              <span style={{fontSize:11,color:C.textDim,minWidth:48,textAlign:"right"}}>{fmtDate(iss.createdAt)}</span>
            </div>;
          })}
        </div>
      </div>;
    })}

    {showCreate&&<IssueCreateModal user={user} users={users} projects={projects} issues={issues} setIssues={setIssues} defaultProjectId={defaultProjectId} onClose={()=>setShowCreate(false)}/>}
  </div>;
}

function IssueCreateModal({user,users,projects,issues,setIssues,onClose,defaultProjectId}){
  const [title,setTitle]=useState("");
  const [description,setDescription]=useState("");
  const [priority,setPriority]=useState("medium");
  const [status,setStatus]=useState("todo");
  const [labels,setLabels]=useState([]);
  const [assignees,setAssignees]=useState([user.id]);
  const [aiAgents,setAiAgents]=useState([]);
  const [projectId,setProjectId]=useState(defaultProjectId||"");
  const staffUsers=users.filter(u=>isStaff(u)&&u.status!=="pending");
  const toggleArr=(arr,v,setter)=>{setter(arr.includes(v)?arr.filter(x=>x!==v):[...arr,v])};
  const create=()=>{
    if(!title.trim())return;
    const num=`ISS-${String((issues||[]).length+1).padStart(3,"0")}`;
    const newIss={
      id:genId("iss"),
      number:num,
      title:title.trim(),
      description:description.trim(),
      status,priority,
      labels,
      assignees,
      aiAgents,
      projectId:projectId||null,
      createdBy:user.id,
      createdAt:new Date().toISOString(),
      comments:[],
    };
    setIssues(prev=>[newIss,...(prev||[])]);
    onClose();
  };
  return <Modal title="🎯 New Issue" onClose={onClose} footer={<><button style={S.btnO} onClick={onClose}>Cancel</button><button style={{...S.btn,opacity:title.trim()?1:.4}} onClick={create} disabled={!title.trim()}>Create Issue</button></>}>
    <div style={S.inputGroup}>
      <label style={S.label}>Title</label>
      <input style={{...S.input,fontSize:14}} autoFocus value={title} onChange={e=>setTitle(e.target.value)} placeholder="What needs to be done?"/>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Description (optional)</label>
      <textarea style={{...S.textarea,minHeight:80}} value={description} onChange={e=>setDescription(e.target.value)} placeholder="Add more context, steps to reproduce, acceptance criteria..."/>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <div style={S.inputGroup}>
        <label style={S.label}>Status</label>
        <select style={S.select} value={status} onChange={e=>setStatus(e.target.value)}>{ISSUE_STATUSES.map(s=><option key={s.id} value={s.id}>{s.label}</option>)}</select>
      </div>
      <div style={S.inputGroup}>
        <label style={S.label}>Priority</label>
        <select style={S.select} value={priority} onChange={e=>setPriority(e.target.value)}>{ISSUE_PRIORITIES.map(p=><option key={p.id} value={p.id}>{p.label}</option>)}</select>
      </div>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Project (optional)</label>
      <select style={S.select} value={projectId} onChange={e=>setProjectId(e.target.value)}>
        <option value="">No project</option>
        {projects.map(p=><option key={p.id} value={p.id}>{p.number} · {p.name}</option>)}
      </select>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Labels</label>
      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
        {ISSUE_LABELS.map(l=>{
          const on=labels.includes(l);
          return <button key={l} type="button" onClick={()=>toggleArr(labels,l,setLabels)} style={{padding:"4px 10px",borderRadius:14,fontSize:11,fontWeight:600,border:`1px solid ${on?C.accent:C.border}`,background:on?C.accentSoft:"transparent",color:on?C.accent:C.textMid,cursor:"pointer"}}>{l}</button>;
        })}
      </div>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>Assignees ({assignees.length})</label>
      <div style={{display:"flex",flexWrap:"wrap",gap:6,maxHeight:120,overflowY:"auto",padding:6,background:C.card,borderRadius:8}}>
        {staffUsers.map(u=>{
          const on=assignees.includes(u.id);
          return <button key={u.id} type="button" onClick={()=>toggleArr(assignees,u.id,setAssignees)} style={{display:"flex",alignItems:"center",gap:6,padding:"4px 8px",borderRadius:14,fontSize:11,fontWeight:600,border:`1px solid ${on?C.accent:C.border}`,background:on?C.accentSoft:"transparent",color:on?C.accent:C.textMid,cursor:"pointer"}}>
            <div style={{...S.avatar,width:18,height:18,fontSize:8,background:u.profileColor||C.grad2}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
            {u.name}
          </button>;
        })}
      </div>
    </div>
    <div style={S.inputGroup}>
      <label style={S.label}>🤖 AI Agents (optional)</label>
      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
        {AI_AGENTS.map(a=>{
          const on=aiAgents.includes(a.id);
          return <button key={a.id} type="button" onClick={()=>toggleArr(aiAgents,a.id,setAiAgents)} style={{padding:"6px 12px",borderRadius:14,fontSize:11,fontWeight:600,border:`1px solid ${on?a.color:C.border}`,background:on?`${a.color}1A`:"transparent",color:on?a.color:C.textMid,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
            <span>{a.icon}</span>{a.label}
          </button>;
        })}
      </div>
      <div style={{fontSize:10,color:C.textDim,marginTop:6}}>AI agents can read the issue and post suggestions in comments. Real agent integration coming next session — for now this just tags the issue.</div>
    </div>
  </Modal>;
}

function IssueDetailModal({issueId,issues,setIssues,users,projects,user,onClose}){
  const issue=(issues||[]).find(i=>i.id===issueId);
  const [draft,setDraft]=useState("");
  const [editingTitle,setEditingTitle]=useState(false);
  const [editTitleDraft,setEditTitleDraft]=useState(issue?.title||"");
  if(!issue)return <Modal title="Issue not found" onClose={onClose} footer={<button style={S.btn} onClick={onClose}>Close</button>}><div style={{padding:20,textAlign:"center",color:C.textDim}}>This issue may have been deleted.</div></Modal>;
  const project=issue.projectId?projects.find(p=>p.id===issue.projectId):null;
  const assigneeUsers=(issue.assignees||[]).map(uid=>users.find(u=>u.id===uid)).filter(Boolean);
  const agents=(issue.aiAgents||[]).map(aid=>AI_AGENTS.find(a=>a.id===aid)).filter(Boolean);
  const creator=users.find(u=>u.id===issue.createdBy);

  const update=(patch)=>{setIssues(prev=>prev.map(i=>i.id===issue.id?{...i,...patch}:i))};
  const addComment=()=>{
    if(!draft.trim())return;
    const c={id:genId("c"),author:user.id,authorType:"user",text:draft.trim(),sentAt:new Date().toISOString()};
    update({comments:[...(issue.comments||[]),c]});
    setDraft("");
  };
  const remove=()=>{
    if(!confirm("Delete this issue? This cannot be undone."))return;
    setIssues(prev=>prev.filter(i=>i.id!==issue.id));
    onClose();
  };
  const fmtTime=(iso)=>{try{const d=new Date(iso);const now=new Date();const diff=Math.floor((now-d)/1000);if(diff<60)return "just now";if(diff<3600)return `${Math.floor(diff/60)}m ago`;if(diff<86400)return `${Math.floor(diff/3600)}h ago`;if(diff<604800)return `${Math.floor(diff/86400)}d ago`;return d.toLocaleDateString([],{month:"short",day:"numeric"})}catch{return ""}};

  const canEdit=issue.createdBy===user.id||(issue.assignees||[]).includes(user.id)||isAdmin(user);

  return <Modal title="" onClose={onClose} footer={<>
    {canEdit&&<button style={{...S.btnO,color:C.red,borderColor:C.red,padding:"6px 12px",fontSize:11}} onClick={remove}>Delete</button>}
    <div style={{flex:1}}/>
    <button style={S.btnO} onClick={onClose}>Close</button>
  </>}>
    <div style={{padding:0,marginBottom:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10,fontSize:12,color:C.textDim}}>
        <span style={{fontFamily:"'SF Mono',Menlo,monospace",fontWeight:600}}>{issue.number}</span>
        <span>·</span>
        <span>by {creator?.name||"Unknown"}</span>
        <span>·</span>
        <span>{fmtTime(issue.createdAt)}</span>
      </div>
      {editingTitle?<div style={{display:"flex",gap:6,marginBottom:10}}>
        <input autoFocus style={{...S.input,fontSize:18,fontWeight:700,fontFamily:"'Inter',sans-serif"}} value={editTitleDraft} onChange={e=>setEditTitleDraft(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){update({title:editTitleDraft.trim()||issue.title});setEditingTitle(false)}else if(e.key==="Escape"){setEditingTitle(false);setEditTitleDraft(issue.title)}}}/>
        <button style={S.btn} onClick={()=>{update({title:editTitleDraft.trim()||issue.title});setEditingTitle(false)}}>Save</button>
      </div>:<div style={{fontFamily:"'Inter',sans-serif",fontSize:22,fontWeight:700,marginBottom:10,cursor:canEdit?"pointer":"default"}} onClick={()=>{if(canEdit){setEditTitleDraft(issue.title);setEditingTitle(true)}}}>{issue.title}</div>}
    </div>

    {/* Properties row */}
    <div style={{...S.card,padding:"12px 14px",marginBottom:14,display:"grid",gridTemplateColumns:"100px 1fr",rowGap:10,columnGap:14,fontSize:12}}>
      <div style={{color:C.textDim,fontWeight:600}}>Status</div>
      <div><select style={{...S.select,padding:"4px 8px",fontSize:12,width:160}} value={issue.status||"todo"} onChange={e=>update({status:e.target.value})} disabled={!canEdit}>{ISSUE_STATUSES.map(s=><option key={s.id} value={s.id}>{s.icon} {s.label}</option>)}</select></div>

      <div style={{color:C.textDim,fontWeight:600}}>Priority</div>
      <div><select style={{...S.select,padding:"4px 8px",fontSize:12,width:160}} value={issue.priority||"none"} onChange={e=>update({priority:e.target.value})} disabled={!canEdit}>{ISSUE_PRIORITIES.map(p=><option key={p.id} value={p.id}>{p.label}</option>)}</select></div>

      {project&&<>
        <div style={{color:C.textDim,fontWeight:600}}>Project</div>
        <div><Badge bg={C.card} fg={C.textMid}>📁 {project.number} · {project.name}</Badge></div>
      </>}

      {(issue.labels||[]).length>0&&<>
        <div style={{color:C.textDim,fontWeight:600}}>Labels</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:4}}>{(issue.labels||[]).map(l=><Badge key={l} bg={C.accentSoft} fg={C.accent}>{l}</Badge>)}</div>
      </>}

      <div style={{color:C.textDim,fontWeight:600}}>Assignees</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
        {assigneeUsers.length>0?assigneeUsers.map(u=><div key={u.id} style={{display:"flex",alignItems:"center",gap:4,padding:"3px 8px",borderRadius:12,background:C.card,fontSize:11}}>
          <div style={{...S.avatar,width:18,height:18,fontSize:8,background:u.profileColor||C.grad2}}>{u.profilePhoto?<img src={u.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.avatar}</div>
          <span>{u.name}</span>
        </div>):<span style={{color:C.textDim,fontStyle:"italic"}}>None</span>}
      </div>

      {agents.length>0&&<>
        <div style={{color:C.textDim,fontWeight:600}}>🤖 Agents</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:4}}>{agents.map(a=><span key={a.id} style={{display:"flex",alignItems:"center",gap:4,padding:"3px 8px",borderRadius:12,background:`${a.color}1A`,color:a.color,fontSize:11,fontWeight:600}}>{a.icon} {a.label}</span>)}</div>
      </>}
    </div>

    {/* Description */}
    {issue.description&&<div style={{marginBottom:18}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>Description</div>
      <div style={{...S.card,padding:"10px 12px",fontSize:13,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{issue.description}</div>
    </div>}

    {/* Activity / comments */}
    <div style={{marginBottom:14}}>
      <div style={{fontSize:11,color:C.textDim,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Activity ({(issue.comments||[]).length})</div>
      {(issue.comments||[]).length===0?<div style={{padding:"12px",fontSize:12,color:C.textDim,fontStyle:"italic"}}>No comments yet. Start the discussion below.</div>:
      (issue.comments||[]).map(c=>{
        const author=users.find(u=>u.id===c.author);
        const isAgent=c.authorType==="agent";
        return <div key={c.id} style={{display:"flex",gap:10,padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
          <div style={{...S.avatar,width:30,height:30,fontSize:11,background:isAgent?"#D97757":(author?.profileColor||C.grad2),flexShrink:0}}>{isAgent?"🤖":(author?.avatar||"?")}</div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:12,marginBottom:3}}><strong>{isAgent?(c.agentName||"AI Agent"):(author?.name||"Unknown")}</strong>{isAgent&&<Badge bg={C.purpleSoft} fg={C.purple}>AI</Badge>} <span style={{color:C.textDim,fontSize:11}}>· {fmtTime(c.sentAt)}</span></div>
            <div style={{fontSize:13,lineHeight:1.5,whiteSpace:"pre-wrap"}}>{c.text}</div>
          </div>
        </div>;
      })}
    </div>

    {/* Comment composer */}
    <div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
      <textarea style={{...S.textarea,flex:1,minHeight:60,fontSize:13,resize:"vertical"}} value={draft} onChange={e=>setDraft(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&(e.metaKey||e.ctrlKey)){e.preventDefault();addComment()}}} placeholder="Leave a comment..."/>
      <button style={{...S.btn,padding:"10px 16px",fontSize:13,opacity:draft.trim()?1:.4}} onClick={addComment} disabled={!draft.trim()}>Comment</button>
    </div>
    <div style={{fontSize:10,color:C.textDim,marginTop:4}}>⌘/Ctrl+Enter to submit</div>
  </Modal>;
}


function MessagesModal({user,users,publicProfiles,dmThreads,activeDmThread,onLoadThreads,onOpenThread,onSendDm,onClose,onUpdateThread,onBackToList}){
  const mbIsMobile=useIsMobile();
  const [draft,setDraft]=useState("");
  const [showEmojiPicker,setShowEmojiPicker]=useState(null); // message id
  const messagesEndRef=useRef(null);

  // Resolve a user by ID — check internal workspace users first, then public profiles
  const resolveUser=(uid)=>{
    const internal=(users||[]).find(u=>u.id===uid);
    if(internal)return{name:internal.name,avatar:internal.avatar,profileColor:internal.profileColor,profilePhoto:internal.profilePhoto,role:internal.role,companyName:null};
    const pub=(publicProfiles||[]).find(p=>p.userId===uid);
    if(pub)return{name:pub.name,avatar:pub.avatar,profileColor:pub.profileColor,profilePhoto:pub.profilePhoto,role:pub.role,companyName:pub.companyName};
    return null;
  };

  const otherUser=activeDmThread?resolveUser(activeDmThread.otherUserId):null;

  // Rich time formatting
  const fmtTime=(iso)=>{try{const d=new Date(iso);const now=new Date();const day=Math.floor((now-d)/864e5);if(day===0)return d.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"});if(day===1)return "Yesterday "+d.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"});if(day<7)return d.toLocaleDateString([],{weekday:"short"})+" "+d.toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"});return d.toLocaleDateString([],{month:"short",day:"numeric",year:"numeric"})}catch{return ""}};
  const fmtDate=(iso)=>{try{const d=new Date(iso);const now=new Date();const day=Math.floor((now-d)/864e5);if(day===0)return "Today";if(day===1)return "Yesterday";if(day<7)return d.toLocaleDateString([],{weekday:"long"});return d.toLocaleDateString([],{month:"long",day:"numeric",year:"numeric"})}catch{return ""}};
  const sameDay=(a,b)=>{try{const da=new Date(a);const db=new Date(b);return da.getFullYear()===db.getFullYear()&&da.getMonth()===db.getMonth()&&da.getDate()===db.getDate()}catch{return false}};

  const EMOJI_REACTIONS=["❤️","👍","😂","😮","😢","🔥","👏","✅"];

  const addReaction=(msgId,emoji)=>{
    if(!activeDmThread||!onUpdateThread)return;
    const updated=(activeDmThread.messages||[]).map(m=>{
      if((m.id||"")!==msgId)return m;
      const reactions=m.reactions||{};
      const existingUsers=reactions[emoji]||[];
      const hasReacted=existingUsers.includes(user.id);
      return{...m,reactions:{...reactions,[emoji]:hasReacted?existingUsers.filter(uid=>uid!==user.id):[...existingUsers,user.id]}};
    });
    onUpdateThread({...activeDmThread,messages:updated});
    setShowEmojiPicker(null);
  };

  const send=()=>{if(!draft.trim())return;onSendDm(draft.trim());setDraft("")};

  // Auto-scroll to bottom when messages update
  useEffect(()=>{messagesEndRef.current?.scrollIntoView({behavior:"smooth"})},[activeDmThread?.messages?.length]);

  return <div style={S.overlay} onClick={onClose}>
    <div data-wb-modal="1" style={{...S.modal,width:"min(900px,100%)",maxWidth:"96vw",height:"84vh",maxHeight:700,display:"flex",flexDirection:"column"}} onClick={e=>e.stopPropagation()}>

      {/* Header */}
      <div style={{padding:"14px 18px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
        <div style={{fontSize:18,fontWeight:700}}>💬 Messages</div>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:22,color:C.textDim,cursor:"pointer",padding:0,lineHeight:1}}>×</button>
      </div>
      <div style={{...S.banner(C.greenSoft,C.green),margin:"10px 18px 0",fontSize:11}}>🔒 <strong>Private:</strong> Only you and the recipient can read these messages in WorkBro.</div>

      <div style={{flex:1,minHeight:0,display:"flex",overflow:"hidden"}}>

        {/* Thread list — on mobile it takes the full width and hides while a conversation is open */}
        {(!mbIsMobile||!activeDmThread)&&<div style={{width:mbIsMobile?"100%":260,borderRight:mbIsMobile?"none":`1px solid ${C.border}`,overflowY:"auto",flexShrink:0}}>
          {(dmThreads||[]).length===0
            ?<div style={{padding:30,textAlign:"center",color:C.textDim,fontSize:12,lineHeight:1.6}}>No conversations yet.<br/><br/>Open someone's profile in <strong>Discover</strong> and click "Send Message".</div>
            :(dmThreads||[]).map(t=>{
              const other=resolveUser(t.otherUserId);
              const isActive=activeDmThread?.otherUserId===t.otherUserId;
              return <div key={t.threadId} onClick={()=>onOpenThread(t.otherUserId)}
                style={{padding:"12px 14px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",background:isActive?C.accentSoft:"transparent",display:"flex",gap:10,alignItems:"center",transition:"background .1s"}}
                onMouseEnter={e=>{if(!isActive)e.currentTarget.style.background=C.card}}
                onMouseLeave={e=>{if(!isActive)e.currentTarget.style.background="transparent"}}>
                <div style={{...S.avatar,width:38,height:38,fontSize:12,background:other?.profilePhoto?"transparent":(other?.profileColor||C.grad2),flexShrink:0}}>
                  {other?.profilePhoto?<img src={other.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(other?.avatar||"?")}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:4,marginBottom:2}}>
                    <div style={{fontSize:13,fontWeight:t.unread>0?700:600,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{other?.name||"Unknown"}</div>
                    <span style={{fontSize:10,color:C.textDim,flexShrink:0,whiteSpace:"nowrap"}}>{fmtTime(t.lastMessageAt)}</span>
                  </div>
                  <div style={{fontSize:11,color:t.unread>0?C.text:C.textDim,fontWeight:t.unread>0?600:400,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{t.lastMessage||"No messages yet"}</div>
                </div>
                {t.unread>0&&<span style={{background:C.red,color:C.white,borderRadius:10,fontSize:9,fontWeight:700,padding:"2px 6px",flexShrink:0}}>{t.unread}</span>}
              </div>;
            })}
        </div>}

        {/* Conversation pane — on mobile only shows while a thread is open */}
        {(!mbIsMobile||activeDmThread)&&<div style={{flex:1,minWidth:0,display:"flex",flexDirection:"column"}}>
          {!activeDmThread
            ?<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:C.textDim,fontSize:13,padding:30,textAlign:"center"}}>
              {(dmThreads||[]).length>0?"← Select a conversation":"Start a conversation from someone's profile in Discover"}
            </div>
            :<>
              {/* Conversation header */}
              <div style={{padding:"12px 16px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:10,background:C.card}}>
                {mbIsMobile&&<button onClick={()=>onBackToList&&onBackToList()} style={{background:"none",border:"none",fontSize:20,color:"var(--a-500)",cursor:"pointer",padding:"0 4px 0 0",fontWeight:700}} title="Back to conversations">‹</button>}
                <div style={{...S.avatar,width:34,height:34,fontSize:12,background:otherUser?.profilePhoto?"transparent":(otherUser?.profileColor||C.grad2),flexShrink:0}}>
                  {otherUser?.profilePhoto?<img src={otherUser.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(otherUser?.avatar||"?")}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:14,fontWeight:700}}>{otherUser?.name||"Unknown User"}</div>
                  <div style={{fontSize:11,color:C.textDim}}>{[otherUser?.role,otherUser?.companyName].filter(Boolean).join(" · ")||"WorkBro user"}</div>
                </div>
              </div>

              {/* Messages */}
              <div style={{flex:1,overflowY:"auto",padding:"12px 16px",display:"flex",flexDirection:"column",gap:2,background:C.bg}}>
                {(activeDmThread.messages||[]).length===0
                  ?<div style={{margin:"auto",color:C.textDim,fontSize:12,fontStyle:"italic"}}>Send your first message below.</div>
                  :(activeDmThread.messages||[]).map((m,idx)=>{
                    const fromMe=m.from===user.id;
                    const prevMsg=(activeDmThread.messages||[])[idx-1];
                    const showDateSep=!prevMsg||!sameDay(prevMsg.sentAt,m.sentAt);
                    const reactions=m.reactions||{};
                    const reactionEntries=Object.entries(reactions).filter(([,users])=>users.length>0);
                    const isPickerOpen=showEmojiPicker===(m.id||idx);

                    return <div key={m.id||idx}>
                      {/* Date separator */}
                      {showDateSep&&<div style={{display:"flex",alignItems:"center",gap:10,margin:"14px 0 10px"}}>
                        <div style={{flex:1,height:1,background:C.border}}/>
                        <div style={{fontSize:11,color:C.textDim,fontWeight:600,whiteSpace:"nowrap",padding:"2px 10px",background:C.bg}}>{fmtDate(m.sentAt)}</div>
                        <div style={{flex:1,height:1,background:C.border}}/>
                      </div>}

                      {/* Message bubble */}
                      <div style={{display:"flex",justifyContent:fromMe?"flex-end":"flex-start",marginBottom:reactionEntries.length>0?6:2,position:"relative"}}
                        onMouseEnter={e=>{const btn=e.currentTarget.querySelector(".react-btn");if(btn)btn.style.opacity="1"}}
                        onMouseLeave={e=>{const btn=e.currentTarget.querySelector(".react-btn");if(btn&&!isPickerOpen)btn.style.opacity="0"}}>
                        <div style={{maxWidth:"74%"}}>
                          <div style={{padding:"9px 13px",borderRadius:fromMe?"16px 16px 4px 16px":"16px 16px 16px 4px",background:fromMe?C.accent:C.surface,color:fromMe?C.white:C.text,border:fromMe?"none":`1px solid ${C.border}`,fontSize:13,lineHeight:1.55,whiteSpace:"pre-wrap",wordBreak:"break-word"}}>
                            {m.text}
                            <div style={{fontSize:10,color:fromMe?"rgba(255,255,255,.6)":C.textDim,marginTop:4,fontWeight:500,fontVariantNumeric:"tabular-nums"}}>{fmtTime(m.sentAt)}</div>
                          </div>

                          {/* Reactions row */}
                          {reactionEntries.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4,justifyContent:fromMe?"flex-end":"flex-start"}}>
                            {reactionEntries.map(([emoji,reactors])=>{
                              const iMine=reactors.includes(user.id);
                              return <button key={emoji} onClick={()=>addReaction(m.id||String(idx),emoji)}
                                style={{display:"flex",alignItems:"center",gap:3,padding:"2px 7px",borderRadius:12,border:`1px solid ${iMine?C.accent:C.border}`,background:iMine?C.accentSoft:C.surface,cursor:"pointer",fontSize:12,color:iMine?C.accent:C.text,fontWeight:iMine?700:500}}>
                                {emoji}<span style={{fontSize:11}}>{reactors.length}</span>
                              </button>;
                            })}
                          </div>}
                        </div>

                        {/* Hover react button */}
                        <button className="react-btn" onClick={()=>setShowEmojiPicker(isPickerOpen?null:(m.id||idx))}
                          style={{alignSelf:"center",margin:fromMe?"0 6px 0 0":"0 0 0 6px",order:fromMe?-1:1,opacity:0,transition:"opacity .15s",background:"none",border:`1px solid ${C.border}`,borderRadius:8,cursor:"pointer",padding:"3px 6px",fontSize:14,color:C.textDim,lineHeight:1,flexShrink:0}}>
                          😊
                        </button>

                        {/* Emoji picker popup */}
                        {isPickerOpen&&<div style={{position:"absolute",bottom:"calc(100% + 6px)",right:fromMe?0:undefined,left:fromMe?undefined:0,zIndex:20,background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:"8px 10px",display:"flex",gap:4,boxShadow:`0 6px 20px rgba(0,0,0,.18)`,flexWrap:"wrap",maxWidth:220}}>
                          {EMOJI_REACTIONS.map(e=><button key={e} onClick={()=>addReaction(m.id||String(idx),e)}
                            style={{fontSize:20,background:"none",border:"none",cursor:"pointer",padding:"4px 6px",borderRadius:8,lineHeight:1,transition:"transform .1s"}}
                            onMouseEnter={ev=>ev.currentTarget.style.transform="scale(1.25)"}
                            onMouseLeave={ev=>ev.currentTarget.style.transform="scale(1)"}>{e}</button>)}
                        </div>}
                      </div>
                    </div>;
                  })}
                <div ref={messagesEndRef}/>
              </div>

              {/* Composer */}
              <div style={{padding:12,borderTop:`1px solid ${C.border}`,background:C.surface}}>
                <div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
                  <textarea style={{...S.textarea,flex:1,minHeight:40,maxHeight:120,fontSize:13,resize:"none"}} value={draft} onChange={e=>setDraft(e.target.value)}
                    onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send()}}}
                    placeholder={`Message ${otherUser?.name||"…"}`} maxLength={2000}/>
                  <button style={{...S.btn,padding:"10px 18px",fontSize:13,opacity:draft.trim()?1:.4}} onClick={send} disabled={!draft.trim()}>Send</button>
                </div>
                <div style={{fontSize:10,color:C.textDim,marginTop:4}}>Enter to send · Shift+Enter for new line · Hover a message to react</div>
              </div>
            </>}
        </div>}
      </div>
    </div>
  </div>;
}


// ══════════════════════════════════════════════════════════════
// MOBILE APP — Full mobile-native shell (phones < 768px)
// Shares all state/data/actions from the parent App component.
// Bottom tab navigation, full-screen cards, touch-friendly targets.
// ══════════════════════════════════════════════════════════════
const MB={
  // Mobile-specific style constants
  wrap:{minHeight:"100vh",background:"var(--bg)",color:"var(--text)",fontFamily:"var(--font-sans)",paddingBottom:80,WebkitTapHighlightColor:"transparent"},
  topbar:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 18px 10px",background:"var(--surface)",borderBottom:"1px solid var(--border)",position:"sticky",top:0,zIndex:50,WebkitBackdropFilter:"blur(12px)",backdropFilter:"blur(12px)"},
  title:{fontSize:18,fontWeight:700,letterSpacing:"-0.03em",fontFamily:"var(--font-display)"},
  tabBar:{position:"fixed",bottom:0,left:0,right:0,background:"var(--surface)",borderTop:"1px solid var(--border)",display:"flex",zIndex:50,paddingBottom:"env(safe-area-inset-bottom,0px)"},
  tabBtn:(a)=>({flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"10px 0 8px",border:"none",background:"none",color:a?"var(--a-500)":"var(--text-3)",cursor:"pointer",fontSize:10,fontWeight:a?700:500,fontFamily:"var(--font-sans)",gap:3,transition:"color .12s",WebkitTapHighlightColor:"transparent"}),
  tabIcon:{fontSize:22,lineHeight:1},
  card:{background:"var(--surface)",borderRadius:14,border:"1px solid var(--border)",boxShadow:"var(--shadow-xs)",overflow:"hidden",marginBottom:12},
  cardHead:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",borderBottom:"1px solid var(--divider)"},
  cardTitle:{fontSize:15,fontWeight:700,letterSpacing:"-0.02em"},
  section:{padding:"16px 16px 6px"},
  sectionTitle:{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",color:"var(--text-3)",marginBottom:10},
  row:{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",borderBottom:"1px solid var(--divider)",cursor:"pointer",WebkitTapHighlightColor:"transparent"},
  rowLast:{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",cursor:"pointer"},
  stat:{flex:1,background:"var(--surface)",borderRadius:12,border:"1px solid var(--border)",padding:"14px 16px",textAlign:"center"},
  statVal:{fontSize:28,fontWeight:700,letterSpacing:"-0.04em",fontFamily:"var(--font-display)",fontVariantNumeric:"tabular-nums"},
  statLbl:{fontSize:11,color:"var(--text-3)",marginTop:4,fontWeight:500,textTransform:"uppercase",letterSpacing:"0.06em"},
  btn:{display:"flex",alignItems:"center",justifyContent:"center",gap:6,height:44,paddingLeft:18,paddingRight:18,background:"var(--a-500)",color:"var(--text-on-accent)",border:"1px solid var(--a-600)",borderRadius:10,fontSize:15,fontWeight:600,cursor:"pointer",fontFamily:"var(--font-sans)",WebkitTapHighlightColor:"transparent"},
  btnO:{display:"flex",alignItems:"center",justifyContent:"center",gap:6,height:44,paddingLeft:18,paddingRight:18,background:"var(--surface)",color:"var(--text)",border:"1px solid var(--border-strong)",borderRadius:10,fontSize:15,fontWeight:500,cursor:"pointer",fontFamily:"var(--font-sans)"},
  input:{width:"100%",height:44,padding:"0 14px",background:"var(--surface)",border:"1px solid var(--border-strong)",borderRadius:10,color:"var(--text)",fontSize:15,outline:"none",boxSizing:"border-box",fontFamily:"var(--font-sans)"},
  back:{display:"flex",alignItems:"center",gap:6,color:"var(--a-500)",fontSize:15,fontWeight:600,cursor:"pointer",border:"none",background:"none",fontFamily:"var(--font-sans)",padding:"0 0 0 0"},
};

function MobileApp({user,users,projects,timesheets,setTimesheets,newsFeed,postNews,updateProfile,setDarkMode,darkMode,notifications,setNotifications,companyInfo,company,actionItems,onUpdateActions,publicPosts,publicProfiles,openDmThread,setModal,activeDmThread,dmThreads,issues,setIssues,teams,onUpdateProject,addDeadline,vacations,setVacations,events,setEvents,logout,onSwitchToFull}){
  const [tab,setTab]=useState("home");
  const [activeProject,setActiveProject]=useState(null);
  const [viewingUserId,setViewingUserId]=useState(null);
  const [globalSearch,setGlobalSearch]=useState("");
  const [showSearch,setShowSearch]=useState(false);

  const myProjects=projects.filter(p=>(p.team||[]).includes(user.id));
  const activeProjects=myProjects.filter(p=>p.status!=="Archived"&&p.status!=="Completed");
  const unreadNotifs=(notifications||[]).filter(n=>!n.read).length;

  const fmtTime=(iso)=>{try{const d=new Date(iso);const now=new Date();const diff=Math.floor((now-d)/1000);if(diff<60)return"just now";if(diff<3600)return`${Math.floor(diff/60)}m`;if(diff<86400)return`${Math.floor(diff/3600)}h`;return d.toLocaleDateString([],{month:"short",day:"numeric"})}catch{return""}};

  const EMOJI_REACTIONS=["❤️","👍","😂","😮","😢","🔥","👏","✅"];

  // ── GLOBAL SEARCH ─────────────────────────────────────────────
  const SearchOverlay=()=>{
    const q=globalSearch.toLowerCase();
    if(!q)return null;
    const pResults=projects.filter(p=>p.name.toLowerCase().includes(q)||p.number.toLowerCase().includes(q)).slice(0,5);
    const uResults=users.filter(u=>u.name.toLowerCase().includes(q)).slice(0,4);
    return <div style={{position:"fixed",inset:0,zIndex:200,background:"var(--bg)",overflowY:"auto",paddingTop:60}}>
      <div style={{padding:"12px 16px"}}>
        {pResults.length>0&&<><div style={MB.sectionTitle}>Projects</div>
        {pResults.map(p=><div key={p.id} style={{...MB.card,marginBottom:8,cursor:"pointer"}} onClick={()=>{setActiveProject(p.id);setShowSearch(false);setGlobalSearch("");}}>
          <div style={{padding:"12px 14px"}}>
            <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)"}}>{p.number}</div>
            <div style={{fontSize:14,fontWeight:700}}>{p.name}</div>
          </div>
        </div>)}</>}
        {uResults.length>0&&<><div style={{...MB.sectionTitle,marginTop:12}}>People</div>
        {uResults.map(u=><div key={u.id} style={{...MB.card,marginBottom:8,cursor:"pointer"}} onClick={()=>{setViewingUserId(u.id);setTab("profile");setShowSearch(false);setGlobalSearch("");}}>
          <div style={{padding:"12px 14px",display:"flex",alignItems:"center",gap:10}}>
            <div style={{...S.avatar,width:36,height:36,fontSize:12,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2)}}>{u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}</div>
            <div><div style={{fontSize:14,fontWeight:700}}>{u.name}</div><div style={{fontSize:12,color:"var(--text-3)"}}>{u.role}</div></div>
          </div>
        </div>)}</>}
        {pResults.length===0&&uResults.length===0&&<div style={{textAlign:"center",padding:40,color:"var(--text-3)",fontSize:13}}>No results for "{globalSearch}"</div>}
      </div>
    </div>;
  };

  // ── HOME TAB ──────────────────────────────────────────────────
  const HomeTab=()=>{
    const totalFocus=myProjects.reduce((s,p)=>s+getUserFocus(p,user.id),0);
    const overdue=Object.values(actionItems||{}).flat().filter(a=>!a.done&&a.weekKey&&a.weekKey<getWeekStart(new Date()).toISOString().split("T")[0]).length;
    const photo=user.profilePhoto;
    return <div>
      <div style={{padding:"20px 18px 12px",display:"flex",alignItems:"center",gap:12}}>
        <div style={{...S.avatar,width:48,height:48,fontSize:16,background:photo?"transparent":(user.profileColor||C.grad2),flexShrink:0}}>
          {photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}
        </div>
        <div style={{flex:1}}>
          <div style={{fontSize:13,color:"var(--text-3)"}}>Good {new Date().getHours()<12?"morning":new Date().getHours()<17?"afternoon":"evening"},</div>
          <div style={{fontSize:20,fontWeight:700,letterSpacing:"-0.03em"}}>{user.name.split(" ")[0]} 👋</div>
        </div>
        <button onClick={()=>setDarkMode(d=>!d)} style={{width:40,height:40,borderRadius:10,border:"1px solid var(--border)",background:"var(--surface)",cursor:"pointer",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center"}}>{darkMode?"☀️":"🌙"}</button>
      </div>
      <div style={{display:"flex",gap:10,padding:"0 16px 16px"}}>
        <div style={MB.stat}><div style={{...MB.statVal,color:"var(--a-500)"}}>{activeProjects.length}</div><div style={MB.statLbl}>Active</div></div>
        <div style={MB.stat}><div style={{...MB.statVal,color:totalFocus>100?"var(--red-500)":totalFocus>0?"var(--green-500)":"var(--text-3)"}}>{totalFocus}%</div><div style={MB.statLbl}>Focus</div></div>
        <div style={{...MB.stat,cursor:"pointer"}} onClick={()=>setTab("notifs")}><div style={{...MB.statVal,color:overdue>0?"var(--red-500)":unreadNotifs>0?"var(--amber-500)":"var(--text-3)"}}>{overdue||unreadNotifs||0}</div><div style={MB.statLbl}>{overdue>0?"Past":"Notifs"}</div></div>
      </div>
      <div style={{padding:"0 16px"}}><div style={MB.sectionTitle}>Active Projects ({activeProjects.length})</div></div>
      {activeProjects.length===0?<div style={{...MB.card,margin:"0 16px",padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No active projects.</div>:
      activeProjects.slice(0,5).map(p=><div key={p.id} style={{...MB.card,margin:"0 16px",cursor:"pointer"}} onClick={()=>setActiveProject(p.id)}>
        <div style={{padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8,marginBottom:8}}>
            <div style={{flex:1}}>
              <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)",marginBottom:2}}>{p.number}</div>
              <div style={{fontSize:15,fontWeight:700,letterSpacing:"-0.02em",lineHeight:1.3}}>{p.name}</div>
            </div>
            <span style={{...S.tag("var(--a-50)","var(--a-500)"),flexShrink:0,marginTop:2}}>{p.status}</span>
          </div>
          <div style={{height:6,borderRadius:999,background:"var(--n-100)",overflow:"hidden",marginBottom:8}}>
            <div style={{height:"100%",width:`${p.progress||0}%`,background:"var(--a-500)",borderRadius:999}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"var(--text-3)"}}>
            <span>{p.phase}</span><span style={{fontVariantNumeric:"tabular-nums",fontWeight:600}}>{p.progress||0}%</span>
          </div>
        </div>
      </div>)}
      {myProjects.length>5&&<div style={{padding:"8px 16px 16px",textAlign:"center"}}>
        <button onClick={()=>setTab("projects")} style={{...MB.btnO,height:38,fontSize:13,width:"100%"}}>View all {myProjects.length} projects →</button>
      </div>}
      <div style={{padding:"16px 16px 6px"}}><div style={MB.sectionTitle}>Recent Activity</div></div>
      <div style={{...MB.card,margin:"0 16px 80px"}}>
        {(()=>{const acts=myProjects.flatMap(p=>(p.updates||[]).map(u=>({...u,projName:p.name,projNum:p.number}))).sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,5);
        if(acts.length===0)return <div style={{padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No recent activity.</div>;
        return acts.map((a,i)=>{const author=users.find(u=>u.id===a.author);return <div key={i} style={i<acts.length-1?MB.row:MB.rowLast}>
          <div style={{...S.avatar,width:32,height:32,fontSize:11,background:author?.profilePhoto?"transparent":(author?.profileColor||C.grad2),flexShrink:0}}>{author?.profilePhoto?<img src={author.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(author?.avatar||"?")}</div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:12,color:"var(--text-3)",marginBottom:2}}><span style={{fontFamily:"var(--font-mono)",fontWeight:600}}>{a.projNum}</span> · {a.projName}</div>
            <div style={{fontSize:13,lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>{a.text}</div>
          </div>
        </div>;});})()} 
      </div>
    </div>;
  };

  // ── PROJECTS TAB ─────────────────────────────────────────────
  const ProjectsTab=()=>{
    const [search,setSearch]=useState("");
    const filtered=myProjects.filter(p=>!search||p.name.toLowerCase().includes(search.toLowerCase())||p.number.toLowerCase().includes(search.toLowerCase()));
    return <div>
      <div style={{padding:"14px 16px 12px"}}>
        <input style={MB.input} placeholder="Search projects..." value={search} onChange={e=>setSearch(e.target.value)}/>
      </div>
      {filtered.map(p=><div key={p.id} style={{...MB.card,margin:"0 16px 8px",cursor:"pointer"}} onClick={()=>setActiveProject(p.id)}>
        <div style={{padding:"14px 16px"}}>
          <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8,marginBottom:8}}>
            <div style={{flex:1}}>
              <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)",marginBottom:3}}>{p.number}</div>
              <div style={{fontSize:15,fontWeight:700,letterSpacing:"-0.02em"}}>{p.name}</div>
              {p.client&&<div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>{p.client} · {p.location}</div>}
            </div>
            <span style={{...S.tag("var(--a-50)","var(--a-500)"),flexShrink:0}}>{p.status}</span>
          </div>
          <div style={{height:5,borderRadius:999,background:"var(--n-100)",overflow:"hidden",marginBottom:6}}>
            <div style={{height:"100%",width:`${p.progress||0}%`,background:"var(--a-500)",borderRadius:999}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"var(--text-3)"}}>
            <span>{p.phase} · {(p.team||[]).length} members</span>
            <span style={{fontVariantNumeric:"tabular-nums",fontWeight:600,color:"var(--a-500)"}}>{getUserFocus(p,user.id)>0?`${getUserFocus(p,user.id)}% focus`:""}</span>
          </div>
        </div>
      </div>)}
      {filtered.length===0&&<div style={{...MB.card,margin:"0 16px",padding:40,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No projects found.</div>}
      <div style={{height:80}}/>
    </div>;
  };

  // ── PROJECT DETAIL (mobile) — full featured ──────────────────
  const MobileProjectDetail=({projectId})=>{
    const p=projects.find(x=>x.id===projectId);
    if(!p)return null;
    const [detailTab,setDetailTab]=useState("info");
    const [replyText,setReplyText]=useState("");
    const [newActionText,setNewActionText]=useState("");
    const [progressVal,setProgressVal]=useState(p.progress||0);
    const teamMembers=users.filter(u=>(p.team||[]).includes(u.id));
    const openRFIs=(p.issues||[]).filter(i=>i.status!=="Closed").length;
    const myFocus=getUserFocus(p,user.id);
    const projActions=(actionItems?.[p.id]||[]).filter(a=>a.assignee===user.id||isAdmin(user)||isPM(user));
    const canEdit=isAdmin(user)||isPM(user);
    return <div style={{paddingBottom:40}}>
      {/* Back + title */}
      <div style={{...MB.topbar,gap:12}}>
        <button style={MB.back} onClick={()=>setActiveProject(null)}>‹ Back</button>
        <div style={{flex:1,textAlign:"center",fontSize:15,fontWeight:700,letterSpacing:"-0.02em",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
        <div style={{width:60}}/>
      </div>
      {/* Hero */}
      <div style={{...MB.card,margin:"14px 16px 0"}}>
        <div style={{padding:"16px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontSize:11,color:"var(--text-3)",fontFamily:"var(--font-mono)",fontWeight:600}}>{p.number}</div>
            <span style={{...S.tag("var(--a-50)","var(--a-500)")}}>{p.status}</span>
          </div>
          {canEdit&&<>
            <input type="range" min={0} max={100} value={progressVal} onChange={e=>setProgressVal(Number(e.target.value))} onMouseUp={()=>onUpdateProject&&onUpdateProject(p.id,{progress:progressVal})} onTouchEnd={()=>onUpdateProject&&onUpdateProject(p.id,{progress:progressVal})} style={{width:"100%",accentColor:"var(--a-500)",marginBottom:6}}/>
          </>}
          <div style={{height:8,borderRadius:999,background:"var(--n-100)",overflow:"hidden",marginBottom:10}}>
            <div style={{height:"100%",width:`${progressVal}%`,background:"var(--a-500)",borderRadius:999,transition:"width .4s"}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}>
            <span style={{color:"var(--text-3)"}}>{p.phase}</span>
            <span style={{fontWeight:700,color:"var(--a-500)",fontVariantNumeric:"tabular-nums"}}>{progressVal}%</span>
          </div>
        </div>
        <div style={{display:"flex",borderTop:"1px solid var(--divider)"}}>
          {[["👥",teamMembers.length,"Team"],["🔔",openRFIs,"RFIs"],["🎯",myFocus+"%","My Focus"]].map(([icon,val,lbl],i)=><div key={i} style={{flex:1,padding:"12px 8px",textAlign:"center",borderRight:i<2?"1px solid var(--divider)":"none"}}>
            <div style={{fontSize:16,marginBottom:2}}>{icon}</div>
            <div style={{fontSize:17,fontWeight:700,fontVariantNumeric:"tabular-nums"}}>{val}</div>
            <div style={{fontSize:10,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em"}}>{lbl}</div>
          </div>)}
        </div>
      </div>
      {/* Sub-tabs */}
      <div style={{display:"flex",borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none",WebkitOverflowScrolling:"touch",margin:"12px 0 0"}}>
        {[["info","Info"],["team","Team"],["actions","Actions"],["updates","Updates"],["rfis","RFIs"]].map(([k,l])=><button key={k} style={{padding:"9px 14px",border:"none",borderBottom:detailTab===k?"2px solid var(--a-500)":"2px solid transparent",background:"transparent",color:detailTab===k?"var(--text)":"var(--text-3)",fontWeight:detailTab===k?700:500,fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"var(--font-sans)"}} onClick={()=>setDetailTab(k)}>{l}</button>)}
      </div>

      {/* INFO TAB */}
      {detailTab==="info"&&<div style={{padding:"16px"}}>
        {p.client&&<div style={MB.card}><div style={{padding:"14px 16px"}}>
          <div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em",fontWeight:600,marginBottom:8}}>Project Info</div>
          {[["Client",p.client],["Location",p.location],["Type",p.type],["Phase",p.phase],["Status",p.status]].filter(([,v])=>v).map(([k,v])=><div key={k} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid var(--divider)",fontSize:14}}>
            <span style={{color:"var(--text-3)"}}>{k}</span><span style={{fontWeight:500,textAlign:"right",maxWidth:"60%"}}>{v}</span>
          </div>)}
        </div></div>}
        {canEdit&&onUpdateProject&&<div style={{marginTop:12}}>
          <div style={MB.sectionTitle}>Quick Actions</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {["In Progress","On Hold","Completed"].filter(s=>s!==p.status).map(s=><button key={s} onClick={()=>onUpdateProject(p.id,{status:s})} style={{...MB.btnO,flex:1,fontSize:12,height:38}}>{s}</button>)}
          </div>
        </div>}
        {p.description&&<div style={{...MB.card,marginTop:12}}><div style={{padding:"14px 16px"}}>
          <div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em",fontWeight:600,marginBottom:8}}>Description</div>
          <div style={{fontSize:14,lineHeight:1.6}}>{p.description}</div>
        </div></div>}
        {p.deadlines?.length>0&&<div style={{...MB.card,marginTop:12}}><div style={{padding:"14px 16px"}}>
          <div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em",fontWeight:600,marginBottom:8}}>Deadlines</div>
          {[...p.deadlines].sort((a,b)=>new Date(a.date)-new Date(b.date)).map((d,i)=>{const days=daysUntil(d.date);return <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid var(--divider)",fontSize:13}}>
            <span>{d.name}</span>
            <Badge bg={days<=0?C.redSoft:days<=7?C.amberSoft:C.accentSoft} fg={days<=0?C.red:days<=7?C.amber:C.accent}>{days<=0?"Past":days===0?"Today":`${days}d`}</Badge>
          </div>;})}
        </div></div>}
      </div>}

      {/* TEAM TAB */}
      {detailTab==="team"&&<div style={{padding:"16px"}}>
        <div style={MB.card}>
          {teamMembers.map((u,i)=><div key={u.id} style={i<teamMembers.length-1?MB.row:MB.rowLast} onClick={()=>{setViewingUserId(u.id);setActiveProject(null);setTab("profile")}}>
            <div style={{...S.avatar,width:40,height:40,fontSize:14,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),flexShrink:0}}>
              {u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:600}}>{u.name}</div>
              <div style={{fontSize:12,color:"var(--text-3)"}}>{u.role}{u.teamName?` · ${u.teamName}`:""}</div>
            </div>
            {getUserFocus(p,u.id)>0&&<div style={{fontSize:13,fontWeight:700,color:"var(--a-500)",fontVariantNumeric:"tabular-nums"}}>{getUserFocus(p,u.id)}%</div>}
          </div>)}
          {teamMembers.length===0&&<div style={{padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No team members assigned.</div>}
        </div>
      </div>}

      {/* ACTIONS TAB */}
      {detailTab==="actions"&&<div style={{padding:"16px"}}>
        <div style={{display:"flex",gap:8,marginBottom:14}}>
          <input style={{...MB.input,flex:1}} value={newActionText} onChange={e=>setNewActionText(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&newActionText.trim()){onUpdateActions&&onUpdateActions(p.id,[...(actionItems?.[p.id]||[]),{id:genId("act"),text:newActionText.trim(),done:false,assignee:user.id,weekKey:getWeekStart(new Date()).toISOString().split("T")[0],priority:"Medium",date:new Date().toISOString().split("T")[0]}]);setNewActionText("");}}} placeholder="Add action item..."/>
          <button style={{...MB.btn,height:44,padding:"0 16px",flexShrink:0}} onClick={()=>{if(newActionText.trim()){onUpdateActions&&onUpdateActions(p.id,[...(actionItems?.[p.id]||[]),{id:genId("act"),text:newActionText.trim(),done:false,assignee:user.id,weekKey:getWeekStart(new Date()).toISOString().split("T")[0],priority:"Medium",date:new Date().toISOString().split("T")[0]}]);setNewActionText("");}}}>+</button>
        </div>
        <div style={MB.card}>
          {projActions.length===0?<div style={{padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No action items. Add one above.</div>:
          projActions.sort((a,b)=>a.done===b.done?0:a.done?1:-1).map((a,i)=><div key={a.id} style={{padding:"12px 16px",borderBottom:i<projActions.length-1?"1px solid var(--divider)":"none",display:"flex",alignItems:"center",gap:10}}>
            <input type="checkbox" checked={!!a.done} onChange={()=>{const latest=actionItems[p.id]||[];onUpdateActions&&onUpdateActions(p.id,latest.map(x=>x.id===a.id?{...x,done:!x.done}:x));}} style={{accentColor:"var(--a-500)",width:18,height:18,flexShrink:0}}/>
            <div style={{flex:1,fontSize:14,textDecoration:a.done?"line-through":"none",color:a.done?"var(--text-3)":"var(--text)",lineHeight:1.4}}>{a.text}</div>
          </div>)}
        </div>
      </div>}

      {/* UPDATES TAB */}
      {detailTab==="updates"&&<div style={{padding:"16px"}}>
        {(isAdmin(user)||isPM(user)||isDesigner(user))&&<div style={{display:"flex",gap:8,marginBottom:14}}>
          <input style={{...MB.input,flex:1}} value={replyText} onChange={e=>setReplyText(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&replyText.trim()){onUpdateProject&&onUpdateProject(p.id,{updates:[{id:genId("upd"),author:user.id,text:replyText.trim(),date:new Date().toISOString().split("T")[0]},...(p.updates||[])]});setReplyText("");}}} placeholder="Post an update..."/>
          <button style={{...MB.btn,height:44,padding:"0 16px",flexShrink:0}} onClick={()=>{if(replyText.trim()){onUpdateProject&&onUpdateProject(p.id,{updates:[{id:genId("upd"),author:user.id,text:replyText.trim(),date:new Date().toISOString().split("T")[0]},...(p.updates||[])]});setReplyText("");}}}>Post</button>
        </div>}
        <div style={MB.card}>
          {(p.updates||[]).length===0?<div style={{padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No updates yet.</div>:
          [...(p.updates||[])].sort((a,b)=>new Date(b.date)-new Date(a.date)).map((u,i)=>{
            const author=users.find(x=>x.id===u.author);
            return <div key={i} style={{padding:"12px 16px",borderBottom:i<(p.updates||[]).length-1?"1px solid var(--divider)":"none",display:"flex",gap:10,alignItems:"flex-start"}}>
              <div style={{...S.avatar,width:32,height:32,fontSize:11,background:author?.profilePhoto?"transparent":(author?.profileColor||C.grad2),flexShrink:0}}>{author?.profilePhoto?<img src={author.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(author?.avatar||"?")}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:12,color:"var(--text-3)",marginBottom:3}}>{author?.name||"?"} · {u.date}</div>
                <div style={{fontSize:14,lineHeight:1.5}}>{u.text}</div>
              </div>
            </div>;
          })}
        </div>
      </div>}

      {/* RFIs TAB */}
      {detailTab==="rfis"&&<div style={{padding:"16px"}}>
        {(p.issues||[]).length===0?<div style={{...MB.card,padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No RFIs yet.</div>:
        <div style={MB.card}>{(p.issues||[]).map((rfi,i)=><div key={i} style={{padding:"12px 16px",borderBottom:i<(p.issues||[]).length-1?"1px solid var(--divider)":"none"}}>
          <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:4}}>
            <span style={{...S.tag(rfi.status==="Closed"?"var(--green-100)":"var(--amber-100)",rfi.status==="Closed"?"var(--green-500)":"var(--amber-500)"),fontSize:10}}>{rfi.status||"Open"}</span>
          </div>
          <div style={{fontSize:14,fontWeight:500}}>{rfi.question||rfi.title}</div>
          {rfi.author&&<div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>{users.find(u=>u.id===rfi.author)?.name||rfi.author}</div>}
        </div>)}</div>}
      </div>}
    </div>;
  };

  // ── MY TEAM TAB ──────────────────────────────────────────────
  const TeamTab=()=>{
    const [teamSubTab,setTeamSubTab]=useState("team");
    const allStaff=users.filter(u=>isStaff(u)&&u.status!=="pending");
    const today=new Date();
    const upcoming=(vacations||[]).filter(v=>new Date(v.endDate)>=today).sort((a,b)=>new Date(a.startDate)-new Date(b.startDate));
    return <div>
      <div style={{display:"flex",borderBottom:"1px solid var(--border)",overflowX:"auto",scrollbarWidth:"none"}}>
        {[["team","👥 Team"],["vacations","🌴 Vacations"],["events","🎉 Events"]].map(([k,l])=><button key={k} style={{padding:"10px 16px",border:"none",borderBottom:teamSubTab===k?"2px solid var(--a-500)":"2px solid transparent",background:"transparent",color:teamSubTab===k?"var(--text)":"var(--text-3)",fontWeight:teamSubTab===k?700:500,fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"var(--font-sans)"}} onClick={()=>setTeamSubTab(k)}>{l}</button>)}
      </div>

      {teamSubTab==="team"&&<div style={{padding:"14px 16px"}}>
        {allStaff.map((u,i)=>{
          const myP=projects.filter(p=>(p.team||[]).includes(u.id));
          const focus=myP.reduce((s,p)=>s+getUserFocus(p,u.id),0);
          return <div key={u.id} style={{...MB.card,marginBottom:8,cursor:"pointer"}} onClick={()=>{setViewingUserId(u.id);setTab("profile")}}>
            <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:12}}>
              <div style={{...S.avatar,width:44,height:44,fontSize:15,background:u.profilePhoto?"transparent":(u.profileColor||C.grad2),flexShrink:0}}>
                {u.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:u.avatar}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:15,fontWeight:700}}>{u.name}<span style={{fontSize:10,fontWeight:700,color:C.accent,background:C.accentSoft,padding:"1px 6px",borderRadius:6,marginLeft:6}}>{u.role?.toUpperCase()}</span></div>
                <div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>{myP.filter(p=>p.status==="In Progress").length} active · {focus}% allocated{u.teamName?` · ${u.teamName}`:""}</div>
              </div>
              <span style={{color:"var(--a-500)",fontSize:18}}>›</span>
            </div>
          </div>;
        })}
      </div>}

      {teamSubTab==="vacations"&&<div style={{padding:"14px 16px"}}>
        <div style={MB.sectionTitle}>Upcoming Vacations</div>
        {upcoming.length===0?<div style={{...MB.card,padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No upcoming vacations.</div>:
        upcoming.map(v=>{
          const u=users.find(x=>x.id===v.userId);
          const days=Math.ceil((new Date(v.endDate)-new Date(v.startDate))/(1000*60*60*24))+1;
          return <div key={v.id} style={{...MB.card,marginBottom:8}}><div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:12}}>
            <div style={{...S.avatar,width:40,height:40,fontSize:13,background:u?.profilePhoto?"transparent":(u?.profileColor||C.grad2),flexShrink:0}}>{u?.profilePhoto?<img src={u.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(u?.avatar||"?")}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:700}}>{u?.name||"?"}</div>
              <div style={{fontSize:12,color:"var(--text-3)"}}>{v.startDate} → {v.endDate} ({days}d){v.reason?` · ${v.reason}`:""}</div>
            </div>
          </div></div>;
        })}
        {/* Book vacation */}
        <div style={{marginTop:12}}>
          <div style={MB.sectionTitle}>Book Your Vacation</div>
          <BookVacationForm currentUser={user} onBook={(v)=>setVacations&&setVacations(prev=>[...(prev||[]),v])}/>
        </div>
      </div>}

      {teamSubTab==="events"&&<div style={{padding:"14px 16px"}}>
        <div style={MB.sectionTitle}>Team Events</div>
        {(events||[]).length===0?<div style={{...MB.card,padding:20,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No events yet.</div>:
        (events||[]).filter(e=>!e.archived).map(ev=><div key={ev.id} style={{...MB.card,marginBottom:8}}>
          <div style={{padding:"14px 16px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:15,fontWeight:700}}>{ev.name}</div>
                <div style={{fontSize:12,color:"var(--text-3)",marginTop:2}}>{ev.type}{ev.endDate?` · ends ${ev.endDate}`:""}</div>
              </div>
              <Badge bg={C.accentSoft} fg={C.accent}>{(ev.participants||[]).length} joined</Badge>
            </div>
          </div>
        </div>)}
      </div>}
      <div style={{height:80}}/>
    </div>;
  };

  // ── PROFILE TAB ──────────────────────────────────────────────
  const ProfileTab=({userId})=>{
    const pu=users.find(u=>u.id===(userId||user.id));
    if(!pu)return null;
    const isOwn=pu.id===user.id;
    const myP=projects.filter(p=>(p.team||[]).includes(pu.id));
    const active=myP.filter(p=>p.status!=="Archived"&&p.status!=="Completed").length;
    const totalFocus=myP.reduce((s,p)=>s+getUserFocus(p,pu.id),0);
    const photo=pu.profilePhoto;
    const skills=pu.profileSkills||[];
    return <div>
      <div style={{background:pu.profileBanner?`url(${pu.profileBanner}) center/cover`:pu.profileColor||"var(--a-500)",height:130,position:"relative",flexShrink:0}}>
        <div style={{position:"absolute",left:20,bottom:-36,width:72,height:72,borderRadius:"50%",border:"4px solid var(--bg)",background:photo?"transparent":(pu.profileColor||"var(--a-500)"),color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,fontWeight:700,overflow:"hidden",boxShadow:"0 4px 14px rgba(0,0,0,.2)"}}>
          {photo?<img src={photo} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:pu.avatar}
        </div>
      </div>
      <div style={{padding:"46px 18px 16px"}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:"-0.03em",marginBottom:2}}>{pu.name}</div>
        {pu.profileHeadline?<div style={{fontSize:13,color:"var(--text-2)",marginBottom:6,lineHeight:1.4}}>{pu.profileHeadline}</div>:<div style={{fontSize:13,color:"var(--text-3)",marginBottom:6}}>{pu.role}</div>}
        {companyInfo?.name&&<div style={{display:"inline-flex",alignItems:"center",gap:6,padding:"5px 10px",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:20,marginBottom:12,fontSize:12,fontWeight:600}}>
          {companyInfo.logo?<img src={companyInfo.logo} alt="" style={{height:14,objectFit:"contain"}}/>:"🏢"}{companyInfo.name}{pu.teamName&&<span style={{color:"var(--text-3)",fontWeight:400}}>· {pu.teamName}</span>}
        </div>}
        {pu.profileLocation&&<div style={{fontSize:12,color:"var(--text-3)",marginBottom:12}}>📍 {pu.profileLocation}</div>}
      </div>
      <div style={{display:"flex",gap:10,padding:"0 16px 14px"}}>
        <div style={MB.stat}><div style={{...MB.statVal,fontSize:22,color:"var(--a-500)"}}>{active}</div><div style={MB.statLbl}>Active</div></div>
        <div style={MB.stat}><div style={{...MB.statVal,fontSize:22,color:totalFocus>100?"var(--red-500)":totalFocus>0?"var(--green-500)":"var(--text-3)"}}>{totalFocus}%</div><div style={MB.statLbl}>Focus</div></div>
        <div style={MB.stat}><div style={{...MB.statVal,fontSize:22}}>{myP.length}</div><div style={MB.statLbl}>Projects</div></div>
      </div>
      {pu.profileBio&&<div style={{...MB.card,margin:"0 16px 12px"}}><div style={{padding:"14px 16px"}}>
        <div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em",fontWeight:600,marginBottom:8}}>About</div>
        <div style={{fontSize:14,lineHeight:1.6}}>{pu.profileBio}</div>
      </div></div>}
      {skills.length>0&&<div style={{...MB.card,margin:"0 16px 12px"}}><div style={{padding:"14px 16px"}}>
        <div style={{fontSize:11,color:"var(--text-3)",textTransform:"uppercase",letterSpacing:"0.06em",fontWeight:600,marginBottom:10}}>Skills</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>{skills.map((s,i)=><span key={i} style={{...S.tag("var(--a-50)","var(--a-600)"),height:24,fontSize:11}}>{s}</span>)}</div>
      </div></div>}
      {!isOwn&&<div style={{padding:"0 16px 80px",display:"flex",gap:8}}>
        <button style={{...MB.btn,flex:1}} onClick={async()=>{await openDmThread(pu.id);}}>💬 Message</button>
        {pu.email&&<a href={`mailto:${pu.email}`} style={{...MB.btnO,flex:1,textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center"}}>📧 Email</a>}
      </div>}
      {isOwn&&<div style={{height:80}}/>}
    </div>;
  };

  // ── FEED TAB ─────────────────────────────────────────────────
  const FeedTab=()=>{
    const [postText,setPostText]=useState("");
    const [reactionPickerMsgId,setReactionPickerMsgId]=useState(null);
    const [commentingOn,setCommentingOn]=useState(null);
    const [commentText,setCommentText]=useState("");

    const addReaction=(postId,emoji)=>{
      // stored in newsFeed items as reactions:{emoji:[userIds]}
      const updated=(newsFeed||[]).map(post=>{
        if((post.id||"")!==postId)return post;
        const reactions=post.reactions||{};
        const existing=reactions[emoji]||[];
        const has=existing.includes(user.id);
        return{...post,reactions:{...reactions,[emoji]:has?existing.filter(id=>id!==user.id):[...existing,user.id]}};
      });
      // We can't directly call setNewsFeed but postNews can be used to update via a special update
      // Use a workaround: post a special "reaction" update that replaces the feed
      if(typeof postNews==="function") postNews(updated.find(p=>p.id===postId),true);
      setReactionPickerMsgId(null);
    };

    const addComment=(postId)=>{
      if(!commentText.trim())return;
      const updated=(newsFeed||[]).map(post=>{
        if((post.id||"")!==postId)return post;
        const comments=[...(post.comments||[]),{id:genId("c"),author:user.id,text:commentText.trim(),date:new Date().toISOString()}];
        return{...post,comments};
      });
      if(typeof postNews==="function") postNews(updated.find(p=>p.id===postId),true);
      setCommentText("");setCommentingOn(null);
    };

    return <div>
      <div style={{padding:"14px 16px"}}>
        <div style={{...MB.card,padding:"12px 14px",marginBottom:0}}>
          <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
            <div style={{...S.avatar,width:36,height:36,fontSize:12,background:user.profilePhoto?"transparent":(user.profileColor||C.grad2),flexShrink:0}}>
              {user.profilePhoto?<img src={user.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}
            </div>
            <div style={{flex:1}}>
              <textarea style={{...MB.input,height:56,padding:"10px 12px",resize:"none",fontSize:14}} value={postText} onChange={e=>setPostText(e.target.value)} placeholder="Share with your team..."/>
              {postText.trim()&&<button style={{...MB.btn,marginTop:8,height:36,fontSize:13}} onClick={()=>{postNews({id:"p"+Date.now(),author:user.id,text:postText.trim(),date:new Date().toISOString(),reactions:{},comments:[]});setPostText("")}}>Post</button>}
            </div>
          </div>
        </div>
      </div>
      <div style={{padding:"0 16px"}}>
        {[...(newsFeed||[])].sort((a,b)=>new Date(b.date)-new Date(a.date)).map((post,i)=>{
          const author=users.find(u=>u.id===post.author);
          const reactions=post.reactions||{};
          const reactionEntries=Object.entries(reactions).filter(([,ids])=>ids.length>0);
          const comments=post.comments||[];
          return <div key={post.id||i} style={{...MB.card,marginBottom:10}}>
            <div style={{padding:"14px 16px 10px"}}>
              <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:10}}>
                <div style={{...S.avatar,width:36,height:36,fontSize:12,background:author?.profilePhoto?"transparent":(author?.profileColor||C.grad2),flexShrink:0}}>
                  {author?.profilePhoto?<img src={author.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(author?.avatar||"?")}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:700}}>{author?.name||"Unknown"}</div>
                  <div style={{fontSize:12,color:"var(--text-3)"}}>{fmtTime(post.date)}</div>
                </div>
              </div>
              <div style={{fontSize:14,lineHeight:1.6,whiteSpace:"pre-wrap",marginBottom:10}}>{post.text}</div>

              {/* Reactions */}
              {reactionEntries.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
                {reactionEntries.map(([emoji,ids])=><button key={emoji} onClick={()=>addReaction(post.id||String(i),emoji)} style={{display:"flex",alignItems:"center",gap:3,padding:"3px 8px",borderRadius:12,border:`1px solid ${ids.includes(user.id)?"var(--a-500)":"var(--border)"}`,background:ids.includes(user.id)?"var(--a-50)":"var(--surface)",cursor:"pointer",fontSize:13,fontWeight:ids.includes(user.id)?700:400}}>
                  {emoji}<span style={{fontSize:11}}>{ids.length}</span>
                </button>)}
              </div>}

              {/* Action bar */}
              <div style={{display:"flex",gap:8,borderTop:"1px solid var(--divider)",paddingTop:10}}>
                <button onClick={()=>setReactionPickerMsgId(reactionPickerMsgId===(post.id||i)?null:(post.id||i))} style={{...MB.btnO,flex:1,height:36,fontSize:13}}>😊 React</button>
                <button onClick={()=>{setCommentingOn(commentingOn===(post.id||i)?null:(post.id||i));setCommentText("");}} style={{...MB.btnO,flex:1,height:36,fontSize:13}}>💬 Comment {comments.length>0?`(${comments.length})`:""}</button>
              </div>

              {/* Emoji picker */}
              {reactionPickerMsgId===(post.id||i)&&<div style={{display:"flex",gap:4,flexWrap:"wrap",padding:"10px 0 0"}}>
                {EMOJI_REACTIONS.map(e=><button key={e} onClick={()=>addReaction(post.id||String(i),e)} style={{fontSize:24,background:"none",border:"none",cursor:"pointer",padding:"4px 6px",borderRadius:8}}>{e}</button>)}
              </div>}

              {/* Comments */}
              {commentingOn===(post.id||i)&&<div style={{marginTop:10}}>
                <div style={{display:"flex",gap:8}}>
                  <input style={{...MB.input,flex:1,height:38,fontSize:13}} value={commentText} onChange={e=>setCommentText(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addComment(post.id||String(i))} placeholder="Write a comment..."/>
                  <button style={{...MB.btn,height:38,padding:"0 14px",flexShrink:0}} onClick={()=>addComment(post.id||String(i))}>Post</button>
                </div>
              </div>}
              {comments.length>0&&<div style={{marginTop:10}}>
                {comments.map((c,ci)=>{const ca=users.find(u=>u.id===c.author);return <div key={ci} style={{display:"flex",gap:8,marginTop:8,alignItems:"flex-start"}}>
                  <div style={{...S.avatar,width:26,height:26,fontSize:9,flexShrink:0,background:ca?.profileColor||C.grad2}}>{ca?.avatar||"?"}</div>
                  <div style={{flex:1,background:"var(--surface-2)",borderRadius:8,padding:"6px 10px",fontSize:13}}>
                    <div style={{fontWeight:600,fontSize:11,marginBottom:2}}>{ca?.name||"?"}</div>
                    <div style={{lineHeight:1.4}}>{c.text}</div>
                  </div>
                </div>;})}
              </div>}
            </div>
          </div>;
        })}
        {(newsFeed||[]).length===0&&<div style={{...MB.card,padding:40,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No posts yet. Share something!</div>}
      </div>
      <div style={{height:80}}/>
    </div>;
  };

  // ── NOTIFS TAB ──────────────────────────────────────────────
  const NotifsTab=()=>{
    const markAllRead=()=>setNotifications(prev=>(prev||[]).map(n=>({...n,read:true})));
    const notifList=notifications||[];
    return <div style={{padding:"14px 16px"}}>
      {unreadNotifs>0&&<button onClick={markAllRead} style={{...MB.btnO,width:"100%",marginBottom:12,height:44,fontSize:14}}>✓ Mark all read ({unreadNotifs})</button>}
      <div style={MB.card}>
        {notifList.length===0
          ?<div style={{padding:40,textAlign:"center",color:"var(--text-3)",fontSize:13}}>No notifications yet.</div>
          :[...notifList].reverse().slice(0,50).map((n,i)=>{
            // Fix [object Object] — extract message string properly
            const msg=typeof n==="string"?n:n?.message||n?.text||n?.title||"Notification";
            const dateStr=n?.date?new Date(n.date).toLocaleDateString([],{month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"}):null;
            return <div key={i} style={{padding:"12px 16px",borderBottom:i<Math.min(notifList.length,50)-1?"1px solid var(--divider)":"none",background:n?.read===false?"var(--a-50)":"transparent"}}>
              <div style={{fontSize:14,lineHeight:1.5,fontWeight:n?.read===false?600:400}}>{msg}</div>
              {dateStr&&<div style={{fontSize:11,color:"var(--text-3)",marginTop:3}}>{dateStr}</div>}
            </div>;
          })}
      </div>
      <div style={{height:80}}/>
    </div>;
  };

  // ── RENDER ───────────────────────────────────────────────────
  if(activeProject){
    return <div style={MB.wrap}>
      <MobileProjectDetail projectId={activeProject}/>
    </div>;
  }

  const TABS=[
    {id:"home",icon:"🏠",label:"Home"},
    {id:"projects",icon:"📁",label:"Projects"},
    {id:"feed",icon:"📰",label:"Feed"},
    {id:"team",icon:"👥",label:"Team"},
    {id:"notifs",icon:"🔔",label:unreadNotifs>0?`(${unreadNotifs})`:"Notifs"},
  ];

  const tabTitle={home:"WorkBro",projects:"My Projects",feed:"Team Feed",team:"My Team",profile:viewingUserId?users.find(u=>u.id===viewingUserId)?.name||"Profile":"My Profile",notifs:"Notifications"};

  return <div style={MB.wrap}>
    {/* Search overlay */}
    {showSearch&&<SearchOverlay/>}

    {/* Top bar */}
    <div style={MB.topbar}>
      {(tab==="profile"&&viewingUserId)
        ?<button style={MB.back} onClick={()=>setViewingUserId(null)}>‹ Back</button>
        :<div style={{width:50}}/>}
      <div style={MB.title}>{tab==="home"?<span><span style={{color:"var(--a-500)"}}>Work</span>Bro</span>:tabTitle[tab]}</div>
      <div style={{display:"flex",gap:6,alignItems:"center"}}>
        {onSwitchToFull&&<button onClick={onSwitchToFull} style={{height:36,padding:"0 10px",borderRadius:8,border:"1px solid var(--border)",background:"var(--surface)",cursor:"pointer",fontSize:11,fontWeight:600,color:"var(--a-600,var(--a-500))",display:"flex",alignItems:"center",gap:4}} title="Switch to the full WorkBro site">🖥 Full site</button>}
        <button onClick={()=>setShowSearch(s=>!s)} style={{width:36,height:36,borderRadius:8,border:"1px solid var(--border)",background:showSearch?"var(--a-50)":"var(--surface)",cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>🔍</button>
        {tab==="home"&&<button onClick={logout} style={{width:36,height:36,borderRadius:8,border:"1px solid var(--border)",background:"var(--surface)",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",color:"var(--text-3)"}}>⏏</button>}
      </div>
    </div>

    {/* Search bar (when open) */}
    {showSearch&&<div style={{padding:"8px 16px",background:"var(--surface)",borderBottom:"1px solid var(--border)",position:"sticky",top:56,zIndex:49}}>
      <input autoFocus style={MB.input} placeholder="Search projects, people..." value={globalSearch} onChange={e=>setGlobalSearch(e.target.value)}/>
    </div>}

    {/* Page content */}
    <div style={{paddingTop:4}}>
      {tab==="home"&&<HomeTab/>}
      {tab==="projects"&&<ProjectsTab/>}
      {tab==="feed"&&<FeedTab/>}
      {tab==="team"&&<TeamTab/>}
      {tab==="profile"&&<ProfileTab userId={viewingUserId}/>}
      {tab==="notifs"&&<NotifsTab/>}
    </div>

    {/* Bottom tab bar */}
    <div style={MB.tabBar}>
      {TABS.map(t=><button key={t.id} style={MB.tabBtn(tab===t.id)} onClick={()=>{setTab(t.id);setViewingUserId(null);setShowSearch(false);setGlobalSearch("");}}>
        <span style={MB.tabIcon}>{t.icon}</span>
        <span>{t.label}</span>
      </button>)}
    </div>
  </div>;
}

// ══════════════════════════════════════════════════════════════
// APP
// ══════════════════════════════════════════════════════════════
// ─── PUBLIC WORLD CUP LEADERBOARD (no login required) ──────────
export function PublicLeaderboard({companyId,eventId}){
  const [loading,setLoading]=React.useState(true);
  const [event,setEvent]=React.useState(null);
  const [users,setUsers]=React.useState([]);
  const [error,setError]=React.useState(null);
  const [tab,setTab]=React.useState("leaderboard"); // leaderboard | groups | r32

  const reloadEvent=React.useCallback(async()=>{
    try{
      const sk=getSK(companyId);
      const [events,usrs]=await Promise.all([ld(sk.events,[]),ld(sk.u,[])]);
      const ev=events.find(e=>e.id===eventId);
      if(!ev){setError("Event not found or no longer available.");setLoading(false);return null;}
      setEvent(ev);setUsers(usrs);setLoading(false);return ev;
    }catch(e){setError("Could not load leaderboard. Please try again later.");setLoading(false);return null;}
  },[companyId,eventId]);

  React.useEffect(()=>{reloadEvent();},[reloadEvent]);

  if(loading)return <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:"#0d1117"}}><div style={{textAlign:"center"}}><LogoImg h={48} style={{marginBottom:16}}/><div style={{color:"#888",fontSize:14}}>Loading leaderboard…</div></div></div>;

  if(error)return <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:"#0d1117",padding:20}}><div style={{textAlign:"center",maxWidth:380}}><div style={{fontSize:40,marginBottom:12}}>🏆</div><div style={{color:"#fff",fontSize:18,fontWeight:600,marginBottom:8}}>Leaderboard unavailable</div><div style={{color:"#888",fontSize:14}}>{error}</div></div></div>;

  const wcPicks=event.wcPicks||{};
  const wcResults=event.wcResults||{};
  const r32Picks=event.wcR32Picks||{};
  const r32Results=event.wcR32Results||{};
  const computePoints=(uid)=>computeWCPoints(event,uid);
  const allUserIds=wcEntrantIds(event);
  const nameOf=(uid)=>uid.startsWith("guest_")?((event.wcGuestNames||{})[uid]||uid.replace("guest_","")):(users.find(x=>x.id===uid)?.name||"Unknown");
  const leaderboard=allUserIds.map(uid=>{
    const isGuest=uid.startsWith("guest_");
    const u=isGuest?null:users.find(x=>x.id===uid);
    return{userId:uid,user:u,name:nameOf(uid),isGuest,points:computePoints(uid),totalPicks:WC26_GROUP_LETTERS.reduce((s,g)=>s+(wcPicks[uid]?.[g]||[]).length,0),r32Count:WC26_R32_FIXTURES.filter(g=>(r32Picks[uid]||{})[g.id]).length};
  }).sort((a,b)=>b.points-a.points||a.name.localeCompare(b.name));

  const TABS=[{id:"leaderboard",label:"🏆 Leaderboard"},...(wcPodium(event)?[{id:"podium",label:"🏅 Podium"}]:[]),{id:"groups",label:"Group Stage"},{id:"r32",label:"Round of 32"},{id:"r16",label:"Round of 16"},{id:"qf",label:"Quarter Final"},{id:"sf",label:"Semi Final"},{id:"final",label:"Final"}];

  const Avatar=({entry,size=36})=><div style={{width:size,height:size,borderRadius:"50%",background:entry.isGuest?"#2e3541":"#c96a33",display:"flex",alignItems:"center",justifyContent:"center",fontSize:Math.round(size*0.36),fontWeight:700,color:"#fff",overflow:"hidden",flexShrink:0}}>
    {entry.isGuest?"👤":(entry.user?.profilePhoto?<img src={entry.user.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:(entry.user?.avatar||entry.name.charAt(0)))}
  </div>;

  const renderKOPublic=(cfg)=>{
    const koPicks=event[cfg.picksKey]||{};const koResults=wcRoundResults(event,cfg);const N=cfg.fixtures.length;
    const decided=cfg.fixtures.filter(g=>koResults[g.id]);
    const withPicks=leaderboard.filter(e=>cfg.fixtures.some(g=>(koPicks[e.userId]||{})[g.id]));
    return <>
      {decided.length>0&&<div style={{background:"#161b22",border:"1px solid #222831",borderRadius:12,padding:"14px 16px",marginBottom:16}}>
        <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em",color:"#10b981",marginBottom:10}}>⚽ Results ({decided.length}/{N})</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:6}}>
          {decided.map(g=><div key={g.id} style={{display:"flex",alignItems:"center",gap:5,padding:"4px 8px",background:"#0d1117",border:"1px solid #222831",borderRadius:8,fontSize:12}}>
            <FlagImg team={koResults[g.id]} size={13}/>
            <span style={{color:"#10b981",fontWeight:700,flex:1}}>{koResults[g.id]}</span>
            <span style={{fontSize:9,color:"#666"}}>def. {(g.home===koResults[g.id]?g.away:g.home)}</span>
          </div>)}
        </div>
      </div>}
      {withPicks.length===0?<div style={{textAlign:"center",padding:40,color:"#888",fontSize:14}}>No {cfg.label} selections yet.<br/><span style={{fontSize:12,color:"#555"}}>Picks are made on the WorkBro website.</span></div>:
      withPicks.map(entry=>{
        const picks=koPicks[entry.userId]||{};
        const vd=(gid)=>!!(event.wcVoids||{})[`${cfg.picksKey}:${gid}:${entry.userId}`];
        const correct=cfg.fixtures.filter(g=>koResults[g.id]&&picks[g.id]===koResults[g.id]&&!vd(g.id)).length;
        return <div key={entry.userId} style={{background:"#161b22",border:"1px solid #222831",borderRadius:12,marginBottom:12,overflow:"hidden"}}>
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",borderBottom:"1px solid #222831"}}>
            <Avatar entry={entry} size={30}/>
            <div style={{flex:1,minWidth:0,fontSize:14,fontWeight:600,color:"#fff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{entry.name}{entry.isGuest&&<span style={{fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:999,background:"#222831",color:"#888",marginLeft:6,textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}</div>
            {decided.length>0&&<div style={{fontSize:11,color:"#10b981",fontWeight:700}}>{correct} correct</div>}
          </div>
          <div style={{padding:"12px 14px",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:6}}>
            {cfg.fixtures.map(game=>{
              const pick=picks[game.id];const result=koResults[game.id];const voided=vd(game.id);
              const isCorrect=result&&pick===result&&!voided;const isWrong=result&&pick&&(pick!==result||voided);
              return <div key={game.id} style={{display:"flex",alignItems:"center",gap:6,padding:"5px 8px",background:"#0d1117",border:"1px solid "+(isCorrect?"rgba(16,185,129,.4)":isWrong?"rgba(239,68,68,.3)":"#222831"),borderRadius:8,fontSize:12,opacity:voided?0.75:1}}>
                {pick?<><FlagImg team={pick} size={13}/>
                  <span style={{flex:1,fontWeight:600,color:isCorrect?"#10b981":isWrong?"#ef4444":"#e6e9ef",textDecoration:(isWrong||voided)?"line-through":"none",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{pick}</span>
                  {voided&&<span style={{fontSize:8,fontWeight:700,padding:"0 4px",borderRadius:999,background:"#ef4444",color:"#fff"}}>VOID</span>}
                  {isCorrect&&<span style={{color:"#10b981"}}>✓</span>}
                  {isWrong&&!voided&&<span style={{color:"#ef4444",fontSize:11}}>✕</span>}
                </>:<span style={{flex:1,color:"#555"}}>{game.home} v {game.away}: —</span>}
              </div>;
            })}
          </div>
        </div>;
      })}
    </>;
  };

  return <div style={{minHeight:"100vh",background:"#0d1117",color:"#e6e9ef",fontFamily:"Inter,system-ui,sans-serif",padding:"0 0 60px"}}>
    {/* Header */}
    <div style={{background:"linear-gradient(135deg,#c96a33,#9a4f24)",padding:"32px 20px 28px",textAlign:"center"}}>
      <div style={{fontSize:40,marginBottom:8}}>🏆</div>
      <h1 style={{margin:"0 0 4px",fontSize:24,fontWeight:700,color:"#fff"}}>{event.title||"World Cup 2026"}</h1>
      <div style={{fontSize:13,color:"rgba(255,255,255,.8)"}}>Live Leaderboard · {leaderboard.length} {leaderboard.length===1?"player":"players"}</div>
    </div>

    {/* Tab bar */}
    <div style={{position:"sticky",top:0,zIndex:5,background:"#0d1117",borderBottom:"1px solid #222831"}}>
      <div style={{maxWidth:560,margin:"0 auto",display:"flex",gap:4,padding:"0 12px",overflowX:"auto"}}>
        {TABS.map(t=><button key={t.id} onClick={()=>setTab(t.id)} style={{padding:"13px 14px",border:"none",borderBottom:tab===t.id?"2px solid #c96a33":"2px solid transparent",background:"transparent",color:tab===t.id?"#fff":"#888",fontWeight:tab===t.id?700:500,fontSize:13,cursor:"pointer",whiteSpace:"nowrap",fontFamily:"inherit"}}>{t.label}</button>)}
      </div>
    </div>

    <div style={{maxWidth:560,margin:"0 auto",padding:"20px 16px"}}>

      {/* ───────── LEADERBOARD TAB ───────── */}
      {tab==="leaderboard"&&<>
      {(()=>{const pod=wcPodium(event);if(!pod)return null;return <div style={{background:"linear-gradient(135deg,rgba(126,200,0,.16),#161b22)",border:"1px solid rgba(126,200,0,.34)",borderRadius:14,padding:"16px 18px",marginBottom:14,display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
        <div style={{fontSize:32}}>🏆</div>
        <div style={{flex:1,minWidth:160}}>
          <div style={{fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#9fe870"}}>2026 World Cup Champions</div>
          <div style={{fontSize:22,fontWeight:800,color:"#fff",display:"flex",alignItems:"center",gap:8,marginTop:2}}><FlagImg team={pod.champion} size={24}/>{pod.champion}</div>
          <div style={{fontSize:12,color:"#8a9992",marginTop:2}}>def. {pod.runnerUp} in the final{pod.third?` · ${pod.third} finished 3rd`:""}</div>
        </div>
      </div>;})()}
      </>}
      {tab==="leaderboard"&&(leaderboard.length===0?<div style={{textAlign:"center",padding:40,color:"#888",fontSize:14}}>No picks submitted yet.</div>:
        leaderboard.map((entry,idx)=>{
          const medal=idx===0?"🥇":idx===1?"🥈":idx===2?"🥉":"#"+(idx+1);
          return <div key={entry.userId} style={{background:idx<3?"rgba(201,106,51,.08)":"#161b22",border:"1px solid "+(idx<3?"rgba(201,106,51,.25)":"#222831"),borderRadius:12,marginBottom:8}}>
            <div style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px"}}>
              <div style={{minWidth:36,textAlign:"center",fontSize:idx<3?24:14,fontWeight:700,color:idx<3?"#f59e0b":"#666"}}>{medal}</div>
              <Avatar entry={entry}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:15,fontWeight:600,color:"#fff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{entry.name}{entry.isGuest&&<span style={{fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:999,background:"#222831",color:"#888",marginLeft:6,textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}</div>
                <div style={{fontSize:11,color:"#666"}}>{entry.totalPicks}/24 teams{entry.r32Count>0?" · "+entry.r32Count+"/16 R32":""}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:24,fontWeight:700,color:"#10b981",fontVariantNumeric:"tabular-nums"}}>{entry.points}</div>
                <div style={{fontSize:10,color:"#666",fontWeight:600,letterSpacing:1}}>PTS</div>
              </div>
            </div>
          </div>;
        })
      )}

      {/* ───────── GROUP STAGE SELECTIONS TAB ───────── */}
      {tab==="groups"&&(()=>{
        const withGroups=leaderboard.filter(e=>e.totalPicks>0);
        if(withGroups.length===0)return <div style={{textAlign:"center",padding:40,color:"#888",fontSize:14}}>No group-stage selections yet.</div>;
        return withGroups.map(entry=>{
          const userPicks=wcPicks[entry.userId]||{};
          return <div key={entry.userId} style={{background:"#161b22",border:"1px solid #222831",borderRadius:12,marginBottom:12,overflow:"hidden"}}>
            <div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",borderBottom:"1px solid #222831"}}>
              <Avatar entry={entry} size={30}/>
              <div style={{flex:1,minWidth:0,fontSize:14,fontWeight:600,color:"#fff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{entry.name}{entry.isGuest&&<span style={{fontSize:9,fontWeight:600,padding:"1px 5px",borderRadius:999,background:"#222831",color:"#888",marginLeft:6,textTransform:"uppercase",letterSpacing:"0.05em"}}>guest</span>}</div>
              <div style={{fontSize:11,color:"#666"}}>{entry.totalPicks}/24</div>
            </div>
            <div style={{padding:"12px 14px",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:8}}>
              {WC26_GROUP_LETTERS.map(g=>{
                const groupPicks=userPicks[g]||[];
                return <div key={g} style={{background:"#0d1117",border:"1px solid #222831",borderRadius:8,padding:"8px 10px"}}>
                  <div style={{fontSize:10,fontWeight:700,color:"#888",marginBottom:6,letterSpacing:1}}>GROUP {g}</div>
                  {groupPicks.length===0?<div style={{fontSize:11,color:"#555"}}>—</div>:groupPicks.map(team=>{
                    const reached=wcReachedRound(team,event);const eliminated=reached==="group";const advanced=WC26_ROUNDS.indexOf(reached)>=1;
                    return <div key={team} style={{display:"flex",alignItems:"center",gap:6,padding:"3px 0",fontSize:12,opacity:eliminated?0.5:1,textDecoration:eliminated?"line-through":"none"}}>
                      <FlagImg team={team} size={14}/>
                      <span style={{flex:1,fontWeight:advanced?700:500,color:advanced?"#10b981":"#e6e9ef"}}>{team}</span>
                      {advanced&&<span style={{fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:999,background:"rgba(16,185,129,.15)",color:"#10b981"}}>{WC26_ROUND_LABELS[reached]||reached}</span>}
                      {eliminated&&<span style={{fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:999,background:"rgba(239,68,68,.15)",color:"#ef4444"}}>OUT</span>}
                    </div>;
                  })}
                </div>;
              })}
            </div>
          </div>;
        });
      })()}

      {/* ───────── KNOCKOUT SELECTION TABS (read-only) ───────── */}
      {tab==="r32"&&renderKOPublic(WC26_KO_ROUNDS[0])}
      {tab==="r16"&&renderKOPublic(WC26_KO_ROUNDS[1])}
      {tab==="qf"&&renderKOPublic(WC26_KO_ROUNDS[2])}
      {tab==="sf"&&renderKOPublic(WC26_KO_ROUNDS[3])}
      {tab==="podium"&&(()=>{
        const pod=wcPodium(event);if(!pod)return null;
        const steps=[{p:2,team:pod.runnerUp,m:"🥈",label:"Runner-up",h:92,bg:"linear-gradient(180deg,#c0c7d0,#9aa3ae)"},{p:1,team:pod.champion,m:"🥇",label:"Champion",h:124,bg:"linear-gradient(180deg,#f7d774,#e0b43a)"},{p:3,team:pod.third,m:"🥉",label:"Third place",h:68,bg:"linear-gradient(180deg,#d69a68,#b97840)"}];
        const top=leaderboard.slice(0,3);const medals=["🥇","🥈","🥉"];
        return <>
          <div style={{background:"#161b22",border:"1px solid #222831",borderRadius:14,padding:"22px 16px 18px",marginBottom:14}}>
            <div style={{textAlign:"center",fontSize:11,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#8a9992",marginBottom:18}}>FIFA World Cup 2026 · Final Standings</div>
            <div style={{display:"flex",justifyContent:"center",alignItems:"flex-end",gap:12,flexWrap:"wrap"}}>
              {steps.map(s=>s.team&&<div key={s.p} style={{display:"flex",flexDirection:"column",alignItems:"center",width:120,maxWidth:"31%"}}>
                <div style={{fontSize:s.p===1?32:24,marginBottom:4}}>{s.m}</div>
                <FlagImg team={s.team} size={s.p===1?38:30}/>
                <div style={{fontSize:s.p===1?16:14,fontWeight:800,color:"#fff",marginTop:6,textAlign:"center"}}>{s.team}</div>
                <div style={{fontSize:11,color:"#8a9992",marginBottom:8}}>{s.label}</div>
                <div style={{width:"100%",height:s.h,borderRadius:"8px 8px 0 0",background:s.bg,display:"flex",justifyContent:"center",paddingTop:8,color:"rgba(0,0,0,.55)",fontWeight:800,fontSize:20}}>{s.p}</div>
              </div>)}
            </div>
          </div>
          {top.length>0&&<div style={{background:"#161b22",border:"1px solid #222831",borderRadius:14,padding:16}}>
            <div style={{fontSize:12,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em",color:"#8a9992",marginBottom:12}}>🏅 Prediction Pool — Winners</div>
            {top.map((e,i)=><div key={e.userId} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 12px",borderRadius:10,marginBottom:8,background:i===0?"linear-gradient(135deg,rgba(126,200,0,.14),#0d1117)":"#0d1117",border:"1px solid "+(i===0?"rgba(126,200,0,.3)":"#222831")}}>
              <div style={{fontSize:22,width:30,textAlign:"center"}}>{medals[i]}</div>
              <div style={{flex:1,minWidth:0,fontSize:15,fontWeight:700,color:"#fff"}}>{e.name}</div>
              <div style={{fontSize:20,fontWeight:800,color:i===0?"#9fe870":"#e6e9ef"}}>{e.points}<span style={{fontSize:11,color:"#8a9992",fontWeight:600}}> pts</span></div>
            </div>)}
          </div>}
        </>;
      })()}
      {tab==="final"&&renderKOPublic(WC26_KO_ROUNDS[4])}

      {/* Footer */}
      <div style={{textAlign:"center",marginTop:32,paddingTop:20,borderTop:"1px solid #222831"}}>
        <div style={{fontSize:12,color:"#666",marginBottom:8}}>View-only · selections are made on the WorkBro website</div>
        <a href="/" style={{display:"inline-flex",alignItems:"center",gap:6,fontSize:13,color:"#c96a33",textDecoration:"none",fontWeight:600}}>Powered by WorkBro →</a>
      </div>
    </div>
  </div>;
}

export default function App(){
  const [company,setCompany]=useState(null);
  const [users,setUsers]=useState([]);
  const [projects,setProjects]=useState([]);
  const [timesheets,setTimesheets]=useState({});
  const [meetingNotes,setMeetingNotes]=useState({});
  const [newsFeed,setNewsFeed]=useState([]);
  const [actionItems,setActionItems]=useState({});
  const [teams,setTeams]=useState([]);
  const [assignments,setAssignments]=useState([]);
  const [vacations,setVacations]=useState([]);
  const [companyInfo,setCompanyInfo]=useState({logo:null,name:""});
  const [notifications,setNotifications]=useState([]);
  const [events,setEvents]=useState([]);
  const [issues,setIssues]=useState([]);
  // ── Social/Public layer (cross-workspace) ──
  const [publicCompanies,setPublicCompanies]=useState([]);
  const [publicProfiles,setPublicProfiles]=useState([]);
  const [publicPosts,setPublicPosts]=useState([]);
  const [publicProjects,setPublicProjects]=useState([]);
  const [dmThreads,setDmThreads]=useState([]); // [{threadId, otherUserId, lastMessage, lastMessageAt, unread:0}]
  const [activeDmThread,setActiveDmThread]=useState(null); // currently open thread {threadId, otherUserId, messages:[]}
  const isMobile=useIsMobile();
  const [mobileLite,setMobileLite]=useState(()=>localStorage.getItem("wb:mobileLite")==="1"); // opt-in compact mobile shell; full app is the default
  const [showSidebar,setShowSidebar]=useState(()=>typeof window!=="undefined"?window.innerWidth>=900:true);
  const [darkMode,setDarkMode]=useState(()=>localStorage.getItem("wb:darkMode")==="1");
  // ── Design system preferences (clay accent, density, radius) ──
  // These map to data-* attributes on <html> consumed by tokens.css. Live-switchable.
  const [accent,setAccent]=useState(()=>localStorage.getItem("wb:accent")||"clay"); // clay|indigo|emerald|violet
  const [density,setDensity]=useState(()=>localStorage.getItem("wb:density")||"comfortable"); // compact|comfortable|spacious
  const [radius,setRadius]=useState(()=>localStorage.getItem("wb:radius")||"rounded"); // sharp|rounded|pill
  // Shared toggleAction so SlidePanel (from TeamMeetingView) can mark items done/undone
  const toggleAction=(pid,aid)=>setActionItems(prev=>({...prev,[pid]:(prev[pid]||[]).map(a=>a.id===aid?{...a,done:!a.done}:a)}));
  useEffect(()=>{
    localStorage.setItem("wb:darkMode",darkMode?"1":"0");
    localStorage.setItem("wb:accent",accent);
    localStorage.setItem("wb:density",density);
    localStorage.setItem("wb:radius",radius);
    // Apply design system data-* attributes on <html>
    const html=document.documentElement;
    html.setAttribute("data-theme",darkMode?"dark":"light");
    html.setAttribute("data-accent",accent);
    html.setAttribute("data-density",density);
    html.setAttribute("data-radius",radius);
    // Inject legacy --c-* bridge so existing inline styles continue working
    let style=document.getElementById("wbro-theme-style");
    if(!style){style=document.createElement("style");style.id="wbro-theme-style";document.head.appendChild(style)}
    style.innerHTML=darkMode?THEME_DARK:THEME_LIGHT;
    // Clean up any old filter-based dark mode
    document.documentElement.style.filter="";
    document.documentElement.style.background="";
    const oldStyle=document.getElementById("wbro-dark-style");
    if(oldStyle)oldStyle.remove();
  },[darkMode,accent,density,radius]);
  const [user,setUser]=useState(null);
  const [extUser,setExtUser]=useState(null);
  const [page,setPage]=useState("portfolio");
  const [activeProject,setActiveProject]=useState(null);
  const [profileUserId,setProfileUserId]=useState(null);
  const [pendingView,setPendingView]=useState(null); // "actions"|"deliverables"|null — consumed by PortfolioView
  const [activePortfolioView,setActivePortfolioView]=useState("dashboard"); // tracks which sub-view is active
  const [showSearch,setShowSearch]=useState(false);
  const [modal,setModal]=useState(null);
  const [loading,setLoading]=useState(true);
  // Safety timeout: if loading never clears (DB hang), force it off after 8s
  useEffect(()=>{const t=setTimeout(()=>setLoading(false),8000);return()=>clearTimeout(t);},[]);
  const [saveStatus,setSaveStatus]=useState("");
  const [showProfile,setShowProfile]=useState(false);
  const [showNotifs,setShowNotifs]=useState(false);
  const [dbStatus,setDbStatus]=useState("checking"); // checking|ok|error

  const SK=useMemo(()=>company?getSK(company.id):null,[company]);

  // Load font
  useEffect(()=>{const l=document.createElement("link");l.rel="stylesheet";l.href=FONT;document.head.appendChild(l)},[]);

  // Test database + restore session on mount
  useEffect(()=>{
    (async()=>{
      try{
        // Test Supabase connection
        try{
          const {error}=await supabase.from("kv_store").select("key").limit(1);
          if(error){console.error("DB test failed:",error.message);setDbStatus("error")}
          else{setDbStatus("ok");console.log("WBRO: Database connected")}
        }catch(e){console.error("DB connection failed:",e);setDbStatus("error")}

        // Restore session
        let session=null;try{const ss=localStorage.getItem(SESSION_KEY);if(ss)session=JSON.parse(ss)}catch{}
        if(session?.userId&&session?.companyId){
          try{
            const sk=getSK(session.companyId);
            const usrs=await ld(sk.u,[]);
            const found=usrs.find(u=>u.id===session.userId&&u.status!=="pending");
            if(found){
              setCompany({id:session.companyId,name:session.companyName||"Workspace",type:session.companyType||"company"});
              setUser(found);
            }
          }catch(e){console.error("Session restore failed:",e);}
        }
      }catch(e){
        console.error("Init error:",e);
      }finally{
        setLoading(false);
      }
    })();
  },[]);

  // Load company data when company changes
  useEffect(()=>{
    if(!SK)return;
    (async()=>{
      // Timesheets: load both legacy blob AND per-user keys, merge
      // Per-user keys at `${SK.t}:userId` win over the legacy blob on conflict
      const tsLegacyPromise=ld(SK.t,{});
      const tsPerUserPromise=listKeysByPrefix(`${SK.t}:`);
      const [u,p,tLegacy,n,f,a,tm,asg,vac,ci,nt,ev,tsPerUser,pubC,pubProf,pubPosts,pubProj,iss]=await Promise.all([
        ld(SK.u,[]),ld(SK.p,[]),tsLegacyPromise,ld(SK.n,{}),ld(SK.f,[]),ld(SK.a,{}),ld(SK.teams,[]),ld(SK.assignments,[]),ld(SK.vacations,[]),ld(SK.company,{logo:null,name:""}),ld(SK.notifs,[]),ld(SK.events,[]),tsPerUserPromise,
        ld(PUBLIC_KEYS.companies,[]),ld(PUBLIC_KEYS.profiles,[]),ld(PUBLIC_KEYS.posts,[]),ld(PUBLIC_KEYS.showcased,[]),
        ld(SK.issues,[])
      ]);
      const t={...(tLegacy||{})};
      (tsPerUser||[]).forEach(row=>{
        if(!row||!row.key)return;
        const uid=row.key.slice(`${SK.t}:`.length);
        if(uid)t[uid]=row.value||{};
      });
      const migratedP=(p||[]).map(proj=>({
        ...proj,
        team:Array.isArray(proj.team)?proj.team:[],
        milestones:Array.isArray(proj.milestones)?proj.milestones:[],
        issues:(Array.isArray(proj.issues)?proj.issues:[]).map(iss=>({...iss,responses:Array.isArray(iss?.responses)?iss.responses:[],message:iss?.message||""})),
        updates:Array.isArray(proj.updates)?proj.updates:[],
        deadlines:Array.isArray(proj.deadlines)?proj.deadlines:[],
        coordination:Array.isArray(proj.coordination)?proj.coordination:[],
        budget:proj.budget&&typeof proj.budget==="object"?{total:proj.budget.total||0,spent:proj.budget.spent||0}:{total:0,spent:0},
        budgetBreakdown:Array.isArray(proj.budgetBreakdown)?proj.budgetBreakdown:[],
        status:proj.status||"In Progress",
        phase:proj.phase||"Schematic Design",
        progress:typeof proj.progress==="number"?proj.progress:0,
        designerFocus:typeof proj.designerFocus==="number"?proj.designerFocus:0,
        focusMap:proj.focusMap&&typeof proj.focusMap==="object"?proj.focusMap:{},
        accessPin:proj.accessPin||genPinCode(),
      }));
      const migratedU=(u||[]).map(usr=>({...usr,billableRole:usr.billableRole||usr.role,teamName:usr.teamName||"",status:usr.status||"active"}));
      setUsers(migratedU);setProjects(migratedP);setTimesheets(t);setMeetingNotes(n);setNewsFeed(f||[]);setActionItems(a||{});setTeams(tm||[]);setAssignments(asg||[]);setVacations(vac||[]);setCompanyInfo(ci||{logo:null,name:""});setNotifications(nt||[]);setEvents(ev||[]);setIssues(iss||[]);
      // PUBLIC DATA SANITIZATION on load:
      // Strip sensitive fields from stored public records (defense-in-depth — even if
      // an old record was published with sensitive fields, viewers will not see them).
      // This ALSO writes the cleaned versions back to the database to remove leaked data.
      const cleanPubProf=(pubProf||[]).map(p=>{const{email,...rest}=p;return rest});
      const cleanPubProj=(pubProj||[]).map(p=>{
        const{number,status,phase,progress,startDate,endDate,...rest}=p;
        // Derive year-only completion from old endDate if present
        const year=endDate?(new Date(endDate)).getFullYear():null;
        return{...rest,yearCompleted:status==="Completed"&&year?year:null,isOngoing:status&&status!=="Completed"};
      });
      setPublicCompanies(pubC||[]);
      setPublicProfiles(cleanPubProf);
      setPublicPosts(pubPosts||[]);
      setPublicProjects(cleanPubProj);
      // Write back the sanitized versions (asynchronously, fire-and-forget)
      if(JSON.stringify(cleanPubProf)!==JSON.stringify(pubProf||[]))sv(PUBLIC_KEYS.profiles,cleanPubProf);
      if(JSON.stringify(cleanPubProj)!==JSON.stringify(pubProj||[]))sv(PUBLIC_KEYS.showcased,cleanPubProj);
    })();
  },[SK]);

  // Compute budget from timesheets
  useEffect(()=>{
    if(!SK||projects.length===0)return;
    setProjects(prev=>prev.map(p=>{
      let spent=0;
      Object.entries(timesheets).forEach(([uid,weeks])=>{
        const u=users.find(x=>x.id===uid);
        const rate=HOURLY_RATES[u?.billableRole]||0;
        Object.values(weeks).forEach(weekData=>{
          // Sum labor cost from legacy proj:{id} AND all new proj:{id}:{phase} keys
          Object.entries(weekData).forEach(([k,row])=>{
            if(k==="expenses"||!Array.isArray(row))return;
            if(k===`proj:${p.id}`||k.startsWith(`proj:${p.id}:`)){
              spent+=row.reduce((a,b)=>a+b,0)*rate;
            }
          });
          if(weekData.expenses)weekData.expenses.filter(e=>e.projectId===p.id).forEach(e=>{spent+=e.amount||0});
        });
      });
      return{...p,budget:{...p.budget,spent:Math.round(spent*100)/100}};
    }));
  },[timesheets,users]);

  // Auto-save (debounced)
  const saveRef=useRef(null);const initRef=useRef(true);
  const prevTsRef=useRef({});
  useEffect(()=>{
    if(!SK||users.length===0)return;
    if(initRef.current){initRef.current=false;prevTsRef.current=timesheets;return}
    if(saveRef.current)clearTimeout(saveRef.current);
    saveRef.current=setTimeout(async()=>{
      setSaveStatus("saving");
      // For timesheets: diff against previous snapshot, save only changed users (prevents cross-user overwrite)
      const prevTs=prevTsRef.current||{};
      const changedUserIds=new Set();
      Object.keys(timesheets).forEach(uid=>{if(timesheets[uid]!==prevTs[uid])changedUserIds.add(uid)});
      Object.keys(prevTs).forEach(uid=>{if(!(uid in timesheets))changedUserIds.add(uid)}); // deletions
      prevTsRef.current=timesheets;
      const tsSaves=Array.from(changedUserIds).map(uid=>sv(`${SK.t}:${uid}`,timesheets[uid]||{}));
      await Promise.all([sv(SK.u,users),sv(SK.p,projects),...tsSaves,sv(SK.n,meetingNotes),sv(SK.f,newsFeed),sv(SK.a,actionItems),sv(SK.teams,teams),sv(SK.assignments,assignments),sv(SK.vacations,vacations),sv(SK.company,companyInfo),sv(SK.notifs,notifications),sv(SK.events,events),sv(SK.issues,issues)]);
      setSaveStatus("saved");setTimeout(()=>setSaveStatus(""),2000);
    },400);
    return()=>{if(saveRef.current)clearTimeout(saveRef.current)};
  },[users,projects,timesheets,meetingNotes,newsFeed,actionItems,teams,assignments,vacations,companyInfo,notifications,events,issues]);

  // Check for approaching deadlines (runs once when projects load for current user)
  useEffect(()=>{
    if(!user||!projects.length)return;
    const today=new Date();today.setHours(0,0,0,0);
    const existingKeys=new Set(notifications.filter(n=>n.userId===user.id&&n.type==="deadline").map(n=>n.link||""));
    const newNotifs=[];
    projects.forEach(p=>{
      if(!(p.team||[]).includes(user.id))return;
      (p.deadlines||[]).forEach(dl=>{
        const dlDate=new Date(dl.date);if(isNaN(dlDate))return;
        dlDate.setHours(0,0,0,0);
        const daysUntil=Math.round((dlDate-today)/864e5);
        // Alert at 7, 3, 1, 0 days away
        if([7,3,1,0].includes(daysUntil)){
          const key=`p:${p.id}:dl:${dl.id}:d${daysUntil}`;
          if(!existingKeys.has(key)){
            const label=daysUntil===0?"TODAY":daysUntil===1?"TOMORROW":`in ${daysUntil} days`;
            newNotifs.push({
              id:"n_"+Date.now()+"_"+Math.random().toString(36).slice(2,7),
              userId:user.id,type:"deadline",
              title:`⏰ Deadline ${label}: ${dl.title||"Deadline"}`,
              body:`Project "${p.name}" has a deadline ${label}.`,
              link:key,read:false,createdAt:new Date().toISOString()
            });
          }
        }
        // Check internal deadline (7 days before)
        if(dl.internalDate){
          const iDate=new Date(dl.internalDate);iDate.setHours(0,0,0,0);
          const daysUntilInt=Math.round((iDate-today)/864e5);
          if([3,1,0].includes(daysUntilInt)){
            const key=`p:${p.id}:dl:${dl.id}:int:d${daysUntilInt}`;
            if(!existingKeys.has(key)){
              const label=daysUntilInt===0?"TODAY":daysUntilInt===1?"TOMORROW":`in ${daysUntilInt} days`;
              newNotifs.push({
                id:"n_"+Date.now()+"_"+Math.random().toString(36).slice(2,7),
                userId:user.id,type:"deadline",
                title:`📋 Internal deadline ${label}: ${dl.title||"Deadline"}`,
                body:`Project "${p.name}" hits internal deadline ${label} (review phase starts).`,
                link:key,read:false,createdAt:new Date().toISOString()
              });
            }
          }
        }
      });
    });
    if(newNotifs.length>0)setNotifications(prev=>[...newNotifs,...prev]);
  },[user,projects]);

  // Auto-route Finance users to finance portal (they don't belong on the regular portfolio)
  // Must live at top level of App (before any early returns) to satisfy rules of hooks
  const financeRedirectRef=useRef(false);
  useEffect(()=>{
    if(user&&isFinance(user)&&!financeRedirectRef.current&&(page==="portfolio"||page==="cad"||page==="meeting"||page==="project")){
      financeRedirectRef.current=true;
      setPage("finance");
    }
  },[user,page]);

  // Browser history integration — back button navigates between in-app pages
  const historyRef=useRef({initialized:false});
  useEffect(()=>{
    if(!user)return;
    // On first mount, parse the current URL and restore the matching page
    if(!historyRef.current.initialized){
      const incomingPath=window.location.pathname;
      if(incomingPath&&incomingPath!=="/"){
        // URL was shared or bookmarked — restore from pathname
        const restored=pathToState(incomingPath,projects,users);
        if(restored.page!=="portfolio"||restored.activeProject){
          setPage(restored.page);
          if(restored.activeProject)setActiveProject(restored.activeProject);
          if(restored.profileUserId)setProfileUserId(restored.profileUserId);
        }
      }
      const path=pageToPath(page,activeProject,profileUserId,projects,users);
      window.history.replaceState({page,activeProject,profileUserId},"",path);
      historyRef.current.initialized=true;
    }
    // Listen for back/forward navigation
    const handlePopState=(e)=>{
      if(e.state){
        setPage(e.state.page||"portfolio");
        setActiveProject(e.state.activeProject||null);
        setProfileUserId(e.state.profileUserId||null);
      } else {
        // Fallback: parse the URL we've navigated to
        const restored=pathToState(window.location.pathname,projects,users);
        setPage(restored.page);
        setActiveProject(restored.activeProject);
        setProfileUserId(restored.profileUserId);
      }
    };
    window.addEventListener("popstate",handlePopState);
    return()=>window.removeEventListener("popstate",handlePopState);
  },[user]);

  // Push to history whenever page state changes (after initial mount)
  useEffect(()=>{
    if(!user||!historyRef.current.initialized)return;
    const currentState=window.history.state;
    if(currentState&&currentState.page===page&&currentState.activeProject===activeProject&&currentState.profileUserId===profileUserId)return;
    const path=pageToPath(page,activeProject,profileUserId,projects,users);
    // Dynamic page title
    let pageTitle="WorkBro";
    if(page==="project"&&activeProject){const p=projects.find(x=>x.id===activeProject);if(p)pageTitle=`${p.number} · ${p.name} — WorkBro`;}
    else if(page==="profile"&&profileUserId){const u=users.find(x=>x.id===profileUserId);if(u)pageTitle=`${u.name} — WorkBro`;}
    else{const TITLES={portfolio:"Projects — WorkBro",company:`${companyInfo?.name||"Company"} — WorkBro`,meeting:"My Team — WorkBro",timesheet:"Timesheet — WorkBro",cad:"CAD Team — WorkBro",discover:"Discover — WorkBro",finance:"Finance — WorkBro",issues:"Issues — WorkBro"};pageTitle=TITLES[page]||"WorkBro";}
    document.title=pageTitle;
    window.history.pushState({page,activeProject,profileUserId},pageTitle,path);
  },[page,activeProject,profileUserId,user]);

  // Keyboard shortcut
  useEffect(()=>{
    const handler=(e)=>{if((e.metaKey||e.ctrlKey)&&e.key==="k"){e.preventDefault();setShowSearch(true)}if(e.key==="Escape")setShowSearch(false)};
    window.addEventListener("keydown",handler);return()=>window.removeEventListener("keydown",handler);
  },[]);

  // ── URL ↔ app-state mapping ───────────────────────────────────
  // Maps internal page+activeProject+profileUserId to a readable URL path,
  // and parses incoming paths back to app state on load / popstate.
  const pageToPath=(pg,activeProj,profUserId,allProjects,allUsers)=>{
    if(pg==="project"&&activeProj){
      const p=allProjects.find(x=>x.id===activeProj);
      return p?`/project/${encodeURIComponent(p.number||p.id)}`:`/project/${activeProj}`;
    }
    if(pg==="profile"&&profUserId){
      const u=allUsers.find(x=>x.id===profUserId);
      const slug=u?u.name.toLowerCase().replace(/\s+/g,"-").replace(/[^a-z0-9-]/g,""):"user";
      return `/profile/${slug}--${profUserId}`;
    }
    const MAP={portfolio:"/",company:"/company",meeting:"/team",timesheet:"/timesheet",cad:"/cad",discover:"/discover",finance:"/finance",issues:"/issues"};
    return MAP[pg]||"/";
  };

  const pathToState=(pathname,allProjects,allUsers)=>{
    const p=pathname.replace(/\/$/,"");
    if(!p||p==="/")return{page:"portfolio",activeProject:null,profileUserId:null};
    if(p.startsWith("/project/")){
      const num=decodeURIComponent(p.replace("/project/",""));
      // Try match by number first, then by id
      const proj=allProjects.find(x=>x.number===num||x.id===num);
      return{page:"project",activeProject:proj?.id||null,profileUserId:null};
    }
    if(p.startsWith("/profile/")){
      const slug=p.replace("/profile/","");
      // Slug format: name--userId
      const parts=slug.split("--");
      const uid=parts[parts.length-1];
      return{page:"profile",activeProject:null,profileUserId:uid||null};
    }
    const MAP={"/company":"company","/team":"meeting","/timesheet":"timesheet","/cad":"cad","/discover":"discover","/finance":"finance","/issues":"issues"};
    return{page:MAP[p]||"portfolio",activeProject:null,profileUserId:null};
  };
  const handleLogin=(u,co)=>{setUser(u);setCompany(co);initRef.current=true};
  const handleExtLogin=(ext,co)=>{setExtUser(ext);setCompany(co);initRef.current=true};
  const handleLogout=()=>{localStorage.removeItem(SESSION_KEY);supabase.from("kv_store").delete().eq("key",SESSION_KEY);setUser(null);setExtUser(null);setCompany(null);setActiveProject(null);setPage("portfolio");initRef.current=true};

  const updateFocus=(pid,val,targetUserId)=>{
    const uid=targetUserId||user?.id;
    if(!uid)return;
    setProjects(p=>p.map(x=>x.id!==pid?x:setUserFocus(x,uid,val)));
  };
  const updateFocusHours=(pid,hours,targetUserId)=>{
    const uid=targetUserId||user?.id;
    if(!uid)return;
    setProjects(p=>p.map(x=>x.id!==pid?x:setUserFocusHours(x,uid,hours)));
  };
  const updateProgress=useCallback((pid,val)=>setProjects(p=>p.map(x=>x.id===pid?{...x,progress:val}:x)),[]);
  const toggleMilestone=(pid,mi)=>{
    setProjects(p=>p.map(x=>{
      if(x.id!==pid)return x;
      const updated=x.milestones.map((m,i)=>i===mi?{...m,done:!m.done}:m);
      // Side effect: notify team when a milestone is newly completed
      const old=x.milestones[mi];
      const now=updated[mi];
      if(old&&now&&!old.done&&now.done){
        const recipients=(x.team||[]).filter(uid=>uid!==user?.id);
        if(recipients.length>0){
          setTimeout(()=>addNotification(recipients,"update",
            `✅ Milestone complete: ${x.name}`,
            `${user?.name||"Teammate"} marked "${old.title||"milestone"}" as complete.`,
            `p:${pid}`),0);
        }
      }
      return{...x,milestones:updated};
    }));
  };
  const addUser=(u)=>setUsers(p=>[...p,u]);
  const deleteUser=(id)=>setUsers(p=>p.filter(u=>u.id!==id));
  const updateProfile=(updates)=>{setUsers(p=>p.map(u=>u.id===user.id?{...u,...updates}:u));setUser(prev=>({...prev,...updates}))};
  const addProject=(p)=>{
    setProjects(prev=>[...prev,p]);
    // Notify all team members assigned to the project
    if(p.team&&p.team.length>0){
      const recipients=p.team.filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        addNotification(recipients,"project",
          `📁 New project: ${p.name}`,
          `You've been added to "${p.name}" (${p.number}) by ${user?.name||"a teammate"}.`,
          `p:${p.id}`);
      }
    }
  };
  const editProject=(pid,updates)=>{
    setProjects(p=>p.map(x=>x.id===pid?{...x,...updates}:x));
    const proj=projects.find(x=>x.id===pid);
    if(!proj)return;
    const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
    if(recipients.length===0)return;
    if("status" in updates&&updates.status!==proj.status){
      addNotification(recipients,"update",
        `🔔 Project status: ${proj.name}`,
        `${user?.name||"Teammate"} changed status to "${updates.status}".`,
        `p:${pid}`);
      // Email all team members about status change
      const teamMembers=users.filter(u=>recipients.includes(u.id)&&u.email);
      teamMembers.forEach(u=>sendEmail(u.email,
        `Project update: ${proj.name} is now ${updates.status}`,
        `${proj.name} — Status Update`,
        `<p>Hi ${u.name},</p>
        <p><strong>${user?.name||"A teammate"}</strong> changed the status of <strong>${proj.number} · ${proj.name}</strong> to <strong>${updates.status}</strong>.</p>
        <p style="margin:24px 0"><a href="https://workbro.ca/project/${encodeURIComponent(proj.number)}" style="background:#c96a33;color:#fff;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600;">View Project →</a></p>`
      ));
    }
    // Notify + email newly added team members
    if("team" in updates&&Array.isArray(updates.team)){
      const newlyAdded=updates.team.filter(uid=>!(proj.team||[]).includes(uid)&&uid!==user?.id);
      if(newlyAdded.length>0){
        addNotification(newlyAdded,"project",
          `📁 Added to project: ${proj.name}`,
          `${user?.name||"Teammate"} added you to "${proj.name}" (${proj.number}).`,
          `p:${pid}`);
        // Email each newly added person
        const newMembers=users.filter(u=>newlyAdded.includes(u.id)&&u.email);
        newMembers.forEach(u=>sendEmail(u.email,
          `You've been added to ${proj.name}`,
          `You've been added to a project`,
          `<p>Hi ${u.name},</p>
          <p><strong>${user?.name||"A teammate"}</strong> added you to <strong>${proj.number} · ${proj.name}</strong>.</p>
          ${proj.phase?`<p style="color:#64748b;">Current phase: ${proj.phase}</p>`:""}
          <p style="margin:24px 0"><a href="https://workbro.ca/project/${encodeURIComponent(proj.number)}" style="background:#c96a33;color:#fff;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600;">View Project →</a></p>`
        ));
      }
    }
  };
  const addIssue=(pid,iss)=>{
    setProjects(p=>p.map(x=>x.id===pid?{...x,issues:[iss,...x.issues]}:x));
    const proj=projects.find(x=>x.id===pid);
    if(proj){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      const priorityEmoji=iss.priority==="High"?"🔴":iss.priority==="Medium"?"🟡":"🟢";
      if(recipients.length>0){
        addNotification(recipients,"rfi",
          `${priorityEmoji} New RFI: ${proj.name}`,
          `${user?.name||"Teammate"} raised "${iss.title||iss.subject||"RFI"}"${iss.priority?` (${iss.priority} priority)`:""}.`,
          `p:${pid}`);
      }
      // Also notify assignee if set separately
      if(iss.assignee&&iss.assignee!==user?.id&&!recipients.includes(iss.assignee)){
        addNotification(iss.assignee,"assignment",
          `📌 RFI assigned to you: ${proj.name}`,
          `${user?.name||"Teammate"} assigned you "${iss.title||iss.subject||"RFI"}".`,
          `p:${pid}`);
      }
    }
  };
  const addUpdate=(pid,upd)=>{
    setProjects(p=>p.map(x=>x.id===pid?{...x,updates:[upd,...x.updates]}:x));
    const proj=projects.find(x=>x.id===pid);
    if(proj){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        const preview=(upd.text||upd.message||"").slice(0,80);
        // In-app notification only — no email (high volume with 20 users)
        addNotification(recipients,"update",
          `📝 New note on ${proj.name}`,
          `${user?.name||"Teammate"}: "${preview}${preview.length>=80?"…":""}"`,
          `p:${pid}`);
      }
    }
  };
  const addMilestone=(pid,ms)=>{
    setProjects(p=>p.map(x=>x.id===pid?{...x,milestones:[...x.milestones,ms].sort((a,b)=>new Date(a.date)-new Date(b.date))}:x));
    const proj=projects.find(x=>x.id===pid);
    if(proj){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        const dateStr=ms.date?new Date(ms.date).toLocaleDateString("en-US",{month:"short",day:"numeric"}):"";
        addNotification(recipients,"deadline",
          `🎯 New milestone: ${proj.name}`,
          `${user?.name||"Teammate"} added "${ms.title||"Milestone"}"${dateStr?` for ${dateStr}`:""}.`,
          `p:${pid}`);
      }
    }
  };
  // Helper: keep milestones in sync with deadlines that have addAsMilestone:true
  // We tag synced milestones with `deadlineId` so we can find them again later.
  const syncMilestoneFromDeadline=(project,dl,action)=>{
    // action: "add"|"update"|"delete"
    const milestones=project.milestones||[];
    if(action==="delete"){
      return milestones.filter(m=>m.deadlineId!==dl.id);
    }
    const existing=milestones.find(m=>m.deadlineId===dl.id);
    if(!dl.addAsMilestone){
      // If user toggled OFF, remove the synced milestone
      return existing?milestones.filter(m=>m.deadlineId!==dl.id):milestones;
    }
    const ms={
      name:dl.title||dl.name||"Deadline",
      date:dl.date,
      done:!!dl.completed,
      deadlineId:dl.id,
    };
    if(existing){
      return milestones.map(m=>m.deadlineId===dl.id?{...m,...ms}:m);
    }else{
      return [...milestones,ms];
    }
  };

  const addDeadline=(pid,dl)=>{
    const id=dl.id||"dl_"+Date.now()+"_"+Math.random().toString(36).slice(2,6);
    const withId={...dl,id};
    setProjects(p=>p.map(x=>{
      if(x.id!==pid)return x;
      const newDeadlines=[...(x.deadlines||[]),withId].sort((a,b)=>new Date(a.date)-new Date(b.date));
      const newMilestones=syncMilestoneFromDeadline(x,withId,"add");
      return{...x,deadlines:newDeadlines,milestones:newMilestones};
    }));
    const proj=projects.find(x=>x.id===pid);
    if(proj){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      const dateStr=new Date(dl.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
      if(recipients.length>0){
        addNotification(recipients,"deadline",
          `⏰ New deadline: ${proj.name}`,
          `"${dl.title||"Deadline"}" set for ${dateStr}${dl.reviewer?` · reviewer assigned`:""}.`,
          `p:${pid}`);
      }
      if(dl.reviewer&&dl.reviewer!==user?.id){
        addNotification(dl.reviewer,"assignment",
          `📋 You're the reviewer: ${proj.name}`,
          `${user?.name||"Teammate"} assigned you to review "${dl.title||"Deadline"}" by ${dateStr}.`,
          `p:${pid}`);
      }
    }
  };
  const updateDeadline=(pid,dlId,updates)=>{
    const proj=projects.find(x=>x.id===pid);
    const oldDl=proj?.deadlines?.find(d=>d.id===dlId);
    setProjects(p=>p.map(x=>{
      if(x.id!==pid)return x;
      const newDeadlines=(x.deadlines||[]).map(d=>d.id===dlId?{...d,...updates}:d).sort((a,b)=>new Date(a.date)-new Date(b.date));
      const updatedDl=newDeadlines.find(d=>d.id===dlId);
      const newMilestones=updatedDl?syncMilestoneFromDeadline(x,updatedDl,"update"):x.milestones;
      return{...x,deadlines:newDeadlines,milestones:newMilestones};
    }));
    // Notify team if important fields changed
    if(proj&&oldDl){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        const dateChanged="date" in updates&&updates.date!==oldDl.date;
        const titleChanged="title" in updates&&updates.title!==oldDl.title;
        if(dateChanged||titleChanged){
          const newDate=new Date(updates.date||oldDl.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
          addNotification(recipients,"deadline",
            `✏️ Deadline updated: ${proj.name}`,
            `${user?.name||"Teammate"} changed "${oldDl.title||"deadline"}"${dateChanged?` — new date: ${newDate}`:""}.`,
            `p:${pid}`);
        }
      }
      // If reviewer was newly assigned
      if("reviewer" in updates&&updates.reviewer&&updates.reviewer!==oldDl.reviewer&&updates.reviewer!==user?.id){
        const dateStr=new Date(updates.date||oldDl.date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
        addNotification(updates.reviewer,"assignment",
          `📋 You're the reviewer: ${proj.name}`,
          `${user?.name||"Teammate"} assigned you to review "${updates.title||oldDl.title||"deadline"}" by ${dateStr}.`,
          `p:${pid}`);
      }
    }
  };
  const deleteDeadline=(pid,dlId)=>{
    const proj=projects.find(x=>x.id===pid);
    const dl=proj?.deadlines?.find(d=>d.id===dlId);
    setProjects(p=>p.map(x=>{
      if(x.id!==pid)return x;
      const targetDl=(x.deadlines||[]).find(d=>d.id===dlId);
      const newMilestones=targetDl?syncMilestoneFromDeadline(x,targetDl,"delete"):x.milestones;
      return{...x,deadlines:(x.deadlines||[]).filter(d=>d.id!==dlId),milestones:newMilestones};
    }));
    if(proj&&dl){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        addNotification(recipients,"deadline",
          `🗑 Deadline removed: ${proj.name}`,
          `${user?.name||"Teammate"} deleted "${dl.title||"deadline"}".`,
          `p:${pid}`);
      }
    }
  };
  const changeStatus=(pid,status)=>{
    const proj=projects.find(x=>x.id===pid);
    setProjects(p=>p.map(x=>x.id===pid?{...x,status}:x));
    if(proj&&status!==proj.status){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        const emoji=status==="Completed"?"✅":status==="On Hold"?"⏸":status==="In Progress"?"▶️":"🔔";
        addNotification(recipients,"update",
          `${emoji} ${proj.name}: ${status}`,
          `${user?.name||"Teammate"} changed status from "${proj.status}" to "${status}".`,
          `p:${pid}`);
      }
    }
  };
  const deleteProject=(pid)=>{setProjects(p=>p.filter(x=>x.id!==pid));setActiveProject(null)};
  const addResponse=(pid,rfiId,response,newStatus)=>{
    setProjects(p=>p.map(x=>{if(x.id!==pid)return x;return{...x,issues:x.issues.map(i=>{if(i.id!==rfiId)return i;const updated={...i};if(response)updated.responses=[...(i.responses||[]),response];if(newStatus)updated.status=newStatus;return updated})}}));
    // Notify team about RFI responses + status changes
    const proj=projects.find(x=>x.id===pid);
    const rfi=proj?.issues?.find(i=>i.id===rfiId);
    if(proj&&rfi){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(response&&recipients.length>0){
        const preview=(response.text||"").slice(0,60);
        addNotification(recipients,"rfi",
          `💬 RFI reply on ${proj.name}`,
          `${user?.name||"Teammate"} replied to "${rfi.title||rfi.subject||"RFI"}": "${preview}${preview.length>=60?"…":""}"`,
          `p:${pid}`);
      }
      if(newStatus&&newStatus!==rfi.status&&recipients.length>0){
        const statusEmoji=newStatus==="Closed"?"✅":newStatus==="In Review"?"🔍":"🟢";
        addNotification(recipients,"rfi",
          `${statusEmoji} RFI ${newStatus}: ${proj.name}`,
          `"${rfi.title||rfi.subject||"RFI"}" marked ${newStatus} by ${user?.name||"teammate"}.`,
          `p:${pid}`);
      }
    }
  };
  const addCoord=(pid,coord)=>{
    setProjects(p=>p.map(x=>x.id===pid?{...x,coordination:[...(x.coordination||[]),coord]}:x));
    const proj=projects.find(x=>x.id===pid);
    if(proj){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      if(recipients.length>0){
        addNotification(recipients,"update",
          `🔗 Coordination update: ${proj.name}`,
          `${user?.name||"Teammate"} added "${coord.discipline||coord.title||"coordination item"}".`,
          `p:${pid}`);
      }
    }
  };
  const addCoordNote=(pid,coordIdx,note)=>{
    setProjects(p=>p.map(x=>{if(x.id!==pid)return x;const coords=[...(x.coordination||[])];if(coords[coordIdx])coords[coordIdx]={...coords[coordIdx],messages:[...(coords[coordIdx].messages||[]),note]};return{...x,coordination:coords}}));
    const proj=projects.find(x=>x.id===pid);
    if(proj){
      const recipients=(proj.team||[]).filter(uid=>uid!==user?.id);
      const coord=proj.coordination?.[coordIdx];
      if(recipients.length>0){
        const preview=(note.text||note.message||"").slice(0,60);
        addNotification(recipients,"update",
          `💬 Coordination note: ${proj.name}`,
          `${user?.name||"Teammate"} on "${coord?.discipline||"coordination"}": "${preview}${preview.length>=60?"…":""}"`,
          `p:${pid}`);
      }
    }
  };
  const postNews=(post)=>setNewsFeed(prev=>[post,...prev]);

  // ── SOCIAL / PUBLIC LAYER ACTIONS ──
  // These write directly to the global PUBLIC_KEYS (cross-workspace).

  const publishProfile=async(profileData)=>{
    // profileData: {headline, about, skills, showcaseProjectIds, publicLocation}
    const me=user;if(!me)return;
    // PUBLIC PROFILE — only marketing-safe fields. Email is NEVER exposed publicly
    // (would lead to spam + privacy issues; users can connect via in-app messaging when that ships).
    const entry={
      userId:me.id,
      companyId:company?.id||null,
      companyName:companyInfo?.name||company?.name||"",
      name:me.name,
      role:me.role,
      avatar:me.avatar,
      profileColor:me.profileColor,
      headline:profileData.headline||"",
      about:profileData.about||"",
      skills:profileData.skills||[],
      showcaseProjectIds:profileData.showcaseProjectIds||[],
      publicLocation:profileData.publicLocation||"",
      publishedAt:new Date().toISOString(),
    };
    // Re-fetch latest, merge, save (avoid clobbering other users' edits)
    const fresh=await ld(PUBLIC_KEYS.profiles,[]);
    // Strip email from any pre-existing record too (one-time migration of stored data)
    const cleaned=fresh.map(p=>{const{email,...rest}=p;return rest});
    const updated=[entry,...cleaned.filter(p=>p.userId!==me.id)];
    setPublicProfiles(updated);
    sv(PUBLIC_KEYS.profiles,updated);
    // Mark user as having public profile in their own user record
    setUsers(prev=>prev.map(u=>u.id===me.id?{...u,publicProfile:true,publicProfileData:profileData}:u));
  };

  const unpublishProfile=async()=>{
    const me=user;if(!me)return;
    const fresh=await ld(PUBLIC_KEYS.profiles,[]);
    const updated=fresh.filter(p=>p.userId!==me.id);
    setPublicProfiles(updated);
    sv(PUBLIC_KEYS.profiles,updated);
    setUsers(prev=>prev.map(u=>u.id===me.id?{...u,publicProfile:false}:u));
  };

  const publishCompany=async()=>{
    if(!isAdmin(user)||!company)return;
    const entry={
      companyId:company.id,
      name:companyInfo?.name||company.name,
      logo:companyInfo?.logo||null,
      banner:companyInfo?.banner||null,
      tagline:companyInfo?.tagline||"",
      about:companyInfo?.about||"",
      industry:companyInfo?.industry||"",
      location:companyInfo?.location||"",
      size:companyInfo?.size||"",
      founded:companyInfo?.founded||"",
      website:companyInfo?.website||"",
      memberCount:users.filter(u=>isStaff(u)&&u.status!=="pending").length,
      activeProjects:projects.filter(p=>p.status!=="Archived"&&p.status!=="Completed").length,
      listedAt:new Date().toISOString(),
    };
    const fresh=await ld(PUBLIC_KEYS.companies,[]);
    const updated=[entry,...fresh.filter(c=>c.companyId!==company.id)];
    setPublicCompanies(updated);
    sv(PUBLIC_KEYS.companies,updated);
    setCompanyInfo(prev=>({...prev,publicCompany:true}));
  };

  const unpublishCompany=async()=>{
    if(!isAdmin(user)||!company)return;
    const fresh=await ld(PUBLIC_KEYS.companies,[]);
    const updated=fresh.filter(c=>c.companyId!==company.id);
    setPublicCompanies(updated);
    sv(PUBLIC_KEYS.companies,updated);
    setCompanyInfo(prev=>({...prev,publicCompany:false}));
  };

  const postToPublicFeed=async(text,authorType="user",linkedProjectId=null)=>{
    if(!user||!text.trim())return;
    const entry={
      id:genId("pub"),
      authorType, // 'user' or 'company'
      authorId:authorType==="company"?company?.id:user.id,
      authorName:authorType==="company"?(companyInfo?.name||company?.name):user.name,
      authorAvatar:authorType==="company"?(companyInfo?.logo?null:"🏢"):user.avatar,
      authorAvatarLogo:authorType==="company"?companyInfo?.logo:null,
      authorAvatarColor:authorType==="user"?user.profileColor:null,
      authorRole:authorType==="user"?user.role:null,
      authorCompanyId:company?.id||null,
      authorCompanyName:companyInfo?.name||company?.name||"",
      text:text.trim(),
      projectId:linkedProjectId,
      date:new Date().toISOString(),
      likes:[],
    };
    const fresh=await ld(PUBLIC_KEYS.posts,[]);
    const updated=[entry,...fresh].slice(0,500); // cap at 500 posts globally to keep storage manageable
    setPublicPosts(updated);
    sv(PUBLIC_KEYS.posts,updated);
  };

  const togglePublicPostLike=async(postId)=>{
    if(!user)return;
    const fresh=await ld(PUBLIC_KEYS.posts,[]);
    const updated=fresh.map(p=>{
      if(p.id!==postId)return p;
      const likes=p.likes||[];
      return{...p,likes:likes.includes(user.id)?likes.filter(uid=>uid!==user.id):[...likes,user.id]};
    });
    setPublicPosts(updated);
    sv(PUBLIC_KEYS.posts,updated);
  };

  const deletePublicPost=async(postId)=>{
    if(!confirm("Delete this post from the public feed?"))return;
    const fresh=await ld(PUBLIC_KEYS.posts,[]);
    const updated=fresh.filter(p=>{
      if(p.id!==postId)return true;
      // Only allow author or admin (of the author's company) to delete
      const isAuthor=p.authorId===user.id||p.authorId===company?.id;
      return !isAuthor;
    });
    setPublicPosts(updated);
    sv(PUBLIC_KEYS.posts,updated);
  };

  const showcaseProject=async(projectId,description)=>{
    const proj=projects.find(p=>p.id===projectId);
    if(!proj||!user)return;
    // PUBLIC SHOWCASE — only marketing-safe fields. NEVER expose internal workflow data:
    // - No project number (internal accounting reference)
    // - No status / phase / progress (internal workflow state)
    // - No exact start / end dates (could reveal deadlines, ongoing schedule)
    // - Only year is shared, derived from end date if available
    const yearCompleted=proj.endDate?(new Date(proj.endDate)).getFullYear():null;
    const isCompleted=proj.status==="Completed";
    const entry={
      projectId:proj.id,
      companyId:company?.id,
      companyName:companyInfo?.name||company?.name,
      ownerId:user.id,
      name:proj.name,
      type:proj.type,                          // Marketing: "Residential", "Commercial", etc.
      location:proj.location||"",              // City — usually a marketing point
      yearCompleted:isCompleted?yearCompleted:null,
      isOngoing:!isCompleted,                  // Just a boolean — no progress %
      description:description||"",             // User-written marketing copy
      publishedAt:new Date().toISOString(),
    };
    const fresh=await ld(PUBLIC_KEYS.showcased,[]);
    const updated=[entry,...fresh.filter(p=>p.projectId!==projectId)];
    setPublicProjects(updated);
    sv(PUBLIC_KEYS.showcased,updated);
  };

  const unshowcaseProject=async(projectId)=>{
    const fresh=await ld(PUBLIC_KEYS.showcased,[]);
    const updated=fresh.filter(p=>p.projectId!==projectId);
    setPublicProjects(updated);
    sv(PUBLIC_KEYS.showcased,updated);
  };

  // ── DIRECT MESSAGES ──
  // Loads the user's thread index + each thread's metadata so we know who they've
  // messaged with and whether anything is unread. Threads are loaded on demand.
  const loadDmThreads=async()=>{
    if(!user)return;
    const indexEntries=await ld(dmUserIndexKey(user.id),[]);
    if(!Array.isArray(indexEntries)||indexEntries.length===0){setDmThreads([]);return}
    // For each thread, load the latest message preview
    const threadsWithPreview=await Promise.all(indexEntries.map(async(e)=>{
      const messages=await ld(e.threadId,[]);
      const lastMsg=Array.isArray(messages)&&messages.length>0?messages[messages.length-1]:null;
      const unreadCount=Array.isArray(messages)?messages.filter(m=>m.from===e.otherUserId&&!(m.readBy||[]).includes(user.id)).length:0;
      return{
        threadId:e.threadId,
        otherUserId:e.otherUserId,
        lastMessage:lastMsg?.text||"",
        lastMessageAt:lastMsg?.sentAt||e.startedAt,
        unread:unreadCount,
      };
    }));
    threadsWithPreview.sort((a,b)=>new Date(b.lastMessageAt||0)-new Date(a.lastMessageAt||0));
    setDmThreads(threadsWithPreview);
  };

  const openDmThread=async(otherUserId)=>{
    if(!user||!otherUserId||otherUserId===user.id)return;
    const tid=dmThreadId(user.id,otherUserId);
    const messages=await ld(tid,[]);
    setActiveDmThread({threadId:tid,otherUserId,messages:Array.isArray(messages)?messages:[]});

    // Mark messages from the other user as read
    const updated=(Array.isArray(messages)?messages:[]).map(m=>{
      if(m.from===otherUserId&&!(m.readBy||[]).includes(user.id)){
        return{...m,readBy:[...(m.readBy||[]),user.id]};
      }
      return m;
    });
    if(JSON.stringify(updated)!==JSON.stringify(messages))sv(tid,updated);

    // Refresh thread index unread counts
    loadDmThreads();
  };

  const sendDm=async(text)=>{
    if(!user||!activeDmThread||!text.trim())return;
    const tid=activeDmThread.threadId;
    const fresh=await ld(tid,[]);
    const messages=Array.isArray(fresh)?fresh:[];
    const newMsg={
      id:genId("msg"),
      from:user.id,
      to:activeDmThread.otherUserId,
      text:text.trim(),
      sentAt:new Date().toISOString(),
      readBy:[user.id], // sender always has it as "read"
    };
    const updated=[...messages,newMsg].slice(-200); // cap thread size at 200 messages to avoid bloat
    sv(tid,updated);
    setActiveDmThread({...activeDmThread,messages:updated});

    // Update both users' indexes (so the other user sees a new thread)
    const startedAt=new Date().toISOString();
    const myIdx=await ld(dmUserIndexKey(user.id),[]);
    const myIdxArr=Array.isArray(myIdx)?myIdx:[];
    if(!myIdxArr.find(e=>e.threadId===tid)){
      myIdxArr.push({threadId:tid,otherUserId:activeDmThread.otherUserId,startedAt});
      sv(dmUserIndexKey(user.id),myIdxArr);
    }
    const theirIdx=await ld(dmUserIndexKey(activeDmThread.otherUserId),[]);
    const theirIdxArr=Array.isArray(theirIdx)?theirIdx:[];
    if(!theirIdxArr.find(e=>e.threadId===tid)){
      theirIdxArr.push({threadId:tid,otherUserId:user.id,startedAt});
      sv(dmUserIndexKey(activeDmThread.otherUserId),theirIdxArr);
    }
    loadDmThreads();
  };

  // Auto-load threads when user logs in
  useEffect(()=>{
    if(user)loadDmThreads();
  },[user?.id]);

  // ── Deadline reminder emails (day-of only) ──
  // Sends one email per deadline on the actual deadline day.
  // Uses localStorage to avoid re-sending if user logs in multiple times same day.
  useEffect(()=>{
    if(!user||!projects.length)return;
    const TODAY=new Date().toISOString().split("T")[0];
    const SENT_KEY=`wb:deadline_reminders:${TODAY}`;
    const alreadySent=JSON.parse(localStorage.getItem(SENT_KEY)||"[]");
    const newlySent=[...alreadySent];

    projects.forEach(p=>{
      if(p.status==="Archived"||p.status==="Completed")return;
      (p.deadlines||[]).forEach(dl=>{
        const days=Math.ceil((new Date(dl.date)-new Date())/864e5);
        if(days!==0)return; // day-of only
        const sentId=`${p.id}:${dl.id||dl.date}:0`;
        if(newlySent.includes(sentId))return;
        newlySent.push(sentId);
        const teamMembers=users.filter(u=>(p.team||[]).includes(u.id)&&u.email&&u.status==="active");
        teamMembers.forEach(u=>{
          sendEmail(u.email,
            `🔴 Deadline today: ${dl.label||dl.name||"Deadline"} — ${p.name}`,
            `Deadline Today`,
            `<p>Hi ${u.name},</p>
            <p>This deadline is <strong>today</strong>:</p>
            <div style="margin:20px 0;padding:16px 20px;background:#f8fafc;border-left:4px solid #eb5757;border-radius:4px;">
              <div style="font-weight:700;font-size:16px;color:#0f172a;">${dl.label||dl.name||"Deadline"}</div>
              <div style="color:#475569;margin-top:4px;">📁 ${p.number} · ${p.name}</div>
              <div style="color:#475569;margin-top:4px;">📅 ${new Date(dl.date).toLocaleDateString("en-CA",{weekday:"long",year:"numeric",month:"long",day:"numeric"})}</div>
              ${dl.description?`<div style="color:#64748b;margin-top:8px;font-size:13px;">${dl.description}</div>`:""}
            </div>
            <p style="margin:24px 0"><a href="https://workbro.ca/project/${encodeURIComponent(p.number)}" style="background:#c96a33;color:#fff;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600;">View Project →</a></p>`
          );
        });
      });
    });
    localStorage.setItem(SENT_KEY,JSON.stringify(newlySent));
    Object.keys(localStorage).filter(k=>k.startsWith("wb:deadline_reminders:")&&k<`wb:deadline_reminders:${new Date(Date.now()-3*864e5).toISOString().split("T")[0]}`).forEach(k=>localStorage.removeItem(k));
  },[user?.id,projects.length]);

  const updateActions=(pid,items)=>{
    const prevItems=actionItems[pid]||[];
    const proj=projects.find(x=>x.id===pid);
    // Detect newly added action items
    const prevIds=new Set(prevItems.map(a=>a.id));
    const newOnes=items.filter(a=>!prevIds.has(a.id));
    setActionItems(prev=>({...prev,[pid]:items}));
    // Notify team + assignee for each new action item
    if(proj&&newOnes.length>0){
      newOnes.forEach(a=>{
        const teamRecipients=(proj.team||[]).filter(uid=>uid!==user?.id&&uid!==a.assignee);
        const priorityEmoji=a.priority==="High"?"🔴":a.priority==="Medium"?"🟡":"🟢";
        if(teamRecipients.length>0){
          addNotification(teamRecipients,"action",
            `${priorityEmoji} New action: ${proj.name}`,
            `${user?.name||"Teammate"} added "${a.text}"${a.dueDate?` · due ${a.dueDate}`:""}.`,
            `p:${pid}`);
        }
        if(a.assignee&&a.assignee!==user?.id){
          addNotification(a.assignee,"assignment",
            `📌 Action assigned to you: ${proj.name}`,
            `${user?.name||"Teammate"} assigned you "${a.text}"${a.dueDate?` · due ${a.dueDate}`:""}.`,
            `p:${pid}`);
        }
      });
    }
  };
  const handleReset=async()=>{if(!isAdmin(user)||!SK)return;if(!confirm("Reset ALL company data?"))return;setUsers([{...user}]);setProjects([]);setTimesheets({});setMeetingNotes({});setNewsFeed([]);setActionItems({});setTeams([]);await Promise.all([sv(SK.u,[{...user}]),sv(SK.p,[]),sv(SK.t,{}),sv(SK.n,{}),sv(SK.f,[]),sv(SK.a,{}),sv(SK.teams,[])]);setActiveProject(null);setModal(null);setPage("portfolio")};
  // Approve pending user
  const approveUser=(uid)=>{
    const u=users.find(x=>x.id===uid);
    setUsers(p=>p.map(x=>x.id===uid?{...x,status:"active"}:x));
    // Email the approved user
    if(u?.email){
      sendEmail(u.email,
        `✅ You've been approved to join ${companyInfo?.name||company?.name||"WorkBro"}`,
        `You've been approved to join ${companyInfo?.name||company?.name||"WorkBro"}`,
        `<p>Hi ${u.name},</p>
        <p>Great news — your request to join <strong>${companyInfo?.name||company?.name||"your workspace"}</strong> on WorkBro has been approved by ${user?.name||"an admin"}.</p>
        <p style="margin:24px 0"><a href="https://workbro.ca" style="background:#c96a33;color:#fff;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600;">Log in to WorkBro →</a></p>
        <p style="color:#64748b;font-size:13px;">Use the email and PIN you registered with to sign in.</p>`
      );
    }
  };

  // ── Email helper — calls the Supabase Edge Function ──────────
  const sendEmail=async(to,subject,title,htmlBody)=>{
    try{
      const html=`<!DOCTYPE html><html><head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#f4f4f5;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;">
<div style="max-width:560px;margin:40px auto;background:#ffffff;border-radius:12px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.08);">
<div style="background:#c96a33;padding:24px 32px;"><div style="font-size:22px;font-weight:700;color:#ffffff;letter-spacing:-.02em;">WorkBro</div></div>
<div style="padding:32px;"><h2 style="margin:0 0 16px;font-size:20px;font-weight:700;color:#0f172a;">${title}</h2>${htmlBody}</div>
<div style="padding:20px 32px;border-top:1px solid #f0f0f0;background:#fafafa;"><p style="margin:0;font-size:11px;color:#94a3b8;">This is an automated message from WorkBro · workbro.ca</p></div>
</div></body></html>`;
      await fetch("https://nccvxhjxpgocrfudxhrl.supabase.co/functions/v1/send-email",{
        method:"POST",
        headers:{
          "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5jY3Z4aGp4cGdvY3JmdWR4aHJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYwMTgwMzYsImV4cCI6MjA5MTU5NDAzNn0.xnn2_nmemFV9mVSQoQe9EhQmnNaLGgH74eI7Uf3-QkA",
          "Content-Type":"application/json"
        },
        body:JSON.stringify({to,subject,html})
      });
    }catch(e){console.warn("Email send failed:",e.message);}
  };

  // Notification helpers
  const addNotification=(recipientIds,type,title,body,link)=>{
    const ids=Array.isArray(recipientIds)?recipientIds:[recipientIds];
    const notifs=ids.filter(Boolean).map(uid=>({
      id:"n_"+Date.now()+"_"+Math.random().toString(36).slice(2,7),
      userId:uid,type,title,body:body||"",link:link||null,
      read:false,createdAt:new Date().toISOString()
    }));
    if(notifs.length>0)setNotifications(prev=>[...notifs,...prev]);
  };
  const markNotifRead=(nid)=>setNotifications(prev=>prev.map(n=>n.id===nid?{...n,read:true}:n));
  const markAllNotifsRead=()=>setNotifications(prev=>prev.map(n=>n.userId===user?.id?{...n,read:true}:n));
  const deleteNotif=(nid)=>setNotifications(prev=>prev.filter(n=>n.id!==nid));
  const myNotifications=user?notifications.filter(n=>n.userId===user.id):[];
  const unreadCount=myNotifications.filter(n=>!n.read).length;

  // ── Connections (request/accept/decline) ─────────────────────
  // User shape additions: { connections: [uid,...], pendingFromMe: [uid,...] }
  // Pending requests TO me are computed by scanning other users' pendingFromMe.
  const sendConnectionRequest=(targetUid)=>{
    if(!user||!targetUid||targetUid===user.id)return;
    setUsers(prev=>prev.map(u=>{
      if(u.id===user.id){
        const pendingFromMe=u.pendingFromMe||[];
        if(pendingFromMe.includes(targetUid))return u;
        return {...u,pendingFromMe:[...pendingFromMe,targetUid]};
      }
      return u;
    }));
    const me=users.find(u=>u.id===user.id);
    addNotification(targetUid,"connection_request",
      `${me?.name||"Someone"} wants to connect`,
      `${me?.profileHeadline||me?.role||""} · Tap to review`,
      `connectionRequest:${user.id}`);
  };
  const acceptConnectionRequest=(fromUid)=>{
    if(!user||!fromUid)return;
    setUsers(prev=>prev.map(u=>{
      if(u.id===user.id){
        const conns=u.connections||[];
        return conns.includes(fromUid)?u:{...u,connections:[...conns,fromUid]};
      }
      if(u.id===fromUid){
        const conns=u.connections||[];
        const pfm=(u.pendingFromMe||[]).filter(id=>id!==user.id);
        return {...u,pendingFromMe:pfm,connections:conns.includes(user.id)?conns:[...conns,user.id]};
      }
      return u;
    }));
    // Remove the original connection_request notification(s) from sender
    setNotifications(prev=>prev.filter(n=>!(n.userId===user.id&&n.type==="connection_request"&&n.link===`connectionRequest:${fromUid}`)));
    // Notify the sender that you accepted
    const me=users.find(u=>u.id===user.id);
    addNotification(fromUid,"connection_accepted",
      `${me?.name||"Someone"} accepted your request`,
      `You're now connected.`,
      `profile:${user.id}`);
  };
  const declineConnectionRequest=(fromUid)=>{
    if(!user||!fromUid)return;
    setUsers(prev=>prev.map(u=>{
      if(u.id===fromUid){
        const pfm=(u.pendingFromMe||[]).filter(id=>id!==user.id);
        return {...u,pendingFromMe:pfm};
      }
      return u;
    }));
    setNotifications(prev=>prev.filter(n=>!(n.userId===user.id&&n.type==="connection_request"&&n.link===`connectionRequest:${fromUid}`)));
  };
  // Inbound pending requests for current user (those who have me in their pendingFromMe)
  const pendingRequests=user?users.filter(u=>(u.pendingFromMe||[]).includes(user.id)):[];

  // ── Deadline reminder emails ───────────────────────────────
  // Runs once on mount + every hour. Sends reminder email when:
  //  - 7 days before deadline (one-week reminder)
  //  - 1 day before (final reminder)
  //  - on deadline day
  // Each deadline tracks `reminderSentFor:[7,1,0]` so we don't re-send.
  useEffect(()=>{
    if(!user||!projects?.length)return;
    const runScan=()=>{
      const today=new Date();today.setHours(0,0,0,0);
      const todayMs=today.getTime();
      projects.forEach(p=>{
        if(p.status==="Completed"||p.status==="Archived")return;
        (p.deadlines||[]).forEach(dl=>{
          if(!dl.date||dl.completed)return;
          const dlDate=new Date(dl.date);dlDate.setHours(0,0,0,0);
          const daysOut=Math.round((dlDate.getTime()-todayMs)/86400000);
          const sentMarkers=dl.reminderSentFor||[];
          // Check each milestone
          [7,1,0].forEach(threshold=>{
            if(daysOut===threshold&&!sentMarkers.includes(threshold)){
              // Send reminder
              const team=(p.team||[]).map(uid=>users.find(u=>u.id===uid)).filter(u=>u&&u.email);
              if(team.length>0){
                const label=threshold===7?"1 week away":threshold===1?"due tomorrow":"due today";
                const subject=`⏰ Deadline ${label}: ${dl.name||dl.title||"Deadline"} — ${p.name}`;
                const niceDate=dlDate.toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"});
                const kindLabel=dl.kind==="external"?"📤 External":"🏢 Internal";
                team.forEach(u=>{
                  sendEmail(u.email,subject,`${label==="due today"?"⚠️ Deadline today":label==="due tomorrow"?"⏰ Deadline tomorrow":"📅 Deadline reminder"}`,
                    `<p style="margin:0 0 12px;font-size:15px;color:#1f2937;">Hi ${u.name?.split(" ")[0]||"there"},</p>
                    <p style="margin:0 0 16px;font-size:14px;color:#374151;line-height:1.6;">This is an automated reminder for an upcoming deadline.</p>
                    <div style="padding:16px;background:#fafafa;border:1px solid #e5e7eb;border-radius:8px;margin-bottom:16px;">
                      <div style="font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.06em;color:#6b7280;margin-bottom:6px;">${kindLabel} deadline</div>
                      <div style="font-size:16px;font-weight:600;color:#0f172a;margin-bottom:4px;">${dl.name||dl.title||"Deadline"}</div>
                      <div style="font-size:13px;color:#6b7280;">Project: ${p.name} · ${p.number||""}</div>
                      <div style="font-size:13px;color:${threshold===0?"#dc2626":threshold===1?"#d97706":"#c96a33"};font-weight:600;margin-top:10px;">${niceDate} (${label})</div>
                    </div>
                    <p style="margin:0;font-size:13px;color:#6b7280;">Open the project in WorkBro to review status, mark as complete, or update the date.</p>`);
                });
                // Also create in-app notification
                addNotification((p.team||[]).filter(uid=>uid!==user?.id),"deadline",
                  `⏰ ${label==="due today"?"DEADLINE TODAY":label==="due tomorrow"?"Deadline tomorrow":"Deadline in 1 week"}: ${dl.name||dl.title||"Deadline"}`,
                  `${p.name} · ${niceDate}`,
                  `p:${p.id}`);
                // Mark as sent so we don't re-send
                setProjects(prev=>prev.map(x=>{
                  if(x.id!==p.id)return x;
                  return{...x,deadlines:(x.deadlines||[]).map(d=>d.id===dl.id?{...d,reminderSentFor:[...(d.reminderSentFor||[]),threshold]}:d)};
                }));
              }
            }
          });
        });
      });
    };
    // Initial run on mount
    runScan();
    // Run every hour
    const interval=setInterval(runScan,60*60*1000);
    return ()=>clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[projects?.length,user?.id]);

  const updateUserRole=(uid,updates)=>{
    const target=users.find(u=>u.id===uid);
    if(!target)return;
    if(target.email?.toLowerCase()===SUPER_ADMIN_EMAIL)return;
    if(!isAdmin(user)&&!isPM(user))return;
    setUsers(p=>p.map(u=>u.id===uid?{...u,...updates}:u));
  };

  // ── Loading ──
  if(loading)return <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:"var(--bg, #f8f9fa)",fontFamily:"var(--font-sans,sans-serif)"}}><div style={{textAlign:"center"}}><LogoImg h={56} style={{marginBottom:16}}/><div style={{color:"#666",fontSize:14}}>Loading WorkBro...</div><div style={{marginTop:8,fontSize:11,color:dbStatus==="ok"?"#2ecc71":dbStatus==="error"?"#ff6b6b":"#aaa"}}>{dbStatus==="ok"?"● Database connected":dbStatus==="error"?"● Database error — check console":"● Connecting..."}</div></div></div>;

  // ── No user → Login ──
  if(!user&&!extUser)return <div style={S.app}><LandingPage onLogin={handleLogin} onExternalLogin={handleExtLogin}/></div>;

  const cur=projects.find(p=>p.id===activeProject);

  // ── EXTERNAL USER VIEW ──
  if(extUser&&company){
    const proj=projects.find(p=>p.id===extUser.projectId);
    if(!proj)return <div style={S.app}><div style={{padding:40,textAlign:"center"}}><div style={{fontSize:18,color:C.red}}>Project not found.</div><button style={{...S.btn,marginTop:16}} onClick={handleLogout}>Back to Login</button></div></div>;
    return <div style={S.app}>
      <div style={S.topbar}>
        <div style={{display:"flex",alignItems:"center",gap:8}}><LogoImg h={30} style={{cursor:"pointer"}}/><span style={{fontSize:11,color:C.textDim,background:C.card,padding:"2px 8px",borderRadius:4}}>{company.name}</span></div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{textAlign:"right"}}><div style={{fontSize:13,fontWeight:600}}>{extUser.name}<RoleBadge role={extUser.role}/></div><div style={{fontSize:11,color:C.textDim}}>{proj.name}</div></div>
          <div style={S.avatar}>{extUser.profilePhoto?<img src={extUser.profilePhoto} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:extUser.avatar}</div>
          <button style={{...S.btnO,padding:"6px 14px",fontSize:12,color:C.red,borderColor:C.red}} onClick={handleLogout}>Logout</button>
        </div>
      </div>
      <div style={S.main}>
        <ProjectDetailView project={proj} user={extUser} users={users} onBack={handleLogout} setModal={setModal} onUpdateProgress={updateProgress} onToggleMilestone={toggleMilestone} hideBudgetSpend={true} onChangeStatus={changeStatus} onDeleteProject={deleteProject} onAddResponse={addResponse} onAddCoordNote={addCoordNote}/>
      </div>
      {modal?.type==="addIssue"&&<AddIssueModal onClose={()=>setModal(null)} onAdd={addIssue} users={users} projectId={modal.pid} currentUser={extUser}/>}
      {modal?.type==="addUpdate"&&<AddUpdateModal onClose={()=>setModal(null)} onAdd={addUpdate} projectId={modal.pid} userId={extUser.id}/>}
      {modal?.type==="addCoord"&&<AddCoordModal onClose={()=>setModal(null)} onAdd={addCoord} projectId={modal.pid} defaults={modal.defaults}/>}
    </div>;
  }

  if(!user)return <div style={S.app}><LandingPage onLogin={handleLogin} onExternalLogin={handleExtLogin}/></div>;

  // ── STAFF VIEW ──
  const openProject=(id)=>{setActiveProject(id);setPage("project");setProfileUserId(null)};
  const openProfile=(uid)=>{setProfileUserId(uid);setPage("profile");setActiveProject(null)};
  const backToPortfolio=()=>{setActiveProject(null);setProfileUserId(null);setPage("portfolio")};

  // ── MOBILE: full desktop app by default (responsive); compact "Lite" shell is opt-in ──
  if(isMobile&&mobileLite){
    return <div style={S.app}>
      <MobileApp
        user={user} users={users} projects={projects}
        timesheets={timesheets} setTimesheets={setTimesheets}
        newsFeed={newsFeed} postNews={postNews}
        updateProfile={updateProfile}
        darkMode={darkMode} setDarkMode={setDarkMode}
        notifications={notifications} setNotifications={setNotifications}
        companyInfo={companyInfo} company={company}
        actionItems={actionItems} onUpdateActions={updateActions}
        publicPosts={publicPosts} publicProfiles={publicProfiles}
        openDmThread={openDmThread}
        setModal={setModal}
        activeDmThread={activeDmThread} dmThreads={dmThreads}
        issues={issues} setIssues={setIssues}
        teams={teams}
        onUpdateProject={editProject}
        addDeadline={addDeadline}
        vacations={vacations} setVacations={setVacations}
        events={events} setEvents={setEvents}
        logout={handleLogout}
        onSwitchToFull={()=>{setMobileLite(false);localStorage.setItem("wb:mobileLite","0")}}
      />
    </div>;
  }

  return <div style={S.app}>
    <div style={{...S.topbar,...(isMobile?{flexWrap:"nowrap",gap:6,padding:"8px 8px",minHeight:52}:{})}}>
      <div style={{display:"flex",alignItems:"center",gap:isMobile?6:14,minWidth:0}}>
        <button onClick={()=>setShowSidebar(!showSidebar)} style={{...S.btnO,padding:"6px 10px",fontSize:14,minWidth:36,border:"none",background:"transparent"}} title={showSidebar?"Collapse menu":"Expand menu"}>☰</button>
        <span style={{cursor:"pointer"}} onClick={backToPortfolio} title="Go to home"><LogoImg h={isMobile?22:26}/></span>
        {!isMobile&&companyInfo?.logo&&<><div style={{width:1,height:24,background:C.border}}/><img src={companyInfo.logo} alt={companyInfo.name||"Company"} style={{height:26,objectFit:"contain",maxWidth:120,cursor:"pointer"}} onClick={()=>{setPage("company");setActiveProject(null);setProfileUserId(null)}} title={`View ${companyInfo.name||"company"} profile`}/></>}
        {!isMobile&&!companyInfo?.logo&&isAdmin(user)&&<button onClick={()=>setModal("companySettings")} style={{...S.btnO,padding:"4px 10px",fontSize:11,color:C.textDim,borderColor:C.border}} title="Add your company logo">+ Company Logo</button>}
        {!isMobile&&company&&<span onClick={()=>{setPage("company");setActiveProject(null);setProfileUserId(null)}} style={{fontSize:11,color:C.textDim,background:C.card,padding:"3px 10px",borderRadius:6,fontWeight:500,cursor:"pointer",transition:"background .12s, color .12s"}} onMouseEnter={e=>{e.currentTarget.style.background=C.accentSoft;e.currentTarget.style.color=C.accent}} onMouseLeave={e=>{e.currentTarget.style.background=C.card;e.currentTarget.style.color=C.textDim}} title={`View ${company.name} profile`}>{company.name}</span>}
        <button onClick={()=>setShowSearch(true)} style={{display:"flex",alignItems:"center",gap:6,padding:isMobile?"6px 10px":"6px 14px",background:C.card,border:`1px solid ${C.border}`,borderRadius:8,cursor:"pointer",fontFamily:"'Inter',sans-serif",fontSize:12,color:C.textDim}}>🔍{!isMobile&&<> Search<span style={{fontSize:10,color:C.border,marginLeft:8,background:C.bg,padding:"1px 6px",borderRadius:4}}>⌘K</span></>}</button>
        {!isMobile&&saveStatus&&<span style={{fontSize:11,color:saveStatus==="saving"?C.amber:C.green,fontWeight:500}}>{saveStatus==="saving"?"Saving...":"✓ Saved"}</span>}
      </div>
      <div style={{display:"flex",alignItems:"center",gap:isMobile?3:6,flexShrink:0}}>
        {canManageTeam(user)&&!isFinance(user)&&<button style={{...S.btnO,padding:isMobile?"6px 7px":"6px 12px",fontSize:isMobile?14:12,minWidth:isMobile?30:undefined}} onClick={()=>setModal("admin")} title="Admin">{isMobile?"⚙":"⚙ Admin"}</button>}
        {canCreateProject(user)&&!isFinance(user)&&<button style={{...S.btnO,padding:isMobile?"6px 7px":"6px 12px",fontSize:isMobile?14:12,minWidth:isMobile?30:undefined}} onClick={()=>setModal("addProject")} title="New project">{isMobile?"＋":"+ Project"}</button>}
        <button onClick={()=>setDarkMode(!darkMode)} style={{...S.btnO,padding:isMobile?"6px 7px":"6px 10px",fontSize:14,minWidth:isMobile?30:36}} title={darkMode?"Switch to Light Mode":"Switch to Dark Mode"}>{darkMode?"☀️":"🌙"}</button>
        {!isFinance(user)&&<button onClick={()=>setModal("messages")} style={{...S.btnO,padding:isMobile?"6px 7px":"6px 10px",fontSize:14,minWidth:isMobile?30:36,position:"relative"}} title="Messages">
          💬
          {(()=>{const totalUnread=dmThreads.reduce((s,t)=>s+(t.unread||0),0);return totalUnread>0&&<span style={{position:"absolute",top:-4,right:-4,background:C.red,color:C.white,borderRadius:10,fontSize:9,fontWeight:700,minWidth:16,height:16,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 4px",border:`2px solid ${C.surface}`}}>{totalUnread>99?"99+":totalUnread}</span>})()}
        </button>}
        <div style={{position:"relative"}}>
          <button onClick={()=>setShowNotifs(!showNotifs)} style={{...S.btnO,padding:isMobile?"6px 7px":"6px 10px",fontSize:14,minWidth:isMobile?30:36,position:"relative"}} title="Notifications">
            🔔
            {(()=>{const total=unreadCount+pendingRequests.length;return total>0&&<span style={{position:"absolute",top:-4,right:-4,background:C.red,color:C.white,borderRadius:10,fontSize:9,fontWeight:700,minWidth:16,height:16,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 4px",border:`2px solid ${C.surface}`}}>{total>99?"99+":total}</span>})()}
          </button>
          {showNotifs&&<NotificationPanel
            notifications={myNotifications}
            onMarkRead={markNotifRead}
            onMarkAllRead={markAllNotifsRead}
            onDelete={deleteNotif}
            onClose={()=>setShowNotifs(false)}
            pendingRequests={pendingRequests}
            onAcceptRequest={acceptConnectionRequest}
            onDeclineRequest={declineConnectionRequest}
            onNavigate={(n)=>{
              // Parse link like "p:projId:..." to navigate to project
              if(n.link&&n.link.startsWith("p:")){
                const pid=n.link.split(":")[1];
                if(pid){setActiveProject(pid);setPage("project")}
              } else if(n.link&&n.link.startsWith("profile:")){
                const uid=n.link.split(":")[1];
                if(uid){setProfileUserId(uid);setPage("profile")}
              } else if(n.type==="assignment"){
                setPage("meeting");
              }
            }}
          />}
        </div>
        <div style={{position:"relative",display:"flex",alignItems:"center",gap:8,marginLeft:isMobile?2:4}}>
          {!isMobile&&<div style={{textAlign:"right"}}>
            <div style={{fontSize:12,fontWeight:600}}>{user.name}<RoleBadge role={user.role}/></div>
            <div style={{fontSize:10,color:C.textDim}}>{user.teamName?`${user.teamName} · `:""}{user.billableRole}</div>
          </div>}
          <div style={{...S.avatar,background:user.profilePhoto?"transparent":(user.profileColor||C.grad2),color:C.white,overflow:"hidden",cursor:"pointer"}} onClick={()=>setShowProfile(!showProfile)}>{user.profilePhoto?<img src={user.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}</div>
          {showProfile&&<>
            <div onClick={()=>setShowProfile(false)} style={{position:"fixed",inset:0,zIndex:89}}/>
            <div style={{position:"absolute",right:0,top:"100%",marginTop:8,background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,boxShadow:C.shadowLg,zIndex:90,width:280,overflow:"hidden"}}>
              <div style={{padding:"20px 18px",background:C.card,textAlign:"center",borderBottom:`1px solid ${C.border}`}}>
                <div style={{width:56,height:56,borderRadius:16,background:user.profilePhoto?"transparent":(user.profileColor||C.accent),color:C.white,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,fontWeight:700,margin:"0 auto 10px",overflow:"hidden"}}>{user.profilePhoto?<img src={user.profilePhoto} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:user.avatar}</div>
                <div style={{fontWeight:700,fontSize:15}}>{user.name}</div>
                <div style={{fontSize:12,color:C.textMid,marginTop:2}}>{user.email}</div>
                {user.teamName&&<div style={{fontSize:11,color:C.accent,marginTop:4}}>Team: {user.teamName}</div>}
                <div style={{marginTop:6}}><RoleBadge role={user.role}/></div>
              </div>
              <div style={{padding:6}}>
                <button onClick={()=>{setShowProfile(false);openProfile(user.id)}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:"none",border:"none",borderRadius:8,fontSize:13,color:C.text,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"left"}}
                  onMouseEnter={e=>e.target.style.background=C.card} onMouseLeave={e=>e.target.style.background="none"}>
                  👤 View My Profile
                </button>
                <button onClick={()=>{setShowProfile(false);setModal("profileSettings")}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:"none",border:"none",borderRadius:8,fontSize:13,color:C.text,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"left"}}
                  onMouseEnter={e=>e.target.style.background=C.card} onMouseLeave={e=>e.target.style.background="none"}>
                  ⚙️ Profile Settings
                </button>
                {canManageTeam(user)&&<button onClick={()=>{setShowProfile(false);setModal("admin")}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:"none",border:"none",borderRadius:8,fontSize:13,color:C.text,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"left"}}
                  onMouseEnter={e=>e.target.style.background=C.card} onMouseLeave={e=>e.target.style.background="none"}>
                  👥 Team Management
                </button>}
                {isAdmin(user)&&<button onClick={()=>{setShowProfile(false);setModal("companySettings")}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:"none",border:"none",borderRadius:8,fontSize:13,color:C.text,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"left"}}
                  onMouseEnter={e=>e.target.style.background=C.card} onMouseLeave={e=>e.target.style.background="none"}>
                  🏢 Company Settings
                </button>}
                {isMobile&&<button onClick={()=>{setShowProfile(false);setMobileLite(true);localStorage.setItem("wb:mobileLite","1")}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:"none",border:"none",borderRadius:8,fontSize:13,color:C.text,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"left"}}
                  onMouseEnter={e=>e.target.style.background=C.card} onMouseLeave={e=>e.target.style.background="none"}>
                  📱 Switch to Lite mobile view
                </button>}
                <div style={{height:1,background:C.border,margin:"4px 8px"}}/>
                <button onClick={()=>{setShowProfile(false);handleLogout()}} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"10px 14px",background:"none",border:"none",borderRadius:8,fontSize:13,color:C.red,cursor:"pointer",fontFamily:"'Inter',sans-serif",textAlign:"left",fontWeight:600}}
                  onMouseEnter={e=>e.target.style.background=C.redSoft} onMouseLeave={e=>e.target.style.background="none"}>
                  🚪 Sign Out
                </button>
              </div>
            </div>
          </>}
        </div>
      </div>
    </div>
    <div style={S.shell}>
      {/* Mobile: sidebar becomes a slide-in drawer with a tap-to-close backdrop */}
      {isMobile&&showSidebar&&<div onClick={()=>setShowSidebar(false)} style={{position:"fixed",inset:0,background:"rgba(15,23,42,.45)",zIndex:98}}/>}
      <div style={isMobile?{position:"fixed",left:0,top:0,bottom:0,zIndex:99,transform:showSidebar?"translateX(0)":"translateX(-105%)",transition:"transform .22s ease",boxShadow:showSidebar?"0 0 42px rgba(0,0,0,.4)":"none",height:"100dvh",overflowY:"auto",background:"var(--surface)"}:{display:"contents"}}>
      <Sidebar mobile={isMobile} user={user} page={page} collapsed={isMobile?false:!showSidebar} dmUnread={dmThreads.reduce((s,t)=>s+(t.unread||0),0)} visibilityState={{profilePublic:(publicProfiles||[]).some(p=>p.userId===user.id)}} companyInfo={companyInfo} company={company} users={users} actionItems={actionItems} activePortfolioView={activePortfolioView} onNavigate={(pg)=>{
        setActiveProject(null);
        if(pg==="profile"){setProfileUserId(user.id);setPage("profile")}
        else if(pg==="actions"){setPage("portfolio");setProfileUserId(null);setPendingView("actions")}
        else if(pg==="deliverables"){setPage("portfolio");setProfileUserId(null);setPendingView("deliverables")}
        else{setProfileUserId(null);setPage(pg);if(pg==="portfolio")setActivePortfolioView("dashboard");}
        if(isMobile)setShowSidebar(false);
      }} onShowSettings={()=>{setModal("settings");if(isMobile)setShowSidebar(false)}} onShowMessages={()=>{setModal("messages");if(isMobile)setShowSidebar(false)}}/>
      </div>
      <div style={S.main}>
      {page==="portfolio"&&<PortfolioView user={user} users={users} projects={projects} onOpen={openProject} onUpdateProject={editProject} onOpenModal={setModal} newsFeed={newsFeed} onPostNews={postNews} onUpdateFeed={setNewsFeed} actionItems={actionItems} onUpdateActions={updateActions} assignments={assignments} setAssignments={setAssignments} pendingView={pendingView} onConsumePendingView={(v)=>{setPendingView(null);setActivePortfolioView(v||"dashboard");}} onViewChange={setActivePortfolioView}/>}
      {page==="project"&&cur&&<ProjectDetailView project={cur} user={user} users={users} onBack={backToPortfolio} setModal={setModal} onUpdateProgress={updateProgress} onToggleMilestone={toggleMilestone} onChangeStatus={changeStatus} onDeleteProject={deleteProject} onAddResponse={addResponse} onAddCoordNote={addCoordNote} onUpdateProject={editProject} onUpdateFocus={updateFocus} actionItems={actionItems} onUpdateActions={updateActions} issues={issues} setIssues={setIssues} companyInfo={companyInfo}/>}
      {page==="timesheet"&&<TimesheetView user={user} projects={projects} timesheets={timesheets} setTimesheets={setTimesheets} users={users} allView={isAdmin(user)||isFinance(user)}/>}
      {page==="meeting"&&<TeamMeetingView user={user} users={users} projects={projects} onUpdateFocus={updateFocus} onUpdateFocusHours={updateFocusHours} meetingNotes={meetingNotes} setMeetingNotes={setMeetingNotes} teams={teams} onAddDeadline={addDeadline} onUpdateProject={editProject} onOpenProject={openProject} assignments={assignments} setAssignments={setAssignments} vacations={vacations} setVacations={setVacations} addNotification={addNotification} onUpdateDeadline={updateDeadline} onDeleteDeadline={deleteDeadline} actionItems={actionItems} toggleAction={toggleAction} events={events} setEvents={setEvents} timesheets={timesheets}/>}
      {page==="cad"&&<CADTeamView user={user} users={users} projects={projects} onUpdateUser={updateUserRole} onBookDrafter={(uid,bookings)=>setUsers(p=>p.map(u=>u.id===uid?{...u,bookings}:u))}/>}
      {page==="finance"&&(isAdmin(user)||isFinance(user))&&<FinancePortalView user={user} users={users} projects={projects} timesheets={timesheets}/>}
      {page==="profile"&&profileUserId&&<ProfilePage profileUserId={profileUserId} users={users} projects={projects} teams={teams} companyInfo={companyInfo} company={company} newsFeed={newsFeed} publicProjects={publicProjects} onBack={profileUserId===user.id?null:backToPortfolio} onOpenProject={openProject} currentUser={user} onPostNews={postNews} onUpdateFeed={setNewsFeed} onEditProfile={profileUserId===user.id?()=>setModal("profileSettings"):null} onViewCompany={()=>{setPage("company");setActiveProject(null);setProfileUserId(null)}} onManageVisibility={profileUserId===user.id?()=>setModal("settings"):null} onSendMessage={async(uid)=>{await openDmThread(uid);setModal("messages")}} onSendConnectionRequest={(action,uid)=>{if(action==="send")sendConnectionRequest(uid);else if(action==="accept")acceptConnectionRequest(uid);}}/>}
      {page==="company"&&<CompanyProfilePage user={user} users={users} projects={projects} teams={teams} companyInfo={companyInfo} company={company} newsFeed={newsFeed} onPostNews={postNews} onOpenProject={openProject} onOpenUser={(uid)=>{setProfileUserId(uid);setPage("profile")}} onEditCompany={()=>setModal("companySettings")} onUpdateFeed={setNewsFeed}/>}
      {page==="discover"&&<DiscoverView user={user} company={company} companyInfo={companyInfo} projects={projects} publicCompanies={publicCompanies} publicProfiles={publicProfiles} publicPosts={publicPosts} publicProjects={publicProjects} onPost={postToPublicFeed} onLikePost={togglePublicPostLike} onDeletePost={deletePublicPost} onOpenPublicProfile={(uid)=>setModal({type:"publicProfile",userId:uid})} onOpenPublicCompany={(cid)=>setModal({type:"publicCompany",companyId:cid})} onOpenPublicProject={(pid)=>setModal({type:"publicProject",projectId:pid})} onShowSettings={()=>setModal("settings")} onUnpublishProfile={unpublishProfile}/>}
      </div>
    </div>
    {showSearch&&<GlobalSearch users={users} projects={projects} onOpenProject={openProject} onOpenProfile={openProfile} onClose={()=>setShowSearch(false)} onNavigate={(pg)=>{setPage(pg);setActiveProject(null);setShowSearch(false)}} companyInfo={companyInfo} company={company}/>}
    {modal==="addUser"&&<AddUserModal onClose={()=>setModal("admin")} onAdd={addUser} currentUser={user}/>}
    {modal==="addProject"&&<AddProjectModal onClose={()=>setModal(null)} onAdd={addProject} users={users} currentUser={user}/>}
    {modal==="admin"&&<AdminPanel users={users} currentUser={user} projects={projects} onClose={()=>setModal(null)} onAddUser={()=>setModal("addUser")} onDeleteUser={deleteUser} onReset={handleReset} onApproveUser={approveUser} teams={teams} onUpdateTeams={setTeams} onUpdateRole={updateUserRole}/>}
    {modal==="companySettings"&&<CompanySettingsModal companyInfo={companyInfo} onSave={(info)=>{setCompanyInfo(info);setModal(null)}} onClose={()=>setModal(null)}/>}
    {modal==="settings"&&<SettingsModal user={user} company={company} companyInfo={companyInfo} projects={projects} publicProfiles={publicProfiles} publicCompanies={publicCompanies} publicProjects={publicProjects} onClose={()=>setModal(null)} onPublishProfile={publishProfile} onUnpublishProfile={unpublishProfile} onPublishCompany={publishCompany} onUnpublishCompany={unpublishCompany} onShowcaseProject={showcaseProject} onUnshowcaseProject={unshowcaseProject} darkMode={darkMode} onToggleDark={setDarkMode} accent={accent} onSetAccent={setAccent} density={density} onSetDensity={setDensity} radius={radius} onSetRadius={setRadius}/>}
    {modal==="messages"&&<MessagesModal user={user} users={users} publicProfiles={publicProfiles} dmThreads={dmThreads} activeDmThread={activeDmThread} onLoadThreads={loadDmThreads} onOpenThread={openDmThread} onSendDm={sendDm} onBackToList={()=>setActiveDmThread(null)} onClose={()=>{setModal(null);setActiveDmThread(null)}} onUpdateThread={(updated)=>{setActiveDmThread(updated);sv(updated.threadId,updated.messages)}}/>}
    {modal?.type==="issue"&&<IssueDetailModal issueId={modal.issueId} issues={issues} setIssues={setIssues} users={users} projects={projects} user={user} onClose={()=>setModal(null)}/>}
    {modal?.type==="publicProfile"&&<PublicProfileModal userId={modal.userId} currentUserId={user.id} publicProfiles={publicProfiles} publicProjects={publicProjects} publicCompanies={publicCompanies} onClose={()=>setModal(null)} onOpenPublicCompany={(cid)=>setModal({type:"publicCompany",companyId:cid})} onOpenPublicProject={(pid)=>setModal({type:"publicProject",projectId:pid})} onSendMessage={async(uid)=>{await openDmThread(uid);setModal("messages")}}/>}
    {modal?.type==="publicCompany"&&<PublicCompanyModal companyId={modal.companyId} publicCompanies={publicCompanies} publicProfiles={publicProfiles} publicProjects={publicProjects} onClose={()=>setModal(null)} onOpenPublicProfile={(uid)=>setModal({type:"publicProfile",userId:uid})} onOpenPublicProject={(pid)=>setModal({type:"publicProject",projectId:pid})}/>}
    {modal?.type==="publicProject"&&<PublicProjectModal projectId={modal.projectId} publicProjects={publicProjects} publicCompanies={publicCompanies} onClose={()=>setModal(null)} onOpenPublicCompany={(cid)=>setModal({type:"publicCompany",companyId:cid})}/>}
    {modal==="profileSettings"&&<ProfileSettingsModal user={user} onClose={()=>setModal(null)} onSave={updateProfile}/>}
    {modal?.type==="addIssue"&&<AddIssueModal onClose={()=>setModal(null)} onAdd={addIssue} users={users} projectId={modal.pid} currentUser={user}/>}
    {modal?.type==="addUpdate"&&<AddUpdateModal onClose={()=>setModal(null)} onAdd={addUpdate} projectId={modal.pid} userId={user.id}/>}
    {modal?.type==="addMilestone"&&<AddMilestoneModal onClose={()=>setModal(null)} onAdd={addMilestone} projectId={modal.pid}/>}
    {modal?.type==="addDeadline"&&<AddDeadlineModal onClose={()=>setModal(null)} onAdd={addDeadline} projectId={modal.pid}/>}
    {modal?.type==="editMilestone"&&<EditMilestoneModal onClose={()=>setModal(null)} onSave={(pid,idx,updated)=>{const proj=projects.find(x=>x.id===pid);if(proj){editProject(pid,{milestones:proj.milestones.map((m,i)=>i===idx?updated:m)});}}} projectId={modal.pid} index={modal.index} milestone={modal.milestone}/>}
    {modal?.type==="editDeadline"&&<EditDeadlineModal onClose={()=>setModal(null)} onSave={(pid,dlId,updated)=>{updateDeadline(pid,dlId,updated);}} projectId={modal.pid} index={modal.index} deadline={modal.deadline}/>}
    {modal?.type==="editProject"&&(()=>{const ep=projects.find(x=>x.id===modal.pid);return ep?<EditProjectModal project={ep} onClose={()=>setModal(null)} onSave={editProject} users={users}/>:null})()}
    {modal?.type==="addCoord"&&<AddCoordModal onClose={()=>setModal(null)} onAdd={addCoord} projectId={modal.pid} defaults={modal.defaults}/>}
    {modal?.type==="editPhaseSchedule"&&(()=>{const ep=projects.find(x=>x.id===modal.pid);return ep?<EditPhaseScheduleModal onClose={()=>setModal(null)} onSave={(pid,sched)=>editProject(pid,{phaseSchedule:sched})} project={ep}/>:null})()}
    {modal?.type==="editPhases"&&(()=>{const ep=projects.find(x=>x.id===modal.pid);const DP=["Proposal","Schematic Design","Design Development","IFC","Construction Admin","Closeout"];return ep?<EditPhasesModal onClose={()=>setModal(null)} onSave={(pid,phases)=>editProject(pid,{customPhases:phases})} projectId={modal.pid} initialPhases={modal.phases||(ep.customPhases?.length>0?ep.customPhases:DP)}/>:null})()}
    {modal?.type==="addMeeting"&&(()=>{const ep=projects.find(x=>x.id===modal.pid);return ep?<AddMeetingModal onClose={()=>setModal(null)} onSave={(pid,meeting)=>{const proj=projects.find(x=>x.id===pid);if(proj){editProject(pid,{meetings:[...(proj.meetings||[]),meeting]});}}} projectId={modal.pid} project={ep} users={users} currentUser={user}/>:null})()}
    {modal?.type==="editMeeting"&&(()=>{const ep=projects.find(x=>x.id===modal.pid);return ep?<EditMeetingModal onClose={()=>setModal(null)} onSave={(pid,updated)=>{const proj=projects.find(x=>x.id===pid);if(proj){editProject(pid,{meetings:(proj.meetings||[]).map(m=>m.id===updated.id?updated:m)});}}} projectId={modal.pid} meeting={modal.meeting} project={ep} users={users}/>:null})()}
    {modal?.type==="addDecision"&&<AddDecisionModal onClose={()=>setModal(null)} onSave={(pid,decision)=>{const proj=projects.find(x=>x.id===pid);if(proj){editProject(pid,{decisions:[...(proj.decisions||[]),decision]});}}} projectId={modal.pid} meetingId={modal.meetingId} currentUser={user}/>}
    {modal?.type==="editDecision"&&<EditDecisionModal onClose={()=>setModal(null)} onSave={(pid,updated)=>{const proj=projects.find(x=>x.id===pid);if(proj){editProject(pid,{decisions:(proj.decisions||[]).map(d=>d.id===updated.id?updated:d)});}}} projectId={modal.pid} decision={modal.decision}/>}
  </div>;
}
